// src/index.tsx
import { useEffect as useEffect20, useMemo as useMemo15, useState as useState22 } from "react";

// src/brain.tsx
import { useCallback, useEffect, useState } from "react";
import {
  brainListSchema,
  brainViewSchema,
  knowledgeGapReportSchema,
  knowledgeProposalSchema,
  onboardingMessageResponseSchema,
  voiceOnboardingStatusSchema,
  proposalListSchema,
  publishBrainResponseSchema,
  retrievalResponseSchema,
  sourceAcceptedSchema
} from "@agentos/contracts";

// src/i18n.ts
var tr = {
  "AI Agents": "AI Ajanlar\u0131",
  Analytics: "Analitik",
  Approve: "Onayla",
  Approved: "Onaylanan",
  "Authorized scope": "Yetkili kapsam",
  "Available modules": "Kullan\u0131labilir mod\xFCller",
  "Billing & Usage": "Faturalama ve Kullan\u0131m",
  "Build a verified source of truth": "Do\u011Frulanm\u0131\u015F bilgi kayna\u011F\u0131 olu\u015Ftur",
  "Business Brain": "Business Brain",
  Channels: "Kanallar",
  Conversations: "G\xF6r\xFC\u015Fmeler",
  Directory: "Rehber",
  Numbers: "Numaralar",
  "Caller IDs and BYO numbers": "Arayan kimlik ve BYO numaralar",
  Campaigns: "Kampanyalar",
  Leads: "Leadler",
  "Calling Factory": "Arama Fabrikas\u0131",
  "Control Plane": "Kontrol D\xFCzlemi",
  "Create Brain": "Brain Olu\u015Ftur",
  "Customer Operations": "M\xFC\u015Fteri Operasyonlar\u0131",
  "Main navigation": "Ana men\xFC",
  "Mobile navigation": "Mobil men\xFC",
  Home: "Ana sayfa",
  "Daily work": "G\xFCnl\xFCk i\u015F",
  Build: "Olu\u015Fturma",
  Setup: "Kurulum",
  System: "Sistem",
  Integrations: "Entegrasyonlar",
  "Live ops": "Canl\u0131 operasyon",
  "Brain Live Ops": "Brain Live Ops",
  "Brain Pilot Active": "Brain Pilot aktif",
  "No Brain turns in selected period.": "Se\xE7ilen d\xF6nemde Brain turn yok.",
  "Latency samples unavailable.": "Gecikme \xF6rnekleri yok.",
  "Baseline period not selected": "Baseline aral\u0131\u011F\u0131 se\xE7ilmedi",
  "Last updated": "Son g\xFCncelleme",
  "Latest metric": "Son metrik",
  Lag: "Gecikme",
  "Deterministic Turns": "Deterministik turn",
  "Fail-open": "Fail-open",
  "Response Latency": "Yan\u0131t gecikmesi",
  "Latency Coverage": "Gecikme coverage",
  "LLM Efficiency": "LLM verimlili\u011Fi",
  "LLM Calls": "LLM \xE7a\u011Fr\u0131lar\u0131",
  "LLM reduction": "LLM azalmas\u0131",
  "Intent Mix": "Intent da\u011F\u0131l\u0131m\u0131",
  "Deterministic Templates": "Deterministik \u015Fablonlar",
  "Policy / Safety": "Politika / g\xFCvenlik",
  "Measure Brain path mix, LLM reduction, latency, and pilot safety \u2014 read only.": "Brain path, LLM azalmas\u0131, gecikme ve pilot g\xFCvenli\u011Fini \xF6l\xE7\xFCn \u2014 salt okunur.",
  "End policy/tool conflict detected (count > 0). Review turns before expanding pilot.": "End policy/tool \xE7eli\u015Fkisi (>0). Pilotu geni\u015Fletmeden \xF6nce turn\u2019leri inceleyin.",
  "Router may be active outside explicit pilot allowlist.": "Router a\xE7\u0131k allowlist d\u0131\u015F\u0131nda da aktif olabilir.",
  "Latency coverage below 80%. Treat p95 with caution.": "Gecikme coverage %80 alt\u0131nda. p95\u2019i temkinli yorumlay\u0131n.",
  "Same workspace/channel. Router OFF + CENTEROS_BRAIN_METRICS=1 period.": "Ayn\u0131 workspace/channel. Router OFF + CENTEROS_BRAIN_METRICS=1 d\xF6nemi.",
  "Observational \u2014 not executed": "G\xF6zlemsel \u2014 aksiyon de\u011Fil",
  "Observational only \u2014 no tool permission change": "Yaln\u0131z g\xF6zlemsel \u2014 tool izni de\u011Fi\u015Fmez",
  "Soft farewell, call not ended": "Yumu\u015Fak veda, arama kapanmad\u0131",
  "Hide baseline": "Baseline gizle",
  "Baseline range": "Baseline aral\u0131\u011F\u0131",
  "Failed to load Brain metrics": "Brain metrikleri y\xFCklenemedi",
  Usage: "Kullan\u0131m",
  Repeats: "Tekrar",
  "Repeat rate": "Tekrar oran\u0131",
  "Next-turn LLM": "Sonraki turn LLM",
  "Top repeated": "En \xE7ok tekrar",
  "Repeated Templates": "Tekrarlayan \u015Fablonlar",
  "Brain path distribution": "Brain path da\u011F\u0131l\u0131m\u0131",
  "Policy / tool divergence": "Politika / tool sapmas\u0131",
  "Hangup / end": "Kapan\u0131\u015F / end",
  "Lead detected": "Lead tespit",
  "Lead actionable": "Lead actionable",
  "Callback detected": "Callback tespit",
  "Callback actionable": "Callback actionable",
  "Decline terminal": "Decline terminal",
  "End terminal": "End terminal",
  "Lead actionable, no legacy tool": "Lead actionable, legacy tool yok",
  "Legacy lead tool, policy not actionable": "Legacy lead tool, policy actionable de\u011Fil",
  "Callback actionable, no legacy tool": "Callback actionable, legacy tool yok",
  "Legacy callback tool, policy not actionable": "Legacy callback tool, policy actionable de\u011Fil",
  "of brain-active post turns": "brain-active post turn oran\u0131",
  "llm_called=true / post turns": "llm_called=true / post turn",
  "Exact turn join samples / voice-eligible post turns": "Exact turn join \xF6rnekleri / voice uygun post turn",
  "Baseline LLM rate": "Baseline LLM oran\u0131",
  "Pilot LLM rate": "Pilot LLM oran\u0131",
  "Input tokens": "Girdi token",
  "Output tokens": "\xC7\u0131kt\u0131 token",
  "Latency trend": "Gecikme trendi",
  "Deterministic vs LLM stop\u2192audio": "Det vs LLM stop\u2192audio",
  "Brain path": "Brain path",
  "Call id": "Call id",
  "Baseline comparison": "Baseline kar\u015F\u0131la\u015Ft\u0131rmas\u0131",
  "Hide demo/test agents": "Gizle demo/test ajanlar\u0131",
  "Demo/test": "Demo/test",
  Incomplete: "Eksik",
  "Includes demo/browser_demo sessions": "Demo/browser_demo oturumlar\u0131 dahil",
  "Precall blocked": "Arama \xF6ncesi engel",
  "Purpose not allowed": "Ama\xE7 \u015Fablonu izinli de\u011Fil",
  "Custom purpose blocked": "\xD6zel ama\xE7 engellendi",
  "Freeform note blocked": "Serbest not engellendi",
  "Denylist blocked the call content": "Yasakl\u0131 ifade \u2014 i\xE7erik engellendi",
  "Denylist flagged (call continued)": "Yasakl\u0131 ifade i\u015Faretlendi (arama s\xFCrd\xFC)",
  "Number is on DNC list": "Numara aranmaz (DNC) listesinde",
  "Platform warm-up daily minutes exceeded": "Platform warm-up g\xFCnl\xFCk dakika doldu",
  Welcome: "Ho\u015F geldiniz",
  Today: "Bug\xFCn",
  "TODAY OPS": "BUG\xDCNK\xDC OPERASYON",
  "Command center": "Komuta merkezi",
  "Pick a job below. Campaign \u2192 Calls \u2192 Leads.": "A\u015Fa\u011F\u0131dan i\u015F se\xE7in. Kampanya \u2192 Aramalar \u2192 Leadler.",
  "Run outbound campaigns, review calls, follow leads \u2014 this home is your work queue, not a feature map.": "Kampanya \xE7al\u0131\u015Ft\u0131r\u0131n, aramalar\u0131 inceleyin, lead takibi yap\u0131n \u2014 bu ana sayfa i\u015F kuyru\u011Fudur, \xF6zellik listesi de\u011Fil.",
  "Four doors to daily work": "G\xFCnl\xFCk i\u015Fe d\xF6rt kap\u0131",
  "Color mode": "Renk modu",
  Dark: "Koyu",
  Light: "A\xE7\u0131k",
  "Live queue": "Canl\u0131 kuyruk",
  "What needs attention": "Dikkat gerekenler",
  "Refreshing\u2026": "Yenileniyor\u2026",
  Refresh: "Yenile",
  "Some metrics could not load. Values show \u2014 when unavailable.": "Baz\u0131 metrikler y\xFCklenemedi. Bo\u015F de\u011Ferler \u2014 olarak g\xF6r\xFCn\xFCr.",
  "Active calls": "Aktif aramalar",
  "Waiting for human": "\u0130nsan bekliyor",
  "Failed calls (recent)": "Ba\u015Far\u0131s\u0131z aramalar (son)",
  "Hot leads": "S\u0131cak leadler",
  "Running campaigns": "\xC7al\u0131\u015Fan kampanyalar",
  "Published agents": "Yay\u0131nl\u0131 ajanlar",
  "Human handoff waiting": "\u0130nsan devralmas\u0131 bekliyor",
  "One or more calls need an operator now.": "Bir veya daha fazla arama operat\xF6r bekliyor.",
  "Open live ops": "Canl\u0131 operasyona git",
  "Failed calls need review": "Ba\u015Far\u0131s\u0131z aramalar incelenmeli",
  "Check recordings and retry or fix the number / agent.": "Kay\u0131tlar\u0131 kontrol edin; numaray\u0131 veya ajan\u0131 d\xFCzeltip yeniden deneyin.",
  "Hot leads waiting": "S\u0131cak leadler bekliyor",
  "Follow up while interest is high.": "\u0130lgi y\xFCksekken takip edin.",
  "Production DID without inbound agent": "Gelen ajan\u0131 ba\u011Fl\u0131 olmayan \xFCretim DID",
  "Bind a published agent so inbound calls are answered.": "Gelen aramalar\u0131n cevaplanmas\u0131 i\xE7in yay\u0131nl\u0131 ajan ba\u011Flay\u0131n.",
  "Open numbers": "Numaralara git",
  "No published agent yet": "Hen\xFCz yay\u0131nl\u0131 ajan yok",
  "Publish an agent before campaigns or inbound DID routing.": "Kampanya veya gelen DID y\xF6nlendirmesinden \xF6nce bir ajan yay\u0131nlay\u0131n.",
  "Open agents": "Ajanlara git",
  "No campaigns yet": "Hen\xFCz kampanya yok",
  "Create a draft, add contacts, then start outbound dialing.": "Taslak olu\u015Fturun, ki\u015Fi ekleyin, ard\u0131ndan giden aramay\u0131 ba\u015Flat\u0131n.",
  "Queue looks clear": "Kuyruk sakin g\xF6r\xFCn\xFCyor",
  "No critical exceptions. Start a campaign or review recent calls.": "Kritik istisna yok. Kampanya ba\u015Flat\u0131n veya son aramalar\u0131 inceleyin.",
  "Not published yet \u2014 save, then publish to go live": "Hen\xFCz yay\u0131nlanmad\u0131 \u2014 kaydedin, sonra yay\u0131nlay\u0131p canl\u0131ya al\u0131n",
  "Save first if you changed fields, then Publish & deploy. Test on the right after publish.": "Alanlar\u0131 de\u011Fi\u015Ftirdiyseniz \xF6nce kaydedin, sonra Yay\u0131nla. Yay\u0131n sonras\u0131 sa\u011Fda test edin.",
  Configure: "Yap\u0131land\u0131r",
  "Test call": "Test aramas\u0131",
  "Hide advanced settings": "\u0130leri ayarlar\u0131 gizle",
  "Show advanced settings": "\u0130leri ayarlar\u0131 g\xF6ster",
  "Create, publish, then test \u2014 in that order": "Olu\u015Ftur, yay\u0131nla, sonra test et \u2014 bu s\u0131rayla",
  Create: "Olu\u015Ftur",
  "Not published": "Yay\u0131nlanmad\u0131",
  "No live version": "Canl\u0131 yok",
  "Live v{n}": "Canl\u0131 v{n}",
  "Live v{n} \xB7 draft newer": "Canl\u0131 v{n} \xB7 taslak yeni",
  "Draft is newer than live \u2014 publish to update phone and campaigns": "Taslak canl\u0131dan yeni \u2014 telefon ve kampanyalar i\xE7in yeniden yay\u0131nlay\u0131n",
  "This version is live on phone and campaigns": "Bu s\xFCr\xFCm telefonda ve kampanyalarda canl\u0131",
  "Publish path": "Yay\u0131n yolu",
  "Jump to softphone / text test": "Softphone / metin testine git",
  "Publish first to unlock test": "Test i\xE7in \xF6nce yay\u0131nlay\u0131n",
  "Open \u2192 publish draft to go live": "A\xE7 \u2192 tasla\u011F\u0131 yay\u0131nla",
  "Open \u2192 save & publish": "A\xE7 \u2192 kaydet ve yay\u0131nla",
  "Open to edit": "D\xFCzenlemek i\xE7in a\xE7",
  "Save Agent": "Ajan\u0131 kaydet",
  "Published agents only (live pin required)": "Yaln\u0131zca yay\u0131nl\u0131 ajanlar (canl\u0131 pin gerekli)",
  "Select a published agent": "Yay\u0131nl\u0131 bir ajan se\xE7in",
  Hello: "Merhaba",
  "Run outbound calling campaigns, review conversations, and follow up leads \u2014 all in one place.": "Toplu arama kampanyas\u0131 ba\u015Flat\u0131n, g\xF6r\xFC\u015Fmeleri inceleyin ve lead takibi yap\u0131n \u2014 hepsi tek yerde.",
  "Today\u2019s work: start campaigns, review calls, and follow up leads \u2014 without leaving this console.": "Bug\xFCnk\xFC i\u015F: kampanya ba\u015Flat\u0131n, aramalar\u0131 inceleyin ve lead takibi yap\u0131n \u2014 konsoldan \xE7\u0131kmadan.",
  "Start a campaign": "Kampanya ba\u015Flat",
  "Review calls": "Aramalar\u0131 incele",
  Workspace: "\xC7al\u0131\u015Fma alan\u0131",
  "Session expires": "Oturum biti\u015F",
  "Session active": "Oturum aktif",
  "Short-lived session verified by the server": "K\u0131sa \xF6m\xFCrl\xFC oturum sunucu taraf\u0131ndan do\u011Fruland\u0131",
  "Quick actions": "H\u0131zl\u0131 i\u015Flemler",
  "Get started": "Ba\u015Flay\u0131n",
  "Work queue": "\u0130\u015F kuyru\u011Fu",
  "What do you want to do?": "Ne yapmak istiyorsunuz?",
  "What should I do next?": "S\u0131rada ne yapmal\u0131y\u0131m?",
  "Import contacts, set the script, and dial outbound calls in order.": "Ki\u015Fi ekleyin, script yaz\u0131n ve aramalar\u0131 s\u0131rayla ba\u015Flat\u0131n.",
  "Open campaigns": "Kampanyalara git",
  "Listen to recordings, read transcripts, and check purpose notes.": "Kay\u0131t dinleyin, transkript okuyun ve ama\xE7 notunu g\xF6r\xFCn.",
  "Open conversations": "G\xF6r\xFC\u015Fmelere git",
  "Follow up leads": "Lead takibi",
  "See hot / warm / cold scores and next actions after each call.": "Her arama sonras\u0131 s\u0131cak/\u0131l\u0131k/so\u011Fuk skor ve sonraki ad\u0131m\u0131 g\xF6r\xFCn.",
  "Open leads": "Leadlere git",
  "Call from directory": "Rehberden ara",
  "Pick a contact, set the purpose note, and place a single outbound call.": "Ki\u015Fi se\xE7in, ama\xE7 notu yaz\u0131n ve tek arama ba\u015Flat\u0131n.",
  "Open directory": "Rehbere git",
  "All modules": "T\xFCm mod\xFCller",
  "Browse the console": "Konsolu gezin",
  Account: "Hesap",
  "Your access": "Eri\u015Fiminiz",
  Company: "\u015Eirket",
  User: "Kullan\u0131c\u0131",
  "Your data stays inside this company workspace. Sessions are short-lived and server-verified.": "Verileriniz bu \u015Firket \xE7al\u0131\u015Fma alan\u0131nda kal\u0131r. Oturumlar k\u0131sa \xF6m\xFCrl\xFC ve sunucu do\u011Frulamal\u0131d\u0131r.",
  "Outbound dialing lists": "Toplu arama listeleri",
  "Transcripts and recordings": "Transkript ve kay\u0131tlar",
  "Scores and next steps": "Skor ve sonraki ad\u0131mlar",
  "Contacts and single calls": "Ki\u015Filer ve tek arama",
  "Company knowledge": "\u015Eirket bilgisi",
  "Voice and chat agents": "Ses ve sohbet ajanlar\u0131",
  "Webchat and messaging": "Webchat ve mesajla\u015Fma",
  "Telephony and AI keys": "Telefoni ve AI anahtarlar\u0131",
  Automations: "Otomasyonlar",
  "Performance insights": "Performans \xF6zeti",
  "Plan and usage": "Plan ve kullan\u0131m",
  "Retention and data": "Saklama ve veri",
  "Open module": "Mod\xFCl\xFC a\xE7",
  "Data & Retention": "Veri ve Saklama",
  Entitlements: "Haklar",
  "Guided Onboarding": "Rehberli Kurulum",
  "Human Review": "\u0130nsan Onay\u0131",
  "Immutable Brain snapshot published.": "De\u011Fi\u015Fmez Brain s\xFCr\xFCm\xFC yay\u0131nland\u0131.",
  "Ingest source": "Kayna\u011F\u0131 \u0130\xE7eri Al",
  "Ingest trusted material": "G\xFCvenilir materyal ekle",
  "Knowledge proposals": "Bilgi \xF6nerileri",
  "Live manifest": "Canl\u0131 manifest",
  "No proposals yet.": "Hen\xFCz \xF6neri yok.",
  Onboarding: "Kurulum",
  "Onboarding complete": "Kurulum tamamland\u0131",
  Overview: "Genel Bak\u0131\u015F",
  Permissions: "\u0130zinler",
  "Permission and entitlement verified": "\u0130zin ve hak do\u011Fruland\u0131",
  "Plan capabilities": "Plan yetenekleri",
  "PostgreSQL RLS enforcement": "PostgreSQL RLS korumas\u0131",
  Providers: "Sa\u011Flay\u0131c\u0131lar",
  Proposals: "\xD6neriler",
  Protected: "Korunuyor",
  Publish: "Yay\u0131nla",
  Published: "Yay\u0131nlanan",
  "Published-only Retrieval": "Yaln\u0131zca Yay\u0131nlanan Bilgiden Arama",
  "Publish immutable version": "De\u011Fi\u015Fmez s\xFCr\xFCm\xFC yay\u0131nla",
  Retrieve: "Getir",
  "Save answer": "Cevab\u0131 kaydet",
  "Search published knowledge": "Yay\u0131nlanan bilgide ara",
  "Security Posture": "G\xFCvenlik Durumu",
  "Server verified": "Sunucu do\u011Frulad\u0131",
  "Server-side authorization": "Sunucu taraf\u0131 yetkilendirme",
  "Short-lived embed session": "K\u0131sa \xF6m\xFCrl\xFC embed oturumu",
  "Source ingested. Proposed facts are ready for review.": "Kaynak i\xE7eri al\u0131nd\u0131. \xD6nerilen bilgiler incelemeye haz\u0131r.",
  "Source title": "Kaynak ba\u015Fl\u0131\u011F\u0131",
  "Start with the guided questions.": "Rehberli sorularla ba\u015Flay\u0131n.",
  "Tenant boundary": "Tenant s\u0131n\u0131r\u0131",
  "Test the Brain": "Brain'i test et",
  "Text Source": "Metin Kayna\u011F\u0131",
  "Verified Knowledge Control": "Do\u011Frulanm\u0131\u015F Bilgi Kontrol\xFC",
  Workflows: "\u0130\u015F Ak\u0131\u015Flar\u0131",
  Workspaces: "\xC7al\u0131\u015Fma Alanlar\u0131",
  "Your AI customer operations workspace": "AI m\xFC\u015Fteri operasyonlar\u0131 \xE7al\u0131\u015Fma alan\u0131n\u0131z",
  "Add verified facts\u2026": "Do\u011Frulanm\u0131\u015F bilgileri ekleyin...",
  "Acme Support Agent": "Panaryus Destek Ajan\u0131",
  Agent: "Ajan",
  "All systems operational": "T\xFCm sistemler \xE7al\u0131\u015F\u0131yor",
  "Allowed connector tools": "\u0130zin verilen connector ara\xE7lar\u0131",
  "Answer saved as a reviewable proposal.": "Cevap incelenebilir \xF6neri olarak kaydedildi.",
  "Answer only from published business knowledge. State when verified context is insufficient.": "Yaln\u0131zca yay\u0131nlanm\u0131\u015F i\u015Fletme bilgisinden cevap ver. Do\u011Frulanm\u0131\u015F ba\u011Flam yetersizse bunu belirt.",
  "Ask the published Agent\u2026": "Yay\u0131nlanm\u0131\u015F ajana sorun...",
  "Barge-in enabled": "S\xF6z kesme a\xE7\u0131k",
  "Bind a published Brain, test the policies, then deploy immutable webchat.": "Yay\u0131nlanm\u0131\u015F bir Brain ba\u011Flay\u0131n, politikalar\u0131 test edin ve de\u011Fi\u015Fmez webchat s\xFCr\xFCm\xFCn\xFC yay\u0131na al\u0131n.",
  "Blocked topics": "Engellenen konular",
  "Business Brain created. Start with the guided questions.": "Business Brain olu\u015Fturuldu. Rehberli sorularla ba\u015Flay\u0131n.",
  "Clear, calm and concise": "Net, sakin ve k\u0131sa",
  "Create a grounded customer agent": "Bilgiye dayal\u0131 m\xFC\u015Fteri ajan\u0131 olu\u015Ftur",
  "Create Agent": "Ajan Olu\u015Ftur",
  "Customer support specialist": "M\xFC\u015Fteri destek uzman\u0131",
  "Draft Agent created.": "Taslak ajan olu\u015Fturuldu.",
  "Draft Configuration": "Taslak Konfig\xFCrasyon",
  "Handoff destination": "Devretme hedefi",
  Instructions: "Talimatlar",
  "Immutable Agent version deployed.": "De\u011Fi\u015Fmez ajan s\xFCr\xFCm\xFC yay\u0131na al\u0131nd\u0131.",
  "Manage verified business knowledge, AI agents, channels and conversations from one secure tenant boundary.": "Do\u011Frulanm\u0131\u015F i\u015Fletme bilgisini, AI ajanlar\u0131n\u0131, kanallar\u0131 ve konu\u015Fmalar\u0131 g\xFCvenli tek tenant s\u0131n\u0131r\u0131ndan y\xF6netin.",
  "Max call seconds": "Maksimum arama saniyesi",
  "Onboard your business, review every proposal, then publish an immutable snapshot.": "\u0130\u015Fletmenizi tan\u0131mlay\u0131n, her \xF6neriyi inceleyin ve de\u011Fi\u015Fmez bir s\xFCr\xFCm yay\u0131nlay\u0131n.",
  Persona: "Persona",
  "Published Agent runtime": "Yay\u0131nlanm\u0131\u015F ajan \xE7al\u0131\u015Fma zaman\u0131",
  "Published Brain": "Yay\u0131nlanm\u0131\u015F Brain",
  "Publish & deploy": "Yay\u0131nla ve devreye al",
  "Publish the Agent, then test grounded responses.": "Ajan\u0131 yay\u0131nlay\u0131n, sonra bilgiye dayal\u0131 cevaplar\u0131 test edin.",
  "Proposal approved for the next publication.": "\xD6neri bir sonraki yay\u0131n i\xE7in onayland\u0131.",
  Recording: "Kay\u0131t",
  "Recording enabled": "Kay\u0131t a\xE7\u0131k",
  "Recording notice": "Kay\u0131t bilgilendirmesi",
  "Background sound / ambience": "Arka plan sesi / ambiance",
  "Looped office bed mixed quietly under the agent voice on the phone (and PC demo). More beds can be added later.": "Ajan konu\u015Furken telefonda (ve PC demo\u2019da) al\xE7ak ofis ortam\u0131 d\xF6ner. Sonradan yeni yatak eklenebilir.",
  "Upload your own looping bed (office, cafe, brand audio). It plays quietly under the agent on the phone and in PC demo. Isolated to this workspace.": "Kendi d\xF6ng\xFC sesinizi y\xFCkleyin (ofis, kafe, marka). Ajan konu\u015Furken telefonda ve PC demo\u2019da al\xE7ak \xE7alar. Yaln\u0131zca bu \xE7al\u0131\u015Fma alan\u0131na aittir.",
  "Ambience bed": "Ambiance yata\u011F\u0131",
  "Office ambience": "Ofis ortam\u0131",
  "Ambience off": "Kapal\u0131",
  "Upload your sound": "Kendi sesinizi y\xFCkleyin",
  "MP3, WAV, OGG or M4A. Max 8 MB / 3 min. Save + Publish after choosing.": "MP3, WAV, OGG veya M4A. En fazla 8 MB / 3 dk. Se\xE7tikten sonra Kaydet + Yay\u0131nla.",
  "File must be 8 MB or smaller.": "Dosya 8 MB veya daha k\xFC\xE7\xFCk olmal\u0131.",
  "Upload failed": "Y\xFCkleme ba\u015Far\u0131s\u0131z",
  "Delete failed": "Silinemedi",
  "Delete this sound": "Bu sesi sil",
  Delete: "Sil",
  "Delete agent": "Ajan\u0131 sil",
  "Delete agent {name}? It leaves this list. Call history is kept.": "\u201C{name}\u201D ajan\u0131n\u0131 silmek istiyor musunuz? Listeden \xE7\u0131kar. Arama ge\xE7mi\u015Fi kal\u0131r.",
  "Agent deleted": "Ajan silindi",
  "Uploading\u2026": "Y\xFCkleniyor\u2026",
  "Ambience preview": "Ambiance \xF6nizleme",
  "Ambience level": "Ambiance seviyesi",
  "Keep low so the agent voice stays clear. Default 0.12.": "Ajan sesi net kals\u0131n diye d\xFC\u015F\xFCk tutun. Varsay\u0131lan 0.12.",
  "This slider changes the preview and the live phone after Save + Publish. 8% is clearly quieter than 12%.": "Bu kayd\u0131r\u0131c\u0131 \xF6nizlemeyi hemen, telefonu Kaydet + Yay\u0131nla sonras\u0131 de\u011Fi\u015Ftirir. %8, %12\u2019den belirgin k\u0131s\u0131k olur.",
  "Play while agent speaks": "Ajan konu\u015Furken \xE7al",
  "Play while waiting for the answer": "Cevap beklerken \xE7al",
  "Office ambience preview": "Ofis ortam\u0131 \xF6nizleme",
  Role: "Rol",
  "Role and guardrails": "Rol ve g\xFCvenlik s\u0131n\u0131rlar\u0131",
  "Save draft": "Tasla\u011F\u0131 kaydet",
  Send: "G\xF6nder",
  "Separate distinct facts with blank lines.": "Ayr\u0131 bilgileri bo\u015F sat\u0131rlarla ay\u0131r\u0131n.",
  "Select Brain": "Brain se\xE7",
  "Test Simulator": "Test Sim\xFClat\xF6r\xFC",
  "This call may be recorded for quality purposes.": "Bu arama kalite ama\xE7l\u0131 kaydedilebilir.",
  "Versioned Agent Control": "Versiyonlu Ajan Kontrol\xFC",
  Voice: "Ses",
  "Voice ID": "Ses ID",
  "Voice language": "Ses dili",
  "Voice profile": "Ses profili",
  "Webchat Deployment Key": "Webchat Da\u011F\u0131t\u0131m Anahtar\u0131",
  "Agents": "Ajanlar",
  "Prompt Templates": "Prompt \u015Eablonlar\u0131",
  "Voices": "Sesler",
  "Voices \xB7 ElevenLabs": "Sesler \xB7 ElevenLabs",
  "Voices \xB7 ElevenLabs library": "Sesler \xB7 ElevenLabs k\xFCt\xFCphanesi",
  "Full account catalogue from ElevenLabs API \u2014 not a fixed list of 7. Phone trunk: Zadarma.": "ElevenLabs API hesab\u0131ndaki tam katalog \u2014 sabit 7 ses de\u011Fil. Telefon hatt\u0131: Zadarma.",
  "Refresh library": "K\xFCt\xFCphaneyi yenile",
  "Live TTS provider": "Canl\u0131 TTS sa\u011Flay\u0131c\u0131",
  "Library voices": "K\xFCt\xFCphane sesleri",
  "Showing now": "G\xF6sterilen",
  "Loading full ElevenLabs library\u2026": "ElevenLabs k\xFCt\xFCphanesi y\xFCkleniyor\u2026",
  "All genders": "T\xFCm cinsiyetler",
  "Female": "Kad\u0131n",
  "Male": "Erkek",
  "All langs": "T\xFCm diller",
  "Play sample": "\xD6rnek dinle",
  "Play ElevenLabs sample": "ElevenLabs \xF6rne\u011Fini dinle",
  "\u25A0 Stop": "\u25A0 Durdur",
  "\u25A0 Stop sample": "\u25A0 \xD6rne\u011Fi durdur",
  "Create and manage reusable AI prompt templates": "Yeniden kullan\u0131labilir AI prompt \u015Fablonlar\u0131n\u0131 olu\u015Fturun ve y\xF6netin",
  "Total Templates": "Toplam \u015Fablon",
  "Categories": "Kategoriler",
  "All Templates": "T\xFCm \u015Fablonlar",
  "Use template": "\u015Eablonu kullan",
  "Create and manage your conversational AI agents": "Konu\u015Fmal\u0131 AI ajanlar\u0131n\u0131z\u0131 olu\u015Fturun ve y\xF6netin",
  "Guided Wizard": "Rehberli Sihirbaz",
  "AI Assistant": "AI Asistan",
  "Hello, I am your CenterOS assistant. We can set up this agent by talking.": "Merhaba, ben CenterOS asistan\u0131n\u0131z\u0131m. Bu ajan\u0131 konu\u015Farak kural\u0131m.",
  "AI-assisted agent": "AI destekli ajan",
  "Talk here to fill in the missing agent fields. We create a draft only \u2014 you still publish.": "Burada yazarak eksik ajan alanlar\u0131n\u0131 tamamlay\u0131n. Taslak olu\u015Fur; yay\u0131n\u0131 siz yapars\u0131n\u0131z.",
  "Answer a few questions. We create a draft only \u2014 you still publish.": "Birka\xE7 soruya cevap verin. Taslak olu\u015Fur; yay\u0131n\u0131 siz yapars\u0131n\u0131z.",
  "Create draft agent": "Taslak ajan\u0131 olu\u015Ftur",
  "Agent created from AI interview.": "Ajan AI g\xF6r\xFC\u015Fmesinden olu\u015Fturuldu.",
  "Type your answer": "Cevab\u0131n\u0131z\u0131 yaz\u0131n",
  "Type your answer\u2026": "Cevab\u0131n\u0131z\u0131 yaz\u0131n...",
  "Next question": "S\u0131radaki soru",
  "Setup progress": "Kurulum ilerlemesi",
  "Agent setup": "Ajan kurulumu",
  "Start over": "Ba\u015Ftan ba\u015Flat",
  "Draft ready": "Taslak haz\u0131r",
  "Business Brain required": "Business Brain gerekli",
  "Open Company knowledge": "\u015Eirket bilgisini a\xE7",
  "Create failed": "Olu\u015Fturulamad\u0131",
  "Publish a Business Brain first so the interview can pin knowledge.": "G\xF6r\xFC\u015Fmenin bilgiyi ba\u011Flayabilmesi i\xE7in \xF6nce bir Business Brain yay\u0131nlay\u0131n.",
  CenterOS: "CenterOS",
  "Interview failed": "G\xF6r\xFC\u015Fme ba\u015Far\u0131s\u0131z",
  "AI istek limiti doldu. Birka\xE7 saniye bekleyip tekrar g\xF6nderin veya YZ Ayarlar\u0131 \u2192 CenterOS Agent modelini GLM-5.2 yap\u0131n.": "AI istek limiti doldu. Birka\xE7 saniye bekleyip tekrar g\xF6nderin veya YZ Ayarlar\u0131 \u2192 CenterOS Agent modelini GLM-5.2 yap\u0131n.",
  "AI interview is paused": "AI g\xF6r\xFC\u015Fmesi duraklat\u0131ld\u0131",
  "CenterOS Agent g\xF6r\xFC\u015Fmesi YZ Ayarlar\u0131'nda durdurulmu\u015F. \xD6nce CenterOS Agent i\u015F y\xFCk\xFCn\xFC a\xE7\u0131n.": "CenterOS Agent g\xF6r\xFC\u015Fmesi YZ Ayarlar\u0131'nda durdurulmu\u015F. \xD6nce CenterOS Agent i\u015F y\xFCk\xFCn\xFC a\xE7\u0131n.",
  "Thinking\u2026": "D\xFC\u015F\xFCn\xFCyor\u2026",
  You: "Siz",
  AI: "AI",
  "+ New Agent": "+ Yeni Ajan",
  "New Agent": "Yeni Ajan",
  "Total Agents": "Toplam ajan",
  "agents": "ajan",
  "Approaching plan agent limit": "Plan limitine yakla\u015F\u0131ld\u0131",
  "Agent plan limit reached": "Plan ajan limitine ula\u015F\u0131ld\u0131. Yeni ajan olu\u015Fturmak i\xE7in plan\u0131 y\xFCkseltin.",
  "Approaching plan campaign limit": "Plan kampanya limitine yakla\u015F\u0131ld\u0131",
  "Campaign plan limit reached": "Plan kampanya limitine ula\u015F\u0131ld\u0131. Yeni kampanya olu\u015Fturmak i\xE7in plan\u0131 y\xFCkseltin.",
  "Approaching plan phone number limit": "Plan numara limitine yakla\u015F\u0131ld\u0131",
  "Phone number plan limit reached": "Plan numara limitine ula\u015F\u0131ld\u0131. Yeni numara eklemek i\xE7in plan\u0131 y\xFCkseltin.",
  "Approaching plan contact limit": "Plan ki\u015Fi limitine yakla\u015F\u0131ld\u0131",
  "Contact plan limit reached": "Plan ki\u015Fi limitine ula\u015F\u0131ld\u0131. Yeni ki\u015Fi eklemek i\xE7in plan\u0131 y\xFCkseltin.",
  "Approaching plan lead limit": "Plan lead limitine yakla\u015F\u0131ld\u0131",
  "Lead plan limit reached": "Plan lead limitine ula\u015F\u0131ld\u0131. Yeni lead i\xE7in plan\u0131 y\xFCkseltin veya arama ak\u0131\u015F\u0131n\u0131 g\xF6zden ge\xE7irin.",
  "Incoming": "Gelen",
  "Outgoing": "Giden",
  "Omni": "Omni",
  "Direction": "Y\xF6n",
  "Agent direction (inbound / outbound)": "Ajan y\xF6n\xFC (gelen / giden)",
  "Live phone knobs (PSTN)": "Canl\u0131 hat ayarlar\u0131 (PSTN)",
  "These settings apply to live phone (AudioSocket / media-gateway) after Publish & deploy \u2014 not only global env. Softphone also uses interruption mode where relevant.": "Bu ayarlar Yay\u0131nla sonras\u0131 canl\u0131 telefona (AudioSocket / media-gateway) gider \u2014 yaln\u0131zca global env de\u011Fil. Softphone da kesme modunu kullan\u0131r.",
  "Live (published) effective": "Canl\u0131 (yay\u0131nl\u0131) ge\xE7erli de\u011Ferler",
  "Interruption": "Kesme",
  "Turn / EOU silence": "Tur / konu\u015Fma sonu sessizlik",
  "Idle silence": "Bo\u015Fta sessizlik",
  "hangup on idle": "bo\u015Fta kapat",
  "Max call": "Maks. arama",
  "Draft differs \u2014 publish to push knobs to the phone path.": "Taslak farkl\u0131 \u2014 hat yoluna basmak i\xE7in yay\u0131nlay\u0131n.",
  "Turn / EOU silence (s)": "Tur / konu\u015Fma sonu sessizlik (sn)",
  "How long to wait after user stops talking before agent replies (phone VAD)": "Kullan\u0131c\u0131 susunca ajan\u0131n cevap vermeden \xF6nce bekledi\u011Fi s\xFCre (telefon VAD)",
  "Idle silence (ms)": "Bo\u015Fta sessizlik (ms)",
  "Long quiet period before optional hangup": "\u0130ste\u011Fe ba\u011Fl\u0131 kapatmadan \xF6nceki uzun sessizlik",
  "Interruption mode (live phone)": "Kesme modu (canl\u0131 hat)",
  "Hard \u2014 cut agent audio immediately": "Hard \u2014 ajan sesini an\u0131nda kes",
  "Duck \u2014 lower volume; hard cut after longer speech": "Duck \u2014 sesi k\u0131s; uzun konu\u015Fmada kes",
  "Off \u2014 no barge-in": "Off \u2014 s\xF6z kesme yok",
  "Per-agent policy for PSTN/media-gateway. Global VOICE_INTERRUPTION_MODE is only the default when agent mode is empty.": "Ajan bazl\u0131 PSTN/media-gateway politikas\u0131. Global VOICE_INTERRUPTION_MODE yaln\u0131zca ajan modu bo\u015Fsa varsay\u0131lan.",
  "Interruptible (master)": "Kesilebilir (ana anahtar)",
  "End call on idle silence": "Bo\u015Fta sessizlikte g\xF6r\xFC\u015Fmeyi kapat",
  "Hard cap on live call length": "Canl\u0131 arama s\xFCresi \xFCst s\u0131n\u0131r\u0131",
  "Incoming (answer phone)": "Gelen (telefonu a\xE7ar)",
  "Outgoing (dial / campaigns)": "Giden (arama / kampanya)",
  "Omni (all channels)": "Omni (t\xFCm kanallar)",
  "Inbound agent: bind a published agent to a DID on Numbers (Gelen ba\u011F). Answers ringing phones.": "Gelen ajan: yay\u0131nl\u0131 ajan\u0131 Numaralar\u2019da DID\u2019e ba\u011Flay\u0131n (Gelen ba\u011F). \xC7alan telefonu cevaplar.",
  "Outbound agent: use Campaigns or Agent dial panel. Does not answer inbound DID by itself.": "Giden ajan: Kampanyalar veya ajan arama paneli. Tek ba\u015F\u0131na gelen DID\u2019i cevaplamaz.",
  "Webchat agent: text/chat widget path. Voice campaign dial uses outbound agents.": "Webchat ajan: metin/sohbet widget yolu. Ses kampanyas\u0131 i\xE7in giden ajan kullan\u0131n.",
  "Omni agent: can be used for mixed paths; prefer explicit Incoming or Outgoing for ops clarity.": "Omni ajan: kar\u0131\u015F\u0131k yollar i\xE7in; operasyon netli\u011Fi i\xE7in Gelen veya Giden se\xE7in.",
  "Draft": "Taslak",
  "All": "T\xFCm\xFC",
  "Custom Voice": "\xD6zel ses",
  "Search agents...": "Ajan ara...",
  "Create your first agent": "\u0130lk ajan\u0131n\u0131z\u0131 olu\u015Fturun",
  "Build AI-powered voice agents to handle incoming calls or run automated campaigns with natural conversations.": "Gelen aramalar\u0131 kar\u015F\u0131layan veya do\u011Fal konu\u015Fmal\u0131 kampanyalar y\xFCr\xFCten AI ses ajanlar\u0131 olu\u015Fturun.",
  "Create Your First Agent": "\u0130lk ajan\u0131n\u0131z\u0131 olu\u015Fturun",
  "Create New Agent": "Yeni Ajan Olu\u015Ftur",
  "Configure your conversational AI agent with a voice and personality": "Konu\u015Fmal\u0131 AI ajan\u0131n\u0131z\u0131 ses ve ki\u015Filik ile yap\u0131land\u0131r\u0131n",
  "Agent Type *": "Ajan tipi *",
  "Agent Type": "Ajan tipi",
  "Incoming Agent": "Gelen arama ajan\u0131",
  "Open-ended AI conversations. Best for receiving calls on purchased numbers and human-like dialog.": "A\xE7\u0131k u\xE7lu AI konu\u015Fmalar\u0131. Sat\u0131n al\u0131nan numaralarda gelen arama ve do\u011Fal diyalog i\xE7in ideal.",
  "Flow Agent": "Ak\u0131\u015F ajan\u0131",
  "Campaign / dialer style. Best for bulk outbound, reminders, confirmations and predictable scripts.": "Kampanya / arama tarz\u0131. Toplu giden arama, hat\u0131rlatma, onay ve \xF6ng\xF6r\xFClebilir scriptler i\xE7in ideal.",
  "Custom Engine Agent": "\xD6zel motor ajan\u0131",
  "Coming soon": "Yak\u0131nda",
  "Self-hosted FreeSWITCH pipeline is not enabled on this CenterOS deployment.": "Self-hosted FreeSWITCH hatt\u0131 bu CenterOS kurulumunda a\xE7\u0131k de\u011Fil.",
  "Agent Name *": "Ajan ad\u0131 *",
  "Agent Name": "Ajan ad\u0131",
  "Voice & Personality": "Ses ve ki\u015Filik",
  "Voice Tone": "Ses tonu",
  "Personality": "Ki\u015Filik",
  "Voice & Language \xB7 Telephony stack": "Ses ve dil \xB7 Telefoni y\u0131\u011F\u0131n\u0131",
  "Platform admin": "Platform ayarlar\u0131",
  "PLATFORM ADMIN": "PLATFORM AYARLARI",
  "Platform settings": "Platform ayarlar\u0131",
  "DID pool \xB7 CenterOS packages \xB7 Panaryus plan links": "DID havuzu \xB7 CenterOS paketleri \xB7 Panaryus plan ba\u011Flar\u0131",
  "Open platform settings": "Platform ayarlar\u0131n\u0131 a\xE7",
  "This account is missing platform.admin. Sign out of CenterOS, open Call Center from Panaryus portal again, then hard-refresh.": "Bu oturumda platform.admin yetkisi yok. CenterOS\u2019u kapat\u0131p Panaryus portal\u0131ndan Call Center\u2019\u0131 yeniden a\xE7\u0131n, ard\u0131ndan sayfay\u0131 sert yenileyin (Ctrl+Shift+R).",
  "Only Panaryus operators. Manage shared DIDs, CenterOS packages, and attach packs to Panaryus plans.": "Yaln\u0131zca Panaryus operat\xF6rleri. Ortak DID, CenterOS paketleri ve Panaryus plan ba\u011Flar\u0131.",
  "Operator desk for shared DIDs, reusable CenterOS packs, and which Panaryus plan unlocks them.": "Ortak DID\u2019ler, yeniden kullan\u0131labilir CenterOS paketleri ve hangi Panaryus plan\u0131n\u0131n neyi a\xE7t\u0131\u011F\u0131n\u0131 y\xF6netti\u011Finiz operat\xF6r masas\u0131.",
  "Summary": "\xD6zet",
  "Active DIDs": "Aktif DID",
  "Packages": "Paketler",
  "Plans linked": "Ba\u011Fl\u0131 plan",
  "Platform sections": "Platform b\xF6l\xFCmleri",
  "Shared outbound CLI numbers": "Payla\u015F\u0131ml\u0131 giden CLI numaralar\u0131",
  "Capability packs for plans": "Planlar i\xE7in yetenek paketleri",
  "Which plan gets which pack": "Hangi plan hangi paketi al\u0131r",
  "Loading platform settings\u2026": "Platform ayarlar\u0131 y\xFCkleniyor\u2026",
  "Platform DIDs": "Platform DID",
  "CenterOS packages": "CenterOS paketleri",
  "Panaryus plan links": "Panaryus plan ba\u011Flar\u0131",
  Tariffs: "Tarifeler",
  "Cost and sale rates": "Maliyet ve sat\u0131\u015F tarifeleri",
  "Edit real service prices below. Wholesale is your provider cost; retail is the customer sale price. Billing estimates gross profit at read time \u2014 the ledger stays quantity-only.": "A\u015Fa\u011F\u0131dan ger\xE7ek servis fiyatlar\u0131n\u0131 d\xFCzenleyin. Ger\xE7ek maliyet sa\u011Flay\u0131c\u0131/hizmet maliyetiniz; sat\u0131\u015F tutar\u0131 m\xFC\u015Fteri fiyat\u0131d\u0131r. Faturalama panosu br\xFCt k\xE2r\u0131 okuma an\u0131nda tahmin eder \u2014 defter yaln\u0131zca miktar tutar.",
  "Provider-aware wholesale (real cost) and customer sale tariffs. Units match vendor pricing (hour / minute / 1K chars / 1M tokens). Ledger stays quantity-only; money is a read-time estimate.": "Sa\u011Flay\u0131c\u0131ya g\xF6re ger\xE7ek maliyet ve kullan\u0131c\u0131 sat\u0131\u015F tarifeleri. Birimler sat\u0131c\u0131 fiyatland\u0131rmas\u0131na uyar (saat / dakika / 1K karakter / 1M token). Defter yaln\u0131zca miktar tutar; para okuma an\u0131 tahminidir.",
  Save: "Kaydet",
  "Real cost": "Ger\xE7ek maliyet",
  "Customer sale price": "Kullan\u0131c\u0131 sat\u0131\u015F fiyat\u0131",
  "Gross profit": "Br\xFCt k\xE2r",
  Margin: "Marj",
  Unit: "Birim",
  Service: "Servis",
  Provider: "Sa\u011Flay\u0131c\u0131",
  Model: "Model",
  Source: "Kaynak",
  Currency: "Para birimi",
  "Phone minute": "Telefon dakikas\u0131",
  STT: "STT",
  TTS: "TTS",
  "LLM input": "LLM input",
  "LLM output": "LLM output",
  "Message / SMS": "Mesaj / SMS",
  "per minute": "dakika ba\u015F\u0131na",
  "per hour": "saat ba\u015F\u0131na",
  "per 1K characters": "1K karakter ba\u015F\u0131na",
  "per 1M tokens": "1M token ba\u015F\u0131na",
  "per message": "mesaj ba\u015F\u0131na",
  "per second": "saniye ba\u015F\u0131na",
  "Operator entry required": "Operat\xF6r giri\u015Fi gerekli",
  "Vendor list": "Sat\u0131c\u0131 listesi",
  "Needs verification": "Do\u011Frulanmal\u0131",
  Checked: "Kontrol",
  Effective: "Ge\xE7erlilik",
  Billed: "Faturalanan",
  "Reset to vendor list prices": "Sat\u0131c\u0131 liste fiyatlar\u0131na s\u0131f\u0131rla",
  "Vendor list costs applied to eligible rows. Review and Save.": "Uygun sat\u0131rlara sat\u0131c\u0131 liste fiyatlar\u0131 uyguland\u0131. Kontrol edip Kaydet\u2019e bas\u0131n.",
  "Saved value differs from vendor list suggestion": "Kaydedilmi\u015F de\u011Fer vendor \xF6nerisinden farkl\u0131",
  "Telephony rates save under providerMeters (zadarma/verimor). Billing dashboard still aggregates quantity without provider breakdown \u2014 uses legacy meters.telephony_minutes when present.": "Telefon tarifeleri providerMeters (zadarma/verimor) alt\u0131na kaydedilir. Faturalama panosu h\xE2l\xE2 sa\u011Flay\u0131c\u0131 k\u0131r\u0131l\u0131m\u0131 olmadan miktar toplar \u2014 varsa legacy meters.telephony_minutes kullan\u0131r.",
  "Package economics": "Paket ekonomisi",
  "Simulated cost / sale / margin for each linked plan using included minutes and current rate cards. Not an invoice. Telephony uses providerMeters when set.": "Ba\u011Fl\u0131 planlar i\xE7in dahil dakika + g\xFCncel rate card ile tahmini maliyet/sat\u0131\u015F/k\xE2r. Fatura de\u011Fildir. Telefon providerMeters kullan\u0131r.",
  "Telephony scenario": "Telefon senaryosu",
  "En pahal\u0131 telefon": "En pahal\u0131 telefon",
  "Ortalama telefon": "Ortalama telefon",
  "Incomplete packages": "Eksik paketler",
  "packages missing telephony cost": "pakette telefon maliyeti eksik",
  "Verimor/Zadarma cost must be entered before package profitability is complete.": "Verimor/Zadarma maliyeti girilmeden paket k\xE2rl\u0131l\u0131\u011F\u0131 tamamlanmaz.",
  "Lowest margin pack": "En d\xFC\u015F\xFCk marjl\u0131 paket",
  "Highest estimated cost": "En y\xFCksek tahmini maliyet",
  "Missing telephony cost": "Telefon maliyeti eksik",
  "Monthly potential revenue": "Ayl\u0131k potansiyel gelir",
  "TTS chars / min": "TTS karakter / dk",
  "LLM input tokens / min": "LLM input token / dk",
  "LLM output tokens / min": "LLM output token / dk",
  "No packages to simulate": "Sim\xFCle edilecek paket yok",
  "Create a CenterOS package and link it to a Panaryus plan.": "CenterOS paketi olu\u015Fturup Panaryus plan\u0131na ba\u011Flay\u0131n.",
  "CenterOS package": "CenterOS paketi",
  "Included minutes": "Dahil dakika",
  "Phone providers": "Telefon sa\u011Flay\u0131c\u0131lar\u0131",
  "AI stack": "AI y\u0131\u011F\u0131n\u0131",
  "Estimated real cost": "Tahmini ger\xE7ek maliyet",
  "Usage sale amount": "Kullan\u0131m sat\u0131\u015F tutar\u0131",
  "Plan subscription": "Plan aboneli\u011Fi",
  "Total potential revenue": "Toplam potansiyel gelir",
  Assumptions: "Varsay\u0131mlar",
  "Package basics": "Paket temel bilgileri",
  "Service selection": "Servis se\xE7imi",
  "Phone calls": "Telefon aramas\u0131",
  "Package customer tariffs": "Kullan\u0131c\u0131 tarifesi (paket)",
  "Defaults from global retail rate card; override only for this package.": "Global sat\u0131\u015F rate card\u2019dan gelir; yaln\u0131zca bu paket i\xE7in override edilir.",
  "Phone sale": "Telefon sat\u0131\u015F fiyat\u0131",
  "Wholesale costs (global)": "Maliyet (global)",
  "From Tariffs rate card \u2014 edit there.": "Tarifeler rate card\u2019dan okunur \u2014 orada d\xFCzenleyin.",
  "Live simulation": "Canl\u0131 sim\xFClasyon",
  "Phone tariff": "Telefon tarifesi",
  "Verimor cost": "Verimor maliyet",
  "Zadarma cost": "Zadarma maliyet",
  "Customer sale": "Kullan\u0131c\u0131 sat\u0131\u015F",
  "Verimor per-min cost": "Verimor dk maliyeti",
  "Zadarma per-min cost": "Zadarma dk maliyeti",
  "Customer per-min price": "Kullan\u0131c\u0131 dk fiyat\u0131",
  "Per-min cost": "Dk ba\u015F\u0131 maliyet",
  "Per-min customer price": "Dk ba\u015F\u0131 kullan\u0131c\u0131 fiyat\u0131",
  "enter cost": "maliyet gir",
  "Edit in Tariffs": "Tarifeler\u2019den d\xFCzenle",
  "Global provider cost \u2014 edit on Tariffs tab": "Global provider maliyeti \u2014 Tarifeler sekmesinden d\xFCzenleyin",
  "Wholesale cost is the global provider cost used by all packages. Customer sale is a package override only.": "Ger\xE7ek maliyet t\xFCm paketlerde kullan\u0131lan global provider maliyetidir. Kullan\u0131c\u0131 sat\u0131\u015F\u0131 yaln\u0131zca paket override\u2019d\u0131r.",
  "This cost is the global provider cost used across all packages.": "Bu maliyet t\xFCm paketlerde kullan\u0131lan global provider maliyetidir.",
  "Missing \u2014 set on Tariffs": "Eksik \u2014 Tarifeler\u2019de girin",
  "Package override": "Paket override",
  "Default from global": "Global varsay\u0131lan",
  "Defaults from global retail rate card": "Global sat\u0131\u015F rate card\u2019dan",
  global: "global",
  Average: "Ortalama",
  "Phone unit cost": "Dk ba\u015F\u0131 maliyet",
  "Customer per-min sale": "Dk ba\u015F\u0131 kullan\u0131c\u0131 fiyat\u0131",
  "Product design: services, AI stack, package retail overrides, wholesale cost readout, and live cost/sale/margin simulation. Global tariffs stay on the Tariffs tab.": "\xDCr\xFCn tasar\u0131m\u0131: servisler, AI y\u0131\u011F\u0131n\u0131, paket sat\u0131\u015F override, global maliyet okumas\u0131 ve canl\u0131 maliyet/sat\u0131\u015F/k\xE2r sim\xFClasyonu. Global tarifeler Tarifeler sekmesinde kal\u0131r.",
  "Amounts use provider-native units (not integer cents per second).": "Tutarlar sa\u011Flay\u0131c\u0131ya \xF6zg\xFC birimlerde (saniye ba\u015F\u0131na tam sent de\u011Fil).",
  dk: "dk",
  saniye: "saniye",
  "1K karakter": "1K karakter",
  "1K token": "1K token",
  adet: "adet",
  "Bridge unavailable": "K\xF6pr\xFC kullan\u0131lam\u0131yor",
  "Panaryus admin bridge could not load saved tariffs. Values below are defaults and may not be saved until the bridge is healthy.": "Panaryus admin k\xF6pr\xFCs\xFC kay\u0131tl\u0131 tarifeleri y\xFCkleyemedi. A\u015Fa\u011F\u0131daki de\u011Ferler varsay\u0131land\u0131r; k\xF6pr\xFC sa\u011Fl\u0131kl\u0131 olana kadar kaydedilemeyebilir.",
  "Loaded from Panaryus": "Panaryus\u2019tan y\xFCklendi",
  "Values below come from saved host options (or host defaults when empty).": "A\u015Fa\u011F\u0131daki de\u011Ferler kay\u0131tl\u0131 host ayarlar\u0131ndan (bo\u015Fsa host varsay\u0131lanlar\u0131ndan) gelir.",
  Defaults: "Varsay\u0131lanlar",
  "Showing built-in defaults. Save once the admin bridge is healthy to persist tariffs in Panaryus.": "Yerle\u015Fik varsay\u0131lanlar g\xF6steriliyor. Tarifeleri Panaryus\u2019ta saklamak i\xE7in admin k\xF6pr\xFCs\xFC sa\u011Fl\u0131kl\u0131 olunca Kaydet\u2019e bas\u0131n.",
  "Advanced JSON": "Geli\u015Fmi\u015F JSON",
  "Ops / debug only \u2014 generated from the table above": "Yaln\u0131zca ops / debug \u2014 \xFCstteki tablodan \xFCretilir",
  "Wholesale provider cost JSON": "Toptan / sa\u011Flay\u0131c\u0131 maliyet JSON",
  "Retail customer tariff JSON": "M\xFC\u015Fteri sat\u0131\u015F tarife JSON",
  "Apply JSON to table": "JSON\u2019u tabloya uygula",
  "Advanced JSON applied to the table.": "Geli\u015Fmi\u015F JSON tabloya uyguland\u0131.",
  "Advanced JSON is invalid. Fix JSON before applying.": "Geli\u015Fmi\u015F JSON ge\xE7ersiz. Uygulamadan \xF6nce JSON\u2019u d\xFCzeltin.",
  "Save disabled until Panaryus admin bridge is healthy.": "Panaryus admin k\xF6pr\xFCs\xFC sa\u011Fl\u0131kl\u0131 olana kadar kaydet kapal\u0131.",
  "Saved values sync into CENTEROS_COST_RATES_JSON and CENTEROS_RETAIL_RATES_JSON.": "Kay\u0131t sonras\u0131 de\u011Ferler CENTEROS_COST_RATES_JSON ve CENTEROS_RETAIL_RATES_JSON\u2019a senkronlan\u0131r.",
  "Rate cards saved. Restart CenterOS API to apply runtime env.": "Tarifeler kaydedildi. Runtime env i\xE7in CenterOS API\u2019yi yeniden ba\u015Flat\u0131n.",
  "FX for mixed-currency rows": "Kar\u0131\u015F\u0131k para birimli sat\u0131rlar i\xE7in kur",
  "per 1K meters use amount per 1000 units": "1K birimli sat\u0131rlarda tutar 1000 birim ba\u015F\u0131na",
  "Use tryMinorPerUnit / usdMinorPerUnit for per-unit meters and tryMinorPer1k / usdMinorPer1k for token or character meters.": "Birim ba\u015F\u0131na \xF6l\xE7\xFCmler i\xE7in tryMinorPerUnit / usdMinorPerUnit; token veya karakter i\xE7in tryMinorPer1k / usdMinorPer1k kullan\u0131n.",
  "Shared platform phone numbers": "Payla\u015F\u0131ml\u0131 platform numaralar\u0131",
  "Assigned to entitled tenants on SSO as outbound CLI. Minutes: plan field centeros_voice_minutes_limit.": "Yetkili tenantlara SSO\u2019da giden CLI olarak atan\u0131r. Dakika: plan alan\u0131 centeros_voice_minutes_limit.",
  "Assigned to entitled tenants on SSO as outbound CLI. Minutes still come from the linked plan pack.": "Yetkili tenantlara SSO\u2019da giden CLI olarak atan\u0131r. Dakika kotas\u0131 ba\u011Fl\u0131 plan paketinden gelir.",
  "Save DID pool": "DID havuzunu kaydet",
  "Add number": "Numara ekle",
  "Remove": "Kald\u0131r",
  "On": "A\xE7\u0131k",
  "Off": "Kapal\u0131",
  "Label": "Etiket",
  "Number (E.164)": "Numara (E.164)",
  "Scope": "Kapsam",
  "Status": "Durum",
  "Actions": "\u0130\u015Flemler",
  "No platform numbers yet": "Hen\xFCz platform numaras\u0131 yok",
  "Add a Verimor or Zadarma DID that tenants can use as outbound CLI.": "Tenantlar\u0131n giden CLI olarak kullanaca\u011F\u0131 bir Verimor veya Zadarma DID ekleyin.",
  "rows": "sat\u0131r",
  "Saving\u2026": "Kaydediliyor\u2026",
  "Saved": "Kaydedildi",
  "Reusable CenterOS capability packs. Attach a pack to a Panaryus plan under Plan links.": "Yeniden kullan\u0131labilir CenterOS yetenek paketleri. Plan ba\u011Flar\u0131 sekmesinden Panaryus plan\u0131na ekleyin.",
  "Reusable packs (minutes, voice tier, concurrency). Link them to Panaryus plans in the next tab.": "Yeniden kullan\u0131labilir paketler (dakika, ses seviyesi, e\u015Fzamanl\u0131l\u0131k). Sonraki sekmeden Panaryus planlar\u0131na ba\u011Flay\u0131n.",
  "Define minutes, which platform numbers tenants may use, and which AI stack (LLM / STT / TTS / realtime) the pack unlocks. Then link the pack to a plan.": "Dakika, tenant\u0131n kullanabilece\u011Fi platform numaralar\u0131 ve AI y\u0131\u011F\u0131n\u0131 (LLM / STT / TTS / realtime) tan\u0131mlay\u0131n. Sonra paketi plana ba\u011Flay\u0131n.",
  "Minutes / period": "Dakika / d\xF6nem",
  "Concurrent": "E\u015Fzamanl\u0131",
  "Max call (sec)": "Maks. arama (sn)",
  "Usage limits": "Kullan\u0131m limitleri",
  "Platform numbers": "Platform numaralar\u0131",
  "Assign platform numbers": "Platform numaras\u0131 ata",
  "Which shared DIDs this pack\u2019s tenants may use as outbound CLI. BYO numbers are always allowed.": "Bu paketin tenantlar\u0131n\u0131n giden CLI olarak kullanabilece\u011Fi payla\u015F\u0131ml\u0131 DID\u2019ler. Kendi (BYO) numaralar her zaman serbest.",
  "Tick the shared DIDs this pack may use as outbound CLI. Empty = BYO only. BYO numbers stay allowed.": "Bu paketin giden CLI olarak kullanaca\u011F\u0131 payla\u015F\u0131ml\u0131 DID\u2019leri i\u015Faretleyin. Bo\u015F = yaln\u0131z BYO. Kendi numaralar her zaman serbest.",
  "None (BYO only)": "Yok (yaln\u0131z BYO)",
  "All pool DIDs": "T\xFCm havuz DID\u2019leri",
  "Selected DIDs": "Se\xE7ili DID\u2019ler",
  "Select all": "T\xFCm\xFCn\xFC se\xE7",
  "Clear": "Temizle",
  "No pool numbers": "Havuzda numara yok",
  "Add numbers under Platform DIDs first, then assign them here.": "\xD6nce Platform DID sekmesinden numara ekleyin, sonra burada atay\u0131n.",
  "Add numbers under Platform DIDs first, then select them here.": "\xD6nce Platform DID sekmesinden numara ekleyin, sonra burada se\xE7in.",
  "Go to Platform DIDs": "Platform DID\u2019lere git",
  "Assigned": "Atanan",
  "Assigned: none (BYO only)": "Atanan: yok (yaln\u0131z BYO)",
  "Assigned: all pool numbers": "Atanan: t\xFCm havuz numaralar\u0131",
  "Services": "Servisler",
  "AI stack this pack may use. Realtime is OpenAI Realtime voice path.": "Bu paketin kullanabilece\u011Fi AI y\u0131\u011F\u0131n\u0131. Realtime = OpenAI Realtime ses yolu.",
  "Multi-select buckets. Tenant may use any selected provider in each bucket.": "\xC7oklu se\xE7im. Tenant her kovada se\xE7ili sa\u011Flay\u0131c\u0131lardan herhangi birini kullanabilir.",
  "Channels & modes": "Kanallar ve modlar",
  "LLM": "LLM",
  "Speech-to-text (STT)": "Konu\u015Fma\u2192metin (STT)",
  "Text-to-speech (TTS)": "Metin\u2192ses (TTS)",
  "Voice calls": "Sesli arama",
  "AI agents": "AI ajanlar",
  "OpenAI Realtime": "OpenAI Realtime",
  "BYO only": "Yaln\u0131z BYO",
  "All DIDs": "T\xFCm DID\u2019ler",
  "DIDs": "DID",
  "Add package": "Paket ekle",
  "Save packages": "Paketleri kaydet",
  "Remove package": "Paketi kald\u0131r",
  "Description": "A\xE7\u0131klama",
  "Short operator note": "K\u0131sa operat\xF6r notu",
  "No packages yet": "Hen\xFCz paket yok",
  "Create starter / growth / pro style packs, then attach them to plans.": "Starter / growth / pro tarz\u0131 paketler olu\u015Fturun, sonra planlara ba\u011Flay\u0131n.",
  "packages": "paket",
  "min": "dk",
  "Attach CenterOS package \u2192 Panaryus plan": "CenterOS paketi \u2192 Panaryus plan\u0131 ba\u011Fla",
  "Merges pack permissions into the Panaryus plan (centeros, voice minutes, profile\u2026).": "Paket izinlerini Panaryus plan\u0131na birle\u015Ftirir (centeros, ses dakikas\u0131, profil\u2026).",
  "Choosing a pack merges minutes, voice tier and CenterOS flags into that Panaryus plan.": "Paket se\xE7mek dakika, ses seviyesi ve CenterOS bayraklar\u0131n\u0131 o Panaryus plan\u0131na yazar.",
  "Current pack": "Mevcut paket",
  "No CenterOS pack": "CenterOS paketi yok",
  "Panaryus plan": "Panaryus plan\u0131",
  "Link package": "Paket ba\u011Fla",
  "Minutes": "Dakika",
  "None": "Yok",
  "No Panaryus plans found": "Panaryus plan\u0131 bulunamad\u0131",
  "Create or enable plans in Panaryus Admin, then refresh this page.": "Panaryus Admin\u2019de plan olu\u015Fturun veya etkinle\u015Ftirin, sonra bu sayfay\u0131 yenileyin.",
  "Tip": "\u0130pucu",
  "Create at least one CenterOS package before linking plans.": "Plan ba\u011Flamadan \xF6nce en az bir CenterOS paketi olu\u015Fturun.",
  "Go to packages": "Paketlere git",
  "Platform DID pool saved. Tenants pick up numbers on next login.": "Platform DID havuzu kaydedildi. Tenantlar sonraki giri\u015Fte numaralar\u0131 al\u0131r.",
  "CenterOS packages saved.": "CenterOS paketleri kaydedildi.",
  "Panaryus plan linked to CenterOS package.": "Panaryus plan\u0131 CenterOS paketine ba\u011Fland\u0131.",
  "Error": "Hata",
  "ElevenLabs + Zadarma": "ElevenLabs + Zadarma",
  "ElevenLabs + platform PSTN": "ElevenLabs + platform PSTN",
  "Premium TTS + our live phone trunk (active on this platform)": "Premium TTS + canl\u0131 telefon hatt\u0131m\u0131z (bu platformda aktif)",
  "Premium TTS \xB7 phone via Numbers DID (Verimor TR + Zadarma live on platform)": "Premium TTS \xB7 telefon Numaralar DID ile (platformda Verimor TR + Zadarma canl\u0131)",
  "OpenAI TTS + Zadarma": "OpenAI TTS + Zadarma",
  "OpenAI TTS + platform PSTN": "OpenAI TTS + platform PSTN",
  "Fallback TTS path; still Zadarma for telephony (not Twilio)": "Yedek TTS yolu; telefoni yine Zadarma (Twilio de\u011Fil)",
  "Fallback TTS \xB7 same multi-trunk telephony (Verimor / Zadarma by number)": "Yedek TTS \xB7 ayn\u0131 \xE7oklu hat (numaraya g\xF6re Verimor / Zadarma)",
  "ElevenLabs + Twilio": "ElevenLabs + Twilio",
  "Not used": "Kullan\u0131lm\u0131yor",
  "AgentLabs default \u2014 we do not use Twilio SID on this deployment": "AgentLabs varsay\u0131lan\u0131 \u2014 bu kurulumda Twilio SID kullanm\u0131yoruz",
  "Twilio is not the active customer trunk on this deployment": "Twilio bu kurulumda m\xFC\u015Fteri trunk\u2019\u0131 olarak kullan\u0131lm\u0131yor",
  "Custom SIP / FreeSWITCH": "\xD6zel SIP / FreeSWITCH",
  "Plugin later": "Sonra eklenti",
  "BYO SIP pipeline is not exposed in this create form yet": "BYO SIP hatt\u0131 bu olu\u015Fturma formunda hen\xFCz yok",
  "Customer BYO SIP credentials wizard is not self-serve yet \u2014 use Numbers BYO inventory + ops": "M\xFC\u015Fteri BYO SIP kimlik sihirbaz\u0131 hen\xFCz self-serve de\u011Fil \u2014 Numaralar BYO envanter + ops",
  "This card picks TTS only. Live phone trunk is chosen by the DID you bind under Numbers (Verimor TR, Zadarma intl, or BYO).": "Bu kart yaln\u0131zca TTS se\xE7er. Canl\u0131 telefon trunk\u2019\u0131 Numaralar\u2019da ba\u011Flad\u0131\u011F\u0131n\u0131z DID\u2019ye g\xF6redir (Verimor TR, Zadarma intl veya BYO).",
  "Available as platform TR trunk. Bind a Verimor DID on Numbers (Gelen ba\u011F / inventory) \u2014 it is not a separate agent-create card because trunk follows the number, not the agent.": "Platform TR trunk olarak mevcut. Numaralar\u2019da Verimor DID ba\u011Flay\u0131n (Gelen ba\u011F / envanter) \u2014 ajan formunda ayr\u0131 kart yok \xE7\xFCnk\xFC trunk ajana de\u011Fil numaraya ba\u011Fl\u0131d\u0131r.",
  "Voice * (ElevenLabs library)": "Ses * (ElevenLabs k\xFCt\xFCphanesi)",
  "Language *": "Dil *",
  "Language": "Dil",
  "voices from your ElevenLabs account": "ElevenLabs hesab\u0131n\u0131zdaki ses",
  "Open Voices tab once if library is empty": "K\xFCt\xFCphane bo\u015Fsa bir kez Sesler sekmesini a\xE7\u0131n",
  "AI Model & Behavior": "AI modeli ve davran\u0131\u015F",
  "LLM Model *": "LLM modeli *",
  "Grounded default (platform LLM \xB7 OpenAI)": "Platform varsay\u0131lan\u0131 (LLM \xB7 OpenAI)",
  "Model routing is controlled by CenterOS providers \u2014 not free multi-model pick yet.": "Model y\xF6nlendirmesi CenterOS sa\u011Flay\u0131c\u0131lar\u0131ndan y\xF6netilir \u2014 serbest model se\xE7imi hen\xFCz yok.",
  "Temperature": "S\u0131cakl\u0131k",
  "Current:": "G\xFCncel:",
  "Deterministic \u2190 \u2192 Creative": "Belirleyici \u2190 \u2192 Yarat\u0131c\u0131",
  "Voice Fine-Tuning": "Ses ince ayar\u0131",
  "Response Delay (turn timeout)": "Yan\u0131t gecikmesi (tur zaman a\u015F\u0131m\u0131)",
  "Seconds before the agent continues after silence": "Sessizlikten sonra ajan\u0131n devam etmeden \xF6nceki saniye",
  "Expressive Mode": "\u0130fade modu",
  "ElevenLabs conversational defaults": "ElevenLabs konu\u015Fma varsay\u0131lanlar\u0131",
  "Native EL style; extra audio-tag UI not wired yet": "EL stili; ek audio-tag aray\xFCz\xFC hen\xFCz ba\u011Fl\u0131 de\u011Fil",
  "Search templates by name or description\u2026": "Ada veya a\xE7\u0131klamaya g\xF6re \u015Fablon ara\u2026",
  "Receptionist": "Resepsiyon",
  "Lead Qualification": "Lead nitelendirme",
  "Appointment": "Randevu",
  "Support": "Destek",
  "Outbound Sales": "Giden sat\u0131\u015F",
  "Survey": "Anket",
  "Collections": "Tahsilat",
  "Events": "Etkinlik",
  "General": "Genel",
  "Sales": "Sat\u0131\u015F",
  "Use": "Kullan",
  "Selected \xB7 Use": "Se\xE7ildi \xB7 Kullan",
  "Browse all prompt templates": "T\xFCm prompt \u015Fablonlar\u0131na g\xF6z at",
  "System Prompt *": "Sistem promptu *",
  "System Prompt": "Sistem promptu",
  "Select a template above or write your own prompt\u2026": "Yukar\u0131dan \u015Fablon se\xE7in veya kendi promptunuzu yaz\u0131n\u2026",
  "Tip: Keep tone consistent. Use variables like {{business_name}} and {{agent_name}}.": "\u0130pucu: Tonu tutarl\u0131 tutun. {{business_name}} ve {{agent_name}} gibi de\u011Fi\u015Fkenler kullan\u0131n.",
  "First Message": "\u0130lk mesaj",
  "Best practices: warm and natural. Avoid \u201Cthis is an automated call\u2026\u201D.": "\u0130yi uygulama: s\u0131cak ve do\u011Fal ba\u015Flay\u0131n. \u201CBu otomatik bir aramad\u0131r\u2026\u201D demeyin.",
  "Available Dynamic Variables": "Kullan\u0131labilir dinamik de\u011Fi\u015Fkenler",
  "Knowledge Base (Optional)": "Bilgi bankas\u0131 (iste\u011Fe ba\u011Fl\u0131)",
  "Knowledge Base (Business Brain)": "Bilgi bankas\u0131 (Business Brain)",
  "Select knowledge base / brain": "Bilgi bankas\u0131 / brain se\xE7in",
  "CenterOS uses published Business Brain documents (not arbitrary URL list).": "CenterOS yay\u0131nlanm\u0131\u015F Business Brain belgelerini kullan\u0131r (serbest URL listesi de\u011Fil).",
  "System Tools": "Sistem ara\xE7lar\u0131",
  "Enable Call Transfer": "Arama aktar\u0131m\u0131n\u0131 a\xE7",
  "Agent can hand off to a human operator when needed": "Gerekirse ajan insan operat\xF6re devredebilir",
  "Enable End Conversation": "G\xF6r\xFC\u015Fmeyi bitirmeyi a\xE7",
  "Let agent intelligently end the call when appropriate": "Uygun oldu\u011Funda ajan g\xF6r\xFC\u015Fmeyi ak\u0131ll\u0131ca bitirebilir",
  "Enable Appointment / Callback": "Randevu / geri arama a\xE7",
  "Schedule callbacks or appointment follow-ups during the call": "Arama s\u0131ras\u0131nda geri arama veya randevu planla",
  "Enable Lead Capture": "Lead yakalamay\u0131 a\xE7",
  "Create leads from qualified conversations": "Nitelikli g\xF6r\xFC\u015Fmelerden lead olu\u015Ftur",
  "Enable Case Create": "Vaka olu\u015Fturmay\u0131 a\xE7",
  "Open a support case when the issue needs tracking": "Takip gereken durumda destek vakas\u0131 a\xE7",
  "Enable Language Detection": "Dil alg\u0131lamay\u0131 a\xE7",
  "Coming soon \u2014 not exposed as a toggle in this runtime yet": "Yak\u0131nda \u2014 bu \xE7al\u0131\u015Fma zaman\u0131nda hen\xFCz a\xE7ma/kapama yok",
  "Enable Email Sending": "E-posta g\xF6nderimini a\xE7",
  "Coming soon \u2014 not part of voice tool set on this stack": "Yak\u0131nda \u2014 bu y\u0131\u011F\u0131nda ses ara\xE7 setinde yok",
  "Cancel": "\u0130ptal",
  "Creating\u2026": "Olu\u015Fturuluyor\u2026",
  "Professional": "Profesyonel",
  "Friendly": "Samimi",
  "Warm": "S\u0131cak",
  "Calm": "Sakin",
  "Energetic": "Enerjik",
  "Helpful": "Yard\u0131msever",
  "Empathetic": "Empatik",
  "Direct": "Do\u011Frudan",
  "Sales-oriented": "Sat\u0131\u015F odakl\u0131",
  "Formal": "Resmi",
  "Agent name is required.": "Ajan ad\u0131 zorunlu.",
  "System prompt is required.": "Sistem promptu zorunlu.",
  "Select a Knowledge Base (Business Brain) first.": "\xD6nce bir Knowledge Base (Business Brain) se\xE7in.",
  "Select an ElevenLabs voice.": "Bir ElevenLabs sesi se\xE7in.",
  "Turkish (tr-TR)": "T\xFCrk\xE7e (tr-TR)",
  "English (en-US)": "\u0130ngilizce (en-US)",
  "English (en-GB)": "\u0130ngilizce (en-GB)",
  "Arabic (ar-SA)": "Arap\xE7a (ar-SA)",
  "Back to agents": "Ajan listesine d\xF6n",
  "Edit Agent \u2014 configure voice, personality and system prompt": "Ajan\u0131 d\xFCzenle \u2014 ses, ki\u015Filik ve sistem promptunu yap\u0131land\u0131r\u0131n",
  "Agent Configuration": "Ajan yap\u0131land\u0131rmas\u0131",
  "ElevenLabs voice (full library)": "ElevenLabs sesi (tam k\xFCt\xFCphane)",
  "Style preset (optional)": "Stil \xF6nayar\u0131 (iste\u011Fe ba\u011Fl\u0131)",
  "Select Language": "Dil se\xE7",
  "Select Voice": "Ses se\xE7",
  "Max Conversation Duration (sec)": "Maks. g\xF6r\xFC\u015Fme s\xFCresi (sn)",
  "Turn timeout (s)": "Tur zaman a\u015F\u0131m\u0131 (sn)",
  "Silence timeout (ms)": "Sessizlik zaman a\u015F\u0131m\u0131 (ms)",
  "End call on silence": "Sessizlikte aramay\u0131 bitir",
  "Transfer phone number": "Aktar\u0131m telefon numaras\u0131",
  "Opening statement when the call connects": "Arama ba\u011Fland\u0131\u011F\u0131nda a\xE7\u0131l\u0131\u015F c\xFCmlesi",
  "Extra connector tools": "Ek connector ara\xE7lar\u0131",
  "Test Agent": "Ajan\u0131 test et",
  "Publish first, then send a test message.": "\xD6nce yay\u0131nlay\u0131n, sonra test mesaj\u0131 g\xF6nderin.",
  "No messages yet.": "Hen\xFCz mesaj yok.",
  "Type a message\u2026": "Mesaj yaz\u0131n\u2026",
  "Connecting\u2026": "Ba\u011Flan\u0131yor\u2026",
  "Agent Updated!": "Ajan g\xFCncellendi!",
  "Agent Created!": "Ajan olu\u015Fturuldu!",
  "WEBCHAT KEY": "WEBCHAT ANAHTARI",
  "Verified AI agent": "Do\u011Frulanm\u0131\u015F AI ajan\u0131",
  "Use Case": "Kullan\u0131m amac\u0131",
  "Basic Info": "Temel bilgi",
  "Prompts": "Promptlar",
  "Review": "G\xF6zden ge\xE7ir",
  "Back": "Geri",
  "Next": "\u0130leri",
  "Finish & create": "Bitir ve olu\u015Ftur",
  "Or use a template": "Veya \u015Fablon kullan",
  "Or start from a template": "Veya \u015Fablondan ba\u015Fla",
  "Browse all prompt templates \u2192": "T\xFCm prompt \u015Fablonlar\u0131na g\xF6z at \u2192",
  "Outgoing / Custom Voice": "Giden / \xD6zel ses",
  "Best for campaigns, reminders and dialer use.": "Kampanya, hat\u0131rlatma ve arama i\xE7in ideal.",
  "Open-ended AI for inbound calls and human-like dialog.": "Gelen aramalar ve do\u011Fal diyalog i\xE7in a\xE7\u0131k u\xE7lu AI.",
  "1 \xB7 Use Case": "1 \xB7 Kullan\u0131m amac\u0131",
  "2 \xB7 Basic Info": "2 \xB7 Temel bilgi",
  "3 \xB7 Personality": "3 \xB7 Ki\u015Filik",
  "4 \xB7 Prompts": "4 \xB7 Promptlar",
  "5 \xB7 Voice": "5 \xB7 Ses",
  "6 \xB7 Review": "6 \xB7 G\xF6zden ge\xE7ir",
  "Name": "Ad",
  "Type": "Tip",
  "Brain": "Brain",
  "Template": "\u015Eablon",
  "First message": "\u0130lk mesaj",
  "Wizard steps": "Sihirbaz ad\u0131mlar\u0131",
  "Close": "Kapat",
  "Loading\u2026": "Y\xFCkleniyor\u2026",
  "active": "aktif",
  "Custom": "\xD6zel",
  "Webchat": "Webchat",
  "Search name, id, description\u2026": "Ad, id, a\xE7\u0131klama ara\u2026",
  "ElevenLabs \xB7 recommended": "ElevenLabs \xB7 \xF6nerilen",
  "ElevenLabs": "ElevenLabs",
  "Zadarma": "Zadarma",
  "Phone trunk (not Twilio)": "Telefon hatt\u0131 (Twilio de\u011Fil)",
  "Mapped library voices": "E\u015Flenen k\xFCt\xFCphane sesleri",
  "Active TTS provider": "Aktif TTS sa\u011Flay\u0131c\u0131",
  "Loading library\u2026 (or open Voices tab and Refresh)": "K\xFCt\xFCphane y\xFCkleniyor\u2026 (veya Sesler sekmesini a\xE7\u0131p yenileyin)",
  "Describe the agent's personality and behavior": "Ajan\u0131n ki\u015Fili\u011Fini ve davran\u0131\u015F\u0131n\u0131 tan\u0131mlay\u0131n",
  "Configuration incomplete \u2014 open to finish setup.": "Yap\u0131land\u0131rma eksik \u2014 kurulumu tamamlamak i\xE7in a\xE7\u0131n.",
  "Canl\u0131 TTS yan\u0131t vermedi; statik \xF6rnek \xE7al\u0131nd\u0131.": "Canl\u0131 TTS yan\u0131t vermedi; statik \xF6rnek \xE7al\u0131nd\u0131.",
  "ElevenLabs library load failed:": "ElevenLabs k\xFCt\xFCphanesi y\xFCklenemedi:",
  "All ({n})": "T\xFCm\xFC ({n})",
  "Incoming ({n})": "Gelen ({n})",
  "Custom Voice ({n})": "\xD6zel ses ({n})",
  "Published ({n})": "Yay\u0131nda ({n})",
  "Draft ({n})": "Taslak ({n})",
  "Describe the agent": "Ajan\u0131 tan\u0131mlay\u0131n",
  "Enter agent name": "Ajan ad\u0131n\u0131 girin",
  "Select a published Business Brain.": "Yay\u0131nlanm\u0131\u015F bir Business Brain se\xE7in.",
  "Enter an agent name (min 2 characters).": "Ajan ad\u0131 girin (en az 2 karakter).",
  "System prompt must be at least 10 characters.": "Sistem promptu en az 10 karakter olmal\u0131.",
  "Publish a Business Brain first so the wizard can pin knowledge.": "Sihirbaz\u0131n bilgiyi ba\u011Flayabilmesi i\xE7in \xF6nce bir Business Brain yay\u0131nlay\u0131n.",
  "Max duration (sec)": "Maks. s\xFCre (sn)",
  "Supports {{business_name}} {{agent_name}} {{purpose}}": "{{business_name}} {{agent_name}} {{purpose}} desteklenir",
  "Playbook view": "Playbook g\xF6r\xFCn\xFCm\xFC",
  "Playbook flow": "Playbook ak\u0131\u015F\u0131",
  "Next step": "Sonraki ad\u0131m",
  "Sequential (default)": "S\u0131ral\u0131 (varsay\u0131lan)",
  "Select a step on the canvas to edit fields.": "Alanlar\u0131 d\xFCzenlemek i\xE7in canvas \xFCzerinde bir ad\u0131m se\xE7in.",
  List: "Liste",
  Flow: "Ak\u0131\u015F",
  "Inline pack": "Inline paket",
  "Prompt only": "Sadece prompt",
  "Test retrieval": "Retrieval test",
  "No published Business Brain yet. Publish a brain on the Company knowledge page": "Yay\u0131nlanm\u0131\u015F Business Brain yok. \u015Eirket bilgisi sayfas\u0131nda bir brain yay\u0131nlay\u0131n",
  "Select a published Business Brain, or switch knowledge mode.": "Yay\u0131nlanm\u0131\u015F bir Business Brain se\xE7in veya bilgi modunu de\u011Fi\u015Ftirin.",
  "Inline pack is required when Inline pack mode is selected. Paste knowledge or switch mode.": "Inline paket modunda metin zorunlu. Bilgi yap\u0131\u015Ft\u0131r\u0131n veya modu de\u011Fi\u015Ftirin.",
  "No agents match filters": "Filtrelere uyan ajan yok",
  "Demo/test agents are hidden. Turn off the filter to show them, or create a new agent.": "Demo/test ajanlar gizli. G\xF6rmek i\xE7in filtreyi kapat\u0131n veya yeni ajan olu\u015Fturun.",
  "Show demo/test agents": "Demo/test ajanlar\u0131 g\xF6ster"
};
var ar = {
  "AI Agents": "\u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
  "Analytics": "\u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A",
  "Approve": "\u0645\u0648\u0627\u0641\u0642\u0629",
  "Approved": "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629",
  "Authorized scope": "\u0627\u0644\u0646\u0637\u0627\u0642 \u0627\u0644\u0645\u0635\u0631\u0651\u062D",
  "Available modules": "\u0627\u0644\u0648\u062D\u062F\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
  "Billing & Usage": "\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
  "Build a verified source of truth": "\u0623\u0646\u0634\u0626 \u0645\u0635\u062F\u0631 \u062D\u0642\u064A\u0642\u0629 \u0645\u0648\u062B\u0648\u0642\u064B\u0627",
  "Business Brain": "\u0639\u0642\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644",
  "Channels": "\u0627\u0644\u0642\u0646\u0648\u0627\u062A",
  "Conversations": "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
  "Directory": "\u0627\u0644\u062F\u0644\u064A\u0644",
  Numbers: "\u0627\u0644\u0623\u0631\u0642\u0627\u0645",
  "Caller IDs and BYO numbers": "\u0647\u0648\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u0635\u0644 \u0648\u0623\u0631\u0642\u0627\u0645 BYO",
  "Campaigns": "\u0627\u0644\u062D\u0645\u0644\u0627\u062A",
  "Leads": "\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0645\u0644\u0648\u0646",
  "Calling Factory": "\u0645\u0635\u0646\u0639 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A",
  "Control Plane": "\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062A\u062D\u0643\u0645",
  "Create Brain": "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0639\u0642\u0644",
  "Customer Operations": "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
  "Main navigation": "\u0627\u0644\u062A\u0646\u0642\u0644 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
  "Mobile navigation": "\u062A\u0646\u0642\u0644 \u0627\u0644\u062C\u0648\u0627\u0644",
  "Home": "\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
  "Daily work": "\u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u064A\u0648\u0645\u064A",
  Build: "\u0627\u0644\u0625\u0646\u0634\u0627\u0621",
  "Setup": "\u0627\u0644\u0625\u0639\u062F\u0627\u062F",
  "System": "\u0627\u0644\u0646\u0638\u0627\u0645",
  "Hide demo/test agents": "\u0625\u062E\u0641\u0627\u0621 \u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0639\u0631\u0636/\u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631",
  "Demo/test": "\u0639\u0631\u0636/\u0627\u062E\u062A\u0628\u0627\u0631",
  Incomplete: "\u063A\u064A\u0631 \u0645\u0643\u062A\u0645\u0644",
  "Includes demo/browser_demo sessions": "\u064A\u0634\u0645\u0644 \u062C\u0644\u0633\u0627\u062A demo/browser_demo",
  "Precall blocked": "\u062D\u0638\u0631 \u0642\u0628\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  "Purpose not allowed": "\u0642\u0627\u0644\u0628 \u0627\u0644\u063A\u0631\u0636 \u063A\u064A\u0631 \u0645\u0633\u0645\u0648\u062D",
  "Custom purpose blocked": "\u0627\u0644\u063A\u0631\u0636 \u0627\u0644\u0645\u062E\u0635\u0635 \u0645\u062D\u0638\u0648\u0631",
  "Freeform note blocked": "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0627\u0644\u062D\u0631\u0629 \u0645\u062D\u0638\u0648\u0631\u0629",
  "Denylist blocked the call content": "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0638\u0631 \u2014 \u062A\u0645 \u0645\u0646\u0639 \u0627\u0644\u0645\u062D\u062A\u0648\u0649",
  "Denylist flagged (call continued)": "\u062A\u0645 \u062A\u0639\u0644\u064A\u0645 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062D\u0638\u0631 (\u0627\u0633\u062A\u0645\u0631\u062A \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629)",
  "Number is on DNC list": "\u0627\u0644\u0631\u0642\u0645 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0639\u062F\u0645 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  "Platform warm-up daily minutes exceeded": "\u0627\u0646\u062A\u0647\u062A \u062F\u0642\u0627\u0626\u0642 \u0627\u0644\u0625\u062D\u0645\u0627\u0621 \u0627\u0644\u064A\u0648\u0645\u064A\u0629 \u0644\u0644\u0645\u0646\u0635\u0629",
  "Welcome": "\u0645\u0631\u062D\u0628\u064B\u0627",
  Today: "\u0627\u0644\u064A\u0648\u0645",
  "TODAY OPS": "\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u064A\u0648\u0645",
  "Command center": "\u0645\u0631\u0643\u0632 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
  "Pick a job below. Campaign \u2192 Calls \u2192 Leads.": "\u0627\u062E\u062A\u0631 \u0645\u0647\u0645\u0629 \u0623\u062F\u0646\u0627\u0647. \u062D\u0645\u0644\u0629 \u2192 \u0645\u0643\u0627\u0644\u0645\u0627\u062A \u2192 \u0639\u0645\u0644\u0627\u0621 \u0645\u062D\u062A\u0645\u0644\u0648\u0646.",
  "Run outbound campaigns, review calls, follow leads \u2014 this home is your work queue, not a feature map.": "\u0634\u063A\u0651\u0644 \u0627\u0644\u062D\u0645\u0644\u0627\u062A\u060C \u0648\u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A\u060C \u0648\u062A\u0627\u0628\u0639 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u2014 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0642\u0627\u0626\u0645\u0629 \u0639\u0645\u0644 \u0648\u0644\u064A\u0633\u062A \u062E\u0631\u064A\u0637\u0629 \u0645\u064A\u0632\u0627\u062A.",
  "Four doors to daily work": "\u0623\u0631\u0628\u0639\u0629 \u0623\u0628\u0648\u0627\u0628 \u0644\u0644\u0639\u0645\u0644 \u0627\u0644\u064A\u0648\u0645\u064A",
  "Color mode": "\u0648\u0636\u0639 \u0627\u0644\u0644\u0648\u0646",
  Dark: "\u062F\u0627\u0643\u0646",
  Light: "\u0641\u0627\u062A\u062D",
  "Live queue": "\u0642\u0627\u0626\u0645\u0629 \u0645\u0628\u0627\u0634\u0631\u0629",
  "What needs attention": "\u0645\u0627 \u064A\u062D\u062A\u0627\u062C \u0627\u0646\u062A\u0628\u0627\u0647\u064B\u0627",
  "Refreshing\u2026": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u062F\u064A\u062B\u2026",
  Refresh: "\u062A\u062D\u062F\u064A\u062B",
  "Some metrics could not load. Values show \u2014 when unavailable.": "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0628\u0639\u0636 \u0627\u0644\u0645\u0642\u0627\u064A\u064A\u0633. \u062A\u0638\u0647\u0631 \u2014 \u0639\u0646\u062F \u0639\u062F\u0645 \u0627\u0644\u062A\u0648\u0641\u0631.",
  "Active calls": "\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0646\u0634\u0637\u0629",
  "Waiting for human": "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0625\u0646\u0633\u0627\u0646",
  "Failed calls (recent)": "\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0641\u0627\u0634\u0644\u0629 (\u062D\u062F\u064A\u062B\u0629)",
  "Hot leads": "\u0639\u0645\u0644\u0627\u0621 \u0645\u062D\u062A\u0645\u0644\u0648\u0646 \u0633\u0627\u062E\u0646\u0648\u0646",
  "Running campaigns": "\u062D\u0645\u0644\u0627\u062A \u0642\u064A\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  "Published agents": "\u0648\u0643\u0644\u0627\u0621 \u0645\u0646\u0634\u0648\u0631\u0648\u0646",
  "Human handoff waiting": "\u062A\u062D\u0648\u064A\u0644 \u0628\u0634\u0631\u064A \u0628\u0627\u0646\u062A\u0638\u0627\u0631",
  "One or more calls need an operator now.": "\u0645\u0643\u0627\u0644\u0645\u0629 \u0623\u0648 \u0623\u0643\u062B\u0631 \u062A\u062D\u062A\u0627\u062C \u0645\u0634\u063A\u0651\u0644\u064B\u0627 \u0627\u0644\u0622\u0646.",
  "Open live ops": "\u0641\u062A\u062D \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  "Failed calls need review": "\u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0627\u0644\u0641\u0627\u0634\u0644\u0629 \u062A\u062D\u062A\u0627\u062C \u0645\u0631\u0627\u062C\u0639\u0629",
  "Check recordings and retry or fix the number / agent.": "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0648\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0623\u0648 \u0623\u0635\u0644\u062D \u0627\u0644\u0631\u0642\u0645 / \u0627\u0644\u0648\u0643\u064A\u0644.",
  "Hot leads waiting": "\u0639\u0645\u0644\u0627\u0621 \u0633\u0627\u062E\u0646\u0648\u0646 \u0628\u0627\u0646\u062A\u0638\u0627\u0631",
  "Follow up while interest is high.": "\u062A\u0627\u0628\u0639 \u0628\u064A\u0646\u0645\u0627 \u0627\u0644\u0627\u0647\u062A\u0645\u0627\u0645 \u0645\u0631\u062A\u0641\u0639.",
  "Production DID without inbound agent": "DID \u0625\u0646\u062A\u0627\u062C \u0628\u062F\u0648\u0646 \u0648\u0643\u064A\u0644 \u0648\u0627\u0631\u062F",
  "Bind a published agent so inbound calls are answered.": "\u0627\u0631\u0628\u0637 \u0648\u0643\u064A\u0644\u064B\u0627 \u0645\u0646\u0634\u0648\u0631\u064B\u0627 \u062D\u062A\u0649 \u062A\u064F\u062C\u0627\u0628 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0627\u0644\u0648\u0627\u0631\u062F\u0629.",
  "Open numbers": "\u0641\u062A\u062D \u0627\u0644\u0623\u0631\u0642\u0627\u0645",
  "No published agent yet": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0648\u0643\u064A\u0644 \u0645\u0646\u0634\u0648\u0631 \u0628\u0639\u062F",
  "Publish an agent before campaigns or inbound DID routing.": "\u0627\u0646\u0634\u0631 \u0648\u0643\u064A\u0644\u064B\u0627 \u0642\u0628\u0644 \u0627\u0644\u062D\u0645\u0644\u0627\u062A \u0623\u0648 \u062A\u0648\u062C\u064A\u0647 DID \u0627\u0644\u0648\u0627\u0631\u062F.",
  "Open agents": "\u0641\u062A\u062D \u0627\u0644\u0648\u0643\u0644\u0627\u0621",
  "No campaigns yet": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062D\u0645\u0644\u0627\u062A \u0628\u0639\u062F",
  "Create a draft, add contacts, then start outbound dialing.": "\u0623\u0646\u0634\u0626 \u0645\u0633\u0648\u062F\u0629\u060C \u0623\u0636\u0641 \u062C\u0647\u0627\u062A \u0627\u062A\u0635\u0627\u0644\u060C \u062B\u0645 \u0627\u0628\u062F\u0623 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0635\u0627\u062F\u0631.",
  "Queue looks clear": "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u062A\u0628\u062F\u0648 \u0647\u0627\u062F\u0626\u0629",
  "No critical exceptions. Start a campaign or review recent calls.": "\u0644\u0627 \u0627\u0633\u062A\u062B\u0646\u0627\u0621\u0627\u062A \u062D\u0631\u062C\u0629. \u0627\u0628\u062F\u0623 \u062D\u0645\u0644\u0629 \u0623\u0648 \u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0627\u0644\u0623\u062E\u064A\u0631\u0629.",
  "Not published yet \u2014 save, then publish to go live": "\u063A\u064A\u0631 \u0645\u0646\u0634\u0648\u0631 \u0628\u0639\u062F \u2014 \u0627\u062D\u0641\u0638 \u062B\u0645 \u0627\u0646\u0634\u0631 \u0644\u0644\u062A\u0634\u063A\u064A\u0644",
  "Save first if you changed fields, then Publish & deploy. Test on the right after publish.": "\u0627\u062D\u0641\u0638 \u0623\u0648\u0644\u0627\u064B \u0625\u0646 \u063A\u064A\u0651\u0631\u062A \u0627\u0644\u062D\u0642\u0648\u0644\u060C \u062B\u0645 \u0627\u0646\u0634\u0631. \u0627\u062E\u062A\u0628\u0631 \u0639\u0644\u0649 \u0627\u0644\u064A\u0645\u064A\u0646 \u0628\u0639\u062F \u0627\u0644\u0646\u0634\u0631.",
  Configure: "\u062A\u0647\u064A\u0626\u0629",
  "Test call": "\u0645\u0643\u0627\u0644\u0645\u0629 \u0627\u062E\u062A\u0628\u0627\u0631",
  "Hide advanced settings": "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u0629",
  "Show advanced settings": "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u0629",
  "Create, publish, then test \u2014 in that order": "\u0623\u0646\u0634\u0626\u060C \u0627\u0646\u0634\u0631\u060C \u062B\u0645 \u0627\u062E\u062A\u0628\u0631 \u2014 \u0628\u0647\u0630\u0627 \u0627\u0644\u062A\u0631\u062A\u064A\u0628",
  Create: "\u0625\u0646\u0634\u0627\u0621",
  "Not published": "\u063A\u064A\u0631 \u0645\u0646\u0634\u0648\u0631",
  "Open \u2192 save & publish": "\u0627\u0641\u062A\u062D \u2192 \u0627\u062D\u0641\u0638 \u0648\u0627\u0646\u0634\u0631",
  "Open to edit": "\u0627\u0641\u062A\u062D \u0644\u0644\u062A\u0639\u062F\u064A\u0644",
  "Save Agent": "\u062D\u0641\u0638 \u0627\u0644\u0648\u0643\u064A\u0644",
  "Hello": "\u0645\u0631\u062D\u0628\u064B\u0627",
  "Run outbound calling campaigns, review conversations, and follow up leads \u2014 all in one place.": "\u0634\u063A\u0651\u0644 \u062D\u0645\u0644\u0627\u062A \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0627\u0644\u0635\u0627\u062F\u0631\u0629\u060C \u0648\u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A\u060C \u0648\u062A\u0627\u0628\u0639 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0645\u0644\u064A\u0646 \u2014 \u0643\u0644 \u0630\u0644\u0643 \u0641\u064A \u0645\u0643\u0627\u0646 \u0648\u0627\u062D\u062F.",
  "Today\u2019s work: start campaigns, review calls, and follow up leads \u2014 without leaving this console.": "\u0639\u0645\u0644 \u0627\u0644\u064A\u0648\u0645: \u0627\u0628\u062F\u0623 \u0627\u0644\u062D\u0645\u0644\u0627\u062A\u060C \u0648\u0631\u0627\u062C\u0639 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A\u060C \u0648\u062A\u0627\u0628\u0639 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0645\u0644\u064A\u0646 \u2014 \u062F\u0648\u0646 \u0645\u063A\u0627\u062F\u0631\u0629 \u0647\u0630\u0647 \u0627\u0644\u0644\u0648\u062D\u0629.",
  "Start a campaign": "\u0628\u062F\u0621 \u062D\u0645\u0644\u0629",
  "Review calls": "\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A",
  "Workspace": "\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644",
  "Session expires": "\u0627\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u062C\u0644\u0633\u0629",
  "Session active": "\u0627\u0644\u062C\u0644\u0633\u0629 \u0646\u0634\u0637\u0629",
  "Short-lived session verified by the server": "\u062C\u0644\u0633\u0629 \u0642\u0635\u064A\u0631\u0629 \u0627\u0644\u0639\u0645\u0631 \u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627 \u0645\u0646 \u0627\u0644\u062E\u0627\u062F\u0645",
  "Quick actions": "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0633\u0631\u064A\u0639\u0629",
  "Get started": "\u0627\u0628\u062F\u0623",
  "Work queue": "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0645\u0644",
  "What do you want to do?": "\u0645\u0627\u0630\u0627 \u062A\u0631\u064A\u062F \u0623\u0646 \u062A\u0641\u0639\u0644\u061F",
  "What should I do next?": "\u0645\u0627\u0630\u0627 \u064A\u062C\u0628 \u0623\u0646 \u0623\u0641\u0639\u0644 \u0628\u0639\u062F \u0630\u0644\u0643\u061F",
  "Import contacts, set the script, and dial outbound calls in order.": "\u0627\u0633\u062A\u0648\u0631\u062F \u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u060C \u0648\u062D\u062F\u062F \u0627\u0644\u0646\u0635\u060C \u0648\u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0627\u0644\u0635\u0627\u062F\u0631\u0629 \u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628.",
  "Open campaigns": "\u0641\u062A\u062D \u0627\u0644\u062D\u0645\u0644\u0627\u062A",
  "Listen to recordings, read transcripts, and check purpose notes.": "\u0627\u0633\u062A\u0645\u0639 \u0625\u0644\u0649 \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A\u060C \u0648\u0627\u0642\u0631\u0623 \u0627\u0644\u0646\u0635\u0648\u0635\u060C \u0648\u062A\u062D\u0642\u0642 \u0645\u0646 \u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0627\u0644\u063A\u0631\u0636.",
  "Open conversations": "\u0641\u062A\u062D \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A",
  "Follow up leads": "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0645\u0644\u064A\u0646",
  "See hot / warm / cold scores and next actions after each call.": "\u0627\u0637\u0644\u0639 \u0639\u0644\u0649 \u062F\u0631\u062C\u0627\u062A \u0633\u0627\u062E\u0646 / \u062F\u0627\u0641\u0626 / \u0628\u0627\u0631\u062F \u0648\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0628\u0639\u062F \u0643\u0644 \u0645\u0643\u0627\u0644\u0645\u0629.",
  "Open leads": "\u0641\u062A\u062D \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0645\u0644\u064A\u0646",
  "Call from directory": "\u0627\u062A\u0635\u0627\u0644 \u0645\u0646 \u0627\u0644\u062F\u0644\u064A\u0644",
  "Pick a contact, set the purpose note, and place a single outbound call.": "\u0627\u062E\u062A\u0631 \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644\u060C \u0648\u062D\u062F\u062F \u0645\u0644\u0627\u062D\u0638\u0629 \u0627\u0644\u063A\u0631\u0636\u060C \u0648\u0623\u062C\u0631\u0650 \u0645\u0643\u0627\u0644\u0645\u0629 \u0635\u0627\u062F\u0631\u0629 \u0648\u0627\u062D\u062F\u0629.",
  "Open directory": "\u0641\u062A\u062D \u0627\u0644\u062F\u0644\u064A\u0644",
  "All modules": "\u062C\u0645\u064A\u0639 \u0627\u0644\u0648\u062D\u062F\u0627\u062A",
  "Browse the console": "\u062A\u0635\u0641\u062D \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
  "Account": "\u0627\u0644\u062D\u0633\u0627\u0628",
  "Your access": "\u0635\u0644\u0627\u062D\u064A\u0627\u062A\u0643",
  "Company": "\u0627\u0644\u0634\u0631\u0643\u0629",
  "User": "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  "Your data stays inside this company workspace. Sessions are short-lived and server-verified.": "\u062A\u0628\u0642\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u062F\u0627\u062E\u0644 \u0645\u0633\u0627\u062D\u0629 \u0639\u0645\u0644 \u0647\u0630\u0647 \u0627\u0644\u0634\u0631\u0643\u0629. \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0642\u0635\u064A\u0631\u0629 \u0627\u0644\u0639\u0645\u0631 \u0648\u0645\u062A\u062D\u0642\u0642 \u0645\u0646\u0647\u0627 \u0645\u0646 \u0627\u0644\u062E\u0627\u062F\u0645.",
  "Outbound dialing lists": "\u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0635\u0627\u062F\u0631",
  "Transcripts and recordings": "\u0627\u0644\u0646\u0635\u0648\u0635 \u0648\u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A",
  "Scores and next steps": "\u0627\u0644\u062F\u0631\u062C\u0627\u062A \u0648\u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
  "Contacts and single calls": "\u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0648\u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0627\u0644\u0641\u0631\u062F\u064A\u0629",
  "Company knowledge": "\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0634\u0631\u0643\u0629",
  "Voice and chat agents": "\u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0635\u0648\u062A \u0648\u0627\u0644\u062F\u0631\u062F\u0634\u0629",
  "Webchat and messaging": "\u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0648\u064A\u0628 \u0648\u0627\u0644\u0645\u0631\u0627\u0633\u0644\u0629",
  "Telephony and AI keys": "\u0627\u0644\u0647\u0627\u062A\u0641 \u0648\u0645\u0641\u0627\u062A\u064A\u062D \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
  "Automations": "\u0627\u0644\u0623\u062A\u0645\u062A\u0629",
  "Performance insights": "\u0631\u0624\u0649 \u0627\u0644\u0623\u062F\u0627\u0621",
  "Plan and usage": "\u0627\u0644\u062E\u0637\u0629 \u0648\u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
  "Retention and data": "\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0648\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  "Open module": "\u0641\u062A\u062D \u0627\u0644\u0648\u062D\u062F\u0629",
  "Data & Retention": "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638",
  "Entitlements": "\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642\u0627\u062A",
  "Guided Onboarding": "\u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0645\u0648\u062C\u0651\u0647",
  "Human Review": "\u0645\u0631\u0627\u062C\u0639\u0629 \u0628\u0634\u0631\u064A\u0629",
  "Immutable Brain snapshot published.": "\u062A\u0645 \u0646\u0634\u0631 \u0644\u0642\u0637\u0629 \u0639\u0642\u0644 \u063A\u064A\u0631 \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u062A\u063A\u064A\u064A\u0631.",
  "Ingest source": "\u0627\u0633\u062A\u064A\u0639\u0627\u0628 \u0627\u0644\u0645\u0635\u062F\u0631",
  "Ingest trusted material": "\u0627\u0633\u062A\u064A\u0639\u0627\u0628 \u0645\u0648\u0627\u062F \u0645\u0648\u062B\u0648\u0642\u0629",
  "Knowledge proposals": "\u0645\u0642\u062A\u0631\u062D\u0627\u062A \u0627\u0644\u0645\u0639\u0631\u0641\u0629",
  "Live manifest": "\u0627\u0644\u0628\u064A\u0627\u0646 \u0627\u0644\u062D\u064A",
  "No proposals yet.": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0642\u062A\u0631\u062D\u0627\u062A \u0628\u0639\u062F.",
  "Onboarding": "\u0627\u0644\u0625\u0639\u062F\u0627\u062F",
  "Onboarding complete": "\u0627\u0643\u062A\u0645\u0644 \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
  "Overview": "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629",
  "Permissions": "\u0627\u0644\u0623\u0630\u0648\u0646\u0627\u062A",
  "Permission and entitlement verified": "\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0625\u0630\u0646 \u0648\u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642",
  "Plan capabilities": "\u0642\u062F\u0631\u0627\u062A \u0627\u0644\u062E\u0637\u0629",
  "PostgreSQL RLS enforcement": "\u0641\u0631\u0636 RLS \u0641\u064A PostgreSQL",
  "Providers": "\u0627\u0644\u0645\u0632\u0648\u0651\u062F\u0648\u0646",
  "Integrations": "\u0627\u0644\u062A\u0643\u0627\u0645\u0644\u0627\u062A",
  "Live ops": "\u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0645\u0628\u0627\u0634\u0631\u0629",
  "Proposals": "\u0627\u0644\u0645\u0642\u062A\u0631\u062D\u0627\u062A",
  "Protected": "\u0645\u062D\u0645\u064A",
  "Publish": "\u0646\u0634\u0631",
  "Published": "\u0645\u0646\u0634\u0648\u0631",
  "Published-only Retrieval": "\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0645\u0646\u0634\u0648\u0631 \u0641\u0642\u0637",
  "Publish immutable version": "\u0646\u0634\u0631 \u0625\u0635\u062F\u0627\u0631 \u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u063A\u064A\u064A\u0631",
  "Retrieve": "\u0627\u0633\u062A\u0631\u062C\u0627\u0639",
  "Save answer": "\u062D\u0641\u0638 \u0627\u0644\u0625\u062C\u0627\u0628\u0629",
  "Search published knowledge": "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629",
  "Security Posture": "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0623\u0645\u0646\u064A",
  "Server verified": "\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062E\u0627\u062F\u0645",
  "Server-side authorization": "\u062A\u0641\u0648\u064A\u0636 \u0645\u0646 \u062C\u0627\u0646\u0628 \u0627\u0644\u062E\u0627\u062F\u0645",
  "Short-lived embed session": "\u062C\u0644\u0633\u0629 \u062A\u0636\u0645\u064A\u0646 \u0642\u0635\u064A\u0631\u0629 \u0627\u0644\u0639\u0645\u0631",
  "Source ingested. Proposed facts are ready for review.": "\u062A\u0645 \u0627\u0633\u062A\u064A\u0639\u0627\u0628 \u0627\u0644\u0645\u0635\u062F\u0631. \u0627\u0644\u062D\u0642\u0627\u0626\u0642 \u0627\u0644\u0645\u0642\u062A\u0631\u062D\u0629 \u062C\u0627\u0647\u0632\u0629 \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629.",
  "Source title": "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0635\u062F\u0631",
  "Start with the guided questions.": "\u0627\u0628\u062F\u0623 \u0628\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0645\u0648\u062C\u0651\u0647\u0629.",
  "Tenant boundary": "\u062D\u062F\u0648\u062F \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631",
  "Test the Brain": "\u0627\u062E\u062A\u0628\u0631 \u0627\u0644\u0639\u0642\u0644",
  "Text Source": "\u0645\u0635\u062F\u0631 \u0646\u0635\u064A",
  "Verified Knowledge Control": "\u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0627\u0644\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0645\u0648\u062B\u0642\u0629",
  "Workflows": "\u0633\u064A\u0631 \u0627\u0644\u0639\u0645\u0644",
  "Workspaces": "\u0645\u0633\u0627\u062D\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
  "Your AI customer operations workspace": "\u0645\u0633\u0627\u062D\u0629 \u0639\u0645\u0644 \u0639\u0645\u0644\u064A\u0627\u062A \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
  "Add verified facts\u2026": "\u0623\u0636\u0641 \u062D\u0642\u0627\u0626\u0642 \u0645\u0648\u062B\u0642\u0629\u2026",
  "Acme Support Agent": "\u0648\u0643\u064A\u0644 \u062F\u0639\u0645 Panaryus",
  "Agent": "\u0627\u0644\u0648\u0643\u064A\u0644",
  "All systems operational": "\u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u0646\u0638\u0645\u0629 \u062A\u0639\u0645\u0644",
  "Allowed connector tools": "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0645\u0648\u0635\u0644 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647\u0627",
  "Answer saved as a reviewable proposal.": "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \u0643\u0645\u0642\u062A\u0631\u062D \u0642\u0627\u0628\u0644 \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629.",
  "Answer only from published business knowledge. State when verified context is insufficient.": "\u0623\u062C\u0628 \u0641\u0642\u0637 \u0645\u0646 \u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0623\u0639\u0645\u0627\u0644 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629. \u0628\u064A\u0651\u0646 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0627\u0644\u0633\u064A\u0627\u0642 \u0627\u0644\u0645\u0648\u062B\u0642 \u063A\u064A\u0631 \u0643\u0627\u0641\u064D.",
  "Ask the published Agent\u2026": "\u0627\u0633\u0623\u0644 \u0627\u0644\u0648\u0643\u064A\u0644 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u2026",
  "Barge-in enabled": "\u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0645\u0641\u0639\u0651\u0644\u0629",
  "Bind a published Brain, test the policies, then deploy immutable webchat.": "\u0627\u0631\u0628\u0637 \u0639\u0642\u0644\u0627\u064B \u0645\u0646\u0634\u0648\u0631\u064B\u0627\u060C \u0648\u0627\u062E\u062A\u0628\u0631 \u0627\u0644\u0633\u064A\u0627\u0633\u0627\u062A\u060C \u062B\u0645 \u0627\u0646\u0634\u0631 \u062F\u0631\u062F\u0634\u0629 \u0648\u064A\u0628 \u063A\u064A\u0631 \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u062A\u063A\u064A\u064A\u0631.",
  "Blocked topics": "\u0627\u0644\u0645\u0648\u0627\u0636\u064A\u0639 \u0627\u0644\u0645\u062D\u0638\u0648\u0631\u0629",
  "Business Brain created. Start with the guided questions.": "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0639\u0642\u0644 \u0627\u0644\u0623\u0639\u0645\u0627\u0644. \u0627\u0628\u062F\u0623 \u0628\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0645\u0648\u062C\u0651\u0647\u0629.",
  "Clear, calm and concise": "\u0648\u0627\u0636\u062D \u0648\u0647\u0627\u062F\u0626 \u0648\u0645\u062E\u062A\u0635\u0631",
  "Create a grounded customer agent": "\u0623\u0646\u0634\u0626 \u0648\u0643\u064A\u0644 \u0639\u0645\u0644\u0627\u0621 \u0645\u0633\u062A\u0646\u062F\u064B\u0627 \u0625\u0644\u0649 \u0627\u0644\u0645\u0639\u0631\u0641\u0629",
  "Create Agent": "\u0625\u0646\u0634\u0627\u0621 \u0648\u0643\u064A\u0644",
  "Customer support specialist": "\u0623\u062E\u0635\u0627\u0626\u064A \u062F\u0639\u0645 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
  "Draft Agent created.": "\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0648\u0643\u064A\u0644.",
  "Draft Configuration": "\u062A\u0643\u0648\u064A\u0646 \u0627\u0644\u0645\u0633\u0648\u062F\u0629",
  "Handoff destination": "\u0648\u062C\u0647\u0629 \u0627\u0644\u062A\u062D\u0648\u064A\u0644",
  "Instructions": "\u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A",
  "Immutable Agent version deployed.": "\u062A\u0645 \u0646\u0634\u0631 \u0625\u0635\u062F\u0627\u0631 \u0648\u0643\u064A\u0644 \u063A\u064A\u0631 \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u063A\u064A\u064A\u0631.",
  "Manage verified business knowledge, AI agents, channels and conversations from one secure tenant boundary.": "\u0623\u062F\u0650\u0631 \u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0623\u0639\u0645\u0627\u0644 \u0627\u0644\u0645\u0648\u062B\u0642\u0629 \u0648\u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A \u0648\u0627\u0644\u0642\u0646\u0648\u0627\u062A \u0648\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0645\u0646 \u062D\u062F\u0648\u062F \u0645\u0633\u062A\u0623\u062C\u0631 \u0622\u0645\u0646\u0629 \u0648\u0627\u062D\u062F\u0629.",
  "Max call seconds": "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u062B\u0648\u0627\u0646\u064A \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629",
  "Onboard your business, review every proposal, then publish an immutable snapshot.": "\u062C\u0647\u0651\u0632 \u0639\u0645\u0644\u0643\u060C \u0648\u0631\u0627\u062C\u0639 \u0643\u0644 \u0645\u0642\u062A\u0631\u062D\u060C \u062B\u0645 \u0627\u0646\u0634\u0631 \u0644\u0642\u0637\u0629 \u063A\u064A\u0631 \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u062A\u063A\u064A\u064A\u0631.",
  "Persona": "\u0627\u0644\u0634\u062E\u0635\u064A\u0629",
  "Published Agent runtime": "\u0648\u0642\u062A \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0648\u0643\u064A\u0644 \u0627\u0644\u0645\u0646\u0634\u0648\u0631",
  "Published Brain": "\u0627\u0644\u0639\u0642\u0644 \u0627\u0644\u0645\u0646\u0634\u0648\u0631",
  "Publish & deploy": "\u0646\u0634\u0631 \u0648\u062A\u0634\u063A\u064A\u0644",
  "Publish the Agent, then test grounded responses.": "\u0627\u0646\u0634\u0631 \u0627\u0644\u0648\u0643\u064A\u0644\u060C \u062B\u0645 \u0627\u062E\u062A\u0628\u0631 \u0627\u0644\u0631\u062F\u0648\u062F \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0639\u0631\u0641\u0629.",
  "Proposal approved for the next publication.": "\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0642\u062A\u0631\u062D \u0644\u0644\u0646\u0634\u0631 \u0627\u0644\u062A\u0627\u0644\u064A.",
  "Recording": "\u0627\u0644\u062A\u0633\u062C\u064A\u0644",
  "Recording enabled": "\u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0645\u0641\u0639\u0651\u0644",
  "Recording notice": "\u0625\u0634\u0639\u0627\u0631 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
  "Role": "\u0627\u0644\u062F\u0648\u0631",
  "Role and guardrails": "\u0627\u0644\u062F\u0648\u0631 \u0648\u062D\u062F\u0648\u062F \u0627\u0644\u0623\u0645\u0627\u0646",
  "Save draft": "\u062D\u0641\u0638 \u0627\u0644\u0645\u0633\u0648\u062F\u0629",
  "Send": "\u0625\u0631\u0633\u0627\u0644",
  "Separate distinct facts with blank lines.": "\u0627\u0641\u0635\u0644 \u0627\u0644\u062D\u0642\u0627\u0626\u0642 \u0627\u0644\u0645\u062A\u0645\u064A\u0632\u0629 \u0628\u0623\u0633\u0637\u0631 \u0641\u0627\u0631\u063A\u0629.",
  "Select Brain": "\u0627\u062E\u062A\u0631 \u0627\u0644\u0639\u0642\u0644",
  "Test Simulator": "\u0645\u062D\u0627\u0643\u064A \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631",
  "This call may be recorded for quality purposes.": "\u0642\u062F \u062A\u064F\u0633\u062C\u0651\u064E\u0644 \u0647\u0630\u0647 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0629 \u0644\u0623\u063A\u0631\u0627\u0636 \u0627\u0644\u062C\u0648\u062F\u0629.",
  "Versioned Agent Control": "\u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0625\u0635\u062F\u0627\u0631\u0627\u062A \u0627\u0644\u0648\u0643\u064A\u0644",
  "Voice": "\u0627\u0644\u0635\u0648\u062A",
  "Voice ID": "\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u0635\u0648\u062A",
  "Voice language": "\u0644\u063A\u0629 \u0627\u0644\u0635\u0648\u062A",
  "Voice profile": "\u0645\u0644\u0641 \u0627\u0644\u0635\u0648\u062A",
  "Webchat Deployment Key": "\u0645\u0641\u062A\u0627\u062D \u0646\u0634\u0631 \u0627\u0644\u062F\u0631\u062F\u0634\u0629 \u0627\u0644\u0648\u064A\u0628",
  "Agents": "\u0627\u0644\u0648\u0643\u0644\u0627\u0621",
  "Prompt Templates": "\u0642\u0648\u0627\u0644\u0628 \u0627\u0644\u0623\u0648\u0627\u0645\u0631",
  "Voices": "\u0627\u0644\u0623\u0635\u0648\u0627\u062A",
  "Create New Agent": "\u0625\u0646\u0634\u0627\u0621 \u0648\u0643\u064A\u0644 \u062C\u062F\u064A\u062F",
  "Guided Wizard": "\u0627\u0644\u0645\u0639\u0627\u0644\u062C \u0627\u0644\u0625\u0631\u0634\u0627\u062F\u064A",
  "AI Assistant": "\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
  "Hello, I am your CenterOS assistant. We can set up this agent by talking.": "\u0645\u0631\u062D\u0628\u0627\u064B\u060C \u0623\u0646\u0627 \u0645\u0633\u0627\u0639\u062F CenterOS. \u064A\u0645\u0643\u0646\u0646\u0627 \u0625\u0639\u062F\u0627\u062F \u0647\u0630\u0627 \u0627\u0644\u0648\u0643\u064A\u0644 \u0628\u0627\u0644\u062D\u062F\u064A\u062B.",
  "AI-assisted agent": "\u0648\u0643\u064A\u0644 \u0628\u0645\u0633\u0627\u0639\u062F\u0629 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
  "Talk here to fill in the missing agent fields. We create a draft only \u2014 you still publish.": "\u0627\u0643\u062A\u0628 \u0647\u0646\u0627 \u0644\u0625\u0643\u0645\u0627\u0644 \u062D\u0642\u0648\u0644 \u0627\u0644\u0648\u0643\u064A\u0644 \u0627\u0644\u0646\u0627\u0642\u0635\u0629. \u0646\u0646\u0634\u0626 \u0645\u0633\u0648\u062F\u0629 \u0641\u0642\u0637 \u2014 \u0648\u0627\u0644\u0646\u0634\u0631 \u064A\u0628\u0642\u0649 \u0628\u064A\u062F\u0643.",
  "Type your answer\u2026": "\u0627\u0643\u062A\u0628 \u0625\u062C\u0627\u0628\u062A\u0643...",
  "Next question": "\u0627\u0644\u0633\u0624\u0627\u0644 \u0627\u0644\u062A\u0627\u0644\u064A",
  "Setup progress": "\u062A\u0642\u062F\u0645 \u0627\u0644\u0625\u0639\u062F\u0627\u062F",
  "Agent setup": "\u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0648\u0643\u064A\u0644",
  "Start over": "\u0627\u0628\u062F\u0623 \u0645\u0646 \u062C\u062F\u064A\u062F",
  "Draft ready": "\u0627\u0644\u0645\u0633\u0648\u062F\u0629 \u062C\u0627\u0647\u0632\u0629",
  "Business Brain required": "\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0634\u0631\u0643\u0629 \u0645\u0637\u0644\u0648\u0628\u0629",
  "Open Company knowledge": "\u0641\u062A\u062D \u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0634\u0631\u0643\u0629",
  "Create failed": "\u0641\u0634\u0644 \u0627\u0644\u0625\u0646\u0634\u0627\u0621",
  "Publish a Business Brain first so the interview can pin knowledge.": "\u0627\u0646\u0634\u0631 \u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0634\u0631\u0643\u0629 \u0623\u0648\u0644\u0627\u064B \u062D\u062A\u0649 \u064A\u062A\u0645\u0643\u0646 \u0627\u0644\u062D\u0648\u0627\u0631 \u0645\u0646 \u0631\u0628\u0637 \u0627\u0644\u0645\u0639\u0631\u0641\u0629.",
  CenterOS: "CenterOS",
  "Interview failed": "\u0641\u0634\u0644 \u0627\u0644\u062D\u0648\u0627\u0631",
  "Create draft agent": "\u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0648\u062F\u0629 \u0648\u0643\u064A\u0644",
  "Thinking\u2026": "\u064A\u0641\u0643\u0631\u2026",
  "+ New Agent": "+ \u0648\u0643\u064A\u0644 \u062C\u062F\u064A\u062F",
  "New Agent": "\u0648\u0643\u064A\u0644 \u062C\u062F\u064A\u062F",
  "Play sample": "\u062A\u0634\u063A\u064A\u0644 \u0639\u064A\u0646\u0629",
  "Cancel": "\u0625\u0644\u063A\u0627\u0621",
  "System Prompt": "\u0645\u0648\u062C\u0647 \u0627\u0644\u0646\u0638\u0627\u0645",
  "First Message": "\u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0623\u0648\u0644\u0649",
  "Incoming Agent": "\u0648\u0643\u064A\u0644 \u0627\u0644\u0648\u0627\u0631\u062F",
  "Flow Agent": "\u0648\u0643\u064A\u0644 \u0627\u0644\u062A\u062F\u0641\u0642",
  "Coming soon": "\u0642\u0631\u064A\u0628\u064B\u0627",
  "Temperature": "\u062F\u0631\u062C\u0629 \u0627\u0644\u062D\u0631\u0627\u0631\u0629",
  "Language": "\u0627\u0644\u0644\u063A\u0629",
  "Personality": "\u0627\u0644\u0634\u062E\u0635\u064A\u0629",
  "System Tools": "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0646\u0638\u0627\u0645",
  "Back to agents": "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0648\u0643\u0644\u0627\u0621",
  "Search agents...": "\u0627\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0648\u0643\u0644\u0627\u0621...",
  "Total Agents": "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0648\u0643\u0644\u0627\u0621",
  "agents": "\u0648\u0643\u0644\u0627\u0621",
  "Approaching plan agent limit": "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0646 \u062D\u062F \u062E\u0637\u0629 \u0627\u0644\u0648\u0643\u0644\u0627\u0621",
  "Agent plan limit reached": "\u062A\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062D\u062F \u0627\u0644\u0648\u0643\u0644\u0627\u0621 \u0641\u064A \u0627\u0644\u062E\u0637\u0629. \u0642\u0645 \u0628\u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u062E\u0637\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0648\u0643\u064A\u0644 \u062C\u062F\u064A\u062F.",
  "Approaching plan campaign limit": "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0646 \u062D\u062F \u062E\u0637\u0629 \u0627\u0644\u062D\u0645\u0644\u0627\u062A",
  "Campaign plan limit reached": "\u062A\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062D\u062F \u0627\u0644\u062D\u0645\u0644\u0627\u062A \u0641\u064A \u0627\u0644\u062E\u0637\u0629. \u0642\u0645 \u0628\u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u062E\u0637\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u062D\u0645\u0644\u0629 \u062C\u062F\u064A\u062F\u0629.",
  "Approaching plan phone number limit": "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0646 \u062D\u062F \u062E\u0637\u0629 \u0627\u0644\u0623\u0631\u0642\u0627\u0645",
  "Phone number plan limit reached": "\u062A\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062D\u062F \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0641\u064A \u0627\u0644\u062E\u0637\u0629. \u0642\u0645 \u0628\u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u062E\u0637\u0629 \u0644\u0625\u0636\u0627\u0641\u0629 \u0631\u0642\u0645 \u062C\u062F\u064A\u062F.",
  "Approaching plan contact limit": "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0646 \u062D\u062F \u062E\u0637\u0629 \u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  "Contact plan limit reached": "\u062A\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062D\u062F \u062C\u0647\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0627\u0644\u062E\u0637\u0629. \u0642\u0645 \u0628\u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u062E\u0637\u0629 \u0644\u0625\u0636\u0627\u0641\u0629 \u062C\u0647\u0629 \u0627\u062A\u0635\u0627\u0644 \u062C\u062F\u064A\u062F\u0629.",
  "Approaching plan lead limit": "\u0627\u0642\u062A\u0631\u0627\u0628 \u0645\u0646 \u062D\u062F \u062E\u0637\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0645\u0644\u064A\u0646",
  "Lead plan limit reached": "\u062A\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062D\u062F \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0645\u0644\u064A\u0646 \u0641\u064A \u0627\u0644\u062E\u0637\u0629. \u0642\u0645 \u0628\u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u062E\u0637\u0629 \u0623\u0648 \u0631\u0627\u062C\u0639 \u062A\u062F\u0641\u0642 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A.",
  "All Templates": "\u0643\u0644 \u0627\u0644\u0642\u0648\u0627\u0644\u0628",
  "Use template": "\u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0642\u0627\u0644\u0628",
  "Library voices": "\u0623\u0635\u0648\u0627\u062A \u0627\u0644\u0645\u0643\u062A\u0628\u0629",
  "Refresh library": "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0643\u062A\u0628\u0629",
  "Incoming": "\u0627\u0644\u0648\u0627\u0631\u062F",
  "Draft": "\u0645\u0633\u0648\u062F\u0629",
  "All": "\u0627\u0644\u0643\u0644",
  "Custom Voice": "\u0635\u0648\u062A \u0645\u062E\u0635\u0635",
  "System Prompt *": "\u0645\u0648\u062C\u0647 \u0627\u0644\u0646\u0638\u0627\u0645 *",
  "Creating\u2026": "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0646\u0634\u0627\u0621\u2026",
  "Language *": "\u0627\u0644\u0644\u063A\u0629 *",
  "Categories": "\u0627\u0644\u0641\u0626\u0627\u062A",
  "Total Templates": "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0642\u0648\u0627\u0644\u0628",
  "Create your first agent": "\u0623\u0646\u0634\u0626 \u0648\u0643\u064A\u0644\u0643 \u0627\u0644\u0623\u0648\u0644",
  "Create Your First Agent": "\u0623\u0646\u0634\u0626 \u0648\u0643\u064A\u0644\u0643 \u0627\u0644\u0623\u0648\u0644",
  "Create and manage your conversational AI agents": "\u0623\u0646\u0634\u0626 \u0648\u0623\u062F\u0631 \u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
  "Create and manage reusable AI prompt templates": "\u0623\u0646\u0634\u0626 \u0648\u0623\u062F\u0631 \u0642\u0648\u0627\u0644\u0628 \u0623\u0648\u0627\u0645\u0631 AI \u0642\u0627\u0628\u0644\u0629 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
  "Selected \xB7 Use": "\u0645\u062D\u062F\u062F \xB7 \u0627\u0633\u062A\u062E\u062F\u0627\u0645",
  "Use": "\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
  "Browse all prompt templates": "\u062A\u0635\u0641\u062D \u0643\u0644 \u0642\u0648\u0627\u0644\u0628 \u0627\u0644\u0623\u0648\u0627\u0645\u0631",
  "Browse all prompt templates \u2192": "\u062A\u0635\u0641\u062D \u0643\u0644 \u0642\u0648\u0627\u0644\u0628 \u0627\u0644\u0623\u0648\u0627\u0645\u0631 \u2192",
  "Playbook view": "\u0639\u0631\u0636 \u062F\u0644\u064A\u0644 \u0627\u0644\u062D\u0648\u0627\u0631",
  "Playbook flow": "\u062A\u062F\u0641\u0642 \u062F\u0644\u064A\u0644 \u0627\u0644\u062D\u0648\u0627\u0631",
  "Next step": "\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
  "Sequential (default)": "\u062A\u0633\u0644\u0633\u0644\u064A (\u0627\u0641\u062A\u0631\u0627\u0636\u064A)",
  "Select a step on the canvas to edit fields.": "\u062D\u062F\u062F \u062E\u0637\u0648\u0629 \u0639\u0644\u0649 \u0627\u0644\u0644\u0648\u062D\u0629 \u0644\u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u062D\u0642\u0648\u0644.",
  List: "\u0642\u0627\u0626\u0645\u0629",
  Flow: "\u062A\u062F\u0641\u0642",
  "Inline pack": "\u062D\u0632\u0645\u0629 \u0645\u0636\u0645\u0651\u0646\u0629",
  "Prompt only": "\u0627\u0644\u0645\u0648\u062C\u0647 \u0641\u0642\u0637",
  "Test retrieval": "\u0627\u062E\u062A\u0628\u0627\u0631 \u0627\u0644\u0627\u0633\u062A\u0631\u062C\u0627\u0639",
  "No published Business Brain yet. Publish a brain on the Company knowledge page": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0642\u0644 \u0623\u0639\u0645\u0627\u0644 \u0645\u0646\u0634\u0648\u0631 \u0628\u0639\u062F. \u0627\u0646\u0634\u0631 \u0639\u0642\u0644\u0627\u064B \u0641\u064A \u0635\u0641\u062D\u0629 \u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0634\u0631\u0643\u0629",
  "Select a published Business Brain, or switch knowledge mode.": "\u0627\u062E\u062A\u0631 \u0639\u0642\u0644 \u0623\u0639\u0645\u0627\u0644 \u0645\u0646\u0634\u0648\u0631\u064B\u0627 \u0623\u0648 \u063A\u064A\u0651\u0631 \u0648\u0636\u0639 \u0627\u0644\u0645\u0639\u0631\u0641\u0629.",
  "Inline pack is required when Inline pack mode is selected. Paste knowledge or switch mode.": "\u0627\u0644\u062D\u0632\u0645\u0629 \u0627\u0644\u0645\u0636\u0645\u0651\u0646\u0629 \u0645\u0637\u0644\u0648\u0628\u0629 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u062D\u0632\u0645\u0629. \u0627\u0644\u0635\u0642 \u0627\u0644\u0645\u0639\u0631\u0641\u0629 \u0623\u0648 \u063A\u064A\u0651\u0631 \u0627\u0644\u0648\u0636\u0639.",
  "No agents match filters": "\u0644\u0627 \u0648\u0643\u0644\u0627\u0621 \u064A\u0637\u0627\u0628\u0642\u0648\u0646 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
  "Demo/test agents are hidden. Turn off the filter to show them, or create a new agent.": "\u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0639\u0631\u0636/\u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631 \u0645\u062E\u0641\u064A\u0648\u0646. \u0623\u0648\u0642\u0641 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0644\u0639\u0631\u0636\u0647\u0645 \u0623\u0648 \u0623\u0646\u0634\u0626 \u0648\u0643\u064A\u0644\u0627\u064B \u062C\u062F\u064A\u062F\u0627\u064B.",
  "Show demo/test agents": "\u0625\u0638\u0647\u0627\u0631 \u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0639\u0631\u0636/\u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631"
};
var localeFrom = (locale) => {
  const value = locale?.toLowerCase() ?? "";
  if (value.startsWith("ar")) return "ar";
  if (value.startsWith("tr")) return "tr";
  return "en";
};
var localeDirection = (locale) => locale === "ar" ? "rtl" : "ltr";
var translate = (locale, text) => {
  if (locale === "tr") return tr[text] ?? text;
  if (locale === "ar") return ar[text] ?? text;
  return text;
};

// src/brain.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var createBrainApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const request = async (path, init) => {
    const response = await fetch(`${base}${path}`, {
      ...init,
      headers: {
        Authorization: `Bearer ${token}`,
        ...init?.body ? { "Content-Type": "application/json" } : {},
        ...init?.headers
      },
      signal: AbortSignal.timeout(12e3)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.code ?? `HTTP_${response.status}`);
    }
    return response.json();
  };
  return {
    list: async (workspaceId) => brainListSchema.parse(
      await request(`/v1/brains?workspaceId=${encodeURIComponent(workspaceId)}`)
    ),
    create: async (workspaceId, name) => brainViewSchema.parse(
      await request("/v1/brains", {
        method: "POST",
        body: JSON.stringify({ workspaceId, name })
      })
    ),
    answer: async (brainId, answer) => onboardingMessageResponseSchema.parse(
      await request(`/v1/brains/${encodeURIComponent(brainId)}/onboarding/messages`, {
        method: "POST",
        body: JSON.stringify({ answer })
      })
    ),
    voiceOnboarding: async (brainId, locale = "tr") => voiceOnboardingStatusSchema.parse(
      await request(
        `/v1/brains/${encodeURIComponent(brainId)}/voice-onboarding?locale=${locale}`
      )
    ),
    voiceOnboardingAnswer: async (brainId, topicKey, answer) => knowledgeProposalSchema.parse(
      await request(`/v1/brains/${encodeURIComponent(brainId)}/voice-onboarding/answers`, {
        method: "POST",
        body: JSON.stringify({ topicKey, answer })
      })
    ),
    knowledgeGaps: async (brainId, days = 30) => knowledgeGapReportSchema.parse(
      await request(`/v1/brains/${encodeURIComponent(brainId)}/knowledge-gaps?days=${days}`)
    ),
    addWebsiteSource: async (brainId, workspaceId, url) => sourceAcceptedSchema.parse(
      await request(`/v1/brains/${encodeURIComponent(brainId)}/sources/website`, {
        method: "POST",
        body: JSON.stringify({ workspaceId, url })
      })
    ),
    addTextSource: async (brainId, workspaceId, title, content) => sourceAcceptedSchema.parse(
      await request(`/v1/brains/${encodeURIComponent(brainId)}/sources`, {
        method: "POST",
        body: JSON.stringify({ workspaceId, title, content })
      })
    ),
    proposals: async (brainId) => proposalListSchema.parse(
      await request(`/v1/brains/${encodeURIComponent(brainId)}/proposals?limit=100`)
    ),
    approve: async (brainId, itemId) => knowledgeProposalSchema.parse(
      await request(
        `/v1/brains/${encodeURIComponent(brainId)}/proposals/${encodeURIComponent(itemId)}/approve`,
        { method: "POST" }
      )
    ),
    publish: async (brainId, expectedDraftVersion) => publishBrainResponseSchema.parse(
      await request(`/v1/brains/${encodeURIComponent(brainId)}/publish`, {
        method: "POST",
        body: JSON.stringify({ expectedDraftVersion })
      })
    ),
    retrieve: async (brainId, query) => retrievalResponseSchema.parse(
      await request(
        `/v1/brains/${encodeURIComponent(brainId)}/retrieve?q=${encodeURIComponent(query)}`
      )
    )
  };
};
var BusinessBrainPage = ({
  api,
  locale = "en",
  workspaceId
}) => {
  const currentLocale = typeof locale === "string" ? localeFrom(locale) : locale;
  const t = (text) => translate(currentLocale, text);
  const [brains, setBrains] = useState([]);
  const [selectedId, setSelectedId] = useState();
  const [proposals, setProposals] = useState([]);
  const [retrieval, setRetrieval] = useState();
  const [voiceStatus, setVoiceStatus] = useState(null);
  const [gaps, setGaps] = useState(null);
  const [notice, setNotice] = useState();
  const [error, setError] = useState();
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    const listed = await api.list(workspaceId);
    setBrains(listed.items);
    const nextId = listed.items.some((brain) => brain.id === selectedId) ? selectedId : listed.items[0]?.id;
    setSelectedId(nextId);
    setProposals(nextId ? (await api.proposals(nextId)).items : []);
    if (nextId) {
      try {
        setVoiceStatus(await api.voiceOnboarding(nextId));
      } catch {
        setVoiceStatus(null);
      }
      try {
        setGaps(await api.knowledgeGaps(nextId));
      } catch {
        setGaps(null);
      }
    } else {
      setVoiceStatus(null);
      setGaps(null);
    }
  }, [api, selectedId, workspaceId]);
  useEffect(() => {
    void load().catch((cause) => setError(message(cause)));
  }, [load]);
  const selected = brains.find((brain) => brain.id === selectedId);
  const mutate = async (operation, success) => {
    setBusy(true);
    setError(void 0);
    setNotice(void 0);
    try {
      await operation();
      await load();
      setNotice(success);
    } catch (cause) {
      setError(message(cause));
    } finally {
      setBusy(false);
    }
  };
  const create = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const name = new FormData(form).get("name");
    if (typeof name !== "string") return;
    void mutate(async () => {
      const brain = await api.create(workspaceId, name);
      setSelectedId(brain.id);
      form.reset();
    }, t("Business Brain created. Start with the guided questions."));
  };
  if (brains.length === 0) {
    return /* @__PURE__ */ jsxs("section", { className: "brain-empty", children: [
      /* @__PURE__ */ jsx("span", { children: "BUSINESS BRAIN" }),
      /* @__PURE__ */ jsx("h2", { children: t("Build a verified source of truth") }),
      /* @__PURE__ */ jsx("p", { children: t("Onboard your business, review every proposal, then publish an immutable snapshot.") }),
      /* @__PURE__ */ jsxs("form", { onSubmit: create, children: [
        /* @__PURE__ */ jsx("input", { name: "name", required: true, minLength: 2, placeholder: "e.g. Panaryus Support Brain" }),
        /* @__PURE__ */ jsx("button", { disabled: busy, type: "submit", children: t("Create Brain") })
      ] }),
      error && /* @__PURE__ */ jsx("div", { className: "brain-alert error", children: error })
    ] });
  }
  return /* @__PURE__ */ jsxs("section", { className: "brain-page", children: [
    /* @__PURE__ */ jsxs("div", { className: "brain-toolbar", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("span", { children: t("Verified Knowledge Control").toUpperCase() }),
        /* @__PURE__ */ jsx("h2", { children: selected?.name })
      ] }),
      /* @__PURE__ */ jsx("select", { value: selectedId, onChange: (event) => setSelectedId(event.target.value), children: brains.map((brain) => /* @__PURE__ */ jsx("option", { value: brain.id, children: brain.name }, brain.id)) })
    ] }),
    notice && /* @__PURE__ */ jsx("div", { className: "brain-alert success", children: notice }),
    error && /* @__PURE__ */ jsx("div", { className: "brain-alert error", children: error }),
    selected && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "brain-stats", children: [
        /* @__PURE__ */ jsx(BrainStat, { label: t("Onboarding"), value: `${selected.onboardingProgress}%` }),
        /* @__PURE__ */ jsx(BrainStat, { label: t("Proposals"), value: String(selected.proposalCount) }),
        /* @__PURE__ */ jsx(BrainStat, { label: t("Approved"), value: String(selected.approvedCount) }),
        /* @__PURE__ */ jsx(
          BrainStat,
          {
            label: t("Published"),
            value: selected.publishedVersion ? `v${selected.publishedVersion}` : "\u2014"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "brain-workbench", children: [
        /* @__PURE__ */ jsxs("div", { className: "brain-column", children: [
          gaps && gaps.gaps.length > 0 && /* @__PURE__ */ jsxs("article", { className: "brain-card", children: [
            /* @__PURE__ */ jsx("header", { children: /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("small", { children: "CEVAPLANAMAYAN SORULAR" }),
              /* @__PURE__ */ jsxs("h3", { children: [
                "Son ",
                gaps.sinceDays,
                " g\xFCnde ",
                gaps.unansweredTurns,
                " tur cevaps\u0131z kald\u0131"
              ] })
            ] }) }),
            /* @__PURE__ */ jsx("p", { className: "alx-muted", children: "Arayanlar\u0131n sordu\u011Fu ama ajan\u0131n cevaplayamad\u0131\u011F\u0131 konular. Cevab\u0131 yaz\u0131n, bilgi \xF6nerisi olarak d\xFC\u015Fs\xFCn." }),
            gaps.gaps.map((gap) => /* @__PURE__ */ jsxs("details", { children: [
              /* @__PURE__ */ jsxs("summary", { children: [
                /* @__PURE__ */ jsxs("b", { children: [
                  gap.occurrences,
                  "\xD7"
                ] }),
                " ",
                gap.question
              ] }),
              gap.spokenInstead && /* @__PURE__ */ jsxs("p", { className: "alx-muted", children: [
                "Bunun yerine s\xF6ylenen: \u201C",
                gap.spokenInstead,
                "\u201D"
              ] }),
              gap.variants.length > 0 && /* @__PURE__ */ jsxs("p", { className: "alx-muted", children: [
                "Di\u011Fer sorulu\u015Flar\u0131: ",
                gap.variants.join(" \xB7 ")
              ] }),
              /* @__PURE__ */ jsxs(
                "form",
                {
                  onSubmit: (event) => {
                    event.preventDefault();
                    const form = event.currentTarget;
                    const answer = new FormData(form).get("gapAnswer");
                    if (typeof answer !== "string") return;
                    void mutate(async () => {
                      await api.addTextSource(
                        selected.id,
                        workspaceId,
                        `Cevaps\u0131z soru \xB7 ${gap.question}`.slice(0, 200),
                        `Soru: ${gap.question} Cevap: ${answer.trim()}`
                      );
                      form.reset();
                    }, "Cevap, onay bekleyen bilgi olarak kaydedildi.");
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      "textarea",
                      {
                        name: "gapAnswer",
                        required: true,
                        rows: 3,
                        placeholder: "Arayana s\xF6ylenecek ger\xE7ek cevap\u2026"
                      }
                    ),
                    /* @__PURE__ */ jsx("button", { disabled: busy, type: "submit", children: "Bu soruyu cevapla" })
                  ]
                }
              )
            ] }, gap.key))
          ] }),
          voiceStatus && /* @__PURE__ */ jsxs("article", { className: "brain-card onboarding-card", children: [
            /* @__PURE__ */ jsxs("header", { children: [
              /* @__PURE__ */ jsxs("div", { children: [
                /* @__PURE__ */ jsx("small", { children: "TELEFON \u0130\xC7\u0130N EKS\u0130K B\u0130LG\u0130LER" }),
                /* @__PURE__ */ jsx("h3", { children: voiceStatus.nextTopic ? voiceStatus.nextTopic.question : "Telefon bilgileri tamam" })
              ] }),
              /* @__PURE__ */ jsxs("b", { children: [
                voiceStatus.progress,
                "%"
              ] })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "brain-progress", children: /* @__PURE__ */ jsx("i", { style: { width: `${voiceStatus.progress}%` } }) }),
            !voiceStatus.callReady && /* @__PURE__ */ jsxs("p", { className: "studio-alert error", children: [
              "Arama ajan\u0131 yay\u0131nlanmadan \xF6nce ",
              voiceStatus.missingRequiredKeys.length,
              " zorunlu soru daha cevaplanmal\u0131."
            ] }),
            voiceStatus.nextTopic && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx("p", { className: "alx-muted", children: voiceStatus.nextTopic.why }),
              /* @__PURE__ */ jsxs(
                "form",
                {
                  onSubmit: (event) => {
                    event.preventDefault();
                    const form = event.currentTarget;
                    const answer = new FormData(form).get("voiceAnswer");
                    const topicKey = voiceStatus.nextTopic?.key;
                    if (typeof answer !== "string" || !topicKey) return;
                    void mutate(async () => {
                      await api.voiceOnboardingAnswer(selected.id, topicKey, answer);
                      form.reset();
                    }, "Cevap, onay bekleyen bilgi olarak kaydedildi.");
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      "textarea",
                      {
                        name: "voiceAnswer",
                        required: true,
                        rows: 4,
                        placeholder: "Arayana s\xF6ylenecek ger\xE7ek cevab\u0131 yaz\u0131n\u2026"
                      }
                    ),
                    /* @__PURE__ */ jsx("button", { disabled: busy, type: "submit", children: "Cevab\u0131 kaydet" })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("details", { children: [
              /* @__PURE__ */ jsxs("summary", { children: [
                "T\xFCm telefon sorular\u0131 (",
                voiceStatus.topics.length,
                ")"
              ] }),
              /* @__PURE__ */ jsx("ul", { children: voiceStatus.topics.map((topic) => /* @__PURE__ */ jsxs("li", { children: [
                topic.answered ? "\u2713" : topic.required ? "\u2022 zorunlu" : "\u25E6",
                " ",
                topic.question
              ] }, topic.key)) })
            ] })
          ] }),
          /* @__PURE__ */ jsxs("article", { className: "brain-card onboarding-card", children: [
            /* @__PURE__ */ jsxs("header", { children: [
              /* @__PURE__ */ jsxs("div", { children: [
                /* @__PURE__ */ jsx("small", { children: t("Guided Onboarding").toUpperCase() }),
                /* @__PURE__ */ jsx("h3", { children: selected.nextQuestion ?? t("Onboarding complete") })
              ] }),
              /* @__PURE__ */ jsxs("b", { children: [
                selected.onboardingStep,
                "/10"
              ] })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "brain-progress", children: /* @__PURE__ */ jsx("i", { style: { width: `${selected.onboardingProgress}%` } }) }),
            selected.nextQuestion && /* @__PURE__ */ jsxs(
              "form",
              {
                onSubmit: (event) => {
                  event.preventDefault();
                  const form = event.currentTarget;
                  const answer = new FormData(form).get("answer");
                  if (typeof answer !== "string") return;
                  void mutate(async () => {
                    await api.answer(selected.id, answer);
                    form.reset();
                  }, t("Answer saved as a reviewable proposal."));
                },
                children: [
                  /* @__PURE__ */ jsx("textarea", { name: "answer", required: true, rows: 4, placeholder: t("Add verified facts\u2026") }),
                  /* @__PURE__ */ jsx("button", { disabled: busy, type: "submit", children: t("Save answer") })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("article", { className: "brain-card", children: [
            /* @__PURE__ */ jsx("header", { children: /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("small", { children: "WEB S\u0130TES\u0130NDEN DOLDUR" }),
              /* @__PURE__ */ jsx("h3", { children: "Sitenizin adresini yaz\u0131n" })
            ] }) }),
            /* @__PURE__ */ jsx("p", { className: "alx-muted", children: "Ana sayfa ve ba\u011Fl\u0131 birka\xE7 sayfa okunur, c\xFCmleler onay bekleyen bilgi olarak d\xFC\u015Fer. Hi\xE7bir \u015Fey otomatik yay\u0131nlanmaz; onaylamad\u0131\u011F\u0131n\u0131z c\xFCmle konu\u015Fulmaz." }),
            /* @__PURE__ */ jsxs(
              "form",
              {
                onSubmit: (event) => {
                  event.preventDefault();
                  const form = event.currentTarget;
                  const url = new FormData(form).get("websiteUrl");
                  if (typeof url !== "string") return;
                  void mutate(async () => {
                    await api.addWebsiteSource(selected.id, workspaceId, url);
                    form.reset();
                  }, "Site okundu. \xD6nerilen bilgiler onay\u0131n\u0131z\u0131 bekliyor.");
                },
                children: [
                  /* @__PURE__ */ jsx(
                    "input",
                    {
                      name: "websiteUrl",
                      required: true,
                      minLength: 4,
                      placeholder: "ornekfirma.com"
                    }
                  ),
                  /* @__PURE__ */ jsx("button", { disabled: busy, type: "submit", children: "Siteyi oku" })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("article", { className: "brain-card", children: [
            /* @__PURE__ */ jsx("header", { children: /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("small", { children: t("Text Source").toUpperCase() }),
              /* @__PURE__ */ jsx("h3", { children: t("Ingest trusted material") })
            ] }) }),
            /* @__PURE__ */ jsxs(
              "form",
              {
                onSubmit: (event) => {
                  event.preventDefault();
                  const form = event.currentTarget;
                  const data = new FormData(form);
                  const title = data.get("title");
                  const content = data.get("content");
                  if (typeof title !== "string" || typeof content !== "string") return;
                  void mutate(async () => {
                    await api.addTextSource(selected.id, workspaceId, title, content);
                    form.reset();
                  }, t("Source ingested. Proposed facts are ready for review."));
                },
                children: [
                  /* @__PURE__ */ jsx("input", { name: "title", required: true, minLength: 2, placeholder: t("Source title") }),
                  /* @__PURE__ */ jsx(
                    "textarea",
                    {
                      name: "content",
                      required: true,
                      rows: 6,
                      placeholder: t("Separate distinct facts with blank lines.")
                    }
                  ),
                  /* @__PURE__ */ jsx("button", { disabled: busy, type: "submit", children: t("Ingest source") })
                ]
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "brain-column", children: [
          /* @__PURE__ */ jsxs("article", { className: "brain-card proposal-card", children: [
            /* @__PURE__ */ jsxs("header", { children: [
              /* @__PURE__ */ jsxs("div", { children: [
                /* @__PURE__ */ jsx("small", { children: t("Human Review").toUpperCase() }),
                /* @__PURE__ */ jsx("h3", { children: t("Knowledge proposals") })
              ] }),
              /* @__PURE__ */ jsx("b", { children: proposals.length })
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "proposal-list", children: [
              proposals.length === 0 && /* @__PURE__ */ jsx("p", { children: t("No proposals yet.") }),
              proposals.map((proposal) => /* @__PURE__ */ jsxs("div", { children: [
                /* @__PURE__ */ jsx("span", { children: proposal.kind }),
                /* @__PURE__ */ jsx("p", { children: proposal.canonicalContent }),
                /* @__PURE__ */ jsxs("small", { children: [
                  proposal.sourceLabel,
                  " \xB7 ",
                  Math.round(proposal.confidence * 100),
                  "% confidence"
                ] }),
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    disabled: busy || proposal.approvalState !== "proposed",
                    onClick: () => void mutate(
                      async () => void await api.approve(selected.id, proposal.id),
                      t("Proposal approved for the next publication.")
                    ),
                    type: "button",
                    children: proposal.approvalState === "proposed" ? t("Approve") : proposal.approvalState
                  }
                )
              ] }, proposal.id))
            ] }),
            /* @__PURE__ */ jsx(
              "button",
              {
                className: "publish-button",
                disabled: busy || selected.approvedCount < 1,
                onClick: () => void mutate(
                  async () => void await api.publish(selected.id, selected.draftVersion),
                  t("Immutable Brain snapshot published.")
                ),
                type: "button",
                children: t("Publish immutable version")
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("article", { className: "brain-card retrieval-card", children: [
            /* @__PURE__ */ jsx("header", { children: /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("small", { children: t("Published-only Retrieval").toUpperCase() }),
              /* @__PURE__ */ jsx("h3", { children: t("Test the Brain") })
            ] }) }),
            /* @__PURE__ */ jsxs(
              "form",
              {
                onSubmit: (event) => {
                  event.preventDefault();
                  const query = new FormData(event.currentTarget).get("query");
                  if (typeof query !== "string") return;
                  setBusy(true);
                  setError(void 0);
                  void api.retrieve(selected.id, query).then(setRetrieval).catch((cause) => setError(message(cause))).finally(() => setBusy(false));
                },
                children: [
                  /* @__PURE__ */ jsx("input", { name: "query", required: true, placeholder: t("Search published knowledge") }),
                  /* @__PURE__ */ jsx("button", { disabled: busy || !selected.publishedVersion, type: "submit", children: t("Retrieve") })
                ]
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "retrieval-results", children: retrieval?.items.map((item) => /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("p", { children: item.content }),
              /* @__PURE__ */ jsx("small", { children: item.sourceLabel })
            ] }, item.knowledgeVersionId)) })
          ] })
        ] })
      ] })
    ] })
  ] });
};
var BrainStat = ({ label, value }) => /* @__PURE__ */ jsxs("article", { children: [
  /* @__PURE__ */ jsx("small", { children: label }),
  /* @__PURE__ */ jsx("strong", { children: value })
] });
var message = (cause) => cause instanceof Error ? cause.message.replaceAll("_", " ") : "Unexpected request failure";

// src/agent.tsx
import {
  useEffect as useEffect3,
  useCallback as useCallback3,
  useMemo as useMemo2,
  useRef as useRef2,
  useState as useState3
} from "react";

// src/browser-demo.tsx
import {
  useCallback as useCallback2,
  useEffect as useEffect2,
  useRef,
  useState as useState2
} from "react";
import {
  voiceCallViewSchema
} from "@agentos/contracts";
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var VAD = {
  /** Start speech when frame max abs exceeds this. */
  speechPeak: 0.032,
  /** Start speech when smoothed level exceeds this. */
  speechLevel: 0.09,
  /** Frames above threshold before we commit to "speaking". */
  startFrames: 2,
  /** Silence hangover before cutting the utterance (ms) — snappier turn-taking. */
  silenceMs: 680,
  /** Minimum utterance length before we send (ms). */
  minSpeechMs: 480,
  /** Max utterance length — force cut (ms). Continuous: 6–8s band. */
  maxSpeechMs: 7e3,
  /** Ignore very quiet peak captures. */
  minPeak: 0.01
};
var BrowserDemoSoftphone = ({
  api,
  workspaceId,
  agentId,
  agentName,
  publishedVersion,
  compact = false,
  className,
  interruptionEnabled = true,
  ambienceBedId = "office",
  ambienceGain = 0.12,
  ambienceSrc
}) => {
  const interruptionEnabledRef = useRef(interruptionEnabled);
  useEffect2(() => {
    interruptionEnabledRef.current = interruptionEnabled;
  }, [interruptionEnabled]);
  const ambienceRef = useRef(null);
  const [phase, setPhase] = useState2("idle");
  const [listenMode, setListenMode] = useState2("ptt");
  const [hint, setHint] = useState2();
  const [error, setError] = useState2();
  const [busy, setBusy] = useState2(false);
  const [consent, setConsent] = useState2(false);
  const [call, setCall] = useState2();
  const [turns, setTurns] = useState2([]);
  const [pttHeld, setPttHeld] = useState2(false);
  const [meter, setMeter] = useState2({
    level: 0,
    peak: 0,
    quality: "off",
    live: false
  });
  useEffect2(() => {
    const el = ambienceRef.current;
    if (!el) return;
    el.loop = true;
    const ratio = Math.max(0, (ambienceGain ?? 0.12) / 0.12);
    el.volume = Math.max(0, Math.min(1, 0.42 * ratio ** 2.4));
    const src = ambienceSrc ?? (ambienceBedId === "office" ? "/ambience/office-24734.mp3" : "");
    el.src = src || el.src;
    const want = Boolean(src) && ambienceBedId !== "none" && (phase === "speaking" || phase === "thinking" || phase === "active");
    if (want) {
      void el.play().catch(() => void 0);
    } else {
      el.pause();
    }
  }, [phase, ambienceBedId, ambienceGain, ambienceSrc]);
  const audioPlayerRef = useRef(null);
  const meterCleanupRef = useRef(null);
  const listenStreamRef = useRef(null);
  const audioCtxRef = useRef(null);
  const captureRef = useRef(null);
  const processorRef = useRef(null);
  const sourceRef = useRef(null);
  const armCaptureRef = useRef(false);
  const vadEnabledRef = useRef(false);
  const speechActiveRef = useRef(false);
  const speechStartFramesRef = useRef(0);
  const lastLoudAtRef = useRef(0);
  const turnInFlightRef = useRef(false);
  const pendingBargeInRef = useRef(false);
  const disposedRef = useRef(false);
  const phaseRef = useRef("idle");
  const callRef = useRef(void 0);
  const listenModeRef = useRef("ptt");
  const sessionRef = useRef(null);
  useEffect2(() => {
    phaseRef.current = phase;
  }, [phase]);
  useEffect2(() => {
    callRef.current = call;
  }, [call]);
  useEffect2(() => {
    listenModeRef.current = listenMode;
  }, [listenMode]);
  const stopMeter = useCallback2(() => {
    vadEnabledRef.current = false;
    armCaptureRef.current = false;
    speechActiveRef.current = false;
    speechStartFramesRef.current = 0;
    pendingBargeInRef.current = false;
    try {
      processorRef.current?.disconnect();
      sourceRef.current?.disconnect();
    } catch {
    }
    processorRef.current = null;
    sourceRef.current = null;
    meterCleanupRef.current?.();
    meterCleanupRef.current = null;
    listenStreamRef.current?.getTracks().forEach((t) => t.stop());
    listenStreamRef.current = null;
    void audioCtxRef.current?.close().catch(() => void 0);
    audioCtxRef.current = null;
    captureRef.current = null;
    setMeter({ level: 0, peak: 0, quality: "off", live: false });
    setPttHeld(false);
  }, []);
  const rearmAfterTurn = useCallback2((mode) => {
    if (mode === "continuous") {
      vadEnabledRef.current = true;
      armCaptureRef.current = false;
      speechActiveRef.current = false;
      speechStartFramesRef.current = 0;
    } else {
      vadEnabledRef.current = false;
      armCaptureRef.current = false;
      speechActiveRef.current = false;
      speechStartFramesRef.current = 0;
    }
  }, []);
  const submitUtterance = useCallback2(async () => {
    const session = sessionRef.current;
    if (!session || session.disposedRef.current) return;
    if (session.turnInFlightRef.current) return;
    const capture = session.captureRef.current;
    const wantBargeIn = session.pendingBargeInRef.current;
    session.captureRef.current = null;
    session.armCaptureRef.current = false;
    session.speechActiveRef.current = false;
    session.speechStartFramesRef.current = 0;
    session.vadEnabledRef.current = false;
    session.pendingBargeInRef.current = false;
    if (!session.call) {
      session.setPhase("idle");
      return;
    }
    if (!capture || capture.samples.length === 0) {
      rearmAfterTurn(session.listenMode);
      session.setPhase("active");
      session.setHint(
        session.listenMode === "continuous" ? "Mikrofon a\xE7\u0131k \u2014 konu\u015Fmaya devam edin." : "Bas\u0131l\u0131 tutun ve konu\u015Fun, b\u0131rak\u0131nca g\xF6nderilir."
      );
      return;
    }
    const elapsedMs = Date.now() - capture.startedAt;
    if (elapsedMs < VAD.minSpeechMs || capture.peak < VAD.minPeak) {
      rearmAfterTurn(session.listenMode);
      session.setPhase("active");
      session.setHint(
        session.listenMode === "continuous" ? "K\u0131sa/zay\u0131f ses atland\u0131 \u2014 net konu\u015Fun, mikrofon a\xE7\u0131k kal\u0131r." : "K\u0131sa/zay\u0131f ses atland\u0131 \u2014 bas\u0131l\u0131 tutup net konu\u015Fun."
      );
      return;
    }
    session.turnInFlightRef.current = true;
    session.setBusy(true);
    session.setPhase("thinking");
    session.setHint("\u0130\u015Fleniyor\u2026");
    session.setError(void 0);
    let releasedForPlayback = false;
    try {
      let mono = mergeSamples(capture.samples);
      mono = normalizeGain(mono, capture.peak);
      const targetRate = 16e3;
      const resampled = capture.sampleRate === targetRate ? mono : resampleLinear(mono, capture.sampleRate, targetRate);
      const wav = encodeWavPcm16(resampled, targetRate);
      const turn = await session.api.turn(session.call.id, {
        audioBase64: bytesToBase64(wav),
        audioEncoding: "wav",
        includeAudio: true,
        // Client only requests barge-in when agent allows interruptions (server also ANDs).
        bargeIn: wantBargeIn && interruptionEnabledRef.current
      });
      if (session.disposedRef.current) return;
      session.setTurns((current) => [...current, turn]);
      session.turnInFlightRef.current = false;
      session.setBusy(false);
      releasedForPlayback = true;
      if (turn.response.status === "ended") {
        session.vadEnabledRef.current = false;
        session.armCaptureRef.current = false;
        session.speechActiveRef.current = false;
        session.setCall(void 0);
        callRef.current = void 0;
        session.setPhase("idle");
        session.setHint("Ajan g\xF6r\xFC\u015Fmeyi kapatt\u0131.");
        return;
      }
      const nextStatus = turn.response.status === "waiting_for_human" ? "waiting_for_human" : session.call.status === "completed" ? "completed" : "active";
      const next = voiceCallViewSchema.parse({
        ...session.call,
        status: nextStatus,
        bargeInCount: session.call.bargeInCount + (turn.bargeInAcknowledged ? 1 : 0)
      });
      session.setCall(next);
      callRef.current = next;
      session.call = next;
      if (turn.response.status === "waiting_for_human") {
        session.setPhase("active");
        session.setHint(
          "\u0130nsan aktar\u0131m\u0131 istendi \u2014 g\xF6r\xFC\u015Fme h\xE2l\xE2 a\xE7\u0131k. Bitirmek i\xE7in Kapat\u2019a bas\u0131n."
        );
        session.vadEnabledRef.current = false;
        session.armCaptureRef.current = false;
        return;
      }
      session.setPhase("speaking");
      session.setHint(
        turn.transcript.text && turn.transcript.text !== "\u2026" ? `Siz: ${turn.transcript.text}` : "Ajan yan\u0131tl\u0131yor\u2026"
      );
      if (session.listenMode === "continuous") {
        session.vadEnabledRef.current = true;
      }
      if (turn.audio.audioBase64) {
        await session.playBase64Mp3(turn.audio.audioBase64, session.audioPlayerRef);
      }
      if (session.disposedRef.current) return;
      if (session.speechActiveRef.current || session.armCaptureRef.current || session.turnInFlightRef.current || session.pendingBargeInRef.current) {
        return;
      }
      session.setPhase("active");
      rearmAfterTurn(session.listenMode);
      session.setHint(
        session.listenMode === "continuous" ? "Mikrofon a\xE7\u0131k \u2014 konu\u015Fmaya devam edin." : "Bas\u0131l\u0131 tutun ve konu\u015Fun, b\u0131rak\u0131nca g\xF6nderilir."
      );
    } catch (cause) {
      if (session.disposedRef.current) return;
      const msg = errMsg(cause);
      if (msg) session.setError(msg);
      session.setPhase("active");
      rearmAfterTurn(session.listenMode);
      session.setHint(
        session.listenMode === "continuous" ? "Tur ba\u015Far\u0131s\u0131z \u2014 mikrofon a\xE7\u0131k, tekrar konu\u015Fun." : "Tur ba\u015Far\u0131s\u0131z \u2014 bas-konu\u015F ile tekrar deneyin."
      );
    } finally {
      if (!releasedForPlayback) {
        session.turnInFlightRef.current = false;
        session.setBusy(false);
      }
    }
  }, [rearmAfterTurn]);
  sessionRef.current = {
    api,
    call: callRef.current,
    phase: phaseRef.current,
    listenMode: listenModeRef.current,
    setBusy,
    setError,
    setPhase,
    setHint,
    setTurns,
    setCall,
    playBase64Mp3,
    audioPlayerRef,
    captureRef,
    armCaptureRef,
    vadEnabledRef,
    speechActiveRef,
    speechStartFramesRef,
    lastLoudAtRef,
    turnInFlightRef,
    pendingBargeInRef,
    disposedRef
  };
  const ensureMic = useCallback2(async () => {
    try {
      if (!navigator.mediaDevices?.getUserMedia) {
        setMeter({
          level: 0,
          peak: 0,
          quality: "off",
          live: false,
          error: "MICROPHONE_UNSUPPORTED"
        });
        return null;
      }
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) {
        setMeter({
          level: 0,
          peak: 0,
          quality: "off",
          live: false,
          error: "AUDIO_CONTEXT_UNSUPPORTED"
        });
        return null;
      }
      let stream = listenStreamRef.current;
      if (!stream || stream.getAudioTracks().every((t) => t.readyState !== "live")) {
        stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
            channelCount: 1
          }
        });
        listenStreamRef.current = stream;
      }
      let ctx = audioCtxRef.current;
      if (!ctx || ctx.state === "closed") {
        ctx = new AudioCtx();
        audioCtxRef.current = ctx;
      }
      if (ctx.state === "suspended") await ctx.resume();
      if (!processorRef.current) {
        const source = ctx.createMediaStreamSource(stream);
        const processor = ctx.createScriptProcessor(4096, 1, 1);
        const silent = ctx.createGain();
        silent.gain.value = 0;
        source.connect(processor);
        processor.connect(silent);
        silent.connect(ctx.destination);
        sourceRef.current = source;
        processorRef.current = processor;
        let peak = 0;
        processor.onaudioprocess = (event) => {
          const input = event.inputBuffer.getChannelData(0);
          let sum = 0;
          let max = 0;
          for (let i = 0; i < input.length; i += 1) {
            const v = Math.abs(input[i]);
            sum += v * v;
            if (v > max) max = v;
          }
          const rms = Math.sqrt(sum / input.length);
          const level = Math.min(1, Math.pow(rms * 4.5, 0.65));
          peak = Math.max(peak * 0.92, level);
          setMeter({
            level,
            peak,
            quality: classifyQuality(level, max),
            live: true
          });
          const session = sessionRef.current;
          if (!session || session.disposedRef.current) return;
          if (session.turnInFlightRef.current) return;
          const mode = session.listenMode;
          const now = Date.now();
          const loud = max >= VAD.speechPeak || level >= VAD.speechLevel;
          if (mode === "ptt") {
            if (session.armCaptureRef.current && session.captureRef.current) {
              session.captureRef.current.samples.push(new Float32Array(input));
              session.captureRef.current.peak = Math.max(session.captureRef.current.peak, max);
            }
            return;
          }
          const phaseNow = phaseRef.current;
          if (interruptionEnabledRef.current && phaseNow === "speaking" && loud && !session.speechActiveRef.current && !session.armCaptureRef.current) {
            const player = session.audioPlayerRef.current;
            if (player && !player.paused) {
              player.pause();
            }
            session.pendingBargeInRef.current = true;
            session.speechActiveRef.current = true;
            session.armCaptureRef.current = true;
            session.speechStartFramesRef.current = VAD.startFrames;
            session.lastLoudAtRef.current = now;
            session.captureRef.current = {
              samples: [],
              sampleRate: event.inputBuffer.sampleRate || ctx.sampleRate,
              startedAt: now,
              peak: max
            };
            session.setPhase("listening");
            session.setHint("Kesme \u2014 sizi dinliyorum\u2026");
          }
          if (!session.vadEnabledRef.current && !session.armCaptureRef.current) return;
          if (loud) {
            session.lastLoudAtRef.current = now;
            if (!session.speechActiveRef.current && session.vadEnabledRef.current) {
              session.speechStartFramesRef.current += 1;
              if (session.speechStartFramesRef.current >= VAD.startFrames) {
                session.speechActiveRef.current = true;
                session.armCaptureRef.current = true;
                session.captureRef.current = {
                  samples: [],
                  sampleRate: event.inputBuffer.sampleRate || ctx.sampleRate,
                  startedAt: now,
                  peak: max
                };
                session.setPhase("listening");
                session.setHint("Dinleniyor\u2026 konu\u015Fmaya devam edin.");
              }
            }
          } else if (!session.speechActiveRef.current) {
            session.speechStartFramesRef.current = 0;
          }
          if (session.armCaptureRef.current && session.captureRef.current) {
            session.captureRef.current.samples.push(new Float32Array(input));
            session.captureRef.current.peak = Math.max(session.captureRef.current.peak, max);
            const started = session.captureRef.current.startedAt;
            const elapsed = now - started;
            const silentFor = now - session.lastLoudAtRef.current;
            const shouldCut = session.speechActiveRef.current && silentFor >= VAD.silenceMs && elapsed >= VAD.minSpeechMs || elapsed >= VAD.maxSpeechMs;
            if (shouldCut) {
              session.vadEnabledRef.current = false;
              session.armCaptureRef.current = false;
              session.speechActiveRef.current = false;
              void submitUtterance();
            }
          }
        };
        meterCleanupRef.current = () => {
          try {
            processor.disconnect();
            source.disconnect();
            silent.disconnect();
          } catch {
          }
        };
      }
      return { stream, ctx };
    } catch (cause) {
      setMeter({
        level: 0,
        peak: 0,
        quality: "off",
        live: false,
        error: cause instanceof Error ? cause.message : "MIC_DENIED"
      });
      return null;
    }
  }, [submitUtterance]);
  useEffect2(() => {
    disposedRef.current = false;
    return () => {
      disposedRef.current = true;
      vadEnabledRef.current = false;
      stopMeter();
      audioPlayerRef.current?.pause();
    };
  }, [stopMeter]);
  const beginPtt = useCallback2(() => {
    if (turnInFlightRef.current) return;
    if (phaseRef.current === "connecting" || phaseRef.current === "idle") return;
    if (phaseRef.current === "thinking") return;
    if (listenModeRef.current !== "ptt") return;
    if (!callRef.current) return;
    if (phaseRef.current === "speaking") {
      audioPlayerRef.current?.pause();
      pendingBargeInRef.current = true;
    }
    const ctx = audioCtxRef.current;
    const sampleRate = ctx?.sampleRate ?? 48e3;
    armCaptureRef.current = true;
    speechActiveRef.current = true;
    captureRef.current = {
      samples: [],
      sampleRate,
      startedAt: Date.now(),
      peak: 0
    };
    setPttHeld(true);
    setPhase("listening");
    setHint("Dinleniyor\u2026 b\u0131rak\u0131nca g\xF6nderilir.");
    setError(void 0);
  }, []);
  const endPtt = useCallback2(() => {
    if (listenModeRef.current !== "ptt") return;
    if (!armCaptureRef.current && !captureRef.current) {
      setPttHeld(false);
      return;
    }
    setPttHeld(false);
    armCaptureRef.current = false;
    speechActiveRef.current = false;
    void submitUtterance();
  }, [submitUtterance]);
  const callLive = Boolean(
    call && call.status !== "completed" && call.status !== "failed"
  );
  const canStart = Boolean(publishedVersion) && consent && !busy && phase === "idle" && !callLive;
  const modeLocked = phase !== "idle" || callLive;
  const pttDisabled = busy || turnInFlightRef.current || phase === "connecting" || phase === "thinking" || phase === "idle" || !call || call.status === "waiting_for_human";
  return /* @__PURE__ */ jsxs2("div", { className: `browser-demo-softphone ${compact ? "compact" : ""} ${className ?? ""}`, children: [
    ambienceBedId !== "none" && (ambienceSrc || ambienceBedId === "office") ? /* @__PURE__ */ jsx2(
      "audio",
      {
        ref: ambienceRef,
        src: ambienceSrc || "/ambience/office-24734.mp3",
        loop: true,
        preload: "auto",
        "aria-hidden": true
      }
    ) : null,
    /* @__PURE__ */ jsxs2("header", { className: "bds-header", children: [
      /* @__PURE__ */ jsxs2("div", { children: [
        /* @__PURE__ */ jsx2("small", { children: "PC DEMO G\xD6R\xDC\u015EME" }),
        /* @__PURE__ */ jsx2("h3", { children: compact ? agentName : "Telefondaki gibi ajanla konu\u015F" })
      ] }),
      /* @__PURE__ */ jsx2("em", { className: `bds-phase phase-${phase} ${error ? "phase-error" : ""}`, children: error && phase !== "thinking" && phase !== "connecting" ? "Hata" : call?.status === "waiting_for_human" ? "\u0130nsan bekleniyor" : phaseLabel(phase, listenMode) })
    ] }),
    /* @__PURE__ */ jsxs2("p", { className: "bds-tip", role: "note", children: [
      "Bu bir ",
      /* @__PURE__ */ jsx2("b", { children: "taray\u0131c\u0131 demosu" }),
      "d\u0131r (",
      /* @__PURE__ */ jsx2("code", { children: "browser_demo" }),
      ") \u2014 ger\xE7ek PSTN / Zadarma / Verimor aramas\u0131 de\u011Fildir."
    ] }),
    !compact && /* @__PURE__ */ jsxs2("p", { className: "bds-copy", children: [
      "Varsay\u0131lan: ",
      /* @__PURE__ */ jsx2("b", { children: "Bas konu\u015F" }),
      " (bas\u0131l\u0131 tut \u2192 b\u0131rak \u2192 ajan yan\u0131tlar). \u0130sterseniz",
      " ",
      /* @__PURE__ */ jsx2("b", { children: "S\xFCrekli dinle" }),
      " ile sessizlik veya ~7 sn diliminde otomatik tur. Seviye \xE7ubu\u011Fu ye\u015File yakla\u015Fmal\u0131."
    ] }),
    !publishedVersion && /* @__PURE__ */ jsxs2("p", { className: "bds-warn", children: [
      "\xD6nce ajan\u0131 ",
      /* @__PURE__ */ jsx2("b", { children: "Publish & deploy" }),
      " ile yay\u0131nlay\u0131n."
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "bds-mode-toggle", role: "group", "aria-label": "Dinleme modu", children: [
      /* @__PURE__ */ jsx2(
        "button",
        {
          type: "button",
          className: `bds-mode-btn ${listenMode === "ptt" ? "active" : ""}`,
          disabled: modeLocked,
          onClick: () => setListenMode("ptt"),
          children: "Bas konu\u015F"
        }
      ),
      /* @__PURE__ */ jsx2(
        "button",
        {
          type: "button",
          className: `bds-mode-btn ${listenMode === "continuous" ? "active" : ""}`,
          disabled: modeLocked,
          onClick: () => setListenMode("continuous"),
          children: "S\xFCrekli dinle"
        }
      )
    ] }),
    /* @__PURE__ */ jsx2(MicLevelMeter, { meter }),
    /* @__PURE__ */ jsxs2("div", { className: "bds-controls", children: [
      !callLive ? /* @__PURE__ */ jsxs2(Fragment2, { children: [
        /* @__PURE__ */ jsxs2("label", { className: "bds-consent", children: [
          /* @__PURE__ */ jsx2(
            "input",
            {
              type: "checkbox",
              checked: consent,
              onChange: (e) => setConsent(e.target.checked)
            }
          ),
          "Kay\u0131t bilgilendirmesi kabul edildi"
        ] }),
        /* @__PURE__ */ jsxs2("div", { className: "bds-actions", children: [
          /* @__PURE__ */ jsx2(
            "button",
            {
              type: "button",
              className: "bds-btn ghost",
              disabled: busy,
              onClick: () => void (async () => {
                setError(void 0);
                const ok = await ensureMic();
                if (ok) setHint("Mikrofon a\xE7\u0131k \u2014 konu\u015Farak seviye \xE7ubu\u011Funu kontrol edin.");
              })(),
              children: "Mikrofonu test et"
            }
          ),
          /* @__PURE__ */ jsx2(
            "button",
            {
              type: "button",
              className: "bds-btn primary",
              disabled: !canStart,
              onClick: () => void startDemo({
                api,
                workspaceId,
                agentId,
                setBusy,
                setError,
                setPhase,
                setHint,
                setCall,
                setTurns,
                ensureMic,
                playBase64Mp3,
                audioPlayerRef,
                callRef,
                vadEnabledRef,
                armCaptureRef,
                speechActiveRef,
                speechStartFramesRef,
                pendingBargeInRef,
                listenMode: listenModeRef.current
              }),
              children: "G\xF6r\xFC\u015Fmeyi ba\u015Flat"
            }
          )
        ] })
      ] }) : /* @__PURE__ */ jsxs2("div", { className: "bds-actions bds-actions-live", children: [
        call?.status === "waiting_for_human" ? /* @__PURE__ */ jsx2("div", { className: "bds-live-pill open", "aria-live": "polite", children: "\u0130nsan aktar\u0131m\u0131 \u2014 hat a\xE7\u0131k" }) : listenMode === "ptt" ? /* @__PURE__ */ jsx2(
          "button",
          {
            type: "button",
            className: `bds-btn ptt ${pttHeld ? "hot" : ""}`,
            disabled: pttDisabled && !pttHeld,
            onPointerDown: (e) => {
              e.preventDefault();
              e.currentTarget.setPointerCapture(e.pointerId);
              beginPtt();
            },
            onPointerUp: (e) => {
              e.preventDefault();
              endPtt();
            },
            onPointerCancel: () => endPtt(),
            onPointerLeave: (e) => {
              if (pttHeld && e.buttons === 0) endPtt();
            },
            onContextMenu: (e) => e.preventDefault(),
            children: pttHeld ? "Konu\u015Fun\u2026" : "Bas konu\u015F"
          }
        ) : /* @__PURE__ */ jsx2(
          "div",
          {
            className: `bds-live-pill ${phase === "listening" ? "hot" : ""} ${phase === "active" ? "open" : ""} ${phase === "speaking" ? "speaking" : ""} ${phase === "thinking" ? "busy" : ""}`,
            "aria-live": "polite",
            children: livePillLabel(phase)
          }
        ),
        /* @__PURE__ */ jsx2(
          "button",
          {
            type: "button",
            className: "bds-btn hangup",
            disabled: busy && phase === "connecting",
            title: "Demo g\xF6r\xFC\u015Fmeyi sunucuda tamamla ve kapat",
            onClick: () => void hangupDemo({
              api,
              call: callRef.current ?? call,
              setBusy,
              setError,
              setPhase,
              setHint,
              setCall,
              audioPlayerRef,
              stopMeter,
              vadEnabledRef,
              armCaptureRef,
              speechActiveRef,
              turnInFlightRef,
              pendingBargeInRef
            }),
            children: "G\xF6r\xFC\u015Fmeyi kapat"
          }
        )
      ] }),
      hint && /* @__PURE__ */ jsx2("small", { className: "bds-hint", children: hint }),
      error && /* @__PURE__ */ jsx2("div", { className: "bds-error", children: error }),
      turns.length > 0 && /* @__PURE__ */ jsxs2("div", { className: "bds-turns", children: [
        /* @__PURE__ */ jsx2("small", { children: "SON TURLAR" }),
        turns.slice(-6).map((turn) => /* @__PURE__ */ jsxs2("div", { className: "bds-turn", children: [
          /* @__PURE__ */ jsxs2("p", { children: [
            /* @__PURE__ */ jsx2("strong", { children: "Siz:" }),
            " ",
            turn.transcript.text
          ] }),
          /* @__PURE__ */ jsxs2("p", { children: [
            /* @__PURE__ */ jsx2("strong", { children: "Ajan:" }),
            " ",
            turn.response.text
          ] })
        ] }, turn.transcript.text + turn.response.messageId))
      ] })
    ] })
  ] });
};
var MicLevelMeter = ({ meter }) => {
  const pct2 = Math.min(100, Math.round(meter.level * 100));
  const peakPct = Math.min(100, Math.round(meter.peak * 100));
  return /* @__PURE__ */ jsxs2("div", { className: `bds-meter quality-${meter.quality} ${meter.live ? "live" : ""}`, children: [
    /* @__PURE__ */ jsxs2("div", { className: "bds-meter-head", children: [
      /* @__PURE__ */ jsx2("span", { children: "Mikrofon" }),
      /* @__PURE__ */ jsx2("strong", { children: qualityLabel(meter.quality) }),
      meter.live && /* @__PURE__ */ jsxs2("em", { children: [
        pct2,
        "%"
      ] })
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "bds-meter-track", "aria-hidden": true, children: [
      /* @__PURE__ */ jsx2("div", { className: "bds-meter-fill", style: { width: `${pct2}%` } }),
      /* @__PURE__ */ jsx2("div", { className: "bds-meter-peak", style: { left: `${peakPct}%` } })
    ] }),
    /* @__PURE__ */ jsxs2("div", { className: "bds-meter-scale", children: [
      /* @__PURE__ */ jsx2("span", { children: "Sessiz" }),
      /* @__PURE__ */ jsx2("span", { children: "\u0130yi" }),
      /* @__PURE__ */ jsx2("span", { children: "Y\xFCksek" })
    ] }),
    meter.error && /* @__PURE__ */ jsxs2("small", { className: "bds-meter-err", children: [
      "Mikrofon hatas\u0131:",
      " ",
      meter.error === "NotAllowedError" || meter.error.includes("Permission") ? "\u0130zin reddedildi \u2014 taray\u0131c\u0131dan mikrofon izni verin." : meter.error
    ] }),
    !meter.live && !meter.error && /* @__PURE__ */ jsx2("small", { className: "bds-meter-idle", children: "\xABMikrofonu test et\xBB veya g\xF6r\xFC\u015Fmeyi ba\u015Flat\u0131n \u2014 seviye %20+ olmal\u0131." }),
    meter.live && meter.quality === "silent" && /* @__PURE__ */ jsx2("small", { className: "bds-meter-warn", children: "Ses yok \u2014 konu\u015Fun veya do\u011Fru mikrofonu se\xE7in." }),
    meter.live && meter.quality === "weak" && /* @__PURE__ */ jsxs2("small", { className: "bds-meter-warn", children: [
      "Seviye d\xFC\u015F\xFCk (%",
      pct2,
      ") \u2014 mikrofona yakla\u015F\u0131n; g\xF6r\xFC\u015Fme boyunca net konu\u015Fun."
    ] }),
    meter.live && meter.quality === "clipping" && /* @__PURE__ */ jsx2("small", { className: "bds-meter-warn", children: "\xC7ok y\xFCksek \u2014 bozulma riski." })
  ] });
};
var phaseLabel = (phase, mode) => {
  switch (phase) {
    case "connecting":
      return "Ba\u011Flan\u0131yor";
    case "active":
      return mode === "continuous" ? "Dinleniyor" : "Haz\u0131r";
    case "listening":
      return "Dinleniyor";
    case "thinking":
      return "\u0130\u015Fleniyor";
    case "speaking":
      return "Ajan konu\u015Fuyor";
    default:
      return "Bo\u015Fta";
  }
};
var livePillLabel = (phase) => {
  switch (phase) {
    case "connecting":
      return "Ba\u011Flan\u0131yor\u2026";
    case "thinking":
      return "\u0130\u015Fleniyor\u2026";
    case "speaking":
      return "Ajan konu\u015Fuyor\u2026";
    case "listening":
      return "Dinleniyor\u2026";
    default:
      return "S\xFCrekli dinle \u2014 konu\u015Fun";
  }
};
var qualityLabel = (q) => {
  switch (q) {
    case "silent":
      return "Sessiz";
    case "weak":
      return "Zay\u0131f";
    case "good":
      return "\u0130yi";
    case "loud":
      return "Y\xFCksek";
    case "clipping":
      return "A\u015F\u0131r\u0131";
    default:
      return "Kapal\u0131";
  }
};
var classifyQuality = (level, peakSample) => {
  if (peakSample > 0.95 || level > 0.92) return "clipping";
  if (level < 0.03) return "silent";
  if (level < 0.14) return "weak";
  if (level < 0.55) return "good";
  return "loud";
};
var playBase64Mp3 = async (audioBase64, playerRef) => {
  const binary = atob(audioBase64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  const blob = new Blob([bytes], { type: "audio/mpeg" });
  const url = URL.createObjectURL(blob);
  const previous = playerRef.current;
  if (previous) {
    previous.pause();
    if (previous.src.startsWith("blob:")) URL.revokeObjectURL(previous.src);
  }
  const audio = new Audio(url);
  playerRef.current = audio;
  try {
    await audio.play();
    await new Promise((resolve) => {
      const done = () => {
        audio.onended = null;
        audio.onerror = null;
        audio.onpause = null;
        resolve();
      };
      audio.onended = () => done();
      audio.onerror = () => done();
      audio.onpause = () => {
        if (audio.paused && !audio.ended) done();
      };
    });
  } finally {
    URL.revokeObjectURL(url);
  }
};
var bytesToBase64 = (bytes) => {
  let binary = "";
  const chunk = 32768;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
};
var mergeSamples = (parts) => {
  let total = 0;
  for (const p of parts) total += p.length;
  const out = new Float32Array(total);
  let o = 0;
  for (const p of parts) {
    out.set(p, o);
    o += p.length;
  }
  return out;
};
var normalizeGain = (samples, peak) => {
  if (peak < 1e-3) return samples;
  const target = 0.65;
  const gain = Math.min(12, target / peak);
  if (gain <= 1.05) return samples;
  const out = new Float32Array(samples.length);
  for (let i = 0; i < samples.length; i += 1) {
    out[i] = Math.max(-1, Math.min(1, samples[i] * gain));
  }
  return out;
};
var resampleLinear = (input, fromRate, toRate) => {
  if (fromRate === toRate) return input;
  const ratio = fromRate / toRate;
  const outLength = Math.max(1, Math.round(input.length / ratio));
  const out = new Float32Array(outLength);
  for (let i = 0; i < outLength; i += 1) {
    const src = i * ratio;
    const i0 = Math.floor(src);
    const i1 = Math.min(input.length - 1, i0 + 1);
    const t = src - i0;
    out[i] = input[i0] * (1 - t) + input[i1] * t;
  }
  return out;
};
var encodeWavPcm16 = (samples, sampleRate) => {
  const minSamples = Math.ceil(sampleRate * 0.25);
  const padded = samples.length >= minSamples ? samples : (() => {
    const out = new Float32Array(minSamples);
    out.set(samples);
    return out;
  })();
  const dataSize = padded.length * 2;
  const buffer = new ArrayBuffer(44 + dataSize);
  const view = new DataView(buffer);
  const writeStr = (offset2, value) => {
    for (let i = 0; i < value.length; i += 1) view.setUint8(offset2 + i, value.charCodeAt(i));
  };
  writeStr(0, "RIFF");
  view.setUint32(4, 36 + dataSize, true);
  writeStr(8, "WAVE");
  writeStr(12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, 1, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * 2, true);
  view.setUint16(32, 2, true);
  view.setUint16(34, 16, true);
  writeStr(36, "data");
  view.setUint32(40, dataSize, true);
  let offset = 44;
  for (let i = 0; i < padded.length; i += 1) {
    const s = Math.max(-1, Math.min(1, padded[i]));
    view.setInt16(offset, s < 0 ? s * 32768 : s * 32767, true);
    offset += 2;
  }
  return new Uint8Array(buffer);
};
var friendlyError = (raw) => {
  if (raw.includes("SESSION_EXPIRED") || raw.includes("SESSION_NOT_ACTIVE") || raw.includes("HTTP_401") || raw === "HTTP_ERROR") {
    return "Oturum s\xFCresi doldu veya ge\xE7ersiz (401). Sayfay\u0131 yenileyin (Ctrl+Shift+R), CenterOS\u2019a tekrar girin, demo\u2019yu yeniden ba\u015Flat\u0131n.";
  }
  if (raw.includes("OPENAI_HTTP_400") || raw.includes("OPENAI_STT") || raw.includes("audio_too_short") || raw.includes("corrupted")) {
    return "Ses OpenAI STT taraf\u0131ndan reddedildi (\xE7ok k\u0131sa/zay\u0131f). Daha net ve biraz daha uzun konu\u015Fun; seviye %20+ olsun.";
  }
  if (raw.includes("OPENAI_HTTP_429")) {
    return "OpenAI kota/rate limit (429). Biraz bekleyip tekrar deneyin.";
  }
  if (raw.includes("PAYLOAD_TOO_LARGE") || raw.includes("HTTP_413")) {
    return "Ses paketi \xE7ok b\xFCy\xFCk. Daha k\u0131sa c\xFCmleler kurun.";
  }
  if (raw.includes("STT_")) return `STT hatas\u0131: ${raw}`;
  if (raw.includes("TTS_") || raw.includes("ELEVENLABS")) return `TTS hatas\u0131: ${raw}`;
  if (raw.includes("INTERNAL_ERROR") || raw.includes("INTERNAL ERROR")) {
    return "Sunucu tur hatas\u0131 (INTERNAL_ERROR). Bir c\xFCmle daha net konu\u015Fup tekrar deneyin; devam ederse sayfay\u0131 yenileyin.";
  }
  if (raw.includes("CALL_ALREADY_TERMINAL") || raw.includes("CALL_NOT_ACTIVE") || raw.includes("already_terminal")) {
    return "";
  }
  if (raw.startsWith("HTTP_")) return `Sunucu hatas\u0131: ${raw}. Sayfay\u0131 yenileyip tekrar deneyin.`;
  return raw;
};
var errMsg = (cause) => friendlyError(cause instanceof Error ? cause.message : "DEMO_OPERATION_FAILED");
var startDemo = async (input) => {
  input.setBusy(true);
  input.setError(void 0);
  input.setPhase("connecting");
  input.setHint("Oturum a\xE7\u0131l\u0131yor\u2026");
  input.vadEnabledRef.current = false;
  input.armCaptureRef.current = false;
  input.speechActiveRef.current = false;
  input.speechStartFramesRef.current = 0;
  input.pendingBargeInRef.current = false;
  try {
    const mic = await input.ensureMic();
    if (!mic) throw new Error("MICROPHONE_UNAVAILABLE");
    const call = await input.api.start({
      workspaceId: input.workspaceId,
      agentId: input.agentId,
      direction: "outbound",
      transport: "browser_demo",
      recordingConsent: true
    });
    input.setCall(call);
    input.callRef.current = call;
    input.setTurns([]);
    input.setPhase("speaking");
    input.setHint("Ajan selaml\u0131yor\u2026");
    if (input.listenMode === "continuous") {
      input.vadEnabledRef.current = true;
    }
    try {
      const greeting = await input.api.greeting(call.id);
      await input.playBase64Mp3(greeting.audio.audioBase64, input.audioPlayerRef);
    } catch (cause) {
      console.warn("browser-demo.greeting_failed", cause);
    }
    if (input.speechActiveRef.current || input.armCaptureRef.current) {
      return;
    }
    input.setPhase("active");
    if (input.listenMode === "continuous") {
      input.setHint(
        "S\xFCrekli dinle a\xE7\u0131k \u2014 do\u011Fal konu\u015Fun; sessizlik veya ~7 sn diliminde tur g\xF6nderilir."
      );
      input.vadEnabledRef.current = true;
    } else {
      input.setHint("Bas konu\u015F: butona bas\u0131l\u0131 tutun, konu\u015Fun, b\u0131rak\u0131nca ajan yan\u0131tlar.");
      input.vadEnabledRef.current = false;
    }
  } catch (cause) {
    input.setPhase("idle");
    input.setHint(void 0);
    input.setCall(void 0);
    input.callRef.current = void 0;
    input.vadEnabledRef.current = false;
    input.setError(errMsg(cause));
  } finally {
    input.setBusy(false);
  }
};
var hangupDemo = async (input) => {
  input.setBusy(true);
  try {
    input.vadEnabledRef.current = false;
    input.armCaptureRef.current = false;
    input.speechActiveRef.current = false;
    input.turnInFlightRef.current = false;
    input.pendingBargeInRef.current = false;
    input.audioPlayerRef.current?.pause();
    if (input.call && !["completed", "failed"].includes(input.call.status)) {
      try {
        await input.api.complete(input.call.id, "caller_hangup");
      } catch (cause) {
        const code = cause instanceof Error ? cause.message : "";
        if (!/CALL_ALREADY_TERMINAL|CALL_NOT_ACTIVE|already_terminal|HTTP_409/i.test(code)) {
          throw cause;
        }
      }
    }
    input.setCall(void 0);
    input.setPhase("idle");
    input.setHint("Demo g\xF6r\xFC\u015Fme kapand\u0131.");
    input.stopMeter();
  } catch (cause) {
    const code = cause instanceof Error ? cause.message : "";
    if (/CALL_ALREADY_TERMINAL|CALL_NOT_ACTIVE|already_terminal|HTTP_409/i.test(code)) {
      input.setCall(void 0);
      input.setPhase("idle");
      input.setHint("Demo g\xF6r\xFC\u015Fme kapand\u0131.");
      input.stopMeter();
    } else {
      input.setError(errMsg(cause));
      input.setPhase("idle");
      input.stopMeter();
    }
  } finally {
    input.setBusy(false);
  }
};

// src/playbook-flow.tsx
import { useMemo } from "react";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var PLAYBOOK_STEP_KIND_LABEL = {
  message: "Message",
  question: "Question",
  branch: "Branch",
  end: "End",
  handoff: "Handoff",
  lead: "Lead",
  appointment: "Appointment"
};
var NODE_W = 200;
var NODE_H = 72;
var GAP_Y = 48;
var PAD_X = 40;
var PAD_Y = 24;
var COL_GAP = 28;
var stepPreview = (step) => {
  switch (step.kind) {
    case "message":
    case "question":
      return step.text;
    case "branch":
      return step.prompt;
    case "end":
      return step.text?.trim() || "End";
    case "handoff":
      return step.reason?.trim() || "Handoff";
    case "lead":
      return step.note?.trim() || "Lead";
    case "appointment":
      return step.note?.trim() || "Appointment";
    default:
      return "";
  }
};
var layoutPlaybookFlow = (steps) => {
  const idToIndex = new Map(steps.map((s, i) => [s.id, i]));
  const positions = /* @__PURE__ */ new Map();
  steps.forEach((step, index) => {
    positions.set(step.id, {
      x: PAD_X,
      y: PAD_Y + index * (NODE_H + GAP_Y)
    });
  });
  const edges = [];
  steps.forEach((step, index) => {
    const isTerminal = step.kind === "end" || step.kind === "handoff";
    if (step.kind === "branch") {
      step.options.forEach((opt, oi) => {
        const targetId = opt.nextStepId && idToIndex.has(opt.nextStepId) ? opt.nextStepId : steps[index + 1]?.id;
        if (!targetId) return;
        const usedId = Boolean(opt.nextStepId && idToIndex.has(opt.nextStepId));
        edges.push({
          id: `${step.id}-opt${oi}-${targetId}`,
          fromId: step.id,
          toId: targetId,
          label: opt.label,
          dashed: !usedId
        });
      });
      return;
    }
    if (isTerminal) return;
    const next = steps[index + 1];
    if (!next) return;
    edges.push({
      id: `${step.id}->${next.id}`,
      fromId: step.id,
      toId: next.id
    });
  });
  const height = PAD_Y * 2 + Math.max(steps.length, 1) * (NODE_H + GAP_Y) - GAP_Y;
  const width = PAD_X * 2 + NODE_W + COL_GAP;
  return { positions, edges, width, height };
};
var edgePath = (from, to, offsetIndex) => {
  const x1 = from.x + NODE_W / 2;
  const y1 = from.y + NODE_H;
  const x2 = to.x + NODE_W / 2;
  const y2 = to.y;
  const midY = (y1 + y2) / 2;
  const bow = (offsetIndex - 1) * 18;
  return `M ${x1} ${y1} C ${x1 + bow} ${midY}, ${x2 + bow} ${midY}, ${x2} ${y2}`;
};
var PlaybookFlowCanvas = ({
  steps,
  selectedStepId,
  onSelectStep,
  t
}) => {
  const layout = useMemo(() => layoutPlaybookFlow(steps), [steps]);
  if (steps.length === 0) {
    return /* @__PURE__ */ jsx3("p", { className: "numbers-empty", children: t("No playbook steps yet. Add a step or load the starter.") });
  }
  const bowByEdgeId = /* @__PURE__ */ new Map();
  {
    const counts = /* @__PURE__ */ new Map();
    for (const e of layout.edges) {
      const n = counts.get(e.fromId) ?? 0;
      bowByEdgeId.set(e.id, n);
      counts.set(e.fromId, n + 1);
    }
  }
  return /* @__PURE__ */ jsx3("div", { className: "alx-playbook-flow", role: "region", "aria-label": t("Playbook flow"), children: /* @__PURE__ */ jsxs3(
    "div",
    {
      className: "alx-playbook-flow-stage",
      style: { width: layout.width, minHeight: layout.height },
      children: [
        /* @__PURE__ */ jsxs3(
          "svg",
          {
            className: "alx-playbook-flow-edges",
            width: layout.width,
            height: layout.height,
            "aria-hidden": true,
            children: [
              layout.edges.map((edge) => {
                const from = layout.positions.get(edge.fromId);
                const to = layout.positions.get(edge.toId);
                if (!from || !to) return null;
                const bow = bowByEdgeId.get(edge.id) ?? 0;
                const d = edgePath(from, to, bow);
                const midX = (from.x + to.x) / 2 + NODE_W / 2 + (bow - 1) * 18;
                const midY = (from.y + NODE_H + to.y) / 2;
                return /* @__PURE__ */ jsxs3("g", { children: [
                  /* @__PURE__ */ jsx3(
                    "path",
                    {
                      d,
                      className: edge.dashed ? "alx-playbook-flow-edge is-dashed" : "alx-playbook-flow-edge",
                      fill: "none",
                      markerEnd: "url(#alx-pb-arrow)"
                    }
                  ),
                  edge.label ? /* @__PURE__ */ jsx3("text", { x: midX + 8, y: midY, className: "alx-playbook-flow-edge-label", children: edge.label.length > 18 ? `${edge.label.slice(0, 16)}\u2026` : edge.label }) : null
                ] }, edge.id);
              }),
              /* @__PURE__ */ jsx3("defs", { children: /* @__PURE__ */ jsx3(
                "marker",
                {
                  id: "alx-pb-arrow",
                  viewBox: "0 0 10 10",
                  refX: "8",
                  refY: "5",
                  markerWidth: "6",
                  markerHeight: "6",
                  orient: "auto-start-reverse",
                  children: /* @__PURE__ */ jsx3("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: "#94a3b8" })
                }
              ) })
            ]
          }
        ),
        steps.map((step, index) => {
          const pos = layout.positions.get(step.id);
          if (!pos) return null;
          const selected = selectedStepId === step.id;
          return /* @__PURE__ */ jsxs3(
            "button",
            {
              type: "button",
              className: selected ? "alx-playbook-flow-node is-selected" : "alx-playbook-flow-node",
              style: { left: pos.x, top: pos.y, width: NODE_W, minHeight: NODE_H },
              onClick: () => onSelectStep(step.id),
              children: [
                /* @__PURE__ */ jsxs3("span", { className: "alx-playbook-flow-node-kind", children: [
                  index + 1,
                  ". ",
                  PLAYBOOK_STEP_KIND_LABEL[step.kind]
                ] }),
                /* @__PURE__ */ jsx3("span", { className: "alx-playbook-flow-node-id", children: step.id }),
                /* @__PURE__ */ jsx3("span", { className: "alx-playbook-flow-node-preview", children: stepPreview(step) })
              ]
            },
            step.id
          );
        })
      ]
    }
  ) });
};

// src/problem-error.ts
var trustOperatorFallback = (code) => {
  switch (code) {
    case "TRUST_PURPOSE_NOT_ALLOWED":
      return "Platform numaras\u0131nda bu arama amac\u0131 izinli de\u011Fil. Onayl\u0131 \u015Fablon (sales/general/support) se\xE7in veya kendi (BYO) hatt\u0131n\u0131z\u0131 kullan\u0131n.";
    case "TRUST_CUSTOM_PURPOSE_BLOCKED":
      return "Platform hatt\u0131nda \xF6zel (custom) ama\xE7 kapal\u0131. Sales / general / support se\xE7in veya BYO numara kullan\u0131n.";
    case "TRUST_FREEFORM_NOTE_BLOCKED":
      return "Platform hatt\u0131nda marketing \u015Fablonunda serbest ama\xE7 notu / AI script kapal\u0131. \xC7\xF6z\xFCm: (1) Ama\xE7 notunu silin, (2) Amac\u0131 sales/general/support yap\u0131n, veya (3) Kendi BYO numaran\u0131z\u0131 kullan\u0131n.";
    case "TRUST_DENYLIST_HIT":
      return "Ama\xE7 notu yasakl\u0131 ifade i\xE7eriyor. Notu sadele\u015Ftirin veya BYO hat kullan\u0131n.";
    case "TRUST_DNC_BLOCKED":
      return "Hedef numara aranmaz (DNC) listesinde. Listeden \xE7\u0131kar\u0131n veya ba\u015Fka numara aray\u0131n.";
    case "TRUST_WARMUP_CAP":
      return "Platform numara g\xFCnl\xFCk warm-up dakikas\u0131 doldu. Yar\u0131n tekrar deneyin veya BYO hat kullan\u0131n.";
    case "TRUST_SPEECH_BLOCKED":
      return "Ajan yan\u0131t\u0131 yasakl\u0131 ifade i\xE7erdi\u011Fi i\xE7in ses engellendi. Prompt/scripti g\xF6zden ge\xE7irin.";
    case "RECORDING_NOT_PLAYABLE":
      return "Bu kay\u0131t dinlenemez (softphone/provider yer tutucu). Ger\xE7ek hat (PSTN) kay\u0131tlar\u0131 MinIO/S3\u2019te oynat\u0131l\u0131r.";
    case "RECORDING_NOT_AVAILABLE":
      return "Kay\u0131t hen\xFCz haz\u0131r de\u011Fil veya bu aramada kay\u0131t yok.";
    case "RECORDING_NOT_FOUND":
      return "Kay\u0131t dosyas\u0131 depoda bulunamad\u0131. Ar\u015Fiv silinmi\u015F veya y\xFCkleme tamamlanmam\u0131\u015F olabilir.";
    case "RECORDING_READ_UNSUPPORTED":
      return "Kay\u0131t okuma bu ortamda desteklenmiyor.";
    case "VOICE_NOT_ENTITLED":
      return "Plan\u0131n\u0131zda CenterOS sesli arama yok. Plan\u0131 y\xFCkseltin.";
    case "VOICE_MINUTES_EXCEEDED":
      return "Plan ses dakikas\u0131 limiti doldu.";
    case "VOICE_CONCURRENT_EXCEEDED":
      return "Maksimum e\u015Fzamanl\u0131 CenterOS arama say\u0131s\u0131na ula\u015F\u0131ld\u0131. Bitmi\u015F aramalar\u0131n kapanmas\u0131n\u0131 bekleyin.";
    case "INSUFFICIENT_CREDITS":
      return "Sesli arama i\xE7in kredi yetersiz.";
    case "PRINCIPAL_NOT_FOUND":
      return "Oturum kimli\u011Fi faturalama hesab\u0131na e\u015Flenemedi. Sayfay\u0131 yenileyip tekrar giri\u015F yap\u0131n.";
    case "BILLING_UNAVAILABLE":
      return "Fatura k\xF6pr\xFCs\xFCne ula\u015F\u0131lamad\u0131. K\u0131sa s\xFCre sonra tekrar deneyin.";
    case "HARD_QUOTA_EXCEEDED":
      return "Workspace ses kullan\u0131m kotas\u0131 a\u015F\u0131ld\u0131.";
    case "INTERVIEW_PROVIDER_DISABLED":
      return "CenterOS Agent g\xF6r\xFC\u015Fmesi YZ Ayarlar\u0131'nda durdurulmu\u015F. \xD6nce CenterOS Agent i\u015F y\xFCk\xFCn\xFC a\xE7\u0131n.";
    case "INTERVIEW_RATE_LIMITED":
      return "AI istek limiti doldu. Birka\xE7 saniye bekleyip tekrar g\xF6nderin veya YZ Ayarlar\u0131 \u2192 CenterOS Agent modelini GLM-5.2 yap\u0131n.";
    case "INTERVIEW_PROVIDER_FAILED":
      return "AI yan\u0131t vermedi. Birka\xE7 saniye sonra tekrar deneyin veya YZ Ayarlar\u0131'nda CenterOS Agent sat\u0131r\u0131n\u0131 kontrol edin.";
    case "INTERVIEW_INVALID_RESULT":
      return "AI ge\xE7ersiz yan\u0131t verdi. Cevab\u0131 tekrar g\xF6nderin.";
    case "SUBSCRIPTION_INACTIVE":
      return "Abonelik aktif de\u011Fil.";
    case "VOICE_BILLING_DENIED":
      return "Sesli arama faturalama taraf\u0131ndan reddedildi.";
    default:
      if (code.startsWith("TRUST_")) {
        return `G\xFCven politikas\u0131 aramay\u0131 engelledi (${code}).`;
      }
      if (code.startsWith("RECORDING_")) {
        return `Kay\u0131t hatas\u0131: ${code}`;
      }
      if (code.startsWith("VOICE_") || code.startsWith("BILLING_") || code === "PRINCIPAL_NOT_FOUND") {
        return `Fatura / arama yetkisi: ${code}`;
      }
      return null;
  }
};
var formatProblemError = (body, status = 0) => {
  const code = (body.code ?? body.message ?? (status ? `HTTP_${status}` : "REQUEST_FAILED")).trim();
  const detail = (body.detail ?? body.title ?? "").trim();
  if (code === "SESSION_EXPIRED" || code === "SESSION_NOT_ACTIVE" || status === 401) {
    return "SESSION_EXPIRED: Oturum s\xFCresi doldu. Sayfay\u0131 yenileyin (Ctrl+Shift+R) ve tekrar giri\u015F yap\u0131n.";
  }
  const trustFallback = trustOperatorFallback(code);
  if (trustFallback) {
    if (detail && detail !== code && !/^TRUST_[A-Z0-9_]+$/u.test(detail) && !isGenericProblemTitle(detail)) {
      return detail.startsWith(code) ? detail : detail;
    }
    return trustFallback;
  }
  if (detail && detail !== code && !isGenericProblemTitle(detail)) {
    if (detail.includes(code)) return detail;
    if (/^[A-Z][A-Z0-9_]{3,}$/u.test(code)) {
      return detail;
    }
    return `${code}: ${detail}`;
  }
  if (isGenericProblemTitle(detail) || !detail) {
    const billingFallback = trustOperatorFallback(code);
    if (billingFallback) return billingFallback;
  }
  return code || "REQUEST_FAILED";
};
var isGenericProblemTitle = (value) => {
  const v = value.trim().toLowerCase();
  return v === "billing state conflict" || v === "voice billing denied" || v === "voice billing principal not found" || v === "voice billing bridge unavailable" || v === "usage quota exceeded" || v === "subscription inactive" || v === "request failed" || v === "resource not found" || v === "internal server error";
};
var throwProblemError = async (response) => {
  const body = await response.json().catch(() => ({}));
  throw new Error(formatProblemError(body, response.status));
};

// src/agent.tsx
import {
  AGENT_LLM_MODEL_OPTIONS,
  AGENT_REALTIME_MODEL_OPTIONS,
  AGENT_STT_MODEL_OPTIONS,
  AGENT_STT_PROVIDER_OPTIONS,
  AGENT_VOICE_RUNTIME_OPTIONS,
  PERSONALITY_PRESETS,
  agentListSchema,
  agentLlmModelSchema,
  agentPlaybookSchema,
  agentRealtimeModelSchema,
  agentSttModelSchema,
  agentSttProviderSchema,
  agentTemplateListSchema,
  agentViewSchema,
  agentVoiceRuntimeSchema,
  agentWidgetConfigSchema,
  buildWebchatEmbedSnippet,
  capabilitiesFromTools,
  defaultAgentWidgetConfig,
  defaultInboundPlaybook,
  interviewAgentTurnResponseSchema,
  isWhatsAppMessagingConnectorTool,
  listNamedVoiceProfiles,
  personalityPresetIdSchema,
  CONVERSATION_STYLE_OPTIONS,
  simulateScenarioResponseSchema,
  DEFAULT_VOICE_KNOWLEDGE_DEPTH,
  VOICE_KNOWLEDGE_DEPTH_OPTIONS,
  profileTtsVoiceId,
  providerVoiceCatalogSchema,
  publishAgentResponseSchema,
  resolveNamedVoiceProfile,
  resolveNamedVoiceProfileByProviderVoice,
  resolvePersonalityPreset,
  runtimeResponseSchema,
  toolsFromCapabilities,
  voicePreviewResponseSchema,
  webchatSessionResponseSchema,
  workspaceAmbienceAssetSchema,
  workspaceAmbienceListSchema
} from "@agentos/contracts";
import { Fragment as Fragment3, jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var voiceOptions = listNamedVoiceProfiles();
var INLINE_KNOWLEDGE_MAX = 5e4;
var brainOptionLabel = (b) => b.publishedVersion != null ? `${b.name} \xB7 v${b.publishedVersion}` : b.name;
var firstPublishedBrainId = (options) => options.find((b) => b.publishedVersion != null)?.id ?? "";
var CATEGORY_META = {
  receptionist: { label: "Receptionist", icon: "\u260E" },
  lead_qualification: { label: "Lead Qualification", icon: "\u25CE" },
  appointment: { label: "Appointment", icon: "\u{1F4C5}" },
  support: { label: "Support", icon: "\u{1F4AC}" },
  sales_outbound: { label: "Outbound Sales", icon: "\u{1F4C8}" },
  survey: { label: "Survey", icon: "\u2605" },
  collections: { label: "Collections", icon: "\u{1F4B3}" },
  event: { label: "Events", icon: "\u{1F39F}" },
  general: { label: "General", icon: "\u2726" }
};
var typeBadge = (agent) => {
  const mode = agent.config?.channelMode ?? "omni";
  if (mode === "inbound") return { label: "Incoming", kind: "incoming" };
  if (mode === "outbound") return { label: "Outgoing", kind: "outgoing" };
  if (mode === "webchat") return { label: "Webchat", kind: "webchat" };
  return { label: "Omni", kind: "omni" };
};
var voiceLine = (agent) => {
  const v = agent.config?.voice;
  if (!v) return "Voice not set";
  const profile = v.profileId ? resolveNamedVoiceProfile(v.profileId) : resolveNamedVoiceProfileByProviderVoice(v.voiceId);
  return `${profile.label} \xB7 ${v.language || profile.locale}`;
};
var promptPreview = (agent) => {
  const cfg = agent.config;
  if (!cfg) return "Configuration incomplete \u2014 open to finish setup.";
  const text = [cfg.instructions, cfg.firstMessage, cfg.persona, cfg.role].filter(Boolean).join(" ");
  return text.length > 160 ? `${text.slice(0, 160).trim()}\u2026` : text;
};
var DEMO_OR_INCOMPLETE_NAME_RE = /Blank QA|Wizard QA|incomplete/i;
var isDemoOrIncompleteAgent = (agent) => DEMO_OR_INCOMPLETE_NAME_RE.test(agent.name) || !agent.config;
var supportedVoiceProfileId = (profileId, voiceId) => {
  if (profileId && voiceOptions.some((p) => p.id === profileId)) return profileId;
  return resolveNamedVoiceProfileByProviderVoice(voiceId).id;
};
var createAgentApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const request = async (path, init, timeoutMs = 12e3) => {
    const response = await fetch(`${base}${path}`, {
      ...init,
      headers: {
        Authorization: `Bearer ${token}`,
        ...init?.body ? { "Content-Type": "application/json" } : {}
      },
      signal: AbortSignal.timeout(timeoutMs)
    });
    if (!response.ok) {
      await throwProblemError(response);
    }
    return response.json();
  };
  return {
    list: async (workspaceId) => agentListSchema.parse(
      await request(`/v1/agents?workspaceId=${encodeURIComponent(workspaceId)}`)
    ),
    listTemplates: async (category) => agentTemplateListSchema.parse(
      await request(
        category ? `/v1/agents/templates?category=${encodeURIComponent(category)}` : "/v1/agents/templates"
      )
    ),
    create: async (workspaceId, name, options) => agentViewSchema.parse(
      await request("/v1/agents", {
        method: "POST",
        body: JSON.stringify({
          workspaceId,
          name,
          ...options?.templateId ? { templateId: options.templateId } : {},
          ...options?.brainId ? { brainId: options.brainId } : {}
        })
      })
    ),
    update: async (agentId, input) => agentViewSchema.parse(
      await request(`/v1/agents/${encodeURIComponent(agentId)}/draft`, {
        method: "PUT",
        body: JSON.stringify({
          ...input,
          modelPolicy: "grounded-default",
          allowedTools: input.allowedTools,
          handoffEnabled: input.handoffEnabled ?? true,
          maxResponseCharacters: 2e3
        })
      })
    ),
    publish: async (agentId, expectedDraftVersion) => publishAgentResponseSchema.parse(
      await request(`/v1/agents/${encodeURIComponent(agentId)}/publish`, {
        method: "POST",
        body: JSON.stringify({ expectedDraftVersion })
      })
    ),
    remove: async (agentId) => await request(`/v1/agents/${encodeURIComponent(agentId)}`, {
      method: "DELETE"
    }),
    interview: async (input) => interviewAgentTurnResponseSchema.parse(
      await request("/v1/agents/interview", {
        method: "POST",
        body: JSON.stringify(input)
      }, 35e3)
    ),
    simulate: async (agentId, message3, clientMessageId, conversationId) => runtimeResponseSchema.parse(
      await request(`/v1/agents/${encodeURIComponent(agentId)}/simulate`, {
        method: "POST",
        body: JSON.stringify({ message: message3, clientMessageId, conversationId })
      })
    ),
    simulateScenario: async (agentId, turns, conversationId) => simulateScenarioResponseSchema.parse(
      await request(
        `/v1/agents/${encodeURIComponent(agentId)}/simulate-scenario`,
        {
          method: "POST",
          body: JSON.stringify({ turns: [...turns], conversationId })
        },
        12e4
      )
    ),
    previewVoice: async (input) => voicePreviewResponseSchema.parse(
      await request("/v1/voices/preview", {
        method: "POST",
        body: JSON.stringify(input)
      })
    ),
    listVoices: async () => providerVoiceCatalogSchema.parse(await request("/v1/voices")),
    listAmbience: async (workspaceId) => workspaceAmbienceListSchema.parse(
      await request(`/v1/workspaces/${encodeURIComponent(workspaceId)}/ambience`)
    ).items,
    uploadAmbience: async (workspaceId, input) => workspaceAmbienceAssetSchema.parse(
      await request(
        `/v1/workspaces/${encodeURIComponent(workspaceId)}/ambience`,
        {
          method: "POST",
          body: JSON.stringify({ workspaceId, ...input })
        },
        6e4
      )
    ),
    deleteAmbience: async (workspaceId, assetId) => {
      const result = await request(
        `/v1/workspaces/${encodeURIComponent(workspaceId)}/ambience/${encodeURIComponent(assetId)}`,
        { method: "DELETE" }
      );
      return result;
    },
    previewAmbience: async (workspaceId, assetId) => {
      const response = await fetch(
        `${base}/v1/workspaces/${encodeURIComponent(workspaceId)}/ambience/${encodeURIComponent(assetId)}/preview`,
        {
          headers: { Authorization: `Bearer ${token}` },
          signal: AbortSignal.timeout(15e3)
        }
      );
      if (!response.ok) await throwProblemError(response);
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    }
  };
};
var parseAmbienceBedId = (raw) => {
  const value = raw.trim();
  if (value === "none" || value === "office") return value;
  if (/^custom:[a-zA-Z0-9_-]{6,64}$/u.test(value)) return value;
  return "office";
};
var customAmbienceAssetId = (bedId) => {
  const match = /^custom:([a-zA-Z0-9_-]{6,64})$/u.exec(bedId.trim());
  return match?.[1] ?? null;
};
var fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const text = String(reader.result ?? "");
    const comma = text.indexOf(",");
    resolve(comma >= 0 ? text.slice(comma + 1) : text);
  };
  reader.onerror = () => reject(new Error("AMBIENCE_READ_FAILED"));
  reader.readAsDataURL(file);
});
var sharedPreviewAudio = null;
var sharedPreviewSettle = null;
var previewGeneration = 0;
var stopSharedPreview = () => {
  if (sharedPreviewAudio) {
    sharedPreviewAudio.onended = null;
    sharedPreviewAudio.onerror = null;
    try {
      sharedPreviewAudio.pause();
      sharedPreviewAudio.removeAttribute("src");
      sharedPreviewAudio.load();
    } catch {
    }
    sharedPreviewAudio = null;
  }
  if (typeof window !== "undefined" && "speechSynthesis" in window) {
    window.speechSynthesis.cancel();
  }
  if (sharedPreviewSettle) {
    const settle = sharedPreviewSettle;
    sharedPreviewSettle = null;
    settle();
  }
};
var stopVoicePreview = (setPlayingId) => {
  previewGeneration += 1;
  stopSharedPreview();
  setPlayingId(void 0);
};
var STATIC_VOICE_SAMPLE_URLS = (profileId) => {
  const id = encodeURIComponent(profileId);
  const origin = typeof window !== "undefined" && window.location.hostname.endsWith("panaryus.com") ? "https://panaryus.com" : "";
  return [
    `/voice-samples/${id}.mp3`,
    `/vendor/centeros/voice-samples/${id}.mp3`,
    `${origin}/vendor/centeros/voice-samples/${id}.mp3`
  ].filter((u, i, arr) => u && arr.indexOf(u) === i);
};
var BROWSER_SPEECH_STYLE = {
  tr_female_warm: {
    pitch: 1.2,
    rate: 0.95,
    text: "Merhaba, ben s\u0131cak ve samimi asistan\u0131n\u0131z\u0131m. Size nas\u0131l yard\u0131mc\u0131 olabilirim?"
  },
  tr_female_corporate: {
    pitch: 1.05,
    rate: 1,
    text: "Merhaba, ben kurumsal destek asistan\u0131n\u0131z\u0131m. Size nas\u0131l yard\u0131mc\u0131 olabilirim?"
  },
  tr_female_clear: {
    pitch: 1.28,
    rate: 1.08,
    text: "Merhaba, ben net ve canl\u0131 asistan\u0131n\u0131z\u0131m. Size nas\u0131l yard\u0131mc\u0131 olabilirim?"
  },
  tr_female_soft: {
    pitch: 1.12,
    rate: 0.88,
    text: "Merhaba, ben yumu\u015Fak sesli asistan\u0131n\u0131z\u0131m. Size nas\u0131l yard\u0131mc\u0131 olabilirim?"
  },
  tr_male_professional: {
    pitch: 0.78,
    rate: 0.98,
    text: "Merhaba, ben profesyonel asistan\u0131n\u0131z\u0131m. Size nas\u0131l yard\u0131mc\u0131 olabilirim?"
  },
  tr_male_calm: {
    pitch: 0.7,
    rate: 0.85,
    text: "Merhaba, ben sakin ve net asistan\u0131n\u0131z\u0131m. Size nas\u0131l yard\u0131mc\u0131 olabilirim?"
  },
  tr_male_clear: {
    pitch: 0.85,
    rate: 1.05,
    text: "Merhaba, ben net erkek asistan\u0131n\u0131z\u0131m. Size nas\u0131l yard\u0131mc\u0131 olabilirim?"
  }
};
var playHtmlAudio = (url, setPlayingId, revoke = false) => new Promise((resolve, reject) => {
  stopSharedPreview();
  const audio = new Audio(url);
  sharedPreviewAudio = audio;
  const finish = (ok, err) => {
    if (revoke) URL.revokeObjectURL(url);
    if (sharedPreviewAudio === audio) sharedPreviewAudio = null;
    sharedPreviewSettle = null;
    setPlayingId(void 0);
    if (ok) resolve();
    else reject(err ?? new Error("AUDIO_PLAY_FAILED"));
  };
  sharedPreviewSettle = () => finish(true);
  audio.onended = () => finish(true);
  audio.onerror = () => finish(false, new Error("AUDIO_PLAY_FAILED"));
  void audio.play().catch((err) => {
    finish(false, err instanceof Error ? err : new Error("AUDIO_PLAY_FAILED"));
  });
});
var playBrowserSpeechFallback = async (profileId, setPlayingId) => {
  if (typeof window === "undefined" || !("speechSynthesis" in window)) {
    throw new Error("VOICE_PREVIEW_UNAVAILABLE");
  }
  await new Promise((resolve) => {
    const existing = window.speechSynthesis.getVoices();
    if (existing.length > 0) {
      resolve();
      return;
    }
    const timer = window.setTimeout(() => resolve(), 600);
    window.speechSynthesis.onvoiceschanged = () => {
      window.clearTimeout(timer);
      resolve();
    };
  });
  const profile = resolveNamedVoiceProfile(profileId);
  const style = BROWSER_SPEECH_STYLE[profileId] ?? {
    pitch: profile.gender === "female" ? 1.15 : 0.8,
    rate: 1,
    text: profile.locale.toLowerCase().startsWith("tr") ? "Merhaba, ben sizin dijital asistan\u0131n\u0131z\u0131m. Size nas\u0131l yard\u0131mc\u0131 olabilirim?" : "Hello, I am your digital assistant. How can I help you today?"
  };
  const utter = new SpeechSynthesisUtterance(style.text);
  utter.lang = profile.locale.startsWith("tr") ? "tr-TR" : "en-US";
  utter.pitch = style.pitch;
  utter.rate = style.rate;
  const voices = window.speechSynthesis.getVoices();
  const preferFemale = profile.gender === "female";
  const langVoices = voices.filter(
    (v) => v.lang.toLowerCase().startsWith(utter.lang.slice(0, 2).toLowerCase())
  );
  const gendered = langVoices.filter(
    (v) => preferFemale ? /female|woman|zira|filiz|yelda|emel|aylin/i.test(v.name) || !/male|man|david|ahmet/i.test(v.name) : /male|man|david|mark|ahmet|tolga/i.test(v.name)
  );
  const pool = gendered.length > 0 ? gendered : langVoices.length > 0 ? langVoices : voices;
  let hash = 0;
  for (let i = 0; i < profileId.length; i += 1) hash = hash * 31 + profileId.charCodeAt(i) >>> 0;
  if (pool.length > 0) utter.voice = pool[hash % pool.length];
  stopSharedPreview();
  await new Promise((resolve, reject) => {
    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      sharedPreviewSettle = null;
      setPlayingId(void 0);
      if (ok) resolve();
      else reject(new Error("SPEECH_SYNTHESIS_FAILED"));
    };
    sharedPreviewSettle = () => finish(true);
    utter.onend = () => finish(true);
    utter.onerror = () => finish(false);
    window.speechSynthesis.speak(utter);
  });
};
var playVoicePreview = async (api, target, setBusy, setError, setPlayingId, setNotice) => {
  const gen = previewGeneration += 1;
  setError(void 0);
  setNotice?.(void 0);
  stopSharedPreview();
  setPlayingId(target.playKey);
  setBusy(true);
  const stillActive = () => gen === previewGeneration;
  try {
    try {
      const sample = await api.previewVoice({
        ...target.profileId ? { profileId: target.profileId } : {},
        ...target.voiceId ? { voiceId: target.voiceId } : {}
      });
      if (!stillActive()) return;
      const binary = atob(sample.audioBase64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
      const blob = new Blob([bytes], { type: sample.contentType });
      const url = URL.createObjectURL(blob);
      setBusy(false);
      await playHtmlAudio(url, setPlayingId, true);
      return;
    } catch {
    }
    if (!stillActive()) return;
    if (target.profileId) {
      for (const staticUrl of STATIC_VOICE_SAMPLE_URLS(target.profileId)) {
        if (!stillActive()) return;
        try {
          const head = await fetch(staticUrl, { method: "GET", cache: "force-cache" });
          if (!stillActive()) return;
          if (!head.ok) continue;
          const buf = await head.arrayBuffer();
          if (!stillActive()) return;
          if (buf.byteLength > 1e3) {
            setBusy(false);
            await playHtmlAudio(staticUrl, setPlayingId);
            if (stillActive()) {
              setNotice?.("Canl\u0131 TTS yan\u0131t vermedi; statik \xF6rnek \xE7al\u0131nd\u0131.");
            }
            return;
          }
        } catch {
        }
      }
    }
    if (!stillActive()) return;
    setBusy(false);
    await playBrowserSpeechFallback(target.profileId ?? "tr_female_warm", setPlayingId);
    if (stillActive()) {
      setNotice?.(
        "Canl\u0131 TTS kota/anahtar nedeniyle kullan\u0131lamad\u0131. Statik \xF6rnek veya taray\u0131c\u0131 sesi \xE7al\u0131nd\u0131."
      );
    }
  } catch (cause) {
    if (stillActive()) {
      setPlayingId(void 0);
      setError(errorMessage(cause));
    }
  } finally {
    setBusy(false);
  }
};
var toggleVoicePreview = (api, target, playingId, setBusy, setError, setPlayingId, setNotice) => {
  if (playingId === target.playKey) {
    stopVoicePreview(setPlayingId);
    return;
  }
  void playVoicePreview(api, target, setBusy, setError, setPlayingId, setNotice);
};
var purposeFromAgentTemplate = (agent) => {
  const tpl = (agent.config?.templateId ?? "").toLowerCase();
  const mode = agent.config?.channelMode ?? "omni";
  if (tpl.includes("support") || tpl.includes("tech")) return "support";
  if (tpl.includes("sales") || tpl.includes("lead") || tpl.includes("outbound") || tpl.includes("appointment") || tpl.includes("qualification")) {
    return "sales";
  }
  if (tpl.includes("callback") || tpl.includes("payment") || tpl.includes("nps")) {
    return "callback";
  }
  if (mode === "outbound") return "sales";
  if (mode === "inbound") return "general";
  return "general";
};
var PURPOSE_OPTIONS_SAFE = [
  { id: "sales", label: "Sat\u0131\u015F (script OK)" },
  { id: "general", label: "Genel" },
  { id: "support", label: "Destek" },
  { id: "callback", label: "Geri arama" }
  // marketing intentionally omitted from default dial UI (platform freeform note blocked)
];
var AgentOutboundCallPanel = ({
  agent,
  workspaceId,
  voiceApi,
  contactsApi,
  numbers,
  t,
  onOpenDirectory,
  onOpenNumbers
}) => {
  const templatePurpose = useMemo2(() => purposeFromAgentTemplate(agent), [agent]);
  const dialableNumbers = useMemo2(
    () => numbers.filter(
      (n) => n.status === "active" && (n.numberClass === "platform_external" || n.numberClass === "customer_byo")
    ),
    [numbers]
  );
  const [contacts, setContacts] = useState3([]);
  const [loadError, setLoadError] = useState3();
  const [contactSearch, setContactSearch] = useState3("");
  const [selectedContactId, setSelectedContactId] = useState3("");
  const [manualTo, setManualTo] = useState3("");
  const [numberId, setNumberId] = useState3("");
  const [purpose, setPurpose] = useState3(templatePurpose);
  const [purposeNote, setPurposeNote] = useState3("");
  const [consent, setConsent] = useState3(true);
  const [callBusy, setCallBusy] = useState3(false);
  const [callError, setCallError] = useState3();
  const [callNotice, setCallNotice] = useState3();
  useEffect3(() => {
    setPurpose(templatePurpose);
  }, [templatePurpose, agent.id]);
  useEffect3(() => {
    if (dialableNumbers.length === 0) return;
    if (!numberId || !dialableNumbers.some((n) => n.id === numberId)) {
      setNumberId(dialableNumbers[0].id);
    }
  }, [dialableNumbers, numberId]);
  useEffect3(() => {
    if (!contactsApi) return;
    let cancelled = false;
    void contactsApi.list(workspaceId).then((page) => {
      if (!cancelled) {
        setContacts(page.items.filter((c) => c.status === "active"));
        setLoadError(void 0);
      }
    }).catch((cause) => {
      if (!cancelled) {
        setLoadError(cause instanceof Error ? cause.message : "CONTACTS_LOAD_FAILED");
      }
    });
    return () => {
      cancelled = true;
    };
  }, [contactsApi, workspaceId]);
  const filteredContacts = useMemo2(() => {
    const q = contactSearch.trim().toLocaleLowerCase("tr-TR");
    if (!q) return contacts;
    return contacts.filter((c) => {
      const hay = `${c.displayName} ${c.phoneE164} ${c.company ?? ""}`.toLocaleLowerCase("tr-TR");
      return hay.includes(q);
    });
  }, [contacts, contactSearch]);
  const selectedContact = useMemo2(
    () => contacts.find((c) => c.id === selectedContactId) ?? null,
    [contacts, selectedContactId]
  );
  const startOutbound = async () => {
    setCallBusy(true);
    setCallError(void 0);
    setCallNotice(void 0);
    try {
      if (!agent.publishedVersion) {
        throw new Error("PUBLISH_REQUIRED: \xD6nce ajan\u0131 kaydedip yay\u0131nlay\u0131n.");
      }
      if (!numberId) {
        throw new Error("NUMBER_REQUIRED: Giden hat se\xE7in (Numbers).");
      }
      const note = purpose === "marketing" ? null : purposeNote.trim() ? purposeNote.trim().slice(0, 1e3) : null;
      if (selectedContact && contactsApi) {
        const call2 = await contactsApi.call(selectedContact.id, {
          agentId: agent.id,
          numberId,
          purpose,
          // Always send explicit note (null when empty) so API does not fall back to
          // contact.defaultPurposeNote (wrong-brand SCRIPT).
          purposeNote: note,
          recordingConsent: consent,
          useBusinessBrain: false
        });
        setCallNotice(
          `Arama ba\u015Flad\u0131: ${call2.id} \u2192 ${selectedContact.displayName} (${call2.status})`
        );
        return;
      }
      if (!voiceApi) {
        throw new Error("VOICE_API_REQUIRED: Serbest numara i\xE7in voice API gerekir.");
      }
      const to = manualTo.trim();
      if (!/^\+[1-9]\d{7,14}$/u.test(to)) {
        throw new Error("TO_INVALID: E.164 girin (\xF6rn. +905551112233) veya rehberden se\xE7in.");
      }
      const call = await voiceApi.start({
        workspaceId,
        agentId: agent.id,
        direction: "outbound",
        numberId,
        to,
        recordingConsent: consent,
        purpose,
        purposeNote: note,
        useBusinessBrain: false
      });
      setCallNotice(`Arama ba\u015Flad\u0131: ${call.id} \u2192 ${to} (${call.status})`);
    } catch (cause) {
      setCallError(cause instanceof Error ? cause.message : "CALL_FAILED");
    } finally {
      setCallBusy(false);
    }
  };
  const tplLabel = agent.config?.templateId ? agent.config.templateId.replace(/^tpl_/u, "") : agent.config?.channelMode ?? "omni";
  return /* @__PURE__ */ jsxs4("div", { className: "alx-form-card alx-agent-call-panel", children: [
    /* @__PURE__ */ jsx4("h2", { children: t("Call with this agent") }),
    /* @__PURE__ */ jsxs4("p", { className: "alx-muted", children: [
      "Rehberden ki\u015Fi se\xE7in veya numara yaz\u0131n. Ama\xE7, ajan \u015Fablonuna g\xF6re \xF6nerilir (",
      /* @__PURE__ */ jsx4("code", { children: tplLabel }),
      " \u2192 ",
      /* @__PURE__ */ jsx4("b", { children: purpose }),
      ")."
    ] }),
    !agent.publishedVersion && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: t("Not published yet \u2014 save, then publish to go live") }),
    loadError && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: loadError }),
    callError && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: callError }),
    callNotice && /* @__PURE__ */ jsx4("div", { className: "studio-alert success", children: callNotice }),
    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
      /* @__PURE__ */ jsx4("span", { children: "Rehberde ara" }),
      /* @__PURE__ */ jsx4(
        "input",
        {
          type: "search",
          value: contactSearch,
          onChange: (e) => setContactSearch(e.target.value),
          placeholder: "\u0130sim, \u015Firket, telefon\u2026",
          disabled: !contactsApi
        }
      )
    ] }),
    contactsApi ? /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
      /* @__PURE__ */ jsxs4("span", { children: [
        "Ki\u015Fi (",
        filteredContacts.length,
        ")"
      ] }),
      /* @__PURE__ */ jsxs4(
        "select",
        {
          value: selectedContactId,
          onChange: (e) => {
            const id = e.target.value;
            setSelectedContactId(id);
            if (id) {
              setManualTo("");
              setPurposeNote("");
              setPurpose(templatePurpose);
            }
          },
          children: [
            /* @__PURE__ */ jsx4("option", { value: "", children: "\u2014 Rehberden se\xE7 \u2014" }),
            filteredContacts.map((c) => /* @__PURE__ */ jsxs4("option", { value: c.id, children: [
              c.displayName,
              " \xB7 ",
              c.phoneE164
            ] }, c.id))
          ]
        }
      ),
      filteredContacts.length === 0 && /* @__PURE__ */ jsxs4("small", { children: [
        "Rehber bo\u015F veya arama sonucu yok.",
        " ",
        onOpenDirectory && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-chip-btn", onClick: onOpenDirectory, children: "Rehber" })
      ] })
    ] }) : /* @__PURE__ */ jsx4("p", { className: "alx-muted", children: "Rehber API yok \u2014 serbest numara ile aray\u0131n veya Directory yetkisini a\xE7\u0131n." }),
    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
      /* @__PURE__ */ jsx4("span", { children: "Veya serbest numara (E.164)" }),
      /* @__PURE__ */ jsx4(
        "input",
        {
          type: "tel",
          value: manualTo,
          onChange: (e) => {
            setManualTo(e.target.value);
            if (e.target.value.trim()) setSelectedContactId("");
          },
          placeholder: "+905551112233",
          disabled: Boolean(selectedContactId)
        }
      )
    ] }),
    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
      /* @__PURE__ */ jsx4("span", { children: "Giden hat (CLI)" }),
      dialableNumbers.length > 0 ? /* @__PURE__ */ jsx4("select", { value: numberId, onChange: (e) => setNumberId(e.target.value), children: dialableNumbers.map((n) => /* @__PURE__ */ jsxs4("option", { value: n.id, children: [
        n.provider,
        " \xB7 ",
        n.label || n.e164Masked || n.e164,
        " (",
        n.numberClass,
        ")"
      ] }, n.id)) }) : /* @__PURE__ */ jsxs4("small", { children: [
        "Aktif platform/BYO hat yok.",
        " ",
        onOpenNumbers && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-chip-btn", onClick: onOpenNumbers, children: "Numbers" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
      /* @__PURE__ */ jsxs4("span", { children: [
        "Arama amac\u0131 (\u015Fablon \xF6nerisi: ",
        templatePurpose,
        ")"
      ] }),
      /* @__PURE__ */ jsx4(
        "select",
        {
          value: purpose,
          onChange: (e) => {
            const next = e.target.value;
            setPurpose(next);
            if (next === "marketing") setPurposeNote("");
          },
          children: PURPOSE_OPTIONS_SAFE.map((p) => /* @__PURE__ */ jsx4("option", { value: p.id, children: p.label }, p.id))
        }
      ),
      /* @__PURE__ */ jsx4("small", { children: "Platform hatta marketing + serbest not engellenir. Script i\xE7in sales kullan\u0131n." })
    ] }),
    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
      /* @__PURE__ */ jsx4("span", { children: "Ama\xE7 notu / k\u0131sa script (opsiyonel)" }),
      /* @__PURE__ */ jsx4(
        "textarea",
        {
          rows: 3,
          value: purposeNote,
          onChange: (e) => setPurposeNote(e.target.value),
          placeholder: "Bo\u015F b\u0131rak\u0131n \u2192 ajan kendi a\xE7\u0131l\u0131\u015F\u0131n\u0131 kullan\u0131r. Ba\u015Fka marka SCRIPT yap\u0131\u015Ft\u0131rmay\u0131n.",
          disabled: purpose === "marketing"
        }
      ),
      /* @__PURE__ */ jsxs4("small", { children: [
        "Rehber notu otomatik gelmez. Bu ajan\u0131n metni: Panaryus / CenterOS. Mustafao\u011Flu script\u2019i i\xE7in ",
        /* @__PURE__ */ jsx4("b", { children: "Mustafao\u011Flu Tar\u0131m Ticaret" }),
        " ajan\u0131n\u0131 a\xE7\u0131n."
      ] }),
      selectedContact?.defaultPurposeNote ? /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-chip-btn",
          style: { marginTop: 6 },
          onClick: () => {
            if (window.confirm(
              "Ki\u015Finin kay\u0131tl\u0131 notunu ama\xE7 notuna kopyala? (Ba\u015Fka marka script\u2019i olabilir.)"
            )) {
              setPurposeNote(selectedContact.defaultPurposeNote || "");
            }
          },
          children: "Ki\u015Finin kay\u0131tl\u0131 notunu kopyala"
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsxs4("label", { className: "voice-consent", children: [
      /* @__PURE__ */ jsx4(
        "input",
        {
          type: "checkbox",
          checked: consent,
          onChange: (e) => setConsent(e.target.checked)
        }
      ),
      "Kay\u0131t onay\u0131"
    ] }),
    /* @__PURE__ */ jsx4(
      "button",
      {
        type: "button",
        className: "alx-btn primary",
        style: { width: "100%", marginTop: 8 },
        disabled: callBusy || !agent.publishedVersion || !numberId || !selectedContactId && !manualTo.trim(),
        onClick: () => void startOutbound(),
        children: callBusy ? "Aran\u0131yor\u2026" : `Ara \xB7 ${agent.name}`
      }
    )
  ] });
};
var AgentStudioPage = ({
  api,
  brains,
  voiceApi,
  contactsApi,
  integrationsApi,
  operationsApi,
  phoneNumbersApi,
  locale = "en",
  workspaceId,
  onOpenIntegrations,
  onOpenNumbers,
  onOpenBrain,
  onOpenDirectory
}) => {
  const currentLocale = typeof locale === "string" ? localeFrom(locale) : locale;
  const t = (text, vars) => {
    let out = translate(currentLocale, text);
    if (vars) {
      for (const [key, value] of Object.entries(vars)) {
        out = out.replaceAll(`{${key}}`, String(value));
      }
    }
    return out;
  };
  const [agents, setAgents] = useState3([]);
  const [agentUsage, setAgentUsage] = useState3(0);
  const [agentLimit, setAgentLimit] = useState3(null);
  const [agentEnforcement, setAgentEnforcement] = useState3(null);
  const [templates, setTemplates] = useState3([]);
  const [templateCategories, setTemplateCategories] = useState3(
    []
  );
  const [brainOptions, setBrainOptions] = useState3([]);
  const [selectedId, setSelectedId] = useState3();
  const [pageTab, setPageTab] = useState3("agents");
  const [view, setView] = useState3("list");
  const [filter, setFilter] = useState3("all");
  const [search, setSearch] = useState3("");
  const [hideDemoAgents, setHideDemoAgents] = useState3(true);
  const [createCategory, setCreateCategory] = useState3("all");
  const [showNewDialog, setShowNewDialog] = useState3(false);
  const [showWizard, setShowWizard] = useState3(false);
  const [pendingTemplate, setPendingTemplate] = useState3(null);
  const [conversationId, setConversationId] = useState3();
  const [messages, setMessages] = useState3([]);
  const [deployment, setDeployment] = useState3();
  const [error, setError] = useState3();
  const [notice, setNotice] = useState3();
  const [busy, setBusy] = useState3(false);
  const [playingVoiceId, setPlayingVoiceId] = useState3();
  const [voiceCatalog, setVoiceCatalog] = useState3(null);
  const [voiceCatalogError, setVoiceCatalogError] = useState3();
  const [voiceSearch, setVoiceSearch] = useState3("");
  const [voiceGenderFilter, setVoiceGenderFilter] = useState3(
    "all"
  );
  const [voiceLangFilter, setVoiceLangFilter] = useState3("all");
  const selected = useMemo2(
    () => agents.find((a) => a.id === selectedId),
    [agents, selectedId]
  );
  const publishedBrainOptions = useMemo2(
    () => brainOptions.filter((b) => b.publishedVersion != null),
    [brainOptions]
  );
  const filteredCatalogVoices = useMemo2(() => {
    const items = voiceCatalog?.items ?? [];
    const q = voiceSearch.trim().toLowerCase();
    return items.filter((v) => {
      if (voiceGenderFilter !== "all" && v.gender !== voiceGenderFilter) return false;
      const lang = (v.language ?? "").toLowerCase();
      if (voiceLangFilter === "tr" && !lang.startsWith("tr")) return false;
      if (voiceLangFilter === "en" && !lang.startsWith("en")) return false;
      if (voiceLangFilter === "other" && (lang.startsWith("tr") || lang.startsWith("en") || !lang))
        return false;
      if (!q) return true;
      return v.name.toLowerCase().includes(q) || v.voiceId.toLowerCase().includes(q) || (v.description ?? "").toLowerCase().includes(q) || (v.category ?? "").toLowerCase().includes(q);
    });
  }, [voiceCatalog, voiceSearch, voiceGenderFilter, voiceLangFilter]);
  const load = useCallback3(
    async (preferredId) => {
      const [agentPage, brainPage, templatePage] = await Promise.all([
        api.list(workspaceId),
        brains.list(workspaceId),
        api.listTemplates()
      ]);
      setAgents(agentPage.items);
      setAgentUsage(agentPage.usage);
      setAgentLimit(agentPage.limit);
      setAgentEnforcement(agentPage.enforcement);
      setBrainOptions(
        brainPage.items.map(({ id, name, publishedVersion }) => ({
          id,
          name,
          publishedVersion
        }))
      );
      setTemplates(templatePage.items);
      setTemplateCategories(templatePage.categories);
      if (preferredId) setSelectedId(preferredId);
      void api.listVoices().then((catalog) => {
        setVoiceCatalog(catalog);
        setVoiceCatalogError(void 0);
      }).catch((cause) => {
        setVoiceCatalogError(errorMessage(cause));
      });
    },
    [api, brains, workspaceId]
  );
  useEffect3(() => {
    void load().catch((cause) => setError(errorMessage(cause)));
  }, [load]);
  const stats = useMemo2(() => {
    const incoming = agents.filter((a) => a.config?.channelMode === "inbound").length;
    const outgoing = agents.filter((a) => a.config?.channelMode === "outbound").length;
    const omni = agents.filter((a) => {
      const m = a.config?.channelMode ?? "omni";
      return m === "omni" || m === "webchat";
    }).length;
    const active = agents.filter((a) => a.status === "active").length;
    return {
      total: agents.length,
      incoming,
      outgoing,
      omni,
      active,
      draft: agents.length - active
    };
  }, [agents]);
  const usageCount = Math.max(agentUsage, agents.length);
  const atSoftLimit = agentEnforcement === "soft" && agentLimit != null && usageCount >= agentLimit;
  const atHardLimit = agentEnforcement === "hard" && agentLimit != null && usageCount >= agentLimit;
  const agentCountLabel = agentLimit != null ? `${usageCount} / ${agentLimit} ${t("agents")}` : `${usageCount} ${t("agents")}`;
  const filteredAgents = useMemo2(() => {
    const q = search.trim().toLowerCase();
    return agents.filter((agent) => {
      if (hideDemoAgents && isDemoOrIncompleteAgent(agent)) return false;
      if (filter === "incoming" && agent.config?.channelMode !== "inbound") return false;
      if (filter === "outgoing" && agent.config?.channelMode !== "outbound") return false;
      if (filter === "omni") {
        const m = agent.config?.channelMode ?? "omni";
        if (m !== "omni" && m !== "webchat") return false;
      }
      if (filter === "draft" && agent.status !== "draft") return false;
      if (filter === "active" && agent.status !== "active") return false;
      if (!q) return true;
      const hay = `${agent.name} ${agent.config?.instructions ?? ""} ${agent.config?.role ?? ""}`.toLowerCase();
      return hay.includes(q);
    });
  }, [agents, filter, search, hideDemoAgents]);
  const filteredTemplates = useMemo2(() => {
    if (createCategory === "all") return templates;
    return templates.filter((tpl) => tpl.category === createCategory);
  }, [createCategory, templates]);
  const mutate = async (operation, success) => {
    setBusy(true);
    setError(void 0);
    try {
      const preferred = await operation();
      await load(preferred);
      setNotice(success);
    } catch (cause) {
      setError(errorMessage(cause));
    } finally {
      setBusy(false);
    }
  };
  const deleteAgent = (agent) => {
    const ok = window.confirm(
      t("Delete agent {name}? It leaves this list. Call history is kept.", { name: agent.name })
    );
    if (!ok) return;
    void mutate(async () => {
      await api.remove(agent.id);
      setSelectedId(void 0);
      setView("list");
      return void 0;
    }, t("Agent deleted"));
  };
  const openEditor = (id) => {
    setSelectedId(id);
    setView("editor");
    setShowNewDialog(false);
    setMessages([]);
    setConversationId(void 0);
    setDeployment(void 0);
    setPendingTemplate(null);
  };
  const createFromTemplate = async (template, name) => {
    const brainId = firstPublishedBrainId(brainOptions);
    await mutate(async () => {
      const agent = await api.create(workspaceId, name || template.name, {
        templateId: template.id,
        ...brainId ? { brainId } : {}
      });
      if (!agent.config) setPendingTemplate(template);
      setView("editor");
      setShowNewDialog(false);
      return agent.id;
    }, t("Agent Created!"));
  };
  const createFullAgent = async (draft) => {
    await mutate(async () => {
      const agent = await api.create(workspaceId, draft.name.trim() || "New Agent", {
        ...draft.templateId ? { templateId: draft.templateId } : {},
        ...draft.brainId ? { brainId: draft.brainId } : {}
      });
      const brainId = draft.brainId || firstPublishedBrainId(brainOptions);
      if (brainId) {
        const mapped = voiceCatalog?.items.find((v) => v.voiceId === draft.voiceId);
        const profileId = mapped?.mappedProfileId || draft.profileId || "tr_female_warm";
        await api.update(agent.id, {
          expectedDraftVersion: agent.draftVersion,
          role: draft.role.trim() || draft.name,
          persona: draft.persona.trim() || "Clear, calm and concise",
          instructions: draft.instructions.trim(),
          firstMessage: draft.firstMessage.trim(),
          channelMode: draft.channelMode,
          brainId,
          blockedTopics: [],
          allowedTools: toolsFromCapabilities({
            ...draft.capabilities,
            appointmentBooking: draft.capabilities.appointmentBooking ?? false,
            messagingWhatsappTemplate: draft.capabilities.messagingWhatsappTemplate ?? false,
            messagingSmsPack: draft.capabilities.messagingSmsPack ?? false
          }),
          handoffEnabled: draft.capabilities.handoff,
          capabilities: {
            ...draft.capabilities,
            appointmentBooking: draft.capabilities.appointmentBooking ?? false,
            messagingWhatsappTemplate: draft.capabilities.messagingWhatsappTemplate ?? false,
            messagingSmsPack: draft.capabilities.messagingSmsPack ?? false
          },
          ...draft.templateId ? { templateId: draft.templateId } : {},
          voice: {
            profileId,
            language: draft.language || "tr-TR",
            voiceId: draft.voiceId,
            recordingEnabled: true,
            recordingNotice: "This call may be recorded for quality purposes.",
            interruptionEnabled: true,
            maxCallSeconds: 1800,
            turnTimeoutSeconds: draft.turnTimeoutSeconds,
            silenceTimeoutMs: 5e3,
            temperature: draft.temperature
          }
        });
      }
      setView("editor");
      setShowNewDialog(false);
      return agent.id;
    }, t("Agent Created!"));
  };
  if (view === "interview") {
    return /* @__PURE__ */ jsx4(
      AiAgentInterviewPage,
      {
        api,
        workspaceId,
        locale: currentLocale === "en" ? "en" : "tr",
        busy,
        hasPublishedBrain: Boolean(firstPublishedBrainId(brainOptions)),
        t,
        onBack: () => setView("list"),
        onOpenBrain,
        onComplete: async (draft) => {
          const brainId = firstPublishedBrainId(brainOptions);
          if (!brainId) {
            setError(t("Publish a Business Brain first so the interview can pin knowledge."));
            return;
          }
          const profile = resolveNamedVoiceProfile("tr_female_warm");
          const outbound = draft.channelMode === "outbound" || draft.channelMode === "omni";
          const capabilities = {
            ...draft.capabilities,
            endConversation: true,
            leadCreate: outbound ? true : draft.capabilities.leadCreate,
            callbackSchedule: outbound ? true : draft.capabilities.callbackSchedule
          };
          await mutate(async () => {
            const agent = await api.create(workspaceId, draft.name);
            await api.update(agent.id, {
              expectedDraftVersion: agent.draftVersion,
              role: draft.role,
              persona: draft.persona,
              instructions: draft.instructions,
              firstMessage: draft.firstMessage,
              channelMode: draft.channelMode,
              brainId,
              blockedTopics: draft.blockedTopics,
              allowedTools: toolsFromCapabilities(capabilities),
              handoffEnabled: capabilities.handoff,
              capabilities,
              voice: {
                profileId: profile.id,
                language: draft.language,
                voiceId: profileTtsVoiceId(profile),
                recordingEnabled: true,
                recordingNotice: draft.language.toLowerCase().startsWith("en") ? "This call may be recorded for quality purposes." : "Bu g\xF6r\xFC\u015Fme kalite amac\u0131yla kaydedilebilir.",
                interruptionEnabled: true,
                maxCallSeconds: 1800,
                turnTimeoutSeconds: 1.5,
                silenceTimeoutMs: 5e3,
                temperature: 0.4
              }
            });
            setView("editor");
            return agent.id;
          }, t("Agent created from AI interview."));
        }
      }
    );
  }
  if (view === "editor" && selected) {
    return /* @__PURE__ */ jsx4(
      AgentEditor,
      {
        agent: selected,
        seed: pendingTemplate,
        brainOptions,
        brains,
        api,
        voiceApi,
        contactsApi,
        integrationsApi,
        operationsApi,
        phoneNumbersApi,
        workspaceId,
        voiceCatalog,
        voiceCatalogError,
        busy,
        notice,
        error,
        messages,
        deployment,
        conversationId,
        playingVoiceId,
        t,
        onBack: () => {
          setView("list");
          setPageTab("agents");
        },
        onOpenIntegrations,
        onOpenNumbers,
        onOpenBrain,
        onOpenDirectory,
        onOpenVoices: () => {
          setView("list");
          setPageTab("voices");
        },
        onPublish: () => void mutate(async () => {
          const result = await api.publish(selected.id, selected.draftVersion);
          setDeployment(result);
          return selected.id;
        }, t("Immutable Agent version deployed.")),
        onDelete: () => deleteAgent(selected),
        onSave: (input) => void mutate(async () => {
          const updated = await api.update(selected.id, input);
          setAgents((prev) => prev.map((a) => a.id === updated.id ? updated : a));
          setPendingTemplate(null);
          return updated.id;
        }, t("Agent Updated!")),
        onSimulate: (event) => void submitSimulation(
          event,
          selected,
          api,
          conversationId,
          setConversationId,
          setMessages,
          setError,
          setBusy
        ),
        onSimulatePhrase: (phrase) => void submitSimulationPhrase(
          phrase,
          selected,
          api,
          conversationId,
          setConversationId,
          setMessages,
          setError,
          setBusy
        ),
        onPreviewVoice: (target) => toggleVoicePreview(
          api,
          typeof target === "string" ? { profileId: target, playKey: target } : target,
          playingVoiceId,
          setBusy,
          setError,
          setPlayingVoiceId,
          setNotice
        )
      }
    );
  }
  return /* @__PURE__ */ jsxs4("div", { className: "alx-page", children: [
    /* @__PURE__ */ jsxs4("div", { className: "alx-subnav", children: [
      /* @__PURE__ */ jsxs4(
        "button",
        {
          type: "button",
          className: pageTab === "agents" ? "active" : "",
          onClick: () => {
            setPageTab("agents");
            setView("list");
          },
          children: [
            /* @__PURE__ */ jsx4("span", { className: "alx-ico", children: "\u25A3" }),
            " ",
            t("Agents")
          ]
        }
      ),
      /* @__PURE__ */ jsxs4(
        "button",
        {
          type: "button",
          className: pageTab === "templates" ? "active" : "",
          onClick: () => setPageTab("templates"),
          children: [
            /* @__PURE__ */ jsx4("span", { className: "alx-ico", children: "\u{1F4C4}" }),
            " ",
            t("Prompt Templates")
          ]
        }
      ),
      /* @__PURE__ */ jsxs4(
        "button",
        {
          type: "button",
          className: pageTab === "voices" ? "active" : "",
          onClick: () => setPageTab("voices"),
          children: [
            /* @__PURE__ */ jsx4("span", { className: "alx-ico", children: "\u{1F399}" }),
            " ",
            t("Voices")
          ]
        }
      )
    ] }),
    error && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: error }),
    notice && /* @__PURE__ */ jsx4("div", { className: "studio-alert success", children: notice }),
    pageTab === "voices" && /* @__PURE__ */ jsxs4("section", { className: "alx-hero", children: [
      /* @__PURE__ */ jsxs4("div", { className: "alx-hero-top", children: [
        /* @__PURE__ */ jsxs4("div", { className: "alx-hero-title", children: [
          /* @__PURE__ */ jsx4("div", { className: "alx-hero-icon", children: "\u{1F399}" }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx4("h1", { children: t("Voices \xB7 ElevenLabs library") }),
            /* @__PURE__ */ jsx4("p", { children: "Full account catalogue from ElevenLabs API \u2014 not a fixed list of 7. Phone trunk: Zadarma." })
          ] })
        ] }),
        /* @__PURE__ */ jsx4("div", { className: "alx-hero-actions", children: /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: "alx-btn ghost",
            disabled: busy,
            onClick: () => {
              setBusy(true);
              void api.listVoices().then((catalog) => {
                setVoiceCatalog(catalog);
                setVoiceCatalogError(void 0);
                setNotice(`ElevenLabs: ${catalog.total} voice(s) loaded.`);
              }).catch((cause) => setVoiceCatalogError(errorMessage(cause))).finally(() => setBusy(false));
            },
            children: "\u21BB Refresh library"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-stats", style: { marginBottom: 16 }, children: [
        /* @__PURE__ */ jsxs4("div", { className: "alx-stat accent-purple", children: [
          /* @__PURE__ */ jsx4("b", { children: t("ElevenLabs") }),
          /* @__PURE__ */ jsx4("span", { children: t("Live TTS provider") })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-stat", children: [
          /* @__PURE__ */ jsx4("b", { children: voiceCatalog?.total ?? "\u2026" }),
          /* @__PURE__ */ jsx4("span", { children: t("Library voices") })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-stat accent-green", children: [
          /* @__PURE__ */ jsx4("b", { children: filteredCatalogVoices.length }),
          /* @__PURE__ */ jsx4("span", { children: t("Showing now") })
        ] })
      ] }),
      voiceCatalogError && /* @__PURE__ */ jsxs4("div", { className: "studio-alert error", children: [
        "ElevenLabs library load failed: ",
        voiceCatalogError
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-filters", style: { marginBottom: 16 }, children: [
        /* @__PURE__ */ jsx4(
          "input",
          {
            className: "alx-search",
            placeholder: t("Search name, id, description\u2026"),
            value: voiceSearch,
            onChange: (e) => setVoiceSearch(e.target.value)
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: voiceGenderFilter === "all" ? "active" : "",
            onClick: () => setVoiceGenderFilter("all"),
            children: "All genders"
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: voiceGenderFilter === "female" ? "active" : "",
            onClick: () => setVoiceGenderFilter("female"),
            children: "Female"
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: voiceGenderFilter === "male" ? "active" : "",
            onClick: () => setVoiceGenderFilter("male"),
            children: "Male"
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: voiceLangFilter === "all" ? "active" : "",
            onClick: () => setVoiceLangFilter("all"),
            children: "All langs"
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: voiceLangFilter === "tr" ? "active" : "",
            onClick: () => setVoiceLangFilter("tr"),
            children: "TR"
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: voiceLangFilter === "en" ? "active" : "",
            onClick: () => setVoiceLangFilter("en"),
            children: "EN"
          }
        )
      ] }),
      !voiceCatalog && !voiceCatalogError && /* @__PURE__ */ jsx4("p", { style: { opacity: 0.7 }, children: t("Loading full ElevenLabs library\u2026") }),
      /* @__PURE__ */ jsx4("div", { className: "alx-card-grid", children: filteredCatalogVoices.map((v) => {
        const playKey = v.voiceId;
        const playing = playingVoiceId === playKey;
        return /* @__PURE__ */ jsxs4(
          "article",
          {
            className: "alx-agent-card tone-cream",
            style: { cursor: "default" },
            children: [
              /* @__PURE__ */ jsxs4("div", { className: "alx-card-head", children: [
                /* @__PURE__ */ jsx4("div", { className: "alx-card-icon", children: "\u{1F399}" }),
                /* @__PURE__ */ jsxs4("div", { children: [
                  /* @__PURE__ */ jsx4("h3", { children: v.name }),
                  /* @__PURE__ */ jsx4("span", { className: "alx-pill custom", children: v.recommended ? "ElevenLabs \xB7 recommended" : "ElevenLabs" })
                ] })
              ] }),
              /* @__PURE__ */ jsx4("div", { className: "alx-card-voice", children: /* @__PURE__ */ jsxs4("span", { children: [
                "\u25CE ",
                v.gender,
                v.language ? ` \xB7 ${v.language}` : "",
                v.category ? ` \xB7 ${v.category}` : ""
              ] }) }),
              /* @__PURE__ */ jsxs4("p", { className: "alx-card-prompt", style: { fontSize: 12, opacity: 0.85 }, children: [
                "id: ",
                v.voiceId
              ] }),
              v.description && /* @__PURE__ */ jsxs4("p", { className: "alx-card-prompt", children: [
                v.description.slice(0, 140),
                v.description.length > 140 ? "\u2026" : ""
              ] }),
              /* @__PURE__ */ jsx4(
                "button",
                {
                  type: "button",
                  className: `alx-btn block ${playing ? "ghost" : "primary"}`,
                  disabled: busy && !playing,
                  onClick: () => toggleVoicePreview(
                    api,
                    {
                      voiceId: v.voiceId,
                      ...v.mappedProfileId ? { profileId: v.mappedProfileId } : {},
                      playKey
                    },
                    playingVoiceId,
                    setBusy,
                    setError,
                    setPlayingVoiceId,
                    setNotice
                  ),
                  children: playing ? t("\u25A0 Stop") : `\u25B6 ${t("Play sample")}`
                }
              )
            ]
          },
          v.voiceId
        );
      }) })
    ] }),
    pageTab === "templates" && /* @__PURE__ */ jsxs4("section", { className: "alx-hero", children: [
      /* @__PURE__ */ jsxs4("div", { className: "alx-hero-top", children: [
        /* @__PURE__ */ jsxs4("div", { className: "alx-hero-title", children: [
          /* @__PURE__ */ jsx4("div", { className: "alx-hero-icon", children: "\u{1F4C4}" }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx4("h1", { children: t("Prompt Templates") }),
            /* @__PURE__ */ jsx4("p", { children: t("Create and manage reusable AI prompt templates") })
          ] })
        ] }),
        /* @__PURE__ */ jsx4("div", { className: "alx-hero-actions", children: /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: "alx-btn primary",
            disabled: atHardLimit,
            title: atHardLimit ? t("Agent plan limit reached") : void 0,
            onClick: () => {
              if (atHardLimit) return;
              setShowNewDialog(true);
            },
            children: t("+ New Agent")
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-stats", children: [
        /* @__PURE__ */ jsxs4("div", { className: "alx-stat", children: [
          /* @__PURE__ */ jsx4("b", { children: templates.length }),
          /* @__PURE__ */ jsx4("span", { children: t("Total Templates") })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-stat accent-green", children: [
          /* @__PURE__ */ jsx4("b", { children: templates.length }),
          /* @__PURE__ */ jsx4("span", { children: t("System") })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-stat accent-purple", children: [
          /* @__PURE__ */ jsx4("b", { children: templateCategories.length }),
          /* @__PURE__ */ jsx4("span", { children: t("Categories") })
        ] })
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-filters", children: [
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: createCategory === "all" ? "alx-chip active" : "alx-chip",
            onClick: () => setCreateCategory("all"),
            children: "All Templates"
          }
        ),
        templateCategories.map((cat) => /* @__PURE__ */ jsxs4(
          "button",
          {
            type: "button",
            className: createCategory === cat ? "alx-chip active" : "alx-chip",
            onClick: () => setCreateCategory(cat),
            children: [
              CATEGORY_META[cat].icon,
              " ",
              t(CATEGORY_META[cat].label)
            ]
          },
          cat
        ))
      ] }),
      /* @__PURE__ */ jsx4("div", { className: "alx-card-grid", children: filteredTemplates.map((tpl) => /* @__PURE__ */ jsxs4("article", { className: "alx-agent-card tone-cream", children: [
        /* @__PURE__ */ jsxs4("div", { className: "alx-card-head", children: [
          /* @__PURE__ */ jsx4("div", { className: "alx-card-icon", children: CATEGORY_META[tpl.category].icon }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx4("h3", { children: tpl.name }),
            tpl.nameEn && /* @__PURE__ */ jsx4("small", { className: "alx-tpl-en", children: tpl.nameEn }),
            /* @__PURE__ */ jsx4("span", { className: "alx-pill custom", children: t(CATEGORY_META[tpl.category].label) })
          ] })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-card-voice", children: [
          /* @__PURE__ */ jsxs4("span", { children: [
            "\u25CE ",
            t(CHANNEL_LABELS[tpl.suggestedChannelMode])
          ] }),
          /* @__PURE__ */ jsxs4("span", { children: [
            "\xB7 ",
            tpl.localeHints.join(", ")
          ] })
        ] }),
        /* @__PURE__ */ jsx4("p", { className: "alx-card-prompt", children: tpl.description }),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: "alx-btn primary block",
            disabled: busy,
            onClick: () => void createFromTemplate(tpl, tpl.name),
            children: "Use template"
          }
        )
      ] }, tpl.id)) })
    ] }),
    pageTab === "agents" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
      /* @__PURE__ */ jsxs4("section", { className: "alx-hero", children: [
        /* @__PURE__ */ jsxs4("div", { className: "alx-hero-top", children: [
          /* @__PURE__ */ jsxs4("div", { className: "alx-hero-title", children: [
            /* @__PURE__ */ jsx4("div", { className: "alx-hero-icon", children: "\u25A3" }),
            /* @__PURE__ */ jsxs4("div", { children: [
              /* @__PURE__ */ jsx4("h1", { children: t("AI Agents") }),
              /* @__PURE__ */ jsxs4("p", { children: [
                t("Create, publish, then test \u2014 in that order"),
                " \xB7 ",
                /* @__PURE__ */ jsx4("strong", { className: "alx-agent-count", children: agentCountLabel })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-hero-actions", children: [
            /* @__PURE__ */ jsxs4(
              "button",
              {
                type: "button",
                className: "alx-btn ghost",
                disabled: atHardLimit,
                title: atHardLimit ? t("Agent plan limit reached") : void 0,
                onClick: () => {
                  if (atHardLimit) return;
                  setPageTab("agents");
                  setShowWizard(true);
                },
                children: [
                  "\u2726 ",
                  t("Guided Wizard")
                ]
              }
            ),
            /* @__PURE__ */ jsxs4(
              "button",
              {
                type: "button",
                className: "alx-btn ghost",
                disabled: atHardLimit,
                title: atHardLimit ? t("Agent plan limit reached") : void 0,
                onClick: () => {
                  if (atHardLimit) return;
                  setPageTab("agents");
                  setView("interview");
                },
                children: [
                  "\u2726 ",
                  t("AI Assistant")
                ]
              }
            ),
            /* @__PURE__ */ jsx4(
              "button",
              {
                type: "button",
                className: "alx-btn primary",
                disabled: atHardLimit,
                title: atHardLimit ? t("Agent plan limit reached") : void 0,
                onClick: () => {
                  if (atHardLimit) return;
                  setShowNewDialog(true);
                },
                children: t("+ New Agent")
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-publish-path alx-list-path", role: "status", children: [
          /* @__PURE__ */ jsxs4("span", { className: "active", children: [
            /* @__PURE__ */ jsx4("em", { children: "1" }),
            " ",
            t("Create")
          ] }),
          /* @__PURE__ */ jsxs4("span", { children: [
            /* @__PURE__ */ jsx4("em", { children: "2" }),
            " ",
            t("Save Agent")
          ] }),
          /* @__PURE__ */ jsxs4("span", { children: [
            /* @__PURE__ */ jsx4("em", { children: "3" }),
            " ",
            t("Publish & deploy")
          ] }),
          /* @__PURE__ */ jsxs4("span", { children: [
            /* @__PURE__ */ jsx4("em", { children: "4" }),
            " ",
            t("Test call")
          ] })
        ] }),
        atSoftLimit && /* @__PURE__ */ jsx4("div", { className: "alx-banner alx-banner-warn", role: "status", children: t("Approaching plan agent limit") }),
        atHardLimit && /* @__PURE__ */ jsx4("div", { className: "alx-banner alx-banner-error", role: "alert", children: t("Agent plan limit reached") }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-stats", children: [
          /* @__PURE__ */ jsxs4("div", { className: "alx-stat", children: [
            /* @__PURE__ */ jsx4("b", { children: agentLimit != null ? `${usageCount} / ${agentLimit}` : usageCount }),
            /* @__PURE__ */ jsx4("span", { children: t("Total Agents") })
          ] }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-stat accent-green", children: [
            /* @__PURE__ */ jsx4("b", { children: stats.incoming }),
            /* @__PURE__ */ jsx4("span", { children: t("Incoming") })
          ] }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-stat accent-orange", children: [
            /* @__PURE__ */ jsx4("b", { children: stats.outgoing }),
            /* @__PURE__ */ jsx4("span", { children: t("Outgoing") })
          ] }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-stat accent-purple", children: [
            /* @__PURE__ */ jsx4("b", { children: stats.active }),
            /* @__PURE__ */ jsx4("span", { children: t("Published") })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-filters", children: [
        /* @__PURE__ */ jsxs4(
          "button",
          {
            type: "button",
            className: filter === "all" ? "alx-chip active" : "alx-chip",
            onClick: () => setFilter("all"),
            children: [
              t("All"),
              " (",
              stats.total,
              ")"
            ]
          }
        ),
        /* @__PURE__ */ jsxs4(
          "button",
          {
            type: "button",
            className: filter === "incoming" ? "alx-chip active" : "alx-chip",
            onClick: () => setFilter("incoming"),
            children: [
              "\u260E ",
              t("Incoming"),
              " (",
              stats.incoming,
              ")"
            ]
          }
        ),
        /* @__PURE__ */ jsxs4(
          "button",
          {
            type: "button",
            className: filter === "outgoing" ? "alx-chip active" : "alx-chip",
            onClick: () => setFilter("outgoing"),
            children: [
              "\u2197 ",
              t("Outgoing"),
              " (",
              stats.outgoing,
              ")"
            ]
          }
        ),
        /* @__PURE__ */ jsxs4(
          "button",
          {
            type: "button",
            className: filter === "omni" ? "alx-chip active" : "alx-chip",
            onClick: () => setFilter("omni"),
            children: [
              "\u25C8 ",
              t("Omni"),
              " (",
              stats.omni,
              ")"
            ]
          }
        ),
        /* @__PURE__ */ jsxs4(
          "button",
          {
            type: "button",
            className: filter === "active" ? "alx-chip active" : "alx-chip",
            onClick: () => setFilter("active"),
            children: [
              t("Published"),
              " (",
              stats.active,
              ")"
            ]
          }
        ),
        /* @__PURE__ */ jsxs4(
          "button",
          {
            type: "button",
            className: filter === "draft" ? "alx-chip active" : "alx-chip",
            onClick: () => setFilter("draft"),
            children: [
              t("Draft"),
              " (",
              stats.draft,
              ")"
            ]
          }
        ),
        /* @__PURE__ */ jsx4(
          "input",
          {
            className: "alx-search",
            value: search,
            onChange: (e) => setSearch(e.target.value),
            placeholder: t("Search agents...")
          }
        ),
        /* @__PURE__ */ jsxs4("label", { className: "alx-demo-toggle", children: [
          /* @__PURE__ */ jsx4(
            "input",
            {
              type: "checkbox",
              checked: hideDemoAgents,
              onChange: (e) => setHideDemoAgents(e.target.checked)
            }
          ),
          t("Hide demo/test agents")
        ] })
      ] }),
      filteredAgents.length === 0 ? /* @__PURE__ */ jsx4("div", { className: "alx-empty", children: agents.length > 0 && hideDemoAgents ? /* @__PURE__ */ jsxs4(Fragment3, { children: [
        /* @__PURE__ */ jsx4("h2", { children: t("No agents match filters") }),
        /* @__PURE__ */ jsx4("p", { children: t(
          "Demo/test agents are hidden. Turn off the filter to show them, or create a new agent."
        ) }),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: "alx-btn primary",
            onClick: () => setHideDemoAgents(false),
            children: t("Show demo/test agents")
          }
        )
      ] }) : /* @__PURE__ */ jsxs4(Fragment3, { children: [
        /* @__PURE__ */ jsx4("h2", { children: t("Create your first agent") }),
        /* @__PURE__ */ jsx4("p", { children: t(
          "Build AI-powered voice agents to handle incoming calls or run automated campaigns with natural conversations."
        ) }),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: "alx-btn primary",
            disabled: atHardLimit,
            title: atHardLimit ? t("Agent plan limit reached") : void 0,
            onClick: () => {
              if (atHardLimit) return;
              setShowNewDialog(true);
            },
            children: t("Create Your First Agent")
          }
        )
      ] }) }) : /* @__PURE__ */ jsx4("div", { className: "alx-card-grid", children: filteredAgents.map((agent, index) => {
        const badge = typeBadge(agent);
        const demoOrIncomplete = isDemoOrIncompleteAgent(agent);
        const tone = badge.kind === "incoming" ? "tone-mint" : badge.kind === "outgoing" ? "tone-peach" : "tone-cream";
        const badgeIcon = badge.kind === "incoming" ? "\u260E" : badge.kind === "outgoing" ? "\u2197" : badge.kind === "webchat" ? "\u{1F4AC}" : "\u25C8";
        return /* @__PURE__ */ jsxs4(
          "article",
          {
            className: `alx-agent-card ${tone}${demoOrIncomplete ? " is-demo-muted" : ""}`,
            onClick: () => openEditor(agent.id),
            onKeyDown: (e) => {
              if (e.key === "Enter") openEditor(agent.id);
            },
            role: "button",
            tabIndex: 0,
            children: [
              /* @__PURE__ */ jsxs4("div", { className: "alx-card-head", children: [
                /* @__PURE__ */ jsx4("div", { className: `alx-card-icon kind-${badge.kind}`, children: badgeIcon }),
                /* @__PURE__ */ jsxs4("div", { className: "alx-card-titles", children: [
                  /* @__PURE__ */ jsx4("h3", { title: agent.name, children: agent.name }),
                  /* @__PURE__ */ jsx4("span", { className: `alx-pill ${badge.kind}`, children: t(badge.label) }),
                  demoOrIncomplete && /* @__PURE__ */ jsx4("span", { className: "alx-pill demo", children: !agent.config ? t("Incomplete") : t("Demo/test") })
                ] })
              ] }),
              /* @__PURE__ */ jsx4("div", { className: "alx-card-voice", children: /* @__PURE__ */ jsxs4("span", { children: [
                "\u25CE ",
                voiceLine(agent)
              ] }) }),
              agent.config?.persona && /* @__PURE__ */ jsx4("div", { className: "alx-card-tags", children: /* @__PURE__ */ jsx4("span", { children: agent.config.persona.split(/[,.]/).filter(Boolean)[0]?.trim() }) }),
              /* @__PURE__ */ jsx4("p", { className: "alx-card-prompt", children: promptPreview(agent) }),
              /* @__PURE__ */ jsxs4("div", { className: "alx-card-foot", children: [
                /* @__PURE__ */ jsxs4("span", { children: [
                  t("Draft"),
                  " v",
                  agent.draftVersion
                ] }),
                agent.publishedVersion != null ? /* @__PURE__ */ jsx4(
                  "span",
                  {
                    className: `alx-live-chip ${agent.draftVersion > agent.publishedVersion ? "stale" : "on"}`,
                    children: agent.draftVersion > agent.publishedVersion ? t("Live v{n} \xB7 draft newer", {
                      n: String(agent.publishedVersion)
                    }) : t("Live v{n}", { n: String(agent.publishedVersion) })
                  }
                ) : /* @__PURE__ */ jsx4("span", { className: "alx-live-chip off", children: t("No live version") }),
                agent.status === "active" && /* @__PURE__ */ jsx4("span", { className: "ok", children: t("active") })
              ] }),
              /* @__PURE__ */ jsxs4(
                "div",
                {
                  className: "alx-card-cta",
                  style: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 },
                  children: [
                    agent.publishedVersion == null ? t("Open \u2192 save & publish") : agent.draftVersion > agent.publishedVersion ? t("Open \u2192 publish draft to go live") : t("Open to edit"),
                    /* @__PURE__ */ jsx4(
                      "button",
                      {
                        type: "button",
                        className: "alx-btn ghost",
                        disabled: busy,
                        onClick: (event) => {
                          event.stopPropagation();
                          deleteAgent(agent);
                        },
                        children: t("Delete")
                      }
                    )
                  ]
                }
              )
            ]
          },
          agent.id
        );
      }) })
    ] }),
    showNewDialog && /* @__PURE__ */ jsx4(
      CreateNewAgentModal,
      {
        busy,
        templates,
        brainOptions: publishedBrainOptions,
        onOpenBrain,
        voiceCatalog,
        playingVoiceId,
        t,
        onClose: () => setShowNewDialog(false),
        onPreviewVoice: (target) => toggleVoicePreview(
          api,
          target,
          playingVoiceId,
          setBusy,
          setError,
          setPlayingVoiceId,
          setNotice
        ),
        onCreate: (draft) => void createFullAgent(draft),
        onBrowseTemplates: () => {
          setShowNewDialog(false);
          setPageTab("templates");
        }
      }
    ),
    showWizard && /* @__PURE__ */ jsx4(
      GuidedWizardModal,
      {
        templates,
        brainOptions: publishedBrainOptions,
        onOpenBrain,
        api,
        busy,
        playingVoiceId,
        t,
        onClose: () => setShowWizard(false),
        onPreviewVoice: (target) => toggleVoicePreview(
          api,
          typeof target === "string" ? { profileId: target, playKey: target } : target,
          playingVoiceId,
          setBusy,
          setError,
          setPlayingVoiceId,
          setNotice
        ),
        onComplete: async (draft) => {
          const brainId = draft.brainId || firstPublishedBrainId(brainOptions);
          if (!brainId) {
            setError("Publish a Business Brain first so the wizard can pin knowledge.");
            return;
          }
          await mutate(async () => {
            const agent = await api.create(workspaceId, draft.name);
            await api.update(agent.id, {
              expectedDraftVersion: agent.draftVersion,
              role: draft.role,
              persona: draft.persona,
              instructions: draft.instructions,
              firstMessage: draft.firstMessage,
              channelMode: draft.channelMode,
              brainId,
              blockedTopics: draft.blockedTopics,
              allowedTools: draft.allowedTools,
              handoffEnabled: draft.capabilities.handoff,
              capabilities: draft.capabilities,
              ...draft.templateId ? { templateId: draft.templateId } : {},
              voice: draft.voice
            });
            setShowWizard(false);
            setView("editor");
            return agent.id;
          }, "Agent created from Guided Wizard.");
        }
      }
    )
  ] });
};
var CREATE_DYNAMIC_VARS = [
  "business_name",
  "agent_name",
  "contact_name",
  "first_name",
  "last_name",
  "phone",
  "email",
  "company",
  "city",
  "purpose"
];
var CreateNewAgentModal = ({
  busy,
  templates,
  brainOptions,
  voiceCatalog,
  playingVoiceId,
  t,
  onClose,
  onPreviewVoice,
  onCreate,
  onBrowseTemplates,
  onOpenBrain
}) => {
  const library = voiceCatalog?.items ?? [];
  const defaultVoiceId = library.find((v) => v.recommended)?.voiceId || library[0]?.voiceId || profileTtsVoiceId(resolveNamedVoiceProfile("tr_female_warm"));
  const [agentType, setAgentType] = useState3("incoming");
  const [name, setName] = useState3("Customer Support Agent");
  const [voiceTone, setVoiceTone] = useState3("Professional");
  const [personality, setPersonality] = useState3("Helpful");
  const [telephonyStack, setTelephonyStack] = useState3("el_zadarma");
  const [voiceId, setVoiceId] = useState3(defaultVoiceId);
  const [language, setLanguage] = useState3("tr-TR");
  const [temperature, setTemperature] = useState3(0.5);
  const [responseDelay, setResponseDelay] = useState3(1.5);
  const [templateId, setTemplateId] = useState3("");
  const [templateQuery, setTemplateQuery] = useState3("");
  const [templateCategory, setTemplateCategory] = useState3("all");
  const [instructions, setInstructions] = useState3(
    "Answer only from published business knowledge. Keep answers short for phone. State when context is insufficient."
  );
  const [firstMessage, setFirstMessage] = useState3(
    "Hello! Thank you for calling {{business_name}}. My name is {{agent_name}}. How can I help you today?"
  );
  const [brainId, setBrainId] = useState3(brainOptions[0]?.id ?? "");
  const [handoff, setHandoff] = useState3(true);
  const [endConversation, setEndConversation] = useState3(true);
  const [leadCreate, setLeadCreate] = useState3(false);
  const [callbackSchedule, setCallbackSchedule] = useState3(false);
  const [appointmentBooking, setAppointmentBooking] = useState3(false);
  const [caseCreate, setCaseCreate] = useState3(false);
  const [localError, setLocalError] = useState3();
  useEffect3(() => {
    if (!library.length) return;
    if (!library.some((v) => v.voiceId === voiceId)) {
      setVoiceId(defaultVoiceId);
    }
  }, [library, voiceId, defaultVoiceId]);
  const filteredTemplates = useMemo2(() => {
    const q = templateQuery.trim().toLowerCase();
    return templates.filter((tpl) => {
      if (templateCategory !== "all" && tpl.category !== templateCategory) return false;
      if (!q) return true;
      return `${tpl.name} ${tpl.description} ${tpl.instructions}`.toLowerCase().includes(q);
    });
  }, [templates, templateQuery, templateCategory]);
  const applyTemplate = (tpl) => {
    setTemplateId(tpl.id);
    setName(tpl.name);
    setPersonality(tpl.persona.split(/[,.]/)[0]?.trim() || personality);
    setInstructions(tpl.instructions);
    const loc = language || tpl.localeHints[0] || "tr-TR";
    setFirstMessage(
      loc.toLowerCase().startsWith("en") && tpl.firstMessageEn ? tpl.firstMessageEn : tpl.firstMessage
    );
    setAgentType(tpl.suggestedChannelMode === "outbound" ? "flow" : "incoming");
    setHandoff(tpl.suggestedCapabilities.handoff);
    setEndConversation(tpl.suggestedCapabilities.endConversation);
    setLeadCreate(tpl.suggestedCapabilities.leadCreate);
    setCallbackSchedule(tpl.suggestedCapabilities.callbackSchedule);
    setAppointmentBooking(tpl.suggestedCapabilities.appointmentBooking ?? false);
    setCaseCreate(tpl.suggestedCapabilities.caseCreate);
    const mappedVoice = library.find(
      (v) => v.mappedProfileId === tpl.suggestedVoiceProfileId
    );
    if (mappedVoice) setVoiceId(mappedVoice.voiceId);
    if (tpl.localeHints[0]) setLanguage(tpl.localeHints[0]);
  };
  const submit = () => {
    setLocalError(void 0);
    if (!name.trim()) {
      setLocalError("Agent name is required.");
      return;
    }
    if (!instructions.trim()) {
      setLocalError("System prompt is required.");
      return;
    }
    if (!brainId) {
      setLocalError("Select a Knowledge Base (Business Brain) first.");
      return;
    }
    if (!voiceId) {
      setLocalError("Select an ElevenLabs voice.");
      return;
    }
    const channelMode = agentType === "incoming" ? "inbound" : "outbound";
    const persona = `${voiceTone}, ${personality}`.trim();
    const mapped = library.find((v) => v.voiceId === voiceId);
    const draft = {
      name: name.trim(),
      channelMode,
      role: name.trim(),
      persona,
      instructions: instructions.trim(),
      firstMessage: firstMessage.trim(),
      brainId,
      voiceId,
      profileId: mapped?.mappedProfileId || "tr_female_warm",
      language,
      temperature,
      turnTimeoutSeconds: responseDelay,
      capabilities: {
        handoff,
        endConversation,
        leadCreate,
        callbackSchedule,
        appointmentBooking,
        caseCreate
      }
    };
    onCreate(templateId ? { ...draft, templateId } : draft);
  };
  return /* @__PURE__ */ jsx4("div", { className: "alx-modal-backdrop", role: "presentation", onClick: onClose, children: /* @__PURE__ */ jsxs4(
    "div",
    {
      className: "alx-modal alx-modal-wide",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "alx-new-agent-title",
      onClick: (e) => e.stopPropagation(),
      children: [
        /* @__PURE__ */ jsxs4("header", { className: "alx-modal-head", children: [
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx4("h2", { id: "alx-new-agent-title", children: t("Create New Agent") }),
            /* @__PURE__ */ jsx4("p", { children: "Configure your conversational AI agent with a voice and personality" })
          ] }),
          /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-modal-close", onClick: onClose, "aria-label": "Close", children: "\u2715" })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-modal-body", children: [
          localError && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: localError }),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("Agent Type *") }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-type-grid", children: [
            /* @__PURE__ */ jsxs4(
              "button",
              {
                type: "button",
                className: agentType === "incoming" ? "alx-type-card selected" : "alx-type-card",
                onClick: () => setAgentType("incoming"),
                children: [
                  /* @__PURE__ */ jsx4("strong", { children: t("Incoming Agent") }),
                  /* @__PURE__ */ jsx4("span", { children: "Open-ended AI conversations. Best for receiving calls on purchased numbers and human-like dialog." })
                ]
              }
            ),
            /* @__PURE__ */ jsxs4(
              "button",
              {
                type: "button",
                className: agentType === "flow" ? "alx-type-card selected" : "alx-type-card",
                onClick: () => setAgentType("flow"),
                children: [
                  /* @__PURE__ */ jsx4("strong", { children: t("Flow Agent") }),
                  /* @__PURE__ */ jsx4("span", { children: "Campaign / dialer style. Best for bulk outbound, reminders, confirmations and predictable scripts." })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsx4("div", { className: "alx-type-grid", children: /* @__PURE__ */ jsxs4("button", { type: "button", className: "alx-type-card is-disabled", disabled: true, children: [
            /* @__PURE__ */ jsx4("strong", { children: t("Custom Engine Agent") }),
            /* @__PURE__ */ jsx4("span", { className: "alx-badge-soon", children: t("Coming soon") }),
            /* @__PURE__ */ jsx4("span", { children: "Self-hosted FreeSWITCH pipeline is not enabled on this CenterOS deployment." })
          ] }) }),
          /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
            /* @__PURE__ */ jsx4("span", { children: t("Agent Name *") }),
            /* @__PURE__ */ jsx4("input", { value: name, onChange: (e) => setName(e.target.value), required: true })
          ] }),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: "Voice & Personality" }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Voice Tone") }),
              /* @__PURE__ */ jsx4("select", { value: voiceTone, onChange: (e) => setVoiceTone(e.target.value), children: ["Professional", "Friendly", "Warm", "Calm", "Energetic"].map((t2) => /* @__PURE__ */ jsx4("option", { value: t2, children: t2 }, t2)) })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Personality") }),
              /* @__PURE__ */ jsx4("select", { value: personality, onChange: (e) => setPersonality(e.target.value), children: ["Helpful", "Empathetic", "Direct", "Sales-oriented", "Formal"].map((t2) => /* @__PURE__ */ jsx4("option", { value: t2, children: t2 }, t2)) })
            ] })
          ] }),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("Voice & Language \xB7 Telephony stack") }),
          /* @__PURE__ */ jsx4("p", { className: "numbers-help", style: { marginTop: 0 }, children: t(
            "This card picks TTS only. Live phone trunk is chosen by the DID you bind under Numbers (Verimor TR, Zadarma intl, or BYO)."
          ) }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-provider-grid", children: [
            /* @__PURE__ */ jsxs4(
              "button",
              {
                type: "button",
                className: telephonyStack === "el_zadarma" ? "alx-provider-card selected" : "alx-provider-card",
                onClick: () => setTelephonyStack("el_zadarma"),
                children: [
                  /* @__PURE__ */ jsx4("strong", { children: t("ElevenLabs + platform PSTN") }),
                  /* @__PURE__ */ jsx4("span", { children: t("Premium TTS \xB7 phone via Numbers DID (Verimor TR + Zadarma live on platform)") })
                ]
              }
            ),
            /* @__PURE__ */ jsxs4(
              "button",
              {
                type: "button",
                className: telephonyStack === "openai_zadarma" ? "alx-provider-card selected" : "alx-provider-card",
                onClick: () => setTelephonyStack("openai_zadarma"),
                children: [
                  /* @__PURE__ */ jsx4("strong", { children: t("OpenAI TTS + platform PSTN") }),
                  /* @__PURE__ */ jsx4("span", { children: t("Fallback TTS \xB7 same multi-trunk telephony (Verimor / Zadarma by number)") })
                ]
              }
            ),
            /* @__PURE__ */ jsxs4("button", { type: "button", className: "alx-provider-card is-disabled", disabled: true, children: [
              /* @__PURE__ */ jsx4("strong", { children: t("ElevenLabs + Twilio") }),
              /* @__PURE__ */ jsx4("span", { className: "alx-badge-soon", children: t("Not used") }),
              /* @__PURE__ */ jsx4("span", { children: t("Twilio is not the active customer trunk on this deployment") })
            ] }),
            /* @__PURE__ */ jsxs4("button", { type: "button", className: "alx-provider-card is-disabled", disabled: true, children: [
              /* @__PURE__ */ jsx4("strong", { children: t("Custom SIP / FreeSWITCH") }),
              /* @__PURE__ */ jsx4("span", { className: "alx-badge-soon", children: t("Plugin later") }),
              /* @__PURE__ */ jsx4("span", { children: t("Customer BYO SIP credentials wizard is not self-serve yet \u2014 use Numbers BYO inventory + ops") })
            ] })
          ] }),
          /* @__PURE__ */ jsxs4("p", { className: "numbers-help", children: [
            /* @__PURE__ */ jsx4("b", { children: "Verimor:" }),
            " ",
            t(
              "Available as platform TR trunk. Bind a Verimor DID on Numbers (Gelen ba\u011F / inventory) \u2014 it is not a separate agent-create card because trunk follows the number, not the agent."
            )
          ] }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: "Voice * (ElevenLabs library)" }),
              /* @__PURE__ */ jsxs4("select", { value: voiceId, onChange: (e) => setVoiceId(e.target.value), children: [
                library.length === 0 && /* @__PURE__ */ jsx4("option", { value: voiceId, children: voiceId || "Loading\u2026" }),
                library.map((v) => /* @__PURE__ */ jsxs4("option", { value: v.voiceId, children: [
                  v.name,
                  v.language ? ` \xB7 ${v.language}` : "",
                  v.recommended ? " \u2605" : ""
                ] }, v.voiceId))
              ] }),
              /* @__PURE__ */ jsx4("small", { children: library.length > 0 ? `${library.length} voices from your ElevenLabs account` : "Open Voices tab once if library is empty" })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Language *") }),
              /* @__PURE__ */ jsxs4("select", { value: language, onChange: (e) => setLanguage(e.target.value), children: [
                /* @__PURE__ */ jsx4("option", { value: "tr-TR", children: "Turkish (tr-TR)" }),
                /* @__PURE__ */ jsx4("option", { value: "en-US", children: "English (en-US)" }),
                /* @__PURE__ */ jsx4("option", { value: "en-GB", children: "English (en-GB)" }),
                /* @__PURE__ */ jsx4("option", { value: "ar-SA", children: "Arabic (ar-SA)" })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ jsx4(
            "button",
            {
              type: "button",
              className: "alx-btn ghost",
              disabled: busy || !voiceId,
              onClick: () => onPreviewVoice({
                voiceId,
                playKey: voiceId
              }),
              children: playingVoiceId === voiceId ? t("\u25A0 Stop sample") : `\u25B6 ${t("Play sample")}`
            }
          ),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: "AI Model & Behavior" }),
          /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
            /* @__PURE__ */ jsx4("span", { children: "LLM Model *" }),
            /* @__PURE__ */ jsx4("select", { defaultValue: "grounded-default", disabled: true, children: /* @__PURE__ */ jsx4("option", { value: "grounded-default", children: "Grounded default (platform LLM \xB7 OpenAI)" }) }),
            /* @__PURE__ */ jsx4("small", { children: "Model routing is controlled by CenterOS providers \u2014 not free multi-model pick yet." })
          ] }),
          /* @__PURE__ */ jsx4("div", { className: "alx-range-row", children: /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
            /* @__PURE__ */ jsxs4("span", { children: [
              "Temperature \xB7 Current: ",
              temperature.toFixed(2)
            ] }),
            /* @__PURE__ */ jsx4(
              "input",
              {
                type: "range",
                min: 0,
                max: 1,
                step: 0.05,
                value: temperature,
                onChange: (e) => setTemperature(Number(e.target.value))
              }
            ),
            /* @__PURE__ */ jsx4("small", { children: t("Deterministic \u2190 \u2192 Creative") })
          ] }) }),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("Voice Fine-Tuning") }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: "Response Delay (turn timeout)" }),
              /* @__PURE__ */ jsx4(
                "input",
                {
                  type: "number",
                  min: 0.5,
                  max: 10,
                  step: 0.1,
                  value: responseDelay,
                  onChange: (e) => setResponseDelay(Number(e.target.value))
                }
              ),
              /* @__PURE__ */ jsx4("small", { children: "Seconds before the agent continues after silence" })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Expressive Mode") }),
              /* @__PURE__ */ jsx4("input", { type: "text", value: "ElevenLabs conversational defaults", disabled: true }),
              /* @__PURE__ */ jsx4("small", { children: "Native EL style; extra audio-tag UI not wired yet" })
            ] })
          ] }),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("Prompt Templates") }),
          /* @__PURE__ */ jsx4(
            "input",
            {
              className: "alx-tpl-search",
              placeholder: "Search templates by name or description\u2026",
              value: templateQuery,
              onChange: (e) => setTemplateQuery(e.target.value)
            }
          ),
          /* @__PURE__ */ jsxs4("div", { className: "alx-filters", children: [
            /* @__PURE__ */ jsx4(
              "button",
              {
                type: "button",
                className: templateCategory === "all" ? "alx-chip active" : "alx-chip",
                onClick: () => setTemplateCategory("all"),
                children: "All Templates"
              }
            ),
            [
              "receptionist",
              "sales_outbound",
              "support",
              "appointment",
              "survey",
              "general"
            ].map((cat) => /* @__PURE__ */ jsx4(
              "button",
              {
                type: "button",
                className: templateCategory === cat ? "alx-chip active" : "alx-chip",
                onClick: () => setTemplateCategory(cat),
                children: CATEGORY_META[cat].label
              },
              cat
            ))
          ] }),
          /* @__PURE__ */ jsx4("div", { className: "alx-modal-templates", children: filteredTemplates.slice(0, 8).map((tpl) => /* @__PURE__ */ jsxs4(
            "button",
            {
              type: "button",
              className: templateId === tpl.id ? "alx-modal-tpl selected" : "alx-modal-tpl",
              onClick: () => applyTemplate(tpl),
              children: [
                /* @__PURE__ */ jsxs4("b", { children: [
                  CATEGORY_META[tpl.category].icon,
                  " ",
                  tpl.name
                ] }),
                /* @__PURE__ */ jsxs4("span", { children: [
                  tpl.description.slice(0, 120),
                  tpl.description.length > 120 ? "\u2026" : ""
                ] }),
                /* @__PURE__ */ jsx4("span", { style: { color: "#4f46e5", fontWeight: 700 }, children: templateId === tpl.id ? t("Selected \xB7 Use") : t("Use") })
              ]
            },
            tpl.id
          )) }),
          /* @__PURE__ */ jsxs4("button", { type: "button", className: "alx-btn ghost block", onClick: onBrowseTemplates, children: [
            t("Browse all prompt templates"),
            " (",
            templates.length,
            ") \u2192"
          ] }),
          /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
            /* @__PURE__ */ jsx4("span", { children: t("System Prompt *") }),
            /* @__PURE__ */ jsx4(
              "textarea",
              {
                className: "alx-mono",
                rows: 7,
                value: instructions,
                onChange: (e) => setInstructions(e.target.value),
                placeholder: "Select a template above or write your own prompt\u2026"
              }
            ),
            /* @__PURE__ */ jsxs4("small", { children: [
              "Tip: Keep tone consistent. Use variables like ",
              "{{business_name}}",
              " and",
              " ",
              "{{agent_name}}",
              "."
            ] })
          ] }),
          /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
            /* @__PURE__ */ jsx4("span", { children: t("First Message") }),
            /* @__PURE__ */ jsx4(
              "textarea",
              {
                className: "alx-mono",
                rows: 3,
                value: firstMessage,
                onChange: (e) => setFirstMessage(e.target.value)
              }
            ),
            /* @__PURE__ */ jsx4("small", { children: "Best practices: warm and natural. Avoid \u201Cthis is an automated call\u2026\u201D." })
          ] }),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("Available Dynamic Variables") }),
          /* @__PURE__ */ jsx4("div", { className: "alx-var-chips", children: CREATE_DYNAMIC_VARS.map((v) => /* @__PURE__ */ jsx4("code", { children: `{{${v}}}` }, v)) }),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("Knowledge Base (Optional)") }),
          /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
            /* @__PURE__ */ jsx4("span", { children: "Business Brain" }),
            brainOptions.length === 0 ? /* @__PURE__ */ jsxs4("div", { className: "alx-brain-empty", children: [
              /* @__PURE__ */ jsx4("p", { children: "No published Business Brain yet. Publish a brain on the Company knowledge page before pinning knowledge to an agent." }),
              onOpenBrain && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: onOpenBrain, children: "Open Company knowledge" })
            ] }) : /* @__PURE__ */ jsxs4("select", { value: brainId, onChange: (e) => setBrainId(e.target.value), children: [
              /* @__PURE__ */ jsx4("option", { value: "", disabled: true, children: "Select published brain" }),
              brainOptions.map((b) => /* @__PURE__ */ jsx4("option", { value: b.id, children: brainOptionLabel(b) }, b.id))
            ] }),
            /* @__PURE__ */ jsx4("small", { children: "Only brains with a published version appear here. Multi-source content is ingested per brain on the Brain page \u2014 not multi-brain attach." })
          ] }),
          /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("System Tools") }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-tool-grid", children: [
            /* @__PURE__ */ jsxs4("label", { className: "alx-tool-row", children: [
              /* @__PURE__ */ jsx4("input", { type: "checkbox", checked: handoff, onChange: (e) => setHandoff(e.target.checked) }),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("b", { children: t("Enable Call Transfer") }),
                /* @__PURE__ */ jsx4("span", { children: "Agent can hand off to a human operator when needed" })
              ] })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-tool-row", children: [
              /* @__PURE__ */ jsx4(
                "input",
                {
                  type: "checkbox",
                  checked: endConversation,
                  onChange: (e) => setEndConversation(e.target.checked)
                }
              ),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("b", { children: t("Enable End Conversation") }),
                /* @__PURE__ */ jsx4("span", { children: "Let agent intelligently end the call when appropriate" })
              ] })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-tool-row", children: [
              /* @__PURE__ */ jsx4(
                "input",
                {
                  type: "checkbox",
                  checked: callbackSchedule,
                  onChange: (e) => setCallbackSchedule(e.target.checked)
                }
              ),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("b", { children: t("Enable Callback") }),
                /* @__PURE__ */ jsx4("span", { children: "Schedule callback follow-ups during the call" })
              ] })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-tool-row", children: [
              /* @__PURE__ */ jsx4(
                "input",
                {
                  type: "checkbox",
                  checked: appointmentBooking,
                  onChange: (e) => setAppointmentBooking(e.target.checked)
                }
              ),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("b", { children: t("Enable Appointment Booking") }),
                /* @__PURE__ */ jsx4("span", { children: "Record appointment requests; external calendar sync only when workspace has an active calendar connection" })
              ] })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-tool-row", children: [
              /* @__PURE__ */ jsx4(
                "input",
                {
                  type: "checkbox",
                  checked: leadCreate,
                  onChange: (e) => setLeadCreate(e.target.checked)
                }
              ),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("b", { children: t("Enable Lead Capture") }),
                /* @__PURE__ */ jsx4("span", { children: "Create leads from qualified conversations" })
              ] })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-tool-row", children: [
              /* @__PURE__ */ jsx4(
                "input",
                {
                  type: "checkbox",
                  checked: caseCreate,
                  onChange: (e) => setCaseCreate(e.target.checked)
                }
              ),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("b", { children: t("Enable Case Create") }),
                /* @__PURE__ */ jsx4("span", { children: "Open a support case when the issue needs tracking" })
              ] })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-tool-row", style: { opacity: 0.6 }, children: [
              /* @__PURE__ */ jsx4("input", { type: "checkbox", disabled: true }),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("b", { children: t("Enable Language Detection") }),
                /* @__PURE__ */ jsx4("span", { children: "Coming soon \u2014 not exposed as a toggle in this runtime yet" })
              ] })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-tool-row", style: { opacity: 0.6 }, children: [
              /* @__PURE__ */ jsx4("input", { type: "checkbox", disabled: true }),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("b", { children: t("Enable Email Sending") }),
                /* @__PURE__ */ jsx4("span", { children: "Coming soon \u2014 not part of voice tool set on this stack" })
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-modal-foot", children: [
          /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: onClose, disabled: busy, children: "Cancel" }),
          /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn primary", onClick: submit, disabled: busy, children: busy ? "Creating\u2026" : "Create Agent" })
        ] })
      ]
    }
  ) });
};
var WIZARD_STEPS = [
  { id: "useCase", title: "Use Case" },
  { id: "basics", title: "Basic Info" },
  { id: "personality", title: "Personality" },
  { id: "prompts", title: "Prompts" },
  { id: "voice", title: "Voice" },
  { id: "review", title: "Review" }
];
var AiAgentInterviewPage = ({
  api,
  workspaceId,
  locale,
  busy,
  hasPublishedBrain,
  t,
  onBack,
  onOpenBrain,
  onComplete
}) => {
  const [messages, setMessages] = useState3([]);
  const [draft, setDraft] = useState3(null);
  const [progress, setProgress] = useState3(0);
  const [input, setInput] = useState3("");
  const [localError, setLocalError] = useState3();
  const [turnBusy, setTurnBusy] = useState3(false);
  const [session, setSession] = useState3(0);
  const logRef = useRef2(null);
  const applyTurn = (history, result, answer) => {
    const next = [...history];
    if (answer) next.push({ role: "user", content: answer });
    if (result.status === "ask" && result.question) {
      next.push({ role: "assistant", content: result.question });
    }
    return next;
  };
  const ask = async (history, answer) => {
    setTurnBusy(true);
    setLocalError(void 0);
    try {
      const result = await api.interview({
        workspaceId,
        locale,
        messages: history,
        ...answer ? { answer } : {}
      });
      const seeded = history.length === 0 && !answer ? [{ role: "assistant", content: t("Hello, I am your CenterOS assistant. We can set up this agent by talking.") }] : history;
      setMessages(applyTurn(seeded, result, answer));
      setProgress(result.progress);
      if (result.status === "ready" && result.draft) setDraft(result.draft);
      setInput("");
    } catch (cause) {
      setLocalError(cause instanceof Error ? cause.message : t("Interview failed"));
    } finally {
      setTurnBusy(false);
    }
  };
  useEffect3(() => {
    void ask([]);
  }, [session]);
  useEffect3(() => {
    logRef.current?.scrollTo({ top: logRef.current.scrollHeight, behavior: "smooth" });
  }, [messages, draft, turnBusy]);
  const currentQuestion = !draft ? [...messages].reverse().find((item) => item.role === "assistant")?.content : void 0;
  const send = () => {
    const text = input.trim();
    if (!text || turnBusy || draft) return;
    void ask(messages, text);
  };
  const restart = () => {
    setMessages([]);
    setDraft(null);
    setProgress(0);
    setInput("");
    setLocalError(void 0);
    setSession((value) => value + 1);
  };
  return /* @__PURE__ */ jsxs4("div", { className: "alx-asst", children: [
    /* @__PURE__ */ jsxs4("section", { className: "alx-asst-hero", children: [
      /* @__PURE__ */ jsxs4("div", { className: "alx-asst-hero-main", children: [
        /* @__PURE__ */ jsx4("span", { className: "alx-asst-mark", "aria-hidden": "true", children: "\u2726" }),
        /* @__PURE__ */ jsxs4("div", { children: [
          /* @__PURE__ */ jsx4("p", { className: "alx-asst-kicker", children: t("CenterOS") }),
          /* @__PURE__ */ jsx4("h1", { children: t("AI Assistant") }),
          /* @__PURE__ */ jsx4("p", { className: "alx-asst-lead", children: t("Talk here to fill in the missing agent fields. We create a draft only \u2014 you still publish.") })
        ] })
      ] }),
      /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: onBack, children: t("Back to agents") })
    ] }),
    /* @__PURE__ */ jsxs4("section", { className: "alx-asst-card", children: [
      /* @__PURE__ */ jsxs4("header", { className: "alx-asst-card-head", children: [
        /* @__PURE__ */ jsxs4("div", { className: "alx-asst-identity", children: [
          /* @__PURE__ */ jsx4("span", { className: "alx-asst-spark", "aria-hidden": "true", children: "\u2726" }),
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx4("p", { className: "alx-asst-name", children: t("AI Assistant") }),
            /* @__PURE__ */ jsx4("p", { className: "alx-asst-workspace", children: t("Agent setup") })
          ] })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-asst-progress-meta", children: [
          /* @__PURE__ */ jsxs4("span", { className: "alx-asst-badge", children: [
            progress,
            "%"
          ] }),
          /* @__PURE__ */ jsxs4("span", { children: [
            t("Setup progress"),
            " %",
            progress
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-asst-log", ref: logRef, children: [
        messages.map((item, index) => /* @__PURE__ */ jsx4("div", { className: `alx-asst-row ${item.role}`, children: /* @__PURE__ */ jsx4("div", { className: `alx-asst-bubble ${item.role}`, children: item.content }) }, `${item.role}-${index}`)),
        turnBusy ? /* @__PURE__ */ jsx4("div", { className: "alx-asst-row assistant", children: /* @__PURE__ */ jsx4("div", { className: "alx-asst-bubble assistant muted", children: t("Thinking\u2026") }) }) : null
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-asst-composer", children: [
        localError ? /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: localError }) : null,
        !hasPublishedBrain ? /* @__PURE__ */ jsxs4("div", { className: "alx-asst-next warn", children: [
          /* @__PURE__ */ jsx4("p", { className: "alx-asst-next-label", children: t("Business Brain required") }),
          /* @__PURE__ */ jsx4("p", { children: t("Publish a Business Brain first so the interview can pin knowledge.") }),
          onOpenBrain ? /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: onOpenBrain, children: t("Open Company knowledge") }) : null
        ] }) : null,
        currentQuestion && !draft ? /* @__PURE__ */ jsxs4("div", { className: "alx-asst-next", children: [
          /* @__PURE__ */ jsx4("p", { className: "alx-asst-next-label", children: t("Next question") }),
          /* @__PURE__ */ jsx4("p", { children: currentQuestion })
        ] }) : null,
        draft ? /* @__PURE__ */ jsxs4("div", { className: "alx-asst-ready", children: [
          /* @__PURE__ */ jsx4("p", { className: "alx-asst-next-label", children: t("Draft ready") }),
          /* @__PURE__ */ jsx4("h3", { children: draft.name }),
          /* @__PURE__ */ jsxs4("p", { className: "alx-asst-ready-meta", children: [
            draft.role,
            " \xB7 ",
            draft.channelMode,
            " \xB7 ",
            draft.language
          ] }),
          /* @__PURE__ */ jsx4("p", { children: draft.persona }),
          /* @__PURE__ */ jsxs4("div", { className: "alx-asst-actions", children: [
            /* @__PURE__ */ jsx4(
              "button",
              {
                type: "button",
                className: "alx-btn primary",
                disabled: busy || turnBusy || !hasPublishedBrain,
                onClick: () => void onComplete(draft).catch((cause) => {
                  setLocalError(cause instanceof Error ? cause.message : t("Create failed"));
                }),
                children: t("Create draft agent")
              }
            ),
            /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: restart, children: t("Start over") })
          ] })
        ] }) : /* @__PURE__ */ jsxs4(
          "form",
          {
            onSubmit: (event) => {
              event.preventDefault();
              send();
            },
            children: [
              /* @__PURE__ */ jsx4(
                "textarea",
                {
                  value: input,
                  rows: 3,
                  maxLength: 4e3,
                  disabled: turnBusy,
                  placeholder: t("Type your answer\u2026"),
                  onChange: (event) => setInput(event.target.value),
                  onKeyDown: (event) => {
                    if (event.key === "Enter" && !event.shiftKey) {
                      event.preventDefault();
                      send();
                    }
                  }
                }
              ),
              /* @__PURE__ */ jsxs4("div", { className: "alx-asst-actions", children: [
                /* @__PURE__ */ jsx4(
                  "button",
                  {
                    type: "submit",
                    className: "alx-btn primary",
                    disabled: turnBusy || !input.trim(),
                    children: t("Send")
                  }
                ),
                /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: restart, disabled: turnBusy, children: t("Start over") })
              ] })
            ]
          }
        )
      ] })
    ] })
  ] });
};
var GuidedWizardModal = ({
  templates,
  brainOptions,
  busy,
  playingVoiceId,
  t,
  onClose,
  onPreviewVoice,
  onComplete,
  onOpenBrain
}) => {
  const [step, setStep] = useState3("useCase");
  const [templateId, setTemplateId] = useState3("");
  const [channelMode, setChannelMode] = useState3("inbound");
  const [name, setName] = useState3("Customer Support Agent");
  const [role, setRole] = useState3("Customer support specialist");
  const [brainId, setBrainId] = useState3(brainOptions[0]?.id ?? "");
  const [persona, setPersona] = useState3("Clear, calm and concise");
  const [instructions, setInstructions] = useState3(
    "Answer only from published business knowledge. State when verified context is insufficient."
  );
  const [firstMessage, setFirstMessage] = useState3(
    "Hello, thank you for calling {{business_name}}. My name is {{agent_name}}. How may I help you?"
  );
  const [voiceProfileId, setVoiceProfileId] = useState3(DEFAULT_VOICE_PROFILE);
  const [language, setLanguage] = useState3("tr-TR");
  const [temperature, setTemperature] = useState3(0.5);
  const [maxCallSeconds, setMaxCallSeconds] = useState3(1800);
  const [handoff, setHandoff] = useState3(true);
  const [leadCreate, setLeadCreate] = useState3(false);
  const [callbackSchedule, setCallbackSchedule] = useState3(false);
  const [localError, setLocalError] = useState3();
  const stepIndex = WIZARD_STEPS.findIndex((s) => s.id === step);
  const applyTemplate = (tpl) => {
    setTemplateId(tpl.id);
    setName(tpl.name);
    setRole(tpl.role);
    setPersona(tpl.persona);
    setInstructions(tpl.instructions);
    const loc = (tpl.localeHints[0] ?? "tr-TR").toLowerCase();
    setFirstMessage(
      loc.startsWith("en") && tpl.firstMessageEn ? tpl.firstMessageEn : tpl.firstMessage
    );
    setChannelMode(tpl.suggestedChannelMode);
    setVoiceProfileId(tpl.suggestedVoiceProfileId);
    setLanguage(tpl.localeHints[0] ?? "tr-TR");
    setHandoff(tpl.suggestedCapabilities.handoff);
    setLeadCreate(tpl.suggestedCapabilities.leadCreate);
    setCallbackSchedule(tpl.suggestedCapabilities.callbackSchedule);
  };
  const goNext = () => {
    setLocalError(void 0);
    if (step === "useCase" && !templateId && channelMode !== "inbound" && channelMode !== "outbound") {
    }
    if (step === "basics") {
      if (name.trim().length < 2) {
        setLocalError("Enter an agent name (min 2 characters).");
        return;
      }
      if (!brainId) {
        setLocalError("Select a published Business Brain.");
        return;
      }
    }
    if (step === "prompts" && instructions.trim().length < 10) {
      setLocalError("System prompt must be at least 10 characters.");
      return;
    }
    const next = WIZARD_STEPS[stepIndex + 1];
    if (next) setStep(next.id);
  };
  const goBack = () => {
    setLocalError(void 0);
    const prev = WIZARD_STEPS[stepIndex - 1];
    if (prev) setStep(prev.id);
  };
  const finish = async () => {
    setLocalError(void 0);
    if (!brainId) {
      setLocalError("Select a published Business Brain.");
      setStep("basics");
      return;
    }
    const profile = resolveNamedVoiceProfile(voiceProfileId);
    const capabilities = {
      handoff,
      endConversation: true,
      leadCreate,
      callbackSchedule,
      appointmentBooking: false,
      caseCreate: false,
      messagingWhatsappTemplate: false,
      messagingSmsPack: false
    };
    const draft = {
      name: name.trim(),
      role: role.trim() || "Voice agent",
      persona: persona.trim() || "Clear, calm and concise",
      instructions: instructions.trim(),
      firstMessage: firstMessage.trim(),
      channelMode,
      brainId,
      ...templateId ? { templateId } : {},
      blockedTopics: [],
      allowedTools: toolsFromCapabilities(capabilities),
      capabilities,
      voice: {
        profileId: profile.id,
        language,
        voiceId: profileTtsVoiceId(profile),
        recordingEnabled: true,
        recordingNotice: "This call may be recorded for quality purposes.",
        interruptionEnabled: true,
        maxCallSeconds,
        turnTimeoutSeconds: 1.5,
        silenceTimeoutMs: 5e3,
        temperature
      }
    };
    try {
      await onComplete(draft);
    } catch (cause) {
      setLocalError(errorMessage(cause));
    }
  };
  return /* @__PURE__ */ jsx4("div", { className: "alx-modal-backdrop", role: "presentation", onClick: onClose, children: /* @__PURE__ */ jsxs4(
    "div",
    {
      className: "alx-modal alx-wizard-modal",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "alx-wizard-title",
      onClick: (e) => e.stopPropagation(),
      children: [
        /* @__PURE__ */ jsxs4("header", { className: "alx-modal-head", children: [
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx4("h2", { id: "alx-wizard-title", children: t("Guided Wizard") }),
            /* @__PURE__ */ jsx4("p", { children: "Create a production-ready agent step by step (AgentLabs-style)." })
          ] }),
          /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-modal-close", onClick: onClose, "aria-label": "Close", children: "\u2715" })
        ] }),
        /* @__PURE__ */ jsx4("nav", { className: "alx-wizard-steps", "aria-label": "Wizard steps", children: WIZARD_STEPS.map((s, i) => /* @__PURE__ */ jsxs4(
          "button",
          {
            type: "button",
            className: s.id === step ? "active" : i < stepIndex ? "done" : "",
            onClick: () => {
              if (i <= stepIndex) setStep(s.id);
            },
            children: [
              /* @__PURE__ */ jsx4("span", { className: "alx-wizard-num", children: i + 1 }),
              s.title
            ]
          },
          s.id
        )) }),
        /* @__PURE__ */ jsxs4("div", { className: "alx-modal-body alx-wizard-body", children: [
          localError && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: localError }),
          step === "useCase" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
            /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("1 \xB7 Use Case") }),
            /* @__PURE__ */ jsx4("p", { className: "alx-muted", children: "Choose Incoming vs Outgoing, or pick a preset template to prefill the rest." }),
            /* @__PURE__ */ jsxs4("div", { className: "alx-type-grid", children: [
              /* @__PURE__ */ jsxs4(
                "button",
                {
                  type: "button",
                  className: channelMode === "inbound" && !templateId ? "alx-type-card selected" : "alx-type-card",
                  onClick: () => {
                    setChannelMode("inbound");
                    setTemplateId("");
                    setName("Customer Support Agent");
                    setRole("Incoming support agent");
                  },
                  children: [
                    /* @__PURE__ */ jsx4("strong", { children: t("Incoming Agent") }),
                    /* @__PURE__ */ jsx4("span", { children: t("Open-ended AI for inbound calls and human-like dialog.") })
                  ]
                }
              ),
              /* @__PURE__ */ jsxs4(
                "button",
                {
                  type: "button",
                  className: channelMode === "outbound" && !templateId ? "alx-type-card selected" : "alx-type-card",
                  onClick: () => {
                    setChannelMode("outbound");
                    setTemplateId("");
                    setName("Outbound Campaign Agent");
                    setRole("Outbound sales agent");
                  },
                  children: [
                    /* @__PURE__ */ jsx4("strong", { children: t("Outgoing / Custom Voice") }),
                    /* @__PURE__ */ jsx4("span", { children: t("Best for campaigns, reminders and dialer use.") })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("Or use a template") }),
            /* @__PURE__ */ jsx4("div", { className: "alx-modal-templates", children: templates.slice(0, 8).map((tpl) => /* @__PURE__ */ jsxs4(
              "button",
              {
                type: "button",
                className: templateId === tpl.id ? "alx-modal-tpl selected" : "alx-modal-tpl",
                onClick: () => applyTemplate(tpl),
                children: [
                  /* @__PURE__ */ jsxs4("b", { children: [
                    CATEGORY_META[tpl.category].icon,
                    " ",
                    tpl.name
                  ] }),
                  /* @__PURE__ */ jsxs4("span", { children: [
                    tpl.description.slice(0, 100),
                    "\u2026"
                  ] })
                ]
              },
              tpl.id
            )) })
          ] }),
          step === "basics" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
            /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("2 \xB7 Basic Info") }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Agent Name") }),
              /* @__PURE__ */ jsx4("input", { value: name, onChange: (e) => setName(e.target.value), placeholder: "Enter agent name" })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Role") }),
              /* @__PURE__ */ jsx4("input", { value: role, onChange: (e) => setRole(e.target.value) })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Agent direction (inbound / outbound)") }),
              /* @__PURE__ */ jsx4(
                "select",
                {
                  value: channelMode,
                  onChange: (e) => setChannelMode(e.target.value),
                  children: Object.keys(CHANNEL_LABELS).map((id) => /* @__PURE__ */ jsx4("option", { value: id, children: t(CHANNEL_LABELS[id]) }, id))
                }
              ),
              /* @__PURE__ */ jsx4("small", { className: "alx-field-hint", children: t(channelModeHelp(channelMode)) })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Knowledge Base (Business Brain)") }),
              brainOptions.length === 0 ? /* @__PURE__ */ jsxs4("div", { className: "alx-brain-empty", children: [
                /* @__PURE__ */ jsx4("p", { children: "No published Business Brain yet. Publish one on the Company knowledge page before continuing." }),
                onOpenBrain && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: onOpenBrain, children: "Open Company knowledge" })
              ] }) : /* @__PURE__ */ jsxs4("select", { value: brainId, onChange: (e) => setBrainId(e.target.value), children: [
                /* @__PURE__ */ jsx4("option", { value: "", children: t("Select Brain") }),
                brainOptions.map((b) => /* @__PURE__ */ jsx4("option", { value: b.id, children: brainOptionLabel(b) }, b.id))
              ] }),
              /* @__PURE__ */ jsx4("small", { children: "Published versions only. Multi-source ingestion lives on the Brain page (sources per brain), not multi-brain attach on the agent." })
            ] })
          ] }),
          step === "personality" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
            /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("3 \xB7 Personality") }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Personality") }),
              /* @__PURE__ */ jsx4(
                "textarea",
                {
                  rows: 4,
                  value: persona,
                  onChange: (e) => setPersona(e.target.value),
                  placeholder: t("Describe the agent's personality and behavior")
                }
              )
            ] }),
            /* @__PURE__ */ jsxs4("div", { className: "alx-checks", children: [
              /* @__PURE__ */ jsxs4("label", { children: [
                /* @__PURE__ */ jsx4("input", { type: "checkbox", checked: handoff, onChange: (e) => setHandoff(e.target.checked) }),
                "Call transfer / handoff"
              ] }),
              /* @__PURE__ */ jsxs4("label", { children: [
                /* @__PURE__ */ jsx4("input", { type: "checkbox", checked: leadCreate, onChange: (e) => setLeadCreate(e.target.checked) }),
                "Lead capture"
              ] }),
              /* @__PURE__ */ jsxs4("label", { children: [
                /* @__PURE__ */ jsx4(
                  "input",
                  {
                    type: "checkbox",
                    checked: callbackSchedule,
                    onChange: (e) => setCallbackSchedule(e.target.checked)
                  }
                ),
                "Callback / appointment request"
              ] })
            ] })
          ] }),
          step === "prompts" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
            /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("4 \xB7 Prompts") }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("System Prompt") }),
              /* @__PURE__ */ jsx4(
                "textarea",
                {
                  className: "alx-mono",
                  rows: 8,
                  value: instructions,
                  onChange: (e) => setInstructions(e.target.value)
                }
              ),
              /* @__PURE__ */ jsxs4("small", { children: [
                "Supports ",
                "{{business_name}}",
                " ",
                "{{agent_name}}",
                " ",
                "{{purpose}}"
              ] })
            ] }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("First Message") }),
              /* @__PURE__ */ jsx4(
                "textarea",
                {
                  className: "alx-mono",
                  rows: 3,
                  value: firstMessage,
                  onChange: (e) => setFirstMessage(e.target.value)
                }
              )
            ] })
          ] }),
          step === "voice" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
            /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("5 \xB7 Voice") }),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Select Voice") }),
              /* @__PURE__ */ jsx4("select", { value: voiceProfileId, onChange: (e) => setVoiceProfileId(e.target.value), children: voiceOptions.map((v) => /* @__PURE__ */ jsx4("option", { value: v.id, children: v.label }, v.id)) })
            ] }),
            /* @__PURE__ */ jsx4(
              "button",
              {
                type: "button",
                className: "alx-btn ghost",
                disabled: busy && playingVoiceId !== voiceProfileId,
                onClick: () => onPreviewVoice(voiceProfileId),
                children: playingVoiceId === voiceProfileId ? t("\u25A0 Stop") : `\u25B6 ${t("Play sample")}`
              }
            ),
            /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
              /* @__PURE__ */ jsx4("span", { children: t("Language") }),
              /* @__PURE__ */ jsx4("input", { value: language, onChange: (e) => setLanguage(e.target.value) })
            ] }),
            /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
              /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                /* @__PURE__ */ jsx4("span", { children: t("Temperature") }),
                /* @__PURE__ */ jsx4(
                  "input",
                  {
                    type: "number",
                    min: 0,
                    max: 1,
                    step: 0.05,
                    value: temperature,
                    onChange: (e) => setTemperature(Number(e.target.value))
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                /* @__PURE__ */ jsx4("span", { children: t("Max duration (sec)") }),
                /* @__PURE__ */ jsx4(
                  "input",
                  {
                    type: "number",
                    min: 30,
                    max: 14400,
                    value: maxCallSeconds,
                    onChange: (e) => setMaxCallSeconds(Number(e.target.value))
                  }
                )
              ] })
            ] })
          ] }),
          step === "review" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
            /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: t("6 \xB7 Review") }),
            /* @__PURE__ */ jsxs4("dl", { className: "alx-review", children: [
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("dt", { children: t("Name") }),
                /* @__PURE__ */ jsx4("dd", { children: name })
              ] }),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("dt", { children: t("Direction") }),
                /* @__PURE__ */ jsx4("dd", { children: t(CHANNEL_LABELS[channelMode]) })
              ] }),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("dt", { children: t("Brain") }),
                /* @__PURE__ */ jsx4("dd", { children: (() => {
                  const b = brainOptions.find((x) => x.id === brainId);
                  return b ? brainOptionLabel(b) : "\u2014";
                })() })
              ] }),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("dt", { children: t("Voice") }),
                /* @__PURE__ */ jsxs4("dd", { children: [
                  resolveNamedVoiceProfile(voiceProfileId).label,
                  " \xB7 ",
                  language
                ] })
              ] }),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("dt", { children: t("Template") }),
                /* @__PURE__ */ jsx4("dd", { children: templateId || "Custom" })
              ] }),
              /* @__PURE__ */ jsxs4("div", { children: [
                /* @__PURE__ */ jsx4("dt", { children: t("First message") }),
                /* @__PURE__ */ jsxs4("dd", { children: [
                  firstMessage.slice(0, 120),
                  firstMessage.length > 120 ? "\u2026" : ""
                ] })
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs4("footer", { className: "alx-wizard-footer", children: [
          /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: stepIndex === 0 ? onClose : goBack, children: stepIndex === 0 ? "Cancel" : "Back" }),
          step !== "review" ? /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn primary", onClick: goNext, disabled: busy, children: "Continue" }) : /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn primary", onClick: () => void finish(), disabled: busy, children: busy ? "Creating\u2026" : "Create Agent" })
        ] })
      ]
    }
  ) });
};
var DEFAULT_VOICE_PROFILE = "tr_female_warm";
var CHANNEL_LABELS = {
  inbound: "Incoming (answer phone)",
  outbound: "Outgoing (dial / campaigns)",
  webchat: "Webchat",
  omni: "Omni (all channels)"
};
var channelModeHelp = (mode) => {
  switch (mode) {
    case "inbound":
      return "Inbound agent: bind a published agent to a DID on Numbers (Gelen ba\u011F). Answers ringing phones.";
    case "outbound":
      return "Outbound agent: use Campaigns or Agent dial panel. Does not answer inbound DID by itself.";
    case "webchat":
      return "Webchat agent: text/chat widget path. Voice campaign dial uses outbound agents.";
    default:
      return "Omni agent: can be used for mixed paths; prefer explicit Incoming or Outgoing for ops clarity.";
  }
};
var nextStepId = (steps) => {
  let n = steps.length + 1;
  const used = new Set(steps.map((s) => s.id));
  while (used.has(`s${n}`)) n += 1;
  return `s${n}`;
};
var STEP_KIND_LABEL = PLAYBOOK_STEP_KIND_LABEL;
var PlaybookStepFields = ({
  step,
  index,
  steps,
  updateStep,
  t
}) => {
  const otherStepIds = steps.filter((s) => s.id !== step.id).map((s) => s.id);
  return /* @__PURE__ */ jsxs4(Fragment3, { children: [
    step.kind === "message" && /* @__PURE__ */ jsx4(
      "textarea",
      {
        rows: 2,
        value: step.text,
        onChange: (e) => updateStep(index, { ...step, text: e.target.value })
      }
    ),
    step.kind === "question" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
      /* @__PURE__ */ jsx4(
        "textarea",
        {
          rows: 2,
          value: step.text,
          onChange: (e) => updateStep(index, { ...step, text: e.target.value })
        }
      ),
      /* @__PURE__ */ jsx4(
        "input",
        {
          placeholder: "saveAs (optional)",
          value: step.saveAs ?? "",
          onChange: (e) => updateStep(index, {
            ...step,
            saveAs: e.target.value.trim() || void 0
          })
        }
      )
    ] }),
    step.kind === "branch" && /* @__PURE__ */ jsxs4(Fragment3, { children: [
      /* @__PURE__ */ jsx4(
        "input",
        {
          value: step.prompt,
          onChange: (e) => updateStep(index, { ...step, prompt: e.target.value })
        }
      ),
      step.options.map((opt, oi) => /* @__PURE__ */ jsxs4("div", { className: "alx-playbook-branch-opt", children: [
        /* @__PURE__ */ jsx4(
          "input",
          {
            value: opt.label,
            placeholder: `Option ${String.fromCharCode(65 + oi)}`,
            onChange: (e) => {
              const options = step.options.map(
                (o, i) => i === oi ? { ...o, label: e.target.value } : o
              );
              updateStep(index, { ...step, options });
            }
          }
        ),
        /* @__PURE__ */ jsx4(
          "input",
          {
            value: opt.nextHint ?? "",
            placeholder: "next hint",
            onChange: (e) => {
              const options = step.options.map(
                (o, i) => i === oi ? { ...o, nextHint: e.target.value.trim() || void 0 } : o
              );
              updateStep(index, { ...step, options });
            }
          }
        ),
        /* @__PURE__ */ jsxs4("label", { className: "alx-playbook-next-step", children: [
          /* @__PURE__ */ jsx4("span", { children: t("Next step") }),
          /* @__PURE__ */ jsxs4(
            "select",
            {
              value: opt.nextStepId ?? "",
              onChange: (e) => {
                const v = e.target.value.trim();
                const options = step.options.map(
                  (o, i) => i === oi ? { ...o, nextStepId: v || void 0 } : o
                );
                updateStep(index, { ...step, options });
              },
              children: [
                /* @__PURE__ */ jsx4("option", { value: "", children: t("Sequential (default)") }),
                otherStepIds.map((id) => /* @__PURE__ */ jsx4("option", { value: id, children: id }, id))
              ]
            }
          )
        ] })
      ] }, oi)),
      step.options.length < 3 && /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-btn ghost",
          onClick: () => updateStep(index, {
            ...step,
            options: [
              ...step.options,
              { label: `Se\xE7enek ${String.fromCharCode(65 + step.options.length)}` }
            ]
          }),
          children: "+ option"
        }
      )
    ] }),
    step.kind === "end" && /* @__PURE__ */ jsx4(
      "textarea",
      {
        rows: 2,
        value: step.text ?? "",
        onChange: (e) => updateStep(index, { ...step, text: e.target.value })
      }
    ),
    step.kind === "handoff" && /* @__PURE__ */ jsx4(
      "textarea",
      {
        rows: 2,
        value: step.reason ?? "",
        onChange: (e) => updateStep(index, { ...step, reason: e.target.value })
      }
    ),
    step.kind === "lead" && /* @__PURE__ */ jsx4(
      "textarea",
      {
        rows: 2,
        value: step.note ?? "",
        onChange: (e) => updateStep(index, { ...step, note: e.target.value })
      }
    ),
    step.kind === "appointment" && /* @__PURE__ */ jsx4(
      "textarea",
      {
        rows: 2,
        value: step.note ?? "",
        onChange: (e) => updateStep(index, { ...step, note: e.target.value })
      }
    )
  ] });
};
var PlaybookEditor = ({
  playbook,
  onChange,
  t
}) => {
  const steps = playbook?.steps ?? [];
  const [viewMode, setViewMode] = useState3("list");
  const [selectedStepId, setSelectedStepId] = useState3(null);
  const commit = (nextSteps) => {
    if (nextSteps.length === 0) {
      onChange(null);
      setSelectedStepId(null);
      return;
    }
    onChange(
      agentPlaybookSchema.parse({
        version: 1,
        compileIntoInstructions: true,
        steps: nextSteps
      })
    );
  };
  const addStep = (kind) => {
    const id = nextStepId(steps);
    let step;
    switch (kind) {
      case "message":
        step = { id, kind, text: "K\u0131sa bir mesaj s\xF6yle." };
        break;
      case "question":
        step = { id, kind, text: "Tek bir soru sor.", saveAs: "answer" };
        break;
      case "branch":
        step = {
          id,
          kind,
          prompt: "Cevaba g\xF6re y\xF6nlendir.",
          options: [
            { label: "Se\xE7enek A", nextHint: "sonraki ad\u0131m" },
            { label: "Se\xE7enek B", nextHint: "alternatif" }
          ]
        };
        break;
      case "end":
        step = { id, kind, text: "Te\u015Fekk\xFCr et ve kapat." };
        break;
      case "handoff":
        step = { id, kind, reason: "\u0130nsana aktar (handoff.request)." };
        break;
      case "lead":
        step = { id, kind, note: "lead.create ile kaydet." };
        break;
      case "appointment":
        step = {
          id,
          kind,
          note: "Tercih edilen g\xFCn/saat ve hizmeti al; appointment.book kayd\u0131; aktif takvim ba\u011Flant\u0131s\u0131 varsa senkron dener."
        };
        break;
      default:
        return;
    }
    commit([...steps, step]);
    if (viewMode === "flow") setSelectedStepId(id);
  };
  const updateStep = (index, step) => {
    const next = [...steps];
    next[index] = step;
    commit(next);
  };
  const removeStep = (index) => {
    const removed = steps[index];
    commit(steps.filter((_, i) => i !== index));
    if (removed && selectedStepId === removed.id) setSelectedStepId(null);
  };
  const moveStep = (index, dir) => {
    const j = index + dir;
    if (j < 0 || j >= steps.length) return;
    const next = [...steps];
    const a = next[index];
    next[index] = next[j];
    next[j] = a;
    commit(next);
  };
  const selectedIndex = selectedStepId ? steps.findIndex((s) => s.id === selectedStepId) : -1;
  const selectedStep = selectedIndex >= 0 ? steps[selectedIndex] : null;
  return /* @__PURE__ */ jsxs4("div", { className: "alx-playbook", children: [
    /* @__PURE__ */ jsxs4("div", { className: "alx-playbook-toolbar", children: [
      /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-btn ghost",
          onClick: () => {
            const starter = defaultInboundPlaybook();
            onChange(starter);
            setSelectedStepId(starter.steps[0]?.id ?? null);
          },
          children: t("Load starter playbook")
        }
      ),
      steps.length > 0 && /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-btn ghost",
          onClick: () => {
            onChange(null);
            setSelectedStepId(null);
          },
          children: t("Clear playbook")
        }
      )
    ] }),
    /* @__PURE__ */ jsxs4("div", { className: "alx-playbook-view-toggle", role: "group", "aria-label": t("Playbook view"), children: [
      /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: viewMode === "list" ? "active" : void 0,
          onClick: () => setViewMode("list"),
          children: t("Liste")
        }
      ),
      /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: viewMode === "flow" ? "active" : void 0,
          onClick: () => setViewMode("flow"),
          children: t("Ak\u0131\u015F")
        }
      )
    ] }),
    viewMode === "list" ? steps.length === 0 ? /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: t("No playbook steps yet. Add a step or load the starter.") }) : /* @__PURE__ */ jsx4("ol", { className: "alx-playbook-steps", children: steps.map((step, index) => /* @__PURE__ */ jsxs4("li", { className: "alx-playbook-step", children: [
      /* @__PURE__ */ jsxs4("div", { className: "alx-playbook-step-head", children: [
        /* @__PURE__ */ jsxs4("strong", { children: [
          index + 1,
          ". ",
          STEP_KIND_LABEL[step.kind]
        ] }),
        /* @__PURE__ */ jsxs4("span", { className: "alx-playbook-step-actions", children: [
          /* @__PURE__ */ jsx4("button", { type: "button", disabled: index === 0, onClick: () => moveStep(index, -1), children: "\u2191" }),
          /* @__PURE__ */ jsx4(
            "button",
            {
              type: "button",
              disabled: index === steps.length - 1,
              onClick: () => moveStep(index, 1),
              children: "\u2193"
            }
          ),
          /* @__PURE__ */ jsx4("button", { type: "button", onClick: () => removeStep(index), children: "\u2715" })
        ] })
      ] }),
      /* @__PURE__ */ jsx4(
        PlaybookStepFields,
        {
          step,
          index,
          steps,
          updateStep,
          t
        }
      )
    ] }, step.id)) }) : /* @__PURE__ */ jsxs4("div", { className: "alx-playbook-flow-layout", children: [
      /* @__PURE__ */ jsx4(
        PlaybookFlowCanvas,
        {
          steps,
          selectedStepId,
          onSelectStep: setSelectedStepId,
          t
        }
      ),
      /* @__PURE__ */ jsx4("div", { className: "alx-playbook-flow-panel", children: selectedStep && selectedIndex >= 0 ? /* @__PURE__ */ jsxs4(Fragment3, { children: [
        /* @__PURE__ */ jsxs4("div", { className: "alx-playbook-step-head", children: [
          /* @__PURE__ */ jsxs4("strong", { children: [
            selectedIndex + 1,
            ". ",
            STEP_KIND_LABEL[selectedStep.kind],
            " ",
            /* @__PURE__ */ jsxs4("span", { className: "alx-playbook-flow-node-id", children: [
              "(",
              selectedStep.id,
              ")"
            ] })
          ] }),
          /* @__PURE__ */ jsx4("span", { className: "alx-playbook-step-actions", children: /* @__PURE__ */ jsx4("button", { type: "button", onClick: () => removeStep(selectedIndex), children: "\u2715" }) })
        ] }),
        /* @__PURE__ */ jsx4("div", { className: "alx-playbook-step alx-playbook-flow-panel-fields", children: /* @__PURE__ */ jsx4(
          PlaybookStepFields,
          {
            step: selectedStep,
            index: selectedIndex,
            steps,
            updateStep,
            t
          }
        ) })
      ] }) : /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: t("Select a step on the canvas to edit fields.") }) })
    ] }),
    /* @__PURE__ */ jsx4("div", { className: "alx-playbook-add", children: Object.keys(STEP_KIND_LABEL).map((kind) => /* @__PURE__ */ jsxs4("button", { type: "button", className: "alx-btn ghost", onClick: () => addStep(kind), children: [
      "+ ",
      STEP_KIND_LABEL[kind]
    ] }, kind)) })
  ] });
};
var WidgetBuilder = ({
  widget,
  onChange,
  agentName,
  t
}) => {
  const patch = (partial) => {
    onChange(agentWidgetConfigSchema.parse({ ...widget, ...partial }));
  };
  const domainsText = (widget.allowedDomains ?? []).join("\n");
  const hoursDays = widget.businessHours?.days ?? [];
  const monFri = hoursDays.length === 5 && [1, 2, 3, 4, 5].every((d) => hoursDays.some((x) => x.day === d));
  return /* @__PURE__ */ jsxs4("div", { className: "alx-widget-builder", children: [
    /* @__PURE__ */ jsx4("div", { className: "alx-widget-preview", style: { ["--centeros-primary"]: widget.primaryColor }, children: /* @__PURE__ */ jsxs4("div", { className: "alx-widget-preview-card", children: [
      /* @__PURE__ */ jsxs4("header", { style: { background: widget.primaryColor }, children: [
        /* @__PURE__ */ jsx4("b", { children: widget.title?.trim() || agentName }),
        /* @__PURE__ */ jsx4("small", { children: widget.subtitle?.trim() || t("Verified AI agent") })
      ] }),
      /* @__PURE__ */ jsx4("div", { className: "alx-widget-preview-body", children: widget.welcomeMessage?.trim() || t("Hi! How can we help?") }),
      /* @__PURE__ */ jsx4("footer", { children: /* @__PURE__ */ jsx4("span", { className: "alx-widget-launcher", style: { background: widget.primaryColor }, children: widget.launcherLabel || "Chat" }) })
    ] }) }),
    /* @__PURE__ */ jsxs4("div", { className: "alx-widget-fields", children: [
      /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
        /* @__PURE__ */ jsx4("span", { children: t("Widget enabled") }),
        /* @__PURE__ */ jsx4(
          "input",
          {
            type: "checkbox",
            checked: widget.enabled,
            onChange: (e) => patch({ enabled: e.target.checked })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
        /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
          /* @__PURE__ */ jsx4("span", { children: t("Title") }),
          /* @__PURE__ */ jsx4(
            "input",
            {
              value: widget.title ?? "",
              placeholder: agentName,
              onChange: (e) => patch({ title: e.target.value.trim() || void 0 })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
          /* @__PURE__ */ jsx4("span", { children: t("Launcher label") }),
          /* @__PURE__ */ jsx4(
            "input",
            {
              value: widget.launcherLabel,
              onChange: (e) => patch({ launcherLabel: e.target.value || "Chat" })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
        /* @__PURE__ */ jsx4("span", { children: t("Subtitle") }),
        /* @__PURE__ */ jsx4(
          "input",
          {
            value: widget.subtitle ?? "",
            onChange: (e) => patch({ subtitle: e.target.value.trim() || void 0 })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
        /* @__PURE__ */ jsx4("span", { children: t("Welcome message") }),
        /* @__PURE__ */ jsx4(
          "textarea",
          {
            rows: 2,
            value: widget.welcomeMessage ?? "",
            onChange: (e) => patch({ welcomeMessage: e.target.value.trim() || void 0 })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
        /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
          /* @__PURE__ */ jsx4("span", { children: t("Primary color") }),
          /* @__PURE__ */ jsx4(
            "input",
            {
              type: "color",
              value: widget.primaryColor,
              onChange: (e) => patch({ primaryColor: e.target.value })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
          /* @__PURE__ */ jsx4("span", { children: t("Position") }),
          /* @__PURE__ */ jsxs4(
            "select",
            {
              value: widget.position,
              onChange: (e) => patch({ position: e.target.value }),
              children: [
                /* @__PURE__ */ jsx4("option", { value: "bottom-right", children: "Bottom right" }),
                /* @__PURE__ */ jsx4("option", { value: "bottom-left", children: "Bottom left" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
        /* @__PURE__ */ jsx4("span", { children: t("Allowed domains (one per line; empty = all)") }),
        /* @__PURE__ */ jsx4(
          "textarea",
          {
            rows: 3,
            placeholder: "example.com\n*.example.com",
            value: domainsText,
            onChange: (e) => patch({
              allowedDomains: e.target.value.split(/[\n,]+/u).map((s) => s.trim()).filter(Boolean).slice(0, 20)
            })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
        /* @__PURE__ */ jsx4("span", { children: t("Business hours") }),
        /* @__PURE__ */ jsx4("div", { className: "alx-checks", children: /* @__PURE__ */ jsxs4("label", { children: [
          /* @__PURE__ */ jsx4(
            "input",
            {
              type: "checkbox",
              checked: monFri,
              onChange: (e) => {
                if (e.target.checked) {
                  patch({
                    businessHours: {
                      timezone: widget.businessHours?.timezone ?? "Europe/Istanbul",
                      days: [1, 2, 3, 4, 5].map((day) => ({
                        day,
                        open: "09:00",
                        close: "18:00"
                      }))
                    }
                  });
                } else {
                  patch({
                    businessHours: {
                      timezone: widget.businessHours?.timezone ?? "Europe/Istanbul",
                      days: []
                    }
                  });
                }
              }
            }
          ),
          "Mon\u2013Fri 09:00\u201318:00 (Europe/Istanbul)"
        ] }) }),
        /* @__PURE__ */ jsx4("small", { children: t("Empty hours = always open. Client soft-gates the launcher.") })
      ] }),
      /* @__PURE__ */ jsx4("label", { className: "alx-checks", children: /* @__PURE__ */ jsxs4("label", { children: [
        /* @__PURE__ */ jsx4(
          "input",
          {
            type: "checkbox",
            checked: widget.showBranding,
            onChange: (e) => patch({ showBranding: e.target.checked })
          }
        ),
        t("Show \u201CVerified AI agent\u201D branding")
      ] }) })
    ] })
  ] });
};
var AgentEditor = ({
  agent,
  seed,
  brainOptions,
  brains,
  api,
  busy,
  notice,
  error,
  messages,
  deployment,
  conversationId,
  playingVoiceId,
  voiceCatalog,
  voiceCatalogError,
  voiceApi,
  contactsApi,
  integrationsApi,
  operationsApi,
  phoneNumbersApi,
  workspaceId,
  t,
  onBack,
  onOpenIntegrations,
  onOpenNumbers,
  onOpenBrain,
  onOpenDirectory,
  onOpenVoices,
  onPublish,
  onDelete,
  onSave,
  onSimulate,
  onSimulatePhrase,
  onPreviewVoice
}) => {
  const caps = agent.config?.capabilities ? agent.config.capabilities : capabilitiesFromTools(agent.config?.allowedTools ?? seed?.suggestedTools ?? []);
  const channel = agent.config?.channelMode ?? seed?.suggestedChannelMode ?? "omni";
  const [selectedProfileId, setSelectedProfileId] = useState3(
    supportedVoiceProfileId(
      agent.config?.voice.profileId ?? seed?.suggestedVoiceProfileId,
      agent.config?.voice.voiceId
    )
  );
  const libraryVoices = voiceCatalog?.items ?? [];
  const [selectedLibraryVoiceId, setSelectedLibraryVoiceId] = useState3(
    () => agent.config?.voice.voiceId || profileTtsVoiceId(resolveNamedVoiceProfile(selectedProfileId), "elevenlabs")
  );
  useEffect3(() => {
    const voice = agent.config?.voice;
    if (!voice) return;
    setSelectedProfileId(
      supportedVoiceProfileId(voice.profileId ?? seed?.suggestedVoiceProfileId, voice.voiceId)
    );
    if (voice.voiceId?.trim()) {
      setSelectedLibraryVoiceId(voice.voiceId.trim());
    }
    if (voice.ttsProvider === "openai" || voice.ttsProvider === "elevenlabs") {
      setTtsProvider(voice.ttsProvider);
    }
  }, [agent.id, agent.draftVersion, agent.config?.voice?.voiceId, agent.config?.voice?.profileId, agent.config?.voice?.ttsProvider, seed?.suggestedVoiceProfileId]);
  useEffect3(() => {
    const parsedRuntime = agentVoiceRuntimeSchema.safeParse(agent.config?.voiceRuntime);
    setVoiceRuntime(parsedRuntime.success ? parsedRuntime.data : "pipeline");
    const parsedRealtime = agentRealtimeModelSchema.safeParse(agent.config?.realtimeModel);
    if (parsedRealtime.success) setRealtimeModel(parsedRealtime.data);
  }, [agent.id, agent.draftVersion, agent.config?.voiceRuntime, agent.config?.realtimeModel]);
  const [personaText, setPersonaText] = useState3(
    () => agent.config?.persona ?? seed?.persona ?? ""
  );
  const [personalityPresetId, setPersonalityPresetId] = useState3(
    () => agent.config?.personalityPresetId ?? ""
  );
  const [playbook, setPlaybook] = useState3(() => {
    const raw = agent.config?.playbook;
    if (!raw) return null;
    try {
      return agentPlaybookSchema.parse(raw);
    } catch {
      return null;
    }
  });
  const [widget, setWidget] = useState3(() => {
    try {
      return agentWidgetConfigSchema.parse(agent.config?.widget ?? {});
    } catch {
      return defaultAgentWidgetConfig();
    }
  });
  const [snippetCopied, setSnippetCopied] = useState3(false);
  const [workspaceTools, setWorkspaceTools] = useState3([]);
  const [connectors, setConnectors] = useState3([]);
  const [servicesError, setServicesError] = useState3();
  const [rateCard, setRateCard] = useState3(null);
  const [workspaceNumbers, setWorkspaceNumbers] = useState3([]);
  const [ttsProvider, setTtsProvider] = useState3(
    () => agent.config?.voice?.ttsProvider ?? "elevenlabs"
  );
  const [llmModel, setLlmModel] = useState3(() => {
    const raw = agent.config?.llmModel;
    const parsed = agentLlmModelSchema.safeParse(raw);
    return parsed.success ? parsed.data : "gpt-4o-mini";
  });
  const [voiceRuntime, setVoiceRuntime] = useState3(() => {
    const parsed = agentVoiceRuntimeSchema.safeParse(agent.config?.voiceRuntime);
    return parsed.success ? parsed.data : "pipeline";
  });
  const [realtimeModel, setRealtimeModel] = useState3(() => {
    const parsed = agentRealtimeModelSchema.safeParse(agent.config?.realtimeModel);
    return parsed.success ? parsed.data : "gpt-realtime-2.1";
  });
  const [sttProvider, setSttProvider] = useState3(() => {
    const parsed = agentSttProviderSchema.safeParse(agent.config?.sttProvider);
    return parsed.success ? parsed.data : "auto";
  });
  const [sttModel, setSttModel] = useState3(() => {
    const parsed = agentSttModelSchema.safeParse(agent.config?.sttModel);
    return parsed.success ? parsed.data : "";
  });
  const [knowledgeMode, setKnowledgeMode] = useState3(
    () => agent.config?.knowledgeMode ?? "brain"
  );
  const [inlineKnowledge, setInlineKnowledge] = useState3(
    () => agent.config?.inlineKnowledge ?? ""
  );
  const [voiceKnowledgeMode, setVoiceKnowledgeMode] = useState3(() => agent.config?.voiceKnowledgeMode ?? "brain");
  const [conversationStyle, setConversationStyle] = useState3(() => agent.config?.conversationStyle ?? "informative");
  const [conversationControl, setConversationControl] = useState3(() => agent.config?.conversationControl);
  const [voiceKnowledgeDepth, setVoiceKnowledgeDepth] = useState3(
    () => agent.config?.voiceKnowledgeDepth ?? DEFAULT_VOICE_KNOWLEDGE_DEPTH
  );
  const [knowledgeSaveError, setKnowledgeSaveError] = useState3();
  const [retrieveQuery, setRetrieveQuery] = useState3("");
  const [retrieveBusy, setRetrieveBusy] = useState3(false);
  const [retrieveError, setRetrieveError] = useState3();
  const [retrieveHits, setRetrieveHits] = useState3(null);
  const publishedBrains = useMemo2(
    () => brainOptions.filter((b) => b.publishedVersion != null),
    [brainOptions]
  );
  const pinnedBrainId = agent.config?.brainId ?? "";
  const pinnedBrainMeta = brainOptions.find((b) => b.id === pinnedBrainId);
  const pinnedIsPublished = pinnedBrainMeta?.publishedVersion != null;
  const defaultPublishedBrainId = (pinnedIsPublished ? pinnedBrainId : "") || publishedBrains[0]?.id || "";
  const [selectedBrainId, setSelectedBrainId] = useState3(defaultPublishedBrainId);
  const [selectedServiceTools, setSelectedServiceTools] = useState3(() => {
    const initial = /* @__PURE__ */ new Set();
    for (const tool of agent.config?.allowedTools ?? []) {
      if (tool.startsWith("customer:") || tool.startsWith("connector:")) initial.add(tool);
    }
    return initial;
  });
  const [messagingWhatsappTemplate, setMessagingWhatsappTemplate] = useState3(
    () => caps.messagingWhatsappTemplate ?? (agent.config?.allowedTools ?? []).some(isWhatsAppMessagingConnectorTool)
  );
  const [messagingSmsPack, setMessagingSmsPack] = useState3(
    () => caps.messagingSmsPack ?? false
  );
  const [showAdvanced, setShowAdvanced] = useState3(false);
  const [ambienceBedId, setAmbienceBedId] = useState3(agent.config?.voice.ambienceBedId ?? "office");
  const [ambienceGainValue, setAmbienceGainValue] = useState3(
    agent.config?.voice.ambienceGain ?? 0.12
  );
  const ambiencePreviewAudioRef = useRef2(null);
  const [ambienceLibrary, setAmbienceLibrary] = useState3([]);
  const [ambiencePreviewSrc, setAmbiencePreviewSrc] = useState3(() => {
    const current = agent.config?.voice.ambienceBedId ?? "office";
    return current === "none" || current.startsWith("custom:") ? "" : "/ambience/office-24734.mp3";
  });
  const [ambienceBusy, setAmbienceBusy] = useState3(false);
  const [ambienceError, setAmbienceError] = useState3();
  const isPublished = agent.publishedVersion != null;
  useEffect3(() => {
    let cancelled = false;
    const load = async () => {
      setServicesError(void 0);
      try {
        const [tools, connectorPage, card, numbers] = await Promise.all([
          integrationsApi ? integrationsApi.listTools(workspaceId) : Promise.resolve([]),
          operationsApi ? operationsApi.connectors(workspaceId) : Promise.resolve([]),
          phoneNumbersApi ? phoneNumbersApi.rateCard(workspaceId).catch(() => null) : Promise.resolve(null),
          phoneNumbersApi ? phoneNumbersApi.list(workspaceId).then((page) => page.items).catch(() => []) : Promise.resolve([])
        ]);
        if (cancelled) return;
        setWorkspaceTools(tools);
        setConnectors(connectorPage);
        setRateCard(card);
        setWorkspaceNumbers(numbers);
      } catch (cause) {
        if (!cancelled) {
          setServicesError(cause instanceof Error ? cause.message : "SERVICES_LOAD_FAILED");
        }
      }
    };
    void load();
    return () => {
      cancelled = true;
    };
  }, [integrationsApi, operationsApi, phoneNumbersApi, workspaceId, agent.id]);
  useEffect3(() => {
    let cancelled = false;
    void api.listAmbience(workspaceId).then((items) => {
      if (!cancelled) setAmbienceLibrary(items);
    }).catch((cause) => {
      if (!cancelled) {
        setAmbienceError(cause instanceof Error ? cause.message : "AMBIENCE_LIST_FAILED");
      }
    });
    return () => {
      cancelled = true;
    };
  }, [api, workspaceId]);
  useEffect3(() => {
    if (ambienceBedId === "none") {
      setAmbiencePreviewSrc("");
      return;
    }
    if (ambienceBedId === "office") {
      setAmbiencePreviewSrc("/ambience/office-24734.mp3");
      return;
    }
    const assetId = customAmbienceAssetId(ambienceBedId);
    if (!assetId) return;
    let cancelled = false;
    let objectUrl = "";
    void api.previewAmbience(workspaceId, assetId).then((url) => {
      if (cancelled) {
        URL.revokeObjectURL(url);
        return;
      }
      objectUrl = url;
      setAmbiencePreviewSrc(url);
    }).catch(() => {
      if (!cancelled) setAmbiencePreviewSrc("");
    });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [api, workspaceId, ambienceBedId]);
  useEffect3(() => {
    const el = ambiencePreviewAudioRef.current;
    if (!el) return;
    const ratio = Math.max(0, ambienceGainValue / 0.12);
    el.volume = Math.max(0, Math.min(1, 0.42 * ratio ** 2.4));
  }, [ambienceGainValue, ambiencePreviewSrc]);
  const whatsappConnectorTools = useMemo2(() => {
    const keys = [];
    for (const connector of connectors) {
      if (connector.status !== "active") continue;
      for (const op of connector.operations) {
        if (op.name === "messages_send_template" || op.name === "messages_send_text") {
          keys.push(`connector:${connector.id}#${op.name}`);
        }
      }
    }
    return keys;
  }, [connectors]);
  const applyWhatsAppMessagingTools = useCallback3(
    (enabled) => {
      setMessagingWhatsappTemplate(enabled);
      setSelectedServiceTools((prev) => {
        const next = new Set(prev);
        for (const key of [...next]) {
          if (isWhatsAppMessagingConnectorTool(key)) next.delete(key);
        }
        if (enabled) {
          for (const key of whatsappConnectorTools) next.add(key);
        }
        return next;
      });
    },
    [whatsappConnectorTools]
  );
  useEffect3(() => {
    if (!messagingWhatsappTemplate || whatsappConnectorTools.length === 0) return;
    setSelectedServiceTools((prev) => {
      let changed = false;
      const next = new Set(prev);
      for (const key of whatsappConnectorTools) {
        if (!next.has(key)) {
          next.add(key);
          changed = true;
        }
      }
      return changed ? next : prev;
    });
  }, [messagingWhatsappTemplate, whatsappConnectorTools]);
  const activeNumbers = useMemo2(
    () => workspaceNumbers.filter((n) => n.status === "active"),
    [workspaceNumbers]
  );
  const inboundBoundNumbers = useMemo2(
    () => activeNumbers.filter((n) => n.defaultInboundAgentId === agent.id),
    [activeNumbers, agent.id]
  );
  const ttsLabel = ttsProvider === "elevenlabs" ? "ElevenLabs" : "OpenAI TTS";
  const ttsVoiceLabel = libraryVoices.find((v) => v.voiceId === selectedLibraryVoiceId)?.name ?? selectedLibraryVoiceId;
  const llmOption = AGENT_LLM_MODEL_OPTIONS.find((o) => o.id === llmModel);
  const voiceEffectiveModel = llmModel.startsWith("gpt-5") || llmModel.includes("o1") || llmModel.includes("o3") ? "gpt-4o-mini" : llmModel;
  const sttProviderOption = AGENT_STT_PROVIDER_OPTIONS.find((o) => o.id === sttProvider);
  const sttModelOptions = AGENT_STT_MODEL_OPTIONS.filter((o) => {
    if (sttProvider === "openai") return o.provider === "openai";
    if (sttProvider === "deepgram") return o.provider === "deepgram";
    return true;
  });
  const sttEffectiveLabel = sttProvider === "openai" ? `OpenAI \xB7 ${sttModel || "whisper-1"}` : sttProvider === "deepgram" ? `Deepgram \xB7 ${sttModel || "nova-3"}` : `Otomatik \xB7 PC: OpenAI \xB7 PSTN: Deepgram`;
  const knowledgeLabel = knowledgeMode === "inline" ? "Inline pack" : knowledgeMode === "none" ? "Prompt only" : "Business Brain";
  const isRealtimeStack = voiceRuntime === "openai_realtime";
  const realtimePilotClosed = true;
  const runTestRetrieval = useCallback3(async () => {
    const brainId = selectedBrainId || defaultPublishedBrainId;
    const q = retrieveQuery.trim();
    if (!brainId || !q) {
      setRetrieveError("Enter a query and select a published brain.");
      setRetrieveHits(null);
      return;
    }
    setRetrieveBusy(true);
    setRetrieveError(void 0);
    try {
      const result = await brains.retrieve(brainId, q);
      setRetrieveHits(
        result.items.slice(0, 8).map((item) => ({
          sourceLabel: item.sourceLabel,
          kind: item.kind
        }))
      );
    } catch (cause) {
      setRetrieveHits(null);
      setRetrieveError(cause instanceof Error ? cause.message : "RETRIEVE_FAILED");
    } finally {
      setRetrieveBusy(false);
    }
  }, [brains, defaultPublishedBrainId, retrieveQuery, selectedBrainId]);
  const apiBaseForSnippet = typeof window !== "undefined" ? `${window.location.protocol}//${window.location.host}` : "https://centeros.panaryus.com";
  const embedSnippet = deployment?.webchatKey && deployment.agentId === agent.id ? buildWebchatEmbedSnippet({
    apiBaseUrl: apiBaseForSnippet,
    deploymentKey: deployment.webchatKey,
    widget
  }) : null;
  const draftAhead = isPublished && agent.publishedVersion != null && agent.draftVersion > agent.publishedVersion;
  const liveChipLabel = !isPublished ? t("No live version") : draftAhead ? t("Live v{n} \xB7 draft newer", { n: String(agent.publishedVersion) }) : t("Live v{n}", { n: String(agent.publishedVersion) });
  const [studioTab, setStudioTab] = useState3("settings");
  const [testPane, setTestPane] = useState3("scenario");
  const scrollToTest = () => {
    setStudioTab("test");
    requestAnimationFrame(() => {
      document.getElementById("agent-test-panel")?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  };
  const outboundPane = /* @__PURE__ */ jsx4(Fragment3, { children: (voiceApi || contactsApi) && /* @__PURE__ */ jsx4(
    AgentOutboundCallPanel,
    {
      agent,
      workspaceId,
      voiceApi,
      contactsApi,
      numbers: activeNumbers,
      t,
      onOpenDirectory,
      onOpenNumbers
    }
  ) });
  const demoPane = /* @__PURE__ */ jsx4("div", { id: "agent-test-panel", className: "alx-test-anchor", children: voiceApi ? /* @__PURE__ */ jsx4("div", { className: "alx-form-card alx-demo-card", children: /* @__PURE__ */ jsx4(
    BrowserDemoSoftphone,
    {
      api: voiceApi,
      workspaceId,
      agentId: agent.id,
      agentName: agent.name,
      publishedVersion: agent.publishedVersion,
      interruptionEnabled: agent.config?.voice.interruptionEnabled ?? true,
      ambienceBedId,
      ambienceGain: ambienceGainValue,
      ambienceSrc: ambiencePreviewSrc || null,
      compact: true
    }
  ) }) : /* @__PURE__ */ jsxs4("div", { className: "alx-form-card", children: [
    /* @__PURE__ */ jsx4("h2", { children: "PC Demo G\xF6r\xFC\u015Fme" }),
    /* @__PURE__ */ jsx4("p", { className: "alx-muted", children: "Ses demo i\xE7in voice API ba\u011Fl\u0131 de\u011Fil. Console oturumunda voice yetkisi gerekir." })
  ] }) });
  const quickTestPane = /* @__PURE__ */ jsxs4("div", { className: "alx-form-card", children: [
    /* @__PURE__ */ jsx4("h2", { children: "Ajan\u0131 test et" }),
    /* @__PURE__ */ jsxs4("p", { className: "alx-muted", children: [
      "\xD6nce ",
      /* @__PURE__ */ jsx4("b", { children: "Save" }),
      " + ",
      /* @__PURE__ */ jsx4("b", { children: "Publish & deploy" }),
      ". A\u015Fa\u011F\u0131daki k\u0131sayollar se\xE7ili servisleri metin sim\xFClasyonu ile dener (ses i\xE7in PC Demo)."
    ] }),
    !agent.publishedVersion ? /* @__PURE__ */ jsx4("p", { className: "studio-alert error", children: "Yay\u0131nlanmam\u0131\u015F \u2014 test i\xE7in publish gerekli." }) : /* @__PURE__ */ jsxs4("div", { className: "alx-test-chips", children: [
      /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-chip-btn",
          disabled: busy,
          onClick: () => onSimulatePhrase("Merhaba, nas\u0131ls\u0131n\u0131z?"),
          children: "Selam"
        }
      ),
      caps.leadCreate && /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-chip-btn",
          disabled: busy,
          onClick: () => onSimulatePhrase(
            "Lead olu\u015Ftur: ad\u0131m Ay\u015Fe Y\u0131lmaz, telefon +905551112233, \xFCr\xFCnle ilgileniyor."
          ),
          children: "Lead test"
        }
      ),
      caps.callbackSchedule && /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-chip-btn",
          disabled: busy,
          onClick: () => onSimulatePhrase("Beni yar\u0131n \xF6\u011Fleden sonra geri aray\u0131n l\xFCtfen."),
          children: "Callback test"
        }
      ),
      caps.appointmentBooking && /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-chip-btn",
          disabled: busy,
          onClick: () => onSimulatePhrase("Yar\u0131n saat 14:00 i\xE7in randevu almak istiyorum."),
          children: "Randevu test"
        }
      ),
      caps.caseCreate && /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-chip-btn",
          disabled: busy,
          onClick: () => onSimulatePhrase(
            "Destek kayd\u0131 a\xE7: \xFCr\xFCn\xFCm \xE7al\u0131\u015Fm\u0131yor, acil destek istiyorum."
          ),
          children: "Case test"
        }
      ),
      caps.handoff && /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "alx-chip-btn",
          disabled: busy,
          onClick: () => onSimulatePhrase("\u0130nsan operat\xF6rle g\xF6r\xFC\u015Fmek istiyorum."),
          children: "Handoff test"
        }
      ),
      [...selectedServiceTools].filter((x) => x.startsWith("customer:")).slice(0, 4).map((tool) => /* @__PURE__ */ jsxs4(
        "button",
        {
          type: "button",
          className: "alx-chip-btn",
          disabled: busy,
          onClick: () => onSimulatePhrase(
            `${tool.replace("customer:", "")} servisini \xE7al\u0131\u015Ft\u0131r, gerekli notu al.`
          ),
          children: [
            tool.replace("customer:", ""),
            " test"
          ]
        },
        tool
      ))
    ] }),
    /* @__PURE__ */ jsxs4("div", { className: "alx-sim", children: [
      messages.length === 0 && /* @__PURE__ */ jsx4("p", { className: "alx-muted", children: "Hen\xFCz test mesaj\u0131 yok." }),
      messages.map((m) => /* @__PURE__ */ jsxs4("div", { className: `alx-sim-message ${m.role}`, children: [
        /* @__PURE__ */ jsx4("strong", { children: m.role === "user" ? "Sen" : "Ajan" }),
        /* @__PURE__ */ jsx4("p", { children: m.text }),
        m.role === "assistant" && m.citations.length > 0 && /* @__PURE__ */ jsxs4("small", { className: "alx-sim-evidence", children: [
          m.citations.length,
          " do\u011Frulanm\u0131\u015F kaynak kullan\u0131ld\u0131"
        ] })
      ] }, m.id))
    ] }),
    /* @__PURE__ */ jsxs4("form", { className: "alx-sim-form", onSubmit: onSimulate, children: [
      /* @__PURE__ */ jsx4("input", { name: "message", required: true, placeholder: "Serbest test mesaj\u0131\u2026" }),
      /* @__PURE__ */ jsx4("button", { type: "submit", disabled: busy || !agent.publishedVersion, children: "G\xF6nder" })
    ] }),
    deployment?.agentId === agent.id && /* @__PURE__ */ jsxs4("div", { className: "deployment-key", children: [
      /* @__PURE__ */ jsx4("small", { children: t("WEBCHAT KEY") }),
      /* @__PURE__ */ jsx4("code", { children: deployment.webchatKey })
    ] })
  ] });
  const scenarioPane = /* @__PURE__ */ jsx4(ScenarioTestCard, { agent, api, disabled: busy || !agent.publishedVersion });
  const TEST_PANES = [
    { id: "scenario", label: "Senaryo testi", node: scenarioPane },
    { id: "quick", label: "Serbest test", node: quickTestPane },
    { id: "demo", label: "PC demo", node: demoPane },
    { id: "outbound", label: "Giden arama", node: outboundPane }
  ];
  const testRoomContent = /* @__PURE__ */ jsxs4(Fragment3, { children: [
    /* @__PURE__ */ jsx4("div", { className: "alx-test-tabs", role: "tablist", "aria-label": "Test ara\xE7lar\u0131", children: TEST_PANES.map((pane) => /* @__PURE__ */ jsx4(
      "button",
      {
        type: "button",
        role: "tab",
        "aria-selected": testPane === pane.id,
        className: testPane === pane.id ? "active" : "",
        onClick: () => setTestPane(pane.id),
        children: pane.label
      },
      pane.id
    )) }),
    TEST_PANES.map((pane) => /* @__PURE__ */ jsx4(
      "div",
      {
        className: "alx-test-pane",
        style: testPane === pane.id ? void 0 : { display: "none" },
        children: pane.node
      },
      pane.id
    ))
  ] });
  return /* @__PURE__ */ jsxs4("div", { className: "alx-page alx-page-editor", children: [
    /* @__PURE__ */ jsxs4("button", { type: "button", className: "alx-back", onClick: onBack, children: [
      "\u2190 ",
      t("Back to agents")
    ] }),
    /* @__PURE__ */ jsxs4("header", { className: "alx-edit-hero", children: [
      /* @__PURE__ */ jsxs4("div", { children: [
        /* @__PURE__ */ jsx4("h1", { children: agent.name }),
        /* @__PURE__ */ jsx4("p", { children: isPublished ? `${t("Published")} v${agent.publishedVersion} \xB7 ${t("Draft")} v${agent.draftVersion}` : t("Not published yet \u2014 save, then publish to go live") })
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-hero-actions alx-hero-actions-desktop", children: [
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "submit",
            form: "agent-editor-form",
            className: "alx-btn ghost",
            disabled: busy || !agent.config,
            children: t("Save Agent")
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: "alx-btn primary",
            disabled: busy || !agent.config,
            onClick: onPublish,
            children: t("Publish & deploy")
          }
        ),
        /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", disabled: busy, onClick: onDelete, children: t("Delete agent") })
      ] })
    ] }),
    /* @__PURE__ */ jsx4("div", { className: "alx-studio-sticky", role: "region", "aria-label": t("Publish path"), children: /* @__PURE__ */ jsxs4("div", { className: "alx-studio-sticky-inner", children: [
      /* @__PURE__ */ jsx4(
        "span",
        {
          className: `alx-live-chip ${!isPublished ? "off" : draftAhead ? "stale" : "on"}`,
          title: !isPublished ? t("Not published yet \u2014 save, then publish to go live") : draftAhead ? t("Draft is newer than live \u2014 publish to update phone and campaigns") : t("This version is live on phone and campaigns"),
          children: liveChipLabel
        }
      ),
      /* @__PURE__ */ jsxs4("div", { className: "alx-publish-path alx-publish-path-sticky", role: "status", children: [
        /* @__PURE__ */ jsxs4("span", { className: "done", children: [
          /* @__PURE__ */ jsx4("em", { children: "1" }),
          " ",
          t("Configure")
        ] }),
        /* @__PURE__ */ jsxs4("span", { className: agent.config ? "done" : "active", children: [
          /* @__PURE__ */ jsx4("em", { children: "2" }),
          " ",
          t("Save Agent")
        ] }),
        /* @__PURE__ */ jsxs4("span", { className: isPublished && !draftAhead ? "done" : agent.config ? "active" : "", children: [
          /* @__PURE__ */ jsx4("em", { children: "3" }),
          " ",
          t("Publish & deploy")
        ] }),
        /* @__PURE__ */ jsxs4("span", { className: isPublished ? "active" : "", children: [
          /* @__PURE__ */ jsx4("em", { children: "4" }),
          " ",
          t("Test call")
        ] })
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "alx-studio-sticky-actions", children: [
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "submit",
            form: "agent-editor-form",
            className: "alx-btn ghost",
            disabled: busy || !agent.config,
            children: t("Save Agent")
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: "alx-btn primary",
            disabled: busy || !agent.config,
            onClick: onPublish,
            children: t("Publish & deploy")
          }
        ),
        /* @__PURE__ */ jsx4(
          "button",
          {
            type: "button",
            className: "alx-btn ghost",
            disabled: !isPublished,
            title: isPublished ? t("Jump to softphone / text test") : t("Publish first to unlock test"),
            onClick: scrollToTest,
            children: t("Test call")
          }
        )
      ] })
    ] }) }),
    !isPublished && /* @__PURE__ */ jsx4("div", { className: "alx-banner alx-banner-warn", role: "status", children: t("Save first if you changed fields, then Publish & deploy. Test on the right after publish.") }),
    draftAhead && /* @__PURE__ */ jsxs4("div", { className: "alx-banner alx-banner-warn", role: "status", children: [
      t("Draft is newer than live \u2014 publish to update phone and campaigns"),
      " ",
      /* @__PURE__ */ jsxs4("strong", { children: [
        t("Draft"),
        " v",
        agent.draftVersion,
        " \u2192 ",
        t("Live v{n}", { n: String(agent.publishedVersion) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs4(
      "div",
      {
        className: `alx-banner alx-mode-banner mode-${agent.config?.channelMode ?? "omni"}`,
        role: "status",
        children: [
          /* @__PURE__ */ jsx4("strong", { children: t(CHANNEL_LABELS[agent.config?.channelMode ?? "omni"]) }),
          /* @__PURE__ */ jsx4("span", { children: t(channelModeHelp(agent.config?.channelMode ?? "omni")) })
        ]
      }
    ),
    notice && /* @__PURE__ */ jsx4("div", { className: "studio-alert success", children: notice }),
    error && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: error }),
    /* @__PURE__ */ jsxs4("div", { className: "alx-studio-tabs", role: "tablist", "aria-label": "Ajan b\xF6l\xFCmleri", children: [
      /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          role: "tab",
          "aria-selected": studioTab === "settings",
          className: studioTab === "settings" ? "active" : "",
          onClick: () => setStudioTab("settings"),
          children: "Ayarlar"
        }
      ),
      /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          role: "tab",
          "aria-selected": studioTab === "test",
          className: studioTab === "test" ? "active" : "",
          onClick: () => setStudioTab("test"),
          children: "Test odas\u0131"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs4(
      "div",
      {
        className: "alx-edit-layout",
        style: studioTab === "test" ? { display: "none" } : void 0,
        children: [
          /* @__PURE__ */ jsxs4(
            "form",
            {
              id: "agent-editor-form",
              className: "alx-edit-form",
              onSubmit: (event) => {
                event.preventDefault();
                const data = new FormData(event.currentTarget);
                const handoff = data.get("cap_handoff") === "on";
                const leadCreate = data.get("cap_lead") === "on";
                const callbackSchedule = data.get("cap_callback") === "on";
                const appointmentBooking = data.get("cap_appointment") === "on";
                const caseCreate = data.get("cap_case") === "on";
                const endConversation = data.get("cap_end") === "on";
                const capabilities = {
                  handoff,
                  endConversation,
                  leadCreate,
                  callbackSchedule,
                  appointmentBooking,
                  caseCreate,
                  messagingWhatsappTemplate,
                  messagingSmsPack
                };
                const freeformExtra = formString(data, "allowedTools").split(",").map((v) => v.trim()).filter(Boolean).filter(
                  (tool) => !tool.startsWith("conversation.") && !tool.startsWith("handoff.") && !tool.startsWith("lead.") && !tool.startsWith("callback.") && !tool.startsWith("case.") && !tool.startsWith("appointment.")
                );
                const extra = [
                  ...selectedServiceTools,
                  ...freeformExtra.filter((tool) => !selectedServiceTools.has(tool))
                ];
                const firstMessage = formString(data, "firstMessage").trim();
                const templateId = agent.config?.templateId ?? seed?.id ?? "";
                const libraryVoiceId = (selectedLibraryVoiceId || formString(data, "libraryVoiceId")).trim();
                const profile = resolveNamedVoiceProfile(
                  selectedProfileId || formString(data, "voiceProfileId")
                );
                const mappedFromLibrary = libraryVoices.find((v) => v.voiceId === libraryVoiceId);
                const chosenTts = ttsProvider === "openai" || formString(data, "ttsProvider") === "openai" ? "openai" : "elevenlabs";
                const resolvedVoiceId = chosenTts === "openai" ? profileTtsVoiceId(profile, "openai") : libraryVoiceId || profileTtsVoiceId(profile, "elevenlabs");
                if (chosenTts === "elevenlabs" && libraryVoiceId) {
                  setSelectedLibraryVoiceId(libraryVoiceId);
                }
                const resolvedProfileId = mappedFromLibrary?.mappedProfileId || selectedProfileId || (mappedFromLibrary?.gender === "female" ? "tr_female_warm" : mappedFromLibrary?.gender === "male" ? "tr_male_professional" : profile.id);
                const mode = formString(data, "knowledgeMode") === "inline" ? "inline" : formString(data, "knowledgeMode") === "none" ? "none" : "brain";
                const brainId = formString(data, "brainId").trim();
                const inlinePack = formString(data, "inlineKnowledge").trim();
                if (mode === "inline" && !inlinePack) {
                  setKnowledgeSaveError(
                    "Inline pack is required when Inline pack mode is selected. Paste knowledge or switch mode."
                  );
                  return;
                }
                if (mode === "inline" && inlinePack.length > INLINE_KNOWLEDGE_MAX) {
                  setKnowledgeSaveError(
                    `Inline pack exceeds ${INLINE_KNOWLEDGE_MAX.toLocaleString()} characters.`
                  );
                  return;
                }
                if (mode === "brain" && !brainId) {
                  setKnowledgeSaveError(
                    "Select a published Business Brain, or switch knowledge mode."
                  );
                  return;
                }
                setKnowledgeSaveError(void 0);
                const chosenLlm = agentLlmModelSchema.safeParse(formString(data, "llmModel"));
                const chosenVoiceRuntime = agentVoiceRuntimeSchema.safeParse(
                  formString(data, "voiceRuntime") || voiceRuntime
                );
                const chosenRealtimeModel = agentRealtimeModelSchema.safeParse(
                  formString(data, "realtimeModel") || realtimeModel
                );
                const chosenStt = agentSttProviderSchema.safeParse(formString(data, "sttProvider"));
                const chosenSttModel = agentSttModelSchema.safeParse(formString(data, "sttModel"));
                const presetRaw = formString(data, "personalityPresetId").trim();
                const presetOk = personalityPresetIdSchema.safeParse(presetRaw);
                onSave({
                  expectedDraftVersion: agent.draftVersion,
                  role: formString(data, "role") || formString(data, "name") || agent.name,
                  persona: formString(data, "persona") || personaText,
                  ...presetOk.success ? { personalityPresetId: presetOk.data } : {},
                  instructions: formString(data, "instructions"),
                  ...firstMessage ? { firstMessage } : {},
                  channelMode: formString(data, "channelMode"),
                  knowledgeMode: mode,
                  voiceKnowledgeMode,
                  voiceKnowledgeDepth,
                  llmModel: chosenLlm.success ? chosenLlm.data : llmModel,
                  voiceRuntime: chosenVoiceRuntime.success ? chosenVoiceRuntime.data : voiceRuntime,
                  ...chosenVoiceRuntime.success && chosenVoiceRuntime.data === "openai_realtime" ? {
                    realtimeModel: chosenRealtimeModel.success ? chosenRealtimeModel.data : realtimeModel
                  } : {},
                  sttProvider: chosenStt.success ? chosenStt.data : sttProvider,
                  ...chosenSttModel.success ? { sttModel: chosenSttModel.data } : sttModel ? { sttModel } : {},
                  ...mode === "inline" ? { inlineKnowledge: inlinePack } : {},
                  ...brainId ? { brainId } : {},
                  blockedTopics: formString(data, "blockedTopics").split(",").map((v) => v.trim()).filter(Boolean),
                  allowedTools: toolsFromCapabilities(capabilities, extra),
                  handoffEnabled: handoff,
                  capabilities,
                  playbook,
                  widget,
                  ...conversationControl ? { conversationControl } : {},
                  conversationStyle,
                  ...templateId ? { templateId } : {},
                  voice: {
                    profileId: resolvedProfileId,
                    language: formString(data, "voiceLanguage") || profile.locale,
                    voiceId: resolvedVoiceId,
                    ttsProvider: chosenTts,
                    recordingEnabled: data.get("recordingEnabled") === "on",
                    recordingNotice: formString(data, "recordingNotice"),
                    interruptionEnabled: data.get("interruptionEnabled") === "on",
                    ...(() => {
                      const mode2 = formString(data, "interruptionMode");
                      if (mode2 === "hard" || mode2 === "duck" || mode2 === "off") {
                        return { interruptionMode: mode2 };
                      }
                      return {};
                    })(),
                    maxCallSeconds: Number(formString(data, "maxCallSeconds")) || 1800,
                    ...formString(data, "handoffDestination") ? { handoffDestination: formString(data, "handoffDestination") } : {},
                    ...formString(data, "defaultHandoffMode") === "blind" || formString(data, "defaultHandoffMode") === "warm" ? {
                      defaultHandoffMode: formString(data, "defaultHandoffMode")
                    } : {},
                    turnTimeoutSeconds: Number(formString(data, "turnTimeoutSeconds")) || 1.5,
                    silenceTimeoutMs: Number(formString(data, "silenceTimeoutMs")) || 5e3,
                    endCallOnSilence: data.get("endCallOnSilence") === "on",
                    ambienceBedId: parseAmbienceBedId(formString(data, "ambienceBedId") || ambienceBedId),
                    ambienceGain: Math.max(0, Math.min(0.3, ambienceGainValue)),
                    ambienceDuringSpeech: data.get("ambienceDuringSpeech") === "on",
                    ambienceDuringWait: data.get("ambienceDuringWait") === "on",
                    temperature: Number(formString(data, "temperature")) || 0.5
                  }
                });
              },
              children: [
                /* @__PURE__ */ jsxs4("section", { className: "alx-form-card", children: [
                  /* @__PURE__ */ jsx4("h2", { children: t("Agent Configuration") }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Agent Name") }),
                    /* @__PURE__ */ jsx4("input", { name: "name", defaultValue: agent.name, disabled: true })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Agent direction (inbound / outbound)") }),
                    /* @__PURE__ */ jsx4("select", { name: "channelMode", defaultValue: channel, children: Object.keys(CHANNEL_LABELS).map((id) => /* @__PURE__ */ jsx4("option", { value: id, children: t(CHANNEL_LABELS[id]) }, id)) }),
                    /* @__PURE__ */ jsx4("small", { className: "alx-field-hint", children: t(channelModeHelp(channel)) })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Role") }),
                    /* @__PURE__ */ jsx4(
                      "input",
                      {
                        name: "role",
                        required: true,
                        defaultValue: agent.config?.role ?? seed?.role ?? "Customer Support Agent"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-knowledge-mode", children: [
                    /* @__PURE__ */ jsx4("span", { className: "alx-field", children: /* @__PURE__ */ jsx4("span", { children: "Knowledge source" }) }),
                    /* @__PURE__ */ jsxs4("div", { className: "alx-knowledge-radios", children: [
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "knowledgeMode",
                            value: "brain",
                            checked: knowledgeMode === "brain",
                            onChange: () => {
                              setKnowledgeMode("brain");
                              setKnowledgeSaveError(void 0);
                            }
                          }
                        ),
                        /* @__PURE__ */ jsxs4("div", { children: [
                          /* @__PURE__ */ jsx4("b", { children: "Business Brain" }),
                          /* @__PURE__ */ jsx4("em", { children: "Retrieval + citations from one published Business / Product Brain" })
                        ] })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "knowledgeMode",
                            value: "inline",
                            checked: knowledgeMode === "inline",
                            onChange: () => {
                              setKnowledgeMode("inline");
                              setKnowledgeSaveError(void 0);
                            }
                          }
                        ),
                        /* @__PURE__ */ jsxs4("div", { children: [
                          /* @__PURE__ */ jsx4("b", { children: "Inline pack" }),
                          /* @__PURE__ */ jsx4("em", { children: "Text pack injected every turn (no Brain retrieval)" })
                        ] })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "knowledgeMode",
                            value: "none",
                            checked: knowledgeMode === "none",
                            onChange: () => {
                              setKnowledgeMode("none");
                              setKnowledgeSaveError(void 0);
                            }
                          }
                        ),
                        /* @__PURE__ */ jsxs4("div", { children: [
                          /* @__PURE__ */ jsx4("b", { children: "Prompt only (none)" }),
                          /* @__PURE__ */ jsx4("em", { children: "Role + persona + system prompt only \u2014 no knowledge attach" })
                        ] })
                      ] })
                    ] })
                  ] }),
                  knowledgeSaveError && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: knowledgeSaveError }),
                  knowledgeMode === "brain" ? /* @__PURE__ */ jsxs4("div", { className: "alx-knowledge-brain-block", children: [
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Knowledge Base (Business Brain)") }),
                      publishedBrains.length === 0 ? /* @__PURE__ */ jsxs4("div", { className: "alx-brain-empty", children: [
                        /* @__PURE__ */ jsx4("p", { children: "No published Business Brain in this workspace. Open Company knowledge, add sources, and publish a version before attaching retrieval to this agent." }),
                        onOpenBrain && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: onOpenBrain, children: "Open Company knowledge" }),
                        !onOpenBrain && /* @__PURE__ */ jsxs4("small", { children: [
                          "Use the sidebar ",
                          /* @__PURE__ */ jsx4("b", { children: "Company knowledge" }),
                          " / Brain page to publish."
                        ] })
                      ] }) : /* @__PURE__ */ jsxs4(
                        "select",
                        {
                          name: "brainId",
                          required: true,
                          value: selectedBrainId || defaultPublishedBrainId,
                          onChange: (e) => {
                            setSelectedBrainId(e.target.value);
                            setRetrieveHits(null);
                            setRetrieveError(void 0);
                          },
                          children: [
                            /* @__PURE__ */ jsx4("option", { value: "", disabled: true, children: "Select published brain" }),
                            publishedBrains.map((b) => /* @__PURE__ */ jsx4("option", { value: b.id, children: brainOptionLabel(b) }, b.id)),
                            pinnedBrainId && !pinnedIsPublished && pinnedBrainMeta && /* @__PURE__ */ jsxs4("option", { value: pinnedBrainId, disabled: true, children: [
                              pinnedBrainMeta.name,
                              " (unpublished \u2014 re-pick)"
                            ] })
                          ]
                        }
                      ),
                      /* @__PURE__ */ jsx4("small", { children: "Primary pin only \u2014 one published brain per agent. Multi-source content is managed as sources on the Brain page (not multi-brain attach / EL-style KB files)." })
                    ] }),
                    publishedBrains.length > 0 && defaultPublishedBrainId && /* @__PURE__ */ jsxs4("div", { className: "alx-test-retrieve", children: [
                      /* @__PURE__ */ jsx4("span", { className: "alx-field", children: /* @__PURE__ */ jsx4("span", { children: "Test retrieval" }) }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-test-retrieve-row", children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "search",
                            value: retrieveQuery,
                            onChange: (e) => setRetrieveQuery(e.target.value),
                            placeholder: "Query published knowledge\u2026",
                            "aria-label": "Test retrieval query"
                          }
                        ),
                        /* @__PURE__ */ jsx4(
                          "button",
                          {
                            type: "button",
                            className: "alx-btn ghost",
                            disabled: retrieveBusy || busy || !retrieveQuery.trim(),
                            onClick: () => void runTestRetrieval(),
                            children: retrieveBusy ? "\u2026" : "Test retrieval"
                          }
                        )
                      ] }),
                      retrieveError && /* @__PURE__ */ jsx4("div", { className: "studio-alert error", children: retrieveError }),
                      retrieveHits !== null && retrieveHits.length === 0 && /* @__PURE__ */ jsx4("p", { className: "numbers-help", children: "No hits for this query on the published brain." }),
                      retrieveHits !== null && retrieveHits.length > 0 && /* @__PURE__ */ jsx4("ul", { className: "alx-retrieve-hits", children: retrieveHits.map((hit, idx) => /* @__PURE__ */ jsxs4("li", { children: [
                        /* @__PURE__ */ jsx4("b", { children: hit.sourceLabel || "(untitled source)" }),
                        /* @__PURE__ */ jsx4("em", { children: hit.kind })
                      ] }, `${hit.sourceLabel}-${idx}`)) }),
                      /* @__PURE__ */ jsx4("small", { children: "Shows top hit titles only \u2014 no invented facts." })
                    ] })
                  ] }) : knowledgeMode === "inline" ? /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: "Inline knowledge pack" }),
                    /* @__PURE__ */ jsx4(
                      "textarea",
                      {
                        name: "inlineKnowledge",
                        required: true,
                        rows: 10,
                        className: "alx-mono",
                        maxLength: INLINE_KNOWLEDGE_MAX,
                        placeholder: "e.g.\nCompany: \u2026\nProducts: \u2026\nPricing: \u2026\nFAQ:\n- \u2026\nClosing line: \u2026",
                        value: inlineKnowledge,
                        onChange: (e) => {
                          setInlineKnowledge(e.target.value);
                          if (e.target.value.trim()) setKnowledgeSaveError(void 0);
                        }
                      }
                    ),
                    /* @__PURE__ */ jsx4("div", { className: "alx-char-counter", children: /* @__PURE__ */ jsxs4(
                      "span",
                      {
                        className: inlineKnowledge.length >= INLINE_KNOWLEDGE_MAX ? "over" : inlineKnowledge.trim().length === 0 ? "warn" : "",
                        children: [
                          inlineKnowledge.length.toLocaleString(),
                          "/",
                          INLINE_KNOWLEDGE_MAX.toLocaleString()
                        ]
                      }
                    ) }),
                    /* @__PURE__ */ jsx4("small", { children: "Business Brain retrieval is off. This pack is the agent\u2019s verified context alongside role, persona, and system prompt. Empty pack is blocked on save." })
                  ] }) : /* @__PURE__ */ jsx4("div", { className: "alx-knowledge-none-note", children: /* @__PURE__ */ jsxs4("p", { className: "numbers-help", children: [
                    /* @__PURE__ */ jsx4("b", { children: "Retrieval and citations are OFF." }),
                    " The agent answers from role, persona, and system prompt only. Publish still pins one published workspace brain for FK integrity; that pin is not used for retrieval in this mode."
                  ] }) }),
                  knowledgeMode !== "brain" && /* @__PURE__ */ jsx4(
                    "input",
                    {
                      type: "hidden",
                      name: "brainId",
                      value: agent.config?.brainId || firstPublishedBrainId(brainOptions) || brainOptions[0]?.id || ""
                    }
                  ),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-knowledge-mode", style: { marginTop: "1rem" }, children: [
                    /* @__PURE__ */ jsx4("span", { className: "alx-field", children: /* @__PURE__ */ jsx4("span", { children: "Konu\u015Fma tarz\u0131" }) }),
                    /* @__PURE__ */ jsx4("p", { className: "alx-muted", style: { marginTop: "0.25rem" }, children: "Ajan\u0131n nas\u0131l konu\u015Ftu\u011Funu belirler. Ajan\u0131n diline g\xF6re uygulan\u0131r; her ajan i\xE7in ayr\u0131 se\xE7ilir." }),
                    /* @__PURE__ */ jsx4("div", { className: "alx-knowledge-radios", children: CONVERSATION_STYLE_OPTIONS.map((option) => /* @__PURE__ */ jsxs4("label", { children: [
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          type: "radio",
                          name: "conversationStyle",
                          value: option.id,
                          checked: conversationStyle === option.id,
                          onChange: () => setConversationStyle(option.id)
                        }
                      ),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsx4("b", { children: option.label }),
                        /* @__PURE__ */ jsx4("em", { children: option.hint })
                      ] })
                    ] }, option.id)) })
                  ] }),
                  /* @__PURE__ */ jsx4(AgentMissionCard, { control: conversationControl, onChange: setConversationControl }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-knowledge-mode", style: { marginTop: "1rem" }, children: [
                    /* @__PURE__ */ jsx4("span", { className: "alx-field", children: /* @__PURE__ */ jsx4("span", { children: "Telefon bilgi kayna\u011F\u0131 (voice)" }) }),
                    /* @__PURE__ */ jsxs4("div", { className: "alx-knowledge-radios", children: [
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "voiceKnowledgeMode",
                            value: "brain",
                            checked: voiceKnowledgeMode === "brain",
                            onChange: () => setVoiceKnowledgeMode("brain")
                          }
                        ),
                        /* @__PURE__ */ jsxs4("div", { children: [
                          /* @__PURE__ */ jsx4("b", { children: "Business Brain (her tur retrieve)" }),
                          /* @__PURE__ */ jsx4("em", { children: "Mevcut mimari \u2014 webchat ile ayn\u0131 retrieval yolu. G\xFCvenli varsay\u0131lan." })
                        ] })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "voiceKnowledgeMode",
                            value: "pack",
                            checked: voiceKnowledgeMode === "pack",
                            onChange: () => setVoiceKnowledgeMode("pack")
                          }
                        ),
                        /* @__PURE__ */ jsxs4("div", { children: [
                          /* @__PURE__ */ jsx4("b", { children: "H\u0131zl\u0131 telefon modu: \u015Eirket ses paketi" }),
                          /* @__PURE__ */ jsx4("em", { children: "Yay\u0131nlarken BB+persona+FAQ derlenir; aramada tur ba\u015F\u0131na retrieve yok. D\xFC\u015F\xFCk gecikme." })
                        ] })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "voiceKnowledgeMode",
                            value: "pack_with_fallback",
                            checked: voiceKnowledgeMode === "pack_with_fallback",
                            onChange: () => setVoiceKnowledgeMode("pack_with_fallback")
                          }
                        ),
                        /* @__PURE__ */ jsxs4("div", { children: [
                          /* @__PURE__ */ jsx4("b", { children: "Paket + bilgi sorusunda retrieve" }),
                          /* @__PURE__ */ jsx4("em", { children: "\xD6nce pack; sadece ger\xE7ek bilgi sorusunda tek seferlik retrieve." })
                        ] })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "voiceKnowledgeMode",
                            value: "none",
                            checked: voiceKnowledgeMode === "none",
                            onChange: () => setVoiceKnowledgeMode("none")
                          }
                        ),
                        /* @__PURE__ */ jsxs4("div", { children: [
                          /* @__PURE__ */ jsx4("b", { children: "Sadece prompt (none)" }),
                          /* @__PURE__ */ jsx4("em", { children: "Telefonda bilgin enjeksiyonu yok \u2014 role/persona/playbook." })
                        ] })
                      ] })
                    ] }),
                    voiceKnowledgeMode !== "none" && /* @__PURE__ */ jsxs4("div", { className: "alx-knowledge-mode", style: { marginTop: "1rem" }, children: [
                      /* @__PURE__ */ jsx4("span", { className: "alx-field", children: /* @__PURE__ */ jsx4("span", { children: "Telefonda bilgi derinli\u011Fi" }) }),
                      /* @__PURE__ */ jsx4("p", { className: "numbers-help", style: { marginTop: "0.25rem" }, children: "Ajan\u0131n her turda ta\u015F\u0131yabilece\u011Fi onayl\u0131 bilgi miktar\u0131. Az bilgi = h\u0131zl\u0131 ama cevaps\u0131z soru; \xE7ok bilgi = daha fazla cevap, tur ba\u015F\u0131na birka\xE7 y\xFCz ms." }),
                      /* @__PURE__ */ jsx4("div", { className: "alx-knowledge-radios", children: VOICE_KNOWLEDGE_DEPTH_OPTIONS.map((option) => /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "voiceKnowledgeDepth",
                            value: option.id,
                            checked: voiceKnowledgeDepth === option.id,
                            onChange: () => setVoiceKnowledgeDepth(option.id)
                          }
                        ),
                        /* @__PURE__ */ jsxs4("div", { children: [
                          /* @__PURE__ */ jsx4("b", { children: option.label }),
                          /* @__PURE__ */ jsx4("em", { children: option.hint })
                        ] })
                      ] }, option.id)) })
                    ] }),
                    (voiceKnowledgeMode === "pack" || voiceKnowledgeMode === "pack_with_fallback") && /* @__PURE__ */ jsx4("p", { className: "numbers-help", style: { marginTop: "0.5rem" }, children: agent.config?.voiceCompanyPackHash ? `Son derlenen paket: hash ${agent.config.voiceCompanyPackHash}${agent.config.voiceCompanyPackAt ? ` \xB7 ${agent.config.voiceCompanyPackAt}` : ""} \xB7 ${agent.config.voiceCompanyPack?.length ?? 0} karakter. Kaydet + Yay\u0131nla ile yenilenir.` : "Kaydet + Yay\u0131nla sonras\u0131 sabit \u015Firket ses paketi derlenir ve ajan s\xFCr\xFCm\xFCne pinlenir." })
                  ] })
                ] }),
                /* @__PURE__ */ jsx4(
                  "button",
                  {
                    type: "button",
                    className: "alx-advanced-toggle",
                    onClick: () => setShowAdvanced((v) => !v),
                    children: showAdvanced ? `\u25BC ${t("Hide advanced settings")}` : `\u25B6 ${t("Show advanced settings")} (STT/LLM \xB7 playbook \xB7 webchat \xB7 tools)`
                  }
                ),
                showAdvanced && /* @__PURE__ */ jsxs4("section", { className: "alx-form-card alx-provider-map", children: [
                  /* @__PURE__ */ jsx4("h2", { children: "Sa\u011Flay\u0131c\u0131 haritas\u0131 \u2014 bu ajan ne kullan\u0131r?" }),
                  /* @__PURE__ */ jsx4("p", { className: "numbers-help", children: isRealtimeStack ? /* @__PURE__ */ jsxs4(Fragment3, { children: [
                    "Bu ajan i\xE7in se\xE7ilen hat ",
                    /* @__PURE__ */ jsx4("b", { children: "OpenAI Realtime" }),
                    " u\xE7tan uca ses oturumudur.",
                    " ",
                    /* @__PURE__ */ jsx4("b", { children: "OpenAI Realtime, STT \u2192 LLM \u2192 TTS zincirinden farkl\u0131d\u0131r." }),
                    " Canl\u0131 telefon i\xE7in d\xFC\u015F\xFCk gecikme hedefler. Yaln\u0131zca feature flag + workspace allowlist a\xE7\u0131kken \xE7al\u0131\u015F\u0131r."
                  ] }) : /* @__PURE__ */ jsxs4(Fragment3, { children: [
                    "Varsay\u0131lan canl\u0131 telefon hatt\u0131 ",
                    /* @__PURE__ */ jsx4("b", { children: "STT \u2192 LLM \u2192 TTS" }),
                    " (pipeline). A\u015Fa\u011F\u0131da",
                    " ",
                    /* @__PURE__ */ jsx4("b", { children: "bu ajan\u0131n etkin stack\u2019i" }),
                    " ve senin se\xE7ebildiklerin ayr\u0131ld\u0131. Kaydet +",
                    " ",
                    /* @__PURE__ */ jsx4("b", { children: "Publish" }),
                    " sonras\u0131 canl\u0131 arama bu s\xFCr\xFCme kilitlenir."
                  ] }) }),
                  isRealtimeStack && realtimePilotClosed && /* @__PURE__ */ jsxs4("p", { className: "alx-pilot-banner", role: "status", children: [
                    /* @__PURE__ */ jsx4("b", { children: "Pilot kapal\u0131." }),
                    " Se\xE7im kaydedilip yay\u0131nlanabilir, ancak",
                    " ",
                    /* @__PURE__ */ jsx4("code", { children: "CENTEROS_REALTIME_VOICE_V1" }),
                    " ve workspace allowlist a\xE7\u0131lmadan canl\u0131 telefonda OpenAI Realtime kullan\u0131lmaz. Gizli fallback yok; mevcut Deepgram + LLM + ElevenLabs hatt\u0131 bozulmaz."
                  ] }),
                  /* @__PURE__ */ jsx4("div", { className: "alx-runtime-cards", role: "radiogroup", "aria-label": "Voice runtime", children: AGENT_VOICE_RUNTIME_OPTIONS.map((opt) => /* @__PURE__ */ jsxs4(
                    "label",
                    {
                      className: voiceRuntime === opt.id ? "alx-runtime-card selected" : "alx-runtime-card",
                      children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            type: "radio",
                            name: "voiceRuntimeCard",
                            value: opt.id,
                            checked: voiceRuntime === opt.id,
                            onChange: () => setVoiceRuntime(opt.id)
                          }
                        ),
                        /* @__PURE__ */ jsxs4("span", { children: [
                          /* @__PURE__ */ jsx4("b", { children: opt.label }),
                          /* @__PURE__ */ jsx4("em", { children: opt.hint })
                        ] })
                      ]
                    },
                    opt.id
                  )) }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-stack-summary", children: [
                    /* @__PURE__ */ jsx4("small", { children: "BU AJANIN ETK\u0130N STACK\u2019\u0130" }),
                    /* @__PURE__ */ jsxs4("ul", { children: [
                      /* @__PURE__ */ jsxs4("li", { children: [
                        /* @__PURE__ */ jsx4("span", { children: "Voice runtime" }),
                        /* @__PURE__ */ jsx4("b", { children: isRealtimeStack ? "OpenAI Realtime" : "Pipeline \xB7 STT \u2192 LLM \u2192 TTS" }),
                        /* @__PURE__ */ jsx4("em", { children: isRealtimeStack ? realtimePilotClosed ? "pilot kapal\u0131 \xB7 kaydet + publish yine de tutulur" : "ajan se\xE7imi \xB7 kaydet + publish" : "ajan se\xE7imi \xB7 kaydet + publish" })
                      ] }),
                      isRealtimeStack ? /* @__PURE__ */ jsxs4("li", { children: [
                        /* @__PURE__ */ jsx4("span", { children: "Realtime model" }),
                        /* @__PURE__ */ jsxs4("b", { children: [
                          "OpenAI \xB7 ",
                          realtimeModel
                        ] }),
                        /* @__PURE__ */ jsx4("em", { children: "dinler + konu\u015Fur \xB7 ayr\u0131 STT/TTS yok" })
                      ] }) : /* @__PURE__ */ jsxs4("li", { children: [
                        /* @__PURE__ */ jsx4("span", { children: "LLM" }),
                        /* @__PURE__ */ jsxs4("b", { children: [
                          "OpenAI \xB7 ",
                          llmModel,
                          voiceEffectiveModel !== llmModel ? ` (ses: ${voiceEffectiveModel})` : ""
                        ] }),
                        /* @__PURE__ */ jsx4("em", { children: "ajan se\xE7imi \xB7 kaydet + publish" })
                      ] }),
                      /* @__PURE__ */ jsxs4("li", { children: [
                        /* @__PURE__ */ jsx4("span", { children: "Bilgi" }),
                        /* @__PURE__ */ jsx4("b", { children: knowledgeLabel }),
                        /* @__PURE__ */ jsx4("em", { children: "yukar\u0131daki \xABBilgi kayna\u011F\u0131\xBBndan" })
                      ] }),
                      /* @__PURE__ */ jsxs4("li", { children: [
                        /* @__PURE__ */ jsx4("span", { children: "STT" }),
                        /* @__PURE__ */ jsx4("b", { children: isRealtimeStack ? "Realtime model dinler (STT ayr\u0131 de\u011Fil)" : sttEffectiveLabel }),
                        /* @__PURE__ */ jsx4("em", { children: isRealtimeStack ? "pipeline se\xE7imine ikincil" : "ajan se\xE7imi \xB7 kaydet + publish" })
                      ] }),
                      /* @__PURE__ */ jsxs4("li", { children: [
                        /* @__PURE__ */ jsx4("span", { children: "TTS" }),
                        /* @__PURE__ */ jsx4("b", { children: isRealtimeStack ? "Realtime model konu\u015Fur (TTS ayr\u0131 de\u011Fil)" : `${ttsLabel}${ttsVoiceLabel ? ` \xB7 ${ttsVoiceLabel}` : ""}` }),
                        /* @__PURE__ */ jsx4("em", { children: isRealtimeStack ? "pipeline se\xE7imine ikincil" : "ajan se\xE7imi \xB7 a\u015Fa\u011F\u0131dan de\u011Fi\u015Ftir" })
                      ] }),
                      /* @__PURE__ */ jsxs4("li", { children: [
                        /* @__PURE__ */ jsx4("span", { children: "Telefon" }),
                        /* @__PURE__ */ jsx4("b", { children: inboundBoundNumbers.length > 0 ? inboundBoundNumbers.map((n) => `${n.provider} ${n.e164Masked || n.e164}`).join(", ") : activeNumbers.length > 0 ? `Workspace hatlar\u0131 var \xB7 ajan DID\u2019e ba\u011Fl\u0131 de\u011Fil` : "Hat yok \xB7 PC demo hat kullanmaz" }),
                        /* @__PURE__ */ jsx4("em", { children: "hat = Numbers envanteri / arama se\xE7imi" })
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-provider-table alx-provider-table-v2", children: [
                    /* @__PURE__ */ jsxs4("div", { className: "alx-provider-head", "aria-hidden": true, children: [
                      /* @__PURE__ */ jsx4("span", { children: "Katman" }),
                      /* @__PURE__ */ jsx4("span", { children: "Bu ajan" }),
                      /* @__PURE__ */ jsx4("span", { children: "Se\xE7im" })
                    ] }),
                    /* @__PURE__ */ jsxs4("div", { className: "alx-provider-row alx-provider-row-pick", children: [
                      /* @__PURE__ */ jsx4("strong", { children: "Voice runtime" }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-provider-now", children: [
                        /* @__PURE__ */ jsx4("span", { className: isRealtimeStack ? "alx-provider-chip pick" : "alx-provider-chip pick", children: isRealtimeStack ? "OpenAI Realtime" : "Pipeline" }),
                        isRealtimeStack && /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip warn", children: "Pilot kapal\u0131" }),
                        /* @__PURE__ */ jsx4("em", { children: isRealtimeStack ? "Ayr\u0131 stack: tek Realtime ses oturumu. STT \u2192 LLM \u2192 TTS zinciri de\u011Fil. Canl\u0131 telefon i\xE7in d\xFC\u015F\xFCk gecikme hedefler. Yaln\u0131zca feature flag + workspace allowlist a\xE7\u0131kken \xE7al\u0131\u015F\u0131r." : "Mevcut canl\u0131 telefon hatt\u0131: STT \u2192 LLM \u2192 TTS. OpenAI Realtime ayr\u0131 bir se\xE7enektir." })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { className: "alx-field alx-provider-pick", children: [
                        /* @__PURE__ */ jsx4("span", { children: "Telefon ses hatt\u0131" }),
                        /* @__PURE__ */ jsx4(
                          "select",
                          {
                            name: "voiceRuntime",
                            value: voiceRuntime,
                            onChange: (e) => {
                              const parsed = agentVoiceRuntimeSchema.safeParse(e.target.value);
                              if (parsed.success) setVoiceRuntime(parsed.data);
                            },
                            children: AGENT_VOICE_RUNTIME_OPTIONS.map((opt) => /* @__PURE__ */ jsxs4("option", { value: opt.id, children: [
                              opt.label,
                              " \u2014 ",
                              opt.hint
                            ] }, opt.id))
                          }
                        ),
                        /* @__PURE__ */ jsx4("small", { children: "Kaydet + Publish. Pipeline her zaman canl\u0131d\u0131r. OpenAI Realtime se\xE7ilse bile flag/allowlist yoksa canl\u0131 telefonda kullan\u0131lmaz." })
                      ] })
                    ] }),
                    isRealtimeStack && /* @__PURE__ */ jsxs4("div", { className: "alx-provider-row alx-provider-row-pick", children: [
                      /* @__PURE__ */ jsx4("strong", { children: "Realtime model" }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-provider-now", children: [
                        /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip pick", children: "OpenAI" }),
                        /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip pick", children: realtimeModel }),
                        /* @__PURE__ */ jsx4("em", { children: "Realtime model dinler ve konu\u015Fur. gpt-5* \u2192 gpt-4o-mini remap bu hatta uygulanmaz." })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { className: "alx-field alx-provider-pick", children: [
                        /* @__PURE__ */ jsx4("span", { children: "Realtime model" }),
                        /* @__PURE__ */ jsx4(
                          "select",
                          {
                            name: "realtimeModel",
                            value: realtimeModel,
                            onChange: (e) => {
                              const parsed = agentRealtimeModelSchema.safeParse(e.target.value);
                              if (parsed.success) setRealtimeModel(parsed.data);
                            },
                            children: AGENT_REALTIME_MODEL_OPTIONS.map((opt) => /* @__PURE__ */ jsxs4("option", { value: opt.id, children: [
                              opt.label,
                              " \u2014 ",
                              opt.hint
                            ] }, opt.id))
                          }
                        ),
                        /* @__PURE__ */ jsx4("small", { children: "ChatGPT benzeri h\u0131zl\u0131 konu\u015Fma hatt\u0131. STT/TTS ayr\u0131 se\xE7ilmez." })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("div", { className: isRealtimeStack ? "alx-provider-row is-secondary" : "alx-provider-row alx-provider-row-pick", children: [
                      /* @__PURE__ */ jsx4("strong", { children: "LLM \xB7 beyin" }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-provider-now", children: [
                        /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip pick", children: "OpenAI" }),
                        /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip pick", children: llmModel }),
                        !isRealtimeStack && voiceEffectiveModel !== llmModel && /* @__PURE__ */ jsxs4("span", { className: "alx-provider-chip muted", children: [
                          "ses \u2192 ",
                          voiceEffectiveModel
                        ] }),
                        isRealtimeStack && /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip muted", children: "telefonda realtime model" }),
                        /* @__PURE__ */ jsx4("em", { children: isRealtimeStack ? "Chat/web i\xE7in. Canl\u0131 telefonda OpenAI Realtime modeli kullan\u0131l\u0131r; gpt-5* remap bu hatta yok." : `Prompt + grounded yan\u0131t. Vendor OpenAI sabit; model bu ajanda se\xE7ilir.${llmOption ? ` ${llmOption.hint}.` : ""} Seste reasoning modelleri (gpt-5*) gecikme i\xE7in ${voiceEffectiveModel !== llmModel ? voiceEffectiveModel : "ayn\u0131 model"} ile \xE7al\u0131\u015F\u0131r.` })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { className: "alx-field alx-provider-pick", children: [
                        /* @__PURE__ */ jsx4("span", { children: "Ajan LLM modeli" }),
                        /* @__PURE__ */ jsx4(
                          "select",
                          {
                            name: "llmModel",
                            value: llmModel,
                            onChange: (e) => {
                              const parsed = agentLlmModelSchema.safeParse(e.target.value);
                              if (parsed.success) setLlmModel(parsed.data);
                            },
                            children: AGENT_LLM_MODEL_OPTIONS.map((opt) => /* @__PURE__ */ jsxs4("option", { value: opt.id, children: [
                              opt.label,
                              " \u2014 ",
                              opt.hint,
                              opt.voiceSafe ? "" : " \u26A0"
                            ] }, opt.id))
                          }
                        ),
                        /* @__PURE__ */ jsx4("small", { children: isRealtimeStack ? "Chat/web: se\xE7ti\u011Fin model. Telefon: gpt-realtime-2.1 (remap yok)." : `Kaydet + Publish. Chat/web: se\xE7ti\u011Fin model. PC demo / telefon: voice-safe model (${voiceEffectiveModel}).` })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("div", { className: isRealtimeStack ? "alx-provider-row is-secondary" : "alx-provider-row alx-provider-row-pick", children: [
                      /* @__PURE__ */ jsx4("strong", { children: "STT \xB7 kulak" }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-provider-now", children: [
                        sttProvider === "auto" ? /* @__PURE__ */ jsxs4(Fragment3, { children: [
                          /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip pick", children: "Otomatik" }),
                          /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip muted", children: "PC \u2192 OpenAI" }),
                          /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip muted", children: "PSTN \u2192 Deepgram" })
                        ] }) : sttProvider === "openai" ? /* @__PURE__ */ jsxs4("span", { className: "alx-provider-chip pick", children: [
                          "OpenAI \xB7 ",
                          sttModel || "whisper-1"
                        ] }) : /* @__PURE__ */ jsxs4("span", { className: "alx-provider-chip pick", children: [
                          "Deepgram \xB7 ",
                          sttModel || "nova-3"
                        ] }),
                        /* @__PURE__ */ jsx4("em", { children: isRealtimeStack ? "OpenAI Realtime se\xE7iliyken STT ayr\u0131 \xE7al\u0131\u015Fmaz; realtime model dinler. Pipeline\u2019a d\xF6n\xFCnce bu se\xE7im yeniden aktif olur." : `Bu ajan\u0131n dinleme motoru. ${sttProviderOption?.hint ?? ""} PC demo ve API turlar\u0131nda se\xE7im uygulan\u0131r. PSTN live h\xE2l\xE2 media-gateway platform Deepgram\u2019\u0131 kullanabilir (ayn\u0131 model tercihleri oraya da ta\u015F\u0131nacak).` })
                      ] }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-provider-pick", children: [
                        /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                          /* @__PURE__ */ jsx4("span", { children: "STT sa\u011Flay\u0131c\u0131s\u0131" }),
                          /* @__PURE__ */ jsx4(
                            "select",
                            {
                              name: "sttProvider",
                              value: sttProvider,
                              disabled: isRealtimeStack,
                              onChange: (e) => {
                                const parsed = agentSttProviderSchema.safeParse(e.target.value);
                                if (!parsed.success) return;
                                setSttProvider(parsed.data);
                                if (parsed.data === "openai") setSttModel("whisper-1");
                                else if (parsed.data === "deepgram") setSttModel("nova-3");
                                else setSttModel("");
                              },
                              children: AGENT_STT_PROVIDER_OPTIONS.map((opt) => /* @__PURE__ */ jsxs4("option", { value: opt.id, children: [
                                opt.label,
                                " \u2014 ",
                                opt.hint
                              ] }, opt.id))
                            }
                          )
                        ] }),
                        /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                          /* @__PURE__ */ jsxs4("span", { children: [
                            "STT modeli ",
                            sttProvider === "auto" ? "(opsiyonel override)" : ""
                          ] }),
                          /* @__PURE__ */ jsxs4(
                            "select",
                            {
                              name: "sttModel",
                              value: sttModel,
                              disabled: isRealtimeStack,
                              onChange: (e) => {
                                const v = e.target.value;
                                if (!v) {
                                  setSttModel("");
                                  return;
                                }
                                const parsed = agentSttModelSchema.safeParse(v);
                                if (parsed.success) setSttModel(parsed.data);
                              },
                              children: [
                                sttProvider === "auto" && /* @__PURE__ */ jsx4("option", { value: "", children: "Varsay\u0131lan (sa\u011Flay\u0131c\u0131ya g\xF6re)" }),
                                sttModelOptions.map((opt) => /* @__PURE__ */ jsxs4("option", { value: opt.id, children: [
                                  opt.label,
                                  " \u2014 ",
                                  opt.hint
                                ] }, opt.id))
                              ]
                            }
                          ),
                          /* @__PURE__ */ jsx4("small", { children: "Kaydet + Publish. OpenAI batch \xB7 Deepgram live PCM." })
                        ] })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("div", { className: isRealtimeStack ? "alx-provider-row is-secondary" : "alx-provider-row alx-provider-row-pick", children: [
                      /* @__PURE__ */ jsx4("strong", { children: "TTS \xB7 ses" }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-provider-now", children: [
                        /* @__PURE__ */ jsx4("span", { className: isRealtimeStack ? "alx-provider-chip muted" : "alx-provider-chip pick", children: isRealtimeStack ? "Realtime model konu\u015Fur" : ttsLabel }),
                        /* @__PURE__ */ jsx4("em", { children: isRealtimeStack ? "OpenAI Realtime se\xE7iliyken ayr\u0131 TTS (ElevenLabs / OpenAI speech API) kullan\u0131lmaz. Pipeline\u2019a d\xF6n\xFCnce bu se\xE7im yeniden aktif olur." : "Bu ajan\u0131n konu\u015Fma sesi. ElevenLabs = library voice. OpenAI = named profile (coral/shimmer/\u2026). Pipeline speech API \u2014 Realtime de\u011Fil." })
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { className: "alx-field alx-provider-pick", children: [
                        /* @__PURE__ */ jsx4("span", { children: "Ajan TTS sa\u011Flay\u0131c\u0131s\u0131" }),
                        /* @__PURE__ */ jsxs4(
                          "select",
                          {
                            name: "ttsProvider",
                            value: ttsProvider,
                            disabled: isRealtimeStack,
                            onChange: (e) => setTtsProvider(e.target.value === "openai" ? "openai" : "elevenlabs"),
                            children: [
                              /* @__PURE__ */ jsx4("option", { value: "elevenlabs", children: "ElevenLabs (library sesler)" }),
                              /* @__PURE__ */ jsx4("option", { value: "openai", children: "OpenAI TTS (named voices)" })
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsx4("small", { children: "Kaydet + Publish ile yay\u0131nlan\u0131r. Ses listesi a\u015Fa\u011F\u0131daki \xABVoice\xBB b\xF6l\xFCm\xFCnde." })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("div", { className: "alx-provider-row alx-provider-row-pick", children: [
                      /* @__PURE__ */ jsx4("strong", { children: "Telefon \xB7 hat" }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-provider-now", children: [
                        inboundBoundNumbers.length > 0 ? inboundBoundNumbers.map((n) => /* @__PURE__ */ jsxs4("span", { className: "alx-provider-chip pick", children: [
                          n.provider,
                          " \xB7 ",
                          n.e164Masked || n.e164
                        ] }, n.id)) : /* @__PURE__ */ jsx4("span", { className: "alx-provider-chip muted", children: "Bu ajana DID ba\u011Fl\u0131 de\u011Fil" }),
                        /* @__PURE__ */ jsxs4("em", { children: [
                          "Trunk, aramada kullan\u0131lan numaran\u0131n ",
                          /* @__PURE__ */ jsx4("code", { children: "provider" }),
                          " alan\u0131ndan gelir (Zadarma / Verimor / Twilio). PC Demo: hat yok (",
                          /* @__PURE__ */ jsx4("code", { children: "browser_demo" }),
                          ")."
                        ] })
                      ] }),
                      /* @__PURE__ */ jsxs4("div", { className: "alx-provider-pick", children: [
                        /* @__PURE__ */ jsx4("span", { className: "alx-provider-lock soft", children: "Hat se\xE7imi ajan formunda de\u011Fil" }),
                        /* @__PURE__ */ jsxs4("small", { children: [
                          "Gelen arama i\xE7in DID \u2192 ajan ba\u011F\u0131n\u0131 ",
                          /* @__PURE__ */ jsx4("b", { children: "Numbers" }),
                          " sayfas\u0131nda yap. Giden aramada Contacts / Campaigns numara se\xE7er; trunk o numaran\u0131n sa\u011Flay\u0131c\u0131s\u0131d\u0131r."
                        ] }),
                        onOpenNumbers && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-chip-btn", onClick: onOpenNumbers, children: "Numbers \xB7 hat / DID ba\u011Fla" })
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-trunk-status", children: [
                    /* @__PURE__ */ jsx4("small", { children: "WORKSPACE HATLARI \xB7 HANG\u0130 SA\u011ELAYICI?" }),
                    activeNumbers.length > 0 ? /* @__PURE__ */ jsx4("ul", { className: "alx-number-provider-list", children: activeNumbers.slice(0, 12).map((n) => /* @__PURE__ */ jsxs4("li", { children: [
                      /* @__PURE__ */ jsx4("b", { children: n.provider }),
                      /* @__PURE__ */ jsx4("span", { children: n.e164Masked || n.e164 }),
                      /* @__PURE__ */ jsx4("em", { children: n.defaultInboundAgentId === agent.id ? "\u2190 bu ajana inbound ba\u011Fl\u0131" : n.defaultInboundAgentId ? "ba\u015Fka ajana ba\u011Fl\u0131" : "inbound serbest" })
                    ] }, n.id)) }) : /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: "Aktif hat yok. PC demo yine \xE7al\u0131\u015F\u0131r; PSTN i\xE7in Numbers\u2019dan hat ekleyin." }),
                    /* @__PURE__ */ jsx4("small", { style: { marginTop: 10, display: "block" }, children: "TRUNK HAZIRLIK (Mode B)" }),
                    rateCard ? /* @__PURE__ */ jsx4("ul", { children: ["zadarma", "verimor", "twilio"].map((provider) => {
                      const row = rateCard.trunks.find((t2) => t2.provider === provider);
                      const count = activeNumbers.filter((n) => n.provider === provider).length;
                      return /* @__PURE__ */ jsxs4("li", { children: [
                        provider,
                        ":",
                        " ",
                        /* @__PURE__ */ jsx4("b", { children: row ? `${row.status} \xB7 ${row.role}` : "not_configured" }),
                        count > 0 ? ` \xB7 ${count} numara` : ""
                      ] }, provider);
                    }) }) : /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: "Trunk kart\u0131 y\xFCklenemedi." }),
                    /* @__PURE__ */ jsxs4("div", { className: "alx-test-chips", children: [
                      onOpenNumbers && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-chip-btn", onClick: onOpenNumbers, children: "Numbers \xB7 hat / DID" }),
                      onOpenVoices && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-chip-btn", onClick: onOpenVoices, children: "Voices \xB7 ElevenLabs k\xFCt\xFCphane" })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ jsxs4("section", { className: "alx-form-card", children: [
                  /* @__PURE__ */ jsx4("h2", { children: t("Voice & Personality") }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: "Ki\u015Filik preset" }),
                    /* @__PURE__ */ jsxs4(
                      "select",
                      {
                        name: "personalityPresetId",
                        value: personalityPresetId,
                        onChange: (e) => {
                          const id = e.target.value;
                          setPersonalityPresetId(id);
                          const preset = resolvePersonalityPreset(id);
                          if (preset) setPersonaText(preset.persona);
                        },
                        children: [
                          /* @__PURE__ */ jsx4("option", { value: "", children: "\xD6zel / serbest metin" }),
                          PERSONALITY_PRESETS.map((p) => /* @__PURE__ */ jsxs4("option", { value: p.id, children: [
                            p.labelTr,
                            " \u2014 ",
                            p.tags.join(", ")
                          ] }, p.id))
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsx4("small", { children: "Preset persona metnini doldurur; kaydetmeden \xF6nce d\xFCzenleyebilirsiniz." })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Personality") }),
                    /* @__PURE__ */ jsx4(
                      "textarea",
                      {
                        name: "persona",
                        required: true,
                        rows: 3,
                        placeholder: t("Describe the agent's personality and behavior"),
                        value: personaText,
                        onChange: (e) => setPersonaText(e.target.value)
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-voice-knobs", id: "agent-voice-knobs", children: [
                    /* @__PURE__ */ jsx4("h3", { className: "alx-voice-knobs-title", children: t("Live phone knobs (PSTN)") }),
                    /* @__PURE__ */ jsx4("p", { className: "numbers-help", children: t(
                      "These settings apply to live phone (AudioSocket / media-gateway) after Publish & deploy \u2014 not only global env. Softphone also uses interruption mode where relevant."
                    ) }),
                    isPublished && /* @__PURE__ */ jsxs4("div", { className: "alx-voice-knobs-live", role: "status", children: [
                      /* @__PURE__ */ jsx4("strong", { children: t("Live (published) effective") }),
                      /* @__PURE__ */ jsxs4("ul", { children: [
                        /* @__PURE__ */ jsxs4("li", { children: [
                          t("Interruption"),
                          ":",
                          " ",
                          /* @__PURE__ */ jsx4("code", { children: agent.config?.voice.interruptionEnabled === false ? "off" : agent.config?.voice.interruptionMode ?? "hard" })
                        ] }),
                        /* @__PURE__ */ jsxs4("li", { children: [
                          t("Turn / EOU silence"),
                          ":",
                          " ",
                          /* @__PURE__ */ jsxs4("code", { children: [
                            agent.config?.voice.turnTimeoutSeconds ?? 1.5,
                            "s"
                          ] }),
                          " \xB7 ",
                          t("Idle silence"),
                          ":",
                          " ",
                          /* @__PURE__ */ jsxs4("code", { children: [
                            agent.config?.voice.silenceTimeoutMs ?? 5e3,
                            "ms"
                          ] }),
                          agent.config?.voice.endCallOnSilence ? ` \xB7 ${t("hangup on idle")}` : ""
                        ] }),
                        /* @__PURE__ */ jsxs4("li", { children: [
                          t("Max call"),
                          ":",
                          " ",
                          /* @__PURE__ */ jsxs4("code", { children: [
                            agent.config?.voice.maxCallSeconds ?? 1800,
                            "s"
                          ] }),
                          " \xB7 ",
                          t("Temperature"),
                          ":",
                          " ",
                          /* @__PURE__ */ jsx4("code", { children: agent.config?.voice.temperature ?? 0.5 })
                        ] })
                      ] }),
                      draftAhead && /* @__PURE__ */ jsx4("small", { className: "alx-voice-knobs-stale", children: t("Draft differs \u2014 publish to push knobs to the phone path.") })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: isRealtimeStack ? "alx-field is-pipeline-secondary" : "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: isRealtimeStack ? "Pipeline voice se\xE7imi" : ttsProvider === "elevenlabs" ? t("ElevenLabs voice (full library)") : "OpenAI voice (style preset \xFCzerinden)" }),
                    /* @__PURE__ */ jsxs4(
                      "select",
                      {
                        name: "libraryVoiceId",
                        required: true,
                        disabled: isRealtimeStack,
                        value: selectedLibraryVoiceId,
                        onChange: (e) => {
                          const id = e.target.value;
                          setSelectedLibraryVoiceId(id);
                          const hit = libraryVoices.find((v) => v.voiceId === id);
                          if (hit?.mappedProfileId) {
                            setSelectedProfileId(hit.mappedProfileId);
                          } else if (hit?.gender === "female") {
                            setSelectedProfileId("tr_female_warm");
                          } else if (hit?.gender === "male") {
                            setSelectedProfileId("tr_male_professional");
                          }
                        },
                        children: [
                          selectedLibraryVoiceId && !libraryVoices.some((v) => v.voiceId === selectedLibraryVoiceId) && /* @__PURE__ */ jsxs4("option", { value: selectedLibraryVoiceId, children: [
                            selectedLibraryVoiceId,
                            " (kay\u0131tl\u0131)"
                          ] }),
                          libraryVoices.map((v) => /* @__PURE__ */ jsxs4("option", { value: v.voiceId, children: [
                            v.name,
                            v.language ? ` \xB7 ${v.language}` : "",
                            v.gender && v.gender !== "unknown" ? ` \xB7 ${v.gender}` : "",
                            v.recommended ? " \u2605" : ""
                          ] }, v.voiceId))
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsx4("small", { children: isRealtimeStack ? "Realtime se\xE7iliyken canl\u0131 telefon bu sesi kullanmaz; gpt-realtime-2.1 kendi sesiyle konu\u015Fur. Pipeline\u2019a d\xF6n\xFCnce bu se\xE7im yeniden aktif olur." : libraryVoices.length > 0 ? `${libraryVoices.length} voices from your ElevenLabs account` : voiceCatalogError ? `K\xFCt\xFCphane y\xFCklenemedi: ${voiceCatalogError}` : "ElevenLabs k\xFCt\xFCphanesi y\xFCkleniyor\u2026 (veya Sesler sekmesi \u2192 Yenile)" }),
                    voiceCatalogError && /* @__PURE__ */ jsxs4("p", { className: "studio-alert error", style: { marginTop: 8 }, children: [
                      "ElevenLabs ses listesi gelmedi. Admin \u203A CenterOS providers i\xE7inde API anahtar\u0131",
                      " ",
                      /* @__PURE__ */ jsx4("code", { children: "sk_" }),
                      " ile ba\u015Flamal\u0131 (key ID de\u011Fil, secret key). Kaydet & apply sonras\u0131 CenterOS API restart gerekir. Hata: ",
                      voiceCatalogError
                    ] }),
                    !voiceCatalogError && libraryVoices.length === 0 && /* @__PURE__ */ jsx4("p", { className: "numbers-help", style: { marginTop: 6 }, children: "Liste bo\u015Fsa \xABSesler \xB7 ElevenLabs\xBB sekmesinden Yenile; h\xE2l\xE2 yoksa platform API anahtar\u0131n\u0131 kontrol edin." }),
                    /* @__PURE__ */ jsxs4("small", { className: "numbers-help", style: { display: "block", marginTop: 6 }, children: [
                      "Kay\u0131tl\u0131 ses id:",
                      " ",
                      /* @__PURE__ */ jsx4("code", { children: agent.config?.voice?.voiceId || "\u2014" }),
                      agent.config?.voice?.ttsProvider ? ` \xB7 ${agent.config.voice.ttsProvider}` : "",
                      " \xB7 ",
                      "Se\xE7ili: ",
                      /* @__PURE__ */ jsx4("code", { children: selectedLibraryVoiceId || "\u2014" })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Style preset (optional)") }),
                      /* @__PURE__ */ jsx4(
                        "select",
                        {
                          name: "voiceProfileId",
                          required: true,
                          value: selectedProfileId,
                          onChange: (e) => setSelectedProfileId(e.target.value),
                          children: voiceOptions.map((v) => /* @__PURE__ */ jsx4("option", { value: v.id, children: v.label }, v.id))
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Select Language") }),
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "voiceLanguage",
                          required: true,
                          defaultValue: agent.config?.voice.language ?? "tr-TR"
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ jsx4(
                    "button",
                    {
                      type: "button",
                      className: "alx-btn ghost",
                      disabled: busy && playingVoiceId !== selectedLibraryVoiceId,
                      onClick: () => onPreviewVoice({
                        voiceId: selectedLibraryVoiceId,
                        profileId: selectedProfileId,
                        playKey: selectedLibraryVoiceId
                      }),
                      children: playingVoiceId === selectedLibraryVoiceId ? t("\u25A0 Stop") : `\u25B6 ${t("Play ElevenLabs sample")}`
                    }
                  ),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Temperature") }),
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "temperature",
                          type: "number",
                          min: "0",
                          max: "1",
                          step: "0.05",
                          defaultValue: agent.config?.voice.temperature ?? 0.5
                        }
                      ),
                      /* @__PURE__ */ jsxs4("small", { children: [
                        t("Deterministic \u2190 \u2192 Creative"),
                        " \xB7 LLM"
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Max Conversation Duration (sec)") }),
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "maxCallSeconds",
                          type: "number",
                          min: "30",
                          max: "14400",
                          defaultValue: agent.config?.voice.maxCallSeconds ?? 1800
                        }
                      ),
                      /* @__PURE__ */ jsx4("small", { children: t("Hard cap on live call length") })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-field-row", children: [
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Turn / EOU silence (s)") }),
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "turnTimeoutSeconds",
                          type: "number",
                          step: "0.1",
                          min: "0.5",
                          max: "10",
                          defaultValue: agent.config?.voice.turnTimeoutSeconds ?? 1.5
                        }
                      ),
                      /* @__PURE__ */ jsx4("small", { children: t("How long to wait after user stops talking before agent replies (phone VAD)") })
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Idle silence (ms)") }),
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "silenceTimeoutMs",
                          type: "number",
                          min: "1000",
                          max: "30000",
                          defaultValue: agent.config?.voice.silenceTimeoutMs ?? 5e3
                        }
                      ),
                      /* @__PURE__ */ jsx4("small", { children: t("Long quiet period before optional hangup") })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Interruption mode (live phone)") }),
                    /* @__PURE__ */ jsxs4(
                      "select",
                      {
                        name: "interruptionMode",
                        defaultValue: agent.config?.voice.interruptionMode ?? (agent.config?.voice.interruptionEnabled === false ? "off" : "hard"),
                        children: [
                          /* @__PURE__ */ jsx4("option", { value: "hard", children: t("Hard \u2014 cut agent audio immediately") }),
                          /* @__PURE__ */ jsx4("option", { value: "duck", children: t("Duck \u2014 lower volume; hard cut after longer speech") }),
                          /* @__PURE__ */ jsx4("option", { value: "off", children: t("Off \u2014 no barge-in") })
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsx4("small", { children: t(
                      "Per-agent policy for PSTN/media-gateway. Global VOICE_INTERRUPTION_MODE is only the default when agent mode is empty."
                    ) })
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-form-card", style: { marginTop: 12, padding: 12 }, children: [
                    /* @__PURE__ */ jsx4("h3", { style: { margin: "0 0 8px", fontSize: 15 }, children: t("Background sound / ambience") }),
                    /* @__PURE__ */ jsx4("p", { className: "alx-muted", style: { marginTop: 0 }, children: t(
                      "Upload your own looping bed (office, cafe, brand audio). It plays quietly under the agent on the phone and in PC demo. Isolated to this workspace."
                    ) }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Ambience bed") }),
                      /* @__PURE__ */ jsxs4(
                        "select",
                        {
                          name: "ambienceBedId",
                          value: ambienceBedId,
                          onChange: (event) => setAmbienceBedId(parseAmbienceBedId(event.target.value)),
                          children: [
                            /* @__PURE__ */ jsx4("option", { value: "office", children: t("Office ambience") }),
                            /* @__PURE__ */ jsx4("option", { value: "none", children: t("Ambience off") }),
                            ambienceLibrary.map((item) => /* @__PURE__ */ jsx4("option", { value: item.bedId, children: item.name }, item.id))
                          ]
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxs4("div", { className: "alx-field", style: { marginTop: 8 }, children: [
                      /* @__PURE__ */ jsx4("span", { children: t("Upload your sound") }),
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          type: "file",
                          accept: "audio/mpeg,audio/mp3,audio/wav,audio/x-wav,audio/ogg,audio/mp4,audio/m4a,.mp3,.wav,.ogg,.m4a",
                          disabled: ambienceBusy,
                          onChange: (event) => {
                            const file = event.target.files?.[0];
                            event.target.value = "";
                            if (!file) return;
                            if (file.size > 8e6) {
                              setAmbienceError(t("File must be 8 MB or smaller."));
                              return;
                            }
                            setAmbienceBusy(true);
                            setAmbienceError(void 0);
                            void (async () => {
                              try {
                                const audioBase64 = await fileToBase64(file);
                                const name = file.name.replace(/\.[^.]+$/u, "").slice(0, 80) || "Ambiance";
                                const saved = await api.uploadAmbience(workspaceId, {
                                  name,
                                  filename: file.name.slice(0, 200),
                                  contentType: file.type || "audio/mpeg",
                                  audioBase64
                                });
                                setAmbienceLibrary((current) => [saved, ...current.filter((item) => item.id !== saved.id)]);
                                setAmbienceBedId(saved.bedId);
                              } catch (cause) {
                                setAmbienceError(cause instanceof Error ? cause.message : t("Upload failed"));
                              } finally {
                                setAmbienceBusy(false);
                              }
                            })();
                          }
                        }
                      ),
                      /* @__PURE__ */ jsx4("small", { children: t("MP3, WAV, OGG or M4A. Max 8 MB / 3 min. Save + Publish after choosing.") })
                    ] }),
                    customAmbienceAssetId(ambienceBedId) ? /* @__PURE__ */ jsx4(
                      "button",
                      {
                        type: "button",
                        className: "alx-btn ghost",
                        disabled: ambienceBusy,
                        onClick: () => {
                          const assetId = customAmbienceAssetId(ambienceBedId);
                          if (!assetId) return;
                          setAmbienceBusy(true);
                          void api.deleteAmbience(workspaceId, assetId).then(() => {
                            setAmbienceLibrary((current) => current.filter((item) => item.id !== assetId));
                            setAmbienceBedId("office");
                          }).catch((cause) => {
                            setAmbienceError(cause instanceof Error ? cause.message : t("Delete failed"));
                          }).finally(() => setAmbienceBusy(false));
                        },
                        children: t("Delete this sound")
                      }
                    ) : null,
                    ambienceBusy ? /* @__PURE__ */ jsx4("p", { className: "alx-muted", children: t("Uploading\u2026") }) : null,
                    ambienceError ? /* @__PURE__ */ jsx4("p", { className: "alx-banner-error", style: { padding: 8, marginTop: 8 }, children: ambienceError }) : null,
                    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                      /* @__PURE__ */ jsxs4("span", { children: [
                        t("Ambience level"),
                        " \u2014 ",
                        Math.round(ambienceGainValue * 100),
                        "%"
                      ] }),
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "ambienceGain",
                          type: "range",
                          min: "0",
                          max: "0.3",
                          step: "0.01",
                          value: ambienceGainValue,
                          onChange: (event) => setAmbienceGainValue(Number(event.target.value))
                        }
                      ),
                      /* @__PURE__ */ jsx4("small", { children: t(
                        "This slider changes the preview and the live phone after Save + Publish. 8% is clearly quieter than 12%."
                      ) })
                    ] }),
                    /* @__PURE__ */ jsxs4("div", { className: "alx-checks", children: [
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            name: "ambienceDuringSpeech",
                            type: "checkbox",
                            defaultChecked: agent.config?.voice.ambienceDuringSpeech ?? true
                          }
                        ),
                        t("Play while agent speaks")
                      ] }),
                      /* @__PURE__ */ jsxs4("label", { children: [
                        /* @__PURE__ */ jsx4(
                          "input",
                          {
                            name: "ambienceDuringWait",
                            type: "checkbox",
                            defaultChecked: agent.config?.voice.ambienceDuringWait ?? true
                          }
                        ),
                        t("Play while waiting for the answer")
                      ] })
                    ] }),
                    ambiencePreviewSrc ? /* @__PURE__ */ jsx4(
                      "audio",
                      {
                        ref: ambiencePreviewAudioRef,
                        controls: true,
                        preload: "none",
                        src: ambiencePreviewSrc,
                        style: { width: "100%", marginTop: 8 },
                        children: t("Ambience preview")
                      },
                      ambiencePreviewSrc
                    ) : null
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-checks", children: [
                    /* @__PURE__ */ jsxs4("label", { children: [
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "recordingEnabled",
                          type: "checkbox",
                          defaultChecked: agent.config?.voice.recordingEnabled ?? true
                        }
                      ),
                      t("Recording enabled")
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { children: [
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "interruptionEnabled",
                          type: "checkbox",
                          defaultChecked: agent.config?.voice.interruptionEnabled ?? true
                        }
                      ),
                      t("Interruptible (master)")
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { children: [
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "endCallOnSilence",
                          type: "checkbox",
                          defaultChecked: agent.config?.voice.endCallOnSilence ?? false
                        }
                      ),
                      t("End call on idle silence")
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Recording notice") }),
                    /* @__PURE__ */ jsx4(
                      "textarea",
                      {
                        name: "recordingNotice",
                        required: true,
                        rows: 2,
                        defaultValue: agent.config?.voice.recordingNotice ?? "This call may be recorded for quality purposes."
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Transfer phone number") }),
                    /* @__PURE__ */ jsx4(
                      "input",
                      {
                        name: "handoffDestination",
                        placeholder: "+905551112233",
                        defaultValue: agent.config?.voice.handoffDestination ?? ""
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxs4("p", { className: "numbers-help", children: [
                    /* @__PURE__ */ jsx4("b", { children: "Warm" }),
                    " \u2014 arayan ringback duyar (Dial); ajan cevaplarsa ba\u011Flan\u0131r.",
                    " ",
                    /* @__PURE__ */ jsx4("b", { children: "Blind" }),
                    " \u2014 sessiz ARI redirect. Full attended consult (\xF6nce operat\xF6r\u2013ajan sonra bridge) bu pakette yok. Live ops istekte ",
                    /* @__PURE__ */ jsx4("code", { children: "mode" }),
                    " se\xE7ebilir; di\u011Fer istemciler mode g\xF6ndermezse ajan ",
                    /* @__PURE__ */ jsx4("code", { children: "defaultHandoffMode" }),
                    " kullan\u0131l\u0131r."
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Default handoff mode") }),
                    /* @__PURE__ */ jsxs4(
                      "select",
                      {
                        name: "defaultHandoffMode",
                        defaultValue: agent.config?.voice.defaultHandoffMode ?? "warm",
                        children: [
                          /* @__PURE__ */ jsx4("option", { value: "warm", children: "Warm (ringback)" }),
                          /* @__PURE__ */ jsx4("option", { value: "blind", children: "Blind (silent redirect)" })
                        ]
                      }
                    )
                  ] })
                ] }),
                showAdvanced && /* @__PURE__ */ jsxs4("section", { className: "alx-form-card", children: [
                  /* @__PURE__ */ jsx4("h2", { children: t("Linear playbook") }),
                  /* @__PURE__ */ jsxs4("p", { className: "numbers-help", children: [
                    "Message \u2192 Question \u2192 Branch (2\u20133) \u2192 Lead / Handoff / End. ",
                    /* @__PURE__ */ jsx4("strong", { children: "Liste" }),
                    " ",
                    "veya lite ",
                    /* @__PURE__ */ jsx4("strong", { children: "Ak\u0131\u015F" }),
                    " g\xF6r\xFCn\xFCm\xFC \u2014 ayn\u0131 model; kaydedince system prompt i\xE7ine ",
                    /* @__PURE__ */ jsx4("code", { children: "## Playbook (linear)" }),
                    " derlenir (ayr\u0131 graph runtime yok)."
                  ] }),
                  /* @__PURE__ */ jsx4(PlaybookEditor, { playbook, onChange: setPlaybook, t })
                ] }),
                showAdvanced && /* @__PURE__ */ jsxs4("section", { className: "alx-form-card", children: [
                  /* @__PURE__ */ jsx4("h2", { children: t("Webchat widget") }),
                  /* @__PURE__ */ jsx4("p", { className: "numbers-help", children: "Marka rengi, launcher, saat dilimi, domain allowlist. Yay\u0131n sonras\u0131 webchat key ile embed snippet kopyalan\u0131r." }),
                  /* @__PURE__ */ jsx4(
                    WidgetBuilder,
                    {
                      widget,
                      onChange: setWidget,
                      agentName: agent.name,
                      t
                    }
                  ),
                  embedSnippet ? /* @__PURE__ */ jsxs4("div", { className: "alx-embed-snippet", children: [
                    /* @__PURE__ */ jsxs4("div", { className: "alx-playbook-toolbar", children: [
                      /* @__PURE__ */ jsxs4("small", { children: [
                        "EMBED SNIPPET \xB7 ",
                        deployment?.webchatKey ? "live key" : ""
                      ] }),
                      /* @__PURE__ */ jsx4(
                        "button",
                        {
                          type: "button",
                          className: "alx-btn ghost",
                          onClick: () => {
                            void navigator.clipboard?.writeText(embedSnippet).then(() => {
                              setSnippetCopied(true);
                              window.setTimeout(() => setSnippetCopied(false), 2e3);
                            });
                          },
                          children: snippetCopied ? t("Copied!") : t("Copy snippet")
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsx4("textarea", { readOnly: true, rows: 10, className: "alx-mono", value: embedSnippet })
                  ] }) : /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: t("Publish & deploy to get a webchat key and embed snippet.") })
                ] }),
                /* @__PURE__ */ jsxs4("section", { className: "alx-form-card", children: [
                  /* @__PURE__ */ jsx4("h2", { children: t("System Prompt") }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("System Prompt") }),
                    /* @__PURE__ */ jsx4(
                      "textarea",
                      {
                        name: "instructions",
                        required: true,
                        rows: 10,
                        className: "alx-mono",
                        defaultValue: agent.config?.instructions ?? seed?.instructions ?? "Answer only from published business knowledge."
                      }
                    ),
                    /* @__PURE__ */ jsxs4("small", { children: [
                      "Use ",
                      "{{business_name}}",
                      ", ",
                      "{{agent_name}}",
                      ", ",
                      "{{purpose}}",
                      ". Playbook blo\u011Fu kaydetmede otomatik eklenir/g\xFCncellenir."
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("First Message") }),
                    /* @__PURE__ */ jsx4(
                      "textarea",
                      {
                        name: "firstMessage",
                        rows: 3,
                        className: "alx-mono",
                        defaultValue: agent.config?.firstMessage ?? seed?.firstMessage ?? ""
                      }
                    ),
                    /* @__PURE__ */ jsx4("small", { children: t("Opening statement when the call connects") })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
                    /* @__PURE__ */ jsx4("span", { children: t("Blocked topics") }),
                    /* @__PURE__ */ jsx4(
                      "input",
                      {
                        name: "blockedTopics",
                        defaultValue: agent.config?.blockedTopics.join(", ") ?? seed?.blockedTopics.join(", ") ?? ""
                      }
                    )
                  ] })
                ] }),
                showAdvanced && /* @__PURE__ */ jsxs4("section", { className: "alx-form-card alx-services-card", children: [
                  /* @__PURE__ */ jsx4("h2", { children: "Servisler ve ara\xE7lar" }),
                  /* @__PURE__ */ jsx4("p", { className: "numbers-help", children: "Hangi i\u015Flemin hangi serviste \xE7al\u0131\u015Faca\u011F\u0131n\u0131 buradan se\xE7in. Platform ara\xE7lar\u0131 CenterOS i\xE7inde \xE7al\u0131\u015F\u0131r; m\xFC\u015Fteri HTTP servisleri ve connector\u2019lar Entegrasyonlar\u2019da tan\u0131mlan\u0131r, burada ajana ba\u011Flan\u0131r. Kaydet + Yay\u0131n sonras\u0131 test edin." }),
                  /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: "Platform servisleri (CenterOS)" }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-service-grid", children: [
                    /* @__PURE__ */ jsxs4("label", { className: "alx-service-row", children: [
                      /* @__PURE__ */ jsx4("input", { name: "cap_handoff", type: "checkbox", defaultChecked: caps.handoff }),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsx4("b", { children: "\u0130nsan aktar\u0131m\u0131 (handoff)" }),
                        /* @__PURE__ */ jsxs4("span", { children: [
                          "\u0130\u015Flem: ",
                          /* @__PURE__ */ jsx4("code", { children: "handoff.request" }),
                          " \xB7 Servis: CenterOS canl\u0131 ops / kuyruk"
                        ] })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-service-row", children: [
                      /* @__PURE__ */ jsx4("input", { name: "cap_end", type: "checkbox", defaultChecked: caps.endConversation }),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsx4("b", { children: "G\xF6r\xFC\u015Fmeyi sonland\u0131r" }),
                        /* @__PURE__ */ jsx4("span", { children: "\u0130\u015Flem: konu\u015Fma kapan\u0131\u015F\u0131 \xB7 Servis: CenterOS runtime" })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-service-row", children: [
                      /* @__PURE__ */ jsx4("input", { name: "cap_lead", type: "checkbox", defaultChecked: caps.leadCreate }),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsx4("b", { children: "Lead olu\u015Ftur" }),
                        /* @__PURE__ */ jsxs4("span", { children: [
                          "\u0130\u015Flem: ",
                          /* @__PURE__ */ jsx4("code", { children: "lead.create" }),
                          " \xB7 Servis: CenterOS CRM-lite / Leads"
                        ] })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-service-row", children: [
                      /* @__PURE__ */ jsx4("input", { name: "cap_callback", type: "checkbox", defaultChecked: caps.callbackSchedule }),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsx4("b", { children: "Geri arama planla" }),
                        /* @__PURE__ */ jsxs4("span", { children: [
                          "\u0130\u015Flem: ",
                          /* @__PURE__ */ jsx4("code", { children: "callback.schedule" }),
                          " \xB7 Servis: CenterOS takip"
                        ] })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-service-row", children: [
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "cap_appointment",
                          type: "checkbox",
                          defaultChecked: caps.appointmentBooking ?? false
                        }
                      ),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsx4("b", { children: "Randevu kayd\u0131" }),
                        /* @__PURE__ */ jsxs4("span", { children: [
                          "\u0130\u015Flem: ",
                          /* @__PURE__ */ jsx4("code", { children: "appointment.book" }),
                          " \xB7 Servis: CenterOS + takvim (ba\u011Fl\u0131ysa)"
                        ] })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs4("label", { className: "alx-service-row", children: [
                      /* @__PURE__ */ jsx4("input", { name: "cap_case", type: "checkbox", defaultChecked: caps.caseCreate }),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsx4("b", { children: "Destek kayd\u0131 (case)" }),
                        /* @__PURE__ */ jsxs4("span", { children: [
                          "\u0130\u015Flem: ",
                          /* @__PURE__ */ jsx4("code", { children: "case.create" }),
                          " \xB7 Servis: CenterOS case / notlar"
                        ] })
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: "Mesajla\u015Fma" }),
                  /* @__PURE__ */ jsxs4("p", { className: "numbers-help", children: [
                    "Post-call / mid-call mesaj niyeti. WhatsApp yaln\u0131zca workspace connector allowlist \xFCzerinden ba\u011Flan\u0131r (Meta domain hardcode yok). Otomatik g\xF6nderim Trust /",
                    " ",
                    /* @__PURE__ */ jsx4("code", { children: "autoSend" }),
                    " kap\u0131lar\u0131na ba\u011Fl\u0131 kal\u0131r."
                  ] }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-service-grid", children: [
                    /* @__PURE__ */ jsxs4(
                      "label",
                      {
                        className: `alx-service-row ${messagingWhatsappTemplate ? "on" : ""}`,
                        children: [
                          /* @__PURE__ */ jsx4(
                            "input",
                            {
                              name: "cap_wa_template",
                              type: "checkbox",
                              checked: messagingWhatsappTemplate,
                              onChange: (e) => applyWhatsAppMessagingTools(e.target.checked)
                            }
                          ),
                          /* @__PURE__ */ jsxs4("div", { children: [
                            /* @__PURE__ */ jsx4("b", { children: "WhatsApp \u015Fablon / metin g\xF6nderimi" }),
                            /* @__PURE__ */ jsxs4("span", { children: [
                              "Intent: ",
                              /* @__PURE__ */ jsx4("code", { children: "messagingWhatsappTemplate" }),
                              " \xB7 Ara\xE7lar:",
                              " ",
                              /* @__PURE__ */ jsx4("code", { children: "connector:\u2026#messages_send_template" }),
                              " /",
                              " ",
                              /* @__PURE__ */ jsx4("code", { children: "messages_send_text" }),
                              whatsappConnectorTools.length > 0 ? ` \xB7 ${whatsappConnectorTools.length} aktif op` : ""
                            ] }),
                            messagingWhatsappTemplate && whatsappConnectorTools.length === 0 && /* @__PURE__ */ jsxs4("span", { className: "numbers-empty", style: { display: "block", marginTop: 4 }, children: [
                              "E\u015Fle\u015Fen connector yok. Entegrasyonlar \u2192 WhatsApp sekmesi veya Operations durum kart\u0131ndan seed connector kurun (",
                              /* @__PURE__ */ jsx4("code", { children: "ctr_whatsapp_cloud_demo" }),
                              " \xB7",
                              " ",
                              /* @__PURE__ */ jsx4("code", { children: "scripts/seed-whatsapp-cloud-connector.sql" }),
                              "). Kimlik bilgisi buraya yaz\u0131lmaz; yaln\u0131zca ",
                              /* @__PURE__ */ jsx4("code", { children: "connector:\u2026#messages_send_*" }),
                              " ",
                              "allowlist.",
                              onOpenIntegrations ? " " : "",
                              onOpenIntegrations && /* @__PURE__ */ jsx4(
                                "button",
                                {
                                  type: "button",
                                  className: "alx-btn ghost",
                                  style: { marginLeft: 4 },
                                  onClick: onOpenIntegrations,
                                  children: "Entegrasyonlar"
                                }
                              )
                            ] })
                          ] })
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsxs4("label", { className: `alx-service-row ${messagingSmsPack ? "on" : ""}`, children: [
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          name: "cap_sms_pack",
                          type: "checkbox",
                          checked: messagingSmsPack,
                          onChange: (e) => setMessagingSmsPack(e.target.checked)
                        }
                      ),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsx4("b", { children: "SMS PACK fark\u0131ndal\u0131\u011F\u0131" }),
                        /* @__PURE__ */ jsxs4("span", { children: [
                          "Intent: ",
                          /* @__PURE__ */ jsx4("code", { children: "messagingSmsPack" }),
                          " \xB7 Giden SMS Numbers \u2192 SMS PACK (sim\xFClat\xF6r veya yap\u0131land\u0131r\u0131lm\u0131\u015F adapter). Ajan runtime\u2019da yeni SMS tool yok."
                        ] }),
                        onOpenNumbers && /* @__PURE__ */ jsx4("span", { style: { display: "block", marginTop: 4 }, children: /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: onOpenNumbers, children: "Numbers / SMS PACK" }) })
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: "M\xFC\u015Fteri HTTP servisleri (Entegrasyonlar)" }),
                  servicesError && /* @__PURE__ */ jsxs4("p", { className: "studio-alert error", children: [
                    "Servis listesi y\xFCklenemedi: ",
                    servicesError
                  ] }),
                  !integrationsApi ? /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: "Entegrasyon API bu oturumda yok. Plan/izin veya SSO yetkisini kontrol edin." }) : workspaceTools.length === 0 ? /* @__PURE__ */ jsxs4("div", { className: "alx-empty-services", children: [
                    /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: "Hen\xFCz tan\u0131ml\u0131 m\xFC\u015Fteri servisi yok. \xD6nce Entegrasyonlar\u2019da HTTP tool ekleyin (\xF6r. CRM lead, stok, sipari\u015F)." }),
                    onOpenIntegrations && /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn ghost", onClick: onOpenIntegrations, children: "Entegrasyonlar\u2019a git" })
                  ] }) : /* @__PURE__ */ jsx4("div", { className: "alx-service-grid", children: workspaceTools.map((tool) => {
                    const key = `customer:${tool.name}`;
                    const checked = selectedServiceTools.has(key);
                    return /* @__PURE__ */ jsxs4("label", { className: `alx-service-row ${checked ? "on" : ""}`, children: [
                      /* @__PURE__ */ jsx4(
                        "input",
                        {
                          type: "checkbox",
                          checked,
                          disabled: !tool.enabled,
                          onChange: () => {
                            setSelectedServiceTools((prev) => {
                              const next = new Set(prev);
                              if (next.has(key)) next.delete(key);
                              else next.add(key);
                              return next;
                            });
                          }
                        }
                      ),
                      /* @__PURE__ */ jsxs4("div", { children: [
                        /* @__PURE__ */ jsxs4("b", { children: [
                          tool.name,
                          " ",
                          /* @__PURE__ */ jsxs4("em", { className: "alx-svc-badge", children: [
                            tool.method,
                            " \xB7 ",
                            tool.enabled ? "aktif" : "kapal\u0131"
                          ] })
                        ] }),
                        /* @__PURE__ */ jsxs4("span", { children: [
                          "\u0130\u015Flem: ",
                          /* @__PURE__ */ jsx4("code", { children: key }),
                          " \xB7 Servis: ",
                          tool.url,
                          tool.description ? ` \u2014 ${tool.description}` : ""
                        ] })
                      ] })
                    ] }, tool.id);
                  }) }),
                  /* @__PURE__ */ jsx4("h3", { className: "alx-modal-section", children: "Connector operasyonlar\u0131" }),
                  !operationsApi ? /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: "Connector API bu oturumda yok." }) : connectors.length === 0 ? /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: "Connector yok. Operations / Entegrasyonlar \xFCzerinden connector ekleyebilirsiniz (\xF6r. WhatsApp Cloud)." }) : /* @__PURE__ */ jsx4("div", { className: "alx-service-grid", children: connectors.flatMap(
                    (connector) => connector.operations.map((op) => {
                      const key = `connector:${connector.id}#${op.name}`;
                      const checked = selectedServiceTools.has(key);
                      return /* @__PURE__ */ jsxs4(
                        "label",
                        {
                          className: `alx-service-row ${checked ? "on" : ""}`,
                          children: [
                            /* @__PURE__ */ jsx4(
                              "input",
                              {
                                type: "checkbox",
                                checked,
                                disabled: connector.status !== "active",
                                onChange: () => {
                                  setSelectedServiceTools((prev) => {
                                    const next = new Set(prev);
                                    if (next.has(key)) next.delete(key);
                                    else next.add(key);
                                    return next;
                                  });
                                }
                              }
                            ),
                            /* @__PURE__ */ jsxs4("div", { children: [
                              /* @__PURE__ */ jsxs4("b", { children: [
                                connector.name,
                                " \u2192 ",
                                op.name,
                                " ",
                                /* @__PURE__ */ jsx4("em", { className: "alx-svc-badge", children: connector.status })
                              ] }),
                              /* @__PURE__ */ jsxs4("span", { children: [
                                "\u0130\u015Flem: ",
                                /* @__PURE__ */ jsx4("code", { children: key }),
                                " \xB7 Origin: ",
                                connector.baseOrigin
                              ] })
                            ] })
                          ]
                        },
                        key
                      );
                    })
                  ) }),
                  /* @__PURE__ */ jsxs4("div", { className: "alx-selected-services", children: [
                    /* @__PURE__ */ jsxs4("small", { children: [
                      "AJANA BA\u011ELI SERV\u0130SLER (",
                      selectedServiceTools.size,
                      ")"
                    ] }),
                    selectedServiceTools.size === 0 ? /* @__PURE__ */ jsx4("p", { className: "numbers-empty", children: "Hen\xFCz m\xFC\u015Fteri/connector servisi se\xE7ilmedi." }) : /* @__PURE__ */ jsx4("ul", { children: [...selectedServiceTools].map((tool) => /* @__PURE__ */ jsx4("li", { children: /* @__PURE__ */ jsx4("code", { children: tool }) }, tool)) })
                  ] }),
                  /* @__PURE__ */ jsxs4("label", { className: "alx-field", style: { marginTop: 12 }, children: [
                    /* @__PURE__ */ jsx4("span", { children: "Geli\u015Fmi\u015F (serbest metin allowlist)" }),
                    /* @__PURE__ */ jsx4(
                      "input",
                      {
                        name: "allowedTools",
                        placeholder: "customer:ozel_servis, connector:ctr_xxx#op",
                        defaultValue: ""
                      }
                    ),
                    /* @__PURE__ */ jsx4("small", { children: "Yukar\u0131daki kutular tercih edilir. Serbest metin yaln\u0131zca listede olmayan ara\xE7lar i\xE7indir." })
                  ] })
                ] }),
                /* @__PURE__ */ jsx4("button", { type: "submit", className: "alx-btn primary", disabled: busy, children: t("Save Agent") })
              ]
            },
            `${agent.id}:${seed?.id ?? "no-seed"}`
          ),
          /* @__PURE__ */ jsxs4("aside", { className: "alx-side", children: [
            agent.config?.brainId && /* @__PURE__ */ jsx4(AgentVoiceFactsCard, { brainId: agent.config.brainId, brains }),
            /* @__PURE__ */ jsxs4("div", { className: "alx-form-card", children: [
              /* @__PURE__ */ jsx4("h2", { children: "Test odas\u0131" }),
              /* @__PURE__ */ jsx4("p", { className: "alx-muted", children: "Senaryo testi, serbest mesaj, PC demo ve giden arama ayr\u0131 sekmede \u2014 tam geni\u015Flikte ve okunabilir." }),
              /* @__PURE__ */ jsx4("button", { type: "button", className: "alx-btn", onClick: () => setStudioTab("test"), children: "Test odas\u0131n\u0131 a\xE7" })
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx4(
      "div",
      {
        className: "alx-test-room",
        style: studioTab === "settings" ? { display: "none" } : void 0,
        children: testRoomContent
      }
    )
  ] });
};
var submitSimulation = async (event, agent, api, conversationId, setConversationId, setMessages, setError, setBusy) => {
  event.preventDefault();
  const form = event.currentTarget;
  const value = new FormData(form).get("message");
  if (typeof value !== "string") return;
  await runSimulation(
    value,
    agent,
    api,
    conversationId,
    setConversationId,
    setMessages,
    setError,
    setBusy
  );
  form.reset();
};
var submitSimulationPhrase = async (phrase, agent, api, conversationId, setConversationId, setMessages, setError, setBusy) => {
  await runSimulation(
    phrase,
    agent,
    api,
    conversationId,
    setConversationId,
    setMessages,
    setError,
    setBusy
  );
};
var DEFAULT_SCENARIO_TURNS = [
  "Merhaba.",
  "Ni\xE7in arad\u0131n\u0131z?",
  "\xDCcret al\u0131n\u0131yor mu?",
  "Nas\u0131l kay\u0131t olunur?",
  "Te\u015Fekk\xFCrler, iyi g\xFCnler."
];
var VERDICT_LABEL = {
  clean: "TEM\u0130Z",
  attention: "D\u0130KKAT",
  failing: "BA\u015EARISIZ"
};
var ScenarioTestCard = ({
  agent,
  api,
  disabled
}) => {
  const [script, setScript] = useState3(() => DEFAULT_SCENARIO_TURNS.join("\n"));
  const [running, setRunning] = useState3(false);
  const [error, setError] = useState3();
  const [result, setResult] = useState3(null);
  const run = async () => {
    const turns = script.split("\n").map((line) => line.trim()).filter(Boolean).slice(0, 20);
    if (turns.length === 0) {
      setError("En az bir m\xFC\u015Fteri c\xFCmlesi yaz\u0131n.");
      return;
    }
    setRunning(true);
    setError(void 0);
    try {
      setResult(await api.simulateScenario(agent.id, turns));
    } catch (cause) {
      setError(errorMessage(cause));
      setResult(null);
    } finally {
      setRunning(false);
    }
  };
  const report = result?.report;
  return /* @__PURE__ */ jsxs4("div", { className: "alx-scenario", style: { marginTop: "1rem" }, children: [
    /* @__PURE__ */ jsx4("h3", { style: { margin: "0 0 0.25rem" }, children: "Senaryo testi" }),
    /* @__PURE__ */ jsx4("p", { className: "alx-muted", style: { marginTop: 0 }, children: "Her sat\u0131r bir m\xFC\u015Fteri c\xFCmlesi. Ajan s\u0131rayla cevaplar ve sonu\xE7, canl\u0131 \xE7a\u011Fr\u0131 karnesiyle ayn\u0131 \xF6l\xE7\xFCtlerle puanlan\u0131r. Telefon hatt\u0131 kullan\u0131lmaz, \xFCcret \xE7\u0131kmaz." }),
    /* @__PURE__ */ jsx4(
      "textarea",
      {
        rows: 5,
        value: script,
        disabled: disabled || running,
        onChange: (event) => setScript(event.target.value),
        style: { width: "100%" }
      }
    ),
    /* @__PURE__ */ jsx4("button", { type: "button", onClick: run, disabled: disabled || running, children: running ? "Senaryo \xE7al\u0131\u015F\u0131yor\u2026" : "Senaryoyu \xE7al\u0131\u015Ft\u0131r" }),
    error && /* @__PURE__ */ jsx4("p", { className: "studio-alert error", children: error }),
    report && /* @__PURE__ */ jsxs4("div", { className: "alx-scenario-result", style: { marginTop: "0.75rem" }, children: [
      /* @__PURE__ */ jsxs4("p", { children: [
        /* @__PURE__ */ jsxs4("b", { children: [
          "Sonu\xE7: ",
          VERDICT_LABEL[report.verdict]
        ] }),
        " \xB7 ",
        report.turns,
        " tur"
      ] }),
      /* @__PURE__ */ jsxs4("ul", { children: [
        /* @__PURE__ */ jsxs4("li", { children: [
          /* @__PURE__ */ jsx4("b", { children: report.blockedInventedClaims }),
          " uydurma c\xFCmle konu\u015Fulmadan engellendi"
        ] }),
        /* @__PURE__ */ jsxs4("li", { children: [
          /* @__PURE__ */ jsx4("b", { children: report.answeredQuestions }),
          " soru cevapland\u0131",
          report.unansweredQuestions > 0 ? ` \xB7 ${report.unansweredQuestions} soru cevaps\u0131z kald\u0131` : ""
        ] }),
        /* @__PURE__ */ jsxs4("li", { children: [
          /* @__PURE__ */ jsx4("b", { children: report.emptyReplies }),
          " sessiz tur \xB7 ",
          /* @__PURE__ */ jsx4("b", { children: report.repeatedReplies }),
          " tekrar eden cevap"
        ] }),
        report.recoveredTurns > 0 && /* @__PURE__ */ jsxs4("li", { children: [
          /* @__PURE__ */ jsx4("b", { children: report.recoveredTurns }),
          " turda g\xFCvenli cevaba d\xFC\u015F\xFCld\xFC \u2014 genelde bilgi taban\u0131nda eksik var demektir"
        ] })
      ] }),
      report.blockedClaimSamples.length > 0 && /* @__PURE__ */ jsxs4("details", { children: [
        /* @__PURE__ */ jsx4("summary", { children: "Engellenen ifadeler" }),
        /* @__PURE__ */ jsx4("ul", { children: report.blockedClaimSamples.map((sample) => /* @__PURE__ */ jsx4("li", { children: /* @__PURE__ */ jsx4("code", { children: sample }) }, sample)) })
      ] }),
      /* @__PURE__ */ jsxs4("details", { children: [
        /* @__PURE__ */ jsx4("summary", { children: "Konu\u015Fma d\xF6k\xFCm\xFC" }),
        result?.transcript.map((line, index) => /* @__PURE__ */ jsxs4("div", { style: { marginBottom: "0.5rem" }, children: [
          /* @__PURE__ */ jsxs4("p", { style: { margin: 0 }, children: [
            /* @__PURE__ */ jsx4("b", { children: "M\xFC\u015Fteri:" }),
            " ",
            line.user
          ] }),
          /* @__PURE__ */ jsxs4("p", { style: { margin: 0 }, children: [
            /* @__PURE__ */ jsx4("b", { children: "Ajan:" }),
            " ",
            line.assistant || /* @__PURE__ */ jsx4("em", { children: "(sessiz)" })
          ] })
        ] }, `${index}-${line.user}`))
      ] })
    ] })
  ] });
};
var AGENT_MISSION_FACT_PRESETS = [
  { key: "availability", label: "\u015Eu an konu\u015Fmaya m\xFCsait mi", type: "enum", enumValues: ["yes", "no"] },
  { key: "interest", label: "\u0130lgileniyor mu", type: "enum", enumValues: ["interested", "declined", "unsure"] },
  { key: "next_step", label: "Sonraki ad\u0131m", type: "enum", enumValues: ["register", "callback", "info", "none"] }
];
var AgentMissionCard = ({
  control,
  onChange
}) => {
  const [goal, setGoal] = useState3(() => control?.mission?.primaryGoal ?? "");
  const [success, setSuccess] = useState3(() => control?.mission?.successCondition ?? "");
  const [facts, setFacts] = useState3(
    () => (control?.factSchema ?? []).map((item) => item.key)
  );
  const push = (nextGoal, nextSuccess, nextFacts) => {
    if (!nextGoal.trim() || !nextSuccess.trim()) {
      onChange(void 0);
      return;
    }
    const chosen = AGENT_MISSION_FACT_PRESETS.filter((preset) => nextFacts.includes(preset.key));
    onChange({
      mission: { primaryGoal: nextGoal.trim(), successCondition: nextSuccess.trim() },
      factSchema: chosen.map((preset) => ({
        key: preset.key,
        label: preset.label,
        type: preset.type,
        enumValues: [...preset.enumValues],
        requiredIn: [],
        confirmationPolicy: "if_low_confidence",
        scope: "call"
      })),
      completionRules: {
        successStageIds: [],
        requiredFactKeys: chosen.map((preset) => preset.key),
        allowCloseOnDecline: true
      },
      policies: {
        doNotRepeatConfirmed: true,
        maxQuestionsPerTurn: 1,
        lowConfidenceThreshold: 0.7,
        closeRequiresCompletion: false
      }
    });
  };
  return /* @__PURE__ */ jsxs4("div", { className: "alx-form-card", children: [
    /* @__PURE__ */ jsx4("h2", { children: "G\xF6rev (konu\u015Fma amac\u0131)" }),
    /* @__PURE__ */ jsx4("p", { className: "alx-muted", children: "Ajan\u0131n neden arad\u0131\u011F\u0131n\u0131 ve neyi \xF6\u011Frenmesi gerekti\u011Fini burada yazars\u0131n\u0131z. Dolduruldu\u011Funda ajan amac\u0131n\u0131 konu\u015Fma boyunca \xF6n\xFCnde tutar, tek soru sorar ve konuyu ilerletir. Bo\u015F b\u0131rak\u0131l\u0131rsa ajan yaln\u0131zca modelin insaf\u0131na kal\u0131r \u2014 gelen \xE7a\u011Fr\u0131 gibi davran\u0131r." }),
    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
      /* @__PURE__ */ jsx4("span", { children: "ASIL AMA\xC7" }),
      /* @__PURE__ */ jsx4(
        "input",
        {
          value: goal,
          maxLength: 200,
          placeholder: "\xF6rn. Eczaneyi Farma Tedarik'e \xFCye olmaya davet etmek",
          onChange: (event) => {
            setGoal(event.target.value);
            push(event.target.value, success, facts);
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs4("label", { className: "alx-field", children: [
      /* @__PURE__ */ jsx4("span", { children: "BA\u015EARI KO\u015EULU" }),
      /* @__PURE__ */ jsx4(
        "input",
        {
          value: success,
          maxLength: 400,
          placeholder: "\xF6rn. \u0130lgilenen eczanenin kayd\u0131 veya geri arama randevusu al\u0131n\u0131r",
          onChange: (event) => {
            setSuccess(event.target.value);
            push(goal, event.target.value, facts);
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsx4("span", { className: "alx-field", children: /* @__PURE__ */ jsx4("span", { children: "\xC7A\u011ERIDA \xD6\u011EREN\u0130LECEKLER" }) }),
    /* @__PURE__ */ jsx4("div", { className: "alx-test-chips", children: AGENT_MISSION_FACT_PRESETS.map((preset) => {
      const on = facts.includes(preset.key);
      return /* @__PURE__ */ jsxs4(
        "button",
        {
          type: "button",
          className: on ? "alx-chip-btn active" : "alx-chip-btn",
          onClick: () => {
            const next = on ? facts.filter((item) => item !== preset.key) : [...facts, preset.key];
            setFacts(next);
            push(goal, success, next);
          },
          children: [
            on ? "\u2713 " : "",
            preset.label
          ]
        },
        preset.key
      );
    }) }),
    (!goal.trim() || !success.trim()) && /* @__PURE__ */ jsx4("p", { className: "numbers-help", children: "Ama\xE7 ve ba\u015Far\u0131 ko\u015Fulu dolmadan g\xF6rev kaydedilmez; ajan eski davran\u0131\u015F\u0131nda kal\u0131r." })
  ] });
};
var AgentVoiceFactsCard = ({
  brainId,
  brains
}) => {
  const [status, setStatus] = useState3(null);
  const [busy, setBusy] = useState3(false);
  const [error, setError] = useState3();
  const [notice, setNotice] = useState3();
  const load = useCallback3(async () => {
    try {
      setStatus(await brains.voiceOnboarding(brainId));
    } catch {
      setStatus(null);
    }
  }, [brainId, brains]);
  useEffect3(() => {
    void load();
  }, [load]);
  if (!status || !status.nextTopic) return null;
  const topic = status.nextTopic;
  return /* @__PURE__ */ jsxs4("div", { className: "alx-form-card", children: [
    /* @__PURE__ */ jsx4("h2", { children: "Telefonda eksik bilgiler" }),
    /* @__PURE__ */ jsx4("p", { className: "alx-muted", children: "Arayanlar\u0131n sordu\u011Fu ama ajan\u0131n cevaplayamad\u0131\u011F\u0131 konular. Cevab\u0131n\u0131z onay bekleyen bilgi olarak kaydedilir; onaylamad\u0131\u011F\u0131n\u0131z hi\xE7bir c\xFCmle konu\u015Fulmaz." }),
    /* @__PURE__ */ jsx4("div", { className: "brain-progress", children: /* @__PURE__ */ jsx4("i", { style: { width: `${status.progress}%` } }) }),
    !status.callReady && /* @__PURE__ */ jsxs4("p", { className: "numbers-help", children: [
      status.missingRequiredKeys.length,
      " zorunlu soru kald\u0131 \xB7 %",
      status.progress,
      " tamam"
    ] }),
    /* @__PURE__ */ jsx4("h3", { style: { marginBottom: "0.25rem" }, children: topic.question }),
    /* @__PURE__ */ jsx4("p", { className: "alx-muted", style: { marginTop: 0 }, children: topic.why }),
    /* @__PURE__ */ jsxs4(
      "form",
      {
        onSubmit: (event) => {
          event.preventDefault();
          const form = event.currentTarget;
          const answer = new FormData(form).get("voiceFact");
          if (typeof answer !== "string") return;
          setBusy(true);
          setError(void 0);
          setNotice(void 0);
          void brains.voiceOnboardingAnswer(brainId, topic.key, answer).then(async () => {
            form.reset();
            setNotice("Kaydedildi. S\u0131radaki soru geldi.");
            await load();
          }).catch((cause) => setError(errorMessage(cause))).finally(() => setBusy(false));
        },
        children: [
          /* @__PURE__ */ jsx4(
            "textarea",
            {
              name: "voiceFact",
              required: true,
              rows: 3,
              placeholder: "Arayana s\xF6ylenecek ger\xE7ek cevab\u0131 yaz\u0131n\u2026"
            }
          ),
          /* @__PURE__ */ jsx4("button", { type: "submit", disabled: busy, children: "Cevab\u0131 kaydet" })
        ]
      }
    ),
    notice && /* @__PURE__ */ jsx4("p", { className: "studio-alert success", children: notice }),
    error && /* @__PURE__ */ jsx4("p", { className: "studio-alert error", children: error })
  ] });
};
var runSimulation = async (value, agent, api, conversationId, setConversationId, setMessages, setError, setBusy) => {
  if (!value.trim()) return;
  setBusy(true);
  setError(void 0);
  const submitted = value.trim();
  const userMessage = {
    id: crypto.randomUUID(),
    role: "user",
    text: submitted,
    citations: []
  };
  setMessages((current) => [...current, userMessage]);
  try {
    const response = await api.simulate(
      agent.id,
      submitted,
      crypto.randomUUID(),
      conversationId
    );
    setConversationId(response.conversationId);
    setMessages((current) => [
      ...current,
      {
        id: response.messageId,
        role: "assistant",
        text: response.text,
        citations: response.citations
      }
    ]);
  } catch (cause) {
    setMessages((current) => current.filter((message3) => message3.id !== userMessage.id));
    setError(errorMessage(cause));
  } finally {
    setBusy(false);
  }
};
var createWebchatApi = (apiBaseUrl, deploymentKey) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  return {
    start: async () => {
      const response = await fetch(`${base}/v1/webchat/sessions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deploymentKey })
      });
      if (!response.ok) throw new Error("WEBCHAT_SESSION_FAILED");
      return webchatSessionResponseSchema.parse(await response.json());
    },
    send: async (token, content) => {
      const response = await fetch(`${base}/v1/webchat/messages`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ clientMessageId: crypto.randomUUID(), content })
      });
      if (!response.ok) throw new Error("WEBCHAT_MESSAGE_FAILED");
      return runtimeResponseSchema.parse(await response.json());
    }
  };
};
var WebchatWidget = ({
  api,
  locale = "en"
}) => {
  const currentLocale = typeof locale === "string" ? localeFrom(locale) : locale;
  const t = (text) => translate(currentLocale, text);
  const [session, setSession] = useState3();
  const [messages, setMessages] = useState3(
    []
  );
  const [error, setError] = useState3();
  const [busy, setBusy] = useState3(false);
  const [open, setOpen] = useState3(true);
  useEffect3(() => {
    void api.start().then((s) => {
      setSession(s);
      if (s.widget?.welcomeMessage) {
        setMessages([
          {
            id: "welcome",
            role: "assistant",
            text: s.widget.welcomeMessage
          }
        ]);
      }
    }).catch((cause) => setError(errorMessage(cause)));
  }, [api]);
  const theme = session?.widget;
  const primary = theme?.primaryColor ?? "#4f46e5";
  const title = theme?.title?.trim() || session?.agentName || t("Connecting\u2026");
  const subtitle = theme?.showBranding === false ? theme?.subtitle?.trim() || "" : theme?.subtitle?.trim() || t("Verified AI agent");
  return /* @__PURE__ */ jsx4(
    "section",
    {
      className: `webchat-widget${open ? "" : " is-collapsed"}`,
      style: { ["--centeros-primary"]: primary },
      children: !open ? /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          className: "webchat-launcher",
          style: { background: primary },
          onClick: () => setOpen(true),
          children: theme?.launcherLabel || t("Chat")
        }
      ) : /* @__PURE__ */ jsxs4(Fragment3, { children: [
        /* @__PURE__ */ jsxs4("header", { style: { background: primary }, children: [
          /* @__PURE__ */ jsxs4("div", { children: [
            /* @__PURE__ */ jsx4("b", { children: title }),
            subtitle ? /* @__PURE__ */ jsx4("small", { children: subtitle }) : null
          ] }),
          /* @__PURE__ */ jsx4("button", { type: "button", className: "webchat-min", onClick: () => setOpen(false), children: "\u2212" })
        ] }),
        /* @__PURE__ */ jsx4("div", { className: "webchat-log", children: messages.map((item) => /* @__PURE__ */ jsx4("div", { className: item.role, children: /* @__PURE__ */ jsx4("p", { children: item.text }) }, item.id)) }),
        error && /* @__PURE__ */ jsx4("div", { className: "webchat-error", children: error }),
        /* @__PURE__ */ jsxs4(
          "form",
          {
            onSubmit: (event) => {
              event.preventDefault();
              const form = event.currentTarget;
              const content = new FormData(form).get("message");
              if (!session || typeof content !== "string") return;
              setMessages((c) => [...c, { id: crypto.randomUUID(), role: "user", text: content }]);
              form.reset();
              setBusy(true);
              void api.send(session.token, content).then(
                (response) => setMessages((c) => [
                  ...c,
                  { id: response.messageId, role: "assistant", text: response.text }
                ])
              ).catch((cause) => setError(errorMessage(cause))).finally(() => setBusy(false));
            },
            children: [
              /* @__PURE__ */ jsx4("input", { name: "message", required: true, placeholder: t("Type a message\u2026") }),
              /* @__PURE__ */ jsx4("button", { disabled: !session || busy, style: { background: primary }, children: t("Send") })
            ]
          }
        )
      ] })
    }
  );
};
var errorMessage = (cause) => cause instanceof Error ? cause.message.replaceAll("_", " ") : "Unexpected request failure";
var formString = (data, key) => {
  const value = data.get(key);
  return typeof value === "string" ? value : "";
};

// src/voice.tsx
import { useCallback as useCallback5, useEffect as useEffect5, useMemo as useMemo4, useState as useState5 } from "react";
import {
  callToolTimelineSchema,
  DIALOGUE_STYLE_CATALOG,
  voiceCallCardSchema,
  voiceCallListSchema,
  voiceCallViewSchema as voiceCallViewSchema2,
  voiceGreetingResponseSchema,
  voiceTranscriptSchema,
  voiceTurnResponseSchema
} from "@agentos/contracts";

// src/leads.tsx
import { useCallback as useCallback4, useEffect as useEffect4, useMemo as useMemo3, useState as useState4 } from "react";
import {
  LEAD_LIST_CONTRACT_HEADER,
  LEAD_LIST_CONTRACT_WORKSPACE_V1,
  LEAD_STAGE_BOARD,
  bulkUpdateVoiceLeadStagesResponseSchema,
  voiceLeadListSchema,
  voiceLeadViewSchema
} from "@agentos/contracts";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var createLeadsApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const request = async (path, init) => {
    const response = await fetch(`${base}${path}`, {
      ...init,
      headers: {
        Authorization: `Bearer ${token}`,
        [LEAD_LIST_CONTRACT_HEADER]: LEAD_LIST_CONTRACT_WORKSPACE_V1,
        ...init?.body ? { "content-type": "application/json" } : {},
        ...init?.headers ?? {}
      },
      signal: AbortSignal.timeout(12e3)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.code ?? `HTTP_${response.status}`);
    }
    if (response.status === 204) return null;
    return response.json();
  };
  return {
    list: async (workspaceId, stage, score) => {
      const qs = new URLSearchParams({
        workspaceId,
        limit: "80",
        contract: LEAD_LIST_CONTRACT_WORKSPACE_V1
      });
      if (stage) qs.set("stage", stage);
      if (score) qs.set("score", score);
      return voiceLeadListSchema.parse(await request(`/v1/leads?${qs.toString()}`));
    },
    get: async (leadId) => voiceLeadViewSchema.parse(await request(`/v1/leads/${encodeURIComponent(leadId)}`)),
    byCall: async (callId) => {
      const raw = await request(`/v1/leads/by-call/${encodeURIComponent(callId)}`);
      if (raw == null) return null;
      return voiceLeadViewSchema.parse(raw);
    },
    update: async (leadId, patch) => voiceLeadViewSchema.parse(
      await request(`/v1/leads/${encodeURIComponent(leadId)}`, {
        method: "PATCH",
        body: JSON.stringify(patch)
      })
    ),
    bulkStage: async (workspaceId, leadIds, stage) => bulkUpdateVoiceLeadStagesResponseSchema.parse(
      await request(
        `/v1/leads/bulk-stage?workspaceId=${encodeURIComponent(workspaceId)}`,
        {
          method: "POST",
          body: JSON.stringify({ leadIds, stage })
        }
      )
    )
  };
};
var LeadsPage = ({
  api,
  locale,
  workspaceId,
  initialLeadId,
  onOpenCall
}) => {
  const currentLocale = localeFrom(typeof locale === "string" ? locale : locale);
  const t = (text) => translate(currentLocale, text);
  const [items, setItems] = useState4([]);
  const [selected, setSelected] = useState4();
  const [error, setError] = useState4();
  const [busy, setBusy] = useState4(false);
  const [mode, setMode] = useState4("board");
  const [filterStage, setFilterStage] = useState4("");
  const [filterScore, setFilterScore] = useState4("");
  const [selectedIds, setSelectedIds] = useState4(/* @__PURE__ */ new Set());
  const [bulkStage, setBulkStage] = useState4("contacted");
  const [leadUsage, setLeadUsage] = useState4(0);
  const [leadLimit, setLeadLimit] = useState4(null);
  const [leadEnforcement, setLeadEnforcement] = useState4(null);
  const load = useCallback4(async () => {
    setBusy(true);
    try {
      const page = await api.list(workspaceId, filterStage || null, filterScore || null);
      setItems(page.items);
      setLeadUsage(page.usage);
      setLeadLimit(page.limit);
      setLeadEnforcement(page.enforcement);
      setSelected((current) => {
        if (initialLeadId) {
          const hit = page.items.find((item) => item.id === initialLeadId);
          if (hit) return hit;
        }
        if (current && page.items.some((item) => item.id === current.id)) {
          return page.items.find((item) => item.id === current.id) ?? current;
        }
        return page.items[0];
      });
      setError(void 0);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "LEADS_LOAD_FAILED");
    } finally {
      setBusy(false);
    }
  }, [api, filterScore, filterStage, initialLeadId, workspaceId]);
  useEffect4(() => {
    void load();
  }, [load]);
  useEffect4(() => {
    if (!initialLeadId || items.length === 0) return;
    const hit = items.find((item) => item.id === initialLeadId);
    if (hit) setSelected(hit);
  }, [initialLeadId, items]);
  const byStage = useMemo3(() => {
    const map = /* @__PURE__ */ new Map();
    for (const stage of LEAD_STAGE_BOARD) map.set(stage, []);
    for (const lead of items) {
      const bucket = map.get(lead.stage) ?? [];
      bucket.push(lead);
      map.set(lead.stage, bucket);
    }
    return map;
  }, [items]);
  const moveLead = async (leadId, stage) => {
    setBusy(true);
    try {
      const updated = await api.update(leadId, { stage });
      setItems((prev) => prev.map((l) => l.id === leadId ? updated : l));
      setSelected((cur) => cur?.id === leadId ? updated : cur);
      setError(void 0);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "LEAD_UPDATE_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const runBulk = async () => {
    if (selectedIds.size === 0) return;
    setBusy(true);
    try {
      const result = await api.bulkStage(workspaceId, [...selectedIds], bulkStage);
      const map = new Map(result.items.map((l) => [l.id, l]));
      setItems((prev) => prev.map((l) => map.get(l.id) ?? l));
      setSelectedIds(/* @__PURE__ */ new Set());
      setError(void 0);
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "LEAD_BULK_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const toggleSelect = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };
  const usageCount = Math.max(leadUsage, items.length);
  const atPlanLimit = (leadEnforcement === "soft" || leadEnforcement === "hard") && leadLimit != null && usageCount >= leadLimit;
  const leadCountLabel = leadLimit != null ? `${usageCount} / ${leadLimit} lead` : `${usageCount} lead`;
  return /* @__PURE__ */ jsxs5("section", { className: "leads-page studio-page", children: [
    /* @__PURE__ */ jsxs5("header", { className: "studio-toolbar", children: [
      /* @__PURE__ */ jsxs5("div", { children: [
        /* @__PURE__ */ jsx5("span", { children: "ARAMA FABR\u0130KASI" }),
        /* @__PURE__ */ jsx5("h2", { children: "Leadler" })
      ] }),
      /* @__PURE__ */ jsx5("b", { children: leadCountLabel }),
      /* @__PURE__ */ jsxs5("div", { className: "leads-toolbar-actions", children: [
        /* @__PURE__ */ jsxs5("div", { className: "leads-view-toggle", children: [
          /* @__PURE__ */ jsx5(
            "button",
            {
              type: "button",
              className: mode === "board" ? "active" : "",
              onClick: () => setMode("board"),
              children: "Pano"
            }
          ),
          /* @__PURE__ */ jsx5(
            "button",
            {
              type: "button",
              className: mode === "list" ? "active" : "",
              onClick: () => setMode("list"),
              children: "Liste"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs5("label", { className: "leads-filter", children: [
          "A\u015Fama",
          /* @__PURE__ */ jsxs5(
            "select",
            {
              value: filterStage,
              onChange: (e) => setFilterStage(e.target.value || ""),
              children: [
                /* @__PURE__ */ jsx5("option", { value: "", children: "T\xFCm\xFC" }),
                LEAD_STAGE_BOARD.map((s) => /* @__PURE__ */ jsx5("option", { value: s, children: stageLabel(s) }, s))
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxs5("label", { className: "leads-filter", children: [
          "Skor",
          /* @__PURE__ */ jsxs5(
            "select",
            {
              value: filterScore,
              onChange: (e) => setFilterScore(e.target.value || ""),
              children: [
                /* @__PURE__ */ jsx5("option", { value: "", children: "T\xFCm\xFC" }),
                /* @__PURE__ */ jsx5("option", { value: "hot", children: "S\u0131cak" }),
                /* @__PURE__ */ jsx5("option", { value: "warm", children: "Il\u0131k" }),
                /* @__PURE__ */ jsx5("option", { value: "cold", children: "So\u011Fuk" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsx5("button", { type: "button", disabled: busy, onClick: () => void load(), children: "Yenile" })
      ] })
    ] }),
    /* @__PURE__ */ jsx5("p", { className: "leads-note", children: "Otomatik lead kartlar\u0131 + manuel a\u015Fama board. Fiyat uydurulmaz; \xF6zet konu\u015Fmadan t\xFCretilir. Kart\u0131 s\xFCr\xFCklemek yerine a\u015Fama men\xFCs\xFCnden ta\u015F\u0131y\u0131n veya toplu ta\u015F\u0131ma kullan\u0131n." }),
    error && /* @__PURE__ */ jsx5("div", { className: "studio-alert error", children: error }),
    atPlanLimit && /* @__PURE__ */ jsx5("div", { className: "studio-alert", role: "status", children: t("Approaching plan lead limit") }),
    selectedIds.size > 0 && /* @__PURE__ */ jsxs5("div", { className: "leads-bulk-bar", children: [
      /* @__PURE__ */ jsxs5("span", { children: [
        selectedIds.size,
        " se\xE7ili"
      ] }),
      /* @__PURE__ */ jsx5(
        "select",
        {
          value: bulkStage,
          onChange: (e) => setBulkStage(e.target.value),
          children: LEAD_STAGE_BOARD.map((s) => /* @__PURE__ */ jsx5("option", { value: s, children: stageLabel(s) }, s))
        }
      ),
      /* @__PURE__ */ jsx5("button", { type: "button", disabled: busy, onClick: () => void runBulk(), children: "Toplu ta\u015F\u0131" }),
      /* @__PURE__ */ jsx5("button", { type: "button", className: "ghost", onClick: () => setSelectedIds(/* @__PURE__ */ new Set()), children: "Se\xE7imi temizle" })
    ] }),
    mode === "board" ? /* @__PURE__ */ jsx5("div", { className: "leads-board", children: LEAD_STAGE_BOARD.map((stage) => {
      const col = byStage.get(stage) ?? [];
      return /* @__PURE__ */ jsxs5("div", { className: "leads-column", children: [
        /* @__PURE__ */ jsxs5("header", { children: [
          /* @__PURE__ */ jsx5("strong", { children: stageLabel(stage) }),
          /* @__PURE__ */ jsx5("em", { children: col.length })
        ] }),
        /* @__PURE__ */ jsx5("div", { className: "leads-column-body", children: col.length === 0 ? /* @__PURE__ */ jsx5("p", { className: "voice-tool-empty", children: "Bu a\u015Famada lead yok" }) : col.map((lead) => /* @__PURE__ */ jsxs5(
          "button",
          {
            type: "button",
            className: selected?.id === lead.id ? "leads-card active" : "leads-card",
            onClick: () => setSelected(lead),
            children: [
              /* @__PURE__ */ jsxs5("span", { className: "leads-card-top", children: [
                /* @__PURE__ */ jsx5(
                  "input",
                  {
                    type: "checkbox",
                    checked: selectedIds.has(lead.id),
                    onChange: () => toggleSelect(lead.id),
                    onClick: (e) => e.stopPropagation()
                  }
                ),
                /* @__PURE__ */ jsx5("strong", { children: lead.displayName ?? lead.phoneMasked ?? lead.id })
              ] }),
              /* @__PURE__ */ jsxs5("small", { children: [
                scoreLabel(lead.leadScore),
                lead.aiCategory ? ` \xB7 ${lead.aiCategory}` : ""
              ] }),
              /* @__PURE__ */ jsx5(
                "select",
                {
                  value: lead.stage,
                  disabled: busy,
                  onClick: (e) => e.stopPropagation(),
                  onChange: (e) => void moveLead(lead.id, e.target.value),
                  children: LEAD_STAGE_BOARD.map((s) => /* @__PURE__ */ jsx5("option", { value: s, children: stageLabel(s) }, s))
                }
              )
            ]
          },
          lead.id
        )) })
      ] }, stage);
    }) }) : /* @__PURE__ */ jsxs5("div", { className: "studio-grid", children: [
      /* @__PURE__ */ jsxs5("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx5("header", { children: /* @__PURE__ */ jsxs5("div", { children: [
          /* @__PURE__ */ jsx5("small", { children: "L\u0130STE" }),
          /* @__PURE__ */ jsxs5("h3", { children: [
            items.length,
            " lead"
          ] })
        ] }) }),
        /* @__PURE__ */ jsx5("div", { className: "leads-list", children: items.length === 0 ? /* @__PURE__ */ jsxs5("div", { className: "studio-inline-empty compact", children: [
          /* @__PURE__ */ jsx5("strong", { children: "Hen\xFCz lead yok" }),
          /* @__PURE__ */ jsx5("p", { children: "Tamamlanan aramalardan lead kart\u0131 olu\u015Fur. Kampanya veya tek arama bitince burada listelenir." })
        ] }) : items.map((lead) => /* @__PURE__ */ jsxs5(
          "button",
          {
            type: "button",
            className: selected?.id === lead.id ? "active" : "",
            onClick: () => setSelected(lead),
            children: [
              /* @__PURE__ */ jsxs5("span", { children: [
                /* @__PURE__ */ jsx5("strong", { children: lead.displayName ?? lead.phoneMasked ?? lead.id }),
                /* @__PURE__ */ jsxs5("small", { children: [
                  scoreLabel(lead.leadScore),
                  " \xB7 ",
                  stageLabel(lead.stage),
                  lead.aiCategory ? ` \xB7 ${lead.aiCategory}` : ""
                ] })
              ] }),
              /* @__PURE__ */ jsx5("em", { className: `score-${lead.leadScore}`, children: scoreLabel(lead.leadScore) })
            ]
          },
          lead.id
        )) })
      ] }),
      /* @__PURE__ */ jsxs5("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsxs5("header", { children: [
          /* @__PURE__ */ jsxs5("div", { children: [
            /* @__PURE__ */ jsx5("small", { children: "LEAD KARTI" }),
            /* @__PURE__ */ jsx5("h3", { children: selected?.displayName ?? selected?.id ?? "Se\xE7in" })
          ] }),
          selected && /* @__PURE__ */ jsx5("b", { className: `score-${selected.leadScore}`, children: scoreLabel(selected.leadScore) })
        ] }),
        !selected ? /* @__PURE__ */ jsxs5("div", { className: "studio-inline-empty compact", children: [
          /* @__PURE__ */ jsx5("strong", { children: "Lead se\xE7in" }),
          /* @__PURE__ */ jsx5("p", { children: "Soldaki listeden bir kart a\xE7\u0131n; a\u015Fama ve skor buradan g\xFCncellenir." })
        ] }) : /* @__PURE__ */ jsx5(
          LeadCardDetail,
          {
            lead: selected,
            busy,
            onStageChange: (stage) => void moveLead(selected.id, stage),
            onScoreChange: (leadScore) => {
              void (async () => {
                setBusy(true);
                try {
                  const updated = await api.update(selected.id, { leadScore });
                  setItems(
                    (prev) => prev.map((l) => l.id === selected.id ? updated : l)
                  );
                  setSelected(updated);
                } catch (cause) {
                  setError(
                    cause instanceof Error ? cause.message : "LEAD_UPDATE_FAILED"
                  );
                } finally {
                  setBusy(false);
                }
              })();
            },
            ...onOpenCall ? { onOpenCall } : {}
          }
        )
      ] })
    ] }),
    mode === "board" && selected && /* @__PURE__ */ jsxs5("article", { className: "studio-card leads-detail-dock", children: [
      /* @__PURE__ */ jsx5("header", { children: /* @__PURE__ */ jsxs5("div", { children: [
        /* @__PURE__ */ jsx5("small", { children: "DETAY" }),
        /* @__PURE__ */ jsx5("h3", { children: selected.displayName ?? selected.id })
      ] }) }),
      /* @__PURE__ */ jsx5(
        LeadCardDetail,
        {
          lead: selected,
          busy,
          onStageChange: (stage) => void moveLead(selected.id, stage),
          onScoreChange: (leadScore) => {
            void (async () => {
              setBusy(true);
              try {
                const updated = await api.update(selected.id, { leadScore });
                setItems((prev) => prev.map((l) => l.id === selected.id ? updated : l));
                setSelected(updated);
              } catch (cause) {
                setError(cause instanceof Error ? cause.message : "LEAD_UPDATE_FAILED");
              } finally {
                setBusy(false);
              }
            })();
          },
          ...onOpenCall ? { onOpenCall } : {}
        }
      )
    ] })
  ] });
};
var LeadCardDetail = ({
  lead,
  onOpenCall,
  onStageChange,
  onScoreChange,
  busy
}) => /* @__PURE__ */ jsxs5("div", { className: "lead-card-detail", children: [
  /* @__PURE__ */ jsxs5("div", { className: "lead-metrics", children: [
    /* @__PURE__ */ jsxs5("span", { children: [
      "A\u015Fama",
      " ",
      onStageChange ? /* @__PURE__ */ jsx5(
        "select",
        {
          value: lead.stage,
          disabled: busy,
          onChange: (e) => onStageChange(e.target.value),
          children: LEAD_STAGE_BOARD.map((s) => /* @__PURE__ */ jsx5("option", { value: s, children: stageLabel(s) }, s))
        }
      ) : /* @__PURE__ */ jsx5("b", { children: stageLabel(lead.stage) })
    ] }),
    /* @__PURE__ */ jsxs5("span", { children: [
      "Skor",
      " ",
      onScoreChange ? /* @__PURE__ */ jsxs5(
        "select",
        {
          value: lead.leadScore,
          disabled: busy,
          onChange: (e) => onScoreChange(e.target.value),
          children: [
            /* @__PURE__ */ jsx5("option", { value: "hot", children: "S\u0131cak" }),
            /* @__PURE__ */ jsx5("option", { value: "warm", children: "Il\u0131k" }),
            /* @__PURE__ */ jsx5("option", { value: "cold", children: "So\u011Fuk" })
          ]
        }
      ) : /* @__PURE__ */ jsx5("b", { className: `score-${lead.leadScore}`, children: scoreLabel(lead.leadScore) })
    ] }),
    /* @__PURE__ */ jsxs5("span", { children: [
      "Sentiment ",
      /* @__PURE__ */ jsx5("b", { children: lead.sentiment })
    ] }),
    /* @__PURE__ */ jsxs5("span", { children: [
      "Kaynak ",
      /* @__PURE__ */ jsx5("b", { children: lead.source })
    ] })
  ] }),
  lead.phoneMasked && /* @__PURE__ */ jsxs5("p", { className: "lead-line", children: [
    "Telefon ",
    /* @__PURE__ */ jsx5("b", { children: lead.phoneMasked })
  ] }),
  lead.aiCategory && /* @__PURE__ */ jsxs5("p", { className: "lead-line", children: [
    "Kategori ",
    /* @__PURE__ */ jsx5("b", { children: lead.aiCategory })
  ] }),
  lead.aiSummary && /* @__PURE__ */ jsxs5("div", { className: "voice-summary", children: [
    /* @__PURE__ */ jsx5("small", { children: "AI \xD6ZET" }),
    /* @__PURE__ */ jsx5("p", { children: lead.aiSummary })
  ] }),
  lead.aiNextAction && /* @__PURE__ */ jsxs5("div", { className: "lead-next-action", children: [
    /* @__PURE__ */ jsx5("small", { children: "SONRAK\u0130 ADIM" }),
    /* @__PURE__ */ jsx5("p", { children: lead.aiNextAction })
  ] }),
  lead.tags.length > 0 && /* @__PURE__ */ jsxs5("small", { className: "lead-tags", children: [
    "Etiketler: ",
    lead.tags.join(", ")
  ] }),
  /* @__PURE__ */ jsx5("div", { className: "lead-actions", children: lead.callId && onOpenCall ? /* @__PURE__ */ jsx5(
    "button",
    {
      type: "button",
      onClick: () => {
        const callId = lead.callId;
        if (callId) onOpenCall(callId);
      },
      children: "Aramay\u0131 a\xE7"
    }
  ) : lead.callId ? /* @__PURE__ */ jsx5("code", { className: "lead-call-id", children: lead.callId }) : /* @__PURE__ */ jsx5("small", { className: "lead-channel", children: lead.channel }) })
] });
var scoreLabel = (score) => {
  switch (score) {
    case "hot":
      return "S\u0131cak";
    case "warm":
      return "Il\u0131k";
    case "cold":
      return "So\u011Fuk";
    default:
      return score;
  }
};
var stageLabel = (stage) => {
  switch (stage) {
    case "new":
      return "Yeni";
    case "contacted":
      return "G\xF6r\xFC\u015F\xFCld\xFC";
    case "qualified":
      return "Nitelikli";
    case "callback":
      return "Geri arama";
    case "not_interested":
      return "\u0130lgilenmiyor";
    case "converted":
      return "D\xF6n\xFC\u015Ft\xFC";
    case "closed":
      return "Kapal\u0131";
    default:
      return stage;
  }
};

// src/voice.tsx
import { Fragment as Fragment4, jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var buildCallListQuery = (workspaceId, filters, cursor, limit) => {
  const params = new URLSearchParams();
  params.set("workspaceId", workspaceId);
  if (cursor) params.set("cursor", cursor);
  if (limit) params.set("limit", String(limit));
  if (filters?.status) params.set("status", filters.status);
  if (filters?.direction) params.set("direction", filters.direction);
  if (filters?.agentId) params.set("agentId", filters.agentId);
  if (filters?.campaignId) params.set("campaignId", filters.campaignId);
  if (filters?.hasRecording !== void 0) {
    params.set("hasRecording", filters.hasRecording ? "true" : "false");
  }
  if (filters?.hasSummary !== void 0) {
    params.set("hasSummary", filters.hasSummary ? "true" : "false");
  }
  if (filters?.startedAfter) params.set("startedAfter", filters.startedAfter);
  if (filters?.startedBefore) params.set("startedBefore", filters.startedBefore);
  return params.toString();
};
var createVoiceApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const request = async (path, init, timeoutMs = 12e3) => {
    const response = await fetch(`${base}${path}`, {
      ...init,
      headers: {
        Authorization: `Bearer ${token}`,
        ...init?.body ? { "Content-Type": "application/json" } : {}
      },
      signal: AbortSignal.timeout(timeoutMs)
    });
    if (!response.ok) {
      await throwProblemError(response);
    }
    return response.json();
  };
  return {
    list: async (workspaceId, filters, cursor, limit) => voiceCallListSchema.parse(
      await request(`/v1/calls?${buildCallListQuery(workspaceId, filters, cursor, limit)}`)
    ),
    start: async (input) => voiceCallViewSchema2.parse(
      await request("/v1/calls", {
        method: "POST",
        body: JSON.stringify({ ...input, clientCallId: crypto.randomUUID() })
      })
    ),
    turn: async (callId, utteranceOrInput, bargeIn = false) => {
      const input = typeof utteranceOrInput === "string" ? { utterance: utteranceOrInput, bargeIn, includeAudio: false } : utteranceOrInput;
      const utterance = input.utterance?.trim() ?? "";
      return voiceTurnResponseSchema.parse(
        await request(
          `/v1/calls/${encodeURIComponent(callId)}/turns`,
          {
            method: "POST",
            body: JSON.stringify({
              clientEventId: crypto.randomUUID(),
              ...utterance ? { utterance } : {},
              ...input.audioBase64 ? {
                audioBase64: input.audioBase64,
                audioEncoding: input.audioEncoding ?? "webm"
              } : {},
              includeAudio: input.includeAudio ?? false,
              startedAtMs: 0,
              endedAtMs: Math.max(250, utterance.length * 40),
              bargeIn: input.bargeIn ?? bargeIn
            })
          },
          55e3
        )
      );
    },
    greeting: async (callId) => voiceGreetingResponseSchema.parse(
      await request(
        `/v1/calls/${encodeURIComponent(callId)}/greeting`,
        { method: "POST", body: JSON.stringify({}) },
        3e4
      )
    ),
    transcript: async (callId) => voiceTranscriptSchema.parse(
      await request(`/v1/calls/${encodeURIComponent(callId)}/transcript`)
    ),
    tools: async (callId) => callToolTimelineSchema.parse(
      await request(`/v1/calls/${encodeURIComponent(callId)}/tools`)
    ),
    card: async (callId) => voiceCallCardSchema.parse(await request(`/v1/calls/${encodeURIComponent(callId)}/card`)),
    recordingBlob: async (callId) => {
      const response = await fetch(`${base}/v1/calls/${encodeURIComponent(callId)}/recording`, {
        headers: { Authorization: `Bearer ${token}` },
        signal: AbortSignal.timeout(3e4)
      });
      if (!response.ok) {
        await throwProblemError(response);
      }
      return response.blob();
    },
    handoff: async (callId, reason) => voiceCallViewSchema2.parse(
      await request(`/v1/calls/${encodeURIComponent(callId)}/handoff`, {
        method: "POST",
        body: JSON.stringify({ reason })
      })
    ),
    complete: async (callId, reason = "caller_hangup") => voiceCallViewSchema2.parse(
      await request(`/v1/calls/${encodeURIComponent(callId)}/complete`, {
        method: "POST",
        body: JSON.stringify({ reason })
      })
    )
  };
};
var VoiceStudioPage = ({
  api,
  agents,
  phoneNumbersApi,
  locale: _locale,
  workspaceId,
  initialCallId,
  onOpenCampaign,
  onOpenLead
}) => {
  const [agentOptions, setAgentOptions] = useState5([]);
  const [numbers, setNumbers] = useState5([]);
  const [calls, setCalls] = useState5([]);
  const [nextCursor, setNextCursor] = useState5(null);
  const [selected, setSelected] = useState5();
  const [turns, setTurns] = useState5([]);
  const [transcript, setTranscript] = useState5();
  const [tools, setTools] = useState5([]);
  const [followUps, setFollowUps] = useState5([]);
  const [cardAnalysis, setCardAnalysis] = useState5(null);
  const [analysisJob, setAnalysisJob] = useState5(null);
  const [cardContext, setCardContext] = useState5(null);
  const [opsCost, setOpsCost] = useState5(null);
  const [cardLead, setCardLead] = useState5(null);
  const [transcriptCount, setTranscriptCount] = useState5(0);
  const [recordingUrl, setRecordingUrl] = useState5();
  const [cardQuality, setCardQuality] = useState5(null);
  const [recordingError, setRecordingError] = useState5();
  const [error, setError] = useState5();
  const [busy, setBusy] = useState5(false);
  const [loadingMore, setLoadingMore] = useState5(false);
  const [density, setDensity] = useState5("comfortable");
  const [filterStatus, setFilterStatus] = useState5("");
  const [filterDirection, setFilterDirection] = useState5("");
  const [filterAgentId, setFilterAgentId] = useState5("");
  const [filterRecording, setFilterRecording] = useState5("");
  const [filterSummary, setFilterSummary] = useState5("");
  const [quickFilter, setQuickFilter] = useState5("all");
  const [cardTab, setCardTab] = useState5("summary");
  const [showTestTools, setShowTestTools] = useState5(false);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState5(false);
  const [demoAgentId, setDemoAgentId] = useState5("");
  const filters = useMemo4(() => {
    const draft = {};
    if (quickFilter === "failed") draft.status = "failed";
    else if (quickFilter === "active") draft.status = "active";
    else if (filterStatus) draft.status = filterStatus;
    if (filterDirection) draft.direction = filterDirection;
    if (filterAgentId) draft.agentId = filterAgentId;
    if (quickFilter === "recording") draft.hasRecording = true;
    else if (filterRecording === "yes") draft.hasRecording = true;
    else if (filterRecording === "no") draft.hasRecording = false;
    if (filterSummary === "yes") draft.hasSummary = true;
    if (filterSummary === "no") draft.hasSummary = false;
    if (quickFilter === "today") {
      const start = /* @__PURE__ */ new Date();
      start.setHours(0, 0, 0, 0);
      draft.startedAfter = start.toISOString();
    }
    return Object.keys(draft).length > 0 ? draft : void 0;
  }, [filterStatus, filterDirection, filterAgentId, filterRecording, filterSummary, quickFilter]);
  const applyQuickFilter = (next) => {
    setQuickFilter(next);
    if (next !== "all") {
      setFilterStatus("");
      setFilterRecording("");
      setFilterSummary("");
    }
  };
  const load = useCallback5(async () => {
    const [agentPage, callPage, numberPage] = await Promise.all([
      agents.list(workspaceId),
      api.list(workspaceId, filters, null, 30),
      phoneNumbersApi ? phoneNumbersApi.list(workspaceId) : Promise.resolve({ items: [] })
    ]);
    setAgentOptions(
      agentPage.items.map(({ id, name, publishedVersion }) => ({
        id,
        name,
        publishedVersion
      }))
    );
    setNumbers(numberPage.items.filter((item) => item.status === "active"));
    setCalls(callPage.items);
    setNextCursor(callPage.nextCursor);
    setSelected((current) => {
      if (initialCallId) {
        const hit = callPage.items.find((item) => item.id === initialCallId);
        if (hit) return hit;
      }
      if (current && callPage.items.some((item) => item.id === current.id)) {
        return callPage.items.find((item) => item.id === current.id) ?? current;
      }
      return current ?? callPage.items[0];
    });
  }, [agents, api, filters, initialCallId, phoneNumbersApi, workspaceId]);
  useEffect5(() => {
    void load().catch((cause) => setError(message2(cause)));
  }, [load]);
  useEffect5(() => {
    setCardTab("summary");
  }, [selected?.id]);
  const refreshTranscript = async (call) => {
    setSelected(call);
    setCardTab("summary");
    setRecordingError(void 0);
    try {
      const [nextTranscript, card] = await Promise.all([
        api.transcript(call.id),
        api.card(call.id)
      ]);
      setTranscript(nextTranscript);
      setTranscriptCount(card.transcriptEntryCount);
      setTools(card.tools);
      setFollowUps(card.followUps);
      setCardAnalysis(card.analysis);
      setCardQuality(card.quality ?? null);
      setAnalysisJob(card.analysisJob);
      setCardContext(card.context);
      setOpsCost(card.opsCost ?? null);
      setCardLead(card.lead);
      setSelected(card.call);
      await loadRecordingAudio(api, card.call, setRecordingUrl, setRecordingError);
    } catch {
      const [nextTranscript, nextTools] = await Promise.all([
        api.transcript(call.id),
        api.tools(call.id)
      ]);
      setTranscript(nextTranscript);
      setTranscriptCount(nextTranscript.entries.length);
      setTools(nextTools.items);
      setFollowUps([]);
      setCardAnalysis(null);
      setAnalysisJob(null);
      setCardContext(null);
      setOpsCost(null);
      setCardLead(null);
      await loadRecordingAudio(api, call, setRecordingUrl, setRecordingError);
    }
    await load();
  };
  useEffect5(() => {
    if (!initialCallId) return;
    const hit = calls.find((item) => item.id === initialCallId);
    if (hit && selected?.id !== hit.id) {
      void refreshTranscript(hit).catch((cause) => setError(message2(cause)));
    }
  }, [initialCallId, calls]);
  useEffect5(() => {
    if (!selected || ["completed", "failed"].includes(selected.status)) return;
    const timer = setInterval(() => {
      void refreshTranscript(selected).catch(() => void 0);
    }, 5e3);
    return () => clearInterval(timer);
  }, [selected?.id, selected?.status]);
  const loadMore = async () => {
    if (!nextCursor || loadingMore) return;
    setLoadingMore(true);
    try {
      const page = await api.list(workspaceId, filters, nextCursor, 30);
      setCalls((current) => {
        const seen = new Set(current.map((item) => item.id));
        return [...current, ...page.items.filter((item) => !seen.has(item.id))];
      });
      setNextCursor(page.nextCursor);
    } catch (cause) {
      setError(message2(cause));
    } finally {
      setLoadingMore(false);
    }
  };
  return /* @__PURE__ */ jsxs6("section", { className: `voice-studio density-${density}`, children: [
    /* @__PURE__ */ jsxs6("header", { className: "voice-toolbar", children: [
      /* @__PURE__ */ jsxs6("div", { children: [
        /* @__PURE__ */ jsx6("span", { children: "G\xD6R\xDC\u015EMELER" }),
        /* @__PURE__ */ jsx6("h2", { children: "Aramalar \xB7 dinle ve takip et" })
      ] }),
      /* @__PURE__ */ jsx6("div", { className: "voice-toolbar-actions", children: /* @__PURE__ */ jsxs6("div", { className: "voice-density-toggle", role: "group", "aria-label": "Liste yo\u011Funlu\u011Fu", children: [
        /* @__PURE__ */ jsx6(
          "button",
          {
            type: "button",
            className: density === "comfortable" ? "active" : "",
            onClick: () => setDensity("comfortable"),
            children: "Rahat"
          }
        ),
        /* @__PURE__ */ jsx6(
          "button",
          {
            type: "button",
            className: density === "compact" ? "active" : "",
            onClick: () => setDensity("compact"),
            children: "S\u0131k\u0131"
          }
        )
      ] }) })
    ] }),
    error && /* @__PURE__ */ jsx6("div", { className: "studio-alert error", children: error }),
    /* @__PURE__ */ jsx6(
      "button",
      {
        type: "button",
        className: "voice-test-tools-toggle",
        onClick: () => setShowTestTools((v) => !v),
        children: showTestTools ? "\u25BC Test / softphone ara\xE7lar\u0131n\u0131 gizle" : "\u25B6 Test / softphone ara\xE7lar\u0131"
      }
    ),
    showTestTools && /* @__PURE__ */ jsxs6(Fragment4, { children: [
      /* @__PURE__ */ jsxs6("article", { className: "studio-card voice-browser-demo", children: [
        /* @__PURE__ */ jsxs6("p", { className: "voice-demo-copy", children: [
          "Softphone birincil yolu: ",
          /* @__PURE__ */ jsx6("b", { children: "AI Ajanlar\u0131" }),
          " \u2192 ajan \u2192 ",
          /* @__PURE__ */ jsx6("b", { children: "PC Demo G\xF6r\xFC\u015Fme" }),
          ". Buradan h\u0131zl\u0131 test de yapabilirsiniz."
        ] }),
        /* @__PURE__ */ jsxs6("label", { className: "voice-demo-agent-pick", children: [
          "Yay\u0131nlanm\u0131\u015F ajan",
          /* @__PURE__ */ jsxs6("select", { value: demoAgentId, onChange: (event) => setDemoAgentId(event.target.value), children: [
            /* @__PURE__ */ jsx6("option", { value: "", children: "Ajan se\xE7" }),
            agentOptions.map((agent) => /* @__PURE__ */ jsx6("option", { value: agent.id, children: agent.name }, agent.id))
          ] })
        ] }),
        demoAgentId ? /* @__PURE__ */ jsx6(
          BrowserDemoSoftphone,
          {
            api,
            workspaceId,
            agentId: demoAgentId,
            agentName: agentOptions.find((a) => a.id === demoAgentId)?.name ?? demoAgentId,
            publishedVersion: agentOptions.find((a) => a.id === demoAgentId)?.publishedVersion ?? null
          },
          demoAgentId
        ) : /* @__PURE__ */ jsx6("p", { className: "voice-demo-copy", children: "Demo i\xE7in ajan se\xE7in veya AI Ajanlar\u0131 sayfas\u0131na gidin." })
      ] }),
      /* @__PURE__ */ jsxs6("article", { className: "studio-card voice-call-create", children: [
        /* @__PURE__ */ jsx6("header", { children: /* @__PURE__ */ jsxs6("div", { children: [
          /* @__PURE__ */ jsx6("small", { children: "PSTN TEST" }),
          /* @__PURE__ */ jsx6("h3", { children: "Telefon aramas\u0131 ba\u015Flat" })
        ] }) }),
        /* @__PURE__ */ jsxs6(
          "form",
          {
            onSubmit: (event) => void startCall(
              event,
              api,
              workspaceId,
              numbers,
              setBusy,
              setError,
              refreshTranscript
            ),
            children: [
              /* @__PURE__ */ jsxs6("label", { children: [
                "Yay\u0131nlanm\u0131\u015F Ajan",
                /* @__PURE__ */ jsxs6("select", { name: "agentId", defaultValue: "", children: [
                  /* @__PURE__ */ jsx6("option", { value: "", children: numbers.some((n) => n.defaultInboundAgentId) ? "\u2014 DID ba\u011F\u0131ndan (inbound) \u2014" : "Ajan se\xE7" }),
                  agentOptions.map((agent) => /* @__PURE__ */ jsx6("option", { value: agent.id, children: agent.name }, agent.id))
                ] })
              ] }),
              /* @__PURE__ */ jsxs6("label", { children: [
                "Y\xF6n",
                /* @__PURE__ */ jsxs6("select", { name: "direction", children: [
                  /* @__PURE__ */ jsx6("option", { value: "outbound", children: "Giden" }),
                  /* @__PURE__ */ jsx6("option", { value: "inbound", children: "Gelen" })
                ] })
              ] }),
              /* @__PURE__ */ jsxs6("label", { children: [
                "Arayan numara",
                numbers.length > 0 ? /* @__PURE__ */ jsx6("select", { name: "numberId", required: true, defaultValue: numbers[0]?.id, children: numbers.map((item) => /* @__PURE__ */ jsxs6("option", { value: item.id, children: [
                  item.label || item.e164,
                  " \xB7 ",
                  item.numberClass,
                  " \xB7 ",
                  item.e164
                ] }, item.id)) }) : /* @__PURE__ */ jsx6("input", { name: "from", required: true, defaultValue: "+908501000000", placeholder: "+E.164" })
              ] }),
              /* @__PURE__ */ jsxs6("label", { children: [
                "Kime",
                /* @__PURE__ */ jsx6("input", { name: "to", required: true, defaultValue: "+905551112233" })
              ] }),
              /* @__PURE__ */ jsxs6("label", { className: "voice-consent", children: [
                /* @__PURE__ */ jsx6("input", { name: "consent", type: "checkbox", required: true }),
                " Kay\u0131t bilgilendirmesi kabul edildi"
              ] }),
              /* @__PURE__ */ jsx6(
                "button",
                {
                  disabled: busy || agentOptions.length === 0 && !numbers.some((n) => n.defaultInboundAgentId),
                  children: "Aramay\u0131 ba\u015Flat"
                }
              )
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs6("div", { className: "voice-layout", children: [
      /* @__PURE__ */ jsxs6("article", { className: "studio-card voice-call-create", children: [
        /* @__PURE__ */ jsx6("header", { children: /* @__PURE__ */ jsxs6("div", { children: [
          /* @__PURE__ */ jsx6("small", { children: "L\u0130STE" }),
          /* @__PURE__ */ jsx6("h3", { children: "Arama ge\xE7mi\u015Fi" })
        ] }) }),
        /* @__PURE__ */ jsx6("div", { className: "voice-quick-filters", role: "group", "aria-label": "H\u0131zl\u0131 filtreler", children: [
          ["all", "T\xFCm\xFC"],
          ["today", "Bug\xFCn"],
          ["failed", "Ba\u015Far\u0131s\u0131z"],
          ["recording", "Dinlenebilir kay\u0131t"],
          ["active", "Aktif"]
        ].map(([id, label]) => /* @__PURE__ */ jsx6(
          "button",
          {
            type: "button",
            className: quickFilter === id ? "active" : "",
            onClick: () => applyQuickFilter(id),
            children: label
          },
          id
        )) }),
        /* @__PURE__ */ jsx6(
          "button",
          {
            type: "button",
            className: "voice-advanced-filters-toggle",
            onClick: () => setShowAdvancedFilters((v) => !v),
            children: showAdvancedFilters ? "\u25BC Detayl\u0131 filtreleri gizle" : "\u25B6 Detayl\u0131 filtreler"
          }
        ),
        showAdvancedFilters && /* @__PURE__ */ jsx6("div", { className: "call-list-filters", children: /* @__PURE__ */ jsxs6("div", { className: "call-list-filter-grid", children: [
          /* @__PURE__ */ jsxs6("label", { children: [
            "Durum",
            /* @__PURE__ */ jsxs6(
              "select",
              {
                value: quickFilter === "all" ? filterStatus : "",
                disabled: quickFilter !== "all",
                onChange: (event) => {
                  setQuickFilter("all");
                  setFilterStatus(event.target.value);
                },
                children: [
                  /* @__PURE__ */ jsx6("option", { value: "", children: "T\xFCm\xFC" }),
                  /* @__PURE__ */ jsx6("option", { value: "active", children: "Aktif" }),
                  /* @__PURE__ */ jsx6("option", { value: "completed", children: "Tamamland\u0131" }),
                  /* @__PURE__ */ jsx6("option", { value: "failed", children: "Ba\u015Far\u0131s\u0131z" }),
                  /* @__PURE__ */ jsx6("option", { value: "ringing", children: "\xC7al\u0131yor" }),
                  /* @__PURE__ */ jsx6("option", { value: "queued", children: "Kuyrukta" }),
                  /* @__PURE__ */ jsx6("option", { value: "waiting_for_human", children: "\u0130nsan bekliyor" })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs6("label", { children: [
            "Y\xF6n",
            /* @__PURE__ */ jsxs6(
              "select",
              {
                value: filterDirection,
                onChange: (event) => setFilterDirection(event.target.value),
                children: [
                  /* @__PURE__ */ jsx6("option", { value: "", children: "T\xFCm\xFC" }),
                  /* @__PURE__ */ jsx6("option", { value: "outbound", children: "Giden" }),
                  /* @__PURE__ */ jsx6("option", { value: "inbound", children: "Gelen" })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs6("label", { children: [
            "Ajan",
            /* @__PURE__ */ jsxs6(
              "select",
              {
                value: filterAgentId,
                onChange: (event) => setFilterAgentId(event.target.value),
                children: [
                  /* @__PURE__ */ jsx6("option", { value: "", children: "T\xFCm\xFC" }),
                  agentOptions.map((agent) => /* @__PURE__ */ jsx6("option", { value: agent.id, children: agent.name }, agent.id))
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs6("label", { children: [
            "Kay\u0131t",
            /* @__PURE__ */ jsxs6(
              "select",
              {
                value: quickFilter === "all" ? filterRecording : "",
                disabled: quickFilter !== "all",
                onChange: (event) => {
                  setQuickFilter("all");
                  setFilterRecording(event.target.value);
                },
                children: [
                  /* @__PURE__ */ jsx6("option", { value: "", children: "T\xFCm\xFC" }),
                  /* @__PURE__ */ jsx6("option", { value: "yes", children: "Var" }),
                  /* @__PURE__ */ jsx6("option", { value: "no", children: "Yok" })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs6("label", { children: [
            "\xD6zet",
            /* @__PURE__ */ jsxs6(
              "select",
              {
                value: filterSummary,
                onChange: (event) => setFilterSummary(event.target.value),
                children: [
                  /* @__PURE__ */ jsx6("option", { value: "", children: "T\xFCm\xFC" }),
                  /* @__PURE__ */ jsx6("option", { value: "yes", children: "Var" }),
                  /* @__PURE__ */ jsx6("option", { value: "no", children: "Yok" })
                ]
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ jsx6("div", { className: `call-list density-${density}`, children: calls.length === 0 ? /* @__PURE__ */ jsx6("div", { className: "studio-inline-empty compact", children: filters ? /* @__PURE__ */ jsxs6(Fragment4, { children: [
          /* @__PURE__ */ jsx6("strong", { children: "Filtreye uyan arama yok" }),
          /* @__PURE__ */ jsx6("p", { children: "Durum, y\xF6n, ajan veya kay\u0131t filtrelerini gev\u015Fetin; liste otomatik yenilenir." })
        ] }) : /* @__PURE__ */ jsxs6(Fragment4, { children: [
          /* @__PURE__ */ jsx6("strong", { children: "Hen\xFCz arama yok" }),
          /* @__PURE__ */ jsx6("p", { children: "Softphone i\xE7in AI Ajanlar\u0131 \u2192 PC Demo G\xF6r\xFC\u015Fme; toplu arama i\xE7in Kampanyalar; tek arama i\xE7in Rehber." })
        ] }) }) : calls.map((call) => /* @__PURE__ */ jsxs6(
          "button",
          {
            type: "button",
            className: selected?.id === call.id ? "active" : "",
            onClick: () => void refreshTranscript(call).catch((cause) => setError(message2(cause))),
            children: [
              /* @__PURE__ */ jsxs6("span", { children: [
                /* @__PURE__ */ jsx6("strong", { children: call.direction === "outbound" ? "Giden" : "Gelen" }),
                /* @__PURE__ */ jsxs6("small", { children: [
                  call.fromMasked,
                  " \u2192 ",
                  call.toMasked
                ] }),
                /* @__PURE__ */ jsxs6("small", { children: [
                  formatDateTime(call.startedAt),
                  " \xB7 ",
                  call.durationSeconds,
                  "s",
                  call.recording.status === "available" ? " \xB7 \u{1F399}" : "",
                  call.summary ? " \xB7 \xF6zet" : ""
                ] })
              ] }),
              /* @__PURE__ */ jsx6("em", { className: `status-${call.status}`, children: statusLabel(call.status) })
            ]
          },
          call.id
        )) }),
        nextCursor && /* @__PURE__ */ jsx6(
          "button",
          {
            type: "button",
            className: "call-list-more",
            disabled: loadingMore,
            onClick: () => void loadMore(),
            children: loadingMore ? "Y\xFCkleniyor\u2026" : "Daha fazla y\xFCkle"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs6("article", { className: "studio-card voice-runtime-card", children: [
        /* @__PURE__ */ jsxs6("header", { children: [
          /* @__PURE__ */ jsxs6("div", { children: [
            /* @__PURE__ */ jsx6("small", { children: "ARAMA KARTI" }),
            /* @__PURE__ */ jsx6("h3", { children: selected ? shortId(selected.id) : "Arama se\xE7in" }),
            selected && /* @__PURE__ */ jsx6("code", { className: "voice-call-id", title: selected.id, children: selected.id })
          ] }),
          /* @__PURE__ */ jsx6("b", { className: selected ? `status-${selected.status}` : "", children: selected ? statusLabel(selected.status) : "\u2014" })
        ] }),
        selected && (selected.handoffRequested || selected.status === "waiting_for_human") && /* @__PURE__ */ jsxs6("div", { className: "voice-handoff-banner", role: "status", children: [
          /* @__PURE__ */ jsx6("span", { children: selected.status === "waiting_for_human" ? "\u0130nsan devralmas\u0131 bekleniyor" : "\u0130nsan devralmas\u0131 talep edildi" }),
          /* @__PURE__ */ jsx6(
            "button",
            {
              type: "button",
              className: "voice-hangup-banner-btn",
              disabled: busy,
              onClick: () => void action(selected, api.complete, void 0, refreshTranscript, setError),
              children: "G\xF6r\xFC\u015Fmeyi kapat"
            }
          )
        ] }),
        selected && !["completed", "failed"].includes(selected.status) && !(selected.handoffRequested || selected.status === "waiting_for_human") && /* @__PURE__ */ jsx6("div", { className: "voice-active-actions", role: "group", "aria-label": "Arama i\u015Flemleri", children: /* @__PURE__ */ jsx6(
          "button",
          {
            type: "button",
            className: "voice-hangup-banner-btn",
            disabled: busy,
            onClick: () => void action(selected, api.complete, void 0, refreshTranscript, setError),
            children: "G\xF6r\xFC\u015Fmeyi kapat"
          }
        ) }),
        /* @__PURE__ */ jsxs6("div", { className: "voice-metrics", children: [
          /* @__PURE__ */ jsxs6("span", { children: [
            "S\xFCre ",
            /* @__PURE__ */ jsxs6("b", { children: [
              selected?.durationSeconds ?? 0,
              "s"
            ] })
          ] }),
          /* @__PURE__ */ jsxs6("span", { children: [
            "Kay\u0131t ",
            /* @__PURE__ */ jsx6("b", { children: selected ? recordingStatusLabel(selected.recording.status) : "\u2014" })
          ] }),
          /* @__PURE__ */ jsxs6("span", { children: [
            "Transkript ",
            /* @__PURE__ */ jsx6("b", { children: transcriptCount || transcript?.entries.length || 0 })
          ] }),
          /* @__PURE__ */ jsxs6("span", { children: [
            "S\xF6z kesme ",
            /* @__PURE__ */ jsx6("b", { children: selected?.bargeInCount ?? 0 })
          ] }),
          /* @__PURE__ */ jsxs6("span", { children: [
            "Ba\u015Flang\u0131\xE7 ",
            /* @__PURE__ */ jsx6("b", { children: formatDateTime(selected?.startedAt) })
          ] }),
          /* @__PURE__ */ jsxs6("span", { children: [
            "Biti\u015F ",
            /* @__PURE__ */ jsx6("b", { children: selected?.endedAt ? formatDateTime(selected.endedAt) : "S\xFCr\xFCyor" })
          ] })
        ] }),
        /* @__PURE__ */ jsx6("div", { className: "voice-card-tabs", role: "tablist", "aria-label": "Arama kart\u0131 sekmeleri", children: [
          ["summary", "\xD6zet"],
          ["transcript", "Transkript"],
          ["recording", "Kay\u0131t"],
          ["lead", `Lead${cardLead ? "" : ""}`]
        ].map(([id, label]) => /* @__PURE__ */ jsxs6(
          "button",
          {
            type: "button",
            role: "tab",
            "aria-selected": cardTab === id,
            className: cardTab === id ? "active" : "",
            onClick: () => setCardTab(id),
            children: [
              label,
              id === "lead" && cardLead ? ` \xB7 ${scoreLabel(cardLead.leadScore)}` : ""
            ]
          },
          id
        )) }),
        cardTab === "summary" && /* @__PURE__ */ jsxs6(Fragment4, { children: [
          cardQuality && /* @__PURE__ */ jsx6(CallQualityPanel, { report: cardQuality }),
          selected && /* @__PURE__ */ jsxs6("div", { className: "voice-context-panel", children: [
            /* @__PURE__ */ jsx6("small", { children: "ARAMA BA\u011ELAMI" }),
            /* @__PURE__ */ jsxs6("div", { className: "voice-context-grid", children: [
              /* @__PURE__ */ jsxs6("span", { children: [
                "Ama\xE7 ",
                /* @__PURE__ */ jsx6("b", { children: purposeLabel(cardContext?.purpose ?? null) })
              ] }),
              /* @__PURE__ */ jsxs6("span", { children: [
                "Diyalog stili",
                " ",
                /* @__PURE__ */ jsx6("b", { children: dialogueStyleLabel(cardContext?.dialogueStyle ?? null) })
              ] }),
              /* @__PURE__ */ jsxs6("span", { children: [
                "Profil ",
                /* @__PURE__ */ jsx6("b", { children: cardContext?.serviceProfile ?? "\u2014" })
              ] }),
              /* @__PURE__ */ jsxs6("span", { children: [
                "Ses ",
                /* @__PURE__ */ jsx6("b", { children: cardContext?.voiceProfileId ?? "\u2014" })
              ] }),
              /* @__PURE__ */ jsxs6("span", { children: [
                "Ki\u015Fi ",
                /* @__PURE__ */ jsx6("b", { children: cardContext?.contact?.displayName ?? "\u2014" })
              ] }),
              /* @__PURE__ */ jsxs6("span", { children: [
                "Kampanya",
                " ",
                cardContext?.campaign ? onOpenCampaign ? /* @__PURE__ */ jsx6(
                  "button",
                  {
                    type: "button",
                    className: "voice-link-chip",
                    onClick: () => onOpenCampaign(cardContext.campaign.id),
                    children: cardContext.campaign.name
                  }
                ) : /* @__PURE__ */ jsx6("b", { title: cardContext.campaign.id, children: cardContext.campaign.name }) : /* @__PURE__ */ jsx6("b", { children: "\u2014" })
              ] })
            ] }),
            cardContext?.purposeNote && /* @__PURE__ */ jsxs6("div", { className: "voice-purpose-note", children: [
              /* @__PURE__ */ jsx6("small", { children: "Ama\xE7 notu / script" }),
              /* @__PURE__ */ jsx6("pre", { children: cardContext.purposeNote })
            ] })
          ] }),
          opsCost && /* @__PURE__ */ jsxs6("div", { className: "voice-ops-cost", role: "region", "aria-label": "Ops maliyet", children: [
            /* @__PURE__ */ jsx6("small", { children: "OPS MAL\u0130YET \xB7 SADECE PLATFORM ADMIN" }),
            /* @__PURE__ */ jsxs6("div", { className: "voice-ops-cost-head", children: [
              /* @__PURE__ */ jsx6("strong", { children: new Intl.NumberFormat("tr-TR", {
                style: "currency",
                currency: "TRY",
                minimumFractionDigits: 2
              }).format(opsCost.estimatedCost.tryMinor / 100) }),
              /* @__PURE__ */ jsxs6("span", { children: [
                "\u2248",
                " ",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 2
                }).format(opsCost.estimatedCost.usdMinor / 100),
                " \xB7 ",
                "kur 1 USD = ",
                opsCost.fx.usdTry,
                " TRY"
              ] })
            ] }),
            /* @__PURE__ */ jsxs6("div", { className: "voice-ops-cost-stack", children: [
              /* @__PURE__ */ jsxs6("span", { children: [
                "LLM ",
                /* @__PURE__ */ jsx6("b", { children: opsCost.configured.llmModel ?? "\u2014" })
              ] }),
              /* @__PURE__ */ jsxs6("span", { children: [
                "STT ",
                /* @__PURE__ */ jsx6("b", { children: opsCost.configured.sttProvider ?? "\u2014" })
              ] }),
              /* @__PURE__ */ jsxs6("span", { children: [
                "TTS",
                " ",
                /* @__PURE__ */ jsxs6("b", { children: [
                  opsCost.configured.ttsProvider ?? "\u2014",
                  opsCost.configured.ttsVoiceId ? ` \xB7 ${opsCost.configured.ttsVoiceId.slice(0, 12)}` : ""
                ] })
              ] })
            ] }),
            opsCost.meters.length === 0 ? /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "Bu arama i\xE7in meter sat\u0131r\u0131 yok (complete \xF6ncesi veya ledger yaz\u0131lmad\u0131)." }) : /* @__PURE__ */ jsx6("ul", { className: "voice-ops-cost-meters", children: opsCost.meters.map((row) => /* @__PURE__ */ jsxs6("li", { children: [
              /* @__PURE__ */ jsx6("span", { children: row.meter.replaceAll("_", " ") }),
              /* @__PURE__ */ jsx6("em", { children: row.quantity }),
              /* @__PURE__ */ jsx6("b", { children: new Intl.NumberFormat("tr-TR", {
                style: "currency",
                currency: "TRY",
                minimumFractionDigits: 2
              }).format(row.estimatedCost.tryMinor / 100) })
            ] }, row.meter)) }),
            /* @__PURE__ */ jsx6("p", { className: "voice-ops-cost-note", children: opsCost.note })
          ] }),
          /* @__PURE__ */ jsxs6("div", { className: "voice-intel-stack", children: [
            /* @__PURE__ */ jsxs6("div", { className: "voice-summary", children: [
              /* @__PURE__ */ jsx6("small", { children: "ARAMA SONRASI \xD6ZET" }),
              !selected ? /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "Arama se\xE7in." }) : selected.summary ? /* @__PURE__ */ jsx6("p", { children: selected.summary }) : ["completed", "failed"].includes(selected.status) ? /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "\xD6zet hen\xFCz yok (transkript k\u0131sa veya \xFCretilmedi)." }) : /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "Arama bitince \xF6zet burada g\xF6r\xFCn\xFCr." })
            ] }),
            /* @__PURE__ */ jsxs6("div", { className: "voice-analysis", children: [
              /* @__PURE__ */ jsx6("small", { children: "ARAMA SONRASI ANAL\u0130Z" }),
              cardAnalysis ? /* @__PURE__ */ jsxs6(Fragment4, { children: [
                /* @__PURE__ */ jsxs6("div", { className: "voice-analysis-chips", children: [
                  /* @__PURE__ */ jsx6("span", { className: `chip outcome-${cardAnalysis.outcome}`, children: outcomeLabel(cardAnalysis.outcome) }),
                  /* @__PURE__ */ jsx6("span", { className: `chip sentiment-${cardAnalysis.sentiment}`, children: sentimentLabel(cardAnalysis.sentiment) }),
                  /* @__PURE__ */ jsx6("span", { className: "chip", children: cardAnalysis.intent })
                ] }),
                /* @__PURE__ */ jsx6("p", { children: cardAnalysis.summary }),
                cardAnalysis.nextStep && /* @__PURE__ */ jsxs6("p", { children: [
                  /* @__PURE__ */ jsx6("strong", { children: "Sonraki ad\u0131m:" }),
                  " ",
                  cardAnalysis.nextStep
                ] }),
                cardAnalysis.topics.length > 0 && /* @__PURE__ */ jsxs6("small", { children: [
                  "Konular: ",
                  cardAnalysis.topics.join(", ")
                ] }),
                /* @__PURE__ */ jsxs6("small", { className: "voice-analysis-meta", children: [
                  "Analiz ",
                  formatDateTime(cardAnalysis.analyzedAt)
                ] })
              ] }) : analysisJob?.status === "queued" || analysisJob?.status === "running" ? /* @__PURE__ */ jsxs6("p", { className: "voice-tool-empty", children: [
                "Analiz ",
                analysisJob.status === "queued" ? "kuyrukta" : "\xE7al\u0131\u015F\u0131yor",
                "\u2026"
              ] }) : analysisJob?.status === "failed" ? /* @__PURE__ */ jsxs6("p", { className: "voice-tool-empty", children: [
                "Analiz ba\u015Far\u0131s\u0131z",
                analysisJob.errorCode ? `: ${analysisJob.errorCode}` : "",
                "."
              ] }) : selected && ["completed", "failed"].includes(selected.status) ? /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "Analiz yok (yeterli transkript yok veya hen\xFCz \xFCretilmedi)." }) : /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "Arama tamamlan\u0131nca sonu\xE7 ve duygu analizi burada g\xF6r\xFCn\xFCr." })
            ] })
          ] }),
          /* @__PURE__ */ jsxs6("div", { className: "voice-follow-ups", children: [
            /* @__PURE__ */ jsx6("small", { children: "CRM / TAK\u0130P MADDELER\u0130" }),
            followUps.length === 0 ? /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "Hen\xFCz not, lead, case, callback veya aktar\u0131m yok." }) : followUps.map((item) => /* @__PURE__ */ jsxs6("div", { className: `voice-follow-up type-${item.type}`, children: [
              /* @__PURE__ */ jsxs6("strong", { children: [
                item.title,
                " ",
                /* @__PURE__ */ jsx6("em", { children: item.type })
              ] }),
              /* @__PURE__ */ jsx6("p", { children: item.detail }),
              /* @__PURE__ */ jsx6("small", { children: formatDateTime(item.createdAt) })
            ] }, item.toolExecutionId))
          ] }),
          /* @__PURE__ */ jsxs6("div", { className: "voice-tool-timeline", children: [
            /* @__PURE__ */ jsx6("small", { children: "ARA\xC7 / AKS\u0130YON" }),
            tools.length === 0 ? /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "Bu aramada hen\xFCz ara\xE7 \xE7al\u0131\u015Ft\u0131r\u0131lmad\u0131." }) : tools.map((tool) => /* @__PURE__ */ jsxs6("div", { className: `voice-tool-item status-${tool.status}`, children: [
              /* @__PURE__ */ jsxs6("div", { children: [
                /* @__PURE__ */ jsx6("strong", { children: tool.toolName }),
                /* @__PURE__ */ jsx6("em", { children: tool.status })
              ] }),
              /* @__PURE__ */ jsx6("p", { children: tool.userSafeMessage }),
              /* @__PURE__ */ jsx6("small", { children: formatDateTime(tool.createdAt) })
            ] }, tool.id))
          ] })
        ] }),
        cardTab === "lead" && /* @__PURE__ */ jsx6("div", { className: "voice-lead-panel", children: cardLead ? /* @__PURE__ */ jsxs6(Fragment4, { children: [
          /* @__PURE__ */ jsxs6("div", { className: "voice-lead-panel-header", children: [
            /* @__PURE__ */ jsxs6("small", { children: [
              "LEAD KARTI \xB7 ",
              scoreLabel(cardLead.leadScore),
              " \xB7 ",
              stageLabel(cardLead.stage)
            ] }),
            onOpenLead && /* @__PURE__ */ jsx6(
              "button",
              {
                type: "button",
                className: "voice-link-chip",
                onClick: () => onOpenLead(cardLead.id),
                children: "Leadler sayfas\u0131nda a\xE7"
              }
            )
          ] }),
          /* @__PURE__ */ jsx6(LeadCardDetail, { lead: cardLead })
        ] }) : /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: selected ? "Bu aramaya ba\u011Fl\u0131 lead kart\u0131 yok (hen\xFCz olu\u015Fmad\u0131 veya lead.create yok)." : "Arama se\xE7in." }) }),
        cardTab === "recording" && /* @__PURE__ */ jsxs6("div", { className: "voice-recording-panel", children: [
          /* @__PURE__ */ jsx6("small", { children: "SES KAYDI" }),
          !selected ? /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: "Arama se\xE7in." }) : /* @__PURE__ */ jsxs6(Fragment4, { children: [
            /* @__PURE__ */ jsx6("ol", { className: "voice-recording-ladder", "aria-label": "Kay\u0131t durumu", children: ["disabled", "capturing", "available", "failed"].map((step) => /* @__PURE__ */ jsx6(
              "li",
              {
                className: selected.recording.status === step ? "current" : recordingStepReached(selected.recording.status, step) ? "done" : "",
                children: recordingStatusLabel(step)
              },
              step
            )) }),
            /* @__PURE__ */ jsxs6("p", { className: "voice-recording-meta", children: [
              "Durum: ",
              /* @__PURE__ */ jsx6("b", { children: recordingStatusLabel(selected.recording.status) }),
              selected.recording.enabled ? "" : " (kay\u0131t kapal\u0131)",
              " \xB7 ",
              recordingKindLabel(selected.recording.storageKey)
            ] }),
            selected.recording.storageKey && /* @__PURE__ */ jsx6("code", { className: "voice-recording-key", title: selected.recording.storageKey, children: shortKey(selected.recording.storageKey) }),
            recordingUrl ? /* @__PURE__ */ jsxs6("div", { className: "voice-recording-player", children: [
              /* @__PURE__ */ jsx6("audio", { controls: true, src: recordingUrl, preload: "metadata", children: "Taray\u0131c\u0131n\u0131z ses oynatmay\u0131 desteklemiyor." }),
              /* @__PURE__ */ jsxs6("div", { className: "voice-recording-actions", children: [
                /* @__PURE__ */ jsx6("a", { href: recordingUrl, download: `${selected.id}.wav`, children: "\u0130ndir (WAV)" }),
                /* @__PURE__ */ jsx6(
                  "button",
                  {
                    type: "button",
                    className: "voice-link-chip",
                    onClick: () => void loadRecordingAudio(
                      api,
                      selected,
                      setRecordingUrl,
                      setRecordingError
                    ),
                    children: "Yeniden y\xFCkle"
                  }
                )
              ] })
            ] }) : /* @__PURE__ */ jsxs6("div", { className: "voice-recording-empty", children: [
              /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: recordingError ? `Oynat\u0131lam\u0131yor: ${recordingError}` : selected.recording.status === "available" && selected.recording.storageKey?.startsWith("provider://") ? "Softphone / demo kayd\u0131: dinlenebilir ses dosyas\u0131 yok (provider yer tutucu). Ger\xE7ek hat (Verimor/Zadarma) kay\u0131tlar\u0131 burada oynar." : selected.recording.status === "available" ? "Kay\u0131t referans\u0131 var ama dosya hen\xFCz y\xFCklenmedi veya depoda yok." : selected.recording.status === "capturing" && (selected.status === "completed" || selected.status === "failed") ? "Kay\u0131t y\xFCklemesi tamamlanmad\u0131 (tak\u0131l\u0131 kald\u0131). Yeni aramalarda d\xFCzeltilir; bu sat\u0131r dinlenemez." : selected.recording.status === "capturing" ? "Kay\u0131t s\xFCr\xFCyor \u2014 arama bitince y\xFCklenecek." : selected.recording.status === "failed" ? "Kay\u0131t ba\u015Far\u0131s\u0131z veya y\xFCklenemedi." : "Bu aramada dinlenebilir kay\u0131t yok." }),
              isPlayableRecordingKey(selected.recording.storageKey) && /* @__PURE__ */ jsx6(
                "button",
                {
                  type: "button",
                  className: "voice-link-chip",
                  onClick: () => void loadRecordingAudio(
                    api,
                    selected,
                    setRecordingUrl,
                    setRecordingError
                  ),
                  children: "Tekrar dene"
                }
              )
            ] })
          ] })
        ] }),
        cardTab === "transcript" && /* @__PURE__ */ jsxs6("div", { className: "voice-transcript-panel", children: [
          /* @__PURE__ */ jsxs6("small", { children: [
            "TRANSKR\u0130PT",
            transcript?.entries.length ? ` \xB7 ${transcript.entries.length} tur` : ""
          ] }),
          /* @__PURE__ */ jsxs6("div", { className: "voice-transcript", children: [
            !transcript || transcript.entries.length === 0 ? /* @__PURE__ */ jsx6("p", { className: "voice-tool-empty", children: selected ? "Hen\xFCz transkript yok \u2014 arama s\xFCr\xFCyor veya tur kaydedilmedi." : "Arama se\xE7in." }) : transcript.entries.map((entry) => /* @__PURE__ */ jsxs6("div", { className: entry.role, children: [
              /* @__PURE__ */ jsxs6("div", { className: "voice-turn-meta", children: [
                /* @__PURE__ */ jsx6("strong", { children: entry.role === "user" ? "Arayan" : "Asistan" }),
                /* @__PURE__ */ jsx6("time", { children: formatTime(entry.createdAt) })
              ] }),
              /* @__PURE__ */ jsx6("p", { children: entry.content })
            ] }, entry.id)),
            turns.at(-1)?.bargeInAcknowledged && /* @__PURE__ */ jsx6("small", { children: "TTS oynatmadan \xF6nce kesinti alg\u0131land\u0131." })
          ] })
        ] }),
        /* @__PURE__ */ jsxs6(
          "form",
          {
            onSubmit: (event) => void runTurn(
              event,
              selected,
              api,
              setTurns,
              setTranscript,
              setTools,
              setSelected,
              setBusy,
              setError
            ),
            children: [
              /* @__PURE__ */ jsx6("input", { name: "utterance", required: true, placeholder: "Arayan konu\u015Fmas\u0131n\u0131 sim\xFCle et..." }),
              /* @__PURE__ */ jsxs6("label", { className: "voice-consent", children: [
                /* @__PURE__ */ jsx6("input", { name: "bargeIn", type: "checkbox" }),
                " S\xF6z kesme"
              ] }),
              /* @__PURE__ */ jsx6("button", { disabled: busy || selected?.status !== "active", children: "Konu\u015Ftur" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs6("div", { className: "voice-actions", children: [
          /* @__PURE__ */ jsx6(
            "button",
            {
              disabled: busy || selected?.status !== "active",
              onClick: () => void action(
                selected,
                api.handoff,
                "Customer requested a human",
                refreshTranscript,
                setError
              ),
              children: "Devret"
            }
          ),
          /* @__PURE__ */ jsx6(
            "button",
            {
              type: "button",
              className: "voice-hangup-banner-btn",
              disabled: busy || !selected || ["completed", "failed"].includes(selected.status),
              onClick: () => void action(selected, api.complete, void 0, refreshTranscript, setError),
              children: "G\xF6r\xFC\u015Fmeyi kapat"
            }
          )
        ] })
      ] })
    ] })
  ] });
};
var shortKey = (value) => value.length <= 48 ? value : `${value.slice(0, 22)}\u2026${value.slice(-18)}`;
var shortId = (value) => value.length <= 28 ? value : `${value.slice(0, 12)}\u2026${value.slice(-8)}`;
var statusLabel = (status) => {
  switch (status) {
    case "queued":
      return "kuyrukta";
    case "ringing":
      return "\xE7al\u0131yor";
    case "active":
      return "aktif";
    case "waiting_for_human":
      return "insan bekliyor";
    case "completed":
      return "tamamland\u0131";
    case "failed":
      return "ba\u015Far\u0131s\u0131z";
    default:
      return status;
  }
};
var QUALITY_VERDICT_LABEL = {
  clean: "TEM\u0130Z",
  attention: "D\u0130KKAT",
  failing: "BA\u015EARISIZ"
};
var CallQualityPanel = ({
  report
}) => /* @__PURE__ */ jsxs6("div", { className: "voice-context-panel", children: [
  /* @__PURE__ */ jsx6("small", { children: "KONU\u015EMA KAL\u0130TES\u0130" }),
  /* @__PURE__ */ jsxs6("div", { className: "voice-context-grid", children: [
    /* @__PURE__ */ jsxs6("span", { children: [
      "Sonu\xE7 ",
      /* @__PURE__ */ jsx6("b", { children: QUALITY_VERDICT_LABEL[report.verdict] })
    ] }),
    /* @__PURE__ */ jsxs6("span", { children: [
      "Tur ",
      /* @__PURE__ */ jsx6("b", { children: report.turns })
    ] }),
    /* @__PURE__ */ jsxs6("span", { children: [
      "Engellenen uydurma ",
      /* @__PURE__ */ jsx6("b", { children: report.blockedInventedClaims })
    ] }),
    /* @__PURE__ */ jsxs6("span", { children: [
      "Sessiz tur ",
      /* @__PURE__ */ jsx6("b", { children: report.emptyReplies })
    ] }),
    /* @__PURE__ */ jsxs6("span", { children: [
      "Tekrar eden cevap ",
      /* @__PURE__ */ jsx6("b", { children: report.repeatedReplies })
    ] }),
    report.answeredQuestions + report.unansweredQuestions > 0 && /* @__PURE__ */ jsxs6("span", { children: [
      "Cevaplanan soru",
      " ",
      /* @__PURE__ */ jsxs6("b", { children: [
        report.answeredQuestions,
        "/",
        report.answeredQuestions + report.unansweredQuestions
      ] })
    ] }),
    report.recoveredTurns > 0 && /* @__PURE__ */ jsxs6("span", { children: [
      "G\xFCvenli cevaba d\xFC\u015F\xFClen tur ",
      /* @__PURE__ */ jsx6("b", { children: report.recoveredTurns })
    ] })
  ] }),
  report.blockedInventedClaims > 0 && /* @__PURE__ */ jsxs6("p", { className: "voice-recording-meta", children: [
    "Bu g\xF6r\xFC\u015Fmede ",
    /* @__PURE__ */ jsx6("b", { children: report.blockedInventedClaims }),
    " uydurma ifade, arayan duymadan engellendi.",
    report.blockedClaimSamples.length > 0 ? ` \xD6rnek: ${report.blockedClaimSamples.slice(0, 2).join(" \xB7 ")}` : ""
  ] }),
  report.recoveredTurns > 0 && report.blockedInventedClaims === 0 && /* @__PURE__ */ jsxs6("p", { className: "voice-recording-meta", children: [
    report.recoveredTurns,
    " turda g\xFCvenli cevaba d\xFC\u015F\xFCld\xFC \u2014 genelde bilgi taban\u0131nda o konunun cevab\u0131 yok demektir."
  ] })
] });
var recordingStatusLabel = (status) => {
  switch (status) {
    case "disabled":
      return "kapal\u0131";
    case "capturing":
      return "kaydediliyor";
    case "available":
      return "haz\u0131r";
    case "failed":
      return "hata";
    default:
      return status;
  }
};
var recordingStepReached = (current, step) => {
  const order = [
    "disabled",
    "capturing",
    "available",
    "failed"
  ];
  if (current === "failed") return step === "failed" || step === "disabled";
  return order.indexOf(step) < order.indexOf(current);
};
var outcomeLabel = (outcome) => {
  switch (outcome) {
    case "converted":
      return "D\xF6n\xFC\u015F\xFCm";
    case "qualified":
      return "Nitelikli";
    case "follow_up":
      return "Takip";
    case "resolved":
      return "\xC7\xF6z\xFCld\xFC";
    case "abandoned":
      return "Terk";
    case "unknown":
    default:
      return "Bilinmiyor";
  }
};
var sentimentLabel = (sentiment) => {
  switch (sentiment) {
    case "positive":
      return "Pozitif";
    case "neutral":
      return "N\xF6tr";
    case "negative":
      return "Negatif";
    case "mixed":
      return "Karma";
    default:
      return "Bilinmiyor";
  }
};
var purposeLabel = (purpose) => {
  switch (purpose) {
    case "general":
      return "Genel";
    case "support":
      return "Destek";
    case "sales":
      return "Sat\u0131\u015F";
    case "marketing":
      return "Pazarlama";
    case "callback":
      return "Geri arama";
    case "custom":
      return "\xD6zel";
    default:
      return "\u2014";
  }
};
var dialogueStyleLabel = (style) => {
  if (!style) return "\u2014";
  return DIALOGUE_STYLE_CATALOG.find((item) => item.id === style)?.label ?? style;
};
var recordingKindLabel = (storageKey) => {
  if (!storageKey) return "Depo anahtar\u0131 yok";
  if (storageKey.startsWith("s3://")) return "MinIO/S3 (oynat\u0131labilir)";
  if (storageKey.startsWith("file://")) return "Yerel dosya (oynat\u0131labilir)";
  if (storageKey.startsWith("memory://")) return "Bellek (test)";
  if (storageKey.startsWith("provider://")) return "Provider placeholder (oynat\u0131lamaz)";
  if (storageKey.startsWith("audiosocket://")) return "Eski manifest (oynat\u0131lamaz)";
  return "Bilinmeyen depo";
};
var isPlayableRecordingKey = (storageKey) => Boolean(
  storageKey && (storageKey.startsWith("s3://") || storageKey.startsWith("file://") || storageKey.startsWith("memory://"))
);
var loadRecordingAudio = async (api, call, setRecordingUrl, setRecordingError) => {
  setRecordingUrl((current) => {
    if (current) URL.revokeObjectURL(current);
    return void 0;
  });
  setRecordingError(void 0);
  if (!isPlayableRecordingKey(call.recording.storageKey)) return;
  try {
    const blob = await api.recordingBlob(call.id);
    setRecordingUrl(URL.createObjectURL(blob));
  } catch (cause) {
    setRecordingError(message2(cause));
  }
};
var startCall = async (event, api, workspaceId, numbers, setBusy, setError, done) => {
  event.preventDefault();
  setBusy(true);
  setError(void 0);
  const data = new FormData(event.currentTarget);
  try {
    const numberId = field(data, "numberId");
    const selected = numbers.find((item) => item.id === numberId);
    const fromFreeform = field(data, "from");
    const agentId = field(data, "agentId");
    const call = await api.start({
      workspaceId,
      ...agentId ? { agentId } : {},
      direction: field(data, "direction") === "inbound" ? "inbound" : "outbound",
      ...numberId ? { numberId } : {},
      ...selected?.e164 ? { from: selected.e164 } : fromFreeform ? { from: fromFreeform } : {},
      to: field(data, "to"),
      recordingConsent: data.get("consent") === "on"
    });
    await done(call);
  } catch (cause) {
    setError(message2(cause));
  } finally {
    setBusy(false);
  }
};
var runTurn = async (event, call, api, setTurns, setTranscript, setTools, setSelected, setBusy, setError) => {
  event.preventDefault();
  if (!call) return;
  setBusy(true);
  setError(void 0);
  const form = event.currentTarget;
  const data = new FormData(form);
  try {
    const turn = await api.turn(call.id, field(data, "utterance"), data.get("bargeIn") === "on");
    setTurns((current) => [...current, turn]);
    const [nextTranscript, nextTools] = await Promise.all([
      api.transcript(call.id),
      api.tools(call.id)
    ]);
    setTranscript(nextTranscript);
    setTools(nextTools.items);
    setSelected(
      voiceCallViewSchema2.parse({
        ...call,
        status: turn.response.status,
        bargeInCount: call.bargeInCount + (turn.bargeInAcknowledged ? 1 : 0)
      })
    );
    form.reset();
  } catch (cause) {
    setError(message2(cause));
  } finally {
    setBusy(false);
  }
};
var action = async (call, operation, argument, done, setError) => {
  if (!call) return;
  try {
    await done(await operation(call.id, argument));
  } catch (cause) {
    setError(message2(cause));
  }
};
var field = (data, name) => {
  const value = data.get(name);
  return typeof value === "string" ? value : "";
};
var message2 = (cause) => cause instanceof Error ? cause.message : "VOICE_OPERATION_FAILED";
var formatDateTime = (value) => {
  if (!value) return "\u2014";
  return new Intl.DateTimeFormat("tr-TR", {
    dateStyle: "short",
    timeStyle: "medium"
  }).format(new Date(value));
};
var formatTime = (value) => {
  if (!value) return "";
  return new Intl.DateTimeFormat("tr-TR", {
    timeStyle: "medium"
  }).format(new Date(value));
};

// src/contacts.tsx
import {
  useCallback as useCallback7,
  useEffect as useEffect6,
  useMemo as useMemo6,
  useState as useState7
} from "react";
import {
  contactListSchema,
  contactViewSchema,
  DIALOGUE_STYLE_CATALOG as DIALOGUE_STYLE_CATALOG2,
  DEFAULT_DIALOGUE_STYLE,
  resolveDialogueStyle,
  voiceCallViewSchema as voiceCallViewSchema3
} from "@agentos/contracts";

// src/whatsapp-status.tsx
import { useCallback as useCallback6, useMemo as useMemo5, useState as useState6 } from "react";
import {
  connectorInvocationViewSchema
} from "@agentos/contracts";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var WHATSAPP_SEED_CONNECTOR_ID = "ctr_whatsapp_cloud_demo";
var WHATSAPP_SEED_SCRIPT = "scripts/seed-whatsapp-cloud-connector.sql";
var WHATSAPP_SECRET_REF_PATTERN = "env://WHATSAPP_CLOUD_CREDENTIAL_JSON";
var WA_OPS = /* @__PURE__ */ new Set(["messages_send_template", "messages_send_text", "messages_mark_read"]);
var isWhatsAppConnectorView = (connector) => {
  if (connector.operations.some((op) => WA_OPS.has(op.name))) return true;
  try {
    const host = new URL(connector.baseOrigin).hostname.toLowerCase();
    return host === "graph.facebook.com" || host.endsWith(".facebook.com");
  } catch {
    const raw = connector.baseOrigin.toLowerCase();
    return raw.includes("graph.facebook.com") || raw.includes(".facebook.com") || raw === "facebook.com";
  }
};
var filterWhatsAppConnectors = (connectors) => connectors.filter(isWhatsAppConnectorView);
var pickDefaultWhatsAppConnectorId = (connectors, preferredId = WHATSAPP_SEED_CONNECTOR_ID) => {
  const wa = filterWhatsAppConnectors(connectors);
  if (wa.some((c) => c.id === preferredId && c.status === "active")) return preferredId;
  const active = wa.find((c) => c.status === "active");
  if (active) return active.id;
  return wa[0]?.id ?? "";
};
var inferWhatsAppProbeResult = (connectorId, invocation) => {
  const at = (/* @__PURE__ */ new Date()).toISOString();
  if (invocation.status === "succeeded") {
    const dryRun = invocation.output?.dryRun === true;
    const live = invocation.output?.dryRun === false;
    if (dryRun) {
      return {
        at,
        connectorId,
        mode: "dry_run",
        status: "succeeded",
        invocationId: invocation.invocationId,
        summary: "DRY-RUN \u2014 Meta Graph \xE7a\u011Fr\u0131lmad\u0131 (output.dryRun=true)."
      };
    }
    if (live) {
      return {
        at,
        connectorId,
        mode: "live",
        status: "succeeded",
        invocationId: invocation.invocationId,
        summary: "LIVE \u2014 dryRun=false; ger\xE7ek Graph yolu. Yeniden probe etmeyin (\xFCretim riski)."
      };
    }
    return {
      at,
      connectorId,
      mode: "unknown",
      status: "succeeded",
      invocationId: invocation.invocationId,
      summary: "Ba\u015Far\u0131l\u0131; dryRun bayra\u011F\u0131 \xE7\u0131kt\u0131da yok."
    };
  }
  const code = invocation.errorCode ?? "FAILED";
  if (code === "WHATSAPP_AUTOSEND_DISABLED" || code.includes("WHATSAPP_AUTOSEND_DISABLED")) {
    return {
      at,
      connectorId,
      mode: "autosend_off",
      status: "failed",
      invocationId: invocation.invocationId,
      errorCode: code,
      summary: "autoSend kapal\u0131 \u2014 WHATSAPP_AUTOSEND_DISABLED (beklenen g\xFCvenlik kap\u0131s\u0131)."
    };
  }
  return {
    at,
    connectorId,
    mode: "error",
    status: "failed",
    invocationId: invocation.invocationId,
    errorCode: code,
    summary: `Hata: ${code}`
  };
};
var modeBadge = (mode) => {
  switch (mode) {
    case "dry_run":
      return { label: "DRY-RUN", className: "wa-badge dry" };
    case "live":
      return { label: "LIVE", className: "wa-badge live" };
    case "autosend_off":
      return { label: "autoSend OFF", className: "wa-badge off" };
    case "error":
      return { label: "HATA", className: "wa-badge err" };
    default:
      return { label: "\u2014", className: "wa-badge unk" };
  }
};
var WhatsAppConnectorStatusPanel = ({
  connectors,
  invokeApi,
  onNavigateOperations,
  onNavigateIntegrations,
  title = "WhatsApp Cloud durumu"
}) => {
  const waConnectors = useMemo5(() => filterWhatsAppConnectors(connectors), [connectors]);
  const [probes, setProbes] = useState6({});
  const [probingId, setProbingId] = useState6(null);
  const [panelError, setPanelError] = useState6();
  const runProbe = useCallback6(
    async (connector) => {
      if (!invokeApi) {
        setPanelError("Probe i\xE7in connector invoke API yok.");
        return;
      }
      const hasTemplate = connector.operations.some((op) => op.name === "messages_send_template");
      const hasText = connector.operations.some((op) => op.name === "messages_send_text");
      if (!hasTemplate && !hasText) {
        setPanelError("Bu connector\u2019da messages_send_template|text yok.");
        return;
      }
      const prior = probes[connector.id];
      if (prior?.mode === "live") {
        setPanelError("LIVE tespit edildi \u2014 yeniden probe atlan\u0131yor (\xFCretim korumas\u0131).");
        return;
      }
      setProbingId(connector.id);
      setPanelError(void 0);
      try {
        const operation = hasTemplate ? "messages_send_template" : "messages_send_text";
        const body = operation === "messages_send_template" ? {
          toE164: "+905551112233",
          templateName: "hello_world",
          languageCode: "tr"
        } : {
          toE164: "+905551112233",
          text: "CenterOS dry-run probe"
        };
        const raw = await invokeApi.invokeConnector(connector.id, {
          operation,
          idempotencyKey: `wa-probe-${crypto.randomUUID()}`,
          input: body
        });
        const invocation = connectorInvocationViewSchema.parse(raw);
        setProbes((prev) => ({
          ...prev,
          [connector.id]: inferWhatsAppProbeResult(connector.id, invocation)
        }));
      } catch (cause) {
        const message3 = cause instanceof Error ? cause.message : "PROBE_FAILED";
        const synthetic = {
          invocationId: "local",
          connectorId: connector.id,
          operation: "messages_send_template",
          status: "failed",
          output: null,
          errorCode: message3,
          completedAt: (/* @__PURE__ */ new Date()).toISOString()
        };
        setProbes((prev) => ({
          ...prev,
          [connector.id]: inferWhatsAppProbeResult(connector.id, synthetic)
        }));
      } finally {
        setProbingId(null);
      }
    },
    [invokeApi, probes]
  );
  return /* @__PURE__ */ jsxs7("article", { className: "agentos-panel wa-status-panel", children: [
    /* @__PURE__ */ jsx7("div", { className: "agentos-panel-head", children: /* @__PURE__ */ jsxs7("div", { children: [
      /* @__PURE__ */ jsx7("small", { children: "MESSAGING \xB7 WHATSAPP CLOUD" }),
      /* @__PURE__ */ jsx7("h3", { children: title })
    ] }) }),
    /* @__PURE__ */ jsxs7("p", { className: "wa-status-help", children: [
      "Connector adapter yolu (Meta domain domain katman\u0131nda yok). Kimlik bilgisi",
      " ",
      /* @__PURE__ */ jsx7("code", { children: WHATSAPP_SECRET_REF_PATTERN }),
      " deseninde secret ref \u2014 token UI\u2019da \xE7\xF6z\xFClmez / loglanmaz. Probe yaln\u0131zca operat\xF6r tetikler; dry-run tercih edilir."
    ] }),
    waConnectors.length === 0 ? /* @__PURE__ */ jsxs7("div", { className: "wa-empty", children: [
      /* @__PURE__ */ jsxs7("p", { children: [
        "Bu workspace\u2019te WhatsApp Cloud connector yok. Seed demo id:",
        " ",
        /* @__PURE__ */ jsx7("code", { children: WHATSAPP_SEED_CONNECTOR_ID })
      ] }),
      /* @__PURE__ */ jsxs7("p", { children: [
        "Kurulum: ",
        /* @__PURE__ */ jsx7("code", { children: WHATSAPP_SEED_SCRIPT }),
        " \xB7 credential env secret ref (asla agent draft\u2019a yazmay\u0131n)."
      ] }),
      /* @__PURE__ */ jsxs7("div", { className: "wa-empty-actions", children: [
        onNavigateOperations && /* @__PURE__ */ jsx7("button", { type: "button", className: "wa-link-btn", onClick: onNavigateOperations, children: "Operations" }),
        onNavigateIntegrations && /* @__PURE__ */ jsx7("button", { type: "button", className: "wa-link-btn", onClick: onNavigateIntegrations, children: "Entegrasyonlar" })
      ] })
    ] }) : /* @__PURE__ */ jsx7("ul", { className: "wa-connector-list", children: waConnectors.map((connector) => {
      const probe = probes[connector.id];
      const badge = probe ? modeBadge(probe.mode) : modeBadge("unknown");
      const isSeed = connector.id === WHATSAPP_SEED_CONNECTOR_ID;
      const ops = connector.operations.map((op) => op.name).join(", ");
      return /* @__PURE__ */ jsxs7("li", { className: "wa-connector-card", children: [
        /* @__PURE__ */ jsxs7("div", { className: "wa-connector-row", children: [
          /* @__PURE__ */ jsxs7("div", { children: [
            /* @__PURE__ */ jsxs7("strong", { children: [
              connector.name,
              isSeed ? " \xB7 seed" : ""
            ] }),
            /* @__PURE__ */ jsxs7("small", { children: [
              /* @__PURE__ */ jsx7("code", { className: isSeed ? "wa-seed-id" : void 0, children: connector.id }),
              " \xB7 ",
              connector.status,
              " \xB7 ",
              "credentialConfigured:",
              " ",
              connector.credentialConfigured ? "yes" : "no"
            ] }),
            /* @__PURE__ */ jsxs7("small", { children: [
              "Origin: ",
              connector.baseOrigin,
              " \xB7 ",
              "Ops: ",
              ops || "\u2014"
            ] }),
            /* @__PURE__ */ jsxs7("small", { className: "wa-secret-note", children: [
              "Secret ref deseni: ",
              /* @__PURE__ */ jsx7("code", { children: WHATSAPP_SECRET_REF_PATTERN }),
              " (de\u011Fer g\xF6sterilmez)"
            ] })
          ] }),
          /* @__PURE__ */ jsx7("em", { className: badge.className, children: badge.label })
        ] }),
        probe && /* @__PURE__ */ jsxs7("p", { className: "wa-probe-status", children: [
          "Son probe: ",
          probe.summary,
          probe.invocationId && probe.invocationId !== "local" ? ` \xB7 ${probe.invocationId}` : "",
          probe.errorCode ? ` \xB7 ${probe.errorCode}` : "",
          /* @__PURE__ */ jsx7("br", {}),
          /* @__PURE__ */ jsx7("time", { dateTime: probe.at, children: new Date(probe.at).toLocaleString() })
        ] }),
        invokeApi && /* @__PURE__ */ jsx7(
          "button",
          {
            type: "button",
            disabled: probingId === connector.id || probe?.mode === "live",
            onClick: () => void runProbe(connector),
            children: probingId === connector.id ? "Probe\u2026" : probe?.mode === "live" ? "LIVE \u2014 probe kilitli" : "Durum / dry-run probe"
          }
        )
      ] }, connector.id);
    }) }),
    panelError && /* @__PURE__ */ jsx7("p", { className: "wa-panel-error", children: panelError }),
    /* @__PURE__ */ jsx7("style", { children: `
.wa-status-panel .wa-status-help{color:#8d97aa;font-size:13px;line-height:1.45;margin:0 0 12px}
.wa-status-panel .wa-empty{padding:12px;border:1px dashed #30394a;border-radius:10px;color:#c5cde0}
.wa-status-panel .wa-empty code{color:#9ecbff}
.wa-status-panel .wa-empty-actions{display:flex;gap:8px;margin-top:10px;flex-wrap:wrap}
.wa-status-panel .wa-link-btn,.wa-status-panel button{padding:8px 12px;border-radius:9px;border:1px solid #30394a;background:#121824;color:#eef;cursor:pointer}
.wa-status-panel button:disabled{opacity:.55;cursor:not-allowed}
.wa-connector-list{list-style:none;margin:0;padding:0;display:grid;gap:10px}
.wa-connector-card{padding:12px;border:1px solid #252b37;border-radius:10px;background:#0b0f17;display:grid;gap:8px}
.wa-connector-row{display:grid;grid-template-columns:1fr auto;gap:10px;align-items:start}
.wa-connector-row strong{display:block;color:#eef}
.wa-connector-row small{display:block;color:#8d97aa;margin-top:3px;line-height:1.4}
.wa-seed-id{color:#72e0a1;font-weight:600}
.wa-secret-note{font-size:12px!important}
.wa-badge{font-style:normal;font-size:11px;font-weight:700;letter-spacing:.04em;padding:4px 8px;border-radius:999px;border:1px solid #30394a}
.wa-badge.dry{color:#72e0a1;border-color:#2a6b4a;background:#0f241a}
.wa-badge.live{color:#ffb4a2;border-color:#8a3a2a;background:#2a1410}
.wa-badge.off{color:#f0c674;border-color:#6b5a2a;background:#241f0f}
.wa-badge.err{color:#ff8a8a;border-color:#6b2a2a;background:#241010}
.wa-badge.unk{color:#8d97aa}
.wa-probe-status{margin:0;color:#c5cde0;font-size:12px;line-height:1.45}
.wa-probe-status time{color:#8d97aa}
.wa-panel-error{color:#ff8a8a;font-size:13px;margin:8px 0 0}
` })
  ] });
};

// src/contacts.tsx
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var purposes = [
  { id: "general", label: "Genel" },
  { id: "support", label: "Destek" },
  { id: "sales", label: "Sat\u0131\u015F" },
  { id: "marketing", label: "Pazarlama" },
  { id: "callback", label: "Geri arama" },
  { id: "custom", label: "\xD6zel" }
];
var createContactsApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const request = async (path, init) => {
    const response = await fetch(`${base}${path}`, {
      ...init,
      headers: {
        Authorization: `Bearer ${token}`,
        ...init?.body ? { "Content-Type": "application/json" } : {}
      },
      signal: AbortSignal.timeout(2e4)
    });
    if (!response.ok) {
      await throwProblemError(response);
    }
    return response.json();
  };
  return {
    list: async (workspaceId) => contactListSchema.parse(
      await request(`/v1/contacts?workspaceId=${encodeURIComponent(workspaceId)}`)
    ),
    get: async (contactId) => contactViewSchema.parse(
      await request(`/v1/contacts/${encodeURIComponent(contactId)}`)
    ),
    create: async (input) => contactViewSchema.parse(
      await request("/v1/contacts", { method: "POST", body: JSON.stringify(input) })
    ),
    update: async (contactId, input) => contactViewSchema.parse(
      await request(`/v1/contacts/${encodeURIComponent(contactId)}`, {
        method: "PATCH",
        body: JSON.stringify(input)
      })
    ),
    call: async (contactId, input) => voiceCallViewSchema3.parse(
      await request(`/v1/contacts/${encodeURIComponent(contactId)}/call`, {
        method: "POST",
        body: JSON.stringify(input)
      })
    ),
    message: async (contactId, input) => request(`/v1/contacts/${encodeURIComponent(contactId)}/message`, {
      method: "POST",
      body: JSON.stringify(input)
    })
  };
};
var emptyEditForm = () => ({
  displayName: "",
  phoneE164: "",
  company: "",
  defaultPurpose: "general",
  defaultPurposeNote: "",
  defaultDialogueStyle: DEFAULT_DIALOGUE_STYLE,
  preferBusinessBrain: false,
  tags: "",
  notes: ""
});
var editFormFromContact = (contact) => ({
  displayName: contact.displayName,
  phoneE164: contact.phoneE164,
  company: contact.company ?? "",
  defaultPurpose: contact.defaultPurpose,
  defaultPurposeNote: contact.defaultPurposeNote ?? "",
  defaultDialogueStyle: resolveDialogueStyle(contact.defaultDialogueStyle),
  preferBusinessBrain: contact.preferBusinessBrain,
  tags: contact.tags.join(", "),
  notes: contact.notes ?? ""
});
var DirectoryPage = ({
  api,
  agents,
  phoneNumbersApi,
  operationsApi,
  workspaceId,
  locale,
  defaultFrom = "+13235405697",
  defaultWhatsAppConnectorId = WHATSAPP_SEED_CONNECTOR_ID,
  onOpenOperations,
  onOpenIntegrations
}) => {
  const currentLocale = localeFrom(typeof locale === "string" ? locale : locale);
  const t = (text) => translate(currentLocale, text);
  const [contacts, setContacts] = useState7([]);
  const [contactUsage, setContactUsage] = useState7(0);
  const [contactLimit, setContactLimit] = useState7(null);
  const [contactEnforcement, setContactEnforcement] = useState7(null);
  const [agentOptions, setAgentOptions] = useState7([]);
  const [phoneNumbers, setPhoneNumbers] = useState7([]);
  const [waConnectors, setWaConnectors] = useState7([]);
  const [selectedId, setSelectedId] = useState7(null);
  const [selected, setSelected] = useState7(null);
  const [detailLoading, setDetailLoading] = useState7(false);
  const [error, setError] = useState7();
  const [notice, setNotice] = useState7();
  const [busy, setBusy] = useState7(false);
  const [showCreate, setShowCreate] = useState7(false);
  const [editForm, setEditForm] = useState7(emptyEditForm);
  const [editDirty, setEditDirty] = useState7(false);
  const [callForm, setCallForm] = useState7({
    agentId: "",
    purpose: "general",
    purposeNote: "",
    dialogueStyle: DEFAULT_DIALOGUE_STYLE,
    from: defaultFrom,
    numberId: "",
    useBusinessBrain: true,
    recordingConsent: true
  });
  const [messageForm, setMessageForm] = useState7({
    connectorId: defaultWhatsAppConnectorId,
    operation: "messages_send_template",
    templateName: "hello_world",
    text: "",
    purpose: "general"
  });
  const load = useCallback7(async () => {
    const [page, agentPage, numberPage, connectorPage] = await Promise.all([
      api.list(workspaceId),
      agents.list(workspaceId),
      phoneNumbersApi ? phoneNumbersApi.list(workspaceId) : Promise.resolve({ items: [] }),
      operationsApi ? operationsApi.connectors(workspaceId) : Promise.resolve([])
    ]);
    setContacts(page.items);
    setContactUsage(page.usage);
    setContactLimit(page.limit);
    setContactEnforcement(page.enforcement);
    const options = agentPage.items.map(({ id, name }) => ({ id, name }));
    setAgentOptions(options);
    const activeNumbers = numberPage.items.filter((n) => n.status === "active");
    setPhoneNumbers(activeNumbers);
    const wa = filterWhatsAppConnectors(connectorPage);
    setWaConnectors(wa);
    const preferred = pickDefaultWhatsAppConnectorId(wa, defaultWhatsAppConnectorId);
    setMessageForm((prev) => {
      const stillValid = wa.some((c) => c.id === prev.connectorId);
      return {
        ...prev,
        connectorId: stillValid ? prev.connectorId : preferred || prev.connectorId
      };
    });
    setCallForm((prev) => ({
      ...prev,
      agentId: prev.agentId || options[0]?.id || "",
      numberId: prev.numberId || activeNumbers[0]?.id || "",
      from: prev.from || activeNumbers[0]?.e164 || defaultFrom
    }));
    return page.items;
  }, [api, agents, phoneNumbersApi, operationsApi, workspaceId, defaultFrom, defaultWhatsAppConnectorId]);
  useEffect6(() => {
    void load().then((page) => {
      if (!selectedId && page[0]) {
        void selectContact(page[0].id, page[0]);
      }
    }).catch((cause) => setError(cause instanceof Error ? cause.message : "ERR"));
  }, [load]);
  const usageCount = Math.max(contactUsage, contacts.length);
  const atSoftLimit = contactEnforcement === "soft" && contactLimit != null && usageCount >= contactLimit;
  const atHardLimit = contactEnforcement === "hard" && contactLimit != null && usageCount >= contactLimit;
  const contactCountLabel = contactLimit != null ? `${usageCount} / ${contactLimit} ki\u015Fi` : `${usageCount} ki\u015Fi`;
  const applyContactToForms = useCallback7(
    (contact) => {
      setEditForm(editFormFromContact(contact));
      setEditDirty(false);
      setCallForm((prev) => ({
        ...prev,
        purpose: contact.defaultPurpose,
        purposeNote: contact.defaultPurposeNote ?? "",
        dialogueStyle: resolveDialogueStyle(contact.defaultDialogueStyle),
        from: prev.from || phoneNumbers[0]?.e164 || defaultFrom,
        numberId: prev.numberId || phoneNumbers[0]?.id || "",
        useBusinessBrain: contact.preferBusinessBrain || contact.defaultPurpose === "marketing",
        recordingConsent: true,
        agentId: prev.agentId || agentOptions[0]?.id || ""
      }));
      setMessageForm((prev) => ({
        ...prev,
        purpose: contact.defaultPurpose
      }));
    },
    [agentOptions, defaultFrom, phoneNumbers]
  );
  const patchEdit = useCallback7((key, value) => {
    setEditForm((prev) => ({ ...prev, [key]: value }));
    setEditDirty(true);
  }, []);
  const saveContact = useCallback7(async () => {
    if (!selectedId) return;
    setBusy(true);
    setError(void 0);
    setNotice(void 0);
    try {
      const phoneE164 = normalizePhoneE164(editForm.phoneE164);
      if (!/^\+[1-9]\d{7,14}$/u.test(phoneE164)) {
        throw new Error(
          "VALIDATION_FAILED: Telefon ge\xE7ersiz. \xD6rnek: +905551112233 veya 05551112233"
        );
      }
      if (!editForm.displayName.trim()) {
        throw new Error("VALIDATION_FAILED: Ad / unvan zorunlu.");
      }
      const tags = editForm.tags.split(",").map((item) => item.trim()).filter(Boolean);
      const updated = await api.update(selectedId, {
        displayName: editForm.displayName.trim(),
        phoneE164,
        company: editForm.company.trim() || null,
        defaultPurpose: editForm.defaultPurpose,
        defaultPurposeNote: editForm.defaultPurposeNote.trim() || null,
        defaultDialogueStyle: editForm.defaultDialogueStyle,
        preferBusinessBrain: editForm.preferBusinessBrain,
        tags,
        notes: editForm.notes.trim() || null
      });
      setSelected(updated);
      applyContactToForms(updated);
      setContacts(
        (prev) => prev.map((item) => item.id === updated.id ? updated : item)
      );
      setNotice(`${updated.displayName} kaydedildi.`);
    } catch (cause) {
      setError(friendlyError2(cause instanceof Error ? cause.message : "UPDATE_FAILED"));
    } finally {
      setBusy(false);
    }
  }, [api, applyContactToForms, editForm, selectedId]);
  const selectContact = useCallback7(
    async (contactId, hint) => {
      setShowCreate(false);
      setSelectedId(contactId);
      setError(void 0);
      if (hint) {
        setSelected(hint);
        applyContactToForms(hint);
      }
      setDetailLoading(true);
      try {
        const fresh = await api.get(contactId);
        setSelected(fresh);
        applyContactToForms(fresh);
        setContacts((prev) => {
          const exists = prev.some((item) => item.id === fresh.id);
          if (!exists) return [fresh, ...prev];
          return prev.map((item) => item.id === fresh.id ? fresh : item);
        });
      } catch (cause) {
        setError(
          friendlyError2(cause instanceof Error ? cause.message : "CONTACT_LOAD_FAILED")
        );
      } finally {
        setDetailLoading(false);
      }
    },
    [api, applyContactToForms]
  );
  const selectedFromList = useMemo6(
    () => contacts.find((item) => item.id === selectedId) ?? null,
    [contacts, selectedId]
  );
  const display = selected ?? selectedFromList;
  return /* @__PURE__ */ jsxs8("section", { className: "directory-page studio-page", children: [
    /* @__PURE__ */ jsxs8("header", { className: "studio-toolbar", children: [
      /* @__PURE__ */ jsxs8("div", { children: [
        /* @__PURE__ */ jsx8("span", { children: "REHBER" }),
        /* @__PURE__ */ jsx8("h2", { children: "Ki\u015Filer ve tek arama" })
      ] }),
      /* @__PURE__ */ jsx8("b", { children: contactCountLabel })
    ] }),
    error && /* @__PURE__ */ jsx8("div", { className: "studio-alert error", children: error }),
    notice && /* @__PURE__ */ jsx8("div", { className: "studio-alert success", children: notice }),
    atSoftLimit && /* @__PURE__ */ jsx8("div", { className: "studio-alert", role: "status", children: t("Approaching plan contact limit") }),
    atHardLimit && /* @__PURE__ */ jsx8("div", { className: "studio-alert error", role: "alert", children: t("Contact plan limit reached") }),
    /* @__PURE__ */ jsxs8("div", { className: "studio-grid directory-layout", children: [
      /* @__PURE__ */ jsxs8("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsxs8("header", { children: [
          /* @__PURE__ */ jsxs8("div", { children: [
            /* @__PURE__ */ jsx8("small", { children: "K\u0130\u015E\u0130LER" }),
            /* @__PURE__ */ jsx8("h3", { children: "Rehber listesi" })
          ] }),
          /* @__PURE__ */ jsx8(
            "button",
            {
              type: "button",
              className: "directory-secondary-btn",
              disabled: busy || atHardLimit,
              title: atHardLimit ? t("Contact plan limit reached") : void 0,
              onClick: () => {
                if (atHardLimit) return;
                setShowCreate(true);
                setSelectedId(null);
                setSelected(null);
                setNotice(void 0);
              },
              children: "+ Yeni numara"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs8("div", { className: "call-list directory-list", children: [
          contacts.length === 0 && !showCreate && /* @__PURE__ */ jsxs8("div", { className: "studio-inline-empty", children: [
            /* @__PURE__ */ jsx8("strong", { children: "Hen\xFCz ki\u015Fi yok" }),
            /* @__PURE__ */ jsx8("p", { children: "Tek arama i\xE7in ki\u015Fi ekleyin: ama\xE7 notu + ajan + arayan numara ile hemen arayabilirsiniz." }),
            /* @__PURE__ */ jsx8(
              "button",
              {
                type: "button",
                className: "agentos-btn primary",
                disabled: busy || atHardLimit,
                title: atHardLimit ? t("Contact plan limit reached") : void 0,
                onClick: () => {
                  if (atHardLimit) return;
                  setShowCreate(true);
                  setSelectedId(null);
                  setSelected(null);
                  setNotice(void 0);
                },
                children: "+ Yeni numara"
              }
            )
          ] }),
          contacts.map((contact) => /* @__PURE__ */ jsxs8(
            "button",
            {
              type: "button",
              className: selectedId === contact.id ? "active" : "",
              onClick: () => void selectContact(contact.id, contact),
              children: [
                /* @__PURE__ */ jsxs8("span", { children: [
                  /* @__PURE__ */ jsx8("strong", { children: contact.displayName }),
                  /* @__PURE__ */ jsx8("small", { children: contact.phoneE164 }),
                  /* @__PURE__ */ jsxs8("small", { children: [
                    purposeLabel2(contact.defaultPurpose),
                    contact.preferBusinessBrain ? " \xB7 Business Brain" : "",
                    contact.defaultPurposeNote ? ` \xB7 ${truncate(contact.defaultPurposeNote, 48)}` : ""
                  ] })
                ] }),
                /* @__PURE__ */ jsx8("em", { children: contact.company ?? "\u2014" })
              ]
            },
            contact.id
          ))
        ] }),
        showCreate && !atHardLimit && /* @__PURE__ */ jsxs8(
          "form",
          {
            className: "directory-create-form",
            onSubmit: (event) => void createContact(
              event,
              api,
              workspaceId,
              setBusy,
              setError,
              setNotice,
              async (c) => {
                await load();
                setShowCreate(false);
                await selectContact(c.id, c);
              },
              t,
              atHardLimit
            ),
            children: [
              /* @__PURE__ */ jsx8("small", { className: "directory-section", children: "YEN\u0130 NUMARA" }),
              /* @__PURE__ */ jsxs8("label", { children: [
                "Ad / unvan",
                /* @__PURE__ */ jsx8("input", { name: "displayName", required: true, placeholder: "Ay\u015Fe Y\u0131lmaz" })
              ] }),
              /* @__PURE__ */ jsxs8("label", { children: [
                "Telefon",
                /* @__PURE__ */ jsx8("input", { name: "phoneE164", required: true, placeholder: "+905551112233 veya 0555\u2026" })
              ] }),
              /* @__PURE__ */ jsxs8("label", { children: [
                "\u015Eirket",
                /* @__PURE__ */ jsx8("input", { name: "company", placeholder: "Opsiyonel" })
              ] }),
              /* @__PURE__ */ jsxs8("label", { children: [
                "Varsay\u0131lan ama\xE7",
                /* @__PURE__ */ jsx8("select", { name: "defaultPurpose", defaultValue: "general", children: purposes.map((item) => /* @__PURE__ */ jsx8("option", { value: item.id, children: item.label }, item.id)) })
              ] }),
              /* @__PURE__ */ jsxs8("label", { children: [
                "Varsay\u0131lan arama/mesaj notu",
                /* @__PURE__ */ jsx8(
                  "textarea",
                  {
                    name: "defaultPurposeNote",
                    rows: 3,
                    placeholder: "\xD6rn: Yeni paket tan\u0131t\u0131m\u0131, randevu hat\u0131rlatma\u2026"
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs8("label", { className: "voice-consent", children: [
                /* @__PURE__ */ jsx8("input", { name: "preferBusinessBrain", type: "checkbox", defaultChecked: true }),
                "Pazarlama / sat\u0131\u015Fta Business Brain kullan"
              ] }),
              /* @__PURE__ */ jsxs8("label", { children: [
                "Etiketler (virg\xFClle)",
                /* @__PURE__ */ jsx8("input", { name: "tags", placeholder: "vip, lead, istanbul" })
              ] }),
              /* @__PURE__ */ jsxs8("div", { className: "directory-form-actions", children: [
                /* @__PURE__ */ jsx8("button", { type: "submit", disabled: busy, children: "Kaydet" }),
                /* @__PURE__ */ jsx8(
                  "button",
                  {
                    type: "button",
                    className: "directory-secondary-btn",
                    onClick: () => setShowCreate(false),
                    children: "\u0130ptal"
                  }
                )
              ] })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs8("article", { className: "studio-card directory-detail-card", children: [
        /* @__PURE__ */ jsxs8("header", { children: [
          /* @__PURE__ */ jsxs8("div", { children: [
            /* @__PURE__ */ jsx8("small", { children: "SE\xC7\u0130L\u0130 K\u0130\u015E\u0130" }),
            /* @__PURE__ */ jsx8("h3", { children: display ? display.displayName : "Ki\u015Fi se\xE7in" })
          ] }),
          /* @__PURE__ */ jsx8("b", { children: display?.phoneE164 ?? "\u2014" })
        ] }),
        !display ? /* @__PURE__ */ jsxs8("div", { className: "studio-inline-empty", children: [
          /* @__PURE__ */ jsx8("strong", { children: "Ki\u015Fi se\xE7in" }),
          /* @__PURE__ */ jsx8("p", { children: "Soldan bir kayd\u0131 a\xE7\u0131n veya yeni numara ekleyin. Detay, arama ve mesaj paneli burada a\xE7\u0131l\u0131r." }),
          !showCreate && /* @__PURE__ */ jsx8(
            "button",
            {
              type: "button",
              className: "directory-secondary-btn",
              disabled: busy || atHardLimit,
              onClick: () => {
                if (atHardLimit) return;
                setShowCreate(true);
                setSelectedId(null);
                setSelected(null);
              },
              children: "+ Yeni numara"
            }
          )
        ] }) : /* @__PURE__ */ jsxs8("div", { className: "directory-selected-panel", children: [
          detailLoading && /* @__PURE__ */ jsx8("p", { className: "directory-loading", children: "Ki\u015Fi detay\u0131 yenileniyor\u2026" }),
          /* @__PURE__ */ jsxs8(
            "form",
            {
              className: "directory-edit-form",
              onSubmit: (event) => {
                event.preventDefault();
                void saveContact();
              },
              children: [
                /* @__PURE__ */ jsx8("small", { className: "directory-section", children: "KAYIT D\xDCZENLE" }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Ad / unvan",
                  /* @__PURE__ */ jsx8(
                    "input",
                    {
                      value: editForm.displayName,
                      onChange: (e) => patchEdit("displayName", e.target.value),
                      required: true
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Telefon",
                  /* @__PURE__ */ jsx8(
                    "input",
                    {
                      value: editForm.phoneE164,
                      onChange: (e) => patchEdit("phoneE164", e.target.value),
                      required: true,
                      placeholder: "+905551112233"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "\u015Eirket",
                  /* @__PURE__ */ jsx8(
                    "input",
                    {
                      value: editForm.company,
                      onChange: (e) => patchEdit("company", e.target.value),
                      placeholder: "Opsiyonel"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Varsay\u0131lan ama\xE7",
                  /* @__PURE__ */ jsx8(
                    "select",
                    {
                      value: editForm.defaultPurpose,
                      onChange: (e) => patchEdit("defaultPurpose", e.target.value),
                      children: purposes.map((item) => /* @__PURE__ */ jsx8("option", { value: item.id, children: item.label }, item.id))
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Varsay\u0131lan arama / \xF6zel not (AI script)",
                  /* @__PURE__ */ jsx8(
                    "textarea",
                    {
                      rows: 5,
                      value: editForm.defaultPurposeNote,
                      onChange: (e) => patchEdit("defaultPurposeNote", e.target.value),
                      placeholder: "\xD6rn: Mustafao\u011Flu tar\u0131m finansman\u0131\u2026 ilgilenir misiniz?"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Konu\u015Fma kural\u0131 (varsay\u0131lan)",
                  /* @__PURE__ */ jsx8(
                    "select",
                    {
                      value: editForm.defaultDialogueStyle,
                      onChange: (e) => patchEdit("defaultDialogueStyle", e.target.value),
                      children: DIALOGUE_STYLE_CATALOG2.map((item) => /* @__PURE__ */ jsx8("option", { value: item.id, children: item.label }, item.id))
                    }
                  ),
                  /* @__PURE__ */ jsx8("small", { className: "directory-field-hint", children: DIALOGUE_STYLE_CATALOG2.find(
                    (item) => item.id === editForm.defaultDialogueStyle
                  )?.description })
                ] }),
                /* @__PURE__ */ jsxs8("label", { className: "voice-consent", children: [
                  /* @__PURE__ */ jsx8(
                    "input",
                    {
                      type: "checkbox",
                      checked: editForm.preferBusinessBrain,
                      onChange: (e) => patchEdit("preferBusinessBrain", e.target.checked)
                    }
                  ),
                  "Pazarlama / sat\u0131\u015Fta Business Brain kullan"
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Etiketler (virg\xFClle)",
                  /* @__PURE__ */ jsx8(
                    "input",
                    {
                      value: editForm.tags,
                      onChange: (e) => patchEdit("tags", e.target.value),
                      placeholder: "vip, lead"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Dahili notlar",
                  /* @__PURE__ */ jsx8(
                    "textarea",
                    {
                      rows: 2,
                      value: editForm.notes,
                      onChange: (e) => patchEdit("notes", e.target.value),
                      placeholder: "Sadece ekip i\xE7in (AI okumaz)"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("div", { className: "directory-form-actions", children: [
                  /* @__PURE__ */ jsx8("button", { type: "submit", disabled: busy || !editDirty, children: editDirty ? "De\u011Fi\u015Fiklikleri kaydet" : "Kaydedildi" }),
                  /* @__PURE__ */ jsx8(
                    "button",
                    {
                      type: "button",
                      className: "directory-secondary-btn",
                      disabled: busy || !editDirty || !display,
                      onClick: () => {
                        if (display) applyContactToForms(display);
                      },
                      children: "Vazge\xE7"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ jsxs8(
            "form",
            {
              className: "directory-action-form",
              onSubmit: (event) => void startCall2(
                event,
                api,
                // Prefer unsaved note for this call if user edited but not saved yet.
                {
                  ...display,
                  defaultPurpose: callForm.purpose,
                  defaultPurposeNote: callForm.purposeNote || display.defaultPurposeNote
                },
                callForm,
                setBusy,
                setError,
                setNotice
              ),
              children: [
                /* @__PURE__ */ jsx8("small", { className: "directory-section", children: "ARAMA" }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Ajan",
                  /* @__PURE__ */ jsxs8(
                    "select",
                    {
                      name: "agentId",
                      required: true,
                      value: callForm.agentId,
                      onChange: (e) => setCallForm((prev) => ({ ...prev, agentId: e.target.value })),
                      children: [
                        agentOptions.length === 0 && /* @__PURE__ */ jsx8("option", { value: "", children: "Yay\u0131nlanm\u0131\u015F ajan yok" }),
                        agentOptions.map((agent) => /* @__PURE__ */ jsx8("option", { value: agent.id, children: agent.name }, agent.id))
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Arama amac\u0131",
                  /* @__PURE__ */ jsx8(
                    "select",
                    {
                      name: "purpose",
                      value: callForm.purpose,
                      onChange: (e) => {
                        const purpose = e.target.value;
                        setCallForm((prev) => ({
                          ...prev,
                          purpose,
                          // Platform marketing template blocks freeform notes.
                          purposeNote: purpose === "marketing" ? "" : prev.purposeNote
                        }));
                      },
                      children: purposes.map((item) => /* @__PURE__ */ jsx8("option", { value: item.id, children: item.label }, item.id))
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Arama nedeni / \xF6zel not",
                  /* @__PURE__ */ jsx8(
                    "textarea",
                    {
                      name: "purposeNote",
                      rows: 3,
                      value: callForm.purposeNote,
                      disabled: callForm.purpose === "marketing",
                      onChange: (e) => setCallForm((prev) => ({ ...prev, purposeNote: e.target.value })),
                      placeholder: callForm.purpose === "marketing" ? "Marketing \u015Fablonunda not kapal\u0131 \u2014 sales se\xE7in veya notu bo\u015F b\u0131rak\u0131n" : "Bu aramada ne konu\u015Fulsun? (sales/general/support i\xE7in OK)"
                    }
                  ),
                  callForm.purpose === "marketing" && /* @__PURE__ */ jsxs8("small", { className: "directory-field-hint", children: [
                    "Platform hatt\u0131nda marketing + serbest not engellenir (TRUST_FREEFORM_NOTE_BLOCKED). Script i\xE7in amac\u0131",
                    " ",
                    /* @__PURE__ */ jsx8("strong", { children: "sales" }),
                    " yap\u0131n."
                  ] })
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Konu\u015Fma kural\u0131",
                  /* @__PURE__ */ jsx8(
                    "select",
                    {
                      name: "dialogueStyle",
                      value: callForm.dialogueStyle,
                      onChange: (e) => setCallForm((prev) => ({
                        ...prev,
                        dialogueStyle: e.target.value
                      })),
                      children: DIALOGUE_STYLE_CATALOG2.map((item) => /* @__PURE__ */ jsxs8("option", { value: item.id, children: [
                        item.label,
                        " \u2014 ",
                        item.hint
                      ] }, item.id))
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Arayan numara",
                  phoneNumbers.length > 0 ? /* @__PURE__ */ jsx8(
                    "select",
                    {
                      name: "numberId",
                      required: true,
                      value: callForm.numberId,
                      onChange: (e) => {
                        const id = e.target.value;
                        const match = phoneNumbers.find((n) => n.id === id);
                        setCallForm((prev) => ({
                          ...prev,
                          numberId: id,
                          from: match?.e164 ?? prev.from
                        }));
                      },
                      children: phoneNumbers.map((n) => /* @__PURE__ */ jsxs8("option", { value: n.id, children: [
                        n.label || n.e164,
                        " \xB7 ",
                        n.numberClass,
                        " \xB7 ",
                        n.e164
                      ] }, n.id))
                    }
                  ) : /* @__PURE__ */ jsx8(
                    "input",
                    {
                      name: "from",
                      required: true,
                      value: callForm.from,
                      onChange: (e) => setCallForm((prev) => ({ ...prev, from: e.target.value }))
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { className: "voice-consent", children: [
                  /* @__PURE__ */ jsx8(
                    "input",
                    {
                      name: "useBusinessBrain",
                      type: "checkbox",
                      checked: callForm.useBusinessBrain,
                      onChange: (e) => setCallForm((prev) => ({
                        ...prev,
                        useBusinessBrain: e.target.checked
                      }))
                    }
                  ),
                  "Business Brain / Product Memory kullan"
                ] }),
                /* @__PURE__ */ jsxs8("label", { className: "voice-consent", children: [
                  /* @__PURE__ */ jsx8(
                    "input",
                    {
                      name: "recordingConsent",
                      type: "checkbox",
                      required: true,
                      checked: callForm.recordingConsent,
                      onChange: (e) => setCallForm((prev) => ({
                        ...prev,
                        recordingConsent: e.target.checked
                      }))
                    }
                  ),
                  "Kay\u0131t bilgilendirmesi kabul"
                ] }),
                /* @__PURE__ */ jsx8("button", { disabled: busy || agentOptions.length === 0, children: "Ara (AI ses)" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs8(
            "form",
            {
              className: "directory-action-form",
              onSubmit: (event) => void sendMessage(
                event,
                api,
                display,
                messageForm,
                setBusy,
                setError,
                setNotice
              ),
              children: [
                /* @__PURE__ */ jsx8("small", { className: "directory-section", children: "WHATSAPP / MESAJ" }),
                /* @__PURE__ */ jsxs8("p", { className: "numbers-help", style: { margin: "0 0 8px" }, children: [
                  "G\xF6nderim yaln\u0131zca connector invoke \xFCzerinden (Meta domain hardcode yok).",
                  " ",
                  /* @__PURE__ */ jsx8("code", { children: "autoSend" }),
                  " / ",
                  /* @__PURE__ */ jsx8("code", { children: "dryRun" }),
                  " kap\u0131lar\u0131 executor\u2019da kal\u0131r."
                ] }),
                waConnectors.length === 0 ? /* @__PURE__ */ jsxs8("div", { className: "numbers-empty", style: { marginBottom: 10 }, children: [
                  /* @__PURE__ */ jsxs8("p", { style: { margin: "0 0 6px" }, children: [
                    "WhatsApp connector bulunamad\u0131. Seed demo:",
                    " ",
                    /* @__PURE__ */ jsx8("code", { children: WHATSAPP_SEED_CONNECTOR_ID })
                  ] }),
                  /* @__PURE__ */ jsxs8("p", { style: { margin: "0 0 8px" }, children: [
                    "Kurulum SQL: ",
                    /* @__PURE__ */ jsx8("code", { children: WHATSAPP_SEED_SCRIPT }),
                    " \xB7 credential",
                    " ",
                    /* @__PURE__ */ jsx8("code", { children: "env://WHATSAPP_CLOUD_CREDENTIAL_JSON" }),
                    " (token buraya yaz\u0131lmaz)."
                  ] }),
                  /* @__PURE__ */ jsxs8("div", { style: { display: "flex", gap: 8, flexWrap: "wrap" }, children: [
                    onOpenOperations && /* @__PURE__ */ jsx8("button", { type: "button", className: "alx-btn ghost", onClick: onOpenOperations, children: "Operations" }),
                    onOpenIntegrations && /* @__PURE__ */ jsx8(
                      "button",
                      {
                        type: "button",
                        className: "alx-btn ghost",
                        onClick: onOpenIntegrations,
                        children: "Entegrasyonlar"
                      }
                    )
                  ] }),
                  !operationsApi && /* @__PURE__ */ jsx8("p", { style: { marginTop: 8, fontSize: 12 }, children: "Connector listesi i\xE7in Operations API ba\u011Fl\u0131 de\u011Fil; id\u2019yi elle girebilirsiniz (tercihen seed id)." })
                ] }) : null,
                /* @__PURE__ */ jsxs8("label", { children: [
                  "WhatsApp connector",
                  waConnectors.length > 0 ? /* @__PURE__ */ jsx8(
                    "select",
                    {
                      name: "connectorId",
                      required: true,
                      value: messageForm.connectorId,
                      onChange: (e) => setMessageForm((prev) => ({ ...prev, connectorId: e.target.value })),
                      children: waConnectors.map((c) => /* @__PURE__ */ jsxs8("option", { value: c.id, children: [
                        c.name,
                        c.id === WHATSAPP_SEED_CONNECTOR_ID ? " (seed)" : "",
                        " \xB7 ",
                        c.status,
                        c.credentialConfigured ? "" : " \xB7 credential?"
                      ] }, c.id))
                    }
                  ) : /* @__PURE__ */ jsx8(
                    "input",
                    {
                      name: "connectorId",
                      required: true,
                      value: messageForm.connectorId,
                      onChange: (e) => setMessageForm((prev) => ({ ...prev, connectorId: e.target.value })),
                      placeholder: WHATSAPP_SEED_CONNECTOR_ID
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "\u0130\u015Flem",
                  /* @__PURE__ */ jsxs8(
                    "select",
                    {
                      name: "operation",
                      value: messageForm.operation,
                      onChange: (e) => setMessageForm((prev) => ({ ...prev, operation: e.target.value })),
                      children: [
                        /* @__PURE__ */ jsx8("option", { value: "messages_send_template", children: "Template g\xF6nder" }),
                        /* @__PURE__ */ jsx8("option", { value: "messages_send_text", children: "Serbest metin (session)" })
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Template ad\u0131",
                  /* @__PURE__ */ jsx8(
                    "input",
                    {
                      name: "templateName",
                      value: messageForm.templateName,
                      onChange: (e) => setMessageForm((prev) => ({ ...prev, templateName: e.target.value }))
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Serbest metin",
                  /* @__PURE__ */ jsx8(
                    "textarea",
                    {
                      name: "text",
                      rows: 2,
                      value: messageForm.text,
                      onChange: (e) => setMessageForm((prev) => ({ ...prev, text: e.target.value })),
                      placeholder: "Session mesaj\u0131 (opsiyonel)"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs8("label", { children: [
                  "Mesaj amac\u0131",
                  /* @__PURE__ */ jsx8(
                    "select",
                    {
                      name: "purpose",
                      value: messageForm.purpose,
                      onChange: (e) => setMessageForm((prev) => ({
                        ...prev,
                        purpose: e.target.value
                      })),
                      children: purposes.map((item) => /* @__PURE__ */ jsx8("option", { value: item.id, children: item.label }, item.id))
                    }
                  )
                ] }),
                /* @__PURE__ */ jsx8("button", { disabled: busy || waConnectors.length === 0 && !messageForm.connectorId, children: "Mesaj g\xF6nder" })
              ]
            }
          )
        ] })
      ] })
    ] })
  ] });
};
var purposeLabel2 = (purpose) => purposes.find((item) => item.id === purpose)?.label ?? purpose;
var truncate = (value, max) => value.length <= max ? value : `${value.slice(0, max - 1)}\u2026`;
var field2 = (data, name) => String(data.get(name) ?? "").trim();
var normalizePhoneE164 = (raw) => {
  const trimmed = raw.trim();
  if (!trimmed) return trimmed;
  if (/^\+[1-9]\d{7,14}$/u.test(trimmed)) return trimmed;
  const digits = trimmed.replace(/\D/gu, "");
  if (digits.startsWith("90") && digits.length === 12) return `+${digits}`;
  if (digits.startsWith("0") && digits.length === 11) return `+9${digits}`;
  if (digits.length === 10 && digits.startsWith("5")) return `+90${digits}`;
  if (digits.length >= 8 && digits.length <= 15) return `+${digits}`;
  return trimmed;
};
var friendlyError2 = (raw, t) => {
  if (raw.includes("CONTACT_LIMIT_REACHED") || raw.includes("Contact plan limit reached")) {
    return t ? t("Contact plan limit reached") : "Plan ki\u015Fi limitine ula\u015F\u0131ld\u0131. Yeni ki\u015Fi eklemek i\xE7in plan\u0131 y\xFCkseltin.";
  }
  if (raw.includes("CONTACT_PHONE_EXISTS")) {
    return "Bu telefon numaras\u0131 zaten rehberde kay\u0131tl\u0131.";
  }
  if (raw.includes("CONTACT_NOT_FOUND")) {
    return "Ki\u015Fi bulunamad\u0131.";
  }
  if (raw.includes("VALIDATION_FAILED") && raw.toLowerCase().includes("phone")) {
    return "Telefon E.164 olmal\u0131 (\xF6r. +905551112233). 0535\u2026 de yazabilirsiniz.";
  }
  if (raw.includes("VALIDATION_FAILED")) {
    return `Form hatas\u0131: ${raw.replace(/^VALIDATION_FAILED:?\s*/u, "")}`;
  }
  if (raw.includes("PUBLISHED_AGENT_NOT_FOUND")) {
    return "Yay\u0131nlanm\u0131\u015F ajan se\xE7ilmedi / bulunamad\u0131.";
  }
  if (raw.includes("HARD_QUOTA_EXCEEDED")) {
    return "Arama kotas\u0131 doldu.";
  }
  if (raw.includes("TRUST_")) {
    const stripped = raw.replace(/^TRUST_[A-Z0-9_]+:\s*/u, "").trim();
    if (stripped && stripped !== raw) return stripped;
    if (!/^TRUST_[A-Z0-9_]+$/u.test(raw.trim())) return raw;
  }
  if (raw.includes("INTERNAL_ERROR")) {
    return "Sunucu hatas\u0131. Telefon zaten kay\u0131tl\u0131 olabilir veya alanlar eksik.";
  }
  return raw;
};
var createContact = async (event, api, workspaceId, setBusy, setError, setNotice, done, t, atHardLimit = false) => {
  event.preventDefault();
  if (atHardLimit) {
    setError(t ? t("Contact plan limit reached") : "Plan ki\u015Fi limitine ula\u015F\u0131ld\u0131. Yeni ki\u015Fi eklemek i\xE7in plan\u0131 y\xFCkseltin.");
    return;
  }
  setBusy(true);
  setError(void 0);
  setNotice(void 0);
  const form = event.currentTarget;
  const data = new FormData(form);
  try {
    const tags = field2(data, "tags").split(",").map((item) => item.trim()).filter(Boolean);
    const phoneE164 = normalizePhoneE164(field2(data, "phoneE164"));
    if (!/^\+[1-9]\d{7,14}$/u.test(phoneE164)) {
      throw new Error(
        "VALIDATION_FAILED: Telefon ge\xE7ersiz. \xD6rnek: +905551112233 veya 05551112233"
      );
    }
    const contact = await api.create({
      workspaceId,
      displayName: field2(data, "displayName"),
      phoneE164,
      company: field2(data, "company") || null,
      defaultPurpose: field2(data, "defaultPurpose") || "general",
      defaultPurposeNote: field2(data, "defaultPurposeNote") || null,
      preferBusinessBrain: data.get("preferBusinessBrain") === "on",
      tags
    });
    if (form.isConnected) {
      form.reset();
    }
    setNotice(`${contact.displayName} rehbere eklendi (${contact.phoneE164}).`);
    await done(contact);
  } catch (cause) {
    setError(friendlyError2(cause instanceof Error ? cause.message : "CREATE_FAILED", t));
  } finally {
    setBusy(false);
  }
};
var startCall2 = async (event, api, contact, form, setBusy, setError, setNotice) => {
  event.preventDefault();
  setBusy(true);
  setError(void 0);
  setNotice(void 0);
  try {
    const purpose = form.purpose || contact.defaultPurpose;
    const rawNote = form.purposeNote?.trim() || null;
    const call = await api.call(contact.id, {
      agentId: form.agentId,
      ...form.numberId ? { numberId: form.numberId } : {},
      ...form.from ? { from: form.from } : {},
      purpose,
      // marketing freeform note blocked on platform_external
      purposeNote: purpose === "marketing" ? null : rawNote,
      dialogueStyle: form.dialogueStyle,
      useBusinessBrain: form.useBusinessBrain,
      recordingConsent: form.recordingConsent
    });
    setNotice(`Arama ba\u015Flat\u0131ld\u0131: ${call.id} \u2192 ${contact.phoneE164} (${call.status})`);
  } catch (cause) {
    setError(friendlyError2(cause instanceof Error ? cause.message : "CALL_FAILED"));
  } finally {
    setBusy(false);
  }
};
var sendMessage = async (event, api, contact, form, setBusy, setError, setNotice) => {
  event.preventDefault();
  setBusy(true);
  setError(void 0);
  setNotice(void 0);
  try {
    const result = await api.message(contact.id, {
      connectorId: form.connectorId,
      operation: form.operation || "messages_send_template",
      templateName: form.templateName || "hello_world",
      text: form.text || void 0,
      purpose: form.purpose || contact.defaultPurpose,
      purposeNote: contact.defaultPurposeNote,
      languageCode: "tr"
    });
    if (result.status === "failed") {
      throw new Error(result.errorCode ?? "MESSAGE_FAILED");
    }
    setNotice(`Mesaj iste\u011Fi: ${result.invocationId ?? "ok"} (${result.status ?? "succeeded"})`);
  } catch (cause) {
    setError(friendlyError2(cause instanceof Error ? cause.message : "MESSAGE_FAILED"));
  } finally {
    setBusy(false);
  }
};

// src/numbers.tsx
import {
  useCallback as useCallback8,
  useEffect as useEffect7,
  useState as useState8
} from "react";
import {
  importPhoneNumberPoolResponseSchema,
  modeBRateCardSchema,
  phoneNumberListSchema,
  phoneNumberViewSchema,
  smsMessageListSchema,
  smsMessageViewSchema
} from "@agentos/contracts";
import { Fragment as Fragment5, jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var createPhoneNumbersApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const request = async (path, init) => {
    const response = await fetch(`${base}${path}`, {
      ...init,
      headers: {
        Authorization: `Bearer ${token}`,
        ...init?.body ? { "Content-Type": "application/json" } : {}
      },
      signal: AbortSignal.timeout(2e4)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      const code = body.code ?? body.message ?? `HTTP_${response.status}`;
      const detail = body.detail ?? body.title;
      throw new Error(detail ? `${code}: ${detail}` : code);
    }
    return response.json();
  };
  return {
    list: async (workspaceId) => phoneNumberListSchema.parse(
      await request(
        `/v1/phone-numbers?workspaceId=${encodeURIComponent(workspaceId)}&activeOnly=false`
      )
    ),
    createByo: async (input) => phoneNumberViewSchema.parse(
      await request("/v1/phone-numbers", { method: "POST", body: JSON.stringify(input) })
    ),
    importPool: async (input) => importPhoneNumberPoolResponseSchema.parse(
      await request("/v1/phone-numbers/import-pool", {
        method: "POST",
        body: JSON.stringify(input)
      })
    ),
    archive: async (numberId) => phoneNumberViewSchema.parse(
      await request(`/v1/phone-numbers/${encodeURIComponent(numberId)}`, {
        method: "PATCH",
        body: JSON.stringify({ status: "archived" })
      })
    ),
    update: async (numberId, patch) => phoneNumberViewSchema.parse(
      await request(`/v1/phone-numbers/${encodeURIComponent(numberId)}`, {
        method: "PATCH",
        body: JSON.stringify(patch)
      })
    ),
    rateCard: async (workspaceId) => modeBRateCardSchema.parse(
      await request(
        `/v1/phone-numbers/mode-b/rate-card?workspaceId=${encodeURIComponent(workspaceId)}`
      )
    ),
    listSms: async (workspaceId) => smsMessageListSchema.parse(
      await request(`/v1/sms/messages?workspaceId=${encodeURIComponent(workspaceId)}`)
    ).items,
    sendSms: async (input) => smsMessageViewSchema.parse(
      await request("/v1/sms/send", { method: "POST", body: JSON.stringify(input) })
    )
  };
};
var classLabel = (value) => {
  if (value === "platform_external") return "Platform \xB7 d\u0131\u015F kullan\u0131m";
  if (value === "customer_byo") return "Benim numaram \xB7 BYO";
  return "Panaryus \xB7 dahili";
};
var trustLabel = (value) => {
  if (value === "strict") return "Strict trust (Mode B)";
  if (value === "light") return "Light trust (BYO)";
  return "Dahili CRM";
};
var numberInventoryTier = (item) => {
  if (item.numberClass === "customer_byo") return "byo";
  if (item.numberClass === "panaryus_internal") return "internal";
  const id = item.id.toLowerCase();
  const label = (item.label ?? "").toLowerCase();
  const notes = (item.notes ?? "").toLowerCase();
  if (id.startsWith("phn_demo_") || label.includes("demo") || notes.includes("demo") || notes.includes("sandbox") || notes.includes("test pool")) {
    return "demo";
  }
  if (notes.includes("imported:verimor") || notes.includes("imported:zadarma") || label.includes("live") || label.includes("oim") || label.includes("o\u0131m")) {
    return "production";
  }
  if (item.numberClass === "platform_external" && item.status === "active") {
    return "production";
  }
  return "demo";
};
var tierBadge = (tier) => {
  if (tier === "production") {
    return { className: "numbers-tier numbers-tier-production", text: "\xDCretim DID" };
  }
  if (tier === "byo") {
    return { className: "numbers-tier numbers-tier-byo", text: "M\xFC\u015Fteri BYO" };
  }
  if (tier === "internal") {
    return { className: "numbers-tier numbers-tier-internal", text: "Dahili" };
  }
  return { className: "numbers-tier numbers-tier-demo", text: "Demo / test pool" };
};
var NumbersPage = ({
  api,
  workspaceId,
  locale,
  agentOptions = [],
  onLoadAgents
}) => {
  const currentLocale = localeFrom(typeof locale === "string" ? locale : locale);
  const t = (text) => translate(currentLocale, text);
  const [items, setItems] = useState8([]);
  const [phoneUsage, setPhoneUsage] = useState8(0);
  const [phoneLimit, setPhoneLimit] = useState8(null);
  const [phoneEnforcement, setPhoneEnforcement] = useState8(null);
  const [smsItems, setSmsItems] = useState8([]);
  const [rateCard, setRateCard] = useState8(null);
  const [agents, setAgents] = useState8(agentOptions);
  const [busy, setBusy] = useState8(false);
  const [error, setError] = useState8();
  const [notice, setNotice] = useState8();
  const [showByo, setShowByo] = useState8(false);
  const [showImport, setShowImport] = useState8(false);
  const [tab, setTab] = useState8("inventory");
  const load = useCallback8(async () => {
    setError(void 0);
    try {
      const [page, messages, card, agentList] = await Promise.all([
        api.list(workspaceId),
        api.listSms(workspaceId).catch(() => []),
        api.rateCard(workspaceId).catch(() => null),
        onLoadAgents ? onLoadAgents().catch(() => agentOptions) : Promise.resolve(agentOptions)
      ]);
      setItems(page.items);
      setPhoneUsage(page.usage);
      setPhoneLimit(page.limit);
      setPhoneEnforcement(page.enforcement);
      setSmsItems(messages);
      setRateCard(card);
      setAgents(agentList);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "LIST_FAILED");
    }
  }, [api, workspaceId, onLoadAgents, agentOptions]);
  useEffect7(() => {
    void load();
  }, [load]);
  const active = items.filter((item) => item.status === "active");
  const inactive = items.filter((item) => item.status !== "active");
  const publishedAgents = agents.filter(
    (agent) => agent.status === "active" && agent.publishedVersion != null
  );
  const byProvider = active.reduce((acc, item) => {
    acc[item.provider] = (acc[item.provider] ?? 0) + 1;
    return acc;
  }, {});
  const usageCount = Math.max(phoneUsage, active.length);
  const atSoftLimit = phoneEnforcement === "soft" && phoneLimit != null && usageCount >= phoneLimit;
  const atHardLimit = phoneEnforcement === "hard" && phoneLimit != null && usageCount >= phoneLimit;
  const phoneCountLabel = phoneLimit != null ? `${usageCount} / ${phoneLimit} numara` : `${usageCount} numara`;
  const production = active.filter((n) => numberInventoryTier(n) === "production");
  const demo = active.filter((n) => numberInventoryTier(n) === "demo");
  const byoOrInternal = active.filter((n) => {
    const tier = numberInventoryTier(n);
    return tier === "byo" || tier === "internal";
  });
  const unboundProduction = production.filter((n) => !n.defaultInboundAgentId);
  const onCreateByo = async (event) => {
    event.preventDefault();
    if (atHardLimit) {
      setError(t("Phone number plan limit reached"));
      return;
    }
    setBusy(true);
    setError(void 0);
    setNotice(void 0);
    const data = new FormData(event.currentTarget);
    try {
      await api.createByo({
        workspaceId,
        e164: String(data.get("e164") ?? "").trim(),
        label: String(data.get("label") ?? "").trim() || null,
        provider: String(data.get("provider") ?? "byo_sip"),
        geoScope: String(data.get("geoScope") ?? "unknown"),
        notes: String(data.get("notes") ?? "").trim() || null
      });
      setShowByo(false);
      setNotice("Kendi numaran\u0131z eklendi.");
      event.currentTarget.reset();
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "CREATE_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const onImportPool = async (event) => {
    event.preventDefault();
    if (atHardLimit) {
      setError(t("Phone number plan limit reached"));
      return;
    }
    setBusy(true);
    setError(void 0);
    setNotice(void 0);
    const data = new FormData(event.currentTarget);
    const raw = String(data.get("numbers") ?? "");
    const lines = raw.split(/[\n,;]+/u).map((line) => line.trim()).filter(Boolean);
    const numbers = lines.map((line) => {
      const [e164, label] = line.split(/\s*\|\s*/u);
      return {
        e164: (e164 ?? "").trim(),
        ...label ? { label: label.trim() } : {}
      };
    });
    try {
      const result = await api.importPool({
        workspaceId,
        provider: String(data.get("provider") ?? "verimor"),
        numberClass: "platform_external",
        geoScope: String(data.get("geoScope") ?? "tr"),
        numbers
      });
      setShowImport(false);
      setNotice(
        `Havuz aktar\u0131m\u0131: ${result.created.length} eklendi` + (result.skipped.length ? `, ${result.skipped.length} atland\u0131` : "")
      );
      event.currentTarget.reset();
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "IMPORT_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const onSendSms = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(void 0);
    setNotice(void 0);
    const data = new FormData(event.currentTarget);
    try {
      const sent = await api.sendSms({
        workspaceId,
        toE164: String(data.get("toE164") ?? "").trim(),
        body: String(data.get("body") ?? "").trim(),
        header: String(data.get("header") ?? "").trim() || void 0,
        simulate: true
      });
      setNotice(`SMS ${sent.status}: ${sent.toMasked} \xB7 ${sent.provider}`);
      event.currentTarget.reset();
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "SMS_SEND_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const bindAgent = async (numberId, agentId) => {
    setBusy(true);
    setError(void 0);
    setNotice(void 0);
    try {
      await api.update(numberId, {
        defaultInboundAgentId: agentId ? agentId : null
      });
      setNotice(
        agentId ? `DID ba\u011Fland\u0131: ${publishedAgents.find((a) => a.id === agentId)?.name ?? agentId}` : "Gelen ajan ba\u011F\u0131n\u0131 kald\u0131rd\u0131n\u0131z."
      );
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "BIND_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const renderInventoryRow = (item, options) => {
    const tier = numberInventoryTier(item);
    const badge = tierBadge(tier);
    const focusBind = options?.focusBind === true;
    return /* @__PURE__ */ jsxs9(
      "div",
      {
        className: `numbers-row numbers-row-inbound${focusBind && !item.defaultInboundAgentId ? " numbers-row-warn" : ""}`,
        children: [
          /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsxs9("strong", { children: [
              item.label || item.e164,
              " ",
              /* @__PURE__ */ jsx9("span", { className: badge.className, children: badge.text })
            ] }),
            /* @__PURE__ */ jsx9("small", { children: item.e164 }),
            /* @__PURE__ */ jsxs9("small", { children: [
              classLabel(item.numberClass),
              " \xB7 ",
              trustLabel(item.trustBand),
              " \xB7",
              " ",
              /* @__PURE__ */ jsx9("span", { className: `provider-chip provider-${item.provider}`, children: item.provider }),
              " \xB7",
              " ",
              item.geoScope
            ] }),
            tier === "demo" && /* @__PURE__ */ jsx9("small", { className: "numbers-tier-hint", children: "Demo/test envanteri \u2014 canl\u0131 m\xFC\u015Fteri trafi\u011Fi i\xE7in \xDCretim DID kullan\u0131n." }),
            tier === "production" && !item.defaultInboundAgentId && /* @__PURE__ */ jsx9("small", { className: "numbers-tier-hint numbers-tier-hint-warn", children: "\xDCretim DID: gelen arama i\xE7in yay\u0131nl\u0131 bir ajan ba\u011Flay\u0131n." }),
            (focusBind || tier === "production" || item.defaultInboundAgentId) && /* @__PURE__ */ jsxs9("label", { className: "numbers-inbound-bind", children: [
              /* @__PURE__ */ jsx9("span", { children: "Gelen arama ajan\u0131" }),
              /* @__PURE__ */ jsxs9(
                "select",
                {
                  disabled: busy || publishedAgents.length === 0,
                  value: item.defaultInboundAgentId ?? "",
                  onChange: (event) => void bindAgent(item.id, event.target.value),
                  children: [
                    /* @__PURE__ */ jsx9("option", { value: "", children: "\u2014 Ba\u011Fl\u0131 de\u011Fil \u2014" }),
                    publishedAgents.map((agent) => /* @__PURE__ */ jsxs9("option", { value: agent.id, children: [
                      agent.name,
                      agent.publishedVersion ? ` \xB7 canl\u0131 v${agent.publishedVersion}` : ""
                    ] }, agent.id))
                  ]
                }
              )
            ] }),
            publishedAgents.length === 0 && (focusBind || tier === "production") && /* @__PURE__ */ jsx9("small", { className: "numbers-empty", children: "\xD6nce AI Ajanlar\u0131\u2019nda bir ajan yay\u0131nlay\u0131n, sonra buradan DID ba\u011Flay\u0131n." })
          ] }),
          /* @__PURE__ */ jsxs9("div", { className: "numbers-row-actions", children: [
            /* @__PURE__ */ jsx9("em", { className: `status-${item.status}`, children: item.status }),
            item.defaultInboundAgentId ? /* @__PURE__ */ jsx9("em", { className: "status-active", children: "Gelen haz\u0131r" }) : tier === "production" ? /* @__PURE__ */ jsx9("em", { className: "status-warn", children: "Ba\u011F yok" }) : null,
            item.numberClass === "customer_byo" && /* @__PURE__ */ jsx9(
              "button",
              {
                type: "button",
                className: "directory-secondary-btn",
                disabled: busy,
                onClick: () => void (async () => {
                  setBusy(true);
                  setError(void 0);
                  try {
                    await api.archive(item.id);
                    setNotice("Kendi numaran\u0131z ar\u015Fivlendi.");
                    await load();
                  } catch (cause) {
                    setError(cause instanceof Error ? cause.message : "ARCHIVE_FAILED");
                  } finally {
                    setBusy(false);
                  }
                })(),
                children: "Ar\u015Fivle"
              }
            )
          ] })
        ]
      },
      item.id
    );
  };
  return /* @__PURE__ */ jsxs9("section", { className: "voice-studio numbers-studio", children: [
    /* @__PURE__ */ jsxs9("header", { className: "voice-toolbar", children: [
      /* @__PURE__ */ jsxs9("div", { children: [
        /* @__PURE__ */ jsx9("span", { children: "NUMARALAR" }),
        /* @__PURE__ */ jsx9("h2", { children: "Arayan kimlik ve gelen hatlar" })
      ] }),
      /* @__PURE__ */ jsx9("b", { children: phoneCountLabel })
    ] }),
    error && /* @__PURE__ */ jsx9("div", { className: "studio-alert error", children: error }),
    notice && /* @__PURE__ */ jsx9("div", { className: "studio-alert", children: notice }),
    atSoftLimit && /* @__PURE__ */ jsx9("div", { className: "studio-alert", role: "status", children: t("Approaching plan phone number limit") }),
    atHardLimit && /* @__PURE__ */ jsx9("div", { className: "studio-alert error", role: "alert", children: t("Phone number plan limit reached") }),
    unboundProduction.length > 0 && /* @__PURE__ */ jsxs9("div", { className: "numbers-unbound-banner", role: "alert", children: [
      /* @__PURE__ */ jsxs9("div", { children: [
        /* @__PURE__ */ jsxs9("strong", { children: [
          unboundProduction.length,
          " \xFCretim DID \u2014 gelen ajan ba\u011Fl\u0131 de\u011Fil"
        ] }),
        /* @__PURE__ */ jsx9("p", { children: "Gelen aramalar cevaplanmaz. Yay\u0131nl\u0131 bir ajan se\xE7ip DID\u2019ye ba\u011Flay\u0131n." })
      ] }),
      /* @__PURE__ */ jsx9(
        "button",
        {
          type: "button",
          className: "agentos-btn primary",
          onClick: () => setTab("inbound"),
          children: "Gelen ba\u011Fa git"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs9("div", { className: "numbers-tabs", role: "tablist", "aria-label": "Numaralar sekmeleri", children: [
      /* @__PURE__ */ jsx9(
        "button",
        {
          type: "button",
          role: "tab",
          "aria-selected": tab === "inventory",
          className: tab === "inventory" ? "active" : "",
          onClick: () => setTab("inventory"),
          children: "Numaralar\u0131m"
        }
      ),
      /* @__PURE__ */ jsxs9(
        "button",
        {
          type: "button",
          role: "tab",
          "aria-selected": tab === "inbound",
          className: tab === "inbound" ? "active" : "",
          onClick: () => setTab("inbound"),
          children: [
            "Gelen ba\u011F",
            unboundProduction.length > 0 ? ` (${unboundProduction.length})` : ""
          ]
        }
      ),
      /* @__PURE__ */ jsx9(
        "button",
        {
          type: "button",
          role: "tab",
          "aria-selected": tab === "rates",
          className: tab === "rates" ? "active" : "",
          onClick: () => setTab("rates"),
          children: "Tarife ve SMS"
        }
      )
    ] }),
    tab === "inventory" && /* @__PURE__ */ jsxs9("div", { className: "voice-layout numbers-tab-panel", children: [
      /* @__PURE__ */ jsxs9("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsxs9("header", { children: [
          /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsx9("small", { children: "ENVANTER" }),
            /* @__PURE__ */ jsx9("h3", { children: "\xC7al\u0131\u015Fma alan\u0131 numaralar\u0131" })
          ] }),
          /* @__PURE__ */ jsxs9("div", { className: "numbers-header-actions", children: [
            /* @__PURE__ */ jsx9(
              "button",
              {
                type: "button",
                disabled: busy || atHardLimit,
                title: atHardLimit ? t("Phone number plan limit reached") : void 0,
                onClick: () => {
                  if (atHardLimit) return;
                  setShowImport((v) => !v);
                  setShowByo(false);
                },
                children: showImport ? "\u0130ptal" : "Havuz aktar"
              }
            ),
            /* @__PURE__ */ jsx9(
              "button",
              {
                type: "button",
                disabled: busy || atHardLimit,
                title: atHardLimit ? t("Phone number plan limit reached") : void 0,
                onClick: () => {
                  if (atHardLimit) return;
                  setShowByo((v) => !v);
                  setShowImport(false);
                },
                children: showByo ? "\u0130ptal" : "+ Kendi numaram\u0131 ekle"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs9("p", { className: "numbers-help", children: [
          "Giden aramalarda buradan arayan kimlik se\xE7in. Yeni hat ekleyin veya havuzdan aktar\u0131n. Gelen aramalar i\xE7in ajan ba\u011Flamay\u0131 ",
          /* @__PURE__ */ jsx9("b", { children: "Gelen ba\u011F" }),
          " sekmesinden yap\u0131n."
        ] }),
        Object.keys(byProvider).length > 0 && /* @__PURE__ */ jsx9("div", { className: "numbers-provider-badges", children: Object.entries(byProvider).map(([provider, count]) => /* @__PURE__ */ jsxs9("span", { className: `provider-chip provider-${provider}`, children: [
          provider,
          " \xB7 ",
          count
        ] }, provider)) }),
        showImport && !atHardLimit && /* @__PURE__ */ jsxs9("form", { className: "numbers-byo-form", onSubmit: (e) => void onImportPool(e), children: [
          /* @__PURE__ */ jsxs9("label", { children: [
            "Sa\u011Flay\u0131c\u0131 (pool)",
            /* @__PURE__ */ jsxs9("select", { name: "provider", defaultValue: "verimor", children: [
              /* @__PURE__ */ jsx9("option", { value: "verimor", children: "Verimor" }),
              /* @__PURE__ */ jsx9("option", { value: "zadarma", children: "Zadarma" }),
              /* @__PURE__ */ jsx9("option", { value: "manual", children: "Manuel" }),
              /* @__PURE__ */ jsx9("option", { value: "twilio", children: "Twilio" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs9("label", { children: [
            "Co\u011Frafya",
            /* @__PURE__ */ jsxs9("select", { name: "geoScope", defaultValue: "tr", children: [
              /* @__PURE__ */ jsx9("option", { value: "tr", children: "TR" }),
              /* @__PURE__ */ jsx9("option", { value: "intl", children: "Yurt d\u0131\u015F\u0131" }),
              /* @__PURE__ */ jsx9("option", { value: "unknown", children: "Bilinmiyor" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs9("label", { children: [
            "Numaralar (sat\u0131r veya virg\xFCl; opsiyonel etiket: +90\u2026 | Etiket)",
            /* @__PURE__ */ jsx9(
              "textarea",
              {
                name: "numbers",
                required: true,
                rows: 4,
                placeholder: "+908501112233 | Verimor TR 1\n+908501112244"
              }
            )
          ] }),
          /* @__PURE__ */ jsx9("button", { type: "submit", disabled: busy || atHardLimit, children: "Havuza aktar (platform d\u0131\u015F hat)" })
        ] }),
        showByo && !atHardLimit && /* @__PURE__ */ jsxs9("form", { className: "numbers-byo-form", onSubmit: (e) => void onCreateByo(e), children: [
          /* @__PURE__ */ jsxs9("label", { children: [
            "E.164 numara",
            /* @__PURE__ */ jsx9("input", { name: "e164", required: true, placeholder: "+905551112233" })
          ] }),
          /* @__PURE__ */ jsxs9("label", { children: [
            "Etiket",
            /* @__PURE__ */ jsx9("input", { name: "label", placeholder: "Ofis hatt\u0131" })
          ] }),
          /* @__PURE__ */ jsxs9("label", { children: [
            "Sa\u011Flay\u0131c\u0131",
            /* @__PURE__ */ jsxs9("select", { name: "provider", defaultValue: "byo_sip", children: [
              /* @__PURE__ */ jsx9("option", { value: "byo_sip", children: "Kendi SIP" }),
              /* @__PURE__ */ jsx9("option", { value: "twilio", children: "Twilio (kendi hat)" }),
              /* @__PURE__ */ jsx9("option", { value: "manual", children: "Manuel" }),
              /* @__PURE__ */ jsx9("option", { value: "other", children: "Di\u011Fer" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs9("label", { children: [
            "Co\u011Frafya",
            /* @__PURE__ */ jsxs9("select", { name: "geoScope", defaultValue: "tr", children: [
              /* @__PURE__ */ jsx9("option", { value: "tr", children: "TR" }),
              /* @__PURE__ */ jsx9("option", { value: "intl", children: "Yurt d\u0131\u015F\u0131" }),
              /* @__PURE__ */ jsx9("option", { value: "unknown", children: "Bilinmiyor" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs9("label", { children: [
            "Not",
            /* @__PURE__ */ jsx9("input", { name: "notes", placeholder: "Opsiyonel" })
          ] }),
          /* @__PURE__ */ jsx9("button", { type: "submit", disabled: busy || atHardLimit, children: "Kendi numaram\u0131 kaydet" })
        ] }),
        /* @__PURE__ */ jsxs9("div", { className: "numbers-list", children: [
          active.length === 0 && !showImport && !showByo && /* @__PURE__ */ jsxs9("div", { className: "studio-inline-empty", children: [
            /* @__PURE__ */ jsx9("strong", { children: "Hen\xFCz aktif numara yok" }),
            /* @__PURE__ */ jsx9("p", { children: "Kendi hatt\u0131n\u0131z\u0131 ekleyin veya platform havuzundan numara aktar\u0131n. Giden aramalarda arayan kimlik buradan se\xE7ilir." }),
            /* @__PURE__ */ jsxs9("div", { className: "studio-inline-empty-actions", children: [
              /* @__PURE__ */ jsx9(
                "button",
                {
                  type: "button",
                  className: "agentos-btn primary",
                  disabled: busy || atHardLimit,
                  onClick: () => {
                    if (atHardLimit) return;
                    setShowByo(true);
                    setShowImport(false);
                  },
                  children: "+ Kendi numaram\u0131 ekle"
                }
              ),
              /* @__PURE__ */ jsx9(
                "button",
                {
                  type: "button",
                  className: "directory-secondary-btn",
                  disabled: busy || atHardLimit,
                  onClick: () => {
                    if (atHardLimit) return;
                    setShowImport(true);
                    setShowByo(false);
                  },
                  children: "Havuz aktar"
                }
              )
            ] })
          ] }),
          production.length > 0 && /* @__PURE__ */ jsxs9(Fragment5, { children: [
            /* @__PURE__ */ jsx9("small", { className: "directory-section", children: "\xDCRET\u0130M DID" }),
            production.map((item) => renderInventoryRow(item))
          ] }),
          byoOrInternal.length > 0 && /* @__PURE__ */ jsxs9(Fragment5, { children: [
            /* @__PURE__ */ jsx9("small", { className: "directory-section", children: "KEND\u0130 HAT / DAH\u0130L\u0130" }),
            byoOrInternal.map((item) => renderInventoryRow(item))
          ] }),
          demo.length > 0 && /* @__PURE__ */ jsxs9(Fragment5, { children: [
            /* @__PURE__ */ jsx9("small", { className: "directory-section", children: "DEMO / TEST HAVUZU" }),
            demo.map((item) => renderInventoryRow(item))
          ] })
        ] }),
        inactive.length > 0 && /* @__PURE__ */ jsxs9(Fragment5, { children: [
          /* @__PURE__ */ jsx9("small", { className: "directory-section", children: "PAS\u0130F / AR\u015E\u0130V" }),
          /* @__PURE__ */ jsx9("div", { className: "numbers-list muted", children: inactive.map((item) => /* @__PURE__ */ jsx9("div", { className: "numbers-row", children: /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsx9("strong", { children: item.label || item.e164 }),
            /* @__PURE__ */ jsxs9("small", { children: [
              item.e164,
              " \xB7 ",
              classLabel(item.numberClass),
              " \xB7 ",
              item.status
            ] })
          ] }) }, item.id)) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs9("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx9("header", { children: /* @__PURE__ */ jsxs9("div", { children: [
          /* @__PURE__ */ jsx9("small", { children: "KISA REHBER" }),
          /* @__PURE__ */ jsx9("h3", { children: "Nas\u0131l se\xE7ilir?" })
        ] }) }),
        /* @__PURE__ */ jsxs9("ul", { className: "numbers-legend", children: [
          /* @__PURE__ */ jsxs9("li", { children: [
            /* @__PURE__ */ jsx9("b", { children: "Platform d\u0131\u015F hat" }),
            " \u2014 Panaryus DID havuzu (Verimor TR + Zadarma). S\u0131k\u0131 g\xFCven band\u0131."
          ] }),
          /* @__PURE__ */ jsxs9("li", { children: [
            /* @__PURE__ */ jsx9("b", { children: "Kendi numaram" }),
            " \u2014 Kendi SIP/API + DID. Telekom faturas\u0131 sizde."
          ] }),
          /* @__PURE__ */ jsxs9("li", { children: [
            /* @__PURE__ */ jsx9("b", { children: "Gelen ba\u011F" }),
            " \u2014 \xDCretim DID\u2019ye yay\u0131nl\u0131 ajan ba\u011Flay\u0131n; aksi halde gelen arama cevaplanmaz."
          ] })
        ] })
      ] })
    ] }),
    tab === "inbound" && /* @__PURE__ */ jsx9("div", { className: "numbers-tab-panel numbers-inbound-panel", children: /* @__PURE__ */ jsxs9("article", { className: "studio-card", children: [
      /* @__PURE__ */ jsxs9("header", { children: [
        /* @__PURE__ */ jsxs9("div", { children: [
          /* @__PURE__ */ jsx9("small", { children: "GELEN ARAMA" }),
          /* @__PURE__ */ jsx9("h3", { children: "DID \u2192 yay\u0131nl\u0131 ajan" })
        ] }),
        /* @__PURE__ */ jsx9("b", { children: unboundProduction.length === 0 ? "T\xFCm\xFC ba\u011Fl\u0131" : `${unboundProduction.length} ba\u011F eksik` })
      ] }),
      /* @__PURE__ */ jsx9("p", { className: "numbers-help", children: "Sadece \xFCretim / platform hatlar\u0131. Gelen arama hangi ajan\u0131n cevaplayaca\u011F\u0131n\u0131 burada se\xE7ersiniz. Yay\u0131nl\u0131 ajan yoksa \xF6nce AI Ajanlar\u0131\u2019ndan yay\u0131nlay\u0131n." }),
      publishedAgents.length === 0 && /* @__PURE__ */ jsx9("div", { className: "studio-alert error", role: "status", children: "Yay\u0131nl\u0131 ajan yok. Gelen ba\u011F i\xE7in en az bir ajan yay\u0131nlay\u0131n." }),
      /* @__PURE__ */ jsx9("div", { className: "numbers-list", children: production.length === 0 ? /* @__PURE__ */ jsxs9("div", { className: "studio-inline-empty", children: [
        /* @__PURE__ */ jsx9("strong", { children: "\xDCretim DID yok" }),
        /* @__PURE__ */ jsx9("p", { children: "\xD6nce Numaralar\u0131m sekmesinden hat ekleyin veya havuzdan aktar\u0131n." }),
        /* @__PURE__ */ jsx9("button", { type: "button", className: "agentos-btn primary", onClick: () => setTab("inventory"), children: "Numaralar\u0131ma git" })
      ] }) : /* @__PURE__ */ jsxs9(Fragment5, { children: [
        unboundProduction.length > 0 && /* @__PURE__ */ jsxs9(Fragment5, { children: [
          /* @__PURE__ */ jsx9("small", { className: "directory-section", children: "BA\u011ELANMAMI\u015E" }),
          unboundProduction.map(
            (item) => renderInventoryRow(item, { focusBind: true })
          )
        ] }),
        production.filter((n) => n.defaultInboundAgentId).length > 0 && /* @__PURE__ */ jsxs9(Fragment5, { children: [
          /* @__PURE__ */ jsx9("small", { className: "directory-section", children: "BA\u011ELI" }),
          production.filter((n) => n.defaultInboundAgentId).map((item) => renderInventoryRow(item, { focusBind: true }))
        ] })
      ] }) })
    ] }) }),
    tab === "rates" && /* @__PURE__ */ jsxs9("div", { className: "voice-layout numbers-tab-panel", children: [
      /* @__PURE__ */ jsxs9("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx9("header", { children: /* @__PURE__ */ jsxs9("div", { children: [
          /* @__PURE__ */ jsx9("small", { children: "SMS" }),
          /* @__PURE__ */ jsx9("h3", { children: "Giden SMS" })
        ] }) }),
        /* @__PURE__ */ jsx9("p", { className: "numbers-help", children: "Test i\xE7in sim\xFClasyon kayd\u0131 d\xFC\u015Fer. Canl\u0131 Verimor i\xE7in operasyon gizli anahtar\u0131 gerekir." }),
        /* @__PURE__ */ jsxs9("form", { className: "numbers-byo-form", onSubmit: (e) => void onSendSms(e), children: [
          /* @__PURE__ */ jsxs9("label", { children: [
            "Al\u0131c\u0131 E.164",
            /* @__PURE__ */ jsx9("input", { name: "toE164", required: true, placeholder: "+905551112233" })
          ] }),
          /* @__PURE__ */ jsxs9("label", { children: [
            "Ba\u015Fl\u0131k",
            /* @__PURE__ */ jsx9("input", { name: "header", placeholder: "PANARYUS" })
          ] }),
          /* @__PURE__ */ jsxs9("label", { children: [
            "Mesaj",
            /* @__PURE__ */ jsx9("textarea", { name: "body", required: true, rows: 3, maxLength: 1e3, placeholder: "Merhaba, randevunuz\u2026" })
          ] }),
          /* @__PURE__ */ jsx9("button", { type: "submit", disabled: busy, children: "SMS g\xF6nder" })
        ] }),
        /* @__PURE__ */ jsx9("div", { className: "numbers-list", style: { marginTop: 12 }, children: smsItems.length === 0 ? /* @__PURE__ */ jsxs9("div", { className: "studio-inline-empty compact", children: [
          /* @__PURE__ */ jsx9("strong", { children: "Hen\xFCz SMS yok" }),
          /* @__PURE__ */ jsx9("p", { children: "Yukar\u0131daki formdan test veya operasyon mesaj\u0131 g\xF6nderin; kay\u0131tlar burada listelenir." })
        ] }) : smsItems.slice(0, 12).map((item) => /* @__PURE__ */ jsx9("div", { className: "numbers-row", children: /* @__PURE__ */ jsxs9("div", { children: [
          /* @__PURE__ */ jsxs9("strong", { children: [
            item.toMasked,
            " \xB7 ",
            item.status
          ] }),
          /* @__PURE__ */ jsxs9("small", { children: [
            item.provider,
            item.header ? ` \xB7 ${item.header}` : "",
            " \xB7 ",
            item.bodyPreview
          ] }),
          /* @__PURE__ */ jsx9("small", { children: item.createdAt })
        ] }) }, item.id)) })
      ] }),
      /* @__PURE__ */ jsxs9("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsxs9("header", { children: [
          /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsx9("small", { children: "TAR\u0130FE" }),
            /* @__PURE__ */ jsx9("h3", { children: "Platform DID katalog (TRY)" })
          ] }),
          rateCard && /* @__PURE__ */ jsx9("em", { className: `status-${rateCard.trust}`, children: rateCard.trust })
        ] }),
        !rateCard ? /* @__PURE__ */ jsx9("p", { className: "numbers-empty", children: "Tarife kart\u0131 y\xFCklenemedi." }) : /* @__PURE__ */ jsxs9(Fragment5, { children: [
          /* @__PURE__ */ jsx9("p", { className: "numbers-help", children: "\xDCr\xFCn katalo\u011Fu \u2014 anl\u0131k operat\xF6r fiyat\u0131 de\u011Fildir. AI ses dakikas\u0131 ayr\u0131 \xF6l\xE7\xFCl\xFCr." }),
          /* @__PURE__ */ jsx9("div", { className: "numbers-provider-badges", children: rateCard.trunks.map((trunk) => /* @__PURE__ */ jsxs9(
            "span",
            {
              className: `provider-chip provider-${trunk.provider}`,
              title: `${trunk.role} \xB7 ${trunk.status}`,
              children: [
                trunk.provider,
                " \xB7 ",
                trunk.role,
                " \xB7 ",
                trunk.status
              ]
            },
            trunk.provider
          )) }),
          /* @__PURE__ */ jsx9("div", { className: "numbers-list", style: { marginTop: 10 }, children: rateCard.lines.map((line) => /* @__PURE__ */ jsx9("div", { className: "numbers-row", children: /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsxs9("strong", { children: [
              line.label,
              " \xB7 \u20BA",
              line.unitAmountTry,
              line.unit === "month" ? "/ay" : line.unit === "minute" ? "/dk" : line.unit === "message" ? "/msg" : "/koltuk"
            ] }),
            /* @__PURE__ */ jsxs9("small", { children: [
              line.sku,
              " \xB7 ",
              line.notes
            ] })
          ] }) }, line.sku)) }),
          /* @__PURE__ */ jsx9("ul", { className: "numbers-legend", style: { marginTop: 12 }, children: rateCard.rules.map((rule) => /* @__PURE__ */ jsx9("li", { children: rule }, rule)) })
        ] })
      ] })
    ] })
  ] });
};

// src/campaigns.tsx
import {
  useCallback as useCallback9,
  useEffect as useEffect8,
  useState as useState9
} from "react";
import {
  campaignContactImportResultSchema,
  campaignContactListSchema,
  campaignListSchema,
  campaignRunResultSchema,
  campaignViewSchema,
  DIALOGUE_STYLE_CATALOG as DIALOGUE_STYLE_CATALOG3,
  DEFAULT_DIALOGUE_STYLE as DEFAULT_DIALOGUE_STYLE2
} from "@agentos/contracts";
import { Fragment as Fragment6, jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var purposes2 = [
  { id: "general", label: "Genel" },
  { id: "support", label: "Destek" },
  { id: "sales", label: "Sat\u0131\u015F" },
  { id: "marketing", label: "Pazarlama" },
  { id: "callback", label: "Geri arama" },
  { id: "custom", label: "\xD6zel" }
];
var createCampaignsApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const request = async (path, init) => {
    const response = await fetch(`${base}${path}`, {
      ...init,
      headers: {
        Authorization: `Bearer ${token}`,
        ...init?.body ? { "Content-Type": "application/json" } : {}
      },
      signal: AbortSignal.timeout(2e4)
    });
    if (!response.ok) {
      await throwProblemError(response);
    }
    return response.json();
  };
  return {
    list: async (workspaceId) => campaignListSchema.parse(
      await request(`/v1/campaigns?workspaceId=${encodeURIComponent(workspaceId)}`)
    ),
    get: async (campaignId) => campaignViewSchema.parse(
      await request(`/v1/campaigns/${encodeURIComponent(campaignId)}`)
    ),
    create: async (input) => campaignViewSchema.parse(
      await request("/v1/campaigns", { method: "POST", body: JSON.stringify(input) })
    ),
    update: async (campaignId, input) => campaignViewSchema.parse(
      await request(`/v1/campaigns/${encodeURIComponent(campaignId)}`, {
        method: "PATCH",
        body: JSON.stringify(input)
      })
    ),
    listContacts: async (campaignId) => {
      const page = campaignContactListSchema.parse(
        await request(
          `/v1/campaigns/${encodeURIComponent(campaignId)}/contacts?limit=200`
        )
      );
      return { items: page.items, total: page.total };
    },
    addContacts: async (campaignId, input) => campaignContactImportResultSchema.parse(
      await request(`/v1/campaigns/${encodeURIComponent(campaignId)}/contacts`, {
        method: "POST",
        body: JSON.stringify(input)
      })
    ),
    importCsv: async (campaignId, csv) => campaignContactImportResultSchema.parse(
      await request(
        `/v1/campaigns/${encodeURIComponent(campaignId)}/contacts/import-csv`,
        { method: "POST", body: JSON.stringify({ csv }) }
      )
    ),
    removeContact: async (campaignId, campaignContactId) => await request(
      `/v1/campaigns/${encodeURIComponent(campaignId)}/contacts/${encodeURIComponent(campaignContactId)}`,
      { method: "DELETE" }
    ),
    start: async (campaignId, input) => campaignRunResultSchema.parse(
      await request(`/v1/campaigns/${encodeURIComponent(campaignId)}/start`, {
        method: "POST",
        body: JSON.stringify({
          from: input.from,
          recordingConsent: input.recordingConsent ?? true
        })
      })
    ),
    pause: async (campaignId) => campaignViewSchema.parse(
      await request(`/v1/campaigns/${encodeURIComponent(campaignId)}/pause`, {
        method: "POST",
        body: JSON.stringify({})
      })
    ),
    runNext: async (campaignId, input) => campaignRunResultSchema.parse(
      await request(`/v1/campaigns/${encodeURIComponent(campaignId)}/run-next`, {
        method: "POST",
        body: JSON.stringify({
          from: input.from,
          recordingConsent: input.recordingConsent ?? true
        })
      })
    )
  };
};
var CampaignsPage = ({
  api,
  agents,
  contactsApi,
  phoneNumbersApi,
  workspaceId,
  locale
}) => {
  const currentLocale = localeFrom(typeof locale === "string" ? locale : locale);
  const t = (text) => translate(currentLocale, text);
  const [campaigns, setCampaigns] = useState9([]);
  const [campaignUsage, setCampaignUsage] = useState9(0);
  const [campaignLimit, setCampaignLimit] = useState9(null);
  const [campaignEnforcement, setCampaignEnforcement] = useState9(
    null
  );
  const [agentOptions, setAgentOptions] = useState9(
    []
  );
  const [directoryContacts, setDirectoryContacts] = useState9([]);
  const [phoneNumbers, setPhoneNumbers] = useState9([]);
  const [campaignContacts, setCampaignContacts] = useState9(
    []
  );
  const [campaignContactTotal, setCampaignContactTotal] = useState9(0);
  const [selectedId, setSelectedId] = useState9(null);
  const [selected, setSelected] = useState9(null);
  const [error, setError] = useState9();
  const [notice, setNotice] = useState9();
  const [busy, setBusy] = useState9(false);
  const [showCreate, setShowCreate] = useState9(false);
  const [createStep, setCreateStep] = useState9(1);
  const [showAdvanced, setShowAdvanced] = useState9(false);
  const [manualPhone, setManualPhone] = useState9("");
  const [manualName, setManualName] = useState9("");
  const [csvText, setCsvText] = useState9("");
  const [pickContactId, setPickContactId] = useState9("");
  const [fromNumberId, setFromNumberId] = useState9("");
  const [fromNumber, setFromNumber] = useState9("+13235405697");
  const [form, setForm] = useState9({
    name: "",
    agentId: "",
    dialogueStyle: DEFAULT_DIALOGUE_STYLE2,
    defaultPurpose: "sales",
    defaultPurposeNote: "",
    goal: "",
    useBusinessBrain: true,
    retryEnabled: false,
    retryMaxAttempts: 3,
    retryIntervalMinutes: 30,
    retryOnBusy: true,
    retryOnNoAnswer: true,
    retryOnFailed: true,
    scheduleEnabled: false,
    scheduleDays: [1, 2, 3, 4, 5],
    scheduleTimeStart: "09:00",
    scheduleTimeEnd: "18:00",
    scheduleTimezone: "Europe/Istanbul"
  });
  const policyPayload = () => ({
    retry: {
      enabled: form.retryEnabled,
      maxAttempts: form.retryMaxAttempts,
      intervalMinutes: form.retryIntervalMinutes,
      onBusy: form.retryOnBusy,
      onNoAnswer: form.retryOnNoAnswer,
      onFailed: form.retryOnFailed
    },
    schedule: {
      enabled: form.scheduleEnabled,
      days: form.scheduleDays,
      timeStart: form.scheduleTimeStart,
      timeEnd: form.scheduleTimeEnd,
      timezone: form.scheduleTimezone
    }
  });
  const load = useCallback9(async () => {
    const [page, agentPage] = await Promise.all([
      api.list(workspaceId),
      agents.list(workspaceId)
    ]);
    setCampaigns(page.items);
    setCampaignUsage(page.usage);
    setCampaignLimit(page.limit);
    setCampaignEnforcement(page.enforcement);
    const options = agentPage.items.filter((a) => a.publishedVersion != null).map(({ id, name, publishedVersion }) => ({
      id,
      name,
      publishedVersion
    }));
    setAgentOptions(options);
    setForm((prev) => ({
      ...prev,
      agentId: prev.agentId && options.some((o) => o.id === prev.agentId) ? prev.agentId : options[0]?.id || ""
    }));
    if (contactsApi) {
      const dir = await contactsApi.list(workspaceId);
      setDirectoryContacts(
        dir.items.map((c) => ({
          id: c.id,
          displayName: c.displayName,
          phoneE164: c.phoneE164
        }))
      );
    }
    if (phoneNumbersApi) {
      const nums = (await phoneNumbersApi.list(workspaceId)).items.filter(
        (n) => n.status === "active"
      );
      setPhoneNumbers(nums);
      if (nums[0]) {
        setFromNumberId(nums[0].id);
        setFromNumber(nums[0].e164);
      }
    }
  }, [api, agents, contactsApi, phoneNumbersApi, workspaceId]);
  const loadCampaignContacts = useCallback9(
    async (campaignId) => {
      const page = await api.listContacts(campaignId);
      setCampaignContacts(page.items);
      setCampaignContactTotal(page.total);
    },
    [api]
  );
  useEffect8(() => {
    void load().catch(
      (cause) => setError(cause instanceof Error ? cause.message : "LOAD_FAILED")
    );
  }, [load]);
  const selectCampaign = (campaign) => {
    setShowCreate(false);
    setSelectedId(campaign.id);
    setSelected(campaign);
    setForm({
      name: campaign.name,
      agentId: campaign.agentId ?? agentOptions[0]?.id ?? "",
      dialogueStyle: campaign.dialogueStyle ?? DEFAULT_DIALOGUE_STYLE2,
      defaultPurpose: campaign.defaultPurpose,
      defaultPurposeNote: campaign.defaultPurposeNote ?? "",
      goal: campaign.goal ?? "",
      useBusinessBrain: campaign.useBusinessBrain,
      retryEnabled: campaign.retry?.enabled ?? false,
      retryMaxAttempts: campaign.retry?.maxAttempts ?? 3,
      retryIntervalMinutes: campaign.retry?.intervalMinutes ?? 30,
      retryOnBusy: campaign.retry?.onBusy ?? true,
      retryOnNoAnswer: campaign.retry?.onNoAnswer ?? true,
      retryOnFailed: campaign.retry?.onFailed ?? true,
      scheduleEnabled: campaign.schedule?.enabled ?? false,
      scheduleDays: campaign.schedule?.days?.length ? [...campaign.schedule.days] : [1, 2, 3, 4, 5],
      scheduleTimeStart: campaign.schedule?.timeStart ?? "09:00",
      scheduleTimeEnd: campaign.schedule?.timeEnd ?? "18:00",
      scheduleTimezone: campaign.schedule?.timezone ?? "Europe/Istanbul"
    });
    setError(void 0);
    setNotice(void 0);
    void loadCampaignContacts(campaign.id).catch(
      (cause) => setError(cause instanceof Error ? cause.message : "CONTACTS_LOAD_FAILED")
    );
  };
  const createCampaign = async (event) => {
    event.preventDefault();
    if (atHardLimit) {
      setError(t("Campaign plan limit reached"));
      return;
    }
    setBusy(true);
    setError(void 0);
    setNotice(void 0);
    try {
      if (!form.name.trim()) throw new Error("Kampanya ad\u0131 zorunlu.");
      const created = await api.create({
        workspaceId,
        name: form.name.trim(),
        agentId: form.agentId || null,
        dialogueStyle: form.dialogueStyle,
        defaultPurpose: form.defaultPurpose,
        defaultPurposeNote: form.defaultPurposeNote.trim() || null,
        useBusinessBrain: form.useBusinessBrain,
        goal: form.goal.trim() || null,
        ...policyPayload()
      });
      setNotice(`Kampanya olu\u015Fturuldu: ${created.name} (${created.status})`);
      setShowCreate(false);
      await load();
      selectCampaign(created);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "CREATE_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const saveCampaign = async (event) => {
    event.preventDefault();
    if (!selectedId || !selected) return;
    setBusy(true);
    setError(void 0);
    setNotice(void 0);
    try {
      if (selected.status === "draft") {
        const updated = await api.update(selectedId, {
          name: form.name.trim(),
          agentId: form.agentId || null,
          dialogueStyle: form.dialogueStyle,
          defaultPurpose: form.defaultPurpose,
          defaultPurposeNote: form.defaultPurposeNote.trim() || null,
          useBusinessBrain: form.useBusinessBrain,
          goal: form.goal.trim() || null,
          ...policyPayload()
        });
        setNotice(`${updated.name} kaydedildi.`);
        await load();
        setSelected(updated);
      } else if (selected.status === "paused") {
        const updated = await api.update(selectedId, policyPayload());
        setNotice(`${updated.name} retry/schedule g\xFCncellendi (paused).`);
        await load();
        setSelected(updated);
      } else {
        throw new Error(
          "Kimlik alanlar\u0131 yaln\u0131z draft; retry/schedule draft veya paused iken kaydedilir."
        );
      }
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "UPDATE_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const archiveCampaign = async () => {
    if (!selectedId) return;
    setBusy(true);
    setError(void 0);
    try {
      await api.update(selectedId, { status: "archived" });
      setNotice("Kampanya ar\u015Fivlendi.");
      setSelected(null);
      setSelectedId(null);
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "ARCHIVE_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const agentName = (id) => agentOptions.find((item) => item.id === id)?.name ?? id ?? "\u2014";
  const styleLabel = (id) => DIALOGUE_STYLE_CATALOG3.find((item) => item.id === id)?.label ?? id ?? "\u2014";
  const usageCount = Math.max(campaignUsage, campaigns.length);
  const atSoftLimit = campaignEnforcement === "soft" && campaignLimit != null && usageCount >= campaignLimit;
  const atHardLimit = campaignEnforcement === "hard" && campaignLimit != null && usageCount >= campaignLimit;
  const campaignCountLabel = campaignLimit != null ? `${usageCount} / ${campaignLimit} kampanya` : `${usageCount} kampanya`;
  const openCreateForm = () => {
    if (atHardLimit) return;
    setShowCreate(true);
    setCreateStep(1);
    setShowAdvanced(false);
    setSelected(null);
    setSelectedId(null);
    setForm((prev) => ({
      ...prev,
      name: "",
      defaultPurposeNote: "",
      goal: "",
      dialogueStyle: DEFAULT_DIALOGUE_STYLE2,
      defaultPurpose: "sales",
      useBusinessBrain: true,
      agentId: agentOptions[0]?.id ?? "",
      retryEnabled: false,
      retryMaxAttempts: 3,
      retryIntervalMinutes: 30,
      retryOnBusy: true,
      retryOnNoAnswer: true,
      retryOnFailed: true,
      scheduleEnabled: false,
      scheduleDays: [1, 2, 3, 4, 5],
      scheduleTimeStart: "09:00",
      scheduleTimeEnd: "18:00",
      scheduleTimezone: "Europe/Istanbul"
    }));
  };
  const statusLabelTr = (status) => {
    switch (status) {
      case "draft":
        return "taslak";
      case "scheduled":
        return "zamanland\u0131";
      case "running":
        return "\xE7al\u0131\u015F\u0131yor";
      case "paused":
        return "duraklat\u0131ld\u0131";
      case "completed":
        return "bitti";
      case "archived":
        return "ar\u015Fiv";
      default:
        return status;
    }
  };
  const canCreateStep1 = form.name.trim().length > 0 && form.agentId.length > 0;
  return /* @__PURE__ */ jsxs10("section", { className: "campaigns-page studio-page", children: [
    /* @__PURE__ */ jsxs10("header", { className: "studio-toolbar", children: [
      /* @__PURE__ */ jsxs10("div", { children: [
        /* @__PURE__ */ jsx10("span", { children: "KAMPANYALAR" }),
        /* @__PURE__ */ jsx10("h2", { children: "Toplu arama kampanyalar\u0131" })
      ] }),
      /* @__PURE__ */ jsx10("b", { children: campaignCountLabel })
    ] }),
    error && /* @__PURE__ */ jsx10("div", { className: "studio-alert error", children: error }),
    notice && /* @__PURE__ */ jsx10("div", { className: "studio-alert success", children: notice }),
    atSoftLimit && /* @__PURE__ */ jsx10("div", { className: "studio-alert", role: "status", children: t("Approaching plan campaign limit") }),
    atHardLimit && /* @__PURE__ */ jsx10("div", { className: "studio-alert error", role: "alert", children: t("Campaign plan limit reached") }),
    /* @__PURE__ */ jsxs10("p", { className: "campaigns-note", children: [
      /* @__PURE__ */ jsx10("b", { children: "3 ad\u0131m:" }),
      " taslak olu\u015Ftur \u2192 ki\u015Fi ekle \u2192 arayan numara ile Ba\u015Flat. Aramalar s\u0131rayla gider; bitince lead kart\u0131 olu\u015Fur. Yeniden arama / saat penceresi iste\u011Fe ba\u011Fl\u0131 (ileri ayar)."
    ] }),
    /* @__PURE__ */ jsxs10("div", { className: "studio-grid directory-layout", children: [
      /* @__PURE__ */ jsxs10("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsxs10("header", { children: [
          /* @__PURE__ */ jsxs10("div", { children: [
            /* @__PURE__ */ jsx10("small", { children: "L\u0130STE" }),
            /* @__PURE__ */ jsx10("h3", { children: "Kampanyalar" })
          ] }),
          /* @__PURE__ */ jsx10(
            "button",
            {
              type: "button",
              className: "directory-secondary-btn",
              disabled: atHardLimit || busy,
              title: atHardLimit ? t("Campaign plan limit reached") : void 0,
              onClick: openCreateForm,
              children: "+ Yeni kampanya"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs10("div", { className: "call-list directory-list", children: [
          campaigns.length === 0 && /* @__PURE__ */ jsxs10("div", { className: "studio-inline-empty", children: [
            /* @__PURE__ */ jsx10("strong", { children: "Hen\xFCz kampanya yok" }),
            /* @__PURE__ */ jsx10("p", { children: "Ki\u015Fi listesi + script + arayan numara ile toplu arama ba\u015Flat\u0131n." }),
            /* @__PURE__ */ jsx10(
              "button",
              {
                type: "button",
                className: "agentos-btn primary",
                disabled: atHardLimit || busy,
                title: atHardLimit ? t("Campaign plan limit reached") : void 0,
                onClick: openCreateForm,
                children: "+ Yeni kampanya"
              }
            )
          ] }),
          campaigns.map((campaign) => /* @__PURE__ */ jsxs10(
            "button",
            {
              type: "button",
              className: selectedId === campaign.id ? "active" : "",
              onClick: () => selectCampaign(campaign),
              children: [
                /* @__PURE__ */ jsxs10("span", { children: [
                  /* @__PURE__ */ jsx10("strong", { children: campaign.name }),
                  /* @__PURE__ */ jsxs10("small", { children: [
                    statusLabelTr(campaign.status),
                    " \xB7 ",
                    styleLabel(campaign.dialogueStyle)
                  ] }),
                  /* @__PURE__ */ jsxs10("small", { children: [
                    agentName(campaign.agentId),
                    " \xB7 ",
                    campaign.totalContacts,
                    " ki\u015Fi"
                  ] })
                ] }),
                /* @__PURE__ */ jsx10("em", { children: purposeLabel3(campaign.defaultPurpose) })
              ]
            },
            campaign.id
          ))
        ] })
      ] }),
      /* @__PURE__ */ jsxs10("article", { className: "studio-card directory-detail-card", children: [
        /* @__PURE__ */ jsxs10("header", { children: [
          /* @__PURE__ */ jsxs10("div", { children: [
            /* @__PURE__ */ jsx10("small", { children: showCreate ? "YEN\u0130" : "SE\xC7\u0130L\u0130" }),
            /* @__PURE__ */ jsx10("h3", { children: showCreate ? "Kampanya olu\u015Ftur" : selected ? selected.name : "Kampanya se\xE7in" })
          ] }),
          /* @__PURE__ */ jsx10("b", { children: selected ? statusLabelTr(selected.status) : showCreate ? "taslak" : "\u2014" })
        ] }),
        !showCreate && !selected ? /* @__PURE__ */ jsxs10("div", { className: "studio-inline-empty", children: [
          /* @__PURE__ */ jsx10("strong", { children: "Kampanya se\xE7in" }),
          /* @__PURE__ */ jsx10("p", { children: "Soldan bir kampanya a\xE7\u0131n veya 3 ad\u0131mda yeni taslak olu\u015Fturun, ki\u015Fi ekleyip Ba\u015Flat\u2019a bas\u0131n." }),
          /* @__PURE__ */ jsx10(
            "button",
            {
              type: "button",
              className: "directory-secondary-btn",
              disabled: atHardLimit || busy,
              onClick: openCreateForm,
              children: "+ Yeni kampanya"
            }
          )
        ] }) : /* @__PURE__ */ jsxs10(
          "form",
          {
            className: "directory-edit-form",
            onSubmit: (event) => void (showCreate ? createCampaign(event) : saveCampaign(event)),
            children: [
              showCreate && /* @__PURE__ */ jsx10("div", { className: "campaign-wizard-steps", "aria-label": "Kampanya olu\u015Fturma ad\u0131mlar\u0131", children: [
                [1, "Temel"],
                [2, "Script"],
                [3, "Olu\u015Ftur"]
              ].map(([step, label]) => /* @__PURE__ */ jsxs10(
                "button",
                {
                  type: "button",
                  className: createStep === step ? "campaign-wizard-step active" : createStep > step ? "campaign-wizard-step done" : "campaign-wizard-step",
                  onClick: () => {
                    if (step === 1) setCreateStep(1);
                    else if (step === 2 && canCreateStep1) setCreateStep(2);
                    else if (step === 3 && canCreateStep1) setCreateStep(3);
                  },
                  children: [
                    /* @__PURE__ */ jsx10("em", { children: step }),
                    label
                  ]
                },
                step
              )) }),
              (!showCreate || createStep === 1) && /* @__PURE__ */ jsxs10(Fragment6, { children: [
                showCreate && /* @__PURE__ */ jsxs10("p", { className: "campaign-wizard-hint", children: [
                  /* @__PURE__ */ jsx10("b", { children: "Ad\u0131m 1/3 \u2014 Temel:" }),
                  " isim, ajan ve arama amac\u0131."
                ] }),
                /* @__PURE__ */ jsxs10("label", { children: [
                  "Kampanya ad\u0131",
                  /* @__PURE__ */ jsx10(
                    "input",
                    {
                      required: true,
                      value: form.name,
                      onChange: (e) => setForm((prev) => ({ ...prev, name: e.target.value })),
                      placeholder: "Mustafao\u011Flu tar\u0131m finansman\u0131 Q3"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs10("label", { children: [
                  "Ajan",
                  /* @__PURE__ */ jsxs10(
                    "select",
                    {
                      value: form.agentId,
                      onChange: (e) => setForm((prev) => ({ ...prev, agentId: e.target.value })),
                      required: showCreate,
                      children: [
                        /* @__PURE__ */ jsx10("option", { value: "", children: "\u2014 se\xE7ilmedi \u2014" }),
                        agentOptions.map((agent) => /* @__PURE__ */ jsxs10("option", { value: agent.id, children: [
                          agent.name,
                          " \xB7 canl\u0131 v",
                          agent.publishedVersion
                        ] }, agent.id))
                      ]
                    }
                  ),
                  agentOptions.length === 0 && /* @__PURE__ */ jsx10("small", { className: "campaign-wizard-hint", children: "Yay\u0131nl\u0131 ajan yok. Ajanlar \u2192 Kaydet \u2192 Yay\u0131nla, sonra kampanya olu\u015Fturun." })
                ] }),
                /* @__PURE__ */ jsxs10("label", { children: [
                  "Ama\xE7",
                  /* @__PURE__ */ jsx10(
                    "select",
                    {
                      value: form.defaultPurpose,
                      onChange: (e) => {
                        const defaultPurpose = e.target.value;
                        setForm((prev) => ({
                          ...prev,
                          defaultPurpose,
                          defaultPurposeNote: defaultPurpose === "marketing" ? "" : prev.defaultPurposeNote
                        }));
                      },
                      children: purposes2.map((item) => /* @__PURE__ */ jsx10("option", { value: item.id, children: item.label }, item.id))
                    }
                  )
                ] })
              ] }),
              (!showCreate || createStep === 2) && /* @__PURE__ */ jsxs10(Fragment6, { children: [
                showCreate && /* @__PURE__ */ jsxs10("p", { className: "campaign-wizard-hint", children: [
                  /* @__PURE__ */ jsx10("b", { children: "Ad\u0131m 2/3 \u2014 Script:" }),
                  " konu\u015Fma kural\u0131, AI notu ve hedef."
                ] }),
                /* @__PURE__ */ jsxs10("label", { children: [
                  "Konu\u015Fma kural\u0131",
                  /* @__PURE__ */ jsx10(
                    "select",
                    {
                      value: form.dialogueStyle,
                      onChange: (e) => setForm((prev) => ({
                        ...prev,
                        dialogueStyle: e.target.value
                      })),
                      children: DIALOGUE_STYLE_CATALOG3.map((item) => /* @__PURE__ */ jsx10("option", { value: item.id, children: item.label }, item.id))
                    }
                  ),
                  /* @__PURE__ */ jsx10("small", { className: "directory-field-hint", children: DIALOGUE_STYLE_CATALOG3.find((item) => item.id === form.dialogueStyle)?.description })
                ] }),
                /* @__PURE__ */ jsxs10("label", { children: [
                  "Ama\xE7 notu / AI script",
                  /* @__PURE__ */ jsx10(
                    "textarea",
                    {
                      rows: showCreate ? 4 : 5,
                      value: form.defaultPurposeNote,
                      disabled: form.defaultPurpose === "marketing",
                      onChange: (e) => setForm((prev) => ({ ...prev, defaultPurposeNote: e.target.value })),
                      placeholder: form.defaultPurpose === "marketing" ? "Marketing + script platform hatt\u0131nda kapal\u0131 \u2014 sales se\xE7in" : 'A\xC7ILI\u015E: "Merhaba\u2026"  M\xDC\u015ETER\u0130 \u0130LG\u0130LEN\u0130RSE: "Tamam\u2026"'
                    }
                  ),
                  form.defaultPurpose === "marketing" && /* @__PURE__ */ jsxs10("small", { className: "directory-field-hint", children: [
                    "Platform d\u0131\u015F hat: marketing \u015Fablonunda serbest script yok. Script i\xE7in amac\u0131",
                    " ",
                    /* @__PURE__ */ jsx10("strong", { children: "sat\u0131\u015F" }),
                    " se\xE7in."
                  ] })
                ] }),
                /* @__PURE__ */ jsxs10("label", { children: [
                  "Hedef (opsiyonel)",
                  /* @__PURE__ */ jsx10(
                    "input",
                    {
                      value: form.goal,
                      onChange: (e) => setForm((prev) => ({ ...prev, goal: e.target.value })),
                      placeholder: "Lead kayd\u0131 + geri arama randevusu"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs10("label", { className: "voice-consent", children: [
                  /* @__PURE__ */ jsx10(
                    "input",
                    {
                      type: "checkbox",
                      checked: form.useBusinessBrain,
                      onChange: (e) => setForm((prev) => ({ ...prev, useBusinessBrain: e.target.checked }))
                    }
                  ),
                  "Business Brain kullan"
                ] })
              ] }),
              (!showCreate || createStep === 3) && /* @__PURE__ */ jsxs10(Fragment6, { children: [
                showCreate && /* @__PURE__ */ jsxs10("p", { className: "campaign-wizard-hint", children: [
                  /* @__PURE__ */ jsx10("b", { children: "Ad\u0131m 3/3 \u2014 Olu\u015Ftur:" }),
                  " iste\u011Fe ba\u011Fl\u0131 ileri ayarlar, sonra taslak kayd\u0131. Ki\u015Fi ekleme ve Ba\u015Flat bir sonraki ekranda."
                ] }),
                /* @__PURE__ */ jsx10(
                  "button",
                  {
                    type: "button",
                    className: "campaign-advanced-toggle",
                    onClick: () => setShowAdvanced((v) => !v),
                    children: showAdvanced ? "\u25BC \u0130leri ayarlar\u0131 gizle" : "\u25B6 \u0130leri ayarlar (yeniden ara / saat)"
                  }
                ),
                showAdvanced && /* @__PURE__ */ jsxs10("div", { className: "campaign-advanced-block", children: [
                  /* @__PURE__ */ jsx10("small", { className: "directory-section", children: "YEN\u0130DEN ARAMA" }),
                  /* @__PURE__ */ jsxs10("label", { className: "voice-consent", children: [
                    /* @__PURE__ */ jsx10(
                      "input",
                      {
                        type: "checkbox",
                        checked: form.retryEnabled,
                        onChange: (e) => setForm((prev) => ({ ...prev, retryEnabled: e.target.checked }))
                      }
                    ),
                    "Ba\u015Far\u0131s\u0131z aramalarda yeniden dene"
                  ] }),
                  form.retryEnabled && /* @__PURE__ */ jsxs10(Fragment6, { children: [
                    /* @__PURE__ */ jsxs10("div", { className: "campaign-contact-actions", children: [
                      /* @__PURE__ */ jsxs10("label", { children: [
                        "Max deneme",
                        /* @__PURE__ */ jsx10(
                          "input",
                          {
                            type: "number",
                            min: 1,
                            max: 10,
                            value: form.retryMaxAttempts,
                            onChange: (e) => setForm((prev) => ({
                              ...prev,
                              retryMaxAttempts: Math.min(
                                10,
                                Math.max(1, Number(e.target.value) || 1)
                              )
                            }))
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsxs10("label", { children: [
                        "Aral\u0131k (dk)",
                        /* @__PURE__ */ jsx10(
                          "input",
                          {
                            type: "number",
                            min: 1,
                            max: 10080,
                            value: form.retryIntervalMinutes,
                            onChange: (e) => setForm((prev) => ({
                              ...prev,
                              retryIntervalMinutes: Math.min(
                                10080,
                                Math.max(1, Number(e.target.value) || 30)
                              )
                            }))
                          }
                        )
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs10("label", { className: "voice-consent", children: [
                      /* @__PURE__ */ jsx10(
                        "input",
                        {
                          type: "checkbox",
                          checked: form.retryOnBusy,
                          onChange: (e) => setForm((prev) => ({ ...prev, retryOnBusy: e.target.checked }))
                        }
                      ),
                      "Me\u015Fgul"
                    ] }),
                    /* @__PURE__ */ jsxs10("label", { className: "voice-consent", children: [
                      /* @__PURE__ */ jsx10(
                        "input",
                        {
                          type: "checkbox",
                          checked: form.retryOnNoAnswer,
                          onChange: (e) => setForm((prev) => ({ ...prev, retryOnNoAnswer: e.target.checked }))
                        }
                      ),
                      "Cevaps\u0131z / timeout"
                    ] }),
                    /* @__PURE__ */ jsxs10("label", { className: "voice-consent", children: [
                      /* @__PURE__ */ jsx10(
                        "input",
                        {
                          type: "checkbox",
                          checked: form.retryOnFailed,
                          onChange: (e) => setForm((prev) => ({ ...prev, retryOnFailed: e.target.checked }))
                        }
                      ),
                      "Di\u011Fer hata"
                    ] })
                  ] }),
                  /* @__PURE__ */ jsx10("small", { className: "directory-section", children: "ARAMA PENCERES\u0130" }),
                  /* @__PURE__ */ jsxs10("label", { className: "voice-consent", children: [
                    /* @__PURE__ */ jsx10(
                      "input",
                      {
                        type: "checkbox",
                        checked: form.scheduleEnabled,
                        onChange: (e) => setForm((prev) => ({ ...prev, scheduleEnabled: e.target.checked }))
                      }
                    ),
                    "Yaln\u0131z se\xE7ili g\xFCn/saatlerde ara"
                  ] }),
                  form.scheduleEnabled && /* @__PURE__ */ jsxs10(Fragment6, { children: [
                    /* @__PURE__ */ jsx10("div", { className: "campaign-day-chips", children: DAY_OPTIONS.map((day) => {
                      const active = form.scheduleDays.includes(day.id);
                      return /* @__PURE__ */ jsx10(
                        "button",
                        {
                          type: "button",
                          className: active ? "directory-secondary-btn active" : "directory-secondary-btn",
                          onClick: () => setForm((prev) => {
                            const set = new Set(prev.scheduleDays);
                            if (set.has(day.id)) set.delete(day.id);
                            else set.add(day.id);
                            const next = [...set].sort();
                            return {
                              ...prev,
                              scheduleDays: next.length > 0 ? next : [day.id]
                            };
                          }),
                          children: day.label
                        },
                        day.id
                      );
                    }) }),
                    /* @__PURE__ */ jsxs10("div", { className: "campaign-contact-actions", children: [
                      /* @__PURE__ */ jsxs10("label", { children: [
                        "Ba\u015Flang\u0131\xE7",
                        /* @__PURE__ */ jsx10(
                          "input",
                          {
                            type: "time",
                            value: form.scheduleTimeStart,
                            onChange: (e) => setForm((prev) => ({
                              ...prev,
                              scheduleTimeStart: e.target.value || "09:00"
                            }))
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsxs10("label", { children: [
                        "Biti\u015F",
                        /* @__PURE__ */ jsx10(
                          "input",
                          {
                            type: "time",
                            value: form.scheduleTimeEnd,
                            onChange: (e) => setForm((prev) => ({
                              ...prev,
                              scheduleTimeEnd: e.target.value || "18:00"
                            }))
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsxs10("label", { children: [
                        "Saat dilimi",
                        /* @__PURE__ */ jsx10(
                          "input",
                          {
                            value: form.scheduleTimezone,
                            onChange: (e) => setForm((prev) => ({
                              ...prev,
                              scheduleTimezone: e.target.value || "Europe/Istanbul"
                            })),
                            placeholder: "Europe/Istanbul"
                          }
                        )
                      ] })
                    ] })
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ jsxs10("div", { className: "directory-form-actions", children: [
                showCreate && createStep > 1 && /* @__PURE__ */ jsx10(
                  "button",
                  {
                    type: "button",
                    className: "directory-secondary-btn",
                    onClick: () => setCreateStep((s) => s === 3 ? 2 : 1),
                    children: "Geri"
                  }
                ),
                showCreate && createStep < 3 && /* @__PURE__ */ jsx10(
                  "button",
                  {
                    type: "button",
                    className: "agentos-btn primary",
                    disabled: createStep === 1 && !canCreateStep1,
                    onClick: () => {
                      if (createStep === 1 && !canCreateStep1) return;
                      setCreateStep((s) => s === 1 ? 2 : 3);
                    },
                    children: "\u0130leri"
                  }
                ),
                (!showCreate || createStep === 3) && /* @__PURE__ */ jsx10("button", { type: "submit", disabled: busy || showCreate && !canCreateStep1, children: showCreate ? "Tasla\u011F\u0131 olu\u015Ftur" : "Kaydet" }),
                !showCreate && selected && /* @__PURE__ */ jsx10(
                  "button",
                  {
                    type: "button",
                    className: "directory-secondary-btn",
                    disabled: busy,
                    onClick: () => void archiveCampaign(),
                    children: "Ar\u015Fivle"
                  }
                )
              ] })
            ]
          }
        ),
        !showCreate && selected && /* @__PURE__ */ jsxs10("div", { className: "campaign-contacts-panel", children: [
          /* @__PURE__ */ jsxs10("div", { className: "campaign-run-steps", "aria-hidden": "true", children: [
            /* @__PURE__ */ jsx10("span", { className: "done", children: "1 Kurulum" }),
            /* @__PURE__ */ jsx10("span", { className: campaignContactTotal > 0 ? "done" : "active", children: "2 Ki\u015Filer" }),
            /* @__PURE__ */ jsx10("span", { className: campaignContactTotal > 0 ? "active" : "", children: "3 Ba\u015Flat" })
          ] }),
          /* @__PURE__ */ jsx10("small", { className: "directory-section", children: "\xC7ALI\u015ETIR" }),
          /* @__PURE__ */ jsxs10("div", { className: "campaign-contact-actions", children: [
            /* @__PURE__ */ jsxs10("label", { children: [
              "Arayan numara",
              phoneNumbers.length > 0 ? /* @__PURE__ */ jsx10(
                "select",
                {
                  value: fromNumberId,
                  onChange: (e) => {
                    const id = e.target.value;
                    setFromNumberId(id);
                    const match = phoneNumbers.find((n) => n.id === id);
                    if (match) setFromNumber(match.e164);
                  },
                  children: phoneNumbers.map((n) => /* @__PURE__ */ jsxs10("option", { value: n.id, children: [
                    n.label || n.e164,
                    " \xB7 ",
                    n.numberClass,
                    " \xB7 ",
                    n.e164
                  ] }, n.id))
                }
              ) : /* @__PURE__ */ jsx10(
                "input",
                {
                  value: fromNumber,
                  onChange: (e) => setFromNumber(e.target.value),
                  placeholder: "+13235405697"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs10("div", { className: "directory-form-actions", children: [
              /* @__PURE__ */ jsx10(
                "button",
                {
                  type: "button",
                  disabled: busy || !fromNumberId && !fromNumber.trim() || campaignContactTotal < 1 || !selected.agentId || selected.status === "completed" || selected.status === "archived",
                  onClick: () => void (async () => {
                    if (!selectedId) return;
                    setBusy(true);
                    setError(void 0);
                    try {
                      const result = await api.start(selectedId, {
                        ...fromNumberId ? { numberId: fromNumberId } : {},
                        ...fromNumber.trim() ? { from: fromNumber.trim() } : {},
                        recordingConsent: true
                      });
                      setSelected(result.campaign);
                      setNotice(result.message);
                      await loadCampaignContacts(selectedId);
                      await load();
                    } catch (cause) {
                      setError(
                        cause instanceof Error ? cause.message : "START_FAILED"
                      );
                    } finally {
                      setBusy(false);
                    }
                  })(),
                  children: selected.status === "running" ? "Devam / s\u0131radaki" : "Ba\u015Flat"
                }
              ),
              /* @__PURE__ */ jsx10(
                "button",
                {
                  type: "button",
                  className: "directory-secondary-btn",
                  disabled: busy || selected.status !== "running",
                  onClick: () => void (async () => {
                    if (!selectedId) return;
                    setBusy(true);
                    try {
                      const updated = await api.pause(selectedId);
                      setSelected(updated);
                      setNotice("Kampanya duraklat\u0131ld\u0131.");
                      await load();
                    } catch (cause) {
                      setError(
                        cause instanceof Error ? cause.message : "PAUSE_FAILED"
                      );
                    } finally {
                      setBusy(false);
                    }
                  })(),
                  children: "Duraklat"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxs10("p", { className: "directory-field-hint", children: [
            "Durum: ",
            /* @__PURE__ */ jsx10("b", { children: selected.status }),
            " \xB7 ba\u015Far\u0131 ",
            selected.successfulCalls,
            " \xB7 hata",
            " ",
            selected.failedCalls,
            " \xB7 ki\u015Fi ",
            campaignContactTotal,
            selected.retry?.enabled ? ` \xB7 retry ${selected.retry.maxAttempts}\xD7/${selected.retry.intervalMinutes}dk` : "",
            selected.schedule?.enabled ? ` \xB7 pencere ${selected.schedule.timeStart}\u2013${selected.schedule.timeEnd} ${selected.schedule.timezone}` : ""
          ] }),
          /* @__PURE__ */ jsxs10("small", { className: "directory-section", children: [
            "K\u0130\u015E\u0130LER (",
            campaignContactTotal,
            ")"
          ] }),
          /* @__PURE__ */ jsx10("p", { className: "directory-field-hint", children: "Rehber / manuel / CSV ekle. Draft iken d\xFCzenle; running iken aran\u0131r." }),
          selected.status === "draft" && /* @__PURE__ */ jsxs10(Fragment6, { children: [
            /* @__PURE__ */ jsxs10("div", { className: "campaign-contact-actions", children: [
              /* @__PURE__ */ jsxs10("label", { children: [
                "Rehberden ekle",
                /* @__PURE__ */ jsxs10(
                  "select",
                  {
                    value: pickContactId,
                    onChange: (e) => setPickContactId(e.target.value),
                    children: [
                      /* @__PURE__ */ jsx10("option", { value: "", children: "\u2014 ki\u015Fi se\xE7 \u2014" }),
                      directoryContacts.map((c) => /* @__PURE__ */ jsxs10("option", { value: c.id, children: [
                        c.displayName,
                        " (",
                        c.phoneE164,
                        ")"
                      ] }, c.id))
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ jsx10(
                "button",
                {
                  type: "button",
                  disabled: busy || !pickContactId,
                  onClick: () => void (async () => {
                    if (!selectedId || !pickContactId) return;
                    setBusy(true);
                    setError(void 0);
                    try {
                      const result = await api.addContacts(selectedId, {
                        contactIds: [pickContactId]
                      });
                      setNotice(
                        `Eklendi: ${result.added}, tekrar: ${result.skippedDuplicate}, ge\xE7ersiz: ${result.skippedInvalid}`
                      );
                      setPickContactId("");
                      await loadCampaignContacts(selectedId);
                      await load();
                      setSelected(
                        (prev) => prev ? { ...prev, totalContacts: result.totalContacts } : prev
                      );
                    } catch (cause) {
                      setError(
                        cause instanceof Error ? cause.message : "ADD_FAILED"
                      );
                    } finally {
                      setBusy(false);
                    }
                  })(),
                  children: "Ekle"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs10("div", { className: "campaign-contact-actions", children: [
              /* @__PURE__ */ jsxs10("label", { children: [
                "Manuel telefon",
                /* @__PURE__ */ jsx10(
                  "input",
                  {
                    value: manualPhone,
                    onChange: (e) => setManualPhone(e.target.value),
                    placeholder: "+905551112233"
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs10("label", { children: [
                "Ad (opsiyonel)",
                /* @__PURE__ */ jsx10(
                  "input",
                  {
                    value: manualName,
                    onChange: (e) => setManualName(e.target.value),
                    placeholder: "Ay\u015Fe"
                  }
                )
              ] }),
              /* @__PURE__ */ jsx10(
                "button",
                {
                  type: "button",
                  disabled: busy || !manualPhone.trim(),
                  onClick: () => void (async () => {
                    if (!selectedId) return;
                    setBusy(true);
                    setError(void 0);
                    try {
                      const result = await api.addContacts(selectedId, {
                        rows: [
                          {
                            phoneE164: manualPhone.trim(),
                            displayName: manualName.trim() || null
                          }
                        ]
                      });
                      setNotice(
                        `Eklendi: ${result.added}, tekrar: ${result.skippedDuplicate}, ge\xE7ersiz: ${result.skippedInvalid}`
                      );
                      setManualPhone("");
                      setManualName("");
                      await loadCampaignContacts(selectedId);
                      await load();
                      setSelected(
                        (prev) => prev ? { ...prev, totalContacts: result.totalContacts } : prev
                      );
                    } catch (cause) {
                      setError(
                        cause instanceof Error ? cause.message : "ADD_FAILED"
                      );
                    } finally {
                      setBusy(false);
                    }
                  })(),
                  children: "Sat\u0131r ekle"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs10("label", { children: [
              "CSV i\xE7e aktar (phone,name)",
              /* @__PURE__ */ jsx10(
                "textarea",
                {
                  rows: 4,
                  value: csvText,
                  onChange: (e) => setCsvText(e.target.value),
                  placeholder: "phone,name\n+905551112233,Ay\u015Fe\n05551112234,Mehmet"
                }
              )
            ] }),
            /* @__PURE__ */ jsx10(
              "button",
              {
                type: "button",
                disabled: busy || !csvText.trim(),
                onClick: () => void (async () => {
                  if (!selectedId) return;
                  setBusy(true);
                  setError(void 0);
                  try {
                    const result = await api.importCsv(selectedId, csvText);
                    setNotice(
                      `CSV: +${result.added} eklendi, ${result.skippedDuplicate} tekrar, ${result.skippedInvalid} ge\xE7ersiz. Toplam ${result.totalContacts}.`
                    );
                    setCsvText("");
                    await loadCampaignContacts(selectedId);
                    await load();
                    setSelected(
                      (prev) => prev ? { ...prev, totalContacts: result.totalContacts } : prev
                    );
                  } catch (cause) {
                    setError(
                      cause instanceof Error ? cause.message : "CSV_FAILED"
                    );
                  } finally {
                    setBusy(false);
                  }
                })(),
                children: "CSV aktar"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs10("div", { className: "call-list directory-list campaign-contact-list", children: [
            campaignContacts.length === 0 && /* @__PURE__ */ jsxs10("div", { className: "studio-inline-empty compact", children: [
              /* @__PURE__ */ jsx10("strong", { children: "Bu kampanyada ki\u015Fi yok" }),
              /* @__PURE__ */ jsx10("p", { children: "Rehberden ekleyin veya CSV / manuel sat\u0131r ile y\xFCkleyin; sonra aramay\u0131 ba\u015Flat\u0131n." })
            ] }),
            campaignContacts.map((row) => /* @__PURE__ */ jsxs10("div", { className: "campaign-contact-row", children: [
              /* @__PURE__ */ jsxs10("span", { children: [
                /* @__PURE__ */ jsx10("strong", { children: row.displayName || "\u2014" }),
                /* @__PURE__ */ jsx10("small", { children: row.phoneE164 }),
                /* @__PURE__ */ jsxs10("small", { children: [
                  row.status,
                  row.attempts > 0 ? ` \xB7 deneme ${row.attempts}` : "",
                  row.nextAttemptAt ? ` \xB7 sonraki ${new Date(row.nextAttemptAt).toLocaleString()}` : "",
                  row.contactId ? " \xB7 rehber" : " \xB7 csv/manuel"
                ] })
              ] }),
              selected.status === "draft" && /* @__PURE__ */ jsx10(
                "button",
                {
                  type: "button",
                  className: "directory-secondary-btn",
                  disabled: busy,
                  onClick: () => void (async () => {
                    if (!selectedId) return;
                    setBusy(true);
                    try {
                      const result = await api.removeContact(selectedId, row.id);
                      setNotice("Ki\u015Fi \xE7\u0131kar\u0131ld\u0131.");
                      await loadCampaignContacts(selectedId);
                      await load();
                      setSelected(
                        (prev) => prev ? { ...prev, totalContacts: result.totalContacts } : prev
                      );
                    } catch (cause) {
                      setError(
                        cause instanceof Error ? cause.message : "REMOVE_FAILED"
                      );
                    } finally {
                      setBusy(false);
                    }
                  })(),
                  children: "\xC7\u0131kar"
                }
              )
            ] }, row.id))
          ] })
        ] })
      ] })
    ] })
  ] });
};
var purposeLabel3 = (purpose) => purposes2.find((item) => item.id === purpose)?.label ?? purpose;
var DAY_OPTIONS = [
  { id: 1, label: "Pzt" },
  { id: 2, label: "Sal" },
  { id: 3, label: "\xC7ar" },
  { id: 4, label: "Per" },
  { id: 5, label: "Cum" },
  { id: 6, label: "Cmt" },
  { id: 0, label: "Paz" }
];

// src/provider.tsx
import { useEffect as useEffect9, useState as useState10 } from "react";
import {
  providerAccountListSchema,
  providerAccountViewSchema,
  providerHealthViewSchema,
  reconcileProvidersResponseSchema,
  routingPolicyViewSchema
} from "@agentos/contracts";
import { jsx as jsx11, jsxs as jsxs11 } from "react/jsx-runtime";
var json = async (response) => {
  if (!response.ok) throw new Error(`PROVIDER_API_${response.status}`);
  return response.json();
};
var formText = (data, key) => {
  const value = data.get(key);
  if (typeof value !== "string") throw new Error(`PROVIDER_FORM_${key.toUpperCase()}_REQUIRED`);
  return value;
};
var createProviderApi = (baseUrl, token) => {
  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
  return {
    list: async (workspaceId) => providerAccountListSchema.parse(
      await json(
        await fetch(
          `${baseUrl}/v1/providers/accounts?workspaceId=${encodeURIComponent(workspaceId)}`,
          { headers }
        )
      )
    ).items,
    create: async (input) => providerAccountViewSchema.parse(
      await json(
        await fetch(`${baseUrl}/v1/providers/accounts`, {
          method: "POST",
          headers,
          body: JSON.stringify(input)
        })
      )
    ),
    route: async (input) => void routingPolicyViewSchema.parse(
      await json(
        await fetch(`${baseUrl}/v1/providers/routing-policies`, {
          method: "PUT",
          headers,
          body: JSON.stringify(input)
        })
      )
    ),
    health: async (workspaceId) => providerHealthViewSchema.array().parse(
      await json(
        await fetch(
          `${baseUrl}/v1/providers/health?workspaceId=${encodeURIComponent(workspaceId)}`,
          { headers }
        )
      )
    ),
    reconcile: async (workspaceId) => reconcileProvidersResponseSchema.parse(
      await json(
        await fetch(`${baseUrl}/v1/providers/reconcile`, {
          method: "POST",
          headers,
          body: JSON.stringify({ workspaceId })
        })
      )
    ).runId
  };
};
var ProviderStudioPage = ({
  api,
  locale: _locale,
  workspaceId
}) => {
  const [accounts, setAccounts] = useState10([]);
  const [health, setHealth] = useState10([]);
  const [message3, setMessage] = useState10("");
  const refresh = async () => {
    setAccounts(await api.list(workspaceId));
    setHealth(await api.health(workspaceId));
  };
  useEffect9(() => {
    void refresh();
  }, [api, workspaceId]);
  const create = async (event) => {
    event.preventDefault();
    const d = new FormData(event.currentTarget);
    await api.create({
      workspaceId,
      providerKey: formText(d, "providerKey"),
      displayName: formText(d, "displayName"),
      capabilities: [formText(d, "capability")],
      secretRef: formText(d, "secretRef"),
      region: formText(d, "region"),
      locales: [formText(d, "locale")],
      countries: [],
      priority: 50,
      fallbackEligible: true
    });
    event.currentTarget.reset();
    setMessage("Sa\u011Flay\u0131c\u0131 hesab\u0131 kaydedildi.");
    await refresh();
  };
  const route = async (event) => {
    event.preventDefault();
    const d = new FormData(event.currentTarget);
    await api.route({
      workspaceId,
      capability: formText(d, "capability"),
      primaryProviderAccountId: formText(d, "primary"),
      fallbackProviderAccountIds: formText(d, "fallback") ? [formText(d, "fallback")] : [],
      locale: "tr-TR",
      dataRegion: formText(d, "region"),
      quality: "standard",
      timeoutMs: 8e3,
      maxAttempts: 2,
      circuitFailureThreshold: 3,
      circuitCooldownSeconds: 30,
      expectedVersion: null
    });
    setMessage("Y\xF6nlendirme politikas\u0131 etkinle\u015Ftirildi.");
  };
  return /* @__PURE__ */ jsxs11("section", { className: "agentos-panels", children: [
    /* @__PURE__ */ jsxs11("article", { className: "agentos-panel", children: [
      /* @__PURE__ */ jsxs11("div", { className: "agentos-panel-head", children: [
        /* @__PURE__ */ jsxs11("div", { children: [
          /* @__PURE__ */ jsx11("small", { children: "SA\u011ELAYICI KAYDI" }),
          /* @__PURE__ */ jsx11("h3", { children: "Hesaplar ve sa\u011Fl\u0131k durumu" })
        ] }),
        /* @__PURE__ */ jsx11("button", { type: "button", onClick: () => void api.reconcile(workspaceId).then(refresh), children: "E\u015Fitle" })
      ] }),
      /* @__PURE__ */ jsx11("div", { children: accounts.map((a) => /* @__PURE__ */ jsxs11("div", { className: "provider-row", children: [
        /* @__PURE__ */ jsxs11("span", { children: [
          /* @__PURE__ */ jsx11("strong", { children: a.displayName }),
          /* @__PURE__ */ jsxs11("small", { children: [
            a.providerKey,
            " \xB7 ",
            a.capabilities.join(", ")
          ] })
        ] }),
        /* @__PURE__ */ jsx11("em", { children: health.find((h) => h.providerAccountId === a.id)?.health ?? a.health })
      ] }, a.id)) }),
      /* @__PURE__ */ jsxs11("form", { onSubmit: (e) => void create(e), className: "provider-form", children: [
        /* @__PURE__ */ jsx11("input", { name: "displayName", placeholder: "G\xF6r\xFCnen ad", required: true }),
        /* @__PURE__ */ jsx11("input", { name: "providerKey", placeholder: "Adapt\xF6r anahtar\u0131", required: true }),
        /* @__PURE__ */ jsxs11("select", { name: "capability", children: [
          /* @__PURE__ */ jsx11("option", { children: "llm" }),
          /* @__PURE__ */ jsx11("option", { children: "stt" }),
          /* @__PURE__ */ jsx11("option", { children: "tts" }),
          /* @__PURE__ */ jsx11("option", { children: "telephony" })
        ] }),
        /* @__PURE__ */ jsx11("input", { name: "secretRef", placeholder: "vault://secret/reference", required: true }),
        /* @__PURE__ */ jsx11("input", { name: "region", defaultValue: "eu", required: true }),
        /* @__PURE__ */ jsx11("input", { name: "locale", defaultValue: "tr-TR", required: true }),
        /* @__PURE__ */ jsx11("button", { type: "submit", children: "Kaydet" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs11("article", { className: "agentos-panel", children: [
      /* @__PURE__ */ jsx11("div", { className: "agentos-panel-head", children: /* @__PURE__ */ jsxs11("div", { children: [
        /* @__PURE__ */ jsx11("small", { children: "DAYANIKLI Y\xD6NLEND\u0130RME" }),
        /* @__PURE__ */ jsx11("h3", { children: "Birincil ve yedek" })
      ] }) }),
      /* @__PURE__ */ jsxs11("form", { onSubmit: (e) => void route(e), className: "provider-form", children: [
        /* @__PURE__ */ jsxs11("select", { name: "capability", children: [
          /* @__PURE__ */ jsx11("option", { children: "llm" }),
          /* @__PURE__ */ jsx11("option", { children: "stt" }),
          /* @__PURE__ */ jsx11("option", { children: "tts" }),
          /* @__PURE__ */ jsx11("option", { children: "telephony" })
        ] }),
        /* @__PURE__ */ jsxs11("select", { name: "primary", required: true, children: [
          /* @__PURE__ */ jsx11("option", { value: "", children: "Birincil" }),
          accounts.map((a) => /* @__PURE__ */ jsx11("option", { value: a.id, children: a.displayName }, a.id))
        ] }),
        /* @__PURE__ */ jsxs11("select", { name: "fallback", children: [
          /* @__PURE__ */ jsx11("option", { value: "", children: "Yedek yok" }),
          accounts.map((a) => /* @__PURE__ */ jsx11("option", { value: a.id, children: a.displayName }, a.id))
        ] }),
        /* @__PURE__ */ jsx11("input", { name: "region", defaultValue: "eu", required: true }),
        /* @__PURE__ */ jsx11("button", { type: "submit", children: "Rotay\u0131 kaydet" })
      ] }),
      message3 && /* @__PURE__ */ jsx11("p", { children: message3 })
    ] }),
    /* @__PURE__ */ jsx11("style", { children: `.provider-form{display:grid;gap:9px;margin-top:18px}.provider-form input,.provider-form select,.provider-form button{padding:10px;border-radius:9px;border:1px solid #30394a;background:#0b0f17;color:#eef}.provider-row{display:flex;justify-content:space-between;padding:12px;border-bottom:1px solid #252b37}.provider-row span{display:grid}.provider-row small{color:#8d97aa}.provider-row em{color:#72e0a1}` })
  ] });
};

// src/operations.tsx
import { useCallback as useCallback10, useEffect as useEffect10, useState as useState11 } from "react";
import {
  connectorInvocationViewSchema as connectorInvocationViewSchema2,
  connectorListSchema,
  connectorViewSchema,
  omnichannelTurnResponseSchema,
  workflowRunListSchema,
  workflowRunViewSchema
} from "@agentos/contracts";
import { jsx as jsx12, jsxs as jsxs12 } from "react/jsx-runtime";
var createOperationsApi = (baseUrl, token) => {
  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
  const request = async (path, init) => {
    const response = await fetch(`${baseUrl}${path}`, {
      ...init,
      headers,
      signal: AbortSignal.timeout(12e3)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.code ?? `HTTP_${response.status}`);
    }
    return response.json();
  };
  return {
    turn: async (input) => omnichannelTurnResponseSchema.parse(
      await request("/v1/channels/turns", { method: "POST", body: JSON.stringify(input) })
    ),
    runs: async (workspaceId) => workflowRunListSchema.parse(
      await request(`/v1/workflows/runs?workspaceId=${encodeURIComponent(workspaceId)}`)
    ).items,
    replay: async (runId) => workflowRunViewSchema.parse(
      await request(`/v1/workflows/runs/${encodeURIComponent(runId)}/replay`, { method: "POST" })
    ),
    connectors: async (workspaceId) => connectorListSchema.parse(
      await request(`/v1/connectors?workspaceId=${encodeURIComponent(workspaceId)}`)
    ).items,
    createConnector: async (input) => connectorViewSchema.parse(
      await request("/v1/connectors", { method: "POST", body: JSON.stringify(input) })
    ),
    invokeConnector: async (connectorId, input) => connectorInvocationViewSchema2.parse(
      await request(`/v1/connectors/${encodeURIComponent(connectorId)}/invoke`, {
        method: "POST",
        body: JSON.stringify(input)
      })
    )
  };
};
var formText2 = (data, key) => {
  const value = data.get(key);
  if (typeof value !== "string") throw new Error(`FORM_${key.toUpperCase()}_REQUIRED`);
  return value;
};
var OperationsStudioPage = ({
  api,
  agents,
  locale: _locale,
  workspaceId,
  onOpenIntegrations
}) => {
  const [agentOptions, setAgentOptions] = useState11([]);
  const [connectors, setConnectors] = useState11([]);
  const [runs, setRuns] = useState11([]);
  const [notice, setNotice] = useState11("");
  const refresh = useCallback10(async () => {
    const [agentPage, connectorPage, runPage] = await Promise.all([
      agents.list(workspaceId),
      api.connectors(workspaceId),
      api.runs(workspaceId)
    ]);
    setAgentOptions(agentPage.items.map(({ id, name }) => ({ id, name })));
    setConnectors(connectorPage);
    setRuns(runPage);
  }, [agents, api, workspaceId]);
  useEffect10(() => {
    void refresh();
  }, [refresh]);
  const send = async (event) => {
    event.preventDefault();
    const d = new FormData(event.currentTarget);
    const connectorId = formText2(d, "connectorId");
    const connector = connectors.find((item) => item.id === connectorId);
    const action2 = connector ? {
      connectorId,
      operation: connector.operations[0]?.name,
      idempotencyKey: crypto.randomUUID(),
      input: { source: "operations-studio" }
    } : void 0;
    const result = await api.turn({
      workspaceId,
      agentId: formText2(d, "agentId"),
      channel: formText2(d, "channel"),
      externalConversationId: formText2(d, "thread"),
      recipientRef: formText2(d, "recipient"),
      clientMessageId: crypto.randomUUID(),
      content: formText2(d, "content"),
      action: action2
    });
    setNotice(`Teslim edildi: ${result.workflow.status}`);
    await refresh();
  };
  const create = async (event) => {
    event.preventDefault();
    const d = new FormData(event.currentTarget);
    await api.createConnector({
      workspaceId,
      name: formText2(d, "name"),
      baseUrl: formText2(d, "baseUrl"),
      secretRef: formText2(d, "secretRef"),
      operations: [{ name: formText2(d, "operation"), method: "POST", path: formText2(d, "path") }],
      timeoutMs: 5e3
    });
    event.currentTarget.reset();
    setNotice("Connector kaydedildi.");
    await refresh();
  };
  const invokeApi = {
    invokeConnector: (connectorId, input) => api.invokeConnector(connectorId, input)
  };
  return /* @__PURE__ */ jsxs12("section", { className: "agentos-panels", children: [
    /* @__PURE__ */ jsx12(
      WhatsAppConnectorStatusPanel,
      {
        connectors,
        invokeApi,
        ...onOpenIntegrations ? { onNavigateIntegrations: onOpenIntegrations } : {},
        title: "WhatsApp connector durumu"
      }
    ),
    /* @__PURE__ */ jsxs12("article", { className: "agentos-panel", children: [
      /* @__PURE__ */ jsx12("div", { className: "agentos-panel-head", children: /* @__PURE__ */ jsxs12("div", { children: [
        /* @__PURE__ */ jsx12("small", { children: "\xC7OKLU KANAL" }),
        /* @__PURE__ */ jsx12("h3", { children: "Bilgiye dayal\u0131 kanal d\xF6n\xFC\u015F\xFC" })
      ] }) }),
      /* @__PURE__ */ jsxs12("form", { className: "ops-form", onSubmit: (e) => void send(e), children: [
        /* @__PURE__ */ jsxs12("select", { name: "agentId", required: true, children: [
          /* @__PURE__ */ jsx12("option", { value: "", children: "Yay\u0131nlanm\u0131\u015F ajan" }),
          agentOptions.map((a) => /* @__PURE__ */ jsx12("option", { value: a.id, children: a.name }, a.id))
        ] }),
        /* @__PURE__ */ jsxs12("select", { name: "channel", children: [
          /* @__PURE__ */ jsx12("option", { children: "messaging" }),
          /* @__PURE__ */ jsx12("option", { children: "email" }),
          /* @__PURE__ */ jsx12("option", { children: "sms" })
        ] }),
        /* @__PURE__ */ jsx12("input", { name: "thread", placeholder: "Harici konu\u015Fma referans\u0131", required: true }),
        /* @__PURE__ */ jsx12("input", { name: "recipient", placeholder: "Al\u0131c\u0131 referans\u0131", required: true }),
        /* @__PURE__ */ jsx12("textarea", { name: "content", placeholder: "Gelen mesaj", required: true }),
        /* @__PURE__ */ jsxs12("select", { name: "connectorId", children: [
          /* @__PURE__ */ jsx12("option", { value: "", children: "Aksiyon yok" }),
          connectors.map((c) => /* @__PURE__ */ jsxs12("option", { value: c.id, children: [
            c.name,
            ": ",
            c.operations[0]?.name
          ] }, c.id))
        ] }),
        /* @__PURE__ */ jsx12("button", { type: "submit", children: "\xC7al\u0131\u015Ft\u0131r ve teslim et" })
      ] }),
      notice && /* @__PURE__ */ jsx12("p", { children: notice })
    ] }),
    /* @__PURE__ */ jsxs12("article", { className: "agentos-panel", children: [
      /* @__PURE__ */ jsx12("div", { className: "agentos-panel-head", children: /* @__PURE__ */ jsxs12("div", { children: [
        /* @__PURE__ */ jsx12("small", { children: "DAYANIKLI \u0130\u015E AKI\u015ELARI" }),
        /* @__PURE__ */ jsx12("h3", { children: "Ge\xE7mi\u015F ve hata kuyru\u011Fu" })
      ] }) }),
      runs.map((run) => /* @__PURE__ */ jsxs12("div", { className: "ops-row", children: [
        /* @__PURE__ */ jsxs12("span", { children: [
          /* @__PURE__ */ jsx12("strong", { children: run.channel }),
          /* @__PURE__ */ jsxs12("small", { children: [
            run.id,
            " \xB7 deneme ",
            run.attemptCount,
            "/",
            run.maxAttempts
          ] })
        ] }),
        /* @__PURE__ */ jsx12("em", { children: run.status }),
        run.status === "dead_letter" && /* @__PURE__ */ jsx12("button", { type: "button", onClick: () => void api.replay(run.id).then(refresh), children: "Tekrar \xE7al\u0131\u015Ft\u0131r" })
      ] }, run.id)),
      /* @__PURE__ */ jsxs12("form", { className: "ops-form", onSubmit: (e) => void create(e), children: [
        /* @__PURE__ */ jsx12("h4", { children: "Connector kaydet" }),
        /* @__PURE__ */ jsx12("input", { name: "name", placeholder: "Connector ad\u0131", required: true }),
        /* @__PURE__ */ jsx12("input", { name: "baseUrl", placeholder: "https://crm.example.com/", required: true }),
        /* @__PURE__ */ jsx12("input", { name: "secretRef", placeholder: "vault://secret/reference", required: true }),
        /* @__PURE__ */ jsx12("input", { name: "operation", placeholder: "create_case", required: true }),
        /* @__PURE__ */ jsx12("input", { name: "path", placeholder: "/cases", required: true }),
        /* @__PURE__ */ jsx12("button", { type: "submit", children: "Kaydet" })
      ] })
    ] }),
    /* @__PURE__ */ jsx12("style", { children: `.ops-form{display:grid;gap:9px}.ops-form input,.ops-form select,.ops-form textarea,.ops-form button{padding:10px;border-radius:9px;border:1px solid #30394a;background:#0b0f17;color:#eef}.ops-row{display:grid;grid-template-columns:1fr auto auto;gap:10px;padding:12px;border-bottom:1px solid #252b37}.ops-row span{display:grid}.ops-row small{color:#8d97aa}.ops-row em{color:#72e0a1}` })
  ] });
};

// src/intelligence.tsx
import { useCallback as useCallback11, useEffect as useEffect11, useState as useState12 } from "react";
import {
  analysisJobViewSchema,
  conversationAnalysisListSchema,
  intelligenceDashboardSchema,
  recommendationListSchema,
  recommendationViewSchema
} from "@agentos/contracts";
import { Fragment as Fragment7, jsx as jsx13, jsxs as jsxs13 } from "react/jsx-runtime";
var createIntelligenceApi = (baseUrl, token) => {
  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
  const request = async (path, init) => {
    const response = await fetch(`${baseUrl}${path}`, {
      ...init,
      headers,
      signal: AbortSignal.timeout(12e3)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.code ?? `HTTP_${response.status}`);
    }
    return response.json();
  };
  return {
    dashboard: async (workspaceId) => intelligenceDashboardSchema.parse(
      await request(`/v1/intelligence/dashboard?workspaceId=${encodeURIComponent(workspaceId)}`)
    ),
    analyses: async (workspaceId) => conversationAnalysisListSchema.parse(
      await request(`/v1/intelligence/analyses?workspaceId=${encodeURIComponent(workspaceId)}`)
    ).items,
    recommendations: async (workspaceId) => recommendationListSchema.parse(
      await request(
        `/v1/intelligence/recommendations?workspaceId=${encodeURIComponent(workspaceId)}`
      )
    ).items,
    analyze: async (conversationId, workspaceId) => {
      analysisJobViewSchema.parse(
        await request(
          `/v1/intelligence/conversations/${encodeURIComponent(conversationId)}/analyze`,
          {
            method: "POST",
            body: JSON.stringify({ workspaceId, idempotencyKey: crypto.randomUUID() })
          }
        )
      );
    },
    review: async (recommendationId, input) => recommendationViewSchema.parse(
      await request(
        `/v1/intelligence/recommendations/${encodeURIComponent(recommendationId)}/review`,
        { method: "POST", body: JSON.stringify(input) }
      )
    )
  };
};
var IntelligenceStudioPage = ({
  api,
  locale: _locale,
  workspaceId
}) => {
  const [dashboard, setDashboard] = useState12();
  const [analyses, setAnalyses] = useState12([]);
  const [recommendations, setRecommendations] = useState12([]);
  const [notice, setNotice] = useState12("");
  const refresh = useCallback11(async () => {
    const [d, a, r] = await Promise.all([
      api.dashboard(workspaceId),
      api.analyses(workspaceId),
      api.recommendations(workspaceId)
    ]);
    setDashboard(d);
    setAnalyses(a);
    setRecommendations(r);
  }, [api, workspaceId]);
  useEffect11(() => {
    void refresh();
  }, [refresh]);
  const analyze = async (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const conversationId = form.get("conversationId");
    if (typeof conversationId !== "string" || !conversationId) return;
    await api.analyze(conversationId, workspaceId);
    setNotice("Analiz tamamland\u0131 veya kuyru\u011Fa al\u0131nd\u0131.");
    event.currentTarget.reset();
    await refresh();
  };
  const review = async (recommendation, decision, content) => {
    await api.review(recommendation.id, {
      decision,
      expectedVersion: recommendation.version,
      ...decision === "accept" && recommendation.type === "missing_knowledge" && content ? { approvedContent: content } : {}
    });
    setNotice(
      decision === "accept" ? "\xD6neri Brain inceleme kuyru\u011Funa kabul edildi." : "\xD6neri reddedildi."
    );
    await refresh();
  };
  return /* @__PURE__ */ jsxs13("section", { className: "intel-stack", children: [
    /* @__PURE__ */ jsxs13("div", { className: "agentos-grid", "aria-label": "Intelligence metrics", children: [
      /* @__PURE__ */ jsx13(Metric, { label: "Analiz edilen", value: dashboard?.analyzedConversations ?? 0 }),
      /* @__PURE__ */ jsx13(Metric, { label: "Kalite", value: dashboard?.averageQualityScore ?? 0 }),
      /* @__PURE__ */ jsx13(
        Metric,
        {
          label: "D\xF6n\xFC\u015F\xFCm",
          value: `${Math.round((dashboard?.conversionRate ?? 0) * 100)}%`
        }
      ),
      /* @__PURE__ */ jsx13(Metric, { label: "\u0130nceleme kuyru\u011Fu", value: dashboard?.pendingRecommendations ?? 0 })
    ] }),
    /* @__PURE__ */ jsxs13("section", { className: "agentos-panels", children: [
      /* @__PURE__ */ jsxs13("article", { className: "agentos-panel", children: [
        /* @__PURE__ */ jsx13("div", { className: "agentos-panel-head", children: /* @__PURE__ */ jsxs13("div", { children: [
          /* @__PURE__ */ jsx13("small", { children: "KANIT AKI\u015EI" }),
          /* @__PURE__ */ jsx13("h3", { children: "Konu\u015Fmay\u0131 analiz et" })
        ] }) }),
        /* @__PURE__ */ jsxs13("form", { className: "intel-form", onSubmit: (event) => void analyze(event), children: [
          /* @__PURE__ */ jsx13("input", { name: "conversationId", placeholder: "Konu\u015Fma ID", required: true }),
          /* @__PURE__ */ jsx13("button", { type: "submit", children: "Analizi \xE7al\u0131\u015Ft\u0131r" })
        ] }),
        notice && /* @__PURE__ */ jsx13("p", { className: "intel-notice", children: notice }),
        /* @__PURE__ */ jsx13("h4", { children: "Son analizler" }),
        analyses.map((analysis) => /* @__PURE__ */ jsxs13("div", { className: "intel-analysis", children: [
          /* @__PURE__ */ jsxs13("span", { children: [
            /* @__PURE__ */ jsx13("strong", { children: analysis.intent }),
            /* @__PURE__ */ jsxs13("small", { children: [
              analysis.channel,
              " \xB7 ",
              analysis.outcome.type
            ] })
          ] }),
          /* @__PURE__ */ jsxs13("em", { children: [
            analysis.scorecard.total,
            "/100"
          ] }),
          /* @__PURE__ */ jsx13("p", { children: analysis.summary }),
          /* @__PURE__ */ jsxs13("details", { children: [
            /* @__PURE__ */ jsxs13("summary", { children: [
              "Kan\u0131t (",
              analysis.evidence.length,
              ")"
            ] }),
            analysis.evidence.map((item) => /* @__PURE__ */ jsxs13("blockquote", { children: [
              /* @__PURE__ */ jsx13("b", { children: item.claim }),
              " \u2014 ",
              item.excerpt
            ] }, `${item.claim}:${item.messageId}`))
          ] })
        ] }, analysis.id))
      ] }),
      /* @__PURE__ */ jsxs13("article", { className: "agentos-panel", children: [
        /* @__PURE__ */ jsxs13("div", { className: "agentos-panel-head", children: [
          /* @__PURE__ */ jsxs13("div", { children: [
            /* @__PURE__ */ jsx13("small", { children: "\u0130NSAN ONAYI" }),
            /* @__PURE__ */ jsx13("h3", { children: "\xD6neriler" })
          ] }),
          /* @__PURE__ */ jsxs13("span", { children: [
            recommendations.filter((item) => item.status === "detected").length,
            " bekliyor"
          ] })
        ] }),
        recommendations.map((recommendation) => /* @__PURE__ */ jsxs13(
          "form",
          {
            className: "intel-rec",
            onSubmit: (event) => {
              event.preventDefault();
              const value = new FormData(event.currentTarget).get("approvedContent");
              void review(
                recommendation,
                "accept",
                typeof value === "string" ? value : void 0
              );
            },
            children: [
              /* @__PURE__ */ jsxs13("div", { children: [
                /* @__PURE__ */ jsx13("strong", { children: recommendation.title }),
                /* @__PURE__ */ jsxs13("small", { children: [
                  recommendation.type,
                  " \xB7 v",
                  recommendation.version
                ] })
              ] }),
              /* @__PURE__ */ jsx13("p", { children: recommendation.rationale }),
              recommendation.evidence.map((item) => /* @__PURE__ */ jsx13("blockquote", { children: item.excerpt }, item.messageId)),
              recommendation.status === "detected" && /* @__PURE__ */ jsxs13(Fragment7, { children: [
                recommendation.type === "missing_knowledge" && /* @__PURE__ */ jsx13(
                  "textarea",
                  {
                    name: "approvedContent",
                    minLength: 10,
                    placeholder: "Brain incelemesi i\xE7in do\u011Frulanm\u0131\u015F SSS cevab\u0131n\u0131 girin",
                    required: true
                  }
                ),
                /* @__PURE__ */ jsxs13("div", { className: "intel-actions", children: [
                  /* @__PURE__ */ jsx13("button", { type: "submit", children: "Kabul et" }),
                  /* @__PURE__ */ jsx13("button", { type: "button", onClick: () => void review(recommendation, "reject"), children: "Reddet" })
                ] })
              ] }),
              recommendation.brainProposal && /* @__PURE__ */ jsxs13("small", { children: [
                "Brain \xF6nerisi: ",
                recommendation.brainProposal.knowledgeItemId
              ] })
            ]
          },
          recommendation.id
        ))
      ] })
    ] }),
    /* @__PURE__ */ jsx13("style", { children: `.intel-stack{display:grid;gap:18px}.intel-form{display:flex;gap:8px}.intel-form input,.intel-form button,.intel-rec textarea,.intel-actions button{padding:10px;border-radius:9px;border:1px solid #30394a;background:#0b0f17;color:#eef}.intel-form input{flex:1}.intel-analysis,.intel-rec{padding:13px;border-bottom:1px solid #252b37}.intel-analysis span,.intel-rec>div:first-child{display:grid}.intel-analysis small,.intel-rec small{color:#8d97aa}.intel-analysis em{float:right;color:#72e0a1}.intel-analysis p,.intel-rec p{color:#b3bbc9}.intel-rec textarea{width:100%;min-height:80px}.intel-actions{display:flex;gap:8px;margin-top:8px}.intel-notice{color:#72e0a1}blockquote{margin:8px 0;padding:8px 10px;border-left:2px solid #6657e8;color:#9da7b8;background:#0c1119}` })
  ] });
};
var Metric = ({
  label,
  value
}) => /* @__PURE__ */ jsxs13("article", { className: "agentos-metric violet", children: [
  /* @__PURE__ */ jsx13("small", { children: label }),
  /* @__PURE__ */ jsx13("strong", { children: value }),
  /* @__PURE__ */ jsx13("span", { children: "Workspace kapsaml\u0131" })
] });

// src/performance.tsx
import { useCallback as useCallback13, useEffect as useEffect13, useMemo as useMemo8, useState as useState14 } from "react";
import {
  voicePerformanceDashboardSchema
} from "@agentos/contracts";

// src/billing.tsx
import { useCallback as useCallback12, useEffect as useEffect12, useMemo as useMemo7, useState as useState13 } from "react";
import {
  billingSummarySchema,
  billingUsageDashboardSchema,
  dataLifecycleRequestListSchema,
  dataLifecycleRequestViewSchema,
  retentionPolicyViewSchema,
  subscriptionViewSchema
} from "@agentos/contracts";
import { Fragment as Fragment8, jsx as jsx14, jsxs as jsxs14 } from "react/jsx-runtime";
var CURRENCY_STORAGE_KEY = "centeros.cost.currency";
var readDisplayCurrency = () => {
  try {
    const raw = localStorage.getItem(CURRENCY_STORAGE_KEY);
    if (raw === "USD" || raw === "TRY") return raw;
  } catch {
  }
  return "TRY";
};
var writeDisplayCurrency = (value) => {
  try {
    localStorage.setItem(CURRENCY_STORAGE_KEY, value);
  } catch {
  }
};
var formatMoneyDual = (money, currency) => {
  const minor = money ? currency === "TRY" ? money.tryMinor : money.usdMinor : 0;
  const major = minor / 100;
  if (currency === "TRY") {
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(major);
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(major);
};
var formatBps = (bps) => `${((Number.isFinite(bps) ? Number(bps) : 0) / 100).toFixed(1)}%`;
var SERVICE_LABELS = {
  voice: "Ses (platform)",
  telephony: "Telefoni",
  stt: "STT",
  tts: "TTS",
  llm: "LLM",
  messaging: "Mesaj",
  storage: "Depolama",
  other: "Di\u011Fer"
};
var serviceLabel = (service) => SERVICE_LABELS[service] ?? service;
var dayActivity = (day, currency) => {
  const retail = day.estimatedRetailCharge ?? day.estimatedCost;
  const cost = currency === "TRY" ? retail.tryMinor : retail.usdMinor;
  if (cost > 0) return cost;
  return day.talkSeconds + day.telephonyMinutes * 60 + day.calls * 30;
};
var hasDaySignal = (day) => day.calls > 0 || day.talkSeconds > 0 || day.telephonyMinutes > 0 || (day.estimatedRetailCharge?.tryMinor ?? 0) > 0 || (day.estimatedRetailCharge?.usdMinor ?? 0) > 0 || day.estimatedCost.tryMinor > 0 || day.estimatedCost.usdMinor > 0;
var formatDayShort = (isoDate) => {
  const parts = isoDate.split("-");
  if (parts.length === 3) return `${parts[1]}-${parts[2]}`;
  return isoDate.slice(5);
};
var BillingEmptyState = ({
  title,
  body
}) => /* @__PURE__ */ jsxs14("div", { className: "cost-empty", role: "status", children: [
  /* @__PURE__ */ jsx14("div", { className: "cost-empty-icon", "aria-hidden": true, children: "\u25AD" }),
  /* @__PURE__ */ jsx14("strong", { children: title }),
  /* @__PURE__ */ jsx14("p", { children: body })
] });
var CostColumnChart = ({
  days,
  currency
}) => {
  const maxActivity = Math.max(1, ...days.map((d) => dayActivity(d, currency)));
  const dense = days.length > 14;
  const labelEvery = days.length <= 7 ? 1 : days.length <= 31 ? 5 : 10;
  return /* @__PURE__ */ jsxs14("div", { className: `cost-col-chart${dense ? " is-dense" : ""}`, role: "img", "aria-label": "G\xFCnl\xFCk sat\u0131\u015F", children: [
    /* @__PURE__ */ jsx14("div", { className: "cost-col-plot", children: days.map((day, index) => {
      const retail = day.estimatedRetailCharge ?? day.estimatedCost;
      const wholesale = day.estimatedWholesaleCost ?? day.estimatedCost;
      const costMinor = currency === "TRY" ? retail.tryMinor : retail.usdMinor;
      const activity = dayActivity(day, currency);
      const pct2 = Math.max(0, Math.min(100, activity / maxActivity * 100));
      const active = hasDaySignal(day);
      const showLabel = index === 0 || index === days.length - 1 || index % labelEvery === 0;
      return /* @__PURE__ */ jsxs14(
        "div",
        {
          className: `cost-col${active ? " is-active" : " is-idle"}`,
          title: `${day.date} \xB7 sat\u0131\u015F ${formatMoneyDual(retail, currency)} \xB7 maliyet ${formatMoneyDual(wholesale, currency)} \xB7 ${Math.round(day.talkSeconds / 60)} dk \xB7 ${day.calls} arama`,
          children: [
            /* @__PURE__ */ jsx14("div", { className: "cost-col-bar-wrap", children: /* @__PURE__ */ jsx14(
              "span",
              {
                className: "cost-col-bar",
                style: { height: active ? `${Math.max(pct2, 6)}%` : "2px" }
              }
            ) }),
            showLabel ? /* @__PURE__ */ jsx14("span", { className: "cost-col-label", children: formatDayShort(day.date) }) : /* @__PURE__ */ jsx14("span", { className: "cost-col-label is-spacer", "aria-hidden": true, children: "\xB7" }),
            !dense && active ? /* @__PURE__ */ jsx14("span", { className: "cost-col-value", children: costMinor > 0 ? formatMoneyDual(retail, currency) : `${Math.round(day.talkSeconds / 60)}dk` }) : null
          ]
        },
        day.date
      );
    }) }),
    /* @__PURE__ */ jsxs14("div", { className: "cost-col-legend", children: [
      /* @__PURE__ */ jsx14("span", { children: "Y\xFCkseklik: tahmini sat\u0131\u015F (yoksa konu\u015Fma aktivitesi)" }),
      /* @__PURE__ */ jsxs14("span", { children: [
        "Toplam arama:",
        " ",
        /* @__PURE__ */ jsx14("b", { children: days.reduce((sum, d) => sum + d.calls, 0) })
      ] })
    ] })
  ] });
};
var createBillingApi = (baseUrl, token) => {
  const request = async (path, init) => {
    const response = await fetch(`${baseUrl}${path}`, {
      ...init,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      signal: AbortSignal.timeout(12e3)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.code ?? `HTTP_${response.status}`);
    }
    return response.json();
  };
  return {
    subscription: async () => subscriptionViewSchema.parse(await request("/v1/billing/subscription")),
    summary: async (workspaceId, from, to) => billingSummarySchema.parse(
      await request(
        `/v1/billing/summary?workspaceId=${encodeURIComponent(workspaceId)}&from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`
      )
    ),
    usageDashboard: async (workspaceId, from, to) => billingUsageDashboardSchema.parse(
      await request(
        `/v1/billing/usage-dashboard?workspaceId=${encodeURIComponent(workspaceId)}&from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`
      )
    ),
    retention: async () => retentionPolicyViewSchema.parse(await request("/v1/data-lifecycle/retention")),
    updateRetention: async (input) => retentionPolicyViewSchema.parse(
      await request("/v1/data-lifecycle/retention", {
        method: "PUT",
        body: JSON.stringify(input)
      })
    ),
    lifecycleRequests: async () => dataLifecycleRequestListSchema.parse(await request("/v1/data-lifecycle/requests")).items,
    requestLifecycle: async (kind, workspaceId, reason) => dataLifecycleRequestViewSchema.parse(
      await request(
        kind === "export" ? "/v1/data-lifecycle/exports" : "/v1/data-lifecycle/deletions",
        {
          method: "POST",
          body: JSON.stringify({
            workspaceId,
            reason,
            idempotencyKey: crypto.randomUUID()
          })
        }
      )
    )
  };
};
var CurrencyToggle = ({
  value,
  onChange
}) => /* @__PURE__ */ jsx14("div", { className: "voice-density-toggle", role: "group", "aria-label": "Para birimi", children: ["TRY", "USD"].map((code) => /* @__PURE__ */ jsx14(
  "button",
  {
    type: "button",
    className: value === code ? "active" : "",
    onClick: () => onChange(code),
    children: code
  },
  code
)) });
var BillingLifecyclePage = ({
  api,
  locale: _locale,
  workspaceId,
  mode
}) => {
  const [subscription, setSubscription] = useState13();
  const [summary, setSummary] = useState13();
  const [dashboard, setDashboard] = useState13();
  const [dashboardError, setDashboardError] = useState13("");
  const [retention, setRetention] = useState13();
  const [jobs, setJobs] = useState13([]);
  const [notice, setNotice] = useState13("");
  const [error, setError] = useState13("");
  const [rangeDays, setRangeDays] = useState13(30);
  const [currency, setCurrency] = useState13(
    () => typeof window === "undefined" ? "TRY" : readDisplayCurrency()
  );
  const range = useMemo7(() => {
    const to = /* @__PURE__ */ new Date();
    const from = new Date(to.getTime() - rangeDays * 24 * 60 * 60 * 1e3);
    return { from, to };
  }, [rangeDays]);
  const setCurrencyPersist = (next) => {
    setCurrency(next);
    writeDisplayCurrency(next);
  };
  const refresh = useCallback12(async () => {
    const errors = [];
    const [subResult, summaryResult, retentionResult, jobsResult, dashboardResult] = await Promise.allSettled([
      api.subscription(),
      api.summary(workspaceId, range.from, range.to),
      api.retention(),
      api.lifecycleRequests(),
      api.usageDashboard ? api.usageDashboard(workspaceId, range.from, range.to) : Promise.resolve(void 0)
    ]);
    if (subResult.status === "fulfilled") {
      setSubscription(subResult.value);
    } else {
      errors.push(
        subResult.reason instanceof Error ? subResult.reason.message : "SUBSCRIPTION_LOAD_FAILED"
      );
    }
    if (summaryResult.status === "fulfilled") {
      setSummary(summaryResult.value);
    } else {
      errors.push(
        summaryResult.reason instanceof Error ? summaryResult.reason.message : "SUMMARY_LOAD_FAILED"
      );
    }
    if (retentionResult.status === "fulfilled") {
      setRetention(retentionResult.value);
    } else if (mode === "settings") {
      errors.push(
        retentionResult.reason instanceof Error ? retentionResult.reason.message : "RETENTION_LOAD_FAILED"
      );
    }
    if (jobsResult.status === "fulfilled") {
      setJobs(jobsResult.value);
    }
    if (dashboardResult.status === "fulfilled" && dashboardResult.value) {
      setDashboard(dashboardResult.value);
      setDashboardError("");
    } else if (dashboardResult.status === "rejected") {
      setDashboard(void 0);
      setDashboardError(
        dashboardResult.reason instanceof Error ? dashboardResult.reason.message : "DASHBOARD_LOAD_FAILED"
      );
    }
    setError(errors.length > 0 ? errors.join(" \xB7 ") : "");
  }, [api, mode, range.from, range.to, workspaceId]);
  useEffect12(() => {
    void refresh().catch(
      (cause) => setError(cause instanceof Error ? cause.message : "LOAD_FAILED")
    );
  }, [refresh]);
  const saveRetention = async (event) => {
    event.preventDefault();
    if (!retention) return;
    const form = new FormData(event.currentTarget);
    try {
      await api.updateRetention({
        conversationDays: Number(form.get("conversationDays")),
        transcriptDays: Number(form.get("transcriptDays")),
        recordingDays: Number(form.get("recordingDays")),
        auditDays: Number(form.get("auditDays")),
        legalHold: form.get("legalHold") === "on",
        expectedVersion: retention.version
      });
      setNotice("Saklama politikas\u0131 g\xFCncellendi ve denetlendi.");
      setError("");
      await refresh();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "UPDATE_FAILED");
    }
  };
  const requestJob = async (kind) => {
    try {
      await api.requestLifecycle(
        kind,
        workspaceId,
        kind === "export" ? "Workspace d\u0131\u015Fa aktar\u0131m\u0131" : "Do\u011Frulanm\u0131\u015F workspace silme iste\u011Fi"
      );
      setNotice(
        kind === "export" ? "D\u0131\u015Fa aktar\u0131m kuyru\u011Fa al\u0131nd\u0131." : "Silme i\u015Flemi yedi g\xFCnl\xFCk g\xFCvenlik penceresiyle kuyru\u011Fa al\u0131nd\u0131."
      );
      setError("");
      await refresh();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "REQUEST_FAILED");
    }
  };
  const maxServiceCost = Math.max(
    1,
    ...dashboard?.series.byService.map((d) => {
      const retail = d.estimatedRetailCharge ?? d.estimatedCost;
      const cost = currency === "TRY" ? retail.tryMinor : retail.usdMinor;
      return cost > 0 ? cost : d.quantity;
    }) ?? [1]
  );
  const talkMinutes = Math.round((dashboard?.kpis.talkSeconds ?? 0) / 60);
  const byDay = dashboard?.series.byDay ?? [];
  const hasRangeActivity = byDay.some(hasDaySignal);
  const hasServiceBreakdown = (dashboard?.series.byService.length ?? 0) > 0;
  const fxLabel = dashboard ? `Tahmini maliyet/sat\u0131\u015F \xB7 kur 1 USD = ${dashboard.fx.usdTry} TRY (${dashboard.fx.source})` : "Tahmini maliyet/sat\u0131\u015F \xB7 kur config";
  return /* @__PURE__ */ jsxs14("section", { className: "studio-page", children: [
    /* @__PURE__ */ jsxs14("header", { className: "studio-toolbar", children: [
      /* @__PURE__ */ jsxs14("div", { children: [
        /* @__PURE__ */ jsx14("span", { children: mode === "billing" ? "\xD6L\xC7\xDCMLEME VE HAKLAR" : "VER\u0130 Y\xD6NET\u0130\u015E\u0130M\u0130" }),
        /* @__PURE__ */ jsx14("h2", { children: mode === "billing" ? "Faturalama ve Kullan\u0131m" : "Saklama ve Ta\u015F\u0131nabilirlik" })
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "performance-toolbar-actions", children: [
        mode === "billing" && /* @__PURE__ */ jsxs14(Fragment8, { children: [
          /* @__PURE__ */ jsx14("div", { className: "voice-density-toggle", role: "group", "aria-label": "Tarih aral\u0131\u011F\u0131", children: [7, 30, 90].map((days) => /* @__PURE__ */ jsxs14(
            "button",
            {
              type: "button",
              className: rangeDays === days ? "active" : "",
              onClick: () => setRangeDays(days),
              children: [
                days,
                "g"
              ]
            },
            days
          )) }),
          /* @__PURE__ */ jsx14(CurrencyToggle, { value: currency, onChange: setCurrencyPersist })
        ] }),
        /* @__PURE__ */ jsx14("b", { children: subscription?.status ?? "y\xFCkleniyor" })
      ] })
    ] }),
    notice && /* @__PURE__ */ jsx14("div", { className: "studio-alert success", children: notice }),
    error && /* @__PURE__ */ jsx14("div", { className: "studio-alert error", children: error }),
    mode === "billing" ? /* @__PURE__ */ jsxs14(Fragment8, { children: [
      /* @__PURE__ */ jsxs14("p", { className: "performance-note", children: [
        "Kullan\u0131m defteri + admin rate-card tahmini maliyet/sat\u0131\u015F/k\xE2r. Fatura de\u011Fildir. ",
        fxLabel,
        ". Telefon dakikas\u0131 maliyeti \u015Fu an sa\u011Flay\u0131c\u0131 (Verimor/Zadarma) k\u0131r\u0131l\u0131m\u0131 olmadan toplam quantity \xFCzerinden hesaplan\u0131r; Tarifeler\u2019de ayr\u0131 providerMeters kayd\u0131 olsa bile panoda tek \u201CTelefoni\u201D sat\u0131r\u0131 g\xF6r\xFCn\xFCr. Defter quantity-only kal\u0131r."
      ] }),
      dashboardError && /* @__PURE__ */ jsxs14("div", { className: "studio-alert error", children: [
        "Maliyet panosu y\xFCklenemedi: ",
        dashboardError
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "performance-kpi-grid", "aria-label": "Kullan\u0131m KPI", children: [
        /* @__PURE__ */ jsxs14("div", { className: "performance-kpi", children: [
          /* @__PURE__ */ jsx14("small", { children: "Konu\u015Fma dk" }),
          /* @__PURE__ */ jsx14("b", { children: talkMinutes })
        ] }),
        /* @__PURE__ */ jsxs14("div", { className: "performance-kpi", children: [
          /* @__PURE__ */ jsx14("small", { children: "Tel. dk" }),
          /* @__PURE__ */ jsx14("b", { children: Math.round(dashboard?.kpis.telephonyMinutes ?? 0) })
        ] }),
        /* @__PURE__ */ jsxs14("div", { className: "performance-kpi", children: [
          /* @__PURE__ */ jsx14("small", { children: "Aramalar" }),
          /* @__PURE__ */ jsx14("b", { children: dashboard?.kpis.calls ?? 0 })
        ] }),
        /* @__PURE__ */ jsxs14("div", { className: "performance-kpi tone-ok", children: [
          /* @__PURE__ */ jsx14("small", { children: "Ger\xE7ek maliyet" }),
          /* @__PURE__ */ jsx14("b", { children: formatMoneyDual(
            dashboard?.kpis.estimatedWholesaleCost ?? dashboard?.kpis.estimatedCost,
            currency
          ) })
        ] }),
        /* @__PURE__ */ jsxs14("div", { className: "performance-kpi tone-ok", children: [
          /* @__PURE__ */ jsx14("small", { children: "Sat\u0131\u015F tutar\u0131" }),
          /* @__PURE__ */ jsx14("b", { children: formatMoneyDual(
            dashboard?.kpis.estimatedRetailCharge ?? dashboard?.kpis.estimatedCost,
            currency
          ) })
        ] }),
        /* @__PURE__ */ jsxs14("div", { className: "performance-kpi tone-ok", children: [
          /* @__PURE__ */ jsx14("small", { children: "Br\xFCt k\xE2r" }),
          /* @__PURE__ */ jsx14("b", { children: formatMoneyDual(dashboard?.kpis.estimatedGrossProfit, currency) }),
          /* @__PURE__ */ jsxs14("small", { children: [
            formatBps(dashboard?.kpis.grossMarginBps),
            " marj"
          ] })
        ] }),
        /* @__PURE__ */ jsxs14("div", { className: "performance-kpi", children: [
          /* @__PURE__ */ jsx14("small", { children: "Plan kalan (ses sn)" }),
          /* @__PURE__ */ jsx14("b", { children: (() => {
            const row = summary?.totals.find((item) => item.meter === "voice_seconds");
            if (!row || row.limit === null) return "\u2014";
            return Math.max(0, row.limit - row.quantity);
          })() })
        ] }),
        /* @__PURE__ */ jsxs14("div", { className: "performance-kpi", children: [
          /* @__PURE__ */ jsx14("small", { children: "Kur (1 USD)" }),
          /* @__PURE__ */ jsx14("b", { children: dashboard ? `${dashboard.fx.usdTry} \u20BA` : "\u2014" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "performance-charts cost-charts", style: { marginBottom: 16 }, children: [
        /* @__PURE__ */ jsxs14("article", { className: "studio-card cost-card", children: [
          /* @__PURE__ */ jsxs14("header", { children: [
            /* @__PURE__ */ jsxs14("div", { children: [
              /* @__PURE__ */ jsx14("small", { children: "TAHM\u0130N\u0130 SATI\u015E" }),
              /* @__PURE__ */ jsxs14("h3", { children: [
                "G\xFCnl\xFCk sat\u0131\u015F/k\xE2r (",
                currency,
                ")"
              ] })
            ] }),
            /* @__PURE__ */ jsxs14("b", { children: [
              rangeDays,
              "g"
            ] })
          ] }),
          !hasRangeActivity ? /* @__PURE__ */ jsx14(
            BillingEmptyState,
            {
              title: "Bu aral\u0131kta hen\xFCz kullan\u0131m yok",
              body: "Tamamlanan aramalar deftere yaz\u0131l\u0131r. Softphone \u2192 ses saniyesi; PSTN \u2192 ayr\u0131ca telefoni dakikas\u0131. Sonra burada s\xFCtun grafik olu\u015Fur."
            }
          ) : /* @__PURE__ */ jsx14(CostColumnChart, { days: byDay, currency })
        ] }),
        /* @__PURE__ */ jsxs14("article", { className: "studio-card cost-card", children: [
          /* @__PURE__ */ jsxs14("header", { children: [
            /* @__PURE__ */ jsxs14("div", { children: [
              /* @__PURE__ */ jsx14("small", { children: "KIRILIM" }),
              /* @__PURE__ */ jsxs14("h3", { children: [
                "Servis bazl\u0131 (",
                currency,
                ")"
              ] })
            ] }),
            /* @__PURE__ */ jsx14("b", { children: hasServiceBreakdown ? dashboard.series.byService.length : 0 })
          ] }),
          !hasServiceBreakdown ? /* @__PURE__ */ jsx14(
            BillingEmptyState,
            {
              title: "Servis k\u0131r\u0131l\u0131m\u0131 bo\u015F",
              body: "Meter kayd\u0131 gelince ses, telefoni, STT/TTS/LLM sat\u0131rlar\u0131 burada toplan\u0131r. \u015Eimdilik fatura de\u011Fil \u2014 rate-card tahmini."
            }
          ) : /* @__PURE__ */ jsx14("div", { className: "cost-service-list", children: dashboard.series.byService.map((row) => {
            const retail = row.estimatedRetailCharge ?? row.estimatedCost;
            const wholesale = row.estimatedWholesaleCost ?? row.estimatedCost;
            const profit = row.estimatedGrossProfit;
            const minor = currency === "TRY" ? retail.tryMinor : retail.usdMinor;
            const barValue = minor > 0 ? minor : row.quantity;
            const widthPct = Math.max(4, Math.min(100, barValue / maxServiceCost * 100));
            return /* @__PURE__ */ jsxs14("div", { className: "cost-service-row", children: [
              /* @__PURE__ */ jsxs14("div", { className: "cost-service-head", children: [
                /* @__PURE__ */ jsx14("strong", { children: serviceLabel(row.service) }),
                /* @__PURE__ */ jsxs14("span", { children: [
                  "Sat\u0131\u015F ",
                  formatMoneyDual(retail, currency)
                ] })
              ] }),
              /* @__PURE__ */ jsx14("div", { className: "cost-service-track", "aria-hidden": true, children: /* @__PURE__ */ jsx14("i", { style: { width: `${widthPct}%` } }) }),
              /* @__PURE__ */ jsxs14("small", { className: "cost-service-meta", children: [
                "maliyet ",
                formatMoneyDual(wholesale, currency),
                " \xB7 ",
                "k\xE2r ",
                formatMoneyDual(profit, currency),
                " \xB7 ",
                "marj ",
                formatBps(row.grossMarginBps),
                " \xB7 ",
                "miktar ",
                row.quantity,
                row.service === "voice" ? " sn" : row.service === "telephony" ? " dk" : ""
              ] })
            ] }, row.service);
          }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "studio-grid", children: [
        /* @__PURE__ */ jsxs14("article", { className: "studio-card", children: [
          /* @__PURE__ */ jsxs14("header", { children: [
            /* @__PURE__ */ jsxs14("div", { children: [
              /* @__PURE__ */ jsx14("small", { children: "MEVCUT PLAN" }),
              /* @__PURE__ */ jsx14("h3", { children: subscription?.plan.name ?? "Y\xFCkleniyor..." })
            ] }),
            /* @__PURE__ */ jsx14("b", { children: subscription?.plan.currency })
          ] }),
          /* @__PURE__ */ jsxs14("p", { children: [
            "D\xF6nem biti\u015Fi:",
            " ",
            subscription ? new Date(subscription.currentPeriodEnd).toLocaleDateString() : "\u2014",
            ". Haklar sunucu taraf\u0131ndan uygulan\u0131r ve her oturumda yenilenir."
          ] }),
          /* @__PURE__ */ jsx14("div", { className: "proposal-list", children: subscription?.entitlements.map((item) => /* @__PURE__ */ jsxs14("div", { children: [
            /* @__PURE__ */ jsx14("span", { children: item.meter ?? "\xF6zellik" }),
            /* @__PURE__ */ jsx14("p", { children: item.key }),
            /* @__PURE__ */ jsx14("small", { children: item.limit === null ? "Etkin" : `${item.limit} \xB7 ${item.enforcement} limit` })
          ] }, item.key)) })
        ] }),
        /* @__PURE__ */ jsxs14("article", { className: "studio-card", children: [
          /* @__PURE__ */ jsxs14("header", { children: [
            /* @__PURE__ */ jsxs14("div", { children: [
              /* @__PURE__ */ jsxs14("small", { children: [
                "SON ",
                rangeDays,
                " G\xDCN"
              ] }),
              /* @__PURE__ */ jsx14("h3", { children: "Kullan\u0131m defteri" })
            ] }),
            /* @__PURE__ */ jsx14("b", { children: "de\u011Fi\u015Fmez" })
          ] }),
          /* @__PURE__ */ jsxs14("div", { className: "proposal-list", children: [
            summary?.totals.map((item) => /* @__PURE__ */ jsxs14("div", { children: [
              /* @__PURE__ */ jsx14("span", { children: item.enforcement }),
              /* @__PURE__ */ jsx14("p", { children: item.meter.replaceAll("_", " ") }),
              /* @__PURE__ */ jsxs14("small", { children: [
                item.quantity,
                " kullan\u0131ld\u0131 \xB7",
                " ",
                item.limit === null ? "s\u0131n\u0131rs\u0131z" : `${item.limit} limit`
              ] })
            ] }, item.meter)),
            summary?.totals.length === 0 && /* @__PURE__ */ jsx14("p", { children: "Bu d\xF6nemde kullan\u0131m kayd\u0131 yok." })
          ] })
        ] })
      ] })
    ] }) : /* @__PURE__ */ jsxs14("div", { className: "studio-grid", children: [
      /* @__PURE__ */ jsxs14("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsxs14("header", { children: [
          /* @__PURE__ */ jsxs14("div", { children: [
            /* @__PURE__ */ jsx14("small", { children: "SAKLAMA POL\u0130T\u0130KASI" }),
            /* @__PURE__ */ jsx14("h3", { children: "Veri ya\u015Fam d\xF6ng\xFCs\xFC s\u0131n\u0131rlar\u0131" })
          ] }),
          /* @__PURE__ */ jsxs14("b", { children: [
            "v",
            retention?.version ?? 0
          ] })
        ] }),
        retention && /* @__PURE__ */ jsxs14("form", { onSubmit: (event) => void saveRetention(event), children: [
          ["conversationDays", "transcriptDays", "recordingDays", "auditDays"].map((name) => /* @__PURE__ */ jsxs14("label", { children: [
            name.replace("conversationDays", "Konu\u015Fma g\xFCnleri").replace("transcriptDays", "Transkript g\xFCnleri").replace("recordingDays", "Kay\u0131t g\xFCnleri").replace("auditDays", "Denetim g\xFCnleri"),
            /* @__PURE__ */ jsx14(
              "input",
              {
                name,
                type: "number",
                min: name === "auditDays" ? 365 : 1,
                max: "3650",
                defaultValue: retention[name]
              }
            )
          ] }, name)),
          /* @__PURE__ */ jsxs14("label", { className: "voice-consent", children: [
            /* @__PURE__ */ jsx14("input", { name: "legalHold", type: "checkbox", defaultChecked: retention.legalHold }),
            "Yasal bekletme silmeyi engeller"
          ] }),
          /* @__PURE__ */ jsx14("button", { type: "submit", children: "Politikay\u0131 kaydet" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs14("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsxs14("header", { children: [
          /* @__PURE__ */ jsxs14("div", { children: [
            /* @__PURE__ */ jsx14("small", { children: "TA\u015EINAB\u0130L\u0130RL\u0130K VE S\u0130LME" }),
            /* @__PURE__ */ jsx14("h3", { children: "Ya\u015Fam d\xF6ng\xFCs\xFC istekleri" })
          ] }),
          /* @__PURE__ */ jsx14("b", { children: jobs.length })
        ] }),
        /* @__PURE__ */ jsxs14("div", { className: "voice-actions", children: [
          /* @__PURE__ */ jsx14("button", { type: "button", onClick: () => void requestJob("export"), children: "D\u0131\u015Fa aktar\u0131m iste" }),
          /* @__PURE__ */ jsx14("button", { type: "button", onClick: () => void requestJob("delete"), children: "Silme iste" })
        ] }),
        /* @__PURE__ */ jsx14("div", { className: "proposal-list", children: jobs.map((job) => /* @__PURE__ */ jsxs14("div", { children: [
          /* @__PURE__ */ jsx14("span", { children: job.status }),
          /* @__PURE__ */ jsxs14("p", { children: [
            job.kind,
            " \xB7 ",
            job.workspaceId ?? "t\xFCm tenant"
          ] }),
          /* @__PURE__ */ jsx14("small", { children: job.executeAfter ? `En erken \xE7al\u0131\u015Fma ${new Date(job.executeAfter).toLocaleDateString()}` : new Date(job.createdAt).toLocaleString() })
        ] }, job.id)) })
      ] })
    ] })
  ] });
};

// src/performance.tsx
import { jsx as jsx15, jsxs as jsxs15 } from "react/jsx-runtime";
var createPerformanceApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  return {
    dashboard: async (workspaceId, filters) => {
      const params = new URLSearchParams({ workspaceId });
      if (filters?.from) params.set("from", filters.from);
      if (filters?.to) params.set("to", filters.to);
      if (filters?.agentId) params.set("agentId", filters.agentId);
      if (filters?.campaignId) params.set("campaignId", filters.campaignId);
      const response = await fetch(`${base}/v1/calls/performance?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
        signal: AbortSignal.timeout(15e3)
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.code ?? `HTTP_${response.status}`);
      }
      return voicePerformanceDashboardSchema.parse(await response.json());
    }
  };
};
var PerformancePage = ({
  api,
  agents,
  billingApi,
  locale: _locale,
  workspaceId
}) => {
  const [data, setData] = useState14();
  const [cost, setCost] = useState14();
  const [costError, setCostError] = useState14();
  const [error, setError] = useState14();
  const [busy, setBusy] = useState14(false);
  const [rangeDays, setRangeDays] = useState14(30);
  const [agentId, setAgentId] = useState14("");
  const [agentOptions, setAgentOptions] = useState14([]);
  const [currency, setCurrency] = useState14(
    () => typeof window === "undefined" ? "TRY" : readDisplayCurrency()
  );
  const range = useMemo8(() => {
    const to = /* @__PURE__ */ new Date();
    const from = new Date(to.getTime() - rangeDays * 24 * 60 * 60 * 1e3);
    return { from: from.toISOString(), to: to.toISOString(), fromDate: from, toDate: to };
  }, [rangeDays]);
  const setCurrencyPersist = (next) => {
    setCurrency(next);
    writeDisplayCurrency(next);
  };
  const load = useCallback13(async () => {
    setBusy(true);
    try {
      const [dashboard, agentPage] = await Promise.all([
        api.dashboard(workspaceId, {
          from: range.from,
          to: range.to,
          ...agentId ? { agentId } : {}
        }),
        agents ? agents.list(workspaceId) : Promise.resolve({ items: [] })
      ]);
      setData(dashboard);
      setAgentOptions(agentPage.items.map(({ id, name }) => ({ id, name })));
      setError(void 0);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "PERFORMANCE_LOAD_FAILED");
    }
    if (billingApi?.usageDashboard) {
      try {
        const nextCost = await billingApi.usageDashboard(
          workspaceId,
          range.fromDate,
          range.toDate
        );
        setCost(nextCost);
        setCostError(void 0);
      } catch (cause) {
        setCost(void 0);
        setCostError(cause instanceof Error ? cause.message : "COST_LOAD_FAILED");
      }
    } else {
      setCost(void 0);
      setCostError(void 0);
    }
    setBusy(false);
  }, [agentId, agents, api, billingApi, range.from, range.fromDate, range.to, range.toDate, workspaceId]);
  useEffect13(() => {
    void load();
  }, [load]);
  const kpis = data?.kpis;
  const maxDay = Math.max(1, ...data?.series.callsByDay.map((d) => d.started) ?? [1]);
  const maxOutcome = Math.max(1, ...data?.series.outcomes.map((d) => d.count) ?? [1]);
  const maxSentiment = Math.max(1, ...data?.series.sentiment.map((d) => d.count) ?? [1]);
  const maxAgent = Math.max(1, ...data?.series.byAgent.map((d) => d.calls) ?? [1]);
  const maxCostDay = Math.max(
    1,
    ...cost?.series.byDay.map(
      (d) => currency === "TRY" ? d.estimatedCost.tryMinor : d.estimatedCost.usdMinor
    ) ?? [1]
  );
  return /* @__PURE__ */ jsxs15("section", { className: "performance-page studio-page", children: [
    /* @__PURE__ */ jsxs15("header", { className: "studio-toolbar", children: [
      /* @__PURE__ */ jsxs15("div", { children: [
        /* @__PURE__ */ jsx15("span", { children: "VOICE PERFORMANCE" }),
        /* @__PURE__ */ jsx15("h2", { children: "Performans" })
      ] }),
      /* @__PURE__ */ jsxs15("div", { className: "performance-toolbar-actions", children: [
        /* @__PURE__ */ jsx15("div", { className: "voice-density-toggle", role: "group", "aria-label": "Tarih aral\u0131\u011F\u0131", children: [7, 30, 90].map((days) => /* @__PURE__ */ jsxs15(
          "button",
          {
            type: "button",
            className: rangeDays === days ? "active" : "",
            onClick: () => setRangeDays(days),
            children: [
              days,
              "g"
            ]
          },
          days
        )) }),
        /* @__PURE__ */ jsx15("div", { className: "voice-density-toggle", role: "group", "aria-label": "Para birimi", children: ["TRY", "USD"].map((code) => /* @__PURE__ */ jsx15(
          "button",
          {
            type: "button",
            className: currency === code ? "active" : "",
            onClick: () => setCurrencyPersist(code),
            children: code
          },
          code
        )) }),
        /* @__PURE__ */ jsxs15("label", { className: "performance-agent-filter", children: [
          "Ajan",
          /* @__PURE__ */ jsxs15("select", { value: agentId, onChange: (event) => setAgentId(event.target.value), children: [
            /* @__PURE__ */ jsx15("option", { value: "", children: "T\xFCm\xFC" }),
            agentOptions.map((agent) => /* @__PURE__ */ jsx15("option", { value: agent.id, children: agent.name }, agent.id))
          ] })
        ] }),
        /* @__PURE__ */ jsx15("button", { type: "button", disabled: busy, onClick: () => void load(), children: "Yenile" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs15("p", { className: "performance-note", children: [
      "Ses aramalar\u0131 i\xE7in hacim, kalite ve i\u015F sonu\xE7lar\u0131. Aral\u0131k:",
      " ",
      /* @__PURE__ */ jsx15("b", { children: formatRange(data?.range.from, data?.range.to) }),
      cost ? ` \xB7 Tahmini maliyet \xB7 kur 1 USD = ${cost.fx.usdTry} TRY (${cost.fx.source})` : ""
    ] }),
    error && /* @__PURE__ */ jsx15("div", { className: "studio-alert error", children: error }),
    costError && /* @__PURE__ */ jsxs15("div", { className: "studio-alert error", children: [
      "Maliyet panosu y\xFCklenemedi (performans devam eder): ",
      costError
    ] }),
    /* @__PURE__ */ jsxs15("div", { className: "performance-kpi-grid", "aria-label": "Voice KPIs", children: [
      /* @__PURE__ */ jsx15(Kpi, { label: "Ba\u015Flayan", value: kpis?.callsStarted ?? 0 }),
      /* @__PURE__ */ jsx15(Kpi, { label: "Tamamlanan", value: kpis?.callsCompleted ?? 0, tone: "ok" }),
      /* @__PURE__ */ jsx15(Kpi, { label: "Ba\u015Far\u0131s\u0131z", value: kpis?.callsFailed ?? 0, tone: "bad" }),
      /* @__PURE__ */ jsx15(Kpi, { label: "Aktif", value: kpis?.callsActive ?? 0, tone: "warn" }),
      /* @__PURE__ */ jsx15(Kpi, { label: "Konu\u015Fma dk", value: kpis?.talkMinutes ?? 0 }),
      /* @__PURE__ */ jsx15(Kpi, { label: "Ort. s\xFCre (sn)", value: kpis?.avgDurationSeconds ?? 0 }),
      /* @__PURE__ */ jsx15(
        Kpi,
        {
          label: "Tahmini maliyet",
          value: cost ? formatMoneyDual(cost.kpis.estimatedCost, currency) : "\u2014",
          tone: "ok"
        }
      ),
      /* @__PURE__ */ jsx15(
        Kpi,
        {
          label: "Containment",
          value: `${Math.round((kpis?.containmentRate ?? 0) * 100)}%`,
          tone: "ok"
        }
      ),
      /* @__PURE__ */ jsx15(
        Kpi,
        {
          label: "Handoff",
          value: `${Math.round((kpis?.handoffRate ?? 0) * 100)}%`
        }
      ),
      /* @__PURE__ */ jsx15(Kpi, { label: "Lead", value: kpis?.leadsCreated ?? 0 }),
      /* @__PURE__ */ jsx15(
        Kpi,
        {
          label: "Tool ba\u015Far\u0131",
          value: kpis?.toolSuccessRate == null ? "\u2014" : `${Math.round(kpis.toolSuccessRate * 100)}%`
        }
      ),
      /* @__PURE__ */ jsx15(Kpi, { label: "Latency p50", value: kpis?.latencyP50Ms == null ? "\u2014" : `${kpis.latencyP50Ms}ms` }),
      /* @__PURE__ */ jsx15(Kpi, { label: "Latency p95", value: kpis?.latencyP95Ms == null ? "\u2014" : `${kpis.latencyP95Ms}ms` })
    ] }),
    /* @__PURE__ */ jsxs15("div", { className: "performance-charts", children: [
      /* @__PURE__ */ jsxs15("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx15("header", { children: /* @__PURE__ */ jsxs15("div", { children: [
          /* @__PURE__ */ jsx15("small", { children: "TAHM\u0130N\u0130 MAL\u0130YET" }),
          /* @__PURE__ */ jsxs15("h3", { children: [
            "G\xFCnl\xFCk maliyet (",
            currency,
            ")"
          ] })
        ] }) }),
        (cost?.series.byDay.length ?? 0) === 0 ? /* @__PURE__ */ jsx15("p", { className: "voice-tool-empty", children: costError ? "Maliyet verisi y\xFCklenemedi." : "Bu aral\u0131kta tahmini maliyet yok (\u20BA0 / $0)." }) : /* @__PURE__ */ jsx15("div", { className: "bar-chart", children: cost.series.byDay.map((day) => {
          const minor = currency === "TRY" ? day.estimatedCost.tryMinor : day.estimatedCost.usdMinor;
          return /* @__PURE__ */ jsxs15(
            "div",
            {
              className: "bar-chart-row",
              title: `${day.date}: ${formatMoneyDual(day.estimatedCost, currency)}`,
              children: [
                /* @__PURE__ */ jsx15("span", { className: "bar-chart-label", children: day.date.slice(5) }),
                /* @__PURE__ */ jsx15("div", { className: "bar-chart-track", children: /* @__PURE__ */ jsx15("i", { style: { width: `${minor / maxCostDay * 100}%` } }) }),
                /* @__PURE__ */ jsx15("span", { className: "bar-chart-value", children: formatMoneyDual(day.estimatedCost, currency) })
              ]
            },
            day.date
          );
        }) })
      ] }),
      /* @__PURE__ */ jsxs15("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx15("header", { children: /* @__PURE__ */ jsxs15("div", { children: [
          /* @__PURE__ */ jsx15("small", { children: "ZAMAN SER\u0130S\u0130" }),
          /* @__PURE__ */ jsx15("h3", { children: "G\xFCnl\xFCk arama hacmi" })
        ] }) }),
        (data?.series.callsByDay.length ?? 0) === 0 ? /* @__PURE__ */ jsx15("p", { className: "voice-tool-empty", children: "Bu aral\u0131kta arama yok." }) : /* @__PURE__ */ jsx15("div", { className: "bar-chart", children: data.series.callsByDay.map((day) => /* @__PURE__ */ jsxs15("div", { className: "bar-chart-row", title: `${day.date}: ${day.started}`, children: [
          /* @__PURE__ */ jsx15("span", { className: "bar-chart-label", children: day.date.slice(5) }),
          /* @__PURE__ */ jsx15("div", { className: "bar-chart-track", children: /* @__PURE__ */ jsx15("i", { style: { width: `${day.started / maxDay * 100}%` } }) }),
          /* @__PURE__ */ jsxs15("span", { className: "bar-chart-value", children: [
            day.started,
            /* @__PURE__ */ jsxs15("small", { children: [
              "\xB7 ",
              day.completed,
              "\u2713 / ",
              day.failed,
              "\u2717"
            ] })
          ] })
        ] }, day.date)) })
      ] }),
      /* @__PURE__ */ jsxs15("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx15("header", { children: /* @__PURE__ */ jsxs15("div", { children: [
          /* @__PURE__ */ jsx15("small", { children: "OUTCOME" }),
          /* @__PURE__ */ jsx15("h3", { children: "Sonu\xE7 da\u011F\u0131l\u0131m\u0131" })
        ] }) }),
        (data?.series.outcomes.length ?? 0) === 0 ? /* @__PURE__ */ jsx15("p", { className: "voice-tool-empty", children: "Analiz outcome yok." }) : /* @__PURE__ */ jsx15("div", { className: "bar-chart", children: data.series.outcomes.map((item) => /* @__PURE__ */ jsxs15("div", { className: "bar-chart-row", children: [
          /* @__PURE__ */ jsx15("span", { className: "bar-chart-label", children: outcomeTr(item.type) }),
          /* @__PURE__ */ jsx15("div", { className: "bar-chart-track", children: /* @__PURE__ */ jsx15(
            "i",
            {
              className: `tone-${item.type}`,
              style: { width: `${item.count / maxOutcome * 100}%` }
            }
          ) }),
          /* @__PURE__ */ jsx15("span", { className: "bar-chart-value", children: item.count })
        ] }, item.type)) })
      ] }),
      /* @__PURE__ */ jsxs15("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx15("header", { children: /* @__PURE__ */ jsxs15("div", { children: [
          /* @__PURE__ */ jsx15("small", { children: "SENTIMENT" }),
          /* @__PURE__ */ jsx15("h3", { children: "Duygu da\u011F\u0131l\u0131m\u0131" })
        ] }) }),
        (data?.series.sentiment.length ?? 0) === 0 ? /* @__PURE__ */ jsx15("p", { className: "voice-tool-empty", children: "Sentiment verisi yok." }) : /* @__PURE__ */ jsx15("div", { className: "bar-chart", children: data.series.sentiment.map((item) => /* @__PURE__ */ jsxs15("div", { className: "bar-chart-row", children: [
          /* @__PURE__ */ jsx15("span", { className: "bar-chart-label", children: sentimentTr(item.sentiment) }),
          /* @__PURE__ */ jsx15("div", { className: "bar-chart-track", children: /* @__PURE__ */ jsx15(
            "i",
            {
              className: `sent-${item.sentiment}`,
              style: { width: `${item.count / maxSentiment * 100}%` }
            }
          ) }),
          /* @__PURE__ */ jsx15("span", { className: "bar-chart-value", children: item.count })
        ] }, item.sentiment)) })
      ] }),
      /* @__PURE__ */ jsxs15("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx15("header", { children: /* @__PURE__ */ jsxs15("div", { children: [
          /* @__PURE__ */ jsx15("small", { children: "AJAN" }),
          /* @__PURE__ */ jsx15("h3", { children: "Ajan kar\u015F\u0131la\u015Ft\u0131rmas\u0131" })
        ] }) }),
        (data?.series.byAgent.length ?? 0) === 0 ? /* @__PURE__ */ jsx15("p", { className: "voice-tool-empty", children: "Ajan bazl\u0131 arama yok." }) : /* @__PURE__ */ jsx15("div", { className: "bar-chart", children: data.series.byAgent.map((item) => /* @__PURE__ */ jsxs15("div", { className: "bar-chart-row", children: [
          /* @__PURE__ */ jsx15("span", { className: "bar-chart-label", title: item.agentId, children: item.agentName ?? shortId2(item.agentId) }),
          /* @__PURE__ */ jsx15("div", { className: "bar-chart-track", children: /* @__PURE__ */ jsx15("i", { style: { width: `${item.calls / maxAgent * 100}%` } }) }),
          /* @__PURE__ */ jsxs15("span", { className: "bar-chart-value", children: [
            item.calls,
            /* @__PURE__ */ jsxs15("small", { children: [
              "\xB7 ",
              item.completed,
              "\u2713 \xB7 ",
              item.avgDurationSeconds,
              "s"
            ] })
          ] })
        ] }, item.agentId)) })
      ] })
    ] })
  ] });
};
var Kpi = ({
  label,
  value,
  tone
}) => /* @__PURE__ */ jsxs15("div", { className: `performance-kpi${tone ? ` tone-${tone}` : ""}`, children: [
  /* @__PURE__ */ jsx15("small", { children: label }),
  /* @__PURE__ */ jsx15("b", { children: value })
] });
var shortId2 = (value) => value.length <= 16 ? value : `${value.slice(0, 8)}\u2026${value.slice(-4)}`;
var formatRange = (from, to) => {
  if (!from || !to) return "\u2014";
  const fmt = (iso) => new Intl.DateTimeFormat("tr-TR", { dateStyle: "medium" }).format(new Date(iso));
  return `${fmt(from)} \u2013 ${fmt(to)}`;
};
var outcomeTr = (type) => {
  switch (type) {
    case "converted":
      return "D\xF6n\xFC\u015F\xFCm";
    case "qualified":
      return "Nitelikli";
    case "follow_up":
      return "Takip";
    case "resolved":
      return "\xC7\xF6z\xFCld\xFC";
    case "abandoned":
      return "Terk";
    default:
      return "Bilinmiyor";
  }
};
var sentimentTr = (value) => {
  switch (value) {
    case "positive":
      return "Pozitif";
    case "neutral":
      return "N\xF6tr";
    case "negative":
      return "Negatif";
    case "mixed":
      return "Karma";
    default:
      return "Bilinmiyor";
  }
};

// src/integrations.tsx
import { useCallback as useCallback14, useEffect as useEffect14, useState as useState15 } from "react";
import {
  createWorkspaceApiKeyResponseSchema,
  customerToolListSchema,
  customerToolViewSchema,
  integrationDocsSchema,
  toolAuditListSchema,
  trustOverviewSchema,
  webhookDeliveryListSchema,
  webhookSubscriptionListSchema,
  webhookSubscriptionViewSchema,
  workspaceApiKeyListSchema,
  workspaceApiKeyViewSchema,
  calendarConnectionListSchema,
  calendarConnectionViewSchema,
  startGoogleCalendarOAuthResponseSchema
} from "@agentos/contracts";
import { jsx as jsx16, jsxs as jsxs16 } from "react/jsx-runtime";
var createIntegrationsApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
  const request = async (path, init) => {
    const response = await fetch(`${base}${path}`, {
      ...init,
      headers: { ...headers, ...init?.headers ?? {} },
      signal: AbortSignal.timeout(15e3)
    });
    return response;
  };
  const json2 = async (response) => {
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body.code ?? `HTTP_${response.status}`);
    }
    if (response.status === 204) return null;
    return response.json();
  };
  return {
    listTools: async (workspaceId) => customerToolListSchema.parse(
      await json2(
        await request(`/v1/integrations/tools?workspaceId=${encodeURIComponent(workspaceId)}`)
      )
    ).items,
    createTool: async (input) => customerToolViewSchema.parse(
      await json2(
        await request("/v1/integrations/tools", {
          method: "POST",
          body: JSON.stringify(input)
        })
      )
    ),
    deleteTool: async (toolId) => {
      await json2(
        await request(`/v1/integrations/tools/${encodeURIComponent(toolId)}`, {
          method: "DELETE"
        })
      );
    },
    listKeys: async (workspaceId) => workspaceApiKeyListSchema.parse(
      await json2(
        await request(`/v1/integrations/api-keys?workspaceId=${encodeURIComponent(workspaceId)}`)
      )
    ).items,
    createKey: async (input) => createWorkspaceApiKeyResponseSchema.parse(
      await json2(
        await request("/v1/integrations/api-keys", {
          method: "POST",
          body: JSON.stringify(input)
        })
      )
    ),
    revokeKey: async (keyId) => workspaceApiKeyViewSchema.parse(
      await json2(
        await request(`/v1/integrations/api-keys/${encodeURIComponent(keyId)}/revoke`, {
          method: "POST"
        })
      )
    ),
    listWebhooks: async (workspaceId) => webhookSubscriptionListSchema.parse(
      await json2(
        await request(`/v1/integrations/webhooks?workspaceId=${encodeURIComponent(workspaceId)}`)
      )
    ).items,
    createWebhook: async (input) => webhookSubscriptionViewSchema.parse(
      await json2(
        await request("/v1/integrations/webhooks", {
          method: "POST",
          body: JSON.stringify(input)
        })
      )
    ),
    deleteWebhook: async (webhookId) => {
      await json2(
        await request(`/v1/integrations/webhooks/${encodeURIComponent(webhookId)}`, {
          method: "DELETE"
        })
      );
    },
    listDeliveries: async (workspaceId) => webhookDeliveryListSchema.parse(
      await json2(
        await request(
          `/v1/integrations/webhook-deliveries?workspaceId=${encodeURIComponent(workspaceId)}`
        )
      )
    ).items,
    audit: async (workspaceId) => toolAuditListSchema.parse(
      await json2(
        await request(`/v1/integrations/audit?workspaceId=${encodeURIComponent(workspaceId)}`)
      )
    ).items,
    docs: async (workspaceId) => integrationDocsSchema.parse(
      await json2(
        await request(`/v1/integrations/docs?workspaceId=${encodeURIComponent(workspaceId)}`)
      )
    ),
    trustOverview: async (workspaceId) => trustOverviewSchema.parse(
      await json2(
        await request(`/v1/trust/overview?workspaceId=${encodeURIComponent(workspaceId)}`)
      )
    ),
    listCalendar: async (workspaceId) => {
      const list = calendarConnectionListSchema.parse(
        await json2(
          await request(
            `/v1/integrations/calendar?workspaceId=${encodeURIComponent(workspaceId)}`
          )
        )
      );
      return {
        items: list.items,
        platformOAuthConfigured: list.platformOAuthConfigured
      };
    },
    upsertCalendar: async (input) => calendarConnectionViewSchema.parse(
      await json2(
        await request("/v1/integrations/calendar", {
          method: "POST",
          body: JSON.stringify(input)
        })
      )
    ),
    disableCalendar: async (connectionId) => calendarConnectionViewSchema.parse(
      await json2(
        await request(
          `/v1/integrations/calendar/${encodeURIComponent(connectionId)}/disable`,
          { method: "PATCH" }
        )
      )
    ),
    startGoogleCalendarOAuth: async (input) => startGoogleCalendarOAuthResponseSchema.parse(
      await json2(
        await request("/v1/integrations/calendar/oauth/google/start", {
          method: "POST",
          body: JSON.stringify(input)
        })
      )
    ),
    clearCalendarCredentials: async (connectionId) => calendarConnectionViewSchema.parse(
      await json2(
        await request(
          `/v1/integrations/calendar/${encodeURIComponent(connectionId)}/clear-credentials`,
          { method: "POST" }
        )
      )
    ),
    addDnc: async (input) => {
      await json2(await request("/v1/trust/dnc", { method: "POST", body: JSON.stringify(input) }));
    },
    deleteDnc: async (dncId) => {
      await json2(
        await request(`/v1/trust/dnc/${encodeURIComponent(dncId)}`, { method: "DELETE" })
      );
    }
  };
};
var SCOPES = [
  "calls.read",
  "calls.start",
  "leads.read",
  "webhooks.manage"
];
var IntegrationsPage = ({
  api,
  operationsApi,
  locale: _locale,
  workspaceId,
  onOpenOperations
}) => {
  const [tab, setTab] = useState15("tools");
  const [tools, setTools] = useState15([]);
  const [keys, setKeys] = useState15([]);
  const [webhooks, setWebhooks] = useState15([]);
  const [deliveries, setDeliveries] = useState15([]);
  const [calendars, setCalendars] = useState15([]);
  const [platformOAuthConfigured, setPlatformOAuthConfigured] = useState15(false);
  const [connectors, setConnectors] = useState15([]);
  const [audit, setAudit] = useState15([]);
  const [docs, setDocs] = useState15();
  const [trust, setTrust] = useState15();
  const [secretOnce, setSecretOnce] = useState15();
  const [error, setError] = useState15();
  const [oauthBanner, setOauthBanner] = useState15();
  const [busy, setBusy] = useState15(false);
  const load = useCallback14(async () => {
    setBusy(true);
    try {
      const [t, k, w, del, cal, a, d, tr2, conn] = await Promise.all([
        api.listTools(workspaceId),
        api.listKeys(workspaceId),
        api.listWebhooks(workspaceId),
        api.listDeliveries(workspaceId),
        api.listCalendar(workspaceId).catch(() => ({ items: [], platformOAuthConfigured: false })),
        api.audit(workspaceId),
        api.docs(workspaceId),
        api.trustOverview(workspaceId),
        operationsApi ? operationsApi.connectors(workspaceId) : Promise.resolve([])
      ]);
      setTools(t);
      setKeys(k);
      setWebhooks(w);
      setDeliveries(del);
      setCalendars(cal.items);
      setPlatformOAuthConfigured(cal.platformOAuthConfigured);
      setConnectors(conn);
      setAudit(a);
      setDocs(d);
      setTrust(tr2);
      setError(void 0);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "INTEGRATIONS_LOAD_FAILED");
    } finally {
      setBusy(false);
    }
  }, [api, operationsApi, workspaceId]);
  useEffect14(() => {
    void load();
  }, [load]);
  useEffect14(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const oauthStatus = params.get("calendarOAuth");
    if (!oauthStatus) return;
    const reason = params.get("reason")?.trim() || void 0;
    if (oauthStatus === "connected") {
      setOauthBanner({
        kind: "success",
        message: reason ? `Google takvim ba\u011Fland\u0131 (${reason})` : "Google takvim ba\u015Far\u0131yla ba\u011Fland\u0131."
      });
      setTab("calendar");
    } else if (oauthStatus === "error") {
      setOauthBanner({
        kind: "error",
        message: reason ? `Takvim OAuth hata: ${reason}` : "Takvim OAuth tamamlanamad\u0131."
      });
      setTab("calendar");
    }
    params.delete("calendarOAuth");
    params.delete("reason");
    params.delete("connectionId");
    const qs = params.toString();
    const next = `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`;
    window.history.replaceState({}, "", next);
  }, []);
  return /* @__PURE__ */ jsxs16("section", { className: "integrations-page studio-page", children: [
    /* @__PURE__ */ jsxs16("header", { className: "studio-toolbar", children: [
      /* @__PURE__ */ jsxs16("div", { children: [
        /* @__PURE__ */ jsx16("span", { children: "INTEGRATIONS" }),
        /* @__PURE__ */ jsx16("h2", { children: "Entegrasyonlar \xB7 API" })
      ] }),
      /* @__PURE__ */ jsx16("button", { type: "button", disabled: busy, onClick: () => void load(), children: "Yenile" })
    ] }),
    /* @__PURE__ */ jsxs16("p", { className: "integrations-note", children: [
      "M\xFC\u015Fteri CRM tool kayd\u0131, workspace API anahtarlar\u0131 (scoped), webhook abonelikleri, WhatsApp Cloud connector durumu ve takvim ba\u011Flant\u0131s\u0131 (mock / Google). Ajan allowlist:",
      " ",
      /* @__PURE__ */ jsx16("code", { children: "customer:tool_ad\u0131" }),
      " \xB7 WA ",
      /* @__PURE__ */ jsx16("code", { children: "connector:\u2026#messages_send_*" }),
      ". Randevu arac\u0131 aktif takvim ba\u011Flant\u0131s\u0131 varsa ",
      /* @__PURE__ */ jsx16("code", { children: "appointment.book" }),
      " senkron dener."
    ] }),
    error && /* @__PURE__ */ jsx16("div", { className: "studio-alert error", children: error }),
    oauthBanner && /* @__PURE__ */ jsxs16(
      "div",
      {
        className: `studio-alert ${oauthBanner.kind === "success" ? "success" : "error"}`,
        role: "status",
        children: [
          oauthBanner.message,
          /* @__PURE__ */ jsx16("button", { type: "button", onClick: () => setOauthBanner(void 0), style: { marginLeft: 12 }, children: "Kapat" })
        ]
      }
    ),
    secretOnce && /* @__PURE__ */ jsxs16("div", { className: "studio-alert success integrations-secret-once", children: [
      /* @__PURE__ */ jsx16("strong", { children: "API secret (bir kez g\xF6sterilir \u2014 kopyalay\u0131n):" }),
      /* @__PURE__ */ jsx16("code", { children: secretOnce }),
      /* @__PURE__ */ jsx16("button", { type: "button", onClick: () => setSecretOnce(void 0), children: "Gizle" })
    ] }),
    /* @__PURE__ */ jsx16("div", { className: "integrations-tabs", children: [
      ["tools", "Tools"],
      ["keys", "API Keys"],
      ["webhooks", "Webhooks"],
      ["calendar", "Calendar"],
      ["whatsapp", "WhatsApp"],
      ["audit", "Audit"],
      ["docs", "Docs"],
      ["trust", "Trust v1"]
    ].map(([id, label]) => /* @__PURE__ */ jsx16(
      "button",
      {
        type: "button",
        className: tab === id ? "active" : "",
        onClick: () => setTab(id),
        children: label
      },
      id
    )) }),
    tab === "tools" && /* @__PURE__ */ jsxs16("div", { className: "studio-grid", children: [
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "YEN\u0130 TOOL" }),
          /* @__PURE__ */ jsx16("h3", { children: "HTTPS function kayd\u0131" })
        ] }) }),
        /* @__PURE__ */ jsxs16(
          "form",
          {
            className: "integrations-form",
            onSubmit: (event) => void onCreateTool(event, api, workspaceId, setBusy, setError, load),
            children: [
              /* @__PURE__ */ jsxs16("label", { children: [
                "Ad (snake_case)",
                /* @__PURE__ */ jsx16("input", { name: "name", required: true, placeholder: "crm_create_lead" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "A\xE7\u0131klama",
                /* @__PURE__ */ jsx16("input", { name: "description", placeholder: "CRM\u2019e lead yazar" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Method",
                /* @__PURE__ */ jsx16("select", { name: "method", defaultValue: "POST", children: ["GET", "POST", "PUT", "PATCH", "DELETE"].map((m) => /* @__PURE__ */ jsx16("option", { value: m, children: m }, m)) })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "HTTPS URL",
                /* @__PURE__ */ jsx16("input", { name: "url", required: true, placeholder: "https://api.example.com/leads" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Auth header",
                /* @__PURE__ */ jsx16("input", { name: "authHeaderName", defaultValue: "Authorization" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Auth secret (opsiyonel)",
                /* @__PURE__ */ jsx16("input", { name: "authSecret", type: "password", placeholder: "Bearer \u2026" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "inputSchema JSON (opsiyonel)",
                /* @__PURE__ */ jsx16(
                  "textarea",
                  {
                    name: "inputSchema",
                    rows: 3,
                    placeholder: '{"fields":{"name":"summary","phone":"$phoneE164"}}'
                  }
                )
              ] }),
              /* @__PURE__ */ jsx16("button", { disabled: busy, children: "Tool kaydet" })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "KAYITLI" }),
          /* @__PURE__ */ jsxs16("h3", { children: [
            tools.length,
            " tool"
          ] })
        ] }) }),
        tools.length === 0 ? /* @__PURE__ */ jsx16("p", { className: "voice-tool-empty", children: "Hen\xFCz tool yok." }) : tools.map((tool) => /* @__PURE__ */ jsxs16("div", { className: "integrations-row", children: [
          /* @__PURE__ */ jsxs16("div", { children: [
            /* @__PURE__ */ jsxs16("strong", { children: [
              tool.method,
              " \xB7 ",
              tool.name
            ] }),
            /* @__PURE__ */ jsx16("small", { children: tool.url }),
            /* @__PURE__ */ jsx16("small", { children: tool.enabled ? "aktif" : "kapal\u0131" })
          ] }),
          /* @__PURE__ */ jsx16(
            "button",
            {
              type: "button",
              disabled: busy,
              onClick: () => void api.deleteTool(tool.id).then(load).catch(
                (cause) => setError(cause instanceof Error ? cause.message : "DELETE_FAILED")
              ),
              children: "Sil"
            }
          )
        ] }, tool.id))
      ] })
    ] }),
    tab === "keys" && /* @__PURE__ */ jsxs16("div", { className: "studio-grid", children: [
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "YEN\u0130 KEY" }),
          /* @__PURE__ */ jsx16("h3", { children: "Workspace API key" })
        ] }) }),
        /* @__PURE__ */ jsxs16(
          "form",
          {
            className: "integrations-form",
            onSubmit: (event) => void onCreateKey(event, api, workspaceId, setBusy, setError, setSecretOnce, load),
            children: [
              /* @__PURE__ */ jsxs16("label", { children: [
                "\u0130sim",
                /* @__PURE__ */ jsx16("input", { name: "name", required: true, placeholder: "CRM production" })
              ] }),
              /* @__PURE__ */ jsxs16("fieldset", { className: "integrations-scopes", children: [
                /* @__PURE__ */ jsx16("legend", { children: "Scopes" }),
                SCOPES.map((scope) => /* @__PURE__ */ jsxs16("label", { className: "voice-consent", children: [
                  /* @__PURE__ */ jsx16("input", { type: "checkbox", name: "scope", value: scope, defaultChecked: scope === "calls.read" }),
                  scope
                ] }, scope))
              ] }),
              /* @__PURE__ */ jsx16("button", { disabled: busy, children: "Key olu\u015Ftur" })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "KEYS" }),
          /* @__PURE__ */ jsxs16("h3", { children: [
            keys.length,
            " key"
          ] })
        ] }) }),
        keys.length === 0 ? /* @__PURE__ */ jsx16("p", { className: "voice-tool-empty", children: "Hen\xFCz key yok." }) : keys.map((key) => /* @__PURE__ */ jsxs16("div", { className: "integrations-row", children: [
          /* @__PURE__ */ jsxs16("div", { children: [
            /* @__PURE__ */ jsx16("strong", { children: key.name }),
            /* @__PURE__ */ jsxs16("small", { children: [
              key.keyPrefix,
              "\u2026 \xB7 ",
              key.status,
              " \xB7 ",
              key.scopes.join(", ")
            ] })
          ] }),
          key.status === "active" && /* @__PURE__ */ jsx16(
            "button",
            {
              type: "button",
              disabled: busy,
              onClick: () => void api.revokeKey(key.id).then(load).catch(
                (cause) => setError(cause instanceof Error ? cause.message : "REVOKE_FAILED")
              ),
              children: "Revoke"
            }
          )
        ] }, key.id))
      ] })
    ] }),
    tab === "webhooks" && /* @__PURE__ */ jsxs16("div", { className: "studio-grid", children: [
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "WEBHOOK" }),
          /* @__PURE__ */ jsx16("h3", { children: "Event aboneli\u011Fi" })
        ] }) }),
        /* @__PURE__ */ jsxs16(
          "form",
          {
            className: "integrations-form",
            onSubmit: (event) => void onCreateWebhook(event, api, workspaceId, setBusy, setError, load),
            children: [
              /* @__PURE__ */ jsxs16("label", { children: [
                "Event",
                /* @__PURE__ */ jsxs16("select", { name: "eventType", defaultValue: "call.completed", children: [
                  /* @__PURE__ */ jsx16("option", { value: "call.completed", children: "call.completed" }),
                  /* @__PURE__ */ jsx16("option", { value: "lead.created", children: "lead.created" }),
                  /* @__PURE__ */ jsx16("option", { value: "tool.failed", children: "tool.failed" }),
                  /* @__PURE__ */ jsx16("option", { value: "risk.flagged", children: "risk.flagged" })
                ] })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Target HTTPS URL",
                /* @__PURE__ */ jsx16("input", { name: "targetUrl", required: true, placeholder: "https://hooks.example.com/centeros" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Secret (opsiyonel)",
                /* @__PURE__ */ jsx16("input", { name: "secret", type: "password" })
              ] }),
              /* @__PURE__ */ jsx16("button", { disabled: busy, children: "Webhook ekle" })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "ABONEL\u0130KLER" }),
          /* @__PURE__ */ jsx16("h3", { children: webhooks.length })
        ] }) }),
        webhooks.length === 0 ? /* @__PURE__ */ jsx16("p", { className: "voice-tool-empty", children: "Webhook yok." }) : webhooks.map((item) => /* @__PURE__ */ jsxs16("div", { className: "integrations-row", children: [
          /* @__PURE__ */ jsxs16("div", { children: [
            /* @__PURE__ */ jsx16("strong", { children: item.eventType }),
            /* @__PURE__ */ jsx16("small", { children: item.targetUrl })
          ] }),
          /* @__PURE__ */ jsx16(
            "button",
            {
              type: "button",
              disabled: busy,
              onClick: () => void api.deleteWebhook(item.id).then(load).catch(
                (cause) => setError(cause instanceof Error ? cause.message : "DELETE_FAILED")
              ),
              children: "Sil"
            }
          )
        ] }, item.id)),
        /* @__PURE__ */ jsx16("h4", { children: "Son teslimatlar" }),
        /* @__PURE__ */ jsx16("p", { className: "integrations-note", style: { marginTop: 0 }, children: "Ba\u015Far\u0131s\u0131z 5xx/timeout denemeleri otomatik yeniden kuyru\u011Fa al\u0131n\u0131r (30s \u2192 2m \u2192 \u2026, max 6)." }),
        deliveries.length === 0 ? /* @__PURE__ */ jsx16("p", { className: "voice-tool-empty", children: "Hen\xFCz teslimat yok. Arama tamamlan\u0131nca call.completed aboneliklerine POST at\u0131l\u0131r." }) : deliveries.slice(0, 20).map((item) => /* @__PURE__ */ jsx16(
          "div",
          {
            className: `integrations-row delivery-${item.status}`,
            children: /* @__PURE__ */ jsxs16("div", { children: [
              /* @__PURE__ */ jsxs16("strong", { children: [
                item.eventType,
                " \xB7 ",
                item.status,
                item.httpStatus != null ? ` \xB7 HTTP ${item.httpStatus}` : "",
                item.attempt > 1 ? ` \xB7 deneme ${item.attempt}` : ""
              ] }),
              /* @__PURE__ */ jsxs16("small", { children: [
                item.targetUrl,
                item.errorCode ? ` \xB7 ${item.errorCode}` : ""
              ] }),
              /* @__PURE__ */ jsx16("small", { children: item.createdAt })
            ] })
          },
          item.id
        ))
      ] })
    ] }),
    tab === "calendar" && /* @__PURE__ */ jsxs16("div", { className: "studio-grid", children: [
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "CALENDAR" }),
          /* @__PURE__ */ jsx16("h3", { children: "Takvim ba\u011Flant\u0131s\u0131" })
        ] }) }),
        /* @__PURE__ */ jsxs16("p", { className: "integrations-note", children: [
          /* @__PURE__ */ jsx16("b", { children: "SaaS multi-tenant:" }),
          " M\xFC\u015Fteri ",
          /* @__PURE__ */ jsx16("b", { children: "Google ile ba\u011Fla" }),
          " ile OAuth consent verir; refresh token workspace\u2019e \xF6zel AES-GCM ile \u015Fifrelenir, API\u2019de bir daha okunmaz. Plan gate: ",
          /* @__PURE__ */ jsx16("code", { children: "integrations.calendar" }),
          ". ",
          /* @__PURE__ */ jsx16("b", { children: "mock" }),
          " yaln\u0131zca sandbox/demo \u2014 randevu senkronu denemeleri i\xE7in."
        ] }),
        !platformOAuthConfigured && /* @__PURE__ */ jsxs16("div", { className: "studio-alert error", style: { marginBottom: 14 }, children: [
          /* @__PURE__ */ jsx16("strong", { children: "Platform Google OAuth yap\u0131land\u0131r\u0131lmam\u0131\u015F" }),
          /* @__PURE__ */ jsxs16("p", { className: "integrations-note", style: { margin: "8px 0 0" }, children: [
            "Kod: ",
            /* @__PURE__ */ jsx16("code", { children: "GOOGLE_CALENDAR_OAUTH_NOT_CONFIGURED" }),
            ". Ops, platform env\u2019de (de\u011Ferler burada g\xF6sterilmez) \u015Funlar\u0131 ayarlamal\u0131:"
          ] }),
          /* @__PURE__ */ jsxs16("ul", { className: "integrations-docs", style: { margin: "8px 0 0", paddingLeft: 18 }, children: [
            /* @__PURE__ */ jsx16("li", { children: /* @__PURE__ */ jsx16("code", { children: "GOOGLE_CALENDAR_CLIENT_ID" }) }),
            /* @__PURE__ */ jsx16("li", { children: /* @__PURE__ */ jsx16("code", { children: "GOOGLE_CALENDAR_CLIENT_SECRET" }) }),
            /* @__PURE__ */ jsxs16("li", { children: [
              /* @__PURE__ */ jsx16("code", { children: "GOOGLE_CALENDAR_REDIRECT_URI" }),
              " veya",
              " ",
              /* @__PURE__ */ jsx16("code", { children: "CENTEROS_PUBLIC_API_BASE_URL" }),
              " (callback t\xFCretilir)"
            ] }),
            /* @__PURE__ */ jsxs16("li", { children: [
              "opsiyonel: ",
              /* @__PURE__ */ jsx16("code", { children: "GOOGLE_CALENDAR_OAUTH_STATE_SECRET" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs16("div", { className: "integrations-form", style: { marginBottom: 16 }, children: [
          /* @__PURE__ */ jsx16(
            "button",
            {
              type: "button",
              disabled: busy || !platformOAuthConfigured,
              title: platformOAuthConfigured ? "Google OAuth consent ba\u015Flat" : "GOOGLE_CALENDAR_OAUTH_NOT_CONFIGURED",
              onClick: () => {
                if (!platformOAuthConfigured) {
                  setError("GOOGLE_CALENDAR_OAUTH_NOT_CONFIGURED");
                  return;
                }
                setBusy(true);
                setError(void 0);
                void api.startGoogleCalendarOAuth({
                  workspaceId,
                  calendarId: "primary",
                  returnPath: "/integrations?tab=calendar"
                }).then((result) => {
                  window.location.assign(result.authorizeUrl);
                }).catch((cause) => {
                  setError(
                    cause instanceof Error ? cause.message : "GOOGLE_OAUTH_START_FAILED"
                  );
                  setBusy(false);
                });
              },
              children: "Google ile ba\u011Fla (OAuth)"
            }
          ),
          !platformOAuthConfigured ? /* @__PURE__ */ jsxs16("small", { className: "integrations-note", children: [
            "Devre d\u0131\u015F\u0131: ",
            /* @__PURE__ */ jsx16("code", { children: "GOOGLE_CALENDAR_OAUTH_NOT_CONFIGURED" }),
            " \u2014 platform client id/secret/redirect env yok. Mock sandbox demo ile randevu senkronu test edilebilir."
          ] }) : /* @__PURE__ */ jsx16("small", { className: "integrations-note", children: "M\xFC\u015Fteri Google hesab\u0131na t\u0131klar, izin verir; callback token\u2019\u0131 \u015Fifreleyip kaydeder." })
        ] }),
        /* @__PURE__ */ jsxs16(
          "form",
          {
            className: "integrations-form",
            onSubmit: (event) => {
              event.preventDefault();
              const data = new FormData(event.currentTarget);
              const provider = String(data.get("provider") || "mock");
              const refreshToken = String(data.get("refreshToken") || "").trim();
              setBusy(true);
              setError(void 0);
              void api.upsertCalendar({
                workspaceId,
                provider,
                calendarId: String(data.get("calendarId") || "primary"),
                accountEmail: String(data.get("accountEmail") || "").trim() || null,
                ...refreshToken ? { refreshToken } : {},
                environment: provider === "mock" ? "sandbox" : "production",
                enabled: true
              }).then(() => {
                event.currentTarget.reset();
                return load();
              }).catch(
                (cause) => setError(cause instanceof Error ? cause.message : "CALENDAR_UPSERT_FAILED")
              ).finally(() => setBusy(false));
            },
            children: [
              /* @__PURE__ */ jsxs16("label", { children: [
                "Provider (sandbox demo / geli\u015Fmi\u015F)",
                /* @__PURE__ */ jsxs16("select", { name: "provider", defaultValue: "mock", children: [
                  /* @__PURE__ */ jsx16("option", { value: "mock", children: "mock \xB7 sandbox demo (\xFCretim de\u011Fil)" }),
                  /* @__PURE__ */ jsx16("option", { value: "google", children: "google (manuel refresh token \u2014 ops)" })
                ] })
              ] }),
              /* @__PURE__ */ jsxs16("p", { className: "integrations-note", style: { margin: 0 }, children: [
                /* @__PURE__ */ jsx16("b", { children: "Mock = sandbox/demo:" }),
                " ger\xE7ek Google hesab\u0131 gerekmez;",
                " ",
                /* @__PURE__ */ jsx16("code", { children: "appointment.book" }),
                " senkron denemeleri i\xE7in ba\u011Flant\u0131 olu\u015Fturur. Production Google i\xE7in OAuth tercih edilir."
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Calendar id",
                /* @__PURE__ */ jsx16("input", { name: "calendarId", defaultValue: "primary" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Customer Google account email",
                /* @__PURE__ */ jsx16("input", { name: "accountEmail", type: "email", placeholder: "musteri@firma.com" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Manuel refresh token (opsiyonel; OAuth tercih edilir)",
                /* @__PURE__ */ jsx16(
                  "input",
                  {
                    name: "refreshToken",
                    type: "password",
                    autoComplete: "off",
                    placeholder: "Yaln\u0131zca kaydetmede g\xF6nderilir; listede g\xF6r\xFCnmez"
                  }
                )
              ] }),
              /* @__PURE__ */ jsx16("button", { disabled: busy, children: "Ba\u011Flant\u0131y\u0131 kaydet" })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "BA\u011ELANTILAR" }),
          /* @__PURE__ */ jsx16("h3", { children: calendars.length })
        ] }) }),
        calendars.length === 0 ? /* @__PURE__ */ jsxs16("p", { className: "voice-tool-empty", children: [
          "Takvim ba\u011Flant\u0131s\u0131 yok. Platform OAuth haz\u0131rsa ",
          /* @__PURE__ */ jsx16("b", { children: "Google ile ba\u011Fla" }),
          "; sandbox demo i\xE7in ",
          /* @__PURE__ */ jsx16("b", { children: "mock" }),
          " kayd\u0131 kullan\u0131n."
        ] }) : calendars.map((item) => {
          const isMockDemo = item.provider === "mock" || item.environment === "sandbox";
          const connectedAt = item.createdAt ? new Date(item.createdAt).toLocaleString() : "\u2014";
          return /* @__PURE__ */ jsxs16("div", { className: "integrations-row", children: [
            /* @__PURE__ */ jsxs16("div", { children: [
              /* @__PURE__ */ jsxs16("strong", { children: [
                item.provider,
                " \xB7 ",
                item.status,
                " \xB7 ",
                item.environment,
                isMockDemo ? " \xB7 DEMO/SANDBOX" : "",
                item.status === "error" ? " \xB7 HATA" : ""
              ] }),
              /* @__PURE__ */ jsxs16("small", { children: [
                "calendarId: ",
                item.calendarId,
                item.accountEmail ? ` \xB7 ${item.accountEmail}` : ""
              ] }),
              /* @__PURE__ */ jsxs16("small", { children: [
                "credentialsConfigured:",
                " ",
                item.credentialsConfigured ? "true" : "false",
                item.lastError ? ` \xB7 lastError: ${item.lastError}` : ""
              ] }),
              /* @__PURE__ */ jsxs16("small", { children: [
                "connectedAt: ",
                connectedAt,
                item.updatedAt ? ` \xB7 updatedAt: ${new Date(item.updatedAt).toLocaleString()}` : ""
              ] })
            ] }),
            /* @__PURE__ */ jsxs16("div", { style: { display: "flex", gap: 8, flexWrap: "wrap" }, children: [
              item.provider === "google" && /* @__PURE__ */ jsx16(
                "button",
                {
                  type: "button",
                  disabled: busy || !platformOAuthConfigured,
                  title: platformOAuthConfigured ? "Yeniden OAuth consent \u2014 token rotation" : "GOOGLE_CALENDAR_OAUTH_NOT_CONFIGURED",
                  onClick: () => {
                    if (!platformOAuthConfigured) {
                      setError("GOOGLE_CALENDAR_OAUTH_NOT_CONFIGURED");
                      return;
                    }
                    setBusy(true);
                    setError(void 0);
                    void api.startGoogleCalendarOAuth({
                      workspaceId,
                      calendarId: item.calendarId || "primary",
                      returnPath: "/integrations?tab=calendar"
                    }).then((result) => {
                      window.location.assign(result.authorizeUrl);
                    }).catch((cause) => {
                      setError(
                        cause instanceof Error ? cause.message : "GOOGLE_OAUTH_START_FAILED"
                      );
                      setBusy(false);
                    });
                  },
                  children: "Yeniden ba\u011Fla"
                }
              ),
              item.credentialsConfigured && /* @__PURE__ */ jsx16(
                "button",
                {
                  type: "button",
                  disabled: busy,
                  title: "Encrypted credentials sil \u2014 re-OAuth gerekir",
                  onClick: () => {
                    if (!window.confirm(
                      "Kimlik bilgilerini temizlemek token rotation\u2019d\u0131r. Yeniden Google ile ba\u011Flanmak gerekir. Devam?"
                    )) {
                      return;
                    }
                    setBusy(true);
                    void api.clearCalendarCredentials(item.id).then(load).catch(
                      (cause) => setError(
                        cause instanceof Error ? cause.message : "CLEAR_CREDS_FAILED"
                      )
                    ).finally(() => setBusy(false));
                  },
                  children: "Kimlik bilgilerini temizle"
                }
              ),
              item.status === "active" && /* @__PURE__ */ jsx16(
                "button",
                {
                  type: "button",
                  disabled: busy,
                  onClick: () => void api.disableCalendar(item.id).then(load).catch(
                    (cause) => setError(
                      cause instanceof Error ? cause.message : "DISABLE_FAILED"
                    )
                  ),
                  children: "Disable"
                }
              )
            ] })
          ] }, item.id);
        })
      ] })
    ] }),
    tab === "whatsapp" && /* @__PURE__ */ jsx16("div", { className: "studio-grid", children: !operationsApi ? /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
      /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
        /* @__PURE__ */ jsx16("small", { children: "WHATSAPP CLOUD" }),
        /* @__PURE__ */ jsx16("h3", { children: "Connector durumu" })
      ] }) }),
      /* @__PURE__ */ jsxs16("p", { className: "voice-tool-empty", children: [
        "Connector listesi i\xE7in Operations API ba\u011Fl\u0131 de\u011Fil. Operations Studio \xFCzerinden WhatsApp durum panelini kullan\u0131n veya shell\u2019e ",
        /* @__PURE__ */ jsx16("code", { children: "operationsApi" }),
        " ge\xE7in."
      ] }),
      onOpenOperations && /* @__PURE__ */ jsx16("button", { type: "button", onClick: onOpenOperations, children: "Operations" })
    ] }) : /* @__PURE__ */ jsx16(
      WhatsAppConnectorStatusPanel,
      {
        connectors,
        invokeApi: {
          invokeConnector: (connectorId, input) => operationsApi.invokeConnector(connectorId, input)
        },
        ...onOpenOperations ? { onNavigateOperations: onOpenOperations } : {},
        title: "WhatsApp Cloud \xB7 Entegrasyonlar"
      }
    ) }),
    tab === "audit" && /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
      /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
        /* @__PURE__ */ jsx16("small", { children: "AUDIT" }),
        /* @__PURE__ */ jsx16("h3", { children: "Tool execution timeline" })
      ] }) }),
      audit.length === 0 ? /* @__PURE__ */ jsx16("p", { className: "voice-tool-empty", children: "Hen\xFCz execution yok." }) : audit.map((item) => /* @__PURE__ */ jsxs16("div", { className: `voice-tool-item status-${item.status}`, children: [
        /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("strong", { children: item.toolName }),
          /* @__PURE__ */ jsx16("em", { children: item.status })
        ] }),
        /* @__PURE__ */ jsx16("p", { children: item.userSafeMessage }),
        /* @__PURE__ */ jsxs16("small", { children: [
          item.createdAt,
          item.callId ? ` \xB7 ${item.callId}` : ""
        ] })
      ] }, item.id))
    ] }),
    tab === "docs" && docs && /* @__PURE__ */ jsxs16("article", { className: "studio-card integrations-docs", children: [
      /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
        /* @__PURE__ */ jsx16("small", { children: "DOCS" }),
        /* @__PURE__ */ jsx16("h3", { children: "Workspace API" })
      ] }) }),
      /* @__PURE__ */ jsxs16("p", { children: [
        "Auth: ",
        /* @__PURE__ */ jsx16("code", { children: "Authorization: Bearer cos_live_\u2026" })
      ] }),
      /* @__PURE__ */ jsx16("p", { children: docs.auth.note }),
      /* @__PURE__ */ jsx16("h4", { children: "Endpoints" }),
      /* @__PURE__ */ jsx16("ul", { children: docs.endpoints.map((ep) => /* @__PURE__ */ jsxs16("li", { children: [
        /* @__PURE__ */ jsxs16("code", { children: [
          ep.method,
          " ",
          ep.path
        ] }),
        " ",
        /* @__PURE__ */ jsxs16("small", { children: [
          "(",
          ep.scope,
          ") \u2014 ",
          ep.summary
        ] })
      ] }, `${ep.method}${ep.path}`)) }),
      /* @__PURE__ */ jsx16("h4", { children: "Tool kurallar\u0131" }),
      /* @__PURE__ */ jsx16("ul", { children: docs.toolConventions.map((line) => /* @__PURE__ */ jsx16("li", { children: line }, line)) })
    ] }),
    tab === "trust" && trust && /* @__PURE__ */ jsxs16("div", { className: "studio-grid", children: [
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "TRUST V1" }),
          /* @__PURE__ */ jsx16("h3", { children: "Platform CLI korumas\u0131" })
        ] }) }),
        /* @__PURE__ */ jsx16("ul", { className: "integrations-docs", children: trust.rules.map((rule) => /* @__PURE__ */ jsx16("li", { children: rule }, rule)) }),
        /* @__PURE__ */ jsxs16("div", { className: "performance-kpi-grid", style: { gridTemplateColumns: "repeat(3,1fr)" }, children: [
          /* @__PURE__ */ jsxs16("div", { className: "performance-kpi", children: [
            /* @__PURE__ */ jsx16("small", { children: "Warm-up kullan\u0131lan" }),
            /* @__PURE__ */ jsxs16("b", { children: [
              trust.warmUp.platformMinutesUsed,
              "/",
              trust.warmUp.dailyMinuteCap,
              " dk"
            ] })
          ] }),
          /* @__PURE__ */ jsxs16("div", { className: "performance-kpi tone-ok", children: [
            /* @__PURE__ */ jsx16("small", { children: "Kalan" }),
            /* @__PURE__ */ jsxs16("b", { children: [
              trust.warmUp.remainingMinutes,
              " dk"
            ] })
          ] }),
          /* @__PURE__ */ jsxs16("div", { className: "performance-kpi", children: [
            /* @__PURE__ */ jsx16("small", { children: "Denylist" }),
            /* @__PURE__ */ jsx16("b", { children: trust.denylistCount })
          ] })
        ] }),
        /* @__PURE__ */ jsx16("h4", { children: "Onayl\u0131 ama\xE7 \u015Fablonlar\u0131" }),
        trust.templates.filter((item) => item.allowedOnPlatformExternal).map((item) => /* @__PURE__ */ jsx16("div", { className: "integrations-row", children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsxs16("strong", { children: [
            item.purpose,
            " \xB7 ",
            item.title
          ] }),
          /* @__PURE__ */ jsx16("small", { children: item.scriptHint })
        ] }) }, item.id))
      ] }),
      /* @__PURE__ */ jsxs16("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx16("header", { children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("small", { children: "DNC" }),
          /* @__PURE__ */ jsx16("h3", { children: "Aranmaz listesi" })
        ] }) }),
        /* @__PURE__ */ jsxs16(
          "form",
          {
            className: "integrations-form",
            onSubmit: (event) => void onAddDnc(event, api, workspaceId, setBusy, setError, load),
            children: [
              /* @__PURE__ */ jsxs16("label", { children: [
                "E.164",
                /* @__PURE__ */ jsx16("input", { name: "phoneE164", required: true, placeholder: "+905551112233" })
              ] }),
              /* @__PURE__ */ jsxs16("label", { children: [
                "Sebep",
                /* @__PURE__ */ jsx16("input", { name: "reason", defaultValue: "opt_out" })
              ] }),
              /* @__PURE__ */ jsx16("button", { disabled: busy, children: "DNC ekle" })
            ]
          }
        ),
        trust.dnc.length === 0 ? /* @__PURE__ */ jsx16("p", { className: "voice-tool-empty", children: "DNC bo\u015F." }) : trust.dnc.map((item) => /* @__PURE__ */ jsxs16("div", { className: "integrations-row", children: [
          /* @__PURE__ */ jsxs16("div", { children: [
            /* @__PURE__ */ jsx16("strong", { children: item.phoneMasked }),
            /* @__PURE__ */ jsxs16("small", { children: [
              item.reason,
              " \xB7 ",
              item.source
            ] })
          ] }),
          /* @__PURE__ */ jsx16(
            "button",
            {
              type: "button",
              disabled: busy,
              onClick: () => void api.deleteDnc(item.id).then(load).catch(
                (cause) => setError(cause instanceof Error ? cause.message : "DNC_DELETE_FAILED")
              ),
              children: "Sil"
            }
          )
        ] }, item.id)),
        /* @__PURE__ */ jsx16("h4", { children: "Risk olaylar\u0131" }),
        trust.recentRiskEvents.length === 0 ? /* @__PURE__ */ jsx16("p", { className: "voice-tool-empty", children: "Risk olay\u0131 yok." }) : trust.recentRiskEvents.map((event) => /* @__PURE__ */ jsx16("div", { className: "integrations-row", children: /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx16("strong", { children: event.eventType }),
          /* @__PURE__ */ jsxs16("small", { children: [
            event.detail,
            " \xB7 ",
            event.createdAt
          ] })
        ] }) }, event.id))
      ] })
    ] })
  ] });
};
var onAddDnc = async (event, api, workspaceId, setBusy, setError, load) => {
  event.preventDefault();
  setBusy(true);
  setError(void 0);
  const data = new FormData(event.currentTarget);
  try {
    await api.addDnc({
      workspaceId,
      phoneE164: String(data.get("phoneE164") ?? ""),
      reason: String(data.get("reason") ?? "opt_out")
    });
    event.currentTarget.reset();
    await load();
  } catch (cause) {
    setError(cause instanceof Error ? cause.message : "DNC_ADD_FAILED");
  } finally {
    setBusy(false);
  }
};
var onCreateTool = async (event, api, workspaceId, setBusy, setError, load) => {
  event.preventDefault();
  setBusy(true);
  setError(void 0);
  const data = new FormData(event.currentTarget);
  try {
    const schemaRaw = String(data.get("inputSchema") ?? "").trim();
    let inputSchema;
    if (schemaRaw) {
      const parsed = JSON.parse(schemaRaw);
      if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
        throw new Error("INPUT_SCHEMA_MUST_BE_OBJECT");
      }
      inputSchema = parsed;
    }
    await api.createTool({
      workspaceId,
      name: String(data.get("name") ?? ""),
      description: String(data.get("description") ?? ""),
      method: String(data.get("method") ?? "POST"),
      url: String(data.get("url") ?? ""),
      authHeaderName: String(data.get("authHeaderName") ?? "Authorization"),
      ...String(data.get("authSecret") ?? "") ? { authSecret: String(data.get("authSecret")) } : {},
      ...inputSchema ? { inputSchema } : {}
    });
    event.currentTarget.reset();
    await load();
  } catch (cause) {
    setError(cause instanceof Error ? cause.message : "CREATE_TOOL_FAILED");
  } finally {
    setBusy(false);
  }
};
var onCreateKey = async (event, api, workspaceId, setBusy, setError, setSecretOnce, load) => {
  event.preventDefault();
  setBusy(true);
  setError(void 0);
  const data = new FormData(event.currentTarget);
  const scopes = data.getAll("scope").filter((v) => typeof v === "string");
  try {
    const created = await api.createKey({
      workspaceId,
      name: String(data.get("name") ?? ""),
      scopes
    });
    setSecretOnce(created.secret);
    event.currentTarget.reset();
    await load();
  } catch (cause) {
    setError(cause instanceof Error ? cause.message : "CREATE_KEY_FAILED");
  } finally {
    setBusy(false);
  }
};
var onCreateWebhook = async (event, api, workspaceId, setBusy, setError, load) => {
  event.preventDefault();
  setBusy(true);
  setError(void 0);
  const data = new FormData(event.currentTarget);
  try {
    await api.createWebhook({
      workspaceId,
      eventType: String(data.get("eventType") ?? "call.completed"),
      targetUrl: String(data.get("targetUrl") ?? ""),
      ...String(data.get("secret") ?? "") ? { secret: String(data.get("secret")) } : {}
    });
    event.currentTarget.reset();
    await load();
  } catch (cause) {
    setError(cause instanceof Error ? cause.message : "CREATE_WEBHOOK_FAILED");
  } finally {
    setBusy(false);
  }
};

// src/live-ops.tsx
import { useCallback as useCallback16, useEffect as useEffect16, useMemo as useMemo10, useState as useState17 } from "react";
import {
  liveOpsDashboardSchema,
  voiceCallViewSchema as voiceCallViewSchema4
} from "@agentos/contracts";

// src/brain-live-ops.tsx
import { useCallback as useCallback15, useEffect as useEffect15, useMemo as useMemo9, useState as useState16 } from "react";
import {
  brainLiveOpsDashboardSchema,
  brainTurnsPageSchema
} from "@agentos/contracts";
import { Fragment as Fragment9, jsx as jsx17, jsxs as jsxs17 } from "react/jsx-runtime";
var createBrainLiveOpsApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const headers = { Authorization: `Bearer ${token}` };
  const buildParams = (query) => {
    const params = new URLSearchParams({ workspaceId: query.workspaceId });
    if (query.workspaceIds?.length) params.set("workspaceIds", query.workspaceIds.join(","));
    if (query.from) params.set("from", query.from);
    if (query.to) params.set("to", query.to);
    if (query.baselineFrom) params.set("baselineFrom", query.baselineFrom);
    if (query.baselineTo) params.set("baselineTo", query.baselineTo);
    if (query.channel) params.set("channel", query.channel);
    if (query.agentId) params.set("agentId", query.agentId);
    if (query.brainPath) params.set("brainPath", query.brainPath);
    if (query.primaryIntent) params.set("primaryIntent", query.primaryIntent);
    if (query.callId) params.set("callId", query.callId);
    if (query.page) params.set("page", String(query.page));
    if (query.pageSize) params.set("pageSize", String(query.pageSize));
    return params.toString();
  };
  return {
    summary: async (query) => {
      const response = await fetch(`${base}/v1/ops/brain/summary?${buildParams(query)}`, {
        headers,
        signal: AbortSignal.timeout(2e4)
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.message ?? body.code ?? `HTTP_${response.status}`);
      }
      return brainLiveOpsDashboardSchema.parse(await response.json());
    },
    turns: async (query) => {
      const response = await fetch(`${base}/v1/ops/brain/turns?${buildParams(query)}`, {
        headers,
        signal: AbortSignal.timeout(2e4)
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.message ?? body.code ?? `HTTP_${response.status}`);
      }
      return brainTurnsPageSchema.parse(await response.json());
    }
  };
};
var pct = (rate) => {
  if (rate == null || !Number.isFinite(rate)) return "\u2014";
  return `${Math.round(rate * 1e3) / 10}%`;
};
var ms = (value) => {
  if (value == null || !Number.isFinite(value)) return "\u2014";
  return `${Math.round(value)} ms`;
};
var truncateId = (id, max = 14) => id.length <= max ? id : `${id.slice(0, 6)}\u2026${id.slice(-4)}`;
var toLocalInputValue = (iso) => {
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
var fromLocalInputValue = (value) => {
  if (!value) return void 0;
  const d = new Date(value);
  return Number.isFinite(d.getTime()) ? d.toISOString() : void 0;
};
var defaultRange = () => {
  const to = /* @__PURE__ */ new Date();
  const from = new Date(to.getTime() - 24 * 60 * 60 * 1e3);
  return { from: from.toISOString(), to: to.toISOString() };
};
var BrainLiveOpsPage = ({
  api,
  workspaceId,
  locale: localeProp,
  sessionWorkspaces
}) => {
  const locale = localeFrom(localeProp);
  const t = (text) => translate(locale, text);
  const defaults = useMemo9(() => defaultRange(), []);
  const [from, setFrom] = useState16(defaults.from);
  const [to, setTo] = useState16(defaults.to);
  const [baselineFrom, setBaselineFrom] = useState16("");
  const [baselineTo, setBaselineTo] = useState16("");
  const [channel, setChannel] = useState16("");
  const [brainPath, setBrainPath] = useState16("");
  const [primaryIntent, setPrimaryIntent] = useState16("");
  const [callId, setCallId] = useState16("");
  const [filterWs, setFilterWs] = useState16(workspaceId);
  const [data, setData] = useState16();
  const [turns, setTurns] = useState16();
  const [page, setPage] = useState16(1);
  const [error, setError] = useState16();
  const [busy, setBusy] = useState16(false);
  const [showBaseline, setShowBaseline] = useState16(false);
  const query = useMemo9(() => {
    return {
      workspaceId: filterWs || workspaceId,
      from,
      to,
      ...channel ? { channel } : {},
      ...brainPath ? { brainPath } : {},
      ...primaryIntent ? { primaryIntent } : {},
      ...callId.trim() ? { callId: callId.trim() } : {},
      ...baselineFrom && baselineTo ? { baselineFrom, baselineTo } : {}
    };
  }, [filterWs, workspaceId, from, to, channel, brainPath, primaryIntent, callId, baselineFrom, baselineTo]);
  const load = useCallback15(async () => {
    setBusy(true);
    setError(void 0);
    try {
      const [summary, turnPage] = await Promise.all([
        api.summary(query),
        api.turns({ ...query, page, pageSize: 25 })
      ]);
      setData(summary);
      setTurns(turnPage);
    } catch (err) {
      setError(err instanceof Error ? err.message : t("Failed to load Brain metrics"));
    } finally {
      setBusy(false);
    }
  }, [api, query, page, t]);
  useEffect15(() => {
    void load();
  }, [load]);
  useEffect15(() => {
    if (typeof window === "undefined") return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", "brain");
      url.searchParams.set("from", from);
      url.searchParams.set("to", to);
      if (channel) url.searchParams.set("channel", channel);
      else url.searchParams.delete("channel");
      if (brainPath) url.searchParams.set("brainPath", brainPath);
      else url.searchParams.delete("brainPath");
      if (baselineFrom) url.searchParams.set("baselineFrom", baselineFrom);
      else url.searchParams.delete("baselineFrom");
      if (baselineTo) url.searchParams.set("baselineTo", baselineTo);
      else url.searchParams.delete("baselineTo");
      window.history.replaceState({}, "", url.toString());
    } catch {
    }
  }, [from, to, channel, brainPath, baselineFrom, baselineTo]);
  const o = data?.overview;
  const empty = data?.empty === true;
  return /* @__PURE__ */ jsxs17("section", { className: "brain-live-ops studio-page", "aria-label": t("Brain Live Ops"), children: [
    /* @__PURE__ */ jsxs17("header", { className: "studio-page-header", children: [
      /* @__PURE__ */ jsxs17("div", { children: [
        /* @__PURE__ */ jsx17("h2", { children: t("Brain Live Ops") }),
        /* @__PURE__ */ jsx17("p", { className: "studio-muted", children: t("Measure Brain path mix, LLM reduction, latency, and pilot safety \u2014 read only.") })
      ] }),
      /* @__PURE__ */ jsx17("div", { className: "live-ops-toolbar", children: /* @__PURE__ */ jsx17("button", { type: "button", className: "agentos-btn", onClick: () => void load(), disabled: busy, children: busy ? t("Refreshing\u2026") : t("Refresh") }) })
    ] }),
    data?.pilot_status.pilot_banner && /* @__PURE__ */ jsxs17("p", { className: "live-ops-note", role: "status", children: [
      /* @__PURE__ */ jsx17("strong", { children: t("Brain Pilot Active") }),
      " \xB7 ",
      "V1 ",
      data.pilot_status.brain_v1 ? "ON" : "OFF",
      " \xB7 Router",
      " ",
      data.pilot_status.router ? "ON" : "OFF",
      " \xB7 Allowlist",
      " ",
      data.pilot_status.require_allowlist ? t("required") : t("optional")
    ] }),
    data?.pilot_status.safety_warning && /* @__PURE__ */ jsx17("p", { className: "live-ops-note live-ops-stale-alert", role: "alert", children: t(data.pilot_status.safety_warning) }),
    data?.divergence.end_conflict_alert && /* @__PURE__ */ jsx17("p", { className: "live-ops-note live-ops-stale-alert", role: "alert", children: t("End policy/tool conflict detected (count > 0). Review turns before expanding pilot.") }),
    /* @__PURE__ */ jsxs17("div", { className: "live-ops-scope-bar brain-live-filters", "aria-label": t("Filters"), children: [
      (sessionWorkspaces?.length ?? 0) > 1 && /* @__PURE__ */ jsxs17("label", { children: [
        t("Workspace"),
        /* @__PURE__ */ jsx17("select", { value: filterWs, onChange: (e) => setFilterWs(e.target.value), children: sessionWorkspaces.map((ws) => /* @__PURE__ */ jsx17("option", { value: ws.id, children: ws.name }, ws.id)) })
      ] }),
      /* @__PURE__ */ jsxs17("label", { children: [
        t("From"),
        /* @__PURE__ */ jsx17(
          "input",
          {
            type: "datetime-local",
            value: toLocalInputValue(from),
            onChange: (e) => {
              const v = fromLocalInputValue(e.target.value);
              if (v) setFrom(v);
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs17("label", { children: [
        t("To"),
        /* @__PURE__ */ jsx17(
          "input",
          {
            type: "datetime-local",
            value: toLocalInputValue(to),
            onChange: (e) => {
              const v = fromLocalInputValue(e.target.value);
              if (v) setTo(v);
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs17("label", { children: [
        t("Channel"),
        /* @__PURE__ */ jsxs17("select", { value: channel, onChange: (e) => setChannel(e.target.value), children: [
          /* @__PURE__ */ jsx17("option", { value: "", children: t("All") }),
          /* @__PURE__ */ jsx17("option", { value: "voice", children: "voice" }),
          /* @__PURE__ */ jsx17("option", { value: "webchat", children: "webchat" }),
          /* @__PURE__ */ jsx17("option", { value: "simulator", children: "simulator" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs17("label", { children: [
        t("Brain path"),
        /* @__PURE__ */ jsxs17("select", { value: brainPath, onChange: (e) => setBrainPath(e.target.value), children: [
          /* @__PURE__ */ jsx17("option", { value: "", children: t("All") }),
          /* @__PURE__ */ jsx17("option", { value: "deterministic", children: "deterministic" }),
          /* @__PURE__ */ jsx17("option", { value: "llm", children: "llm" }),
          /* @__PURE__ */ jsx17("option", { value: "legacy", children: "legacy" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs17("label", { children: [
        t("Intent"),
        /* @__PURE__ */ jsx17(
          "input",
          {
            type: "text",
            value: primaryIntent,
            placeholder: "greeting",
            onChange: (e) => setPrimaryIntent(e.target.value.trim())
          }
        )
      ] }),
      /* @__PURE__ */ jsxs17("label", { children: [
        t("Call id"),
        /* @__PURE__ */ jsx17(
          "input",
          {
            type: "text",
            value: callId,
            placeholder: "call_\u2026",
            onChange: (e) => setCallId(e.target.value)
          }
        )
      ] }),
      /* @__PURE__ */ jsx17(
        "button",
        {
          type: "button",
          className: "agentos-btn",
          onClick: () => setShowBaseline((v) => !v),
          children: showBaseline ? t("Hide baseline") : t("Baseline range")
        }
      )
    ] }),
    showBaseline && /* @__PURE__ */ jsxs17("div", { className: "live-ops-scope-bar", "aria-label": t("Baseline comparison"), children: [
      /* @__PURE__ */ jsxs17("label", { children: [
        t("Baseline from"),
        /* @__PURE__ */ jsx17(
          "input",
          {
            type: "datetime-local",
            value: baselineFrom ? toLocalInputValue(baselineFrom) : "",
            onChange: (e) => setBaselineFrom(fromLocalInputValue(e.target.value) ?? "")
          }
        )
      ] }),
      /* @__PURE__ */ jsxs17("label", { children: [
        t("Baseline to"),
        /* @__PURE__ */ jsx17(
          "input",
          {
            type: "datetime-local",
            value: baselineTo ? toLocalInputValue(baselineTo) : "",
            onChange: (e) => setBaselineTo(fromLocalInputValue(e.target.value) ?? "")
          }
        )
      ] }),
      /* @__PURE__ */ jsx17("small", { className: "studio-muted", children: t("Same workspace/channel. Router OFF + CENTEROS_BRAIN_METRICS=1 period.") })
    ] }),
    data && /* @__PURE__ */ jsxs17("p", { className: "live-ops-note", role: "status", children: [
      t("Last updated"),
      ": ",
      new Date(data.generated_at).toLocaleString(),
      data.last_metric_at ? ` \xB7 ${t("Latest metric")}: ${new Date(data.last_metric_at).toLocaleString()}` : "",
      data.freshness_lag_seconds != null ? ` \xB7 ${t("Lag")}: ${data.freshness_lag_seconds}s` : ""
    ] }),
    error && /* @__PURE__ */ jsxs17("div", { className: "studio-card", role: "alert", children: [
      /* @__PURE__ */ jsx17("p", { children: error }),
      /* @__PURE__ */ jsx17("button", { type: "button", className: "agentos-btn primary", onClick: () => void load(), children: t("Retry") })
    ] }),
    busy && !data && /* @__PURE__ */ jsx17("div", { className: "live-ops-kpi-grid live-ops-kpi-primary", "aria-busy": "true", children: [1, 2, 3, 4].map((i) => /* @__PURE__ */ jsx17("article", { className: "studio-card", children: /* @__PURE__ */ jsx17("p", { className: "studio-muted", children: t("Loading\u2026") }) }, i)) }),
    data && empty && /* @__PURE__ */ jsx17("p", { className: "live-ops-empty-quality", role: "status", children: t("No Brain turns in selected period.") }),
    data && !empty && o && /* @__PURE__ */ jsxs17(Fragment9, { children: [
      /* @__PURE__ */ jsx17("h3", { className: "brain-section-title", children: t("Health") }),
      /* @__PURE__ */ jsxs17("div", { className: "live-ops-kpi-grid live-ops-kpi-primary", children: [
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Total Turns"), value: String(o.total_turns) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Brain Active Turns"), value: String(o.brain_active_turns) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Deterministic Turns"), value: pct(o.deterministic_rate), hint: t("of brain-active post turns") }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Fail-open"), value: pct(o.fail_open_rate), tone: (o.fail_open_rate ?? 0) > 0.05 ? "warn" : "ok" }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Conversations"), value: String(o.conversations_count) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Calls"), value: String(o.calls_count) })
      ] }),
      /* @__PURE__ */ jsx17("h3", { className: "brain-section-title", children: t("Response Latency") }),
      !data.latency.samples_available ? /* @__PURE__ */ jsx17("p", { className: "live-ops-empty-quality", role: "status", children: t("Latency samples unavailable.") }) : /* @__PURE__ */ jsxs17(Fragment9, { children: [
        /* @__PURE__ */ jsxs17("div", { className: "live-ops-kpi-grid live-ops-kpi-latency", children: [
          /* @__PURE__ */ jsx17(KpiCard, { label: t("Det p50"), value: ms(data.latency.deterministic_p50_ms) }),
          /* @__PURE__ */ jsx17(KpiCard, { label: t("Det p95"), value: ms(data.latency.deterministic_p95_ms) }),
          /* @__PURE__ */ jsx17(KpiCard, { label: t("LLM p50"), value: ms(data.latency.llm_p50_ms) }),
          /* @__PURE__ */ jsx17(KpiCard, { label: t("LLM p95"), value: ms(data.latency.llm_p95_ms) }),
          /* @__PURE__ */ jsx17(
            KpiCard,
            {
              label: t("Latency Coverage"),
              value: pct(data.latency.coverage),
              tone: data.latency.coverage_warning ? "warn" : "ok",
              hint: t("Exact turn join samples / voice-eligible post turns")
            }
          )
        ] }),
        data.latency.coverage_warning && /* @__PURE__ */ jsx17("p", { className: "live-ops-note", role: "status", children: t("Latency coverage below 80%. Treat p95 with caution.") }),
        data.latency.timeseries.length > 0 && /* @__PURE__ */ jsxs17("article", { className: "studio-card", children: [
          /* @__PURE__ */ jsxs17("header", { children: [
            /* @__PURE__ */ jsx17("strong", { children: t("Latency trend") }),
            /* @__PURE__ */ jsxs17("small", { className: "studio-muted", children: [
              " ",
              t("Deterministic vs LLM stop\u2192audio")
            ] })
          ] }),
          /* @__PURE__ */ jsx17("div", { className: "live-ops-trend7d-bars", role: "img", "aria-label": t("Latency trend"), children: data.latency.timeseries.map((pt) => {
            const max = Math.max(
              pt.deterministic_p95_ms ?? 0,
              pt.llm_p95_ms ?? 0,
              1
            );
            const detH = pt.deterministic_p50_ms != null ? pt.deterministic_p50_ms / max * 100 : 0;
            const llmH = pt.llm_p50_ms != null ? pt.llm_p50_ms / max * 100 : 0;
            return /* @__PURE__ */ jsxs17(
              "div",
              {
                className: "live-ops-trend7d-col",
                title: `${pt.bucket} det p50=${ms(pt.deterministic_p50_ms)} llm p50=${ms(pt.llm_p50_ms)} n=${pt.sample_count}`,
                children: [
                  /* @__PURE__ */ jsxs17("div", { className: "brain-latency-bar-pair", children: [
                    /* @__PURE__ */ jsx17("i", { style: { height: `${detH}%` }, className: "brain-bar-det" }),
                    /* @__PURE__ */ jsx17("i", { style: { height: `${llmH}%` }, className: "brain-bar-llm" })
                  ] }),
                  /* @__PURE__ */ jsx17("small", { children: pt.bucket.slice(5, 13) })
                ]
              },
              pt.bucket
            );
          }) })
        ] })
      ] }),
      /* @__PURE__ */ jsx17("h3", { className: "brain-section-title", children: t("LLM Efficiency") }),
      !data.baseline_selected && /* @__PURE__ */ jsx17("p", { className: "live-ops-note", role: "status", children: t("Baseline period not selected") }),
      /* @__PURE__ */ jsxs17("div", { className: "live-ops-kpi-grid live-ops-kpi-primary", children: [
        /* @__PURE__ */ jsx17(KpiCard, { label: t("LLM Calls"), value: pct(o.llm_call_rate), hint: t("llm_called=true / post turns") }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Baseline LLM rate"), value: pct(o.baseline_llm_call_rate) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Pilot LLM rate"), value: pct(o.pilot_llm_call_rate) }),
        /* @__PURE__ */ jsx17(
          KpiCard,
          {
            label: t("LLM reduction"),
            value: o.llm_reduction_label ?? "\u2014",
            ...o.llm_call_rate_delta != null && o.llm_call_rate_delta < 0 ? { tone: "ok" } : o.llm_call_rate_delta != null && o.llm_call_rate_delta > 0 ? { tone: "warn" } : {}
          }
        ),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Input tokens"), value: String(data.tokens.input_sum) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Output tokens"), value: String(data.tokens.output_sum) })
      ] }),
      /* @__PURE__ */ jsxs17("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx17("header", { children: /* @__PURE__ */ jsx17("strong", { children: t("Brain path distribution") }) }),
        /* @__PURE__ */ jsxs17("div", { className: "live-ops-channel-split", children: [
          /* @__PURE__ */ jsx17(
            PathBar,
            {
              label: "Deterministic",
              count: data.path_distribution.deterministic,
              pct: data.path_distribution.deterministic_pct
            }
          ),
          /* @__PURE__ */ jsx17(PathBar, { label: "LLM", count: data.path_distribution.llm, pct: data.path_distribution.llm_pct }),
          /* @__PURE__ */ jsx17(
            PathBar,
            {
              label: "Legacy",
              count: data.path_distribution.legacy,
              pct: data.path_distribution.legacy_pct,
              warn: data.path_distribution.legacy > 0 && data.overview.brain_active_turns > 0
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx17("h3", { className: "brain-section-title", children: t("Intent Mix") }),
      /* @__PURE__ */ jsx17("article", { className: "studio-card", children: /* @__PURE__ */ jsx17("div", { className: "studio-table-wrap", children: /* @__PURE__ */ jsxs17("table", { className: "studio-table", children: [
        /* @__PURE__ */ jsx17("thead", { children: /* @__PURE__ */ jsxs17("tr", { children: [
          /* @__PURE__ */ jsx17("th", { children: t("Intent") }),
          /* @__PURE__ */ jsx17("th", { children: t("Turns") }),
          /* @__PURE__ */ jsxs17("th", { children: [
            "% ",
            t("total")
          ] }),
          /* @__PURE__ */ jsxs17("th", { children: [
            t("Deterministic"),
            " %"
          ] }),
          /* @__PURE__ */ jsxs17("th", { children: [
            t("LLM"),
            " %"
          ] }),
          /* @__PURE__ */ jsxs17("th", { children: [
            t("Latency"),
            " p50"
          ] })
        ] }) }),
        /* @__PURE__ */ jsx17("tbody", { children: data.intents.slice(0, 20).map((row) => /* @__PURE__ */ jsxs17("tr", { children: [
          /* @__PURE__ */ jsx17("td", { children: row.intent }),
          /* @__PURE__ */ jsx17("td", { children: row.turns }),
          /* @__PURE__ */ jsx17("td", { children: pct(row.pct_total) }),
          /* @__PURE__ */ jsx17("td", { children: pct(row.deterministic_pct) }),
          /* @__PURE__ */ jsx17("td", { children: pct(row.llm_pct) }),
          /* @__PURE__ */ jsx17("td", { children: ms(row.stop_p50_ms) })
        ] }, row.intent)) })
      ] }) }) }),
      /* @__PURE__ */ jsx17("h3", { className: "brain-section-title", children: t("Deterministic Templates") }),
      /* @__PURE__ */ jsx17("div", { className: "live-ops-kpi-grid", children: /* @__PURE__ */ jsx17(KpiCard, { label: t("Repeated Templates"), value: String(data.template_repeat.repeated_turns), tone: data.template_repeat.repeated_turns > 0 ? "warn" : "ok" }) }),
      data.template_repeat.top_repeated_template_ids.length > 0 && /* @__PURE__ */ jsxs17("p", { className: "live-ops-note", children: [
        t("Top repeated"),
        ":",
        " ",
        data.template_repeat.top_repeated_template_ids.map((r) => `${r.template_id} (${r.repeat_turns})`).join(", ")
      ] }),
      /* @__PURE__ */ jsx17("article", { className: "studio-card", children: /* @__PURE__ */ jsx17("div", { className: "studio-table-wrap", children: /* @__PURE__ */ jsxs17("table", { className: "studio-table", children: [
        /* @__PURE__ */ jsx17("thead", { children: /* @__PURE__ */ jsxs17("tr", { children: [
          /* @__PURE__ */ jsx17("th", { children: "template_id" }),
          /* @__PURE__ */ jsx17("th", { children: t("Usage") }),
          /* @__PURE__ */ jsx17("th", { children: t("Repeats") }),
          /* @__PURE__ */ jsx17("th", { children: t("Repeat rate") }),
          /* @__PURE__ */ jsx17("th", { children: "p50 stop\u2192audio" }),
          /* @__PURE__ */ jsx17("th", { children: t("Next-turn LLM") })
        ] }) }),
        /* @__PURE__ */ jsx17("tbody", { children: data.templates.slice(0, 20).map((row) => /* @__PURE__ */ jsxs17("tr", { children: [
          /* @__PURE__ */ jsx17("td", { children: /* @__PURE__ */ jsx17("code", { children: row.template_id }) }),
          /* @__PURE__ */ jsx17("td", { children: row.usage_count }),
          /* @__PURE__ */ jsx17("td", { children: row.repeat_count }),
          /* @__PURE__ */ jsx17("td", { children: pct(row.repeat_rate) }),
          /* @__PURE__ */ jsx17("td", { children: ms(row.stop_p50_ms) }),
          /* @__PURE__ */ jsx17("td", { children: pct(row.next_turn_llm_fallback_rate) })
        ] }, row.template_id)) })
      ] }) }) }),
      /* @__PURE__ */ jsx17("h3", { className: "brain-section-title", children: t("Policy / Safety") }),
      /* @__PURE__ */ jsxs17("div", { className: "live-ops-kpi-grid", children: [
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Lead detected"), value: String(data.policy.lead_detected) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Lead actionable"), value: String(data.policy.lead_actionable), hint: t("Observational \u2014 not executed") }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Callback detected"), value: String(data.policy.callback_detected) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Callback actionable"), value: String(data.policy.callback_actionable) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("Decline terminal"), value: String(data.policy.decline_terminal) }),
        /* @__PURE__ */ jsx17(KpiCard, { label: t("End terminal"), value: String(data.policy.end_terminal) })
      ] }),
      /* @__PURE__ */ jsxs17("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsxs17("header", { children: [
          /* @__PURE__ */ jsx17("strong", { children: t("Policy / tool divergence") }),
          /* @__PURE__ */ jsxs17("small", { className: "studio-muted", children: [
            " ",
            t("Observational only \u2014 no tool permission change")
          ] })
        ] }),
        /* @__PURE__ */ jsxs17("ul", { className: "brain-divergence-list", children: [
          /* @__PURE__ */ jsxs17("li", { children: [
            t("Lead actionable, no legacy tool"),
            ":",
            " ",
            /* @__PURE__ */ jsx17("strong", { children: data.divergence.policy_lead_actionable_tool_none })
          ] }),
          /* @__PURE__ */ jsxs17("li", { children: [
            t("Legacy lead tool, policy not actionable"),
            ":",
            " ",
            /* @__PURE__ */ jsx17("strong", { children: data.divergence.legacy_lead_tool_policy_not_actionable })
          ] }),
          /* @__PURE__ */ jsxs17("li", { children: [
            t("Callback actionable, no legacy tool"),
            ":",
            " ",
            /* @__PURE__ */ jsx17("strong", { children: data.divergence.policy_callback_actionable_tool_none })
          ] }),
          /* @__PURE__ */ jsxs17("li", { children: [
            t("Legacy callback tool, policy not actionable"),
            ":",
            " ",
            /* @__PURE__ */ jsx17("strong", { children: data.divergence.legacy_callback_tool_policy_not_actionable })
          ] }),
          /* @__PURE__ */ jsxs17("li", { className: data.divergence.end_conflict_alert ? "is-alert" : "", children: [
            "end_policy_tool_conflict: ",
            /* @__PURE__ */ jsx17("strong", { children: data.divergence.end_policy_tool_conflict_count })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs17("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx17("header", { children: /* @__PURE__ */ jsx17("strong", { children: t("Fail-open") }) }),
        /* @__PURE__ */ jsxs17("ul", { className: "brain-divergence-list", children: [
          /* @__PURE__ */ jsxs17("li", { children: [
            t("Count"),
            ": ",
            data.fail_open.fail_open_count,
            " (",
            pct(data.fail_open.fail_open_rate),
            ")"
          ] }),
          /* @__PURE__ */ jsxs17("li", { children: [
            "classifier_exception: ",
            data.fail_open.classifier_exception_count
          ] }),
          /* @__PURE__ */ jsxs17("li", { children: [
            "policy_exception: ",
            data.fail_open.policy_exception_count
          ] }),
          /* @__PURE__ */ jsxs17("li", { children: [
            "deterministic_missing_response: ",
            data.fail_open.deterministic_missing_response_count
          ] }),
          /* @__PURE__ */ jsxs17("li", { children: [
            "metrics_write_failed: ",
            data.fail_open.metrics_write_failed_count
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs17("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx17("header", { children: /* @__PURE__ */ jsx17("strong", { children: t("Hangup / end") }) }),
        /* @__PURE__ */ jsxs17("ul", { className: "brain-divergence-list", children: [
          Object.entries(data.hangup.counts).map(([k, v]) => /* @__PURE__ */ jsxs17("li", { children: [
            k,
            ": ",
            /* @__PURE__ */ jsx17("strong", { children: v })
          ] }, k)),
          /* @__PURE__ */ jsxs17("li", { children: [
            "soft_farewell_detected: ",
            data.hangup.soft_farewell_detected
          ] }),
          /* @__PURE__ */ jsxs17("li", { children: [
            t("Soft farewell, call not ended"),
            ": ",
            data.hangup.soft_farewell_not_ended,
            " (",
            pct(data.hangup.soft_farewell_not_ended_rate),
            ")"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsx17("h3", { className: "brain-section-title", children: t("Turns") }),
      /* @__PURE__ */ jsxs17("article", { className: "studio-card", children: [
        /* @__PURE__ */ jsx17("div", { className: "studio-table-wrap", children: /* @__PURE__ */ jsxs17("table", { className: "studio-table", children: [
          /* @__PURE__ */ jsx17("thead", { children: /* @__PURE__ */ jsxs17("tr", { children: [
            /* @__PURE__ */ jsx17("th", { children: t("Time") }),
            /* @__PURE__ */ jsx17("th", { children: "path" }),
            /* @__PURE__ */ jsx17("th", { children: "intent" }),
            /* @__PURE__ */ jsx17("th", { children: "template" }),
            /* @__PURE__ */ jsx17("th", { children: "latency" }),
            /* @__PURE__ */ jsx17("th", { children: "tokens" }),
            /* @__PURE__ */ jsx17("th", { children: "turn / call" })
          ] }) }),
          /* @__PURE__ */ jsx17("tbody", { children: (turns?.items ?? []).map((row) => /* @__PURE__ */ jsxs17("tr", { children: [
            /* @__PURE__ */ jsx17("td", { children: new Date(row.created_at).toLocaleString() }),
            /* @__PURE__ */ jsx17("td", { children: row.brain_path }),
            /* @__PURE__ */ jsx17("td", { children: row.primary_intent ?? "\u2014" }),
            /* @__PURE__ */ jsx17("td", { children: /* @__PURE__ */ jsx17("code", { children: row.template_id ? truncateId(row.template_id, 18) : "\u2014" }) }),
            /* @__PURE__ */ jsx17("td", { children: ms(row.stop_to_first_audio_ms) }),
            /* @__PURE__ */ jsxs17("td", { children: [
              row.llm_input_tokens ?? 0,
              "/",
              row.llm_output_tokens ?? 0
            ] }),
            /* @__PURE__ */ jsxs17("td", { title: `${row.turn_id} / ${row.call_id ?? ""}`, children: [
              truncateId(row.turn_id),
              row.call_id ? ` / ${truncateId(row.call_id)}` : ""
            ] })
          ] }, row.id)) })
        ] }) }),
        turns && turns.total > turns.page_size && /* @__PURE__ */ jsxs17("div", { className: "live-ops-toolbar", children: [
          /* @__PURE__ */ jsx17(
            "button",
            {
              type: "button",
              className: "agentos-btn",
              disabled: page <= 1 || busy,
              onClick: () => setPage((p) => Math.max(1, p - 1)),
              children: t("Previous")
            }
          ),
          /* @__PURE__ */ jsxs17("span", { className: "studio-muted", children: [
            t("Page"),
            " ",
            turns.page,
            " / ",
            Math.max(1, Math.ceil(turns.total / turns.page_size)),
            " (",
            turns.total,
            ")"
          ] }),
          /* @__PURE__ */ jsx17(
            "button",
            {
              type: "button",
              className: "agentos-btn",
              disabled: page * turns.page_size >= turns.total || busy,
              onClick: () => setPage((p) => p + 1),
              children: t("Next")
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx17("style", { children: brainLiveOpsStyles })
  ] });
};
var KpiCard = ({
  label,
  value,
  hint,
  tone
}) => /* @__PURE__ */ jsxs17("article", { className: `studio-card brain-kpi${tone ? ` is-${tone}` : ""}`, children: [
  /* @__PURE__ */ jsx17("small", { children: label }),
  /* @__PURE__ */ jsx17("strong", { children: value }),
  hint ? /* @__PURE__ */ jsx17("span", { className: "studio-muted", children: hint }) : null
] });
var PathBar = ({
  label,
  count,
  pct: pathRate,
  warn
}) => /* @__PURE__ */ jsx17("div", { className: `live-ops-channel-card${warn ? " is-alert" : ""}`, children: /* @__PURE__ */ jsxs17("div", { className: "live-ops-channel-card-head", children: [
  /* @__PURE__ */ jsx17("strong", { children: label }),
  /* @__PURE__ */ jsxs17("span", { children: [
    count,
    " (",
    pathRate == null ? "\u2014" : `${Math.round(pathRate * 1e3) / 10}%`,
    ")"
  ] })
] }) });
var brainLiveOpsStyles = `
.brain-live-ops .brain-section-title {
  margin: 1.25rem 0 0.5rem;
  font-size: 0.95rem;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  opacity: 0.85;
}
.brain-live-ops .brain-kpi strong {
  display: block;
  font-size: 1.35rem;
  margin-top: 0.25rem;
}
.brain-live-ops .brain-kpi.is-ok strong { color: var(--agentos-success, #0f766e); }
.brain-live-ops .brain-kpi.is-warn strong { color: var(--agentos-warning, #b45309); }
.brain-live-ops .brain-kpi.is-error strong { color: var(--agentos-danger, #b91c1c); }
.brain-live-ops .brain-divergence-list {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
  line-height: 1.55;
}
.brain-live-ops .brain-divergence-list .is-alert,
.brain-live-ops .live-ops-channel-card.is-alert {
  color: var(--agentos-danger, #b91c1c);
  font-weight: 600;
}
.brain-live-ops .brain-live-filters label {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.8rem;
}
.brain-live-ops .brain-live-filters input,
.brain-live-ops .brain-live-filters select {
  min-width: 9rem;
}
.brain-live-ops .brain-latency-bar-pair {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  height: 72px;
}
.brain-live-ops .brain-bar-det,
.brain-live-ops .brain-bar-llm {
  display: block;
  width: 8px;
  min-height: 2px;
  border-radius: 2px 2px 0 0;
  background: var(--agentos-primary, #0d9488);
}
.brain-live-ops .brain-bar-llm {
  background: color-mix(in srgb, var(--agentos-primary, #0d9488) 45%, #64748b);
  opacity: 0.85;
}
.brain-live-ops .studio-table-wrap { overflow-x: auto; }
.brain-live-ops .studio-table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
.brain-live-ops .studio-table th,
.brain-live-ops .studio-table td {
  text-align: left;
  padding: 0.4rem 0.55rem;
  border-bottom: 1px solid color-mix(in srgb, currentColor 12%, transparent);
}
.brain-live-ops .studio-table code { font-size: 0.8em; }
`;

// src/live-ops.tsx
import { Fragment as Fragment10, jsx as jsx18, jsxs as jsxs18 } from "react/jsx-runtime";
var createLiveOpsApi = (apiBaseUrl, token) => {
  const base = apiBaseUrl.replace(/\/$/u, "");
  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
  return {
    brain: createBrainLiveOpsApi(apiBaseUrl, token),
    dashboard: async (workspaceId, windowMinutes = 60, scope = "workspace") => {
      const params = new URLSearchParams({
        workspaceId,
        windowMinutes: String(windowMinutes),
        scope
      });
      const response = await fetch(`${base}/v1/ops/live?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
        signal: AbortSignal.timeout(15e3)
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.code ?? `HTTP_${response.status}`);
      }
      return liveOpsDashboardSchema.parse(await response.json());
    },
    handoff: async (callId, reason, options) => {
      const response = await fetch(`${base}/v1/calls/${encodeURIComponent(callId)}/handoff`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          reason,
          ...options?.mode ? { mode: options.mode } : { mode: "warm" },
          ...options?.destination ? { destination: options.destination } : {}
        }),
        signal: AbortSignal.timeout(15e3)
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.detail ?? body.code ?? `HTTP_${response.status}`);
      }
      voiceCallViewSchema4.parse(await response.json());
    },
    complete: async (callId, reason = "caller_hangup") => {
      const response = await fetch(`${base}/v1/calls/${encodeURIComponent(callId)}/complete`, {
        method: "POST",
        headers,
        body: JSON.stringify({ reason }),
        signal: AbortSignal.timeout(15e3)
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const code = body.detail ?? body.code ?? `HTTP_${response.status}`;
        if (!/CALL_ALREADY_TERMINAL|CALL_NOT_ACTIVE|already_terminal|HTTP_409/i.test(code)) {
          throw new Error(code);
        }
      } else {
        voiceCallViewSchema4.parse(await response.json());
      }
    }
  };
};
var E164_RE = /^\+[1-9]\d{7,14}$/u;
var BROWSER_DEMO_PROVIDER_RE = /browser_demo/i;
var maskDestination = (value) => value.length <= 7 ? `${value.slice(0, 2)}***` : `${value.slice(0, 4)}***${value.slice(-3)}`;
var humanizeTrust = (event, t) => {
  const type = event.eventType.toLowerCase();
  const detail = event.detail.toUpperCase();
  if (type === "denylist_block" || detail.includes("DENYLIST") || detail.startsWith("NOTE:")) {
    return t("Denylist blocked the call content");
  }
  if (type === "denylist_flag") {
    return t("Denylist flagged (call continued)");
  }
  if (type === "dnc_block" || detail.includes("DNC")) {
    return t("Number is on DNC list");
  }
  if (type === "warmup_block" || detail.includes("WARMUP") || detail.includes("MINUTES=")) {
    return t("Platform warm-up daily minutes exceeded");
  }
  if (type === "precall_reject" || type.includes("precall")) {
    if (detail.includes("PURPOSE_NOT_ALLOWED")) return t("Purpose not allowed");
    if (detail.includes("CUSTOM_PURPOSE_BLOCKED")) return t("Custom purpose blocked");
    if (detail.includes("FREEFORM_NOTE_BLOCKED"))
      return t(
        "Freeform note blocked: clear the purpose note or switch purpose to sales/general (marketing forbids scripts on platform numbers)"
      );
    return t("Precall blocked");
  }
  if (detail.includes("PURPOSE_NOT_ALLOWED") || type.includes("purpose_not_allowed")) {
    return t("Purpose not allowed");
  }
  if (detail.includes("CUSTOM_PURPOSE_BLOCKED") || type.includes("custom_purpose")) {
    return t("Custom purpose blocked");
  }
  if (detail.includes("FREEFORM_NOTE_BLOCKED") || type.includes("freeform")) {
    return t("Freeform note blocked");
  }
  return event.eventType;
};
var LiveOpsPage = ({
  api,
  workspaceId,
  locale: localeProp,
  onOpenCall,
  sessionWorkspaces
}) => {
  const locale = localeFrom(localeProp);
  const t = (text) => translate(locale, text);
  const initialTab = (() => {
    if (typeof window === "undefined") return "calls";
    try {
      return new URL(window.location.href).searchParams.get("tab") === "brain" ? "brain" : "calls";
    } catch {
      return "calls";
    }
  })();
  const [opsTab, setOpsTab] = useState17(initialTab);
  const [data, setData] = useState17();
  const [error, setError] = useState17();
  const [notice, setNotice] = useState17();
  const [busy, setBusy] = useState17(false);
  const [handoffBusyId, setHandoffBusyId] = useState17();
  const [hangupBusyId, setHangupBusyId] = useState17();
  const [windowMinutes, setWindowMinutes] = useState17(60);
  const [autoRefresh, setAutoRefresh] = useState17(true);
  const multiCapable = (sessionWorkspaces?.length ?? 0) > 1;
  const [scope, setScope] = useState17(multiCapable ? "workspace" : "workspace");
  const [filterWs, setFilterWs] = useState17("all");
  const [handoffMode, setHandoffMode] = useState17("warm");
  const [destinationOverride, setDestinationOverride] = useState17("");
  const [lastHandoff, setLastHandoff] = useState17();
  const [showLatency, setShowLatency] = useState17(false);
  const load = useCallback16(async () => {
    setBusy(true);
    try {
      setData(await api.dashboard(workspaceId, windowMinutes, scope));
      setError(void 0);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "LIVE_OPS_LOAD_FAILED");
    } finally {
      setBusy(false);
    }
  }, [api, scope, windowMinutes, workspaceId]);
  useEffect16(() => {
    void load();
  }, [load]);
  useEffect16(() => {
    if (!autoRefresh) return;
    const timer = setInterval(() => {
      void load();
    }, 5e3);
    return () => clearInterval(timer);
  }, [autoRefresh, load]);
  const onHangup = async (call) => {
    setHangupBusyId(call.id);
    setError(void 0);
    setNotice(void 0);
    try {
      await api.complete(call.id, "caller_hangup");
      setNotice(`G\xF6r\xFC\u015Fme kapat\u0131ld\u0131 \xB7 ${call.fromMasked} \u2192 ${call.toMasked}`);
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "HANGUP_FAILED");
    } finally {
      setHangupBusyId(void 0);
    }
  };
  const onHandoff = async (call) => {
    const dest = destinationOverride.trim();
    if (dest && !E164_RE.test(dest)) {
      setError("DESTINATION_MUST_BE_E164 (\xF6rn. +905551112233)");
      setNotice(void 0);
      return;
    }
    setHandoffBusyId(call.id);
    setError(void 0);
    setNotice(void 0);
    try {
      await api.handoff(call.id, "live_ops_operator_barge_in", {
        mode: handoffMode,
        ...dest ? { destination: dest } : {}
      });
      setLastHandoff({
        callId: call.id,
        mode: handoffMode,
        ...dest ? { destinationMasked: maskDestination(dest) } : {}
      });
      setNotice(
        `\u0130nsan aktar\u0131m\u0131 \xB7 ${handoffMode === "warm" ? "s\u0131cak" : "k\xF6r"} \xB7 ${call.fromMasked} \u2192 ${call.toMasked}` + (dest ? ` \xB7 ${maskDestination(dest)}` : "")
      );
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "HANDOFF_FAILED");
    } finally {
      setHandoffBusyId(void 0);
    }
  };
  const latency = data?.latency;
  const quality = data?.quality;
  const counts = data?.counts;
  const visibleCalls = data?.activeCalls.filter(
    (call) => filterWs === "all" || scope === "workspace" || call.workspaceId === filterWs
  ) ?? [];
  const demoSessionsDominate = useMemo10(() => {
    if (visibleCalls.length === 0) return false;
    const allDemo = visibleCalls.every((call) => BROWSER_DEMO_PROVIDER_RE.test(call.provider));
    if (!allDemo) return false;
    const activeCount = counts?.active ?? visibleCalls.length;
    const hasStale = visibleCalls.some(
      (call) => call.durationSeconds >= 300 || Date.now() - Date.parse(call.startedAt) >= 3e5
    );
    return activeCount >= 1 && (activeCount >= 3 || hasStale || visibleCalls.length >= 2);
  }, [visibleCalls, counts?.active]);
  return /* @__PURE__ */ jsxs18("section", { className: "live-ops-page studio-page", children: [
    /* @__PURE__ */ jsxs18("div", { className: "live-ops-tabs", role: "tablist", "aria-label": t("Live ops"), style: { display: "flex", gap: "0.5rem", marginBottom: "0.75rem" }, children: [
      /* @__PURE__ */ jsx18(
        "button",
        {
          type: "button",
          role: "tab",
          "aria-selected": opsTab === "calls",
          className: opsTab === "calls" ? "agentos-btn primary" : "agentos-btn",
          onClick: () => setOpsTab("calls"),
          children: t("Live queue")
        }
      ),
      api.brain ? /* @__PURE__ */ jsx18(
        "button",
        {
          type: "button",
          role: "tab",
          "aria-selected": opsTab === "brain",
          className: opsTab === "brain" ? "agentos-btn primary" : "agentos-btn",
          onClick: () => setOpsTab("brain"),
          children: t("Brain Live Ops")
        }
      ) : null
    ] }),
    opsTab === "brain" && api.brain ? /* @__PURE__ */ jsx18(
      BrainLiveOpsPage,
      {
        api: api.brain,
        workspaceId,
        locale,
        ...sessionWorkspaces ? { sessionWorkspaces } : {}
      }
    ) : null,
    opsTab === "calls" ? /* @__PURE__ */ jsxs18(Fragment10, { children: [
      /* @__PURE__ */ jsxs18("header", { className: "studio-toolbar", children: [
        /* @__PURE__ */ jsxs18("div", { children: [
          /* @__PURE__ */ jsx18("span", { children: "CANLI OPERASYON" }),
          /* @__PURE__ */ jsx18("h2", { children: "Aktif aramalar ve insan aktar\u0131m\u0131" })
        ] }),
        /* @__PURE__ */ jsxs18("div", { className: "live-ops-toolbar", children: [
          /* @__PURE__ */ jsx18("div", { className: "voice-density-toggle", role: "group", "aria-label": "Zaman penceresi", children: [
            [15, "15 dk"],
            [60, "1 sa"],
            [240, "4 sa"],
            [10080, "7g"]
          ].map(([mins, label]) => /* @__PURE__ */ jsx18(
            "button",
            {
              type: "button",
              className: windowMinutes === mins ? "active" : "",
              onClick: () => setWindowMinutes(mins),
              children: label
            },
            mins
          )) }),
          /* @__PURE__ */ jsxs18("label", { className: "voice-consent", children: [
            /* @__PURE__ */ jsx18(
              "input",
              {
                type: "checkbox",
                checked: autoRefresh,
                onChange: (event) => setAutoRefresh(event.target.checked)
              }
            ),
            "Otomatik yenile (5 sn)"
          ] }),
          /* @__PURE__ */ jsx18("button", { type: "button", disabled: busy, onClick: () => void load(), children: "Yenile" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs18("p", { className: "live-ops-note", children: [
        "\xD6nce ",
        /* @__PURE__ */ jsx18("b", { children: "canl\u0131 aramalar" }),
        ". Sat\u0131ra t\u0131klay\u0131nca g\xF6r\xFC\u015Fme kart\u0131 a\xE7\u0131l\u0131r. Aktar\u0131m modunu se\xE7ip",
        " ",
        /* @__PURE__ */ jsx18("b", { children: "\u0130nsana aktar" }),
        " bas\u0131n. G\xFCncellendi:",
        " ",
        /* @__PURE__ */ jsx18("b", { children: data?.generatedAt ? formatTime2(data.generatedAt) : "\u2014" })
      ] }),
      /* @__PURE__ */ jsxs18("div", { className: "live-ops-handoff-bar", "aria-label": "\u0130nsan aktar\u0131m kontrolleri", children: [
        /* @__PURE__ */ jsxs18("div", { className: "voice-density-toggle", role: "group", "aria-label": "Aktar\u0131m modu", children: [
          /* @__PURE__ */ jsx18(
            "button",
            {
              type: "button",
              className: handoffMode === "warm" ? "active" : "",
              onClick: () => setHandoffMode("warm"),
              title: "S\u0131cak aktar\u0131m \u2014 arayan \xE7alma sesi duyar",
              children: "S\u0131cak aktar\u0131m"
            }
          ),
          /* @__PURE__ */ jsx18(
            "button",
            {
              type: "button",
              className: handoffMode === "blind" ? "active" : "",
              onClick: () => setHandoffMode("blind"),
              title: "K\xF6r aktar\u0131m \u2014 sessiz y\xF6nlendirme",
              children: "K\xF6r aktar\u0131m"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs18("label", { className: "live-ops-dest-field", children: [
          /* @__PURE__ */ jsx18("span", { children: "Hedef numara (iste\u011Fe ba\u011Fl\u0131)" }),
          /* @__PURE__ */ jsx18(
            "input",
            {
              type: "tel",
              inputMode: "tel",
              placeholder: "+905551112233",
              value: destinationOverride,
              onChange: (event) => setDestinationOverride(event.target.value),
              "aria-label": "Aktar\u0131m hedef numaras\u0131"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs18("small", { className: "live-ops-handoff-help", children: [
          "Bo\u015F b\u0131rak\u0131rsan\u0131z ajan\u0131n veya platformun varsay\u0131lan hedefi kullan\u0131l\u0131r.",
          " ",
          handoffMode === "warm" ? "S\u0131cak: arayan \xE7alma sesi duyar, operat\xF6r ba\u011Flan\u0131r." : "K\xF6r: sessiz y\xF6nlendirme, arayan bekletme duymayabilir."
        ] })
      ] }),
      /* @__PURE__ */ jsxs18("div", { className: "live-ops-scope-bar", children: [
        /* @__PURE__ */ jsxs18("div", { className: "voice-density-toggle", role: "group", "aria-label": "Kapsam", children: [
          /* @__PURE__ */ jsx18(
            "button",
            {
              type: "button",
              className: scope === "workspace" ? "active" : "",
              onClick: () => {
                setScope("workspace");
                setFilterWs("all");
              },
              children: "Bu \xE7al\u0131\u015Fma alan\u0131"
            }
          ),
          /* @__PURE__ */ jsxs18(
            "button",
            {
              type: "button",
              className: scope === "all" ? "active" : "",
              onClick: () => setScope("all"),
              children: [
                "T\xFCm \xE7al\u0131\u015Fma alanlar\u0131",
                multiCapable ? ` (${sessionWorkspaces?.length ?? data?.workspaces.length ?? 0})` : ""
              ]
            }
          )
        ] }),
        scope === "all" && (data?.workspaces.length ?? 0) > 0 && /* @__PURE__ */ jsxs18("div", { className: "live-ops-ws-chips", role: "group", "aria-label": "\xC7al\u0131\u015Fma alan\u0131 s\xFCzgeci", children: [
          /* @__PURE__ */ jsx18(
            "button",
            {
              type: "button",
              className: filterWs === "all" ? "active" : "",
              onClick: () => setFilterWs("all"),
              children: "Hepsi"
            }
          ),
          (data?.workspaces ?? sessionWorkspaces ?? []).map((ws) => /* @__PURE__ */ jsx18(
            "button",
            {
              type: "button",
              className: filterWs === ws.id ? "active" : "",
              onClick: () => setFilterWs(ws.id),
              children: ws.name
            },
            ws.id
          ))
        ] })
      ] }),
      error && /* @__PURE__ */ jsx18("div", { className: "studio-alert error", children: error }),
      notice && /* @__PURE__ */ jsx18("div", { className: "studio-alert success", children: notice }),
      /* @__PURE__ */ jsxs18("div", { className: "live-ops-kpi-grid live-ops-kpi-primary", children: [
        /* @__PURE__ */ jsx18(Kpi2, { label: "Aktif", value: counts?.active ?? 0, tone: "warn" }),
        /* @__PURE__ */ jsx18(Kpi2, { label: "\xC7al\u0131yor", value: counts?.ringing ?? 0 }),
        /* @__PURE__ */ jsx18(Kpi2, { label: "Kuyruk", value: counts?.queued ?? 0 }),
        /* @__PURE__ */ jsx18(Kpi2, { label: "\u0130nsan bekliyor", value: counts?.waitingForHuman ?? 0, tone: "bad" }),
        /* @__PURE__ */ jsx18(Kpi2, { label: "Listelenen hat", value: visibleCalls.length }),
        /* @__PURE__ */ jsx18(
          Kpi2,
          {
            label: "G\xFCnl\xFCk kota kalan",
            value: data?.warmUp ? `${data.warmUp.remainingMinutes}/${data.warmUp.dailyMinuteCap} dk` : "\u2014",
            tone: "ok"
          }
        ),
        /* @__PURE__ */ jsx18(
          Kpi2,
          {
            label: "Bayat kampanya",
            value: data?.staleRecovery?.callingStale ?? 0,
            tone: (data?.staleRecovery?.callingStale ?? 0) > 0 ? "bad" : "ok"
          }
        )
      ] }),
      data?.staleRecovery && (data.staleRecovery.callingStale > 0 || data.staleRecovery.recoveredInWindow > 0) && /* @__PURE__ */ jsx18(
        "p",
        {
          className: `live-ops-note${data.staleRecovery.callingStale > 0 ? " live-ops-stale-alert" : ""}`,
          role: "status",
          children: data.staleRecovery.callingStale > 0 ? /* @__PURE__ */ jsxs18(Fragment10, { children: [
            /* @__PURE__ */ jsx18("b", { children: data.staleRecovery.callingStale }),
            " kampanya ki\u015Fisi",
            " ",
            /* @__PURE__ */ jsxs18("b", { children: [
              data.staleRecovery.staleAfterSeconds,
              "sn+"
            ] }),
            " \u201Caran\u0131yor\u201Dda tak\u0131l\u0131 (sistem toparlamay\u0131 dener). \u015Eu an calling:",
            " ",
            /* @__PURE__ */ jsx18("b", { children: data.staleRecovery.callingNow }),
            "."
          ] }) : /* @__PURE__ */ jsxs18(Fragment10, { children: [
            "Son ",
            data.staleRecovery.windowMinutes,
            " dk i\xE7inde",
            " ",
            /* @__PURE__ */ jsx18("b", { children: data.staleRecovery.recoveredInWindow }),
            " bayat kampanya kayd\u0131 toparland\u0131."
          ] })
        }
      ),
      demoSessionsDominate && /* @__PURE__ */ jsx18("p", { className: "live-ops-note live-ops-demo-note", role: "status", children: t("Includes demo/browser_demo sessions") }),
      /* @__PURE__ */ jsxs18("div", { className: "live-ops-grid", children: [
        /* @__PURE__ */ jsxs18("article", { className: "studio-card", children: [
          /* @__PURE__ */ jsx18("header", { children: /* @__PURE__ */ jsxs18("div", { children: [
            /* @__PURE__ */ jsx18("small", { children: "CANLI ARAMALAR" }),
            /* @__PURE__ */ jsxs18("h3", { children: [
              "Aktif hatlar \xB7 ",
              visibleCalls.length,
              scope === "all" ? " \xB7 \xE7oklu alan" : "",
              autoRefresh ? " \xB7 canl\u0131" : ""
            ] })
          ] }) }),
          visibleCalls.length === 0 ? /* @__PURE__ */ jsx18("p", { className: "voice-tool-empty", children: "\u015Eu an aktif / \xE7alan / kuyruktaki arama yok." }) : /* @__PURE__ */ jsx18("div", { className: "live-call-list", children: visibleCalls.map((call) => {
            const handoffMeta = lastHandoff?.callId === call.id ? lastHandoff : void 0;
            const showHandoffChip = call.handoffRequested || call.status === "waiting_for_human";
            return /* @__PURE__ */ jsxs18(
              "div",
              {
                className: `live-call-row status-${call.status}${call.handoffRequested ? " handoff-pending" : ""}`,
                children: [
                  /* @__PURE__ */ jsxs18(
                    "button",
                    {
                      type: "button",
                      className: "live-call-main",
                      onClick: () => onOpenCall?.(call.id),
                      title: "G\xF6r\xFC\u015Fme kart\u0131n\u0131 a\xE7",
                      children: [
                        /* @__PURE__ */ jsxs18("span", { children: [
                          /* @__PURE__ */ jsxs18("strong", { children: [
                            call.direction === "outbound" ? "Giden" : "Gelen",
                            " \xB7",
                            " ",
                            statusTr(call.status),
                            call.handoffRequested ? " \xB7 aktar\u0131m" : ""
                          ] }),
                          /* @__PURE__ */ jsxs18("small", { children: [
                            call.fromMasked,
                            " \u2192 ",
                            call.toMasked
                          ] }),
                          /* @__PURE__ */ jsxs18("small", { children: [
                            /* @__PURE__ */ jsx18("span", { className: "live-ws-chip", children: call.workspaceName }),
                            call.provider,
                            call.numberClass ? ` \xB7 ${call.numberClass}` : "",
                            " \xB7 ",
                            call.durationSeconds,
                            "s \xB7 s\xF6z kesme ",
                            call.bargeInCount
                          ] }),
                          showHandoffChip && /* @__PURE__ */ jsxs18("span", { className: "live-handoff-chip", role: "status", children: [
                            call.status === "waiting_for_human" ? "\u0130nsan bekleniyor" : "Aktar\u0131m istendi",
                            handoffMeta ? ` \xB7 ${handoffMeta.mode === "warm" ? "s\u0131cak" : "k\xF6r"}` : "",
                            handoffMeta?.destinationMasked ? ` \xB7 ${handoffMeta.destinationMasked}` : ""
                          ] })
                        ] }),
                        /* @__PURE__ */ jsxs18("em", { children: [
                          formatTime2(call.startedAt),
                          /* @__PURE__ */ jsx18("span", { className: "live-call-open-hint", children: "A\xE7 \u2192" })
                        ] })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxs18("div", { className: "live-call-actions", children: [
                    /* @__PURE__ */ jsx18(
                      "button",
                      {
                        type: "button",
                        className: "live-handoff-btn",
                        disabled: handoffBusyId === call.id || hangupBusyId === call.id || call.handoffRequested || call.status === "queued" || busy,
                        onClick: () => void onHandoff(call),
                        title: handoffMode === "warm" ? "S\u0131cak aktar\u0131m \u2014 arayan \xE7alma sesi duyar" : "K\xF6r aktar\u0131m \u2014 sessiz y\xF6nlendirme",
                        children: call.handoffRequested ? "Aktar\u0131ld\u0131" : handoffBusyId === call.id ? "\u2026" : "\u0130nsana aktar"
                      }
                    ),
                    /* @__PURE__ */ jsx18(
                      "button",
                      {
                        type: "button",
                        className: "live-hangup-btn",
                        disabled: hangupBusyId === call.id || handoffBusyId === call.id || busy,
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          void onHangup(call);
                        },
                        title: "G\xF6r\xFC\u015Fmeyi kapat",
                        children: hangupBusyId === call.id ? "Kapat\u0131l\u0131yor\u2026" : "G\xF6r\xFC\u015Fmeyi kapat"
                      }
                    )
                  ] })
                ]
              },
              call.id
            );
          }) })
        ] }),
        /* @__PURE__ */ jsxs18("article", { className: "studio-card live-ops-trust", children: [
          /* @__PURE__ */ jsx18("header", { children: /* @__PURE__ */ jsxs18("div", { children: [
            /* @__PURE__ */ jsx18("small", { children: "G\xDCVEN / BLOK" }),
            /* @__PURE__ */ jsx18("h3", { children: "Risk ve engel olaylar\u0131" })
          ] }) }),
          (data?.trustFeed.length ?? 0) === 0 ? /* @__PURE__ */ jsx18("p", { className: "voice-tool-empty", children: "Yak\u0131n zamanda trust risk olay\u0131 yok." }) : data.trustFeed.map((event) => {
            const human = humanizeTrust(event, t);
            const rawTitle = [event.eventType, event.detail].filter(Boolean).join(" \u2014 ");
            return /* @__PURE__ */ jsxs18(
              "button",
              {
                type: "button",
                className: `live-trust-row type-${event.eventType}${event.callId ? " is-clickable" : ""}`,
                disabled: !event.callId,
                onClick: () => {
                  if (event.callId) onOpenCall?.(event.callId);
                },
                title: event.callId ? `${rawTitle} \xB7 \u0130lgili g\xF6r\xFC\u015Fmeyi a\xE7` : rawTitle,
                children: [
                  /* @__PURE__ */ jsx18("strong", { children: human }),
                  /* @__PURE__ */ jsx18("p", { children: event.detail }),
                  /* @__PURE__ */ jsxs18("small", { children: [
                    event.eventType,
                    event.detail ? ` \xB7 ${event.detail}` : "",
                    " \xB7 ",
                    formatTime2(event.createdAt),
                    event.numberClass ? ` \xB7 ${event.numberClass}` : "",
                    event.callId ? ` \xB7 ${event.callId.slice(0, 12)}\u2026 \xB7 A\xE7 \u2192` : ""
                  ] })
                ]
              },
              event.id
            );
          })
        ] }),
        /* @__PURE__ */ jsxs18("article", { className: "studio-card live-ops-quality-card", children: [
          /* @__PURE__ */ jsxs18("header", { children: [
            /* @__PURE__ */ jsxs18("div", { children: [
              /* @__PURE__ */ jsx18("small", { children: "\xC7A\u011ERI KAL\u0130TES\u0130" }),
              /* @__PURE__ */ jsxs18("h3", { children: [
                "Kalite panosu (son ",
                windowLabel(windowMinutes),
                ")"
              ] })
            ] }),
            /* @__PURE__ */ jsx18(
              "button",
              {
                type: "button",
                className: "directory-secondary-btn",
                onClick: () => setShowLatency((v) => !v),
                children: showLatency ? "Gizle" : "Detay"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs18("div", { className: "live-ops-kpi-grid live-ops-kpi-latency", children: [
            /* @__PURE__ */ jsx18(
              Kpi2,
              {
                label: "\u0130lk ses p50",
                value: fmtMs(latency?.stopToAudioP50Ms ?? latency?.e2eP50Ms),
                ...latency?.stopToAudioP50Ms != null && latency.stopToAudioP50Ms > 1800 ? { tone: "warn" } : {}
              }
            ),
            /* @__PURE__ */ jsx18(
              Kpi2,
              {
                label: "\u0130lk ses p95",
                value: fmtMs(latency?.stopToAudioP95Ms ?? latency?.e2eP95Ms),
                ...latency?.stopToAudioP95Ms != null && latency.stopToAudioP95Ms > 3e3 ? { tone: "bad" } : { tone: "warn" }
              }
            ),
            /* @__PURE__ */ jsx18(
              Kpi2,
              {
                label: "Ara\xE7 ba\u015Far\u0131",
                value: quality?.toolSuccessRate == null ? "\u2014" : `${Math.round(quality.toolSuccessRate * 100)}%`,
                ...quality?.toolSuccessRate != null && quality.toolSuccessRate < 0.8 ? { tone: "warn" } : quality?.toolSuccessRate != null ? { tone: "ok" } : {}
              }
            ),
            /* @__PURE__ */ jsx18(
              Kpi2,
              {
                label: "Erken kapanma",
                value: quality?.earlyHangupRate == null ? "\u2014" : `${Math.round(quality.earlyHangupRate * 100)}%`,
                ...quality?.earlyHangupRate != null && quality.earlyHangupRate > 0.25 ? { tone: "bad" } : {}
              }
            ),
            /* @__PURE__ */ jsx18(Kpi2, { label: "Circuit open", value: quality?.circuitOpenCount ?? 0 }),
            /* @__PURE__ */ jsx18(Kpi2, { label: "Tur", value: latency?.turnCount ?? 0 })
          ] }),
          /* @__PURE__ */ jsxs18("div", { className: "live-ops-channel-split", "aria-label": "Softphone ve PSTN", children: [
            /* @__PURE__ */ jsx18(
              ChannelLatencyCard,
              {
                title: "Softphone",
                hint: "browser_demo",
                channel: quality?.softphone ?? null,
                empty: "Bu pencerede softphone turu yok"
              }
            ),
            /* @__PURE__ */ jsx18(
              ChannelLatencyCard,
              {
                title: "PSTN",
                hint: "Verimor / Zadarma / Twilio",
                channel: quality?.pstn ?? null,
                empty: "Bu pencerede PSTN turu yok"
              }
            )
          ] }),
          (latency?.turnCount ?? 0) === 0 && (quality?.toolTotal ?? 0) === 0 && /* @__PURE__ */ jsx18("p", { className: "live-ops-empty-quality", role: "status", children: "Hen\xFCz kalite \xF6rne\u011Fi yok. Softphone veya ger\xE7ek arama yapt\u0131k\xE7a ilk ses, ara\xE7 ve erken kapanma metrikleri burada dolacak." }),
          showLatency && /* @__PURE__ */ jsxs18(Fragment10, { children: [
            /* @__PURE__ */ jsxs18("div", { className: "bar-chart", children: [
              /* @__PURE__ */ jsx18(
                LatencyBar,
                {
                  label: "\u0130lk ses p50",
                  value: latency?.stopToAudioP50Ms ?? latency?.e2eP50Ms,
                  max: 5e3
                }
              ),
              /* @__PURE__ */ jsx18(
                LatencyBar,
                {
                  label: "\u0130lk ses p95",
                  value: latency?.stopToAudioP95Ms ?? latency?.e2eP95Ms,
                  max: 8e3
                }
              ),
              /* @__PURE__ */ jsx18(LatencyBar, { label: "Sessizlik p50", value: latency?.silenceP50Ms, max: 3e3 }),
              /* @__PURE__ */ jsx18(LatencyBar, { label: "STT p50", value: latency?.sttP50Ms, max: 3e3 }),
              /* @__PURE__ */ jsx18(LatencyBar, { label: "LLM p50", value: latency?.llmP50Ms, max: 5e3 }),
              /* @__PURE__ */ jsx18(LatencyBar, { label: "TTS p50", value: latency?.ttsP50Ms, max: 3e3 })
            ] }),
            /* @__PURE__ */ jsxs18("p", { className: "live-ops-note", children: [
              "\u0130lk ses = kullan\u0131c\u0131 sustuktan sonra ajan sesinin gelmesi. Erken kapanma = tamamlanan arama < ",
              quality?.earlyHangupSeconds ?? 20,
              "s. Ara\xE7 ba\u015Far\u0131 =",
              " ",
              quality?.toolSucceeded ?? 0,
              "/",
              quality?.toolTotal ?? 0,
              ". Circuit = provider health open sayac\u0131 (s\xFCre\xE7 i\xE7i LLM devresi de\u011Fil)."
            ] })
          ] }),
          /* @__PURE__ */ jsxs18("div", { className: "live-ops-trend7d", children: [
            /* @__PURE__ */ jsxs18("header", { className: "live-ops-trend7d-head", children: [
              /* @__PURE__ */ jsx18("small", { children: "7 G\xDCN TREND" }),
              /* @__PURE__ */ jsx18("span", { children: "\u0130lk ses p50 (UTC g\xFCn)" })
            ] }),
            (quality?.trend7d?.length ?? 0) === 0 ? /* @__PURE__ */ jsx18("p", { className: "live-ops-empty-quality", children: "7 g\xFCnl\xFCk trend i\xE7in hen\xFCz \xF6rnek yok." }) : /* @__PURE__ */ jsx18("div", { className: "live-ops-trend7d-bars", role: "img", "aria-label": "7 g\xFCnl\xFCk ilk ses p50", children: quality.trend7d.map((day) => {
              const ms2 = day.stopToAudioP50Ms;
              const height = ms2 == null ? 4 : Math.max(8, Math.min(100, Math.round(ms2 / 4e3 * 100)));
              return /* @__PURE__ */ jsxs18("div", { className: "live-ops-trend7d-col", title: trendTitle(day), children: [
                /* @__PURE__ */ jsx18("i", { style: { height: `${height}%` }, className: ms2 == null ? "empty" : "" }),
                /* @__PURE__ */ jsx18("span", { children: day.date.slice(5) })
              ] }, day.date);
            }) })
          ] })
        ] })
      ] })
    ] }) : null
  ] });
};
var windowLabel = (minutes) => {
  if (minutes >= 10080) return "7 g\xFCn";
  if (minutes >= 240) return `${Math.round(minutes / 60)} sa`;
  if (minutes >= 60) return `${Math.round(minutes / 60)} sa`;
  return `${minutes} dk`;
};
var fmtPct = (rate) => rate == null ? "\u2014" : `${Math.round(rate * 100)}%`;
var trendTitle = (day) => `${day.date}: p50=${fmtMs(day.stopToAudioP50Ms)} \xB7 tur=${day.turnCount} \xB7 ara\xE7=${fmtPct(day.toolSuccessRate)} \xB7 erken=${fmtPct(day.earlyHangupRate)}`;
var ChannelLatencyCard = ({
  title,
  hint,
  channel,
  empty
}) => /* @__PURE__ */ jsxs18("div", { className: `live-ops-channel-card${channel ? "" : " is-empty"}`, children: [
  /* @__PURE__ */ jsxs18("div", { className: "live-ops-channel-card-head", children: [
    /* @__PURE__ */ jsx18("b", { children: title }),
    /* @__PURE__ */ jsx18("small", { children: hint })
  ] }),
  !channel ? /* @__PURE__ */ jsx18("p", { className: "live-ops-empty-quality", children: empty }) : /* @__PURE__ */ jsxs18("div", { className: "live-ops-channel-kpis", children: [
    /* @__PURE__ */ jsxs18("span", { children: [
      "p50 ",
      /* @__PURE__ */ jsx18("strong", { children: fmtMs(channel.stopToAudioP50Ms) })
    ] }),
    /* @__PURE__ */ jsxs18("span", { children: [
      "p95 ",
      /* @__PURE__ */ jsx18("strong", { children: fmtMs(channel.stopToAudioP95Ms) })
    ] }),
    /* @__PURE__ */ jsxs18("span", { children: [
      "tur ",
      /* @__PURE__ */ jsx18("strong", { children: channel.turnCount })
    ] }),
    /* @__PURE__ */ jsxs18("span", { children: [
      "arama ",
      /* @__PURE__ */ jsx18("strong", { children: channel.callCount })
    ] })
  ] })
] });
var Kpi2 = ({
  label,
  value,
  tone
}) => /* @__PURE__ */ jsxs18("div", { className: `performance-kpi${tone ? ` tone-${tone}` : ""}`, children: [
  /* @__PURE__ */ jsx18("small", { children: label }),
  /* @__PURE__ */ jsx18("b", { children: value })
] });
var LatencyBar = ({
  label,
  value,
  max
}) => {
  const ms2 = value ?? 0;
  const width = value == null ? 0 : Math.min(100, Math.round(ms2 / max * 100));
  return /* @__PURE__ */ jsxs18("div", { className: "bar-chart-row", children: [
    /* @__PURE__ */ jsx18("span", { className: "bar-chart-label", children: label }),
    /* @__PURE__ */ jsx18("div", { className: "bar-chart-track", children: /* @__PURE__ */ jsx18("i", { style: { width: `${width}%` } }) }),
    /* @__PURE__ */ jsx18("span", { className: "bar-chart-value", children: fmtMs(value) })
  ] });
};
var fmtMs = (value) => value == null ? "\u2014" : `${value}ms`;
var formatTime2 = (iso) => new Intl.DateTimeFormat("tr-TR", { timeStyle: "medium", dateStyle: "short" }).format(
  new Date(iso)
);
var statusTr = (status) => {
  switch (status) {
    case "active":
      return "aktif";
    case "ringing":
      return "\xE7al\u0131yor";
    case "queued":
      return "kuyruk";
    case "waiting_for_human":
      return "insan";
    default:
      return status;
  }
};

// src/platform-admin.tsx
import { useCallback as useCallback17, useEffect as useEffect17, useMemo as useMemo13, useState as useState19 } from "react";

// src/package-design-card.tsx
import { useMemo as useMemo11 } from "react";
import {
  DEFAULT_PACKAGE_ECONOMICS_ASSUMPTIONS,
  DEFAULT_PACKAGE_ENABLED_SERVICES,
  meterRateHasPrice,
  parseCostRates,
  resolveMeterRate,
  simulatePackageEconomics
} from "@agentos/domain";
import { jsx as jsx19, jsxs as jsxs19 } from "react/jsx-runtime";
var asList = (perms, arrayKey, singularKey, fallback) => {
  const multi = perms[arrayKey];
  if (Array.isArray(multi)) {
    return multi.map((item) => String(item).toLowerCase()).filter(Boolean);
  }
  const single = perms[singularKey];
  if (typeof single === "string" && single && single !== "none") {
    return [single.toLowerCase()];
  }
  return [...fallback];
};
var readEnabled = (perms) => {
  const raw = perms.centeros_enabled_services;
  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    const o = raw;
    return {
      voice: o.voice !== false && perms.centeros_voice !== false,
      stt: o.stt !== false,
      tts: o.tts !== false,
      llm: o.llm !== false,
      sms: o.sms === true,
      webchat: o.webchat === true || perms.centeros_webchat === true,
      realtime: o.realtime === true || perms.centeros_realtime === true
    };
  }
  return {
    ...DEFAULT_PACKAGE_ENABLED_SERVICES,
    voice: perms.centeros_voice !== false,
    webchat: perms.centeros_webchat === true,
    realtime: perms.centeros_realtime === true,
    sms: false
  };
};
var readTelephonyProviders = (perms) => {
  const raw = perms.centeros_telephony_providers;
  if (Array.isArray(raw) && raw.length > 0) {
    return raw.map((x) => String(x).toLowerCase()).filter(Boolean);
  }
  return ["verimor", "zadarma"];
};
var readRetailOverrides = (perms) => {
  const raw = perms.centeros_package_retail_overrides;
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return {};
  const o = raw;
  const num = (k) => {
    const v = o[k];
    return typeof v === "number" && Number.isFinite(v) ? v : void 0;
  };
  const out = {};
  const tel = num("telephonyTryPerMinute") ?? num("telephony_try_per_minute");
  const stt = num("sttUsdPerHour") ?? num("stt_usd_per_hour");
  const tts = num("ttsUsdPer1k") ?? num("tts_usd_per_1k");
  const llmIn = num("llmInputUsdPer1m") ?? num("llm_input_usd_per_1m");
  const llmOut = num("llmOutputUsdPer1m") ?? num("llm_output_usd_per_1m");
  if (tel !== void 0) out.telephonyTryPerMinute = tel;
  if (stt !== void 0) out.sttUsdPerHour = stt;
  if (tts !== void 0) out.ttsUsdPer1k = tts;
  if (llmIn !== void 0) out.llmInputUsdPer1m = llmIn;
  if (llmOut !== void 0) out.llmOutputUsdPer1m = llmOut;
  return out;
};
var readAssumptions = (perms) => {
  const raw = perms.centeros_package_economics_assumptions;
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
    return { ...DEFAULT_PACKAGE_ECONOMICS_ASSUMPTIONS };
  }
  const o = raw;
  const n = (k, d) => typeof o[k] === "number" && Number.isFinite(o[k]) ? Math.max(0, o[k]) : d;
  return {
    ttsCharsPerMinute: n("ttsCharsPerMinute", DEFAULT_PACKAGE_ECONOMICS_ASSUMPTIONS.ttsCharsPerMinute),
    llmInputTokensPerMinute: n(
      "llmInputTokensPerMinute",
      DEFAULT_PACKAGE_ECONOMICS_ASSUMPTIONS.llmInputTokensPerMinute
    ),
    llmOutputTokensPerMinute: n(
      "llmOutputTokensPerMinute",
      DEFAULT_PACKAGE_ECONOMICS_ASSUMPTIONS.llmOutputTokensPerMinute
    )
  };
};
var readScenario = (perms) => {
  const raw = String(perms.centeros_package_telephony_scenario ?? "most_expensive").toLowerCase();
  if (raw === "verimor" || raw === "zadarma" || raw === "twilio" || raw === "average" || raw === "most_expensive") {
    return raw;
  }
  return "most_expensive";
};
var asDidMode = (perms) => {
  const mode = String(perms.centeros_platform_did_mode ?? "").toLowerCase();
  if (mode === "none" || mode === "selected" || mode === "all") return mode;
  if (perms.centeros_use_platform_dids === false) return "none";
  if (Array.isArray(perms.centeros_allowed_dids) && perms.centeros_allowed_dids.length > 0) {
    return "selected";
  }
  return perms.centeros_use_platform_dids === true ? "all" : "none";
};
var asAllowedDids = (perms) => {
  const raw = perms.centeros_allowed_dids;
  if (!Array.isArray(raw)) return [];
  return raw.map((x) => String(x)).filter(Boolean);
};
var formatTry = (minor) => {
  if (minor === null || minor === void 0 || !Number.isFinite(minor)) return "\u2014";
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2
  }).format(minor / 100);
};
var formatUsd = (minor) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
}).format(minor / 100);
var formatDual = (tryMinor, usdMinor) => `${formatTry(tryMinor)} \xB7 ${formatUsd(usdMinor)}`;
var formatMargin = (bps) => {
  if (bps === null) return "Eksik";
  return `${(bps / 100).toFixed(1).replace(".", ",")}%`;
};
var tryPerMinuteFromRate = (rate) => {
  if (!rate || !meterRateHasPrice(rate)) return null;
  if (typeof rate.tryPerMinute === "number" && Number.isFinite(rate.tryPerMinute)) {
    return rate.tryPerMinute;
  }
  if (typeof rate.tryPerUnit === "number" && Number.isFinite(rate.tryPerUnit)) {
    return rate.tryPerUnit;
  }
  if (typeof rate.tryMinorPerUnit === "number" && Number.isFinite(rate.tryMinorPerUnit)) {
    return rate.tryMinorPerUnit / 100;
  }
  return null;
};
var readTelephonyTryPerMinute = (ratesJson, provider) => {
  try {
    const rates = parseCostRates(JSON.parse(ratesJson));
    return tryPerMinuteFromRate(resolveMeterRate(rates, "telephony_minutes", provider ?? null));
  } catch {
    return null;
  }
};
var formatTryPerMinute = (value) => {
  if (value === null || !Number.isFinite(value)) return "\u2014";
  return `${value.toFixed(2).replace(".", ",")} TL / dk`;
};
var costLabel = (ratesJson, meter, provider) => {
  try {
    const rates = parseCostRates(JSON.parse(ratesJson));
    const rate = resolveMeterRate(rates, meter, provider ?? null);
    if (!meterRateHasPrice(rate)) return "\u2014 (eksik)";
    if (meter === "telephony_minutes") {
      const perMin = tryPerMinuteFromRate(rate);
      return perMin === null ? "\u2014 (eksik)" : formatTryPerMinute(perMin);
    }
    if (meter === "stt_seconds" && typeof rate?.usdPerHour === "number") {
      return `${rate.usdPerHour.toFixed(2).replace(".", ",")} USD/saat`;
    }
    if (meter === "tts_characters" && typeof rate?.usdPer1k === "number") {
      return `${rate.usdPer1k.toFixed(2).replace(".", ",")} USD/1K`;
    }
    if (meter === "llm_input_tokens" && typeof rate?.usdPer1m === "number") {
      return `${rate.usdPer1m.toFixed(2).replace(".", ",")} USD/1M`;
    }
    if (meter === "llm_output_tokens" && typeof rate?.usdPer1m === "number") {
      return `${rate.usdPer1m.toFixed(2).replace(".", ",")} USD/1M`;
    }
    return "ayarl\u0131";
  } catch {
    return "\u2014";
  }
};
var PackageDesignCard = ({
  pack,
  index,
  plans,
  costRatesJson,
  retailRatesJson,
  didPool = [],
  t,
  onUpdatePack,
  onUpdatePerm,
  onRemove,
  onGoToDidTab,
  onGoToRatesTab
}) => {
  const perms = pack.permissions || {};
  const profile = String(perms.centeros_voice_profile ?? "growth");
  const minutes = Number(perms.centeros_voice_minutes_limit ?? 60);
  const concurrent = Number(perms.centeros_voice_concurrent_calls ?? 1);
  const maxSeconds = Number(perms.centeros_voice_max_call_seconds ?? 900);
  const enabled = readEnabled(perms);
  const telProviders = readTelephonyProviders(perms);
  const llmList = asList(perms, "centeros_llm_providers", "centeros_llm_provider", ["openai"]);
  const sttList = asList(perms, "centeros_stt_providers", "centeros_stt_provider", ["deepgram"]);
  const ttsList = asList(perms, "centeros_tts_providers", "centeros_tts_provider", ["elevenlabs"]);
  const overrides = readRetailOverrides(perms);
  const assumptions = readAssumptions(perms);
  const scenario = readScenario(perms);
  const didMode = asDidMode(perms);
  const allowedDids2 = asAllowedDids(perms);
  const poolChoices = didPool.filter((row) => row.e164.trim() && row.enabled !== false);
  const linkedPlan = plans.find((p) => p.packageId === pack.id) ?? null;
  const setEnabled = (key, on) => {
    const next = { ...enabled, [key]: on };
    onUpdatePerm(index, "centeros_enabled_services", next);
    if (key === "voice") onUpdatePerm(index, "centeros_voice", on);
    if (key === "webchat") onUpdatePerm(index, "centeros_webchat", on);
    if (key === "realtime") onUpdatePerm(index, "centeros_realtime", on);
  };
  const toggleTelProvider = (provider) => {
    const next = telProviders.includes(provider) ? telProviders.filter((p) => p !== provider) : [...telProviders, provider];
    onUpdatePerm(index, "centeros_telephony_providers", next.length ? next : ["verimor", "zadarma"]);
  };
  const setProviderList = (arrayKey, singularKey, next) => {
    onUpdatePerm(index, arrayKey, next);
    onUpdatePerm(index, singularKey, next[0] ?? "none");
  };
  const clearOverride = (key) => {
    const next = {};
    for (const [k, v] of Object.entries(overrides)) {
      if (k === key) continue;
      if (typeof v === "number" && Number.isFinite(v)) next[k] = v;
    }
    onUpdatePerm(index, "centeros_package_retail_overrides", next);
  };
  const setOverride = (key, value) => {
    onUpdatePerm(index, "centeros_package_retail_overrides", {
      ...Object.fromEntries(
        Object.entries(overrides).filter(([, v]) => typeof v === "number" && Number.isFinite(v))
      ),
      [key]: value
    });
  };
  const patchAssumptions = (patch) => {
    onUpdatePerm(index, "centeros_package_economics_assumptions", { ...assumptions, ...patch });
  };
  const toggleDid = (e164) => {
    let next;
    if (didMode === "all") {
      next = poolChoices.map((row) => row.e164).filter((item) => item !== e164);
    } else if (didMode === "none") {
      next = [e164];
    } else {
      next = allowedDids2.includes(e164) ? allowedDids2.filter((item) => item !== e164) : [...allowedDids2, e164];
    }
    if (next.length === 0) {
      onUpdatePerm(index, "centeros_platform_did_mode", "none");
      onUpdatePerm(index, "centeros_use_platform_dids", false);
      onUpdatePerm(index, "centeros_allowed_dids", []);
    } else if (next.length === poolChoices.length) {
      onUpdatePerm(index, "centeros_platform_did_mode", "all");
      onUpdatePerm(index, "centeros_use_platform_dids", true);
      onUpdatePerm(index, "centeros_allowed_dids", []);
    } else {
      onUpdatePerm(index, "centeros_platform_did_mode", "selected");
      onUpdatePerm(index, "centeros_use_platform_dids", true);
      onUpdatePerm(index, "centeros_allowed_dids", next);
    }
  };
  const isDidChecked = (e164) => {
    if (didMode === "all") return true;
    if (didMode === "none") return false;
    return allowedDids2.includes(e164);
  };
  const sim = useMemo11(() => {
    let costRates;
    let retailRates;
    try {
      costRates = parseCostRates(JSON.parse(costRatesJson));
    } catch {
      costRates = parseCostRates({});
    }
    try {
      retailRates = parseCostRates(JSON.parse(retailRatesJson));
    } catch {
      retailRates = parseCostRates({});
    }
    return simulatePackageEconomics(
      {
        packageId: pack.id,
        packageName: pack.name,
        planId: linkedPlan?.id ?? null,
        planName: linkedPlan?.name ?? null,
        planMonthlyPriceMinor: typeof linkedPlan?.monthlyPriceMinor === "number" ? linkedPlan.monthlyPriceMinor : null,
        planCurrency: linkedPlan?.currency ?? "TRY",
        includedMinutes: Number.isFinite(minutes) ? minutes : 0,
        telephonyProviders: telProviders,
        llmProviders: llmList,
        sttProviders: sttList,
        ttsProviders: ttsList,
        enabledServices: enabled,
        retailOverrides: overrides
      },
      costRates,
      retailRates,
      scenario,
      assumptions
    );
  }, [
    pack.id,
    pack.name,
    linkedPlan,
    minutes,
    telProviders,
    llmList,
    sttList,
    ttsList,
    enabled,
    overrides,
    costRatesJson,
    retailRatesJson,
    scenario,
    assumptions
  ]);
  const telLine = sim.lines.find((l) => l.meter === "telephony_minutes");
  const sttLine = sim.lines.find((l) => l.meter === "stt_seconds");
  const ttsLine = sim.lines.find((l) => l.meter === "tts_characters");
  const llmInLine = sim.lines.find((l) => l.meter === "llm_input_tokens");
  const llmOutLine = sim.lines.find((l) => l.meter === "llm_output_tokens");
  const verimorCostTry = useMemo11(
    () => readTelephonyTryPerMinute(costRatesJson, "verimor"),
    [costRatesJson]
  );
  const zadarmaCostTry = useMemo11(
    () => readTelephonyTryPerMinute(costRatesJson, "zadarma"),
    [costRatesJson]
  );
  const globalRetailTry = useMemo11(() => {
    if (scenario === "verimor") {
      return readTelephonyTryPerMinute(retailRatesJson, "verimor") ?? readTelephonyTryPerMinute(retailRatesJson, null);
    }
    if (scenario === "zadarma") {
      return readTelephonyTryPerMinute(retailRatesJson, "zadarma") ?? readTelephonyTryPerMinute(retailRatesJson, null);
    }
    return readTelephonyTryPerMinute(retailRatesJson, null);
  }, [retailRatesJson, scenario]);
  const packageSaleTry = typeof overrides.telephonyTryPerMinute === "number" && Number.isFinite(overrides.telephonyTryPerMinute) ? overrides.telephonyTryPerMinute : null;
  const effectiveSaleTry = packageSaleTry ?? globalRetailTry;
  const scenarioUnitCostTry = useMemo11(() => {
    if (!enabled.voice) return null;
    if (scenario === "verimor") return verimorCostTry;
    if (scenario === "zadarma") return zadarmaCostTry;
    if (scenario === "most_expensive") {
      const priced = [verimorCostTry, zadarmaCostTry].filter(
        (v) => v !== null && Number.isFinite(v)
      );
      if (priced.length === 0) return null;
      return Math.max(...priced);
    }
    if (scenario === "average") {
      const priced = [verimorCostTry, zadarmaCostTry].filter(
        (v) => v !== null && Number.isFinite(v)
      );
      if (priced.length === 0) return null;
      return priced.reduce((a, b) => a + b, 0) / priced.length;
    }
    return verimorCostTry ?? zadarmaCostTry;
  }, [enabled.voice, scenario, verimorCostTry, zadarmaCostTry]);
  const scenarioUnitCostDisplay = useMemo11(() => {
    if (!enabled.voice) return { value: "\u2014", hint: "" };
    if (scenarioUnitCostTry === null) {
      return { value: t("Incomplete"), hint: "" };
    }
    const value = formatTryPerMinute(scenarioUnitCostTry);
    if (scenario === "verimor") return { value, hint: "Verimor" };
    if (scenario === "zadarma") return { value, hint: "Zadarma" };
    if (scenario === "most_expensive") {
      const who = verimorCostTry !== null && (zadarmaCostTry === null || verimorCostTry >= zadarmaCostTry) ? "Verimor" : "Zadarma";
      return { value, hint: who };
    }
    if (scenario === "average") return { value, hint: t("Average") };
    return { value, hint: "" };
  }, [
    enabled.voice,
    scenario,
    scenarioUnitCostTry,
    verimorCostTry,
    zadarmaCostTry,
    t
  ]);
  return /* @__PURE__ */ jsxs19("article", { className: "plat-pack-card plat-pack-card-rich plat-pack-design", "data-testid": "package-design-card", children: [
    /* @__PURE__ */ jsxs19("header", { className: "plat-pack-head", children: [
      /* @__PURE__ */ jsx19("div", { className: `plat-pill plat-pill-${profile}`, children: profile }),
      /* @__PURE__ */ jsx19("button", { type: "button", className: "plat-link-danger", onClick: () => onRemove(index), children: t("Remove") })
    ] }),
    /* @__PURE__ */ jsxs19("section", { className: "plat-sub", children: [
      /* @__PURE__ */ jsx19("h4", { children: t("Package basics") }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-field-row", children: [
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: "ID" }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              value: pack.id,
              onChange: (e) => onUpdatePack(index, { id: e.target.value })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("Name") }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input",
              value: pack.name,
              onChange: (e) => onUpdatePack(index, { name: e.target.value })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
        /* @__PURE__ */ jsx19("span", { children: t("Description") }),
        /* @__PURE__ */ jsx19(
          "input",
          {
            className: "plat-input",
            value: pack.description ?? "",
            onChange: (e) => onUpdatePack(index, { description: e.target.value })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-field-row", children: [
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("Included minutes") }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input",
              type: "number",
              min: 0,
              value: minutes,
              onChange: (e) => onUpdatePerm(index, "centeros_voice_minutes_limit", Number(e.target.value))
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("Concurrent") }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input",
              type: "number",
              min: 1,
              value: concurrent,
              onChange: (e) => onUpdatePerm(index, "centeros_voice_concurrent_calls", Number(e.target.value))
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("Max call (sec)") }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input",
              type: "number",
              min: 60,
              value: maxSeconds,
              onChange: (e) => onUpdatePerm(index, "centeros_voice_max_call_seconds", Number(e.target.value))
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("Voice profile") }),
          /* @__PURE__ */ jsxs19(
            "select",
            {
              className: "plat-input",
              value: profile,
              onChange: (e) => onUpdatePerm(index, "centeros_voice_profile", e.target.value),
              children: [
                /* @__PURE__ */ jsx19("option", { value: "starter", children: "Starter" }),
                /* @__PURE__ */ jsx19("option", { value: "growth", children: "Growth" }),
                /* @__PURE__ */ jsx19("option", { value: "pro", children: "Pro" })
              ]
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs19(
      "section",
      {
        className: "plat-sub plat-tel-tariff",
        "data-testid": "package-telephony-tariff",
        "aria-label": t("Phone tariff"),
        children: [
          /* @__PURE__ */ jsxs19("div", { className: "plat-sub-title-row", children: [
            /* @__PURE__ */ jsx19("h4", { children: t("Phone tariff") }),
            onGoToRatesTab ? /* @__PURE__ */ jsx19("button", { type: "button", className: "plat-mini-btn", onClick: onGoToRatesTab, children: t("Edit in Tariffs") }) : null
          ] }),
          /* @__PURE__ */ jsx19("p", { className: "plat-sub-help", children: t(
            "Wholesale cost is the global provider cost used by all packages. Customer sale is a package override only."
          ) }),
          /* @__PURE__ */ jsxs19("div", { className: "plat-field-row plat-tel-tariff-row", children: [
            /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
              /* @__PURE__ */ jsx19("span", { children: t("Verimor per-min cost") }),
              /* @__PURE__ */ jsxs19("div", { className: "plat-input-with-suffix", children: [
                /* @__PURE__ */ jsx19(
                  "input",
                  {
                    className: "plat-input mono",
                    type: "text",
                    readOnly: true,
                    disabled: !enabled.voice,
                    value: verimorCostTry !== null ? verimorCostTry.toFixed(2).replace(".", ",") : "",
                    placeholder: t("enter cost"),
                    title: t("Global provider cost \u2014 edit on Tariffs tab")
                  }
                ),
                /* @__PURE__ */ jsx19("em", { children: "TL / dk" })
              ] }),
              verimorCostTry === null ? /* @__PURE__ */ jsx19("small", { className: "plat-rate-hint", children: t("Missing \u2014 set on Tariffs") }) : null
            ] }),
            /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
              /* @__PURE__ */ jsx19("span", { children: t("Zadarma per-min cost") }),
              /* @__PURE__ */ jsxs19("div", { className: "plat-input-with-suffix", children: [
                /* @__PURE__ */ jsx19(
                  "input",
                  {
                    className: "plat-input mono",
                    type: "text",
                    readOnly: true,
                    disabled: !enabled.voice,
                    value: zadarmaCostTry !== null ? zadarmaCostTry.toFixed(2).replace(".", ",") : "",
                    placeholder: t("enter cost"),
                    title: t("Global provider cost \u2014 edit on Tariffs tab")
                  }
                ),
                /* @__PURE__ */ jsx19("em", { children: "TL / dk" })
              ] }),
              zadarmaCostTry === null ? /* @__PURE__ */ jsx19("small", { className: "plat-rate-hint", children: t("Missing \u2014 set on Tariffs") }) : null
            ] }),
            /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
              /* @__PURE__ */ jsx19("span", { children: t("Customer per-min price") }),
              /* @__PURE__ */ jsxs19("div", { className: "plat-input-with-suffix", children: [
                /* @__PURE__ */ jsx19(
                  "input",
                  {
                    className: "plat-input mono",
                    type: "number",
                    min: 0,
                    step: "0.01",
                    disabled: !enabled.voice,
                    placeholder: globalRetailTry !== null ? globalRetailTry.toFixed(2).replace(".", ",") : t("global"),
                    value: packageSaleTry ?? "",
                    onChange: (e) => {
                      if (e.target.value === "") clearOverride("telephonyTryPerMinute");
                      else setOverride("telephonyTryPerMinute", Number(e.target.value));
                    },
                    "data-testid": "package-telephony-sale"
                  }
                ),
                /* @__PURE__ */ jsx19("em", { children: "TL / dk" })
              ] }),
              /* @__PURE__ */ jsx19("small", { className: "plat-sub-help", style: { marginTop: 2 }, children: packageSaleTry !== null ? t("Package override") : globalRetailTry !== null ? `${t("Default from global")}: ${formatTryPerMinute(globalRetailTry)}` : t("Defaults from global retail rate card") })
            ] })
          ] }),
          onGoToRatesTab ? /* @__PURE__ */ jsxs19("p", { className: "plat-sub-meta", children: [
            t("This cost is the global provider cost used across all packages."),
            " ",
            /* @__PURE__ */ jsx19("button", { type: "button", className: "plat-inline-link", onClick: onGoToRatesTab, children: t("Edit in Tariffs") })
          ] }) : /* @__PURE__ */ jsx19("p", { className: "plat-sub-meta", children: t("This cost is the global provider cost used across all packages.") })
        ]
      }
    ),
    /* @__PURE__ */ jsxs19("section", { className: "plat-sub", children: [
      /* @__PURE__ */ jsx19("h4", { children: t("Service selection") }),
      /* @__PURE__ */ jsx19("div", { className: "plat-chips", role: "group", children: [
        ["voice", t("Phone calls")],
        ["stt", "STT"],
        ["tts", "TTS"],
        ["llm", "LLM"],
        ["sms", "SMS"],
        ["webchat", t("Webchat")],
        ["realtime", t("OpenAI Realtime")]
      ].map(([key, label]) => {
        const on = enabled[key];
        return /* @__PURE__ */ jsx19(
          "button",
          {
            type: "button",
            className: `plat-chip ${on ? "on" : ""}`,
            "aria-pressed": on,
            onClick: () => setEnabled(key, !on),
            children: label
          },
          key
        );
      }) }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-bucket", style: { marginTop: 10 }, children: [
        /* @__PURE__ */ jsx19("span", { className: "plat-bucket-label", children: t("Phone providers") }),
        /* @__PURE__ */ jsx19("div", { className: "plat-chips", children: ["verimor", "zadarma"].map((p) => {
          const on = telProviders.includes(p);
          return /* @__PURE__ */ jsx19(
            "button",
            {
              type: "button",
              className: `plat-chip ${on ? "on" : ""}`,
              disabled: !enabled.voice,
              "aria-pressed": on,
              onClick: () => toggleTelProvider(p),
              children: p === "verimor" ? "Verimor" : "Zadarma"
            },
            p
          );
        }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs19("section", { className: "plat-sub", children: [
      /* @__PURE__ */ jsx19("h4", { children: t("AI stack") }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-bucket", children: [
        /* @__PURE__ */ jsx19("span", { className: "plat-bucket-label", children: "LLM" }),
        /* @__PURE__ */ jsx19("div", { className: "plat-chips", children: [{ value: "openai", label: "OpenAI" }].map((opt) => {
          const on = llmList.includes(opt.value);
          return /* @__PURE__ */ jsx19(
            "button",
            {
              type: "button",
              className: `plat-chip ${on ? "on" : ""}`,
              disabled: !enabled.llm,
              onClick: () => setProviderList(
                "centeros_llm_providers",
                "centeros_llm_provider",
                on ? [] : [opt.value]
              ),
              children: opt.label
            },
            opt.value
          );
        }) })
      ] }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-bucket", children: [
        /* @__PURE__ */ jsx19("span", { className: "plat-bucket-label", children: "STT" }),
        /* @__PURE__ */ jsx19("div", { className: "plat-chips", children: [
          { value: "deepgram", label: "Deepgram" },
          { value: "openai", label: "OpenAI" }
        ].map((opt) => {
          const on = sttList.includes(opt.value);
          return /* @__PURE__ */ jsx19(
            "button",
            {
              type: "button",
              className: `plat-chip ${on ? "on" : ""}`,
              disabled: !enabled.stt,
              onClick: () => {
                const next = on ? sttList.filter((x) => x !== opt.value) : [...sttList, opt.value];
                setProviderList("centeros_stt_providers", "centeros_stt_provider", next);
              },
              children: opt.label
            },
            opt.value
          );
        }) })
      ] }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-bucket", children: [
        /* @__PURE__ */ jsx19("span", { className: "plat-bucket-label", children: "TTS" }),
        /* @__PURE__ */ jsx19("div", { className: "plat-chips", children: [
          { value: "elevenlabs", label: "ElevenLabs" },
          { value: "openai", label: "OpenAI" }
        ].map((opt) => {
          const on = ttsList.includes(opt.value);
          return /* @__PURE__ */ jsx19(
            "button",
            {
              type: "button",
              className: `plat-chip ${on ? "on" : ""}`,
              disabled: !enabled.tts,
              onClick: () => {
                const next = on ? ttsList.filter((x) => x !== opt.value) : [...ttsList, opt.value];
                setProviderList("centeros_tts_providers", "centeros_tts_provider", next);
              },
              children: opt.label
            },
            opt.value
          );
        }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs19("section", { className: "plat-sub", children: [
      /* @__PURE__ */ jsxs19("div", { className: "plat-sub-title-row", children: [
        /* @__PURE__ */ jsx19("h4", { children: t("Assign platform numbers") }),
        /* @__PURE__ */ jsxs19("div", { className: "plat-mini-actions", children: [
          /* @__PURE__ */ jsx19(
            "button",
            {
              type: "button",
              className: "plat-mini-btn",
              onClick: () => {
                onUpdatePerm(index, "centeros_platform_did_mode", "all");
                onUpdatePerm(index, "centeros_use_platform_dids", true);
                onUpdatePerm(index, "centeros_allowed_dids", []);
              },
              children: t("Select all")
            }
          ),
          /* @__PURE__ */ jsx19(
            "button",
            {
              type: "button",
              className: "plat-mini-btn",
              onClick: () => {
                onUpdatePerm(index, "centeros_platform_did_mode", "none");
                onUpdatePerm(index, "centeros_use_platform_dids", false);
                onUpdatePerm(index, "centeros_allowed_dids", []);
              },
              children: t("Clear")
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx19("p", { className: "plat-sub-help", children: t(
        "Tick the shared DIDs this pack may use as outbound CLI. Empty = BYO only. BYO numbers stay allowed."
      ) }),
      poolChoices.length === 0 ? /* @__PURE__ */ jsxs19("div", { className: "plat-empty compact", children: [
        /* @__PURE__ */ jsx19("strong", { children: t("No pool numbers") }),
        /* @__PURE__ */ jsx19("p", { children: t("Add numbers under Platform DIDs first, then assign them here.") }),
        onGoToDidTab ? /* @__PURE__ */ jsx19("button", { type: "button", className: "agentos-btn ghost", onClick: onGoToDidTab, children: t("Go to Platform DIDs") }) : null
      ] }) : /* @__PURE__ */ jsx19("div", { className: "plat-did-pick", role: "group", "aria-label": t("Assign platform numbers"), children: poolChoices.map((row) => {
        const checked = isDidChecked(row.e164);
        return /* @__PURE__ */ jsxs19("label", { className: `plat-check ${checked ? "on" : ""}`, children: [
          /* @__PURE__ */ jsx19(
            "input",
            {
              type: "checkbox",
              checked,
              onChange: () => toggleDid(row.e164)
            }
          ),
          /* @__PURE__ */ jsx19("span", { className: "mono", children: row.e164 }),
          /* @__PURE__ */ jsxs19("small", { children: [
            row.provider,
            row.label ? ` \xB7 ${row.label}` : ""
          ] })
        ] }, row.e164);
      }) }),
      /* @__PURE__ */ jsx19("p", { className: "plat-sub-meta", children: didMode === "none" ? t("Assigned: none (BYO only)") : didMode === "all" ? t("Assigned: all pool numbers") : `${t("Assigned")}: ${allowedDids2.length} / ${poolChoices.length}` })
    ] }),
    /* @__PURE__ */ jsxs19("section", { className: "plat-sub", children: [
      /* @__PURE__ */ jsx19("h4", { children: t("Package customer tariffs") }),
      /* @__PURE__ */ jsx19("p", { className: "plat-sub-help", children: t("Defaults from global retail rate card; override only for this package.") }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-field-row", children: [
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsxs19("span", { children: [
            t("Phone sale"),
            " (TRY/dk)"
          ] }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              type: "number",
              min: 0,
              step: "0.01",
              disabled: !enabled.voice,
              placeholder: "global",
              value: overrides.telephonyTryPerMinute ?? "",
              onChange: (e) => {
                if (e.target.value === "") clearOverride("telephonyTryPerMinute");
                else setOverride("telephonyTryPerMinute", Number(e.target.value));
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: "STT (USD/saat)" }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              type: "number",
              min: 0,
              step: "0.01",
              disabled: !enabled.stt,
              placeholder: "global",
              value: overrides.sttUsdPerHour ?? "",
              onChange: (e) => {
                if (e.target.value === "") clearOverride("sttUsdPerHour");
                else setOverride("sttUsdPerHour", Number(e.target.value));
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: "TTS (USD/1K)" }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              type: "number",
              min: 0,
              step: "0.01",
              disabled: !enabled.tts,
              placeholder: "global",
              value: overrides.ttsUsdPer1k ?? "",
              onChange: (e) => {
                if (e.target.value === "") clearOverride("ttsUsdPer1k");
                else setOverride("ttsUsdPer1k", Number(e.target.value));
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: "LLM in (USD/1M)" }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              type: "number",
              min: 0,
              step: "0.01",
              disabled: !enabled.llm,
              placeholder: "global",
              value: overrides.llmInputUsdPer1m ?? "",
              onChange: (e) => {
                if (e.target.value === "") clearOverride("llmInputUsdPer1m");
                else setOverride("llmInputUsdPer1m", Number(e.target.value));
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: "LLM out (USD/1M)" }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              type: "number",
              min: 0,
              step: "0.01",
              disabled: !enabled.llm,
              placeholder: "global",
              value: overrides.llmOutputUsdPer1m ?? "",
              onChange: (e) => {
                if (e.target.value === "") clearOverride("llmOutputUsdPer1m");
                else setOverride("llmOutputUsdPer1m", Number(e.target.value));
              }
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs19("section", { className: "plat-sub", children: [
      /* @__PURE__ */ jsx19("h4", { children: t("Wholesale costs (global)") }),
      /* @__PURE__ */ jsx19("p", { className: "plat-sub-help", children: t("From Tariffs rate card \u2014 edit there.") }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-cost-readout", children: [
        /* @__PURE__ */ jsxs19("span", { children: [
          "Verimor: ",
          costLabel(costRatesJson, "telephony_minutes", "verimor")
        ] }),
        /* @__PURE__ */ jsxs19("span", { children: [
          "Zadarma: ",
          costLabel(costRatesJson, "telephony_minutes", "zadarma")
        ] }),
        /* @__PURE__ */ jsxs19("span", { children: [
          "Deepgram STT: ",
          costLabel(costRatesJson, "stt_seconds")
        ] }),
        /* @__PURE__ */ jsxs19("span", { children: [
          "ElevenLabs TTS: ",
          costLabel(costRatesJson, "tts_characters")
        ] }),
        /* @__PURE__ */ jsxs19("span", { children: [
          "OpenAI LLM in: ",
          costLabel(costRatesJson, "llm_input_tokens")
        ] }),
        /* @__PURE__ */ jsxs19("span", { children: [
          "OpenAI LLM out: ",
          costLabel(costRatesJson, "llm_output_tokens")
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs19("section", { className: "plat-sub", children: [
      /* @__PURE__ */ jsx19("h4", { children: t("Assumptions") }),
      /* @__PURE__ */ jsxs19("div", { className: "plat-field-row", children: [
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("TTS chars / min") }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              type: "number",
              min: 0,
              value: assumptions.ttsCharsPerMinute,
              onChange: (e) => patchAssumptions({ ttsCharsPerMinute: Math.max(0, Number(e.target.value) || 0) })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("LLM input tokens / min") }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              type: "number",
              min: 0,
              value: assumptions.llmInputTokensPerMinute,
              onChange: (e) => patchAssumptions({
                llmInputTokensPerMinute: Math.max(0, Number(e.target.value) || 0)
              })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("LLM output tokens / min") }),
          /* @__PURE__ */ jsx19(
            "input",
            {
              className: "plat-input mono",
              type: "number",
              min: 0,
              value: assumptions.llmOutputTokensPerMinute,
              onChange: (e) => patchAssumptions({
                llmOutputTokensPerMinute: Math.max(0, Number(e.target.value) || 0)
              })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs19("label", { className: "plat-field", children: [
          /* @__PURE__ */ jsx19("span", { children: t("Telephony scenario") }),
          /* @__PURE__ */ jsxs19(
            "select",
            {
              className: "plat-input",
              value: scenario,
              disabled: !enabled.voice,
              onChange: (e) => onUpdatePerm(index, "centeros_package_telephony_scenario", e.target.value),
              children: [
                /* @__PURE__ */ jsx19("option", { value: "most_expensive", children: t("En pahal\u0131 telefon") }),
                /* @__PURE__ */ jsx19("option", { value: "average", children: t("Ortalama telefon") }),
                /* @__PURE__ */ jsx19("option", { value: "verimor", children: "Verimor" }),
                /* @__PURE__ */ jsx19("option", { value: "zadarma", children: "Zadarma" })
              ]
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs19("section", { className: "plat-sub plat-sim-panel", children: [
      /* @__PURE__ */ jsx19("h4", { children: t("Live simulation") }),
      sim.missingTelephonyCost && enabled.voice ? /* @__PURE__ */ jsxs19("div", { className: "plat-alert plat-alert-warn", role: "status", children: [
        /* @__PURE__ */ jsx19("strong", { children: t("Incomplete") }),
        /* @__PURE__ */ jsx19("span", { children: t(
          "Verimor/Zadarma cost must be entered before package profitability is complete."
        ) })
      ] }) : null,
      /* @__PURE__ */ jsxs19("div", { className: "plat-sim-grid", children: [
        /* @__PURE__ */ jsxs19("div", { className: "plat-sim-emphasis", "data-testid": "sim-unit-cost", children: [
          /* @__PURE__ */ jsx19("small", { children: t("Per-min cost") }),
          /* @__PURE__ */ jsx19("b", { children: scenarioUnitCostDisplay.value }),
          scenarioUnitCostDisplay.hint ? /* @__PURE__ */ jsx19("span", { className: "plat-sim-hint", children: scenarioUnitCostDisplay.hint }) : null
        ] }),
        /* @__PURE__ */ jsxs19("div", { className: "plat-sim-emphasis", "data-testid": "sim-unit-sale", children: [
          /* @__PURE__ */ jsx19("small", { children: t("Per-min customer price") }),
          /* @__PURE__ */ jsx19("b", { children: !enabled.voice ? "\u2014" : effectiveSaleTry !== null ? formatTryPerMinute(effectiveSaleTry) : t("Incomplete") })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: t("Included minutes") }),
          /* @__PURE__ */ jsx19("b", { children: sim.includedMinutes })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: "STT sn" }),
          /* @__PURE__ */ jsx19("b", { children: sttLine ? Math.round(sttLine.quantity) : "\u2014" })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: "TTS kar" }),
          /* @__PURE__ */ jsx19("b", { children: ttsLine ? Math.round(ttsLine.quantity) : "\u2014" })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: "LLM in / out" }),
          /* @__PURE__ */ jsxs19("b", { children: [
            llmInLine ? Math.round(llmInLine.quantity) : "\u2014",
            " /",
            " ",
            llmOutLine ? Math.round(llmOutLine.quantity) : "\u2014"
          ] })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: t("Estimated real cost") }),
          /* @__PURE__ */ jsx19("b", { children: sim.incomplete ? t("Incomplete") : formatDual(sim.wholesaleTotal.tryMinor, sim.wholesaleTotal.usdMinor) })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: t("Usage sale amount") }),
          /* @__PURE__ */ jsx19("b", { children: formatDual(sim.usageRetailTotal.tryMinor, sim.usageRetailTotal.usdMinor) })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: t("Plan subscription") }),
          /* @__PURE__ */ jsxs19("b", { children: [
            sim.planMonthlyPriceMinor !== null ? formatTry(sim.planMonthlyPriceMinor) : "\u2014",
            linkedPlan ? /* @__PURE__ */ jsx19("small", { style: { display: "block", fontWeight: 600, color: "#78716c" }, children: linkedPlan.name }) : null
          ] })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: t("Total potential revenue") }),
          /* @__PURE__ */ jsx19("b", { children: sim.totalPotentialRevenueTryMinor !== null ? formatTry(sim.totalPotentialRevenueTryMinor) : "\u2014" })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: t("Gross profit") }),
          /* @__PURE__ */ jsx19("b", { children: sim.incomplete ? t("Incomplete") : formatDual(sim.grossProfit.tryMinor, sim.grossProfit.usdMinor) })
        ] }),
        /* @__PURE__ */ jsxs19("div", { children: [
          /* @__PURE__ */ jsx19("small", { children: t("Margin") }),
          /* @__PURE__ */ jsx19("b", { children: formatMargin(sim.marginBps) })
        ] })
      ] }),
      /* @__PURE__ */ jsx19("p", { className: "plat-sub-meta", children: sim.assumptionSummary }),
      telLine ? /* @__PURE__ */ jsxs19("small", { className: "plat-sub-help", children: [
        "Tel wholesale ",
        formatTry(telLine.wholesale.tryMinor),
        sim.resolvedTelephonyProvider ? ` (${sim.resolvedTelephonyProvider})` : ""
      ] }) : null
    ] })
  ] });
};

// src/package-economics-panel.tsx
import { useMemo as useMemo12, useState as useState18 } from "react";
import {
  DEFAULT_PACKAGE_ECONOMICS_ASSUMPTIONS as DEFAULT_PACKAGE_ECONOMICS_ASSUMPTIONS2,
  parseCostRates as parseCostRates2,
  simulatePackageEconomics as simulatePackageEconomics2
} from "@agentos/domain";
import { jsx as jsx20, jsxs as jsxs20 } from "react/jsx-runtime";
var asList2 = (perms, arrayKey, singularKey, fallback) => {
  const multi = perms[arrayKey];
  if (Array.isArray(multi)) {
    return multi.map((item) => String(item).toLowerCase()).filter(Boolean);
  }
  const single = perms[singularKey];
  if (typeof single === "string" && single && single !== "none") {
    return [single.toLowerCase()];
  }
  return [...fallback];
};
var asDidMode2 = (perms) => {
  const raw = String(perms.centeros_platform_did_mode ?? "").toLowerCase();
  if (raw === "none" || raw === "selected" || raw === "all") return raw;
  if (perms.centeros_use_platform_dids === false) return "none";
  const list = Array.isArray(perms.centeros_allowed_dids) ? perms.centeros_allowed_dids : [];
  return list.length > 0 ? "selected" : "all";
};
var allowedDids = (perms) => {
  const raw = perms.centeros_allowed_dids;
  if (!Array.isArray(raw)) return [];
  return raw.map((item) => String(item)).filter(Boolean);
};
var formatTry2 = (minor) => {
  if (minor === null || minor === void 0 || !Number.isFinite(minor)) return "\u2014";
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(minor / 100);
};
var formatDual2 = (tryMinor, usdMinor) => {
  const tryS = formatTry2(tryMinor);
  const usdS = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(usdMinor / 100);
  return `${tryS} \xB7 ${usdS}`;
};
var formatMargin2 = (bps) => {
  if (bps === null) return "\u2014";
  return `${(bps / 100).toFixed(1).replace(".", ",")}%`;
};
var SCENARIOS = [
  { id: "most_expensive", label: "En pahal\u0131 telefon" },
  { id: "average", label: "Ortalama telefon" },
  { id: "verimor", label: "Verimor" },
  { id: "zadarma", label: "Zadarma" }
];
var PackageEconomicsPanel = ({
  packages,
  plans,
  didPool,
  costRatesJson,
  retailRatesJson,
  t
}) => {
  const [scenario, setScenario] = useState18("most_expensive");
  const [assumptions, setAssumptions] = useState18(
    DEFAULT_PACKAGE_ECONOMICS_ASSUMPTIONS2
  );
  const costRates = useMemo12(() => {
    try {
      return parseCostRates2(JSON.parse(costRatesJson));
    } catch {
      return parseCostRates2({});
    }
  }, [costRatesJson]);
  const retailRates = useMemo12(() => {
    try {
      return parseCostRates2(JSON.parse(retailRatesJson));
    } catch {
      return parseCostRates2({});
    }
  }, [retailRatesJson]);
  const poolByE164 = useMemo12(() => {
    const map = /* @__PURE__ */ new Map();
    for (const row of didPool) {
      if (row.enabled === false) continue;
      const e164 = row.e164.trim();
      if (!e164) continue;
      map.set(e164, String(row.provider || "").toLowerCase());
    }
    return map;
  }, [didPool]);
  const rows = useMemo12(() => {
    const packById = new Map(packages.map((p) => [p.id, p]));
    const results = [];
    for (const plan of plans) {
      const packageId = plan.packageId && plan.packageId !== "none" ? plan.packageId : null;
      if (!packageId) continue;
      const pack = packById.get(packageId);
      if (!pack) continue;
      const perms = pack.permissions || {};
      const minutes = Number(
        plan.centeros?.centeros_voice_minutes_limit ?? perms.centeros_voice_minutes_limit ?? 0
      );
      const didMode = asDidMode2(perms);
      const allowed = allowedDids(perms);
      let telephonyProviders = [];
      if (didMode === "none") {
        telephonyProviders = ["verimor", "zadarma"];
      } else if (didMode === "selected" && allowed.length > 0) {
        telephonyProviders = [
          ...new Set(
            allowed.map((e164) => poolByE164.get(e164) || "").filter(Boolean)
          )
        ];
        if (telephonyProviders.length === 0) telephonyProviders = ["verimor", "zadarma"];
      } else {
        telephonyProviders = [
          ...new Set(
            [...poolByE164.values()].filter(Boolean).length > 0 ? [...poolByE164.values()] : ["verimor", "zadarma"]
          )
        ];
      }
      results.push(
        simulatePackageEconomics2(
          {
            packageId: pack.id,
            packageName: pack.name,
            planId: plan.id,
            planName: plan.name,
            planMonthlyPriceMinor: typeof plan.monthlyPriceMinor === "number" ? plan.monthlyPriceMinor : null,
            planCurrency: plan.currency ?? "TRY",
            includedMinutes: Number.isFinite(minutes) ? minutes : 0,
            telephonyProviders,
            llmProviders: asList2(perms, "centeros_llm_providers", "centeros_llm_provider", [
              "openai"
            ]),
            sttProviders: asList2(perms, "centeros_stt_providers", "centeros_stt_provider", [
              "deepgram"
            ]),
            ttsProviders: asList2(perms, "centeros_tts_providers", "centeros_tts_provider", [
              "elevenlabs"
            ])
          },
          costRates,
          retailRates,
          scenario,
          assumptions
        )
      );
    }
    const linked = new Set(results.map((r) => r.packageId));
    for (const pack of packages) {
      if (linked.has(pack.id)) continue;
      const perms = pack.permissions || {};
      const minutes = Number(perms.centeros_voice_minutes_limit ?? 0);
      results.push(
        simulatePackageEconomics2(
          {
            packageId: pack.id,
            packageName: pack.name,
            planId: null,
            planName: null,
            planMonthlyPriceMinor: null,
            planCurrency: null,
            includedMinutes: Number.isFinite(minutes) ? minutes : 0,
            telephonyProviders: ["verimor", "zadarma"],
            llmProviders: asList2(perms, "centeros_llm_providers", "centeros_llm_provider", [
              "openai"
            ]),
            sttProviders: asList2(perms, "centeros_stt_providers", "centeros_stt_provider", [
              "deepgram"
            ]),
            ttsProviders: asList2(perms, "centeros_tts_providers", "centeros_tts_provider", [
              "elevenlabs"
            ])
          },
          costRates,
          retailRates,
          scenario,
          assumptions
        )
      );
    }
    return results;
  }, [packages, plans, poolByE164, costRates, retailRates, scenario, assumptions]);
  const summary = useMemo12(() => {
    const complete = rows.filter((r) => !r.incomplete);
    const missingTel = rows.filter((r) => r.missingTelephonyCost).length;
    let lowestMargin = null;
    let highestCost = null;
    let potentialRevenue = 0;
    for (const row of complete) {
      if (row.marginBps !== null) {
        if (!lowestMargin || (lowestMargin.marginBps ?? 0) > row.marginBps) lowestMargin = row;
      }
      if (!highestCost || highestCost.wholesaleTotal.tryMinor < row.wholesaleTotal.tryMinor) {
        highestCost = row;
      }
    }
    for (const row of rows) {
      if (row.totalPotentialRevenueTryMinor !== null) {
        potentialRevenue += row.totalPotentialRevenueTryMinor;
      }
    }
    return { lowestMargin, highestCost, missingTel, potentialRevenue, count: rows.length };
  }, [rows]);
  return /* @__PURE__ */ jsxs20("section", { className: "plat-panel", style: { marginBottom: 16 }, "data-testid": "package-economics", children: [
    /* @__PURE__ */ jsxs20("div", { className: "plat-panel-head", children: [
      /* @__PURE__ */ jsxs20("div", { children: [
        /* @__PURE__ */ jsx20("h3", { children: t("Package economics") }),
        /* @__PURE__ */ jsx20("p", { children: t(
          "Simulated cost / sale / margin for each linked plan using included minutes and current rate cards. Not an invoice. Telephony uses providerMeters when set."
        ) })
      ] }),
      /* @__PURE__ */ jsx20("div", { className: "plat-panel-actions", children: /* @__PURE__ */ jsxs20("label", { className: "plat-field", style: { minWidth: 160 }, children: [
        /* @__PURE__ */ jsx20("span", { children: t("Telephony scenario") }),
        /* @__PURE__ */ jsx20(
          "select",
          {
            className: "plat-input",
            value: scenario,
            onChange: (e) => setScenario(e.target.value),
            children: SCENARIOS.map((s) => /* @__PURE__ */ jsx20("option", { value: s.id, children: t(s.label) }, s.id))
          }
        )
      ] }) })
    ] }),
    summary.missingTel > 0 && /* @__PURE__ */ jsxs20("div", { className: "plat-alert plat-alert-warn", role: "status", children: [
      /* @__PURE__ */ jsx20("strong", { children: t("Incomplete packages") }),
      /* @__PURE__ */ jsxs20("span", { children: [
        summary.missingTel,
        " ",
        t("packages missing telephony cost"),
        " \u2014",
        " ",
        t(
          "Verimor/Zadarma cost must be entered before package profitability is complete."
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs20(
      "div",
      {
        className: "plat-stat-grid",
        style: { marginBottom: 8, gridTemplateColumns: "repeat(4, minmax(88px, 1fr))" },
        children: [
          /* @__PURE__ */ jsxs20("div", { className: "plat-stat", children: [
            /* @__PURE__ */ jsx20("strong", { children: summary.lowestMargin ? formatMargin2(summary.lowestMargin.marginBps) : "\u2014" }),
            /* @__PURE__ */ jsx20("span", { children: t("Lowest margin pack") }),
            /* @__PURE__ */ jsx20("small", { style: { fontSize: 11, color: "#78716c" }, children: summary.lowestMargin?.packageName ?? "\u2014" })
          ] }),
          /* @__PURE__ */ jsxs20("div", { className: "plat-stat", children: [
            /* @__PURE__ */ jsx20("strong", { children: summary.highestCost ? formatTry2(summary.highestCost.wholesaleTotal.tryMinor) : "\u2014" }),
            /* @__PURE__ */ jsx20("span", { children: t("Highest estimated cost") }),
            /* @__PURE__ */ jsx20("small", { style: { fontSize: 11, color: "#78716c" }, children: summary.highestCost?.packageName ?? "\u2014" })
          ] }),
          /* @__PURE__ */ jsxs20("div", { className: "plat-stat", children: [
            /* @__PURE__ */ jsx20("strong", { children: summary.missingTel }),
            /* @__PURE__ */ jsx20("span", { children: t("Missing telephony cost") })
          ] }),
          /* @__PURE__ */ jsxs20("div", { className: "plat-stat", children: [
            /* @__PURE__ */ jsx20("strong", { children: formatTry2(summary.potentialRevenue) }),
            /* @__PURE__ */ jsx20("span", { children: t("Monthly potential revenue") })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs20("div", { className: "plat-field-row", style: { marginBottom: 12 }, children: [
      /* @__PURE__ */ jsxs20("label", { className: "plat-field", children: [
        /* @__PURE__ */ jsx20("span", { children: t("TTS chars / min") }),
        /* @__PURE__ */ jsx20(
          "input",
          {
            className: "plat-input mono",
            type: "number",
            min: 0,
            step: 50,
            value: assumptions.ttsCharsPerMinute,
            onChange: (e) => setAssumptions((a) => ({
              ...a,
              ttsCharsPerMinute: Math.max(0, Number(e.target.value) || 0)
            }))
          }
        )
      ] }),
      /* @__PURE__ */ jsxs20("label", { className: "plat-field", children: [
        /* @__PURE__ */ jsx20("span", { children: t("LLM input tokens / min") }),
        /* @__PURE__ */ jsx20(
          "input",
          {
            className: "plat-input mono",
            type: "number",
            min: 0,
            step: 50,
            value: assumptions.llmInputTokensPerMinute,
            onChange: (e) => setAssumptions((a) => ({
              ...a,
              llmInputTokensPerMinute: Math.max(0, Number(e.target.value) || 0)
            }))
          }
        )
      ] }),
      /* @__PURE__ */ jsxs20("label", { className: "plat-field", children: [
        /* @__PURE__ */ jsx20("span", { children: t("LLM output tokens / min") }),
        /* @__PURE__ */ jsx20(
          "input",
          {
            className: "plat-input mono",
            type: "number",
            min: 0,
            step: 50,
            value: assumptions.llmOutputTokensPerMinute,
            onChange: (e) => setAssumptions((a) => ({
              ...a,
              llmOutputTokensPerMinute: Math.max(0, Number(e.target.value) || 0)
            }))
          }
        )
      ] })
    ] }),
    rows.length === 0 ? /* @__PURE__ */ jsxs20("div", { className: "plat-empty", children: [
      /* @__PURE__ */ jsx20("strong", { children: t("No packages to simulate") }),
      /* @__PURE__ */ jsx20("p", { children: t("Create a CenterOS package and link it to a Panaryus plan.") })
    ] }) : /* @__PURE__ */ jsx20("div", { className: "plat-table-wrap", children: /* @__PURE__ */ jsxs20("table", { className: "plat-table", style: { minWidth: 1100 }, children: [
      /* @__PURE__ */ jsx20("thead", { children: /* @__PURE__ */ jsxs20("tr", { children: [
        /* @__PURE__ */ jsx20("th", { children: t("Panaryus plan") }),
        /* @__PURE__ */ jsx20("th", { children: t("CenterOS package") }),
        /* @__PURE__ */ jsx20("th", { children: t("Included minutes") }),
        /* @__PURE__ */ jsx20("th", { children: t("Phone providers") }),
        /* @__PURE__ */ jsx20("th", { children: t("AI stack") }),
        /* @__PURE__ */ jsx20("th", { children: t("Estimated real cost") }),
        /* @__PURE__ */ jsx20("th", { children: t("Usage sale amount") }),
        /* @__PURE__ */ jsx20("th", { children: t("Plan subscription") }),
        /* @__PURE__ */ jsx20("th", { children: t("Total potential revenue") }),
        /* @__PURE__ */ jsx20("th", { children: t("Gross profit") }),
        /* @__PURE__ */ jsx20("th", { children: t("Margin") }),
        /* @__PURE__ */ jsx20("th", { children: t("Assumptions") })
      ] }) }),
      /* @__PURE__ */ jsx20("tbody", { children: rows.map((row) => /* @__PURE__ */ jsxs20("tr", { children: [
        /* @__PURE__ */ jsxs20("td", { children: [
          /* @__PURE__ */ jsx20("strong", { children: row.planName ?? "\u2014" }),
          row.planId !== null ? /* @__PURE__ */ jsxs20("small", { className: "mono", children: [
            " #",
            row.planId
          ] }) : null
        ] }),
        /* @__PURE__ */ jsxs20("td", { children: [
          /* @__PURE__ */ jsx20("strong", { children: row.packageName }),
          /* @__PURE__ */ jsx20("br", {}),
          /* @__PURE__ */ jsx20("small", { className: "mono", children: row.packageId })
        ] }),
        /* @__PURE__ */ jsx20("td", { className: "mono", children: row.includedMinutes }),
        /* @__PURE__ */ jsxs20("td", { children: [
          /* @__PURE__ */ jsx20("span", { className: "plat-rate-unit", children: row.telephonyProviders.join(", ") || "\u2014" }),
          row.resolvedTelephonyProvider ? /* @__PURE__ */ jsxs20("small", { style: { display: "block", color: "#78716c" }, children: [
            "\u2192 ",
            row.resolvedTelephonyProvider
          ] }) : null
        ] }),
        /* @__PURE__ */ jsx20("td", { children: /* @__PURE__ */ jsxs20("small", { children: [
          "LLM [",
          row.llmProviders.join(", ") || "\u2014",
          "]",
          /* @__PURE__ */ jsx20("br", {}),
          "STT [",
          row.sttProviders.join(", ") || "\u2014",
          "]",
          /* @__PURE__ */ jsx20("br", {}),
          "TTS [",
          row.ttsProviders.join(", ") || "\u2014",
          "]"
        ] }) }),
        /* @__PURE__ */ jsx20("td", { className: "mono", children: row.incomplete ? t("Incomplete") : formatDual2(row.wholesaleTotal.tryMinor, row.wholesaleTotal.usdMinor) }),
        /* @__PURE__ */ jsx20("td", { className: "mono", children: formatDual2(row.usageRetailTotal.tryMinor, row.usageRetailTotal.usdMinor) }),
        /* @__PURE__ */ jsx20("td", { className: "mono", children: row.planMonthlyPriceMinor !== null ? `${formatTry2(row.planMonthlyPriceMinor)}${row.planCurrency && row.planCurrency !== "TRY" ? ` (${row.planCurrency})` : ""}` : "\u2014" }),
        /* @__PURE__ */ jsx20("td", { className: "mono", children: row.totalPotentialRevenueTryMinor !== null ? formatTry2(row.totalPotentialRevenueTryMinor) : "\u2014" }),
        /* @__PURE__ */ jsx20("td", { className: "mono", children: row.incomplete ? "\u2014" : formatDual2(row.grossProfit.tryMinor, row.grossProfit.usdMinor) }),
        /* @__PURE__ */ jsx20("td", { children: /* @__PURE__ */ jsx20(
          "span",
          {
            className: row.marginBps === null ? "plat-badge muted" : row.marginBps >= 4e3 ? "plat-badge teal" : row.marginBps > 0 ? "plat-badge ok" : "plat-badge muted",
            children: formatMargin2(row.marginBps)
          }
        ) }),
        /* @__PURE__ */ jsx20("td", { children: /* @__PURE__ */ jsx20("small", { style: { color: "#64748b", lineHeight: 1.35 }, children: row.assumptionSummary }) })
      ] }, `${row.planId ?? "none"}-${row.packageId}`)) })
    ] }) })
  ] });
};

// src/tariff-editor.ts
import {
  DEFAULT_COST_RATES,
  DEFAULT_RETAIL_RATES,
  detectActiveCostServices,
  meterRateHasPrice as meterRateHasPrice2
} from "@agentos/domain";
var tariffRowId = (meter, provider) => {
  if (meter === "telephony_minutes" && provider && provider !== "\u2014") {
    return `${meter}@${provider.toLowerCase()}`;
  }
  return meter;
};
var BRIDGE_DOWN_WARNING = "Panaryus admin bridge could not load saved tariffs. Values below are defaults and may not be saved until the bridge is healthy.";
var isHostAdminFailure = (message3) => /HOST_ADMIN_FAILED|HOST_KEY_MISSING|admin köprüsü|admin bridge/i.test(message3);
var parseMajor = (raw) => {
  const normalized = raw.trim().replace(",", ".");
  if (normalized === "") return 0;
  const n = Number(normalized);
  return Number.isFinite(n) && n >= 0 ? n : 0;
};
var formatMajorInput = (major) => {
  if (!Number.isFinite(major)) return "0";
  const s = major.toFixed(6).replace(/\.?0+$/u, "");
  return s === "" ? "0" : s;
};
var tariffUnitShortTr = (unit) => {
  switch (unit) {
    case "per_minute":
      return "dk";
    case "per_hour":
      return "saat";
    case "per_1k_chars":
      return "1K karakter";
    case "per_1m_tokens":
      return "1M token";
    case "per_message":
      return "adet";
    case "per_second":
      return "sn";
    default:
      return unit;
  }
};
var tariffUnitLabel = (unit) => {
  switch (unit) {
    case "per_minute":
      return "per minute";
    case "per_hour":
      return "per hour";
    case "per_1k_chars":
      return "per 1K characters";
    case "per_1m_tokens":
      return "per 1M tokens";
    case "per_message":
      return "per message";
    case "per_second":
      return "per second";
    default:
      return unit;
  }
};
var formatRateTr = (major, currency, unit) => {
  if (major === null || major === void 0 || !Number.isFinite(major)) return "\u2014";
  const maxFrac = unit === "per_hour" || unit === "per_1m_tokens" || unit === "per_minute" ? 4 : 4;
  const amount = new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: maxFrac
  }).format(major);
  return `${amount} ${currency} / ${tariffUnitShortTr(unit)}`;
};
var readMeters = (json2) => {
  try {
    const parsed = JSON.parse(json2);
    if (parsed?.meters && typeof parsed.meters === "object") return { ...parsed.meters };
  } catch {
  }
  return {};
};
var readProviderMeters = (json2) => {
  try {
    const parsed = JSON.parse(json2);
    if (parsed?.providerMeters && typeof parsed.providerMeters === "object") {
      return { ...parsed.providerMeters };
    }
  } catch {
  }
  return {};
};
var rateForRow = (meters, providerMeters, meter, provider) => {
  if (meter === "telephony_minutes" && provider && provider !== "\u2014") {
    const scoped = providerMeters[provider.toLowerCase()]?.[meter];
    if (scoped && meterRateHasPrice2(scoped)) return scoped;
    if (scoped && typeof scoped === "object") return scoped;
  }
  return meters[meter];
};
var extractDisplayPrice = (rate, unit, fallback) => {
  if (!rate || !meterRateHasPrice2(rate)) {
    return {
      currency: fallback.currency,
      major: fallback.major,
      present: false
    };
  }
  const pick = (tryKey, usdKey, tryMinorKey, usdMinorKey) => {
    const tryV = rate[tryKey];
    const usdV = rate[usdKey];
    if (typeof tryV === "number" && Number.isFinite(tryV)) {
      return { currency: "TRY", major: tryV };
    }
    if (typeof usdV === "number" && Number.isFinite(usdV)) {
      return { currency: "USD", major: usdV };
    }
    if (tryMinorKey) {
      const tm = rate[tryMinorKey];
      if (typeof tm === "number" && Number.isFinite(tm)) {
        return { currency: "TRY", major: tm / 100 };
      }
    }
    if (usdMinorKey) {
      const um = rate[usdMinorKey];
      if (typeof um === "number" && Number.isFinite(um)) {
        return { currency: "USD", major: um / 100 };
      }
    }
    return null;
  };
  let found = null;
  switch (unit) {
    case "per_hour":
      found = pick("tryPerHour", "usdPerHour") ?? // migrate: minor-per-second × 3600 / 100 was wrong; if only per-unit seconds legacy, convert
      (() => {
        const u = pick("tryPerUnit", "usdPerUnit", "tryMinorPerUnit", "usdMinorPerUnit");
        if (!u) return null;
        if (rate.usdMinorPerUnit !== void 0 || rate.tryMinorPerUnit !== void 0) {
          return { currency: u.currency, major: u.major * 3600 };
        }
        return u;
      })();
      break;
    case "per_minute":
      found = pick("tryPerMinute", "usdPerMinute") ?? pick("tryPerUnit", "usdPerUnit", "tryMinorPerUnit", "usdMinorPerUnit");
      break;
    case "per_1k_chars":
      found = pick("tryPer1k", "usdPer1k", "tryMinorPer1k", "usdMinorPer1k");
      break;
    case "per_1m_tokens":
      found = pick("tryPer1m", "usdPer1m") ?? // migrate: usdPer1k * 1000 or usdMinorPer1k/100 * 1000
      (() => {
        const k = pick("tryPer1k", "usdPer1k", "tryMinorPer1k", "usdMinorPer1k");
        return k ? { currency: k.currency, major: k.major * 1e3 } : null;
      })();
      break;
    case "per_message":
    case "per_second":
      found = pick("tryPerUnit", "usdPerUnit", "tryMinorPerUnit", "usdMinorPerUnit");
      break;
    default:
      found = pick("tryPerUnit", "usdPerUnit", "tryMinorPerUnit", "usdMinorPerUnit");
  }
  if (!found) {
    return { currency: fallback.currency, major: fallback.major, present: false };
  }
  return { currency: found.currency, major: found.major, present: true };
};
var toMeterRateForUnit = (unit, currency, majorRaw) => {
  const major = parseMajor(majorRaw);
  if (unit === "per_hour") {
    return currency === "USD" ? { usdPerHour: major } : { tryPerHour: major };
  }
  if (unit === "per_minute") {
    return currency === "USD" ? { usdPerMinute: major } : { tryPerMinute: major };
  }
  if (unit === "per_1k_chars") {
    return currency === "USD" ? { usdPer1k: major } : { tryPer1k: major };
  }
  if (unit === "per_1m_tokens") {
    return currency === "USD" ? { usdPer1m: major } : { tryPer1m: major };
  }
  return currency === "USD" ? { usdPerUnit: major } : { tryPerUnit: major };
};
var defaultRetailFor = (service) => {
  const retail = DEFAULT_RETAIL_RATES.meters[service.meter];
  const extracted = extractDisplayPrice(retail, service.displayUnit, {
    currency: service.suggestedCostCurrency,
    major: service.suggestedCostMajor !== null ? service.suggestedCostMajor * 2 : 0
  });
  return {
    currency: extracted.currency,
    major: extracted.major ?? 0
  };
};
var buildTariffRows = (costJson, retailJson, env = {}, options) => {
  const services = detectActiveCostServices(
    env,
    options?.didProviders ? { didProviders: options.didProviders } : void 0
  );
  const costMeters = readMeters(costJson);
  const retailMeters = readMeters(retailJson);
  const costProviderMeters = readProviderMeters(costJson);
  const retailProviderMeters = readProviderMeters(retailJson);
  return services.map((svc) => {
    const costFallback = {
      currency: svc.suggestedCostCurrency,
      major: svc.suggestedCostMajor
    };
    const costRate = rateForRow(costMeters, costProviderMeters, svc.meter, svc.provider);
    const retailRate = rateForRow(retailMeters, retailProviderMeters, svc.meter, svc.provider);
    const cost = extractDisplayPrice(costRate, svc.displayUnit, costFallback);
    const retailFb = defaultRetailFor(svc);
    const retail = extractDisplayPrice(retailRate, svc.displayUnit, {
      currency: retailFb.currency,
      major: retailFb.major
    });
    const costOperatorRequired = svc.source === "operator_required" || svc.source === "needs_verification" || !cost.present && svc.suggestedCostMajor === null;
    const costMajor = cost.present && cost.major !== null ? formatMajorInput(cost.major) : svc.suggestedCostMajor !== null && svc.source === "vendor_list" ? formatMajorInput(svc.suggestedCostMajor) : "";
    const retailMajor = retail.present && retail.major !== null ? formatMajorInput(retail.major) : formatMajorInput(retailFb.major);
    return {
      meter: svc.meter,
      rowId: tariffRowId(svc.meter, svc.provider),
      provider: svc.provider,
      model: svc.model,
      billedModel: svc.billedModel,
      displayUnit: svc.displayUnit,
      source: svc.source,
      sourceUrl: svc.sourceUrl,
      checkedAt: svc.checkedAt ?? null,
      effectiveAt: svc.effectiveAt ?? null,
      verified: svc.verified,
      notes: svc.notes,
      suggestedCostMajor: svc.suggestedCostMajor,
      suggestedCostCurrency: svc.suggestedCostCurrency,
      costCurrency: cost.present ? cost.currency : svc.suggestedCostCurrency,
      costMajor,
      retailCurrency: retail.present ? retail.currency : retailFb.currency,
      retailMajor,
      costOperatorRequired
    };
  });
};
var defaultTariffRows = (env = {}, options) => buildTariffRows(
  JSON.stringify(DEFAULT_COST_RATES, null, 2),
  JSON.stringify(DEFAULT_RETAIL_RATES, null, 2),
  env,
  options
);
var rowDiffersFromVendorList = (row) => {
  if (row.source !== "vendor_list" || row.suggestedCostMajor === null || row.suggestedCostMajor === void 0) {
    return false;
  }
  if (row.costMajor.trim() === "") return false;
  if (row.costCurrency !== (row.suggestedCostCurrency ?? "USD")) return true;
  const saved = parseMajor(row.costMajor);
  return Math.abs(saved - row.suggestedCostMajor) > 1e-9;
};
var applyVendorListCosts = (rows) => rows.map((row) => {
  if (row.source !== "vendor_list" || row.suggestedCostMajor === null || row.suggestedCostMajor === void 0) {
    return row;
  }
  return {
    ...row,
    costCurrency: row.suggestedCostCurrency ?? "USD",
    costMajor: formatMajorInput(row.suggestedCostMajor),
    costOperatorRequired: false
  };
});
var mergeJson = (previousJson, kind, rows) => {
  const fallback = kind === "cost" ? DEFAULT_COST_RATES : DEFAULT_RETAIL_RATES;
  let base = {};
  try {
    base = JSON.parse(previousJson);
    if (!base || typeof base !== "object") base = {};
  } catch {
    base = {};
  }
  const meters = {
    ...fallback.meters,
    ...base.meters && typeof base.meters === "object" ? base.meters : {}
  };
  const providerMeters = {
    ...base.providerMeters && typeof base.providerMeters === "object" ? base.providerMeters : {}
  };
  const meta = {
    ...fallback.meta,
    ...base.meta && typeof base.meta === "object" ? base.meta : {}
  };
  for (const row of rows) {
    const rateEmpty = kind === "cost" && row.costMajor.trim() === "" && row.costOperatorRequired;
    const major = kind === "cost" ? row.costMajor : row.retailMajor;
    const currency = kind === "cost" ? row.costCurrency : row.retailCurrency;
    const nextRate = rateEmpty ? {} : toMeterRateForUnit(row.displayUnit, currency, major);
    const isProviderScoped = row.meter === "telephony_minutes" && row.provider && row.provider !== "\u2014";
    if (isProviderScoped) {
      const pKey = row.provider.toLowerCase();
      providerMeters[pKey] = {
        ...providerMeters[pKey] ?? {},
        [row.meter]: nextRate
      };
      if (!meters.telephony_minutes || !meterRateHasPrice2(meters.telephony_minutes)) {
        meters.telephony_minutes = {};
      }
    } else {
      meters[row.meter] = nextRate;
    }
    const metaKey = isProviderScoped ? `${row.meter}@${row.provider.toLowerCase()}` : row.meter;
    meta[metaKey] = {
      provider: row.provider,
      model: row.model,
      ...row.billedModel ? { billedModel: row.billedModel } : {},
      source: row.source,
      operatorEntered: row.costOperatorRequired || row.source === "operator_required" || row.source === "needs_verification",
      verified: row.verified === true && row.source === "vendor_list",
      asOf: row.effectiveAt ?? (/* @__PURE__ */ new Date()).toISOString().slice(0, 10),
      checkedAt: row.checkedAt ?? null,
      effectiveAt: row.effectiveAt ?? null,
      ...row.sourceUrl ? { sourceUrl: row.sourceUrl } : {}
    };
  }
  if (!meters.voice_seconds) meters.voice_seconds = { usdPerUnit: 0 };
  const usdTry = typeof base.fx?.usdTry === "number" && base.fx.usdTry > 0 ? base.fx.usdTry : fallback.fx.usdTry;
  const asOf = base.fx?.asOf !== void 0 ? base.fx.asOf : fallback.fx.asOf;
  return JSON.stringify(
    {
      baseCurrency: base.baseCurrency === "TRY" || base.baseCurrency === "USD" ? base.baseCurrency : fallback.baseCurrency,
      fx: { usdTry, asOf },
      meters,
      ...Object.keys(providerMeters).length > 0 ? { providerMeters } : {},
      meta
    },
    null,
    2
  );
};
var rateCardsFromRows = (rows, previous) => ({
  costRatesJson: mergeJson(previous.costRatesJson, "cost", rows),
  retailRatesJson: mergeJson(previous.retailRatesJson, "retail", rows)
});
var readUsdTry = (costJson, retailJson) => {
  for (const raw of [costJson, retailJson]) {
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed?.fx?.usdTry === "number" && parsed.fx.usdTry > 0) return parsed.fx.usdTry;
    } catch {
    }
  }
  return DEFAULT_COST_RATES.fx.usdTry;
};
var formatMoneyMajor = (major, currency) => {
  const amount = new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4
  }).format(major);
  return `${amount} ${currency}`;
};
var rowEconomics = (row, usdTry) => {
  const costRateLabel = row.costMajor.trim() === "" ? "\u2014" : formatRateTr(parseMajor(row.costMajor), row.costCurrency, row.displayUnit);
  const retailRateLabel = formatRateTr(
    parseMajor(row.retailMajor),
    row.retailCurrency,
    row.displayUnit
  );
  if (row.costMajor.trim() === "") {
    return {
      profitLabel: "\u2014",
      marginLabel: "\u2014",
      marginPct: 0,
      costRateLabel,
      retailRateLabel
    };
  }
  const costMajor = parseMajor(row.costMajor);
  const retailMajor = parseMajor(row.retailMajor);
  if (row.costCurrency === row.retailCurrency) {
    const profit2 = retailMajor - costMajor;
    const marginPct2 = retailMajor > 0 ? profit2 / retailMajor * 100 : 0;
    return {
      profitLabel: formatMoneyMajor(profit2, row.costCurrency),
      marginLabel: `${marginPct2.toFixed(1).replace(".", ",")}%`,
      marginPct: marginPct2,
      costRateLabel,
      retailRateLabel
    };
  }
  const costTry = row.costCurrency === "TRY" ? costMajor : costMajor * usdTry;
  const retailTry = row.retailCurrency === "TRY" ? retailMajor : retailMajor * usdTry;
  const profit = retailTry - costTry;
  const marginPct = retailTry > 0 ? profit / retailTry * 100 : 0;
  return {
    profitLabel: `${formatMoneyMajor(profit, "TRY")} (kur)`,
    marginLabel: `${marginPct.toFixed(1).replace(".", ",")}%`,
    marginPct,
    costRateLabel,
    retailRateLabel
  };
};
var DEFAULT_COST_RATES_JSON = JSON.stringify(DEFAULT_COST_RATES, null, 2);
var DEFAULT_RETAIL_RATES_JSON = JSON.stringify(DEFAULT_RETAIL_RATES, null, 2);
var readBrowserProviderEnv = () => ({
  CENTEROS_LLM_PROVIDER: "openai",
  OPENAI_MODEL: "gpt-5",
  CENTEROS_STT_PROVIDER: "deepgram",
  DEEPGRAM_MODEL: "nova-3",
  CENTEROS_TTS_PROVIDER: "elevenlabs",
  ELEVENLABS_MODEL_ID: "eleven_flash_v2_5",
  // Dual-trunk catalog default (routing supports both).
  CENTEROS_TELEPHONY_PROVIDERS: "zadarma,verimor"
});

// src/platform-admin.tsx
import { Fragment as Fragment11, jsx as jsx21, jsxs as jsxs21 } from "react/jsx-runtime";
var PROVIDERS = [
  { value: "verimor", label: "Verimor" },
  { value: "zadarma", label: "Zadarma" },
  { value: "twilio", label: "Twilio" },
  { value: "manual", label: "Manual" }
];
var emptyDid = () => ({
  e164: "",
  provider: "verimor",
  label: "",
  geoScope: "tr",
  enabled: true
});
var emptyPackage = (index) => ({
  id: `voice_${index}`,
  name: "New CenterOS pack",
  description: "",
  permissions: {
    centeros: true,
    centeros_agents: true,
    centeros_webchat: false,
    centeros_voice: true,
    centeros_voice_profile: "growth",
    centeros_voice_minutes_limit: 60,
    centeros_voice_max_call_seconds: 900,
    centeros_voice_concurrent_calls: 1,
    centeros_platform_did_mode: "selected",
    centeros_use_platform_dids: true,
    centeros_allowed_dids: [],
    centeros_llm_providers: ["openai"],
    centeros_stt_providers: ["deepgram"],
    centeros_tts_providers: ["elevenlabs"],
    centeros_llm_provider: "openai",
    centeros_stt_provider: "deepgram",
    centeros_tts_provider: "elevenlabs",
    centeros_realtime: false,
    centeros_enabled_services: {
      voice: true,
      stt: true,
      tts: true,
      llm: true,
      sms: false,
      webchat: false,
      realtime: false
    },
    centeros_telephony_providers: ["verimor", "zadarma"],
    centeros_package_retail_overrides: {},
    centeros_package_economics_assumptions: {
      ttsCharsPerMinute: 900,
      llmInputTokensPerMinute: 1200,
      llmOutputTokensPerMinute: 350
    },
    centeros_package_telephony_scenario: "most_expensive"
  }
});
var createPlatformAdminApi = (baseUrl, token) => {
  const request = async (path, init) => {
    const response = await fetch(`${baseUrl}${path}`, {
      ...init,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      signal: AbortSignal.timeout(15e3)
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      const code = body.code || `HTTP_${response.status}`;
      if (code === "PLATFORM_ADMIN_REQUIRED") {
        throw new Error(
          "PLATFORM_ADMIN_REQUIRED: Bu oturumda platform.admin yok. Portal \xFCzerinden Call Center\u2019\u0131 yeniden a\xE7\u0131n."
        );
      }
      if (code === "SESSION_EXPIRED" || response.status === 401 && code !== "HOST_KEY_INVALID") {
        throw new Error(
          "SESSION_EXPIRED: CenterOS oturumu doldu. Sayfay\u0131 yenileyin (Ctrl+Shift+R)."
        );
      }
      if (code === "HOST_ADMIN_FAILED" || code === "HOST_KEY_MISSING" || response.status === 502) {
        throw new Error(
          body.detail || body.message || "HOST_ADMIN_FAILED: Panaryus admin k\xF6pr\xFCs\xFC yan\u0131t vermedi. Birka\xE7 saniye sonra tekrar deneyin."
        );
      }
      throw new Error(body.detail || body.message || code);
    }
    return response.json();
  };
  return {
    state: async () => await request("/v1/platform-admin/state"),
    saveDidPool: async (items) => {
      await request("/v1/platform-admin/did-pool", {
        method: "PUT",
        body: JSON.stringify({ items })
      });
    },
    savePackages: async (items) => {
      await request("/v1/platform-admin/packages", {
        method: "PUT",
        body: JSON.stringify({ items })
      });
    },
    saveRateCards: async (input) => {
      await request("/v1/platform-admin/rate-cards", {
        method: "PUT",
        body: JSON.stringify(input)
      });
    },
    linkPlan: async (planId, packageId) => {
      await request("/v1/platform-admin/plan-link", {
        method: "PUT",
        body: JSON.stringify({ planId, packageId })
      });
    }
  };
};
var PlatformAdminPage = ({
  api,
  locale: localeProp
}) => {
  const locale = localeFrom(typeof localeProp === "string" ? localeProp : localeProp);
  const t = (text) => translate(locale, text);
  const [tab, setTab] = useState19("did");
  const [didPool, setDidPool] = useState19([]);
  const [packages, setPackages] = useState19([]);
  const [plans, setPlans] = useState19([]);
  const providerEnv = useMemo13(() => readBrowserProviderEnv(), []);
  const [rateCards, setRateCards] = useState19({
    costRatesJson: DEFAULT_COST_RATES_JSON,
    retailRatesJson: DEFAULT_RETAIL_RATES_JSON
  });
  const [tariffRows, setTariffRows] = useState19(
    () => defaultTariffRows(readBrowserProviderEnv())
  );
  const [ratesLoadedFromHost, setRatesLoadedFromHost] = useState19(false);
  const [bridgeDown, setBridgeDown] = useState19(false);
  const [advancedJsonOpen, setAdvancedJsonOpen] = useState19(false);
  const [error, setError] = useState19("");
  const [notice, setNotice] = useState19("");
  const [busy, setBusy] = useState19(false);
  const [loading, setLoading] = useState19(true);
  const didProviders = useMemo13(
    () => [
      ...new Set(
        didPool.filter((row) => row.enabled !== false && row.e164.trim()).map((row) => String(row.provider || "").toLowerCase()).filter(Boolean)
      )
    ],
    [didPool]
  );
  const rebuildTariffRows = useCallback17(
    (cards, providers) => buildTariffRows(cards.costRatesJson, cards.retailRatesJson, providerEnv, {
      didProviders: providers
    }),
    [providerEnv]
  );
  const applyRateCards = useCallback17(
    (next, fromHost, providers) => {
      setRateCards(next);
      setTariffRows(rebuildTariffRows(next, providers));
      setRatesLoadedFromHost(fromHost);
    },
    [rebuildTariffRows]
  );
  const load = useCallback17(async () => {
    setError("");
    setBridgeDown(false);
    const state = await api.state();
    const nextDids = state.didPool.map((row) => ({
      e164: row.e164,
      provider: row.provider || "verimor",
      label: row.label ?? "",
      geoScope: row.geoScope || "tr",
      enabled: row.enabled !== false
    }));
    setDidPool(nextDids);
    setPackages([...state.packages]);
    setPlans([...state.plans]);
    const providers = [
      ...new Set(
        nextDids.filter((row) => row.enabled !== false && row.e164.trim()).map((row) => String(row.provider || "").toLowerCase()).filter(Boolean)
      )
    ];
    applyRateCards(
      {
        costRatesJson: state.rateCards?.costRatesJson || DEFAULT_COST_RATES_JSON,
        retailRatesJson: state.rateCards?.retailRatesJson || DEFAULT_RETAIL_RATES_JSON
      },
      true,
      providers
    );
  }, [api, applyRateCards]);
  useEffect17(() => {
    setLoading(true);
    void load().catch((cause) => {
      const message3 = cause instanceof Error ? cause.message : "LOAD_FAILED";
      setError(message3);
      if (isHostAdminFailure(message3)) {
        setBridgeDown(true);
        setRatesLoadedFromHost(false);
        applyRateCards(
          {
            costRatesJson: DEFAULT_COST_RATES_JSON,
            retailRatesJson: DEFAULT_RETAIL_RATES_JSON
          },
          false,
          []
        );
      }
    }).finally(() => setLoading(false));
  }, [load, applyRateCards]);
  const usdTry = useMemo13(
    () => readUsdTry(rateCards.costRatesJson, rateCards.retailRatesJson),
    [rateCards.costRatesJson, rateCards.retailRatesJson]
  );
  const updateTariffRow = (rowId, patch) => {
    setTariffRows((prev) => {
      const next = prev.map((row) => row.rowId === rowId ? { ...row, ...patch } : row);
      setRateCards((cards) => rateCardsFromRows(next, cards));
      return next;
    });
  };
  const resetVendorListCosts = () => {
    setTariffRows((prev) => {
      const next = applyVendorListCosts(prev);
      setRateCards((cards) => rateCardsFromRows(next, cards));
      setNotice(t("Vendor list costs applied to eligible rows. Review and Save."));
      return next;
    });
  };
  const stats = useMemo13(() => {
    const activeDids = didPool.filter((row) => row.enabled !== false && row.e164.trim()).length;
    const linkedPlans = plans.filter((plan) => plan.packageId && plan.packageId !== "none").length;
    return {
      dids: activeDids,
      packages: packages.length,
      plans: plans.length,
      linked: linkedPlans
    };
  }, [didPool, packages.length, plans]);
  const saveDid = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    setNotice("");
    try {
      const cleaned = didPool.map((row) => ({ ...row, e164: row.e164.trim() })).filter((row) => row.e164.length > 0);
      await api.saveDidPool(cleaned);
      setNotice(t("Platform DID pool saved. Tenants pick up numbers on next login."));
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "SAVE_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const savePacks = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    setNotice("");
    try {
      await api.savePackages(packages);
      setNotice(t("CenterOS packages saved."));
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "SAVE_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const onLinkPlan = async (planId, packageId) => {
    setBusy(true);
    setError("");
    setNotice("");
    try {
      await api.linkPlan(planId, packageId);
      setNotice(t("Panaryus plan linked to CenterOS package."));
      await load();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "LINK_FAILED");
    } finally {
      setBusy(false);
    }
  };
  const saveRates = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    setNotice("");
    if (bridgeDown) {
      setError(t(BRIDGE_DOWN_WARNING));
      setBusy(false);
      return;
    }
    try {
      const payload = rateCardsFromRows(tariffRows, rateCards);
      JSON.parse(payload.costRatesJson);
      JSON.parse(payload.retailRatesJson);
      setRateCards(payload);
      await api.saveRateCards(payload);
      setNotice(
        t("Rate cards saved. Restart CenterOS API to apply runtime env.")
      );
      await load();
    } catch (cause) {
      const message3 = cause instanceof Error ? cause.message : "RATE_CARD_SAVE_FAILED";
      if (isHostAdminFailure(message3)) {
        setBridgeDown(true);
        setRatesLoadedFromHost(false);
      }
      setError(message3);
    } finally {
      setBusy(false);
    }
  };
  const applyAdvancedJson = () => {
    try {
      JSON.parse(rateCards.costRatesJson);
      JSON.parse(rateCards.retailRatesJson);
      setTariffRows(rebuildTariffRows(rateCards, didProviders));
      setNotice(t("Advanced JSON applied to the table."));
      setError("");
    } catch {
      setError(t("Advanced JSON is invalid. Fix JSON before applying."));
    }
  };
  const updateDid = (index, patch) => {
    setDidPool((prev) => prev.map((row, i) => i === index ? { ...row, ...patch } : row));
  };
  const updatePack = (index, patch) => {
    setPackages((prev) => prev.map((row, i) => i === index ? { ...row, ...patch } : row));
  };
  const updatePackPerm = (index, key, value) => {
    setPackages(
      (prev) => prev.map(
        (row, i) => i === index ? { ...row, permissions: { ...row.permissions || {}, [key]: value } } : row
      )
    );
  };
  const tabs = [
    {
      id: "did",
      label: t("Platform DIDs"),
      count: stats.dids,
      hint: t("Shared outbound CLI numbers")
    },
    {
      id: "packages",
      label: t("CenterOS packages"),
      count: stats.packages,
      hint: t("Capability packs for plans")
    },
    {
      id: "plans",
      label: t("Panaryus plan links"),
      count: stats.linked,
      hint: t("Which plan gets which pack")
    },
    {
      id: "rates",
      label: t("Tariffs"),
      count: tariffRows.length,
      hint: t("Cost and sale rates")
    }
  ];
  return /* @__PURE__ */ jsxs21(
    "div",
    {
      className: "plat-page",
      "data-testid": "platform-admin-page",
      "data-build": "platform-admin-load-loop-fix-2026-08-08",
      children: [
        /* @__PURE__ */ jsx21("style", { children: platformAdminStyles }),
        /* @__PURE__ */ jsxs21("header", { className: "plat-hero", children: [
          /* @__PURE__ */ jsxs21("div", { className: "plat-hero-copy", children: [
            /* @__PURE__ */ jsxs21("span", { className: "plat-kicker", children: [
              "CENTEROS \xB7 ",
              t("PLATFORM ADMIN")
            ] }),
            /* @__PURE__ */ jsx21("h2", { children: t("Platform settings") }),
            /* @__PURE__ */ jsx21("p", { children: t(
              "Operator desk for shared DIDs, reusable CenterOS packs, and which Panaryus plan unlocks them."
            ) })
          ] }),
          /* @__PURE__ */ jsxs21("div", { className: "plat-stat-grid", "aria-label": t("Summary"), children: [
            /* @__PURE__ */ jsxs21("div", { className: "plat-stat", children: [
              /* @__PURE__ */ jsx21("strong", { children: stats.dids }),
              /* @__PURE__ */ jsx21("span", { children: t("Active DIDs") })
            ] }),
            /* @__PURE__ */ jsxs21("div", { className: "plat-stat", children: [
              /* @__PURE__ */ jsx21("strong", { children: stats.packages }),
              /* @__PURE__ */ jsx21("span", { children: t("Packages") })
            ] }),
            /* @__PURE__ */ jsxs21("div", { className: "plat-stat", children: [
              /* @__PURE__ */ jsxs21("strong", { children: [
                stats.linked,
                /* @__PURE__ */ jsxs21("small", { children: [
                  "/",
                  stats.plans
                ] })
              ] }),
              /* @__PURE__ */ jsx21("span", { children: t("Plans linked") })
            ] })
          ] })
        ] }),
        error && /* @__PURE__ */ jsxs21("div", { className: "plat-alert plat-alert-error", role: "alert", children: [
          /* @__PURE__ */ jsx21("strong", { children: t("Error") }),
          /* @__PURE__ */ jsx21("span", { children: error })
        ] }),
        notice && /* @__PURE__ */ jsxs21("div", { className: "plat-alert plat-alert-ok", role: "status", children: [
          /* @__PURE__ */ jsx21("strong", { children: t("Saved") }),
          /* @__PURE__ */ jsx21("span", { children: notice })
        ] }),
        /* @__PURE__ */ jsx21("nav", { className: "plat-tabs", role: "tablist", "aria-label": t("Platform sections"), children: tabs.map((item) => /* @__PURE__ */ jsxs21(
          "button",
          {
            type: "button",
            role: "tab",
            "aria-selected": tab === item.id,
            className: tab === item.id ? "active" : "",
            onClick: () => {
              setTab(item.id);
              setNotice("");
            },
            children: [
              /* @__PURE__ */ jsx21("span", { className: "plat-tab-label", children: item.label }),
              /* @__PURE__ */ jsxs21("span", { className: "plat-tab-meta", children: [
                /* @__PURE__ */ jsx21("em", { children: item.count }),
                /* @__PURE__ */ jsx21("small", { children: item.hint })
              ] })
            ]
          },
          item.id
        )) }),
        loading ? /* @__PURE__ */ jsxs21("div", { className: "plat-loading", role: "status", "aria-busy": "true", children: [
          /* @__PURE__ */ jsx21("div", { className: "plat-skeleton" }),
          /* @__PURE__ */ jsx21("p", { children: t("Loading platform settings\u2026") })
        ] }) : /* @__PURE__ */ jsxs21(Fragment11, { children: [
          tab === "did" && /* @__PURE__ */ jsxs21("form", { className: "plat-panel", onSubmit: (e) => void saveDid(e), children: [
            /* @__PURE__ */ jsxs21("div", { className: "plat-panel-head", children: [
              /* @__PURE__ */ jsxs21("div", { children: [
                /* @__PURE__ */ jsx21("h3", { children: t("Shared platform phone numbers") }),
                /* @__PURE__ */ jsx21("p", { children: t(
                  "Assigned to entitled tenants on SSO as outbound CLI. Minutes still come from the linked plan pack."
                ) })
              ] }),
              /* @__PURE__ */ jsxs21("div", { className: "plat-panel-actions", children: [
                /* @__PURE__ */ jsxs21(
                  "button",
                  {
                    type: "button",
                    className: "agentos-btn ghost",
                    onClick: () => setDidPool((prev) => [...prev, emptyDid()]),
                    children: [
                      "+ ",
                      t("Add number")
                    ]
                  }
                ),
                /* @__PURE__ */ jsx21("button", { type: "submit", className: "agentos-btn primary", disabled: busy, children: busy ? t("Saving\u2026") : t("Save DID pool") })
              ] })
            ] }),
            didPool.length === 0 ? /* @__PURE__ */ jsxs21("div", { className: "plat-empty", children: [
              /* @__PURE__ */ jsx21("strong", { children: t("No platform numbers yet") }),
              /* @__PURE__ */ jsx21("p", { children: t("Add a Verimor or Zadarma DID that tenants can use as outbound CLI.") }),
              /* @__PURE__ */ jsxs21(
                "button",
                {
                  type: "button",
                  className: "agentos-btn primary",
                  onClick: () => setDidPool([emptyDid()]),
                  children: [
                    "+ ",
                    t("Add number")
                  ]
                }
              )
            ] }) : /* @__PURE__ */ jsx21("div", { className: "plat-table-wrap", children: /* @__PURE__ */ jsxs21("table", { className: "plat-table", children: [
              /* @__PURE__ */ jsx21("thead", { children: /* @__PURE__ */ jsxs21("tr", { children: [
                /* @__PURE__ */ jsx21("th", { children: t("Number (E.164)") }),
                /* @__PURE__ */ jsx21("th", { children: t("Provider") }),
                /* @__PURE__ */ jsx21("th", { children: t("Label") }),
                /* @__PURE__ */ jsx21("th", { children: t("Scope") }),
                /* @__PURE__ */ jsx21("th", { children: t("Status") }),
                /* @__PURE__ */ jsx21("th", { "aria-label": t("Actions") })
              ] }) }),
              /* @__PURE__ */ jsx21("tbody", { children: didPool.map((row, index) => /* @__PURE__ */ jsxs21("tr", { children: [
                /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsx21(
                  "input",
                  {
                    className: "plat-input mono",
                    value: row.e164,
                    placeholder: "+90850\u2026",
                    "aria-label": t("Number (E.164)"),
                    onChange: (e) => updateDid(index, { e164: e.target.value })
                  }
                ) }),
                /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsx21(
                  "select",
                  {
                    className: "plat-input",
                    value: row.provider,
                    "aria-label": t("Provider"),
                    onChange: (e) => updateDid(index, { provider: e.target.value }),
                    children: PROVIDERS.map((provider) => /* @__PURE__ */ jsx21("option", { value: provider.value, children: provider.label }, provider.value))
                  }
                ) }),
                /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsx21(
                  "input",
                  {
                    className: "plat-input",
                    value: row.label ?? "",
                    placeholder: t("Label"),
                    "aria-label": t("Label"),
                    onChange: (e) => updateDid(index, { label: e.target.value })
                  }
                ) }),
                /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsxs21(
                  "select",
                  {
                    className: "plat-input",
                    value: row.geoScope ?? "tr",
                    "aria-label": t("Scope"),
                    onChange: (e) => updateDid(index, { geoScope: e.target.value }),
                    children: [
                      /* @__PURE__ */ jsx21("option", { value: "tr", children: "TR" }),
                      /* @__PURE__ */ jsx21("option", { value: "intl", children: "Intl" })
                    ]
                  }
                ) }),
                /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsxs21("label", { className: "plat-switch", children: [
                  /* @__PURE__ */ jsx21(
                    "input",
                    {
                      type: "checkbox",
                      checked: row.enabled !== false,
                      onChange: (e) => updateDid(index, { enabled: e.target.checked })
                    }
                  ),
                  /* @__PURE__ */ jsx21("span", { children: row.enabled !== false ? t("On") : t("Off") })
                ] }) }),
                /* @__PURE__ */ jsx21("td", { className: "plat-row-actions", children: /* @__PURE__ */ jsx21(
                  "button",
                  {
                    type: "button",
                    className: "plat-link-danger",
                    onClick: () => setDidPool((prev) => prev.filter((_, i) => i !== index)),
                    children: t("Remove")
                  }
                ) })
              ] }, `did-${index}`)) })
            ] }) }),
            /* @__PURE__ */ jsxs21("footer", { className: "plat-sticky-bar", children: [
              /* @__PURE__ */ jsxs21("span", { children: [
                didPool.length,
                " ",
                t("rows"),
                " \xB7 ",
                stats.dids,
                " ",
                t("active")
              ] }),
              /* @__PURE__ */ jsx21("button", { type: "submit", className: "agentos-btn primary", disabled: busy, children: busy ? t("Saving\u2026") : t("Save DID pool") })
            ] })
          ] }),
          tab === "packages" && /* @__PURE__ */ jsxs21("form", { className: "plat-panel", onSubmit: (e) => void savePacks(e), children: [
            /* @__PURE__ */ jsxs21("div", { className: "plat-panel-head", children: [
              /* @__PURE__ */ jsxs21("div", { children: [
                /* @__PURE__ */ jsx21("h3", { children: t("CenterOS packages") }),
                /* @__PURE__ */ jsx21("p", { children: t(
                  "Product design: services, AI stack, package retail overrides, wholesale cost readout, and live cost/sale/margin simulation. Global tariffs stay on the Tariffs tab."
                ) })
              ] }),
              /* @__PURE__ */ jsxs21("div", { className: "plat-panel-actions", children: [
                /* @__PURE__ */ jsxs21(
                  "button",
                  {
                    type: "button",
                    className: "agentos-btn ghost",
                    onClick: () => setPackages((prev) => [...prev, emptyPackage(prev.length + 1)]),
                    children: [
                      "+ ",
                      t("Add package")
                    ]
                  }
                ),
                /* @__PURE__ */ jsx21("button", { type: "submit", className: "agentos-btn primary", disabled: busy, children: busy ? t("Saving\u2026") : t("Save packages") })
              ] })
            ] }),
            packages.length === 0 ? /* @__PURE__ */ jsxs21("div", { className: "plat-empty", children: [
              /* @__PURE__ */ jsx21("strong", { children: t("No packages yet") }),
              /* @__PURE__ */ jsx21("p", { children: t("Create starter / growth / pro style packs, then attach them to plans.") }),
              /* @__PURE__ */ jsxs21(
                "button",
                {
                  type: "button",
                  className: "agentos-btn primary",
                  onClick: () => setPackages([emptyPackage(1)]),
                  children: [
                    "+ ",
                    t("Add package")
                  ]
                }
              )
            ] }) : /* @__PURE__ */ jsx21("div", { className: "plat-pack-grid plat-pack-grid-wide plat-pack-design-grid", children: packages.map((pack, index) => /* @__PURE__ */ jsx21(
              PackageDesignCard,
              {
                pack,
                index,
                plans,
                costRatesJson: rateCards.costRatesJson,
                retailRatesJson: rateCards.retailRatesJson,
                didPool,
                t,
                onUpdatePack: updatePack,
                onUpdatePerm: updatePackPerm,
                onRemove: (i) => setPackages((prev) => prev.filter((_, j) => j !== i)),
                onGoToDidTab: () => setTab("did"),
                onGoToRatesTab: () => setTab("rates")
              },
              pack.id || index
            )) }),
            /* @__PURE__ */ jsxs21("footer", { className: "plat-sticky-bar", children: [
              /* @__PURE__ */ jsxs21("span", { children: [
                packages.length,
                " ",
                t("packages")
              ] }),
              /* @__PURE__ */ jsx21("button", { type: "submit", className: "agentos-btn primary", disabled: busy, children: busy ? t("Saving\u2026") : t("Save packages") })
            ] })
          ] }),
          tab === "rates" && /* @__PURE__ */ jsxs21(Fragment11, { children: [
            /* @__PURE__ */ jsx21(
              PackageEconomicsPanel,
              {
                packages,
                plans,
                didPool,
                costRatesJson: rateCards.costRatesJson,
                retailRatesJson: rateCards.retailRatesJson,
                t
              }
            ),
            /* @__PURE__ */ jsxs21("form", { className: "plat-panel", onSubmit: (e) => void saveRates(e), children: [
              /* @__PURE__ */ jsxs21("div", { className: "plat-panel-head", children: [
                /* @__PURE__ */ jsxs21("div", { children: [
                  /* @__PURE__ */ jsx21("h3", { children: t("Tariffs") }),
                  /* @__PURE__ */ jsx21("p", { children: t(
                    "Provider-aware wholesale (real cost) and customer sale tariffs. Units match vendor pricing (hour / minute / 1K chars / 1M tokens). Ledger stays quantity-only; money is a read-time estimate."
                  ) })
                ] }),
                /* @__PURE__ */ jsxs21("div", { className: "plat-panel-actions", children: [
                  /* @__PURE__ */ jsx21(
                    "button",
                    {
                      type: "button",
                      className: "agentos-btn",
                      disabled: busy || bridgeDown,
                      onClick: () => resetVendorListCosts(),
                      children: t("Reset to vendor list prices")
                    }
                  ),
                  /* @__PURE__ */ jsx21(
                    "button",
                    {
                      type: "submit",
                      className: "agentos-btn primary",
                      disabled: busy || bridgeDown,
                      title: bridgeDown ? t(BRIDGE_DOWN_WARNING) : void 0,
                      children: busy ? t("Saving\u2026") : t("Save")
                    }
                  )
                ] })
              ] }),
              bridgeDown && /* @__PURE__ */ jsxs21("div", { className: "plat-alert plat-alert-warn", role: "alert", children: [
                /* @__PURE__ */ jsx21("strong", { children: t("Bridge unavailable") }),
                /* @__PURE__ */ jsx21("span", { children: t(BRIDGE_DOWN_WARNING) })
              ] }),
              !bridgeDown && ratesLoadedFromHost && /* @__PURE__ */ jsxs21("div", { className: "plat-alert plat-alert-ok", role: "status", children: [
                /* @__PURE__ */ jsx21("strong", { children: t("Loaded from Panaryus") }),
                /* @__PURE__ */ jsx21("span", { children: t("Values below come from saved host options (or host defaults when empty).") })
              ] }),
              !bridgeDown && !ratesLoadedFromHost && !loading && /* @__PURE__ */ jsxs21("div", { className: "plat-alert plat-alert-warn", role: "status", children: [
                /* @__PURE__ */ jsx21("strong", { children: t("Defaults") }),
                /* @__PURE__ */ jsx21("span", { children: t(
                  "Showing built-in defaults. Save once the admin bridge is healthy to persist tariffs in Panaryus."
                ) })
              ] }),
              /* @__PURE__ */ jsx21("div", { className: "plat-table-wrap plat-rate-table-wrap", children: /* @__PURE__ */ jsxs21("table", { className: "plat-table plat-rate-table", children: [
                /* @__PURE__ */ jsx21("thead", { children: /* @__PURE__ */ jsxs21("tr", { children: [
                  /* @__PURE__ */ jsx21("th", { children: t("Service") }),
                  /* @__PURE__ */ jsx21("th", { children: t("Provider") }),
                  /* @__PURE__ */ jsx21("th", { children: t("Model") }),
                  /* @__PURE__ */ jsx21("th", { children: t("Unit") }),
                  /* @__PURE__ */ jsx21("th", { children: t("Real cost") }),
                  /* @__PURE__ */ jsx21("th", { children: t("Customer sale price") }),
                  /* @__PURE__ */ jsx21("th", { children: t("Gross profit") }),
                  /* @__PURE__ */ jsx21("th", { children: t("Margin") }),
                  /* @__PURE__ */ jsx21("th", { children: t("Source") })
                ] }) }),
                /* @__PURE__ */ jsx21("tbody", { children: tariffRows.map((row) => {
                  const econ = rowEconomics(row, usdTry);
                  const serviceLabel2 = row.meter === "telephony_minutes" ? t("Phone minute") : row.meter === "stt_seconds" ? t("STT") : row.meter === "tts_characters" ? t("TTS") : row.meter === "llm_input_tokens" ? t("LLM input") : row.meter === "llm_output_tokens" ? t("LLM output") : row.meter === "messages" ? t("Message / SMS") : row.meter;
                  const costPlaceholder = row.costOperatorRequired ? t("Operator entry required") : "";
                  const sourceLabel = row.source === "vendor_list" ? t("Vendor list") : row.source === "needs_verification" ? t("Needs verification") : t("Operator entry required");
                  const drifts = rowDiffersFromVendorList(row);
                  return /* @__PURE__ */ jsxs21("tr", { children: [
                    /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsxs21("div", { className: "plat-rate-service", children: [
                      /* @__PURE__ */ jsx21("strong", { children: serviceLabel2 }),
                      /* @__PURE__ */ jsx21("small", { className: "mono", children: row.meter })
                    ] }) }),
                    /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsx21("span", { className: "plat-rate-unit", children: row.provider }) }),
                    /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsxs21("div", { className: "plat-rate-service", children: [
                      /* @__PURE__ */ jsx21("span", { className: "mono plat-rate-model", children: row.model }),
                      row.billedModel && row.billedModel !== row.model.toLowerCase() ? /* @__PURE__ */ jsxs21("small", { className: "mono", children: [
                        t("Billed"),
                        ": ",
                        row.billedModel
                      ] }) : null
                    ] }) }),
                    /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsx21("span", { className: "plat-rate-unit", children: t(tariffUnitLabel(row.displayUnit)) }) }),
                    /* @__PURE__ */ jsxs21("td", { children: [
                      /* @__PURE__ */ jsxs21("div", { className: "plat-rate-price", children: [
                        /* @__PURE__ */ jsxs21(
                          "select",
                          {
                            className: "plat-input plat-rate-ccy",
                            value: row.costCurrency,
                            disabled: busy || bridgeDown,
                            "aria-label": `${serviceLabel2} ${t("Real cost")} ${t("Currency")}`,
                            onChange: (e) => updateTariffRow(row.rowId, {
                              costCurrency: e.target.value
                            }),
                            children: [
                              /* @__PURE__ */ jsx21("option", { value: "TRY", children: "TRY" }),
                              /* @__PURE__ */ jsx21("option", { value: "USD", children: "USD" })
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsx21(
                          "input",
                          {
                            className: "plat-input plat-rate-amount mono",
                            type: "number",
                            inputMode: "decimal",
                            min: 0,
                            step: "any",
                            placeholder: costPlaceholder,
                            value: row.costMajor,
                            disabled: busy || bridgeDown,
                            "aria-label": `${serviceLabel2} ${row.provider} ${t("Real cost")}`,
                            onChange: (e) => updateTariffRow(row.rowId, {
                              costMajor: e.target.value,
                              costOperatorRequired: false
                            })
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsx21("small", { className: "plat-rate-fmt mono", title: econ.costRateLabel, children: econ.costRateLabel }),
                      row.costOperatorRequired && row.costMajor.trim() === "" ? /* @__PURE__ */ jsx21("small", { className: "plat-rate-hint", children: t("Operator entry required") }) : null,
                      drifts ? /* @__PURE__ */ jsx21("small", { className: "plat-rate-hint", children: t("Saved value differs from vendor list suggestion") }) : null
                    ] }),
                    /* @__PURE__ */ jsxs21("td", { children: [
                      /* @__PURE__ */ jsxs21("div", { className: "plat-rate-price", children: [
                        /* @__PURE__ */ jsxs21(
                          "select",
                          {
                            className: "plat-input plat-rate-ccy",
                            value: row.retailCurrency,
                            disabled: busy || bridgeDown,
                            "aria-label": `${serviceLabel2} ${row.provider} ${t("Customer sale price")} ${t("Currency")}`,
                            onChange: (e) => updateTariffRow(row.rowId, {
                              retailCurrency: e.target.value
                            }),
                            children: [
                              /* @__PURE__ */ jsx21("option", { value: "TRY", children: "TRY" }),
                              /* @__PURE__ */ jsx21("option", { value: "USD", children: "USD" })
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsx21(
                          "input",
                          {
                            className: "plat-input plat-rate-amount mono",
                            type: "number",
                            inputMode: "decimal",
                            min: 0,
                            step: "any",
                            value: row.retailMajor,
                            disabled: busy || bridgeDown,
                            "aria-label": `${serviceLabel2} ${row.provider} ${t("Customer sale price")}`,
                            onChange: (e) => updateTariffRow(row.rowId, { retailMajor: e.target.value })
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsx21("small", { className: "plat-rate-fmt mono", title: econ.retailRateLabel, children: econ.retailRateLabel })
                    ] }),
                    /* @__PURE__ */ jsx21("td", { className: "plat-rate-econ", children: /* @__PURE__ */ jsx21("strong", { children: econ.profitLabel }) }),
                    /* @__PURE__ */ jsx21("td", { className: "plat-rate-econ", children: /* @__PURE__ */ jsx21(
                      "span",
                      {
                        className: econ.marginPct >= 40 ? "plat-badge teal" : econ.marginPct > 0 ? "plat-badge ok" : "plat-badge muted",
                        children: econ.marginLabel
                      }
                    ) }),
                    /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsxs21("div", { className: "plat-rate-source", children: [
                      /* @__PURE__ */ jsx21(
                        "span",
                        {
                          className: row.source === "vendor_list" ? "plat-badge teal" : row.source === "needs_verification" ? "plat-badge" : "plat-badge muted",
                          title: row.notes || row.sourceUrl || row.source,
                          children: sourceLabel
                        }
                      ),
                      row.sourceUrl ? /* @__PURE__ */ jsx21(
                        "a",
                        {
                          className: "plat-inline-link",
                          href: row.sourceUrl,
                          target: "_blank",
                          rel: "noreferrer",
                          children: t("Source")
                        }
                      ) : null,
                      /* @__PURE__ */ jsxs21("small", { children: [
                        t("Checked"),
                        ": ",
                        row.checkedAt ?? "\u2014"
                      ] }),
                      /* @__PURE__ */ jsxs21("small", { children: [
                        t("Effective"),
                        ": ",
                        row.effectiveAt ?? "\u2014"
                      ] })
                    ] }) })
                  ] }, row.rowId);
                }) })
              ] }) }),
              /* @__PURE__ */ jsxs21("p", { className: "plat-rate-footnote", children: [
                t("FX for mixed-currency rows"),
                ": 1 USD = ",
                usdTry,
                " TRY \xB7",
                " ",
                t("Amounts use provider-native units (not integer cents per second)."),
                " \xB7",
                " ",
                t(
                  "Telephony rates save under providerMeters (zadarma/verimor). Billing dashboard still aggregates quantity without provider breakdown \u2014 uses legacy meters.telephony_minutes when present."
                ),
                " ",
                "\xB7 ",
                t("Last updated"),
                ": ",
                (/* @__PURE__ */ new Date()).toISOString().slice(0, 10)
              ] }),
              /* @__PURE__ */ jsxs21(
                "details",
                {
                  className: "plat-advanced-json",
                  open: advancedJsonOpen,
                  onToggle: (e) => setAdvancedJsonOpen(e.target.open),
                  children: [
                    /* @__PURE__ */ jsxs21("summary", { children: [
                      /* @__PURE__ */ jsx21("strong", { children: t("Advanced JSON") }),
                      /* @__PURE__ */ jsx21("span", { children: t("Ops / debug only \u2014 generated from the table above") })
                    ] }),
                    /* @__PURE__ */ jsxs21("div", { className: "plat-rate-grid", children: [
                      /* @__PURE__ */ jsxs21("label", { className: "plat-field", children: [
                        /* @__PURE__ */ jsx21("span", { children: t("Wholesale provider cost JSON") }),
                        /* @__PURE__ */ jsx21(
                          "textarea",
                          {
                            className: "plat-input plat-json",
                            value: rateCards.costRatesJson,
                            spellCheck: false,
                            disabled: bridgeDown,
                            onChange: (e) => setRateCards((prev) => ({ ...prev, costRatesJson: e.target.value }))
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsxs21("label", { className: "plat-field", children: [
                        /* @__PURE__ */ jsx21("span", { children: t("Retail customer tariff JSON") }),
                        /* @__PURE__ */ jsx21(
                          "textarea",
                          {
                            className: "plat-input plat-json",
                            value: rateCards.retailRatesJson,
                            spellCheck: false,
                            disabled: bridgeDown,
                            onChange: (e) => setRateCards((prev) => ({ ...prev, retailRatesJson: e.target.value }))
                          }
                        )
                      ] })
                    ] }),
                    /* @__PURE__ */ jsxs21("div", { className: "plat-advanced-actions", children: [
                      /* @__PURE__ */ jsx21(
                        "button",
                        {
                          type: "button",
                          className: "agentos-btn",
                          disabled: bridgeDown || busy,
                          onClick: () => applyAdvancedJson(),
                          children: t("Apply JSON to table")
                        }
                      ),
                      /* @__PURE__ */ jsx21("span", { className: "plat-sub-help", children: t(
                        "Use tryMinorPerUnit / usdMinorPerUnit for per-unit meters and tryMinorPer1k / usdMinorPer1k for token or character meters."
                      ) })
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ jsxs21("footer", { className: "plat-sticky-bar", children: [
                /* @__PURE__ */ jsx21("span", { children: bridgeDown ? t("Save disabled until Panaryus admin bridge is healthy.") : t(
                  "Saved values sync into CENTEROS_COST_RATES_JSON and CENTEROS_RETAIL_RATES_JSON."
                ) }),
                /* @__PURE__ */ jsx21(
                  "button",
                  {
                    type: "submit",
                    className: "agentos-btn primary",
                    disabled: busy || bridgeDown,
                    children: busy ? t("Saving\u2026") : t("Save")
                  }
                )
              ] })
            ] })
          ] }),
          tab === "plans" && /* @__PURE__ */ jsxs21("div", { className: "plat-panel", children: [
            /* @__PURE__ */ jsx21("div", { className: "plat-panel-head", children: /* @__PURE__ */ jsxs21("div", { children: [
              /* @__PURE__ */ jsx21("h3", { children: t("Attach CenterOS package \u2192 Panaryus plan") }),
              /* @__PURE__ */ jsx21("p", { children: t(
                "Choosing a pack merges minutes, voice tier and CenterOS flags into that Panaryus plan."
              ) })
            ] }) }),
            plans.length === 0 ? /* @__PURE__ */ jsxs21("div", { className: "plat-empty", children: [
              /* @__PURE__ */ jsx21("strong", { children: t("No Panaryus plans found") }),
              /* @__PURE__ */ jsx21("p", { children: t("Create or enable plans in Panaryus Admin, then refresh this page.") })
            ] }) : /* @__PURE__ */ jsx21("div", { className: "plat-table-wrap", children: /* @__PURE__ */ jsxs21("table", { className: "plat-table plat-table-plans", children: [
              /* @__PURE__ */ jsx21("thead", { children: /* @__PURE__ */ jsxs21("tr", { children: [
                /* @__PURE__ */ jsx21("th", { children: t("Panaryus plan") }),
                /* @__PURE__ */ jsx21("th", { children: t("Status") }),
                /* @__PURE__ */ jsx21("th", { children: t("Current pack") }),
                /* @__PURE__ */ jsx21("th", { children: t("Minutes") }),
                /* @__PURE__ */ jsx21("th", { children: t("Link package") })
              ] }) }),
              /* @__PURE__ */ jsx21("tbody", { children: plans.map((plan) => {
                const minutes = plan.centeros?.centeros_voice_minutes_limit;
                const linked = Boolean(plan.packageId && plan.packageId !== "none");
                return /* @__PURE__ */ jsxs21("tr", { children: [
                  /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsxs21("div", { className: "plat-plan-name", children: [
                    /* @__PURE__ */ jsx21("strong", { children: plan.name }),
                    /* @__PURE__ */ jsxs21("small", { children: [
                      "#",
                      plan.id
                    ] })
                  ] }) }),
                  /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsx21(
                    "span",
                    {
                      className: String(plan.status || "").toLowerCase() === "active" ? "plat-badge ok" : "plat-badge",
                      children: plan.status || "\u2014"
                    }
                  ) }),
                  /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsx21("span", { className: linked ? "plat-badge teal" : "plat-badge muted", children: plan.packageId || t("None") }) }),
                  /* @__PURE__ */ jsx21("td", { className: "mono", children: minutes != null ? String(minutes) : "\u2014" }),
                  /* @__PURE__ */ jsx21("td", { children: /* @__PURE__ */ jsxs21(
                    "select",
                    {
                      className: "plat-input",
                      value: plan.packageId || "none",
                      disabled: busy,
                      "aria-label": `${t("Link package")}: ${plan.name}`,
                      onChange: (e) => void onLinkPlan(plan.id, e.target.value),
                      children: [
                        /* @__PURE__ */ jsx21("option", { value: "none", children: t("No CenterOS pack") }),
                        packages.map((pack) => /* @__PURE__ */ jsxs21("option", { value: pack.id, children: [
                          pack.name,
                          " (",
                          pack.id,
                          ")"
                        ] }, pack.id))
                      ]
                    }
                  ) })
                ] }, plan.id);
              }) })
            ] }) }),
            packages.length === 0 && plans.length > 0 && /* @__PURE__ */ jsxs21("div", { className: "plat-alert plat-alert-warn", role: "status", children: [
              /* @__PURE__ */ jsx21("strong", { children: t("Tip") }),
              /* @__PURE__ */ jsxs21("span", { children: [
                t("Create at least one CenterOS package before linking plans."),
                " ",
                /* @__PURE__ */ jsx21("button", { type: "button", className: "plat-inline-link", onClick: () => setTab("packages"), children: t("Go to packages") })
              ] })
            ] })
          ] })
        ] })
      ]
    }
  );
};
var platformAdminStyles = `
.plat-page {
  display: grid;
  gap: 16px;
  padding: 4px 4px 28px;
  max-width: 1180px;
}
.plat-hero {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  justify-content: space-between;
  align-items: stretch;
  padding: 18px 20px;
  border-radius: 18px;
  border: 1px solid color-mix(in srgb, #0d9488 35%, #e7e5e4);
  background:
    linear-gradient(135deg, rgba(13,148,136,.12), rgba(245,158,11,.10) 48%, rgba(15,23,42,.02)),
    #fff;
  box-shadow: 0 10px 30px rgba(15,23,42,.05);
}
.plat-hero-copy { min-width: min(100%, 320px); flex: 1 1 280px; }
.plat-kicker {
  display: inline-block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .12em;
  color: #0f766e;
  margin-bottom: 6px;
}
.plat-hero h2 {
  margin: 0;
  font-size: 24px;
  letter-spacing: -.02em;
  color: #0f172a;
  font-weight: 800;
}
.plat-hero p {
  margin: 8px 0 0;
  color: #475569;
  line-height: 1.55;
  max-width: 52ch;
  font-size: 14px;
}
.plat-stat-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(88px, 1fr));
  gap: 10px;
  align-self: center;
}
.plat-stat {
  min-width: 96px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(255,255,255,.86);
  border: 1px solid #e7e5e4;
  display: grid;
  gap: 2px;
}
.plat-stat strong {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -.02em;
  display: flex;
  align-items: baseline;
  gap: 2px;
}
.plat-stat strong small { font-size: 13px; color: #78716c; font-weight: 700; }
.plat-stat span {
  font-size: 11px;
  font-weight: 700;
  color: #78716c;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.plat-alert {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  align-items: baseline;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid transparent;
  font-size: 13px;
  line-height: 1.45;
}
.plat-alert strong { font-weight: 800; }
.plat-alert-error { background: #fef2f2; border-color: #fecaca; color: #7f1d1d; }
.plat-alert-ok { background: #ecfdf5; border-color: #99f6e4; color: #115e59; }
.plat-alert-warn { background: #fffbeb; border-color: #fde68a; color: #92400e; }

.plat-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}
.plat-tabs button {
  border: 1px solid #e7e5e4;
  background: #fff;
  border-radius: 14px;
  padding: 12px 14px;
  text-align: left;
  cursor: pointer;
  display: grid;
  gap: 6px;
  transition: .15s ease;
  color: #334155;
}
.plat-tabs button:hover { border-color: #99f6e4; background: #f0fdfa; }
.plat-tabs button.active {
  border-color: #0d9488;
  background: linear-gradient(180deg, #f0fdfa, #fff);
  box-shadow: inset 0 0 0 1px rgba(13,148,136,.15), 0 8px 20px rgba(13,148,136,.08);
}
.plat-tab-label { font-weight: 800; font-size: 13px; color: #0f172a; }
.plat-tab-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  align-items: center;
}
.plat-tab-meta em {
  font-style: normal;
  font-weight: 800;
  font-size: 12px;
  color: #0f766e;
  background: #ccfbf1;
  border-radius: 999px;
  padding: 2px 8px;
}
.plat-tab-meta small { color: #78716c; font-size: 11px; font-weight: 600; }

.plat-panel {
  border: 1px solid #e7e5e4;
  border-radius: 18px;
  background: #fff;
  padding: 16px 16px 12px;
  box-shadow: 0 8px 24px rgba(15,23,42,.04);
  display: grid;
  gap: 14px;
}
.plat-panel-head {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 4px;
  border-bottom: 1px solid #f5f5f4;
}
.plat-panel-head h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -.01em;
}
.plat-panel-head p {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
  max-width: 62ch;
}
.plat-panel-actions { display: flex; flex-wrap: wrap; gap: 8px; }

.plat-empty {
  border: 1px dashed #cbd5e1;
  border-radius: 14px;
  padding: 28px 20px;
  text-align: center;
  background: #f8fafc;
  display: grid;
  gap: 8px;
  justify-items: center;
}
.plat-empty strong { color: #0f172a; font-size: 15px; }
.plat-empty p { margin: 0; color: #64748b; font-size: 13px; max-width: 42ch; line-height: 1.5; }

.plat-table-wrap { overflow: auto; border-radius: 12px; border: 1px solid #e7e5e4; }
.plat-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 720px;
  background: #fff;
}
.plat-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: #78716c;
  background: #fafaf9;
  padding: 10px 12px;
  border-bottom: 1px solid #e7e5e4;
  white-space: nowrap;
}
.plat-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #f5f5f4;
  vertical-align: middle;
}
.plat-table tr:last-child td { border-bottom: 0; }
.plat-table tr:hover td { background: #fafaf9; }
.plat-table-plans { min-width: 780px; }

.plat-input {
  width: 100%;
  min-width: 0;
  border: 1px solid #d6d3d1;
  border-radius: 10px;
  padding: 9px 11px;
  font-size: 13px;
  background: #fff;
  color: #0f172a;
  min-height: 38px;
}
.plat-input:focus {
  outline: 2px solid color-mix(in srgb, #0d9488 45%, transparent);
  border-color: #0d9488;
}
.plat-input.mono, .mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 12px; }

.plat-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  cursor: pointer;
  user-select: none;
}
.plat-switch input { width: 16px; height: 16px; accent-color: #0d9488; }
.plat-row-actions { text-align: right; white-space: nowrap; }
.plat-link-danger {
  border: 0;
  background: transparent;
  color: #b91c1c;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 8px;
}
.plat-link-danger:hover { background: #fef2f2; }
.plat-inline-link {
  border: 0;
  background: transparent;
  color: #0f766e;
  font-weight: 800;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-size: inherit;
}

.plat-pack-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}
.plat-pack-grid-wide {
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
}
.plat-pack-design-grid {
  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
}
.plat-pack-card {
  border: 1px solid #e7e5e4;
  border-radius: 16px;
  padding: 14px;
  background: linear-gradient(180deg, #fafaf9, #fff);
  display: grid;
  gap: 10px;
  box-shadow: 0 4px 14px rgba(15,23,42,.03);
}
.plat-pack-card-rich { gap: 12px; }
.plat-pack-design {
  gap: 14px;
  align-content: start;
}
.plat-cost-readout {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.plat-cost-readout span {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: #f5f5f4;
  border: 1px solid #e7e5e4;
  font-size: 11px;
  font-weight: 700;
  color: #44403c;
  white-space: nowrap;
}
.plat-sim-panel {
  background: linear-gradient(180deg, #f0fdfa, #fff);
  border: 1px solid #99f6e4;
  border-radius: 14px;
  padding: 12px;
  border-top: 1px solid #99f6e4;
}
.plat-sim-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.plat-sim-grid > div {
  display: grid;
  gap: 2px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e7e5e4;
  min-width: 0;
}
.plat-sim-grid small {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: #78716c;
}
.plat-sim-grid b {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
  word-break: break-word;
}
.plat-sim-grid > div.plat-sim-emphasis {
  background: #f0fdfa;
  border: 2px solid #0d9488;
  box-shadow: 0 0 0 1px rgba(13, 148, 136, 0.12), 0 6px 16px rgba(13, 148, 136, 0.08);
  padding: 10px 12px;
  gap: 4px;
}
.plat-sim-grid > div.plat-sim-emphasis small {
  color: #0f766e;
  font-size: 11px;
  letter-spacing: .05em;
}
.plat-sim-grid > div.plat-sim-emphasis b {
  font-size: 18px;
  font-weight: 900;
  letter-spacing: -.02em;
  color: #0f172a;
  line-height: 1.2;
}
.plat-sim-hint {
  font-size: 11px;
  font-weight: 700;
  color: #0f766e;
}
.plat-chip:disabled {
  opacity: .45;
  cursor: not-allowed;
}
.plat-tel-tariff {
  background: linear-gradient(180deg, #fff7ed, #fff);
  border: 1px solid #fed7aa;
  border-radius: 14px;
  padding: 12px;
  border-top: 1px solid #fed7aa;
}
.plat-tel-tariff-row {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.plat-input-with-suffix {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px;
  align-items: center;
}
.plat-input-with-suffix em {
  font-style: normal;
  font-size: 11px;
  font-weight: 800;
  color: #78716c;
  white-space: nowrap;
}
.plat-input-with-suffix .plat-input[readonly] {
  background: #f5f5f4;
  color: #44403c;
  cursor: default;
}
.plat-sub {
  border-top: 1px solid #f5f5f4;
  padding-top: 10px;
  display: grid;
  gap: 8px;
}
.plat-sub h4 {
  margin: 0;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: #0f766e;
}
.plat-sub-help {
  margin: 0;
  font-size: 12px;
  color: #78716c;
  line-height: 1.45;
}
.plat-seg {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.plat-seg button {
  border: 1px solid #d6d3d1;
  background: #fff;
  border-radius: 999px;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #44403c;
  cursor: pointer;
}
.plat-seg button.active {
  background: #0f766e;
  border-color: #0f766e;
  color: #ecfdf5;
}
.plat-did-pick {
  display: grid;
  gap: 6px;
  max-height: 180px;
  overflow: auto;
  padding: 4px;
  border: 1px solid #e7e5e4;
  border-radius: 12px;
  background: #fafaf9;
}
.plat-check {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  cursor: pointer;
  user-select: none;
}
.plat-check input { accent-color: #0d9488; width: 15px; height: 15px; }
.plat-check small { color: #78716c; font-weight: 600; }
.plat-check.on {
  background: #ecfdf5;
  border-color: #99f6e4;
}
.plat-toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.plat-toggles .plat-check {
  border: 1px solid #e7e5e4;
  background: #fff;
}
.plat-sub-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.plat-sub-title-row h4 { margin: 0; }
.plat-mini-actions { display: flex; gap: 6px; }
.plat-mini-btn {
  border: 1px solid #d6d3d1;
  background: #fff;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  color: #44403c;
  cursor: pointer;
}
.plat-mini-btn:hover { border-color: #0d9488; color: #0f766e; }
.plat-sub-meta {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: #0f766e;
}
.plat-empty.compact {
  padding: 14px;
  gap: 6px;
}
.plat-bucket {
  display: grid;
  gap: 6px;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid #e7e5e4;
  background: #fafaf9;
}
.plat-bucket-label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .05em;
  text-transform: uppercase;
  color: #78716c;
}
.plat-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.plat-chip {
  border: 1px solid #d6d3d1;
  background: #fff;
  border-radius: 999px;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #44403c;
  cursor: pointer;
  transition: .12s ease;
}
.plat-chip:hover { border-color: #0d9488; }
.plat-chip.on {
  background: #0f766e;
  border-color: #0f766e;
  color: #ecfdf5;
  box-shadow: 0 0 0 1px rgba(13,148,136,.2);
}
.plat-pack-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.plat-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .04em;
  background: #e7e5e4;
  color: #44403c;
}
.plat-pill-starter { background: #e0f2fe; color: #075985; }
.plat-pill-growth { background: #ccfbf1; color: #0f766e; }
.plat-pill-pro { background: #fef3c7; color: #92400e; }
.plat-field { display: grid; gap: 5px; }
.plat-field > span {
  font-size: 11px;
  font-weight: 800;
  color: #78716c;
  text-transform: uppercase;
  letter-spacing: .04em;
}
.plat-field-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.plat-rate-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
}
.plat-rate-table-wrap { min-width: 0; }
.plat-rate-table { min-width: 1100px; }
.plat-rate-service { display: grid; gap: 2px; }
.plat-rate-service strong { color: #0f172a; font-size: 13px; }
.plat-rate-service small { color: #a8a29e; font-size: 11px; }
.plat-rate-model { font-size: 11px; color: #57534e; word-break: break-all; }
.plat-rate-hint { display: block; margin-top: 4px; color: #b45309; font-size: 11px; font-weight: 700; }
.plat-rate-fmt { display: block; margin-top: 4px; color: #0f766e; font-size: 11px; font-weight: 700; }
.plat-rate-source { display: grid; gap: 4px; align-content: start; max-width: 160px; }
.plat-rate-source small { color: #78716c; font-size: 10px; font-weight: 600; }
.plat-rate-unit {
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 999px;
  background: #f5f5f4;
  color: #57534e;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}
.plat-rate-price {
  display: grid;
  grid-template-columns: 72px minmax(88px, 1fr);
  gap: 6px;
  align-items: center;
  min-width: 170px;
}
.plat-rate-ccy { min-height: 36px; padding: 6px 8px; font-weight: 700; }
.plat-rate-amount { min-height: 36px; padding: 6px 8px; }
.plat-rate-econ strong { font-size: 13px; color: #0f172a; white-space: nowrap; }
.plat-rate-footnote {
  margin: 0;
  font-size: 12px;
  color: #78716c;
  font-weight: 600;
}
.plat-advanced-json {
  border: 1px solid #e7e5e4;
  border-radius: 14px;
  background: #fafaf9;
  padding: 0 12px 12px;
}
.plat-advanced-json > summary {
  cursor: pointer;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  align-items: baseline;
  padding: 12px 4px;
  user-select: none;
}
.plat-advanced-json > summary::-webkit-details-marker { display: none; }
.plat-advanced-json > summary::before {
  content: '\u25B8';
  color: #0f766e;
  font-weight: 800;
  margin-right: 4px;
}
.plat-advanced-json[open] > summary::before { content: '\u25BE'; }
.plat-advanced-json > summary strong {
  font-size: 13px;
  color: #0f172a;
}
.plat-advanced-json > summary span {
  font-size: 12px;
  color: #78716c;
  font-weight: 600;
}
.plat-advanced-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: center;
  margin-top: 10px;
}
.plat-json {
  min-height: 220px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 12px;
  line-height: 1.45;
  resize: vertical;
  white-space: pre;
}
.plat-pack-foot {
  border-top: 1px solid #f5f5f4;
  padding-top: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #0f766e;
}

.plat-plan-name { display: grid; gap: 2px; }
.plat-plan-name strong { color: #0f172a; font-size: 13px; }
.plat-plan-name small { color: #a8a29e; font-size: 11px; font-family: ui-monospace, monospace; }
.plat-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 11px;
  font-weight: 800;
  background: #f5f5f4;
  color: #57534e;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.plat-badge.ok { background: #dcfce7; color: #166534; }
.plat-badge.teal { background: #ccfbf1; color: #0f766e; }
.plat-badge.muted { background: #f5f5f4; color: #a8a29e; }

.plat-sticky-bar {
  position: sticky;
  bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid #e7e5e4;
  background: rgba(255,255,255,.92);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 24px rgba(15,23,42,.08);
  font-size: 12px;
  font-weight: 700;
  color: #57534e;
  z-index: 2;
}

.plat-loading {
  border: 1px solid #e7e5e4;
  border-radius: 16px;
  background: #fff;
  padding: 28px;
  display: grid;
  gap: 12px;
  justify-items: center;
  color: #64748b;
  font-size: 13px;
}
.plat-skeleton {
  width: min(100%, 420px);
  height: 10px;
  border-radius: 99px;
  background: linear-gradient(90deg, #e7e5e4, #f5f5f4, #e7e5e4);
  background-size: 200% 100%;
  animation: plat-shimmer 1.2s ease-in-out infinite;
}
@keyframes plat-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.agentos-shell[data-theme="dark"] .plat-hero,
.agentos-shell:not([data-theme="light"]) .plat-hero {
  background:
    linear-gradient(135deg, rgba(13,148,136,.18), rgba(245,158,11,.10) 50%, rgba(15,23,42,.2)),
    #111827;
  border-color: #1f2937;
  box-shadow: none;
}
.agentos-shell[data-theme="dark"] .plat-hero h2,
.agentos-shell:not([data-theme="light"]) .plat-hero h2 { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-hero p,
.agentos-shell:not([data-theme="light"]) .plat-hero p { color: #94a3b8; }
.agentos-shell[data-theme="dark"] .plat-stat,
.agentos-shell:not([data-theme="light"]) .plat-stat {
  background: rgba(15,23,42,.7);
  border-color: #1f2937;
}
.agentos-shell[data-theme="dark"] .plat-stat strong,
.agentos-shell:not([data-theme="light"]) .plat-stat strong { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-tabs button,
.agentos-shell:not([data-theme="light"]) .plat-tabs button {
  background: #111827;
  border-color: #1f2937;
  color: #cbd5e1;
}
.agentos-shell[data-theme="dark"] .plat-tabs button.active,
.agentos-shell:not([data-theme="light"]) .plat-tabs button.active {
  background: linear-gradient(180deg, rgba(13,148,136,.18), #111827);
  border-color: #0d9488;
}
.agentos-shell[data-theme="dark"] .plat-tab-label,
.agentos-shell:not([data-theme="light"]) .plat-tab-label { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-panel,
.agentos-shell:not([data-theme="light"]) .plat-panel {
  background: #0f172a;
  border-color: #1f2937;
  box-shadow: none;
}
.agentos-shell[data-theme="dark"] .plat-panel-head,
.agentos-shell:not([data-theme="light"]) .plat-panel-head { border-bottom-color: #1f2937; }
.agentos-shell[data-theme="dark"] .plat-panel-head h3,
.agentos-shell:not([data-theme="light"]) .plat-panel-head h3 { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-panel-head p,
.agentos-shell:not([data-theme="light"]) .plat-panel-head p { color: #94a3b8; }
.agentos-shell[data-theme="dark"] .plat-table-wrap,
.agentos-shell:not([data-theme="light"]) .plat-table-wrap { border-color: #1f2937; }
.agentos-shell[data-theme="dark"] .plat-table,
.agentos-shell:not([data-theme="light"]) .plat-table { background: #0f172a; }
.agentos-shell[data-theme="dark"] .plat-table th,
.agentos-shell:not([data-theme="light"]) .plat-table th {
  background: #111827;
  color: #94a3b8;
  border-bottom-color: #1f2937;
}
.agentos-shell[data-theme="dark"] .plat-table td,
.agentos-shell:not([data-theme="light"]) .plat-table td { border-bottom-color: #1f2937; }
.agentos-shell[data-theme="dark"] .plat-table tr:hover td,
.agentos-shell:not([data-theme="light"]) .plat-table tr:hover td { background: #111827; }
.agentos-shell[data-theme="dark"] .plat-input,
.agentos-shell:not([data-theme="light"]) .plat-input {
  background: #111827;
  border-color: #334155;
  color: #e2e8f0;
}
.agentos-shell[data-theme="dark"] .plat-pack-card,
.agentos-shell:not([data-theme="light"]) .plat-pack-card {
  background: #111827;
  border-color: #1f2937;
}
.agentos-shell[data-theme="dark"] .plat-sub,
.agentos-shell:not([data-theme="light"]) .plat-sub { border-top-color: #1f2937; }
.agentos-shell[data-theme="dark"] .plat-sub-help,
.agentos-shell:not([data-theme="light"]) .plat-sub-help { color: #94a3b8; }
.agentos-shell[data-theme="dark"] .plat-seg button,
.agentos-shell:not([data-theme="light"]) .plat-seg button {
  background: #0f172a;
  border-color: #334155;
  color: #cbd5e1;
}
.agentos-shell[data-theme="dark"] .plat-seg button.active,
.agentos-shell:not([data-theme="light"]) .plat-seg button.active {
  background: #0d9488;
  border-color: #0d9488;
  color: #fff;
}
.agentos-shell[data-theme="dark"] .plat-did-pick,
.agentos-shell:not([data-theme="light"]) .plat-did-pick {
  background: #0f172a;
  border-color: #1f2937;
}
.agentos-shell[data-theme="dark"] .plat-check,
.agentos-shell:not([data-theme="light"]) .plat-check { color: #e2e8f0; }
.agentos-shell[data-theme="dark"] .plat-check.on,
.agentos-shell:not([data-theme="light"]) .plat-check.on {
  background: rgba(13,148,136,.15);
  border-color: #0f766e;
}
.agentos-shell[data-theme="dark"] .plat-toggles .plat-check,
.agentos-shell:not([data-theme="light"]) .plat-toggles .plat-check {
  background: #0f172a;
  border-color: #1f2937;
}
.agentos-shell[data-theme="dark"] .plat-bucket,
.agentos-shell:not([data-theme="light"]) .plat-bucket {
  background: #0f172a;
  border-color: #1f2937;
}
.agentos-shell[data-theme="dark"] .plat-chip,
.agentos-shell:not([data-theme="light"]) .plat-chip {
  background: #111827;
  border-color: #334155;
  color: #cbd5e1;
}
.agentos-shell[data-theme="dark"] .plat-chip.on,
.agentos-shell:not([data-theme="light"]) .plat-chip.on {
  background: #0d9488;
  border-color: #0d9488;
  color: #fff;
}
.agentos-shell[data-theme="dark"] .plat-mini-btn,
.agentos-shell:not([data-theme="light"]) .plat-mini-btn {
  background: #111827;
  border-color: #334155;
  color: #cbd5e1;
}
.agentos-shell[data-theme="dark"] .plat-sub-meta,
.agentos-shell:not([data-theme="light"]) .plat-sub-meta { color: #5eead4; }
.agentos-shell[data-theme="dark"] .plat-sticky-bar,
.agentos-shell:not([data-theme="light"]) .plat-sticky-bar {
  background: rgba(15,23,42,.92);
  border-color: #1f2937;
  color: #94a3b8;
}
.agentos-shell[data-theme="dark"] .plat-empty,
.agentos-shell:not([data-theme="light"]) .plat-empty {
  background: #111827;
  border-color: #334155;
}
.agentos-shell[data-theme="dark"] .plat-empty strong,
.agentos-shell:not([data-theme="light"]) .plat-empty strong { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-plan-name strong,
.agentos-shell:not([data-theme="light"]) .plat-plan-name strong { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-rate-service strong,
.agentos-shell:not([data-theme="light"]) .plat-rate-service strong { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-rate-econ strong,
.agentos-shell:not([data-theme="light"]) .plat-rate-econ strong { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-advanced-json,
.agentos-shell:not([data-theme="light"]) .plat-advanced-json {
  background: #111827;
  border-color: #1f2937;
}
.agentos-shell[data-theme="dark"] .plat-advanced-json > summary strong,
.agentos-shell:not([data-theme="light"]) .plat-advanced-json > summary strong { color: #f8fafc; }
.agentos-shell[data-theme="dark"] .plat-rate-unit,
.agentos-shell:not([data-theme="light"]) .plat-rate-unit {
  background: #1f2937;
  color: #94a3b8;
}
.agentos-shell[data-theme="dark"] .plat-loading,
.agentos-shell:not([data-theme="light"]) .plat-loading {
  background: #0f172a;
  border-color: #1f2937;
  color: #94a3b8;
}

@media (max-width: 900px) {
  .plat-tabs { grid-template-columns: 1fr; }
  .plat-stat-grid { width: 100%; }
  .plat-field-row { grid-template-columns: 1fr; }
  .plat-rate-grid { grid-template-columns: 1fr; }
  .plat-rate-price { grid-template-columns: 64px minmax(0, 1fr); min-width: 0; }
  .plat-pack-design-grid { grid-template-columns: 1fr; }
  .plat-sim-grid { grid-template-columns: 1fr; }
  .plat-tel-tariff-row { grid-template-columns: 1fr; }
}
@media (max-width: 640px) {
  .plat-hero { padding: 14px; }
  .plat-panel { padding: 12px; }
  .plat-panel-actions { width: 100%; }
  .plat-panel-actions .agentos-btn { flex: 1 1 auto; }
}
`;

// src/home-work-queue.tsx
import { useCallback as useCallback18, useEffect as useEffect18, useState as useState20 } from "react";
import { jsx as jsx22, jsxs as jsxs22 } from "react/jsx-runtime";
var emptyState = () => ({
  loading: true,
  partial: false,
  kpis: [],
  attention: []
});
var HomeWorkQueue = ({
  workspaceId,
  locale: localeProp,
  goById,
  allowedIds,
  liveOpsApi,
  voiceApi,
  leadsApi,
  campaignsApi,
  agentApi,
  phoneNumbersApi
}) => {
  const locale = localeFrom(typeof localeProp === "string" ? localeProp : localeProp);
  const t = (text) => translate(locale, text);
  const can = (routeId) => allowedIds.has(routeId);
  const [state, setState] = useState20(emptyState);
  const load = useCallback18(async () => {
    const tr2 = (text) => translate(locale, text);
    const has = (routeId) => allowedIds.has(routeId);
    setState((prev) => ({ ...prev, loading: true }));
    const apiSlots = [
      liveOpsApi,
      voiceApi,
      leadsApi,
      campaignsApi,
      agentApi,
      phoneNumbersApi
    ];
    const expected = apiSlots.filter(Boolean).length;
    const results = await Promise.allSettled([
      liveOpsApi ? liveOpsApi.dashboard(workspaceId, 60, "workspace") : Promise.reject(new Error("no_live")),
      voiceApi ? voiceApi.list(workspaceId, { status: "failed" }, null, 20) : Promise.reject(new Error("no_voice")),
      leadsApi ? leadsApi.list(workspaceId, null, "hot") : Promise.reject(new Error("no_leads")),
      campaignsApi ? campaignsApi.list(workspaceId) : Promise.reject(new Error("no_campaigns")),
      agentApi ? agentApi.list(workspaceId) : Promise.reject(new Error("no_agents")),
      phoneNumbersApi ? phoneNumbersApi.list(workspaceId) : Promise.reject(new Error("no_numbers"))
    ]);
    const live = results[0].status === "fulfilled" ? results[0].value : null;
    const failedCalls = results[1].status === "fulfilled" ? results[1].value : null;
    const hotLeads = results[2].status === "fulfilled" ? results[2].value : null;
    const campaigns = results[3].status === "fulfilled" ? results[3].value : null;
    const agents = results[4].status === "fulfilled" ? results[4].value : null;
    const numbers = results[5].status === "fulfilled" ? results[5].value : null;
    const settledOk = results.filter((r) => r.status === "fulfilled").length;
    const partial = expected > 0 && settledOk < expected;
    const active = live?.counts.active ?? null;
    const waiting = live?.counts.waitingForHuman ?? null;
    const failedN = failedCalls?.items.length ?? null;
    const hotN = hotLeads?.items.length ?? null;
    const runningN = campaigns?.items.filter((c) => c.status === "running" || c.status === "scheduled").length ?? null;
    const publishedN = agents?.items.filter((a) => a.status === "active" && a.publishedVersion != null).length ?? null;
    const unboundN = numbers?.items.filter(
      (n) => n.status === "active" && n.numberClass === "platform_external" && !n.defaultInboundAgentId && !/demo|test/i.test(`${n.label ?? ""} ${n.notes ?? ""}`)
    ).length ?? null;
    const dash = (n) => n == null ? "\u2014" : String(n);
    const kpi = (id, label, value, tone, routeId) => routeId ? { id, label, value, tone, routeId } : { id, label, value, tone };
    const kpis = [
      kpi(
        "active",
        tr2("Active calls"),
        dash(active),
        active != null && active > 0 ? "warn" : "neutral",
        has("live") ? "live" : has("conversations") ? "conversations" : void 0
      ),
      kpi(
        "human",
        tr2("Waiting for human"),
        dash(waiting),
        waiting != null && waiting > 0 ? "bad" : "neutral",
        has("live") ? "live" : void 0
      ),
      kpi(
        "failed",
        tr2("Failed calls (recent)"),
        dash(failedN),
        failedN != null && failedN > 0 ? "bad" : "ok",
        has("conversations") ? "conversations" : void 0
      ),
      kpi(
        "hot",
        tr2("Hot leads"),
        dash(hotN),
        hotN != null && hotN > 0 ? "warn" : "neutral",
        has("leads") ? "leads" : void 0
      ),
      kpi(
        "campaigns",
        tr2("Running campaigns"),
        dash(runningN),
        runningN != null && runningN > 0 ? "ok" : "neutral",
        has("campaigns") ? "campaigns" : void 0
      ),
      kpi(
        "agents",
        tr2("Published agents"),
        dash(publishedN),
        publishedN === 0 ? "warn" : "ok",
        has("agents") ? "agents" : void 0
      )
    ];
    const attention = [];
    if (waiting != null && waiting > 0 && has("live")) {
      attention.push({
        id: "att-human",
        title: tr2("Human handoff waiting"),
        body: tr2("One or more calls need an operator now."),
        cta: tr2("Open live ops"),
        routeId: "live",
        tone: "bad"
      });
    }
    if (failedN != null && failedN > 0 && has("conversations")) {
      attention.push({
        id: "att-failed",
        title: tr2("Failed calls need review"),
        body: tr2("Check recordings and retry or fix the number / agent."),
        cta: tr2("Review calls"),
        routeId: "conversations",
        tone: "bad"
      });
    }
    if (hotN != null && hotN > 0 && has("leads")) {
      attention.push({
        id: "att-hot",
        title: tr2("Hot leads waiting"),
        body: tr2("Follow up while interest is high."),
        cta: tr2("Open leads"),
        routeId: "leads",
        tone: "warn"
      });
    }
    if (unboundN != null && unboundN > 0 && has("numbers")) {
      attention.push({
        id: "att-did",
        title: tr2("Production DID without inbound agent"),
        body: tr2("Bind a published agent so inbound calls are answered."),
        cta: tr2("Open numbers"),
        routeId: "numbers",
        tone: "warn"
      });
    }
    if (publishedN === 0 && has("agents")) {
      attention.push({
        id: "att-agent",
        title: tr2("No published agent yet"),
        body: tr2("Publish an agent before campaigns or inbound DID routing."),
        cta: tr2("Open agents"),
        routeId: "agents",
        tone: "info"
      });
    }
    if (runningN === 0 && (campaigns?.items.length ?? 0) === 0 && has("campaigns")) {
      attention.push({
        id: "att-camp",
        title: tr2("No campaigns yet"),
        body: tr2("Create a draft, add contacts, then start outbound dialing."),
        cta: tr2("Start a campaign"),
        routeId: "campaigns",
        tone: "info"
      });
    }
    if (attention.length === 0 && settledOk > 0) {
      attention.push({
        id: "att-ok",
        title: tr2("Queue looks clear"),
        body: tr2("No critical exceptions. Start a campaign or review recent calls."),
        cta: has("campaigns") ? tr2("Start a campaign") : has("conversations") ? tr2("Review calls") : tr2("Browse the console"),
        routeId: has("campaigns") ? "campaigns" : has("conversations") ? "conversations" : "overview",
        tone: "info"
      });
    }
    setState({
      loading: false,
      partial: partial || settledOk === 0,
      kpis,
      attention: attention.slice(0, 5)
    });
  }, [
    agentApi,
    allowedIds,
    campaignsApi,
    leadsApi,
    liveOpsApi,
    locale,
    phoneNumbersApi,
    voiceApi,
    workspaceId
  ]);
  useEffect18(() => {
    void load();
    const id = window.setInterval(() => void load(), 45e3);
    return () => window.clearInterval(id);
  }, [load]);
  return /* @__PURE__ */ jsxs22("section", { className: "home-work-queue", "aria-label": t("Work queue"), children: [
    /* @__PURE__ */ jsxs22("header", { className: "home-work-queue-head", children: [
      /* @__PURE__ */ jsxs22("div", { children: [
        /* @__PURE__ */ jsx22("small", { children: t("Live queue") }),
        /* @__PURE__ */ jsx22("h3", { children: t("What needs attention") })
      ] }),
      /* @__PURE__ */ jsx22("button", { type: "button", className: "home-work-refresh", disabled: state.loading, onClick: () => void load(), children: state.loading ? t("Refreshing\u2026") : t("Refresh") })
    ] }),
    state.partial && !state.loading && /* @__PURE__ */ jsx22("p", { className: "home-work-partial", role: "status", children: t("Some metrics could not load. Values show \u2014 when unavailable.") }),
    /* @__PURE__ */ jsx22("div", { className: "home-kpi-grid", "aria-busy": state.loading, children: (state.loading && state.kpis.length === 0 ? Array.from({ length: 6 }, (_, i) => ({
      id: `sk-${i}`,
      label: "\u2026",
      value: "\xB7",
      tone: "neutral"
    })) : state.kpis).map((cell) => {
      const routeId = "routeId" in cell ? cell.routeId : void 0;
      const clickable = Boolean(routeId && can(routeId));
      const className = `home-kpi tone-${cell.tone}${clickable ? " is-clickable" : ""}`;
      if (clickable && routeId) {
        return /* @__PURE__ */ jsxs22(
          "button",
          {
            type: "button",
            className,
            onClick: () => goById(routeId),
            children: [
              /* @__PURE__ */ jsx22("span", { children: cell.label }),
              /* @__PURE__ */ jsx22("strong", { children: cell.value })
            ]
          },
          cell.id
        );
      }
      return /* @__PURE__ */ jsxs22("div", { className, children: [
        /* @__PURE__ */ jsx22("span", { children: cell.label }),
        /* @__PURE__ */ jsx22("strong", { children: cell.value })
      ] }, cell.id);
    }) }),
    /* @__PURE__ */ jsx22("div", { className: "home-attention-list", children: state.attention.map((item) => /* @__PURE__ */ jsxs22("article", { className: `home-attention tone-${item.tone}`, children: [
      /* @__PURE__ */ jsxs22("div", { children: [
        /* @__PURE__ */ jsx22("strong", { children: item.title }),
        /* @__PURE__ */ jsx22("p", { children: item.body })
      ] }),
      can(item.routeId) && /* @__PURE__ */ jsx22("button", { type: "button", className: "agentos-btn primary", onClick: () => goById(item.routeId), children: item.cta })
    ] }, item.id)) })
  ] });
};

// src/conversation-lab.tsx
import { useEffect as useEffect19, useMemo as useMemo14, useState as useState21 } from "react";
import { Fragment as Fragment12, jsx as jsx23, jsxs as jsxs23 } from "react/jsx-runtime";
var millis = (value) => typeof value === "number" && Number.isFinite(value) ? Math.round(value).toLocaleString("tr-TR") : "\u2014";
var verdictClass = (verdict) => {
  if (verdict === "PASS") return "lab-pass";
  if (verdict === "WARN") return "lab-warn";
  return "lab-fail";
};
var ConversationLabPanel = () => {
  const [report, setReport] = useState21(null);
  const [selectedId, setSelectedId] = useState21(null);
  const [trackKey, setTrackKey] = useState21("A");
  const [error, setError] = useState21(null);
  const [busy, setBusy] = useState21(false);
  useEffect19(() => {
    let cancelled = false;
    const load = async () => {
      for (const url of ["/conversation-lab-benchmark-latest.json", "/conversation-lab-latest.json"]) {
        const response = await fetch(url, { cache: "no-store" });
        if (response.ok) return await response.json();
      }
      return null;
    };
    void load().then((loaded) => {
      if (cancelled || !loaded) return;
      setReport(loaded);
      const firstTrack = loaded.tracks?.find((track) => track.conversations.length > 0) ?? loaded.tracks?.[0];
      setTrackKey(firstTrack?.modelKey ?? "A");
      const convs = firstTrack?.conversations ?? loaded.conversations ?? [];
      setSelectedId(convs[0]?.id ?? null);
    }).catch(() => void 0);
    return () => {
      cancelled = true;
    };
  }, []);
  const activeTrack = useMemo14(
    () => report?.tracks?.find((track) => track.modelKey === trackKey) ?? report?.tracks?.[0],
    [report, trackKey]
  );
  const conversations = activeTrack?.conversations ?? report?.conversations ?? [];
  const selected = useMemo14(
    () => conversations.find((row) => row.id === selectedId) ?? conversations[0],
    [conversations, selectedId]
  );
  const agentModel = activeTrack?.exactId ?? report?.agentModel ?? "\u2014";
  const metrics = activeTrack?.metrics ?? report?.metrics;
  const loadFile = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const parsed = JSON.parse(String(reader.result));
        setReport(parsed);
        const firstTrack = parsed.tracks?.find((track) => track.conversations.length > 0) ?? parsed.tracks?.[0];
        setTrackKey(firstTrack?.modelKey ?? "A");
        const convs = firstTrack?.conversations ?? parsed.conversations ?? [];
        setSelectedId(convs[0]?.id ?? null);
        setError(null);
      } catch (cause) {
        setError(cause instanceof Error ? cause.message : "JSON okunamad\u0131");
      }
    };
    reader.readAsText(file);
  };
  return /* @__PURE__ */ jsxs23("section", { className: "conversation-lab", children: [
    /* @__PURE__ */ jsxs23("header", { className: "conversation-lab-top", children: [
      /* @__PURE__ */ jsxs23("div", { children: [
        /* @__PURE__ */ jsx23("h2", { children: "CENTEROS CONVERSATION LAB" }),
        /* @__PURE__ */ jsxs23("p", { children: [
          "Ger\xE7ek provider konu\u015Fmalar\u0131 \u2014 PSTN yok. Ajan: ",
          agentModel,
          " \xB7 M\xFC\u015Fteri:",
          " ",
          report?.customerModel ?? report?.observerModel ?? "gpt-4o-mini",
          " \xB7 G\xF6zlemci: gpt-4o-mini (k\xF6r)"
        ] })
      ] }),
      /* @__PURE__ */ jsxs23("div", { className: "conversation-lab-actions", children: [
        /* @__PURE__ */ jsx23("button", { type: "button", disabled: busy, onClick: () => setBusy(false), children: "Run Conversation" }),
        /* @__PURE__ */ jsx23("button", { type: "button", disabled: busy, children: "Auto Run 20" }),
        /* @__PURE__ */ jsx23("span", { className: "lab-chip", children: "Text" }),
        /* @__PURE__ */ jsx23("span", { className: "lab-chip", children: "Audio" }),
        report?.tracks?.map((track) => /* @__PURE__ */ jsxs23(
          "button",
          {
            type: "button",
            className: track.modelKey === trackKey ? "active" : "",
            onClick: () => {
              setTrackKey(track.modelKey);
              setSelectedId(track.conversations[0]?.id ?? null);
            },
            children: [
              "MODEL ",
              track.modelKey,
              " ",
              track.exactId
            ]
          },
          track.modelKey
        )),
        /* @__PURE__ */ jsxs23("label", { className: "lab-file", children: [
          "Load JSON",
          /* @__PURE__ */ jsx23(
            "input",
            {
              type: "file",
              accept: "application/json",
              onChange: (event) => {
                const file = event.target.files?.[0];
                if (file) loadFile(file);
              }
            }
          )
        ] })
      ] })
    ] }),
    error ? /* @__PURE__ */ jsx23("p", { className: "studio-alert error", children: error }) : null,
    !report ? /* @__PURE__ */ jsx23("p", { className: "alx-muted", children: "Hen\xFCz lab ko\u015Fusu y\xFCklenmedi. `pnpm exec tsx scripts/conversation-lab-run.ts` \xE7al\u0131\u015Ft\u0131r\u0131n veya JSON y\xFCkleyin. Auto Run \xFCretim veritaban\u0131na yazmaz; disposable Postgres kullan\u0131r." }) : /* @__PURE__ */ jsxs23("div", { className: "conversation-lab-grid", children: [
      /* @__PURE__ */ jsx23("aside", { className: "conversation-lab-runs", children: conversations.map((row, index) => /* @__PURE__ */ jsxs23(
        "button",
        {
          type: "button",
          className: row.id === selected?.id ? "active" : "",
          onClick: () => setSelectedId(row.id),
          children: [
            /* @__PURE__ */ jsxs23("b", { children: [
              String(index + 1).padStart(2, "0"),
              " ",
              row.verdict,
              " ",
              row.observerAverage != null ? row.observerAverage.toFixed(1) : "\u2014"
            ] }),
            /* @__PURE__ */ jsxs23("small", { children: [
              row.persona,
              " \xB7 ",
              row.mode,
              " \xB7 ",
              row.turns.length,
              " tur"
            ] })
          ]
        },
        row.id
      )) }),
      /* @__PURE__ */ jsx23("div", { className: "conversation-lab-main", children: selected ? /* @__PURE__ */ jsxs23(Fragment12, { children: [
        /* @__PURE__ */ jsx23("div", { className: "conversation-lab-thread", children: selected.turns.map((turn) => /* @__PURE__ */ jsxs23("article", { children: [
          /* @__PURE__ */ jsxs23("div", { className: "lab-msg customer", children: [
            /* @__PURE__ */ jsx23("strong", { children: "CUSTOMER" }),
            /* @__PURE__ */ jsx23("p", { children: turn.customer.text }),
            turn.customer.sttTranscript ? /* @__PURE__ */ jsxs23("small", { children: [
              "STT: ",
              turn.customer.sttTranscript
            ] }) : null
          ] }),
          /* @__PURE__ */ jsxs23("div", { className: "lab-msg agent", children: [
            /* @__PURE__ */ jsx23("strong", { children: "AGENT" }),
            /* @__PURE__ */ jsx23("p", { children: turn.llm.response }),
            /* @__PURE__ */ jsxs23("small", { children: [
              turn.llm.model,
              " \xB7 ",
              turn.llm.latencyMs ?? "\u2014",
              " ms \xB7 toplam",
              " ",
              turn.totalTurnLatencyMs,
              " ms"
            ] })
          ] })
        ] }, turn.turnIndex)) }),
        /* @__PURE__ */ jsxs23("aside", { className: "conversation-lab-side", children: [
          selected.turns.at(-1) ? /* @__PURE__ */ jsxs23("dl", { children: [
            /* @__PURE__ */ jsx23("dt", { children: "Stage" }),
            /* @__PURE__ */ jsxs23("dd", { children: [
              selected.turns.at(-1)?.conversation.stageBefore,
              " \u2192",
              " ",
              selected.turns.at(-1)?.conversation.stageAfter
            ] }),
            /* @__PURE__ */ jsx23("dt", { children: "Intent" }),
            /* @__PURE__ */ jsx23("dd", { children: selected.turns.at(-1)?.understanding.userTurnIntent ?? "\u2014" }),
            /* @__PURE__ */ jsx23("dt", { children: "Facts" }),
            /* @__PURE__ */ jsx23("dd", { children: (selected.turns.at(-1)?.conversation.remainingRequiredFacts ?? []).join(
              ", "
            ) || "none remaining" }),
            /* @__PURE__ */ jsx23("dt", { children: "Planner" }),
            /* @__PURE__ */ jsx23("dd", { children: selected.turns.at(-1)?.planner.primaryAction ?? "\u2014" }),
            /* @__PURE__ */ jsx23("dt", { children: "Policy" }),
            /* @__PURE__ */ jsx23("dd", { children: selected.turns.at(-1)?.policy.communicativeNeed ?? "\u2014" }),
            /* @__PURE__ */ jsx23("dt", { children: "Tool" }),
            /* @__PURE__ */ jsxs23("dd", { children: [
              selected.turns.at(-1)?.tools.authorityDecision ?? "\u2014",
              " ",
              (selected.turns.at(-1)?.tools.executionStatus ?? []).join(", ")
            ] }),
            /* @__PURE__ */ jsx23("dt", { children: "Final emit" }),
            /* @__PURE__ */ jsx23("dd", { children: selected.turns.at(-1)?.finalEmit.decision ?? "\u2014" })
          ] }) : null,
          /* @__PURE__ */ jsxs23("div", { className: `lab-observer ${verdictClass(selected.verdict)}`, children: [
            /* @__PURE__ */ jsxs23("b", { children: [
              "Observer ",
              selected.observerAverage?.toFixed(1) ?? "\u2014",
              "/10"
            ] }),
            /* @__PURE__ */ jsx23("p", { children: selected.failReason ?? selected.turns.at(-1)?.observer?.reason })
          ] })
        ] })
      ] }) : null })
    ] }),
    report ? /* @__PURE__ */ jsxs23("footer", { className: "conversation-lab-metrics", children: [
      /* @__PURE__ */ jsxs23("span", { children: [
        "STT ",
        millis(metrics?.meanSttMs ?? metrics?.average_stt_ms),
        " ms"
      ] }),
      /* @__PURE__ */ jsxs23("span", { children: [
        "LLM ",
        millis(metrics?.meanLlmMs ?? metrics?.average_llm_ms),
        " ms"
      ] }),
      /* @__PURE__ */ jsxs23("span", { children: [
        "TTS ",
        millis(metrics?.meanTtsMs ?? metrics?.average_tts_ms),
        " ms"
      ] }),
      /* @__PURE__ */ jsxs23("span", { children: [
        "Total ",
        millis(metrics?.meanTotalTurnMs ?? metrics?.average_total_ms),
        " ms"
      ] }),
      /* @__PURE__ */ jsxs23("span", { children: [
        String(metrics?.conversations ?? conversations.length),
        " conv \xB7",
        " ",
        String(metrics?.realTurns ?? metrics?.turns ?? conversations.reduce((n, row) => n + row.turns.length, 0)),
        " ",
        "turns"
      ] })
    ] }) : null
  ] });
};

// src/index.tsx
import { jsx as jsx24, jsxs as jsxs24 } from "react/jsx-runtime";
var iconById = {
  overview: "\u2302",
  brain: "\u25C8",
  agents: "\u2726",
  channels: "\u25CC",
  conversations: "\u25CD",
  directory: "\u260E",
  numbers: "\uFF03",
  campaigns: "\u25A3",
  leads: "\u25CE",
  providers: "\u21C4",
  integrations: "\u29C9",
  live: "\u25C9",
  workflows: "\u21BB",
  analytics: "\u2301",
  billing: "\xA4",
  settings: "\u2699",
  platform: "\u26E8"
};
var NAV_ORDER = [
  "overview",
  "campaigns",
  "conversations",
  "live",
  "leads",
  "directory",
  "numbers",
  "brain",
  "agents",
  "channels",
  "providers",
  "integrations",
  "workflows",
  "analytics",
  "billing",
  "settings",
  "platform"
];
var NAV_SECTION_DAILY = /* @__PURE__ */ new Set([
  "overview",
  "campaigns",
  "conversations",
  "live",
  "leads",
  "directory",
  "numbers"
]);
var NAV_SECTION_BUILD = /* @__PURE__ */ new Set(["brain", "agents"]);
var NAV_SECTION_SETUP = /* @__PURE__ */ new Set([
  "channels",
  "providers",
  "integrations",
  "workflows",
  "analytics",
  "billing",
  "settings",
  "platform"
]);
var NAV_SECTIONS = [
  { id: "daily", label: "Daily work", ids: NAV_SECTION_DAILY },
  { id: "build", label: "Build", ids: NAV_SECTION_BUILD },
  { id: "setup", label: "Setup", ids: NAV_SECTION_SETUP }
];
var QUICK_ACTIONS = [
  {
    id: "qa-campaigns",
    routeId: "campaigns",
    title: "Start a campaign",
    blurb: "Import contacts, set the script, and dial outbound calls in order.",
    cta: "Open campaigns"
  },
  {
    id: "qa-calls",
    routeId: "conversations",
    title: "Review calls",
    blurb: "Listen to recordings, read transcripts, and check purpose notes.",
    cta: "Open conversations"
  },
  {
    id: "qa-leads",
    routeId: "leads",
    title: "Follow up leads",
    blurb: "See hot / warm / cold scores and next actions after each call.",
    cta: "Open leads"
  },
  {
    id: "qa-directory",
    routeId: "directory",
    title: "Call from directory",
    blurb: "Pick a contact, set the purpose note, and place a single outbound call.",
    cta: "Open directory"
  }
];
var COLOR_MODE_KEY = "centeros-color-mode";
var readColorMode = () => {
  if (typeof window === "undefined") return "dark";
  try {
    const stored = window.localStorage.getItem(COLOR_MODE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
  }
  try {
    if (window.matchMedia("(prefers-color-scheme: light)").matches) return "light";
  } catch {
  }
  return "dark";
};
var writeColorMode = (mode) => {
  try {
    window.localStorage.setItem(COLOR_MODE_KEY, mode);
  } catch {
  }
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-centeros-theme", mode);
    document.documentElement.style.colorScheme = mode;
    document.body.style.background = mode === "light" ? "#f4f1ea" : "#070b10";
  }
};
var normalizeShellRoute = (path) => {
  if (!path) return void 0;
  const trimmed = path.trim();
  if (!trimmed || trimmed === "/") return void 0;
  const withSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return withSlash.replace(/\/+$/, "") || void 0;
};
var browserPathRoute = () => {
  if (typeof window === "undefined") return void 0;
  return normalizeShellRoute(window.location.pathname);
};
var AgentOSShell = ({
  manifest,
  initialRoute,
  onNavigate,
  embedded = false,
  brainApi,
  agentApi,
  voiceApi,
  contactsApi,
  phoneNumbersApi,
  campaignsApi,
  leadsApi,
  providerApi,
  operationsApi,
  intelligenceApi,
  performanceApi,
  integrationsApi,
  liveOpsApi,
  billingApi,
  platformAdminApi
}) => {
  const isPlatformAdmin = manifest.entitlements.includes("platform.admin");
  const navigation = useMemo15(() => {
    const items = [...manifest.navigation];
    if (isPlatformAdmin && !items.some((item) => item.id === "platform")) {
      items.push({ id: "platform", route: "/platform", label: "Platform admin" });
    }
    return items;
  }, [manifest.navigation, isPlatformAdmin]);
  const fallbackRoute = navigation[0]?.route ?? "/overview";
  const [route, setRoute] = useState22(
    () => normalizeShellRoute(initialRoute) ?? (!embedded ? browserPathRoute() : void 0) ?? fallbackRoute
  );
  const [colorMode, setColorMode] = useState22(() => readColorMode());
  const matchedNav = navigation.find((item) => item.route === route);
  const activeItem = matchedNav ?? (route === "/platform" && isPlatformAdmin ? { id: "platform", route: "/platform", label: "Platform admin" } : navigation[0]);
  const locale = localeFrom(manifest.locale);
  const direction = localeDirection(locale);
  const t = (text) => translate(locale, text);
  const theme = useMemo15(
    () => ({
      // Teal ops identity (visible shell accent). Manifest may still supply radius.
      "--agentos-primary": "#0d9488",
      "--agentos-radius": manifest.theme.radius ?? "16px"
    }),
    [manifest.theme]
  );
  useEffect20(() => {
    writeColorMode(colorMode);
  }, [colorMode]);
  useEffect20(() => {
    if (typeof document === "undefined") return;
    const previousLang = document.documentElement.getAttribute("lang");
    const previousDir = document.documentElement.getAttribute("dir");
    document.documentElement.setAttribute("lang", locale);
    document.documentElement.setAttribute("dir", direction);
    return () => {
      if (previousLang != null) document.documentElement.setAttribute("lang", previousLang);
      else document.documentElement.removeAttribute("lang");
      if (previousDir != null) document.documentElement.setAttribute("dir", previousDir);
      else document.documentElement.removeAttribute("dir");
    };
  }, [locale, direction]);
  useEffect20(() => {
    if (embedded || typeof window === "undefined") return;
    const current = normalizeShellRoute(window.location.pathname) ?? "/";
    const target = normalizeShellRoute(route) ?? "/";
    if (current !== target) {
      window.history.pushState({ agentosRoute: target }, "", target);
    }
  }, [route, embedded]);
  useEffect20(() => {
    if (embedded || typeof window === "undefined") return;
    const onPopState = () => {
      const next = browserPathRoute() ?? fallbackRoute;
      setRoute(next);
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [embedded, fallbackRoute]);
  const [focusCallId, setFocusCallId] = useState22();
  const [focusLeadId, setFocusLeadId] = useState22();
  const navigate = (nextRoute) => {
    const normalized = normalizeShellRoute(nextRoute) ?? fallbackRoute;
    setRoute(normalized);
    onNavigate?.(normalized);
  };
  const openCall = (callId) => {
    setFocusCallId(callId);
    setFocusLeadId(void 0);
    navigate("/conversations");
  };
  const openLead = (leadId) => {
    setFocusLeadId(leadId);
    setFocusCallId(void 0);
    navigate("/leads");
  };
  const navById = useMemo15(() => {
    const map = new Map(navigation.map((item) => [item.id, item]));
    return map;
  }, [navigation]);
  const allowedNavIds = useMemo15(
    () => new Set(navigation.map((item) => item.id)),
    [navigation]
  );
  const orderedNav = useMemo15(() => {
    const remaining = [...navigation];
    const ordered = [];
    for (const id of NAV_ORDER) {
      const idx = remaining.findIndex((item) => item.id === id);
      if (idx >= 0) {
        const [item] = remaining.splice(idx, 1);
        if (item) ordered.push(item);
      }
    }
    return [...ordered, ...remaining];
  }, [navigation]);
  const navSections = useMemo15(() => {
    const buckets = {
      daily: [],
      build: [],
      setup: []
    };
    for (const item of orderedNav) {
      if (NAV_SECTION_DAILY.has(item.id)) buckets.daily.push(item);
      else if (NAV_SECTION_BUILD.has(item.id)) buckets.build.push(item);
      else buckets.setup.push(item);
    }
    return NAV_SECTIONS.map((section) => ({
      ...section,
      items: buckets[section.id]
    })).filter((section) => section.items.length > 0);
  }, [orderedNav]);
  const goById = (itemId) => {
    const item = navById.get(itemId);
    if (item) navigate(item.route);
  };
  const mobileNavIds = ["overview", "campaigns", "conversations", "leads", "directory"];
  return /* @__PURE__ */ jsxs24(
    "div",
    {
      className: `agentos-shell ${embedded ? "is-embedded" : ""}`,
      "data-theme": colorMode,
      style: theme,
      lang: locale,
      dir: direction,
      children: [
        /* @__PURE__ */ jsx24("style", { children: agentOSStyles }),
        /* @__PURE__ */ jsxs24("aside", { className: "agentos-sidebar", part: "sidebar", children: [
          /* @__PURE__ */ jsxs24("div", { className: "agentos-brand", children: [
            /* @__PURE__ */ jsx24("span", { className: "agentos-mark", children: (manifest.theme.productName ?? "CenterOS").slice(0, 1).toUpperCase() }),
            /* @__PURE__ */ jsxs24("div", { children: [
              /* @__PURE__ */ jsx24("strong", { children: manifest.theme.productName ?? "CenterOS" }),
              /* @__PURE__ */ jsx24("small", { children: t("Customer Operations") })
            ] })
          ] }),
          /* @__PURE__ */ jsx24("nav", { "aria-label": t("Main navigation"), children: navSections.map((section) => /* @__PURE__ */ jsxs24("div", { className: "agentos-nav-section", children: [
            /* @__PURE__ */ jsx24("div", { className: "agentos-nav-section-label", children: t(section.label) }),
            section.items.map((item) => /* @__PURE__ */ jsxs24(
              "button",
              {
                className: [
                  item.route === activeItem?.route ? "active" : "",
                  item.id === "platform" ? "agentos-nav-platform" : ""
                ].filter(Boolean).join(" ") || void 0,
                onClick: () => navigate(item.route),
                type: "button",
                children: [
                  /* @__PURE__ */ jsx24("span", { "aria-hidden": "true", children: iconById[item.id] ?? "\xB7" }),
                  t(item.label)
                ]
              },
              item.id
            ))
          ] }, section.id)) }),
          /* @__PURE__ */ jsxs24("div", { className: "agentos-workspace", children: [
            /* @__PURE__ */ jsx24("span", { className: "agentos-avatar", children: manifest.principal.displayName.slice(0, 1).toUpperCase() }),
            /* @__PURE__ */ jsxs24("div", { children: [
              /* @__PURE__ */ jsx24("strong", { children: manifest.principal.displayName }),
              /* @__PURE__ */ jsx24("small", { children: manifest.workspaces[0]?.name ?? manifest.tenant.name })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs24("main", { className: "agentos-main", part: "content", children: [
          /* @__PURE__ */ jsxs24("header", { className: "agentos-topbar", children: [
            /* @__PURE__ */ jsxs24("div", { children: [
              /* @__PURE__ */ jsx24("small", { children: manifest.tenant.name }),
              /* @__PURE__ */ jsx24("h1", { children: t(activeItem?.label ?? "CenterOS") })
            ] }),
            /* @__PURE__ */ jsxs24("div", { className: "agentos-topbar-right", children: [
              isPlatformAdmin && /* @__PURE__ */ jsxs24(
                "button",
                {
                  type: "button",
                  className: route === "/platform" ? "agentos-btn primary agentos-platform-chip" : "agentos-btn agentos-platform-chip",
                  onClick: () => navigate("/platform"),
                  title: t("DID pool \xB7 CenterOS packages \xB7 Panaryus plan links"),
                  children: [
                    "\u26E8 ",
                    t("Platform admin")
                  ]
                }
              ),
              /* @__PURE__ */ jsxs24(
                "div",
                {
                  className: "agentos-theme-toggle",
                  role: "group",
                  "aria-label": t("Color mode"),
                  children: [
                    /* @__PURE__ */ jsx24(
                      "button",
                      {
                        type: "button",
                        className: colorMode === "dark" ? "active" : "",
                        "aria-pressed": colorMode === "dark",
                        onClick: () => setColorMode("dark"),
                        children: t("Dark")
                      }
                    ),
                    /* @__PURE__ */ jsx24(
                      "button",
                      {
                        type: "button",
                        className: colorMode === "light" ? "active" : "",
                        "aria-pressed": colorMode === "light",
                        onClick: () => setColorMode("light"),
                        children: t("Light")
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsxs24("div", { className: "agentos-status agentos-status-v2", title: t("Short-lived session verified by the server"), children: [
                /* @__PURE__ */ jsx24("i", {}),
                " ",
                t("Session active")
              ] })
            ] })
          ] }),
          activeItem?.id === "brain" && brainApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(BusinessBrainPage, { api: brainApi, locale, workspaceId: manifest.workspaces[0].id }) : activeItem?.id === "agents" && agentApi && brainApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            AgentStudioPage,
            {
              api: agentApi,
              brains: brainApi,
              ...voiceApi ? { voiceApi } : {},
              ...contactsApi ? { contactsApi } : {},
              ...integrationsApi ? { integrationsApi } : {},
              ...operationsApi ? { operationsApi } : {},
              ...phoneNumbersApi ? { phoneNumbersApi } : {},
              locale,
              workspaceId: manifest.workspaces[0].id,
              onOpenIntegrations: () => navigate("/integrations"),
              onOpenNumbers: () => navigate("/numbers"),
              onOpenBrain: () => navigate("/brain"),
              onOpenDirectory: () => navigate("/directory")
            }
          ) : activeItem?.id === "conversations" && voiceApi && agentApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            VoiceStudioPage,
            {
              api: voiceApi,
              agents: agentApi,
              ...phoneNumbersApi ? { phoneNumbersApi } : {},
              locale,
              workspaceId: manifest.workspaces[0].id,
              ...focusCallId ? { initialCallId: focusCallId } : {},
              onOpenCampaign: () => navigate("/campaigns"),
              onOpenLead: openLead
            }
          ) : activeItem?.id === "live" && liveOpsApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            LiveOpsPage,
            {
              api: liveOpsApi,
              locale,
              workspaceId: manifest.workspaces[0].id,
              sessionWorkspaces: manifest.workspaces,
              onOpenCall: openCall
            }
          ) : activeItem?.id === "directory" && contactsApi && agentApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            DirectoryPage,
            {
              api: contactsApi,
              agents: agentApi,
              ...phoneNumbersApi ? { phoneNumbersApi } : {},
              ...operationsApi ? { operationsApi } : {},
              locale,
              workspaceId: manifest.workspaces[0].id,
              onOpenOperations: () => navigate("/workflows"),
              onOpenIntegrations: () => navigate("/integrations")
            }
          ) : activeItem?.id === "numbers" && phoneNumbersApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            NumbersPage,
            {
              api: phoneNumbersApi,
              locale,
              workspaceId: manifest.workspaces[0].id,
              ...agentApi ? {
                onLoadAgents: async () => {
                  const list = await agentApi.list(manifest.workspaces[0].id);
                  return list.items.map((agent) => ({
                    id: agent.id,
                    name: agent.name,
                    status: agent.status,
                    publishedVersion: agent.publishedVersion
                  }));
                }
              } : {}
            }
          ) : activeItem?.id === "campaigns" && campaignsApi && agentApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            CampaignsPage,
            {
              api: campaignsApi,
              agents: agentApi,
              ...contactsApi ? { contactsApi } : {},
              ...phoneNumbersApi ? { phoneNumbersApi } : {},
              locale,
              workspaceId: manifest.workspaces[0].id
            }
          ) : activeItem?.id === "leads" && leadsApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            LeadsPage,
            {
              api: leadsApi,
              locale,
              workspaceId: manifest.workspaces[0].id,
              ...focusLeadId ? { initialLeadId: focusLeadId } : {},
              onOpenCall: openCall
            }
          ) : activeItem?.id === "providers" && providerApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(ProviderStudioPage, { api: providerApi, locale, workspaceId: manifest.workspaces[0].id }) : activeItem?.id === "integrations" && integrationsApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            IntegrationsPage,
            {
              api: integrationsApi,
              ...operationsApi ? { operationsApi } : {},
              locale,
              workspaceId: manifest.workspaces[0].id,
              onOpenOperations: () => navigate("/workflows")
            }
          ) : activeItem?.id === "workflows" && operationsApi && agentApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            OperationsStudioPage,
            {
              api: operationsApi,
              agents: agentApi,
              locale,
              workspaceId: manifest.workspaces[0].id,
              onOpenIntegrations: () => navigate("/integrations")
            }
          ) : activeItem?.id === "analytics" && performanceApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            PerformancePage,
            {
              api: performanceApi,
              ...agentApi ? { agents: agentApi } : {},
              ...billingApi ? { billingApi } : {},
              locale,
              workspaceId: manifest.workspaces[0].id
            }
          ) : activeItem?.id === "analytics" && intelligenceApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(IntelligenceStudioPage, { api: intelligenceApi, locale, workspaceId: manifest.workspaces[0].id }) : (activeItem?.id === "platform" || route === "/platform") && platformAdminApi && isPlatformAdmin ? /* @__PURE__ */ jsx24(PlatformAdminPage, { api: platformAdminApi, locale }) : route === "/platform" ? /* @__PURE__ */ jsx24("div", { className: "agentos-home agentos-home-v2", children: /* @__PURE__ */ jsxs24("div", { className: "agentos-ops-banner", role: "alert", style: { background: "#7f1d1d", color: "#fef2f2" }, children: [
            /* @__PURE__ */ jsx24("strong", { children: t("Platform admin") }),
            /* @__PURE__ */ jsx24("span", { children: t(
              "This account is missing platform.admin. Sign out of CenterOS, open Call Center from Panaryus portal again, then hard-refresh."
            ) })
          ] }) }) : (activeItem?.id === "billing" || activeItem?.id === "settings") && billingApi && manifest.workspaces[0] ? /* @__PURE__ */ jsx24(
            BillingLifecyclePage,
            {
              api: billingApi,
              locale,
              workspaceId: manifest.workspaces[0].id,
              mode: activeItem.id
            }
          ) : /* @__PURE__ */ jsxs24("div", { className: "agentos-home agentos-home-v2", children: [
            isPlatformAdmin && /* @__PURE__ */ jsxs24(
              "div",
              {
                className: "agentos-ops-banner",
                role: "navigation",
                style: {
                  background: "linear-gradient(90deg,#0f766e,#115e59)",
                  color: "#ecfdf5",
                  marginBottom: 12
                },
                children: [
                  /* @__PURE__ */ jsxs24("strong", { children: [
                    "\u26E8 ",
                    t("Platform admin")
                  ] }),
                  /* @__PURE__ */ jsx24("span", { children: t("DID pool \xB7 CenterOS packages \xB7 Panaryus plan links") }),
                  /* @__PURE__ */ jsx24(
                    "button",
                    {
                      type: "button",
                      className: "agentos-btn primary",
                      style: { marginLeft: "auto" },
                      onClick: () => navigate("/platform"),
                      children: t("Open platform settings")
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsxs24("div", { className: "agentos-ops-banner", role: "status", children: [
              /* @__PURE__ */ jsx24("strong", { children: t("TODAY OPS") }),
              /* @__PURE__ */ jsxs24("span", { children: [
                t("Hello"),
                ", ",
                manifest.principal.displayName.split(" ")[0],
                " \u2014",
                " ",
                t("Pick a job below. Campaign \u2192 Calls \u2192 Leads.")
              ] })
            ] }),
            manifest.workspaces[0] && /* @__PURE__ */ jsx24(
              HomeWorkQueue,
              {
                workspaceId: manifest.workspaces[0].id,
                locale,
                goById,
                allowedIds: allowedNavIds,
                ...liveOpsApi ? { liveOpsApi } : {},
                ...voiceApi ? { voiceApi } : {},
                ...leadsApi ? { leadsApi } : {},
                ...campaignsApi ? { campaignsApi } : {},
                ...agentApi ? { agentApi } : {},
                ...phoneNumbersApi ? { phoneNumbersApi } : {}
              }
            ),
            /* @__PURE__ */ jsxs24("section", { className: "agentos-hero agentos-hero-v2", children: [
              /* @__PURE__ */ jsxs24("div", { children: [
                /* @__PURE__ */ jsx24("span", { className: "agentos-eyebrow", children: t("Command center") }),
                /* @__PURE__ */ jsx24("h2", { children: t("What should I do next?") }),
                /* @__PURE__ */ jsx24("p", { children: t(
                  "Run outbound campaigns, review calls, follow leads \u2014 this home is your work queue, not a feature map."
                ) }),
                /* @__PURE__ */ jsxs24("div", { className: "agentos-hero-actions", children: [
                  navById.has("campaigns") && /* @__PURE__ */ jsx24("button", { type: "button", className: "agentos-btn primary", onClick: () => goById("campaigns"), children: t("Start a campaign") }),
                  navById.has("conversations") && /* @__PURE__ */ jsx24(
                    "button",
                    {
                      type: "button",
                      className: "agentos-btn ghost",
                      onClick: () => goById("conversations"),
                      children: t("Review calls")
                    }
                  ),
                  navById.has("leads") && /* @__PURE__ */ jsx24("button", { type: "button", className: "agentos-btn ghost", onClick: () => goById("leads"), children: t("Follow up leads") })
                ] })
              ] }),
              /* @__PURE__ */ jsxs24("div", { className: "agentos-hero-card agentos-hero-card-v2", children: [
                /* @__PURE__ */ jsx24("span", { children: t("Workspace") }),
                /* @__PURE__ */ jsx24("strong", { children: manifest.workspaces[0]?.name ?? manifest.tenant.name }),
                /* @__PURE__ */ jsxs24("small", { children: [
                  manifest.tenant.name,
                  /* @__PURE__ */ jsx24("br", {}),
                  t("Session expires"),
                  " ",
                  new Date(manifest.expiresAt).toLocaleTimeString(manifest.locale, {
                    hour: "2-digit",
                    minute: "2-digit"
                  })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ jsxs24("section", { className: "agentos-quick", "aria-label": t("Quick actions"), children: [
              /* @__PURE__ */ jsx24("header", { className: "agentos-section-head", children: /* @__PURE__ */ jsxs24("div", { children: [
                /* @__PURE__ */ jsx24("small", { children: t("Work queue") }),
                /* @__PURE__ */ jsx24("h3", { children: t("Four doors to daily work") })
              ] }) }),
              /* @__PURE__ */ jsx24("div", { className: "agentos-quick-grid agentos-quick-grid-v2", children: QUICK_ACTIONS.filter((action2) => navById.has(action2.routeId)).map((action2) => /* @__PURE__ */ jsxs24(
                "button",
                {
                  type: "button",
                  className: "agentos-quick-card agentos-quick-card-v2",
                  onClick: () => goById(action2.routeId),
                  children: [
                    /* @__PURE__ */ jsx24("b", { "aria-hidden": "true", children: iconById[action2.routeId] ?? "\xB7" }),
                    /* @__PURE__ */ jsx24("strong", { children: t(action2.title) }),
                    /* @__PURE__ */ jsx24("p", { children: t(action2.blurb) }),
                    /* @__PURE__ */ jsxs24("span", { children: [
                      t(action2.cta),
                      " \u2192"
                    ] })
                  ]
                },
                action2.id
              )) })
            ] }),
            /* @__PURE__ */ jsxs24("section", { className: "agentos-panels agentos-home-panels", children: [
              /* @__PURE__ */ jsxs24("article", { className: "agentos-panel", children: [
                /* @__PURE__ */ jsx24("div", { className: "agentos-panel-head", children: /* @__PURE__ */ jsxs24("div", { children: [
                  /* @__PURE__ */ jsx24("small", { children: t("All modules") }),
                  /* @__PURE__ */ jsx24("h3", { children: t("Browse the console") })
                ] }) }),
                /* @__PURE__ */ jsx24("div", { className: "agentos-module-list", children: navigation.filter((item) => item.id !== "overview").map((item) => /* @__PURE__ */ jsxs24("button", { type: "button", onClick: () => navigate(item.route), children: [
                  /* @__PURE__ */ jsx24("b", { children: iconById[item.id] ?? "\xB7" }),
                  /* @__PURE__ */ jsxs24("span", { children: [
                    /* @__PURE__ */ jsx24("strong", { children: t(item.label) }),
                    /* @__PURE__ */ jsx24("small", { children: moduleHint(item.id, t) })
                  ] }),
                  /* @__PURE__ */ jsx24("em", { "aria-hidden": "true", children: "\u2192" })
                ] }, item.id)) })
              ] }),
              /* @__PURE__ */ jsxs24("article", { className: "agentos-panel agentos-security", children: [
                /* @__PURE__ */ jsxs24("div", { className: "agentos-panel-head", children: [
                  /* @__PURE__ */ jsxs24("div", { children: [
                    /* @__PURE__ */ jsx24("small", { children: t("Account") }),
                    /* @__PURE__ */ jsx24("h3", { children: t("Your access") })
                  ] }),
                  /* @__PURE__ */ jsx24("span", { className: "secure", children: t("Protected") })
                ] }),
                /* @__PURE__ */ jsxs24("ul", { className: "agentos-account-list", children: [
                  /* @__PURE__ */ jsxs24("li", { children: [
                    /* @__PURE__ */ jsx24("span", { children: t("Company") }),
                    /* @__PURE__ */ jsx24("strong", { children: manifest.tenant.name })
                  ] }),
                  /* @__PURE__ */ jsxs24("li", { children: [
                    /* @__PURE__ */ jsx24("span", { children: t("Workspace") }),
                    /* @__PURE__ */ jsx24("strong", { children: manifest.workspaces[0]?.name ?? "\u2014" })
                  ] }),
                  /* @__PURE__ */ jsxs24("li", { children: [
                    /* @__PURE__ */ jsx24("span", { children: t("User") }),
                    /* @__PURE__ */ jsx24("strong", { children: manifest.principal.displayName })
                  ] })
                ] }),
                /* @__PURE__ */ jsx24("p", { className: "agentos-security-note", children: t(
                  "Your data stays inside this company workspace. Sessions are short-lived and server-verified."
                ) })
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsx24("nav", { className: "agentos-mobile-nav", "aria-label": t("Mobile navigation"), children: mobileNavIds.map((id) => navById.get(id)).filter((item) => Boolean(item)).map((item) => /* @__PURE__ */ jsxs24(
          "button",
          {
            type: "button",
            className: item.route === activeItem?.route ? "active" : "",
            onClick: () => navigate(item.route),
            children: [
              /* @__PURE__ */ jsx24("span", { "aria-hidden": "true", children: iconById[item.id] ?? "\xB7" }),
              t(item.label)
            ]
          },
          item.id
        )) })
      ]
    }
  );
};
var moduleHint = (id, t) => {
  const hints = {
    campaigns: t("Outbound dialing lists"),
    conversations: t("Transcripts and recordings"),
    leads: t("Scores and next steps"),
    directory: t("Contacts and single calls"),
    numbers: t("Caller IDs and BYO numbers"),
    brain: t("Company knowledge"),
    agents: t("Voice and chat agents"),
    channels: t("Webchat and messaging"),
    providers: t("Telephony and AI keys"),
    workflows: t("Automations"),
    analytics: t("Performance insights"),
    billing: t("Plan and usage"),
    settings: t("Retention and data"),
    platform: t("Platform admin")
  };
  return hints[id] ?? t("Open module");
};
var agentOSStyles = `
  :host, .agentos-shell {
    color-scheme: dark;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    font-size: 14px;
    line-height: 1.45;
    -webkit-font-smoothing: antialiased;
  }
  * { box-sizing: border-box; }
  button, input, select, textarea { font: inherit; }
  button { cursor: pointer; }
  .agentos-shell {
    --agentos-primary:#0d9488;
    --agentos-radius:14px;
    --agentos-surface:#111620;
    --agentos-border:#273142;
    --agentos-muted:#8490a4;
    --agentos-text:#f2f4f8;
    min-height:100vh;
    display:grid;
    grid-template-columns:232px 1fr;
    background:#070b10;
    color:var(--agentos-text);
    overflow:hidden;
  }
  .agentos-shell.is-embedded { min-height:720px; border-radius:var(--agentos-radius); border:1px solid #222938; }
  .agentos-sidebar {
    padding:16px 10px 12px;
    background:linear-gradient(180deg,#111522 0%,#0d111b 100%);
    border-right:1px solid #242a38;
    display:flex;
    flex-direction:column;
    min-height:0;
  }
  .agentos-brand { display:flex; align-items:center; gap:10px; padding:0 8px 14px; }
  .agentos-mark {
    width:34px; height:34px; border-radius:10px; display:grid; place-items:center;
    font-weight:800; font-size:14px;
    background:linear-gradient(135deg,var(--agentos-primary),#4fd2e7);
    box-shadow:0 8px 20px color-mix(in srgb,var(--agentos-primary) 30%,transparent);
  }
  .agentos-brand div,.agentos-workspace div { display:grid; gap:1px; min-width:0; }
  .agentos-brand strong { letter-spacing:.01em; font-size:13px; line-height:1.2; }
  .agentos-brand small,.agentos-workspace small {
    color:#7d879a; font-size:10px; letter-spacing:.06em; text-transform:uppercase;
    overflow:hidden; text-overflow:ellipsis; white-space:nowrap; line-height:1.2;
  }
  .agentos-sidebar nav {
    display:flex; flex-direction:column; gap:2px;
    overflow:auto; padding:0 2px; flex:1;
  }
  .agentos-nav-section {
    display:flex; flex-direction:column; gap:2px;
  }
  .agentos-nav-section + .agentos-nav-section {
    margin-top:10px; padding-top:8px; border-top:1px solid #1e2433;
  }
  .agentos-nav-section-label {
    padding:2px 10px 6px;
    color:#5c6578; font-size:10px; font-weight:700;
    letter-spacing:.08em; text-transform:uppercase;
    line-height:1.2; user-select:none;
  }
  .agentos-sidebar nav button {
    border:0; color:#8f98aa; background:transparent;
    padding:8px 10px; border-radius:8px;
    text-align:left; display:flex; gap:10px; align-items:center;
    transition:.15s ease; font-size:13px; font-weight:500; line-height:1.2;
    width:100%;
  }
  .agentos-sidebar nav button span {
    width:18px; color:#6f7890; font-size:14px; text-align:center; flex:0 0 auto; line-height:1;
  }
  .agentos-sidebar nav button:hover { background:#171c29; color:#e8eaf2; }
  .agentos-sidebar nav button.active {
    color:#fff; font-weight:600;
    background:linear-gradient(90deg,color-mix(in srgb,var(--agentos-primary) 26%,#171c29),#171c29);
    box-shadow:inset 2px 0 var(--agentos-primary);
  }
  .agentos-sidebar nav button.active span { color:#a89dff; }
  .agentos-sidebar nav button.agentos-nav-platform {
    margin-top:6px;
    color:#99f6e4;
    border:1px solid color-mix(in srgb,#0d9488 55%,transparent);
    background:color-mix(in srgb,#0d9488 14%,transparent);
    font-weight:700;
  }
  .agentos-sidebar nav button.agentos-nav-platform span { color:#5eead4; }
  .agentos-sidebar nav button.agentos-nav-platform.active {
    background:linear-gradient(90deg,#0f766e,#134e4a);
    box-shadow:inset 2px 0 #f59e0b;
    color:#fff;
  }
  .agentos-workspace {
    margin-top:auto; display:flex; align-items:center; gap:8px;
    padding:10px 8px 2px; border-top:1px solid #242a38;
  }
  .agentos-avatar {
    flex:0 0 auto; width:30px; height:30px; display:grid; place-items:center;
    border-radius:50%; background:#22293a; color:#b8b0ff; font-weight:800; font-size:12px;
  }
  .agentos-workspace strong { font-size:12px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; line-height:1.2; }
  .agentos-main {
    min-width:0; overflow:auto;
    background:radial-gradient(circle at 82% 0%,rgba(102,87,232,.08),transparent 32%),#0a0d14;
  }
  .agentos-topbar {
    min-height:68px; display:flex; align-items:center; justify-content:space-between;
    padding:12px 28px; border-bottom:1px solid #202632;
    background:rgba(10,13,20,.88); backdrop-filter:blur(14px); position:sticky; top:0; z-index:5;
  }
  .agentos-topbar small { color:#707a90; font-size:11px; letter-spacing:.06em; text-transform:uppercase; }
  .agentos-topbar h1 { font-size:18px; margin:4px 0 0; font-weight:700; letter-spacing:-.02em; }
  .agentos-topbar-right { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
  .agentos-theme-toggle {
    display:inline-flex; border:1px solid #2d3748; border-radius:100px; overflow:hidden; background:#111720;
  }
  .agentos-theme-toggle button {
    border:0; background:transparent; color:#8490a4; padding:7px 12px;
    font-size:11px; font-weight:700; cursor:pointer; min-height:34px;
  }
  .agentos-theme-toggle button.active {
    background:var(--agentos-primary); color:#fff;
  }
  .agentos-status {
    display:flex; gap:8px; align-items:center; padding:8px 12px;
    border:1px solid #2a3550; border-radius:100px; color:#a8b4cc; font-size:12px; background:#121826;
  }
  .agentos-status i { width:7px; height:7px; border-radius:50%; background:#6b8cff; box-shadow:0 0 10px rgba(107,140,255,.55); }
  .agentos-status-v2 {
    border-color:#0f766e; color:#99f6e4; background:#042f2e; font-weight:700;
  }
  .agentos-status-v2 i { background:#2dd4bf; box-shadow:0 0 12px #2dd4bf; }
  .agentos-home { padding-bottom:24px; }
  .home-work-queue {
    margin:14px 28px 0; padding:16px 18px; border-radius:16px;
    border:1px solid #1f6f68; background:linear-gradient(180deg,#0f1c1a 0%,#111620 100%);
  }
  .home-work-queue-head {
    display:flex; justify-content:space-between; align-items:flex-end; gap:12px; margin-bottom:12px;
  }
  .home-work-queue-head small {
    color:#5eead4; font-size:11px; font-weight:700; letter-spacing:.12em; text-transform:uppercase;
  }
  .home-work-queue-head h3 { margin:4px 0 0; font-size:18px; font-weight:750; color:var(--agentos-text); }
  .home-work-refresh {
    border:1px solid #2d3748; background:#0d121a; color:#a8b4cc; border-radius:10px;
    padding:8px 12px; font-size:12px; font-weight:700; cursor:pointer; min-height:36px;
  }
  .home-work-refresh:disabled { opacity:.55; cursor:wait; }
  .home-work-partial { margin:0 0 10px; color:#fbbf24; font-size:12px; }
  .home-kpi-grid {
    display:grid; grid-template-columns:repeat(6,minmax(0,1fr)); gap:10px; margin-bottom:12px;
  }
  .home-kpi {
    display:grid; gap:6px; text-align:left; border:1px solid #273142; border-radius:12px;
    background:#0d121a; padding:12px 12px 10px; color:var(--agentos-text);
  }
  .home-kpi span { color:#8490a4; font-size:11px; line-height:1.3; }
  .home-kpi strong { font-size:22px; font-weight:800; letter-spacing:-.02em; line-height:1.1; }
  .home-kpi.tone-warn { border-color:#a16207; background:#1a1408; }
  .home-kpi.tone-warn strong { color:#fbbf24; }
  .home-kpi.tone-bad { border-color:#991b1b; background:#1a0c0c; }
  .home-kpi.tone-bad strong { color:#fca5a5; }
  .home-kpi.tone-ok strong { color:#6ee7b7; }
  .home-kpi.is-clickable { cursor:pointer; }
  .home-kpi.is-clickable:hover { border-color:#0d9488; }
  .home-attention-list { display:grid; gap:8px; }
  .home-attention {
    display:flex; justify-content:space-between; align-items:center; gap:12px; flex-wrap:wrap;
    border:1px solid #273142; border-radius:12px; padding:12px 14px; background:#0c1218;
  }
  .home-attention strong { display:block; font-size:13px; margin-bottom:4px; }
  .home-attention p { margin:0; color:#97a1b4; font-size:12px; line-height:1.45; max-width:48rem; }
  .home-attention.tone-bad { border-color:#7f1d1d; background:#1a0c0c; }
  .home-attention.tone-warn { border-color:#854d0e; background:#1a1408; }
  .home-attention.tone-info { border-color:#1f6f68; }
  .agentos-shell[data-theme="light"] .home-work-queue {
    background:linear-gradient(180deg,#fff 0%,#f0fdfa 100%); border-color:#99f6e4;
  }
  .agentos-shell[data-theme="light"] .home-work-queue-head h3 { color:#0f172a; }
  .agentos-shell[data-theme="light"] .home-work-refresh {
    background:#fff; border-color:#d6d3d1; color:#57534e;
  }
  .agentos-shell[data-theme="light"] .home-kpi {
    background:#fff; border-color:#d6d3d1; color:#0f172a;
  }
  .agentos-shell[data-theme="light"] .home-kpi span { color:#57534e; }
  .agentos-shell[data-theme="light"] .home-attention {
    background:#fff; border-color:#d6d3d1;
  }
  .agentos-shell[data-theme="light"] .home-attention p { color:#57534e; }
  .agentos-shell[data-theme="light"] .home-attention.tone-bad { background:#fef2f2; border-color:#fecaca; }
  .agentos-shell[data-theme="light"] .home-attention.tone-warn { background:#fffbeb; border-color:#fde68a; }
  @media (max-width:1100px) {
    .home-kpi-grid { grid-template-columns:repeat(3,minmax(0,1fr)); }
  }
  @media (max-width:720px) {
    .home-work-queue { margin-left:14px; margin-right:14px; }
    .home-kpi-grid { grid-template-columns:repeat(2,minmax(0,1fr)); }
  }
  .agentos-ops-banner {
    margin:0; padding:12px 28px; display:flex; flex-wrap:wrap; gap:10px 16px; align-items:center;
    background:linear-gradient(90deg,#f59e0b 0%,#fbbf24 45%,#34d399 100%);
    color:#0c1220; border-bottom:1px solid #b45309;
  }
  .agentos-ops-banner strong {
    font-size:12px; letter-spacing:.14em; text-transform:uppercase;
    background:#0c1220; color:#fbbf24; padding:6px 10px; border-radius:8px;
  }
  .agentos-ops-banner span { font-size:14px; font-weight:650; line-height:1.35; }
  .agentos-hero {
    margin:24px 28px 18px; border-radius:20px; padding:28px 30px;
    display:flex; justify-content:space-between; align-items:center; gap:20px;
    overflow:hidden; position:relative;
    background:linear-gradient(125deg,#171b2a 0%,#151a27 50%,#101a22 100%);
    border:1px solid #2a3346;
  }
  .agentos-hero-v2 {
    margin:18px 28px; border-radius:18px; padding:28px 30px;
    background:#f4f1ea; color:#0f172a; border:2px solid #0d9488;
    box-shadow:0 18px 50px rgba(0,0,0,.35);
  }
  .agentos-hero-v2:after { display:none; }
  .agentos-hero>div:first-child { max-width:640px; position:relative; z-index:1; }
  .agentos-eyebrow,.agentos-panel-head small,.agentos-section-head small {
    color:#9b91f5; font-size:11px; font-weight:700; letter-spacing:.12em; text-transform:uppercase;
  }
  .agentos-hero-v2 .agentos-eyebrow { color:#0f766e; }
  .agentos-hero h2 {
    font-size:clamp(24px,2.8vw,34px); line-height:1.15; letter-spacing:-.03em; margin:10px 0 12px; font-weight:750;
  }
  .agentos-hero-v2 h2 { color:#0f172a; font-size:clamp(28px,3.2vw,40px); }
  .agentos-hero p { color:#a0a9bb; margin:0; max-width:540px; line-height:1.6; font-size:14px; }
  .agentos-hero-v2 p { color:#334155; font-size:15px; max-width:560px; }
  .agentos-hero-actions { display:flex; flex-wrap:wrap; gap:10px; margin-top:18px; }
  .agentos-btn {
    border:0; border-radius:11px; padding:11px 16px; font-size:13px; font-weight:700;
    transition:.15s ease; min-height:42px;
  }
  .agentos-btn.primary { background:linear-gradient(135deg,var(--agentos-primary),#0e7490); color:#fff; }
  .agentos-btn.primary:hover { filter:brightness(1.06); }
  .agentos-btn.ghost {
    background:transparent; color:#d7dceb; border:1px solid #3a455c;
  }
  .agentos-btn.ghost:hover { background:#1a2030; }
  .agentos-platform-chip {
    border:1px solid #0d9488 !important;
    background:#0f766e !important;
    color:#ecfdf5 !important;
    font-size:12px !important;
    padding:8px 12px !important;
    min-height:36px !important;
    white-space:nowrap;
  }
  .agentos-platform-chip.primary,
  .agentos-platform-chip.agentos-btn.primary {
    background:linear-gradient(135deg,#0d9488,#f59e0b) !important;
    border-color:transparent !important;
  }
  .agentos-hero-v2 .agentos-btn.ghost {
    color:#0f172a; border-color:#94a3b8; background:#fff;
  }
  .agentos-hero-v2 .agentos-btn.ghost:hover { background:#e2e8f0; }
  .agentos-hero-card {
    position:relative; z-index:1; min-width:200px; max-width:240px;
    border:1px solid #33405a; border-radius:16px; padding:16px 18px;
    background:rgba(12,16,26,.72); display:grid; gap:6px;
  }
  .agentos-hero-card-v2 {
    background:#0f172a; color:#f8fafc; border:1px solid #0d9488; min-width:220px;
  }
  .agentos-hero-card span { color:#7f8aa0; font-size:11px; text-transform:uppercase; letter-spacing:.08em; }
  .agentos-hero-card-v2 span { color:#5eead4; }
  .agentos-hero-card strong { font-size:15px; line-height:1.3; }
  .agentos-hero-card small { color:#8b95a8; font-size:12px; }
  .agentos-hero-card-v2 small { color:#94a3b8; }
  .agentos-quick { margin:0 28px 18px; }
  .agentos-section-head { margin-bottom:12px; }
  .agentos-section-head h3 { margin:6px 0 0; font-size:17px; font-weight:700; }
  .agentos-quick-grid {
    display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:12px;
  }
  .agentos-quick-grid-v2 { gap:14px; }
  .agentos-quick-card {
    text-align:left; border:1px solid var(--agentos-border); border-radius:16px;
    background:var(--agentos-surface); padding:16px; display:grid; gap:8px;
    color:var(--agentos-text); transition:.16s ease; min-height:168px; align-content:start;
  }
  .agentos-quick-card-v2 {
    border:1px solid #1f6f68; background:linear-gradient(180deg,#12201e 0%,#111620 100%);
    min-height:180px;
  }
  .agentos-quick-card:hover {
    border-color:color-mix(in srgb,var(--agentos-primary) 55%,#273142);
    transform:translateY(-1px);
    box-shadow:0 12px 30px rgba(0,0,0,.22);
  }
  .agentos-quick-card b {
    width:36px; height:36px; border-radius:11px; display:grid; place-items:center;
    background:#1c2233; color:#a89dff; font-size:16px;
  }
  .agentos-quick-card-v2 b { background:#134e4a; color:#5eead4; }
  .agentos-quick-card strong { font-size:14px; font-weight:700; }
  .agentos-quick-card p { margin:0; color:var(--agentos-muted); font-size:12px; line-height:1.5; }
  .agentos-quick-card span { color:#a89dff; font-size:12px; font-weight:700; margin-top:auto; }
  .agentos-quick-card-v2 span { color:#5eead4; }
  .agentos-panels { display:grid; grid-template-columns:minmax(0,1.55fr) minmax(280px,.75fr); gap:14px; margin:0 28px 28px; }
  .agentos-home-panels { margin-top:4px; }
  .agentos-panel { border:1px solid var(--agentos-border); border-radius:var(--agentos-radius); background:var(--agentos-surface); padding:18px; }
  .agentos-panel-head { display:flex; justify-content:space-between; align-items:start; padding-bottom:14px; border-bottom:1px solid #232a37; gap:10px; }
  .agentos-panel-head h3 { margin:6px 0 0; font-size:16px; font-weight:700; }
  .agentos-panel-head>span {
    color:#7d8799; background:#181e2a; border:1px solid #293143; padding:6px 10px;
    border-radius:20px; font-size:10px; text-transform:uppercase; letter-spacing:.06em; white-space:nowrap;
  }
  .agentos-panel-head>span.secure { color:#64cb7b; border-color:#284533; background:#122017; }
  .agentos-module-list { display:grid; margin-top:6px; }
  .agentos-module-list button {
    background:transparent; border:0; color:#eef0f5;
    display:grid; grid-template-columns:38px 1fr auto; gap:12px; align-items:center;
    text-align:left; padding:12px 8px; border-bottom:1px solid #202632; border-radius:10px;
  }
  .agentos-module-list button:hover { background:#171d29; }
  .agentos-module-list b {
    width:38px; height:38px; border-radius:11px; display:grid; place-items:center;
    background:#1d2331; color:#9489f6; font-size:15px;
  }
  .agentos-module-list button>span { display:grid; gap:3px; min-width:0; }
  .agentos-module-list strong { font-size:13px; font-weight:650; }
  .agentos-module-list small { color:#7a8498; font-size:12px; }
  .agentos-module-list em { font-style:normal; color:#667084; font-size:14px; }
  .agentos-security { display:flex; flex-direction:column; gap:12px; }
  .agentos-account-list { list-style:none; margin:0; padding:0; display:grid; gap:10px; }
  .agentos-account-list li {
    display:grid; gap:3px; padding:11px 12px; border-radius:11px;
    background:#0d121a; border:1px solid #243041;
  }
  .agentos-account-list span { color:#738094; font-size:11px; text-transform:uppercase; letter-spacing:.06em; }
  .agentos-account-list strong { font-size:13px; font-weight:650; }
  .agentos-security-note { margin:0; color:#8b95a8; font-size:12px; line-height:1.55; }
  .agentos-mobile-nav {
    display:none; position:fixed; left:0; right:0; bottom:0; z-index:20;
    grid-template-columns:repeat(5,1fr); gap:0;
    padding:6px 4px calc(6px + env(safe-area-inset-bottom));
    background:rgba(12,16,24,.96); border-top:1px solid #273142; backdrop-filter:blur(12px);
  }
  .agentos-mobile-nav button {
    border:0; background:transparent; color:#8b95a8; display:grid; gap:2px; place-items:center;
    padding:6px 2px; border-radius:8px; font-size:10px; font-weight:600; line-height:1.15;
  }
  .agentos-mobile-nav button span { font-size:15px; line-height:1; }
  .agentos-mobile-nav button.active { color:#fff; background:#1a2030; }
  .brain-page { padding:28px 34px 40px; }
  .brain-toolbar { display:flex; align-items:end; justify-content:space-between; margin-bottom:18px; }
  .brain-toolbar span,.brain-card small,.brain-empty>span { color:#8b80f6; font-size:9px; font-weight:800; letter-spacing:.14em; }
  .brain-toolbar h2 { margin:6px 0 0; font-size:28px; letter-spacing:-.035em; }
  .brain-toolbar select,.brain-card input,.brain-card textarea,.brain-empty input { border:1px solid #30394a; border-radius:10px; background:#0b0f17; color:#e7e9ef; padding:11px 12px; outline:none; }
  .brain-stats { display:grid; grid-template-columns:repeat(4,1fr); gap:10px; margin-bottom:14px; }
  .brain-stats article { border:1px solid #252c39; background:#111620; border-radius:13px; padding:15px; display:grid; gap:6px; }
  .brain-stats small { color:#727d91; font-size:9px; text-transform:uppercase; letter-spacing:.1em; }.brain-stats strong { font-size:21px; }
  .brain-workbench { display:grid; grid-template-columns:1fr 1fr; gap:14px; align-items:start; }
  .brain-column { display:grid; gap:14px; }
  .brain-card { border:1px solid #252c39; border-radius:var(--agentos-radius); background:#111620; padding:19px; }
  .brain-card header { display:flex; justify-content:space-between; align-items:start; margin-bottom:15px; }.brain-card h3 { margin:5px 0 0; font-size:15px; }.brain-card header b { color:#767f91; font-size:11px; }
  .brain-card form { display:grid; gap:9px; }.brain-card input,.brain-card textarea { width:100%; resize:vertical; font-size:11px; line-height:1.5; }
  .brain-card button,.brain-empty button { border:0; border-radius:10px; padding:10px 13px; background:#6657e8; color:#fff; font-weight:800; font-size:10px; cursor:pointer; }.brain-card button:disabled { opacity:.42; cursor:not-allowed; }
  .brain-progress { height:5px; background:#222938; border-radius:5px; margin-bottom:14px; overflow:hidden; }.brain-progress i { display:block; height:100%; background:linear-gradient(90deg,#6657e8,#4fd2e7); }
  .proposal-list { display:grid; gap:9px; max-height:420px; overflow:auto; }.proposal-list>p { color:#717b8e; font-size:11px; }
  .proposal-list>div { position:relative; border:1px solid #293142; border-radius:11px; padding:13px 88px 13px 13px; background:#0d121b; }.proposal-list span { color:#56c9d8; font-size:8px; text-transform:uppercase; letter-spacing:.1em; }.proposal-list p { color:#d9dde7; font-size:11px; line-height:1.5; margin:6px 0; }.proposal-list small { color:#707b8e; font-size:8px; letter-spacing:0; }.proposal-list button { position:absolute; right:10px; top:10px; padding:7px 9px; }
  .publish-button { width:100%; margin-top:14px; background:linear-gradient(135deg,#6657e8,#3e98a8)!important; }
  .retrieval-card form { grid-template-columns:1fr auto; }.retrieval-results { display:grid; gap:8px; margin-top:12px; }.retrieval-results div { border-left:2px solid #4ecbdb; background:#0d121a; padding:10px; }.retrieval-results p { font-size:10px; line-height:1.5; margin:0 0 4px; }.retrieval-results small { color:#6f798b; letter-spacing:0; }
  .brain-alert { margin-bottom:12px; padding:10px 12px; border-radius:10px; font-size:10px; }.brain-alert.success { color:#86d795; background:#112017; border:1px solid #25462d; }.brain-alert.error { color:#ff9d9d; background:#2a1518; border:1px solid #492329; }
  .brain-empty { margin:34px; max-width:650px; border:1px solid #293142; border-radius:20px; padding:42px; background:linear-gradient(135deg,#151a28,#111820); }.brain-empty h2 { font-size:32px; margin:10px 0; }.brain-empty p { color:#8791a4; font-size:12px; line-height:1.6; }.brain-empty form { display:grid; grid-template-columns:1fr auto; gap:9px; margin-top:22px; }
  .studio-page { padding:24px 28px 40px; }
  .studio-toolbar { display:flex; align-items:end; justify-content:space-between; margin-bottom:16px; gap:12px; flex-wrap:wrap; }
  .studio-toolbar span,.studio-empty>span,.studio-card small { color:#9b91f5; font-size:11px; font-weight:700; letter-spacing:.12em; text-transform:uppercase; }
  .studio-toolbar h2 { margin:6px 0 0; font-size:24px; font-weight:750; letter-spacing:-.02em; }
  .studio-toolbar>b { color:#a0a9bb; font-size:12px; font-weight:650; background:#151b28; border:1px solid #2a3346; border-radius:100px; padding:7px 12px; }
  .studio-toolbar select,.studio-card input,.studio-card textarea,.studio-card select,.studio-empty input {
    border:1px solid #354257; border-radius:11px; background:#0b0f17; color:#e7e9ef;
    padding:11px 12px; outline:none; font-size:13px; min-height:42px;
  }
  .studio-toolbar select:focus,.studio-card input:focus,.studio-card textarea:focus,.studio-card select:focus {
    border-color:color-mix(in srgb,var(--agentos-primary) 70%,#354257);
    box-shadow:0 0 0 3px color-mix(in srgb,var(--agentos-primary) 18%,transparent);
  }
  .studio-grid { display:grid; grid-template-columns:1fr 1fr; gap:14px; align-items:start; }
  .studio-card { border:1px solid var(--agentos-border); border-radius:var(--agentos-radius); background:var(--agentos-surface); padding:18px; }
  .studio-card header { display:flex; justify-content:space-between; align-items:start; margin-bottom:14px; gap:10px; }
  .studio-card h3 { margin:5px 0 0; font-size:15px; font-weight:700; }
  .studio-card header b { color:#8b95a8; font-size:12px; font-weight:650; }
  .studio-card form { display:grid; gap:11px; }
  .studio-card label { display:grid; gap:6px; color:#9aa3b5; font-size:11px; text-transform:uppercase; letter-spacing:.06em; font-weight:650; }
  .studio-card textarea { resize:vertical; min-height:72px; line-height:1.45; }
  .studio-card button,.studio-empty button {
    border:0; border-radius:11px; padding:11px 14px; background:#6657e8; color:white;
    font-size:13px; font-weight:700; cursor:pointer; min-height:42px;
  }
  .studio-card button:hover { filter:brightness(1.05); }
  .studio-card button:disabled { opacity:.45; cursor:not-allowed; filter:none; }
  .studio-publish { width:100%; margin-top:10px; background:linear-gradient(135deg,#6657e8,#3896a8)!important; }
  .deployment-key { margin-top:11px; padding:11px; border:1px solid #2a3445; border-radius:10px; background:#0c1119; display:grid; gap:6px; }
  .deployment-key code { font-size:11px; color:#84cad5; overflow-wrap:anywhere; }
  .simulator-messages { min-height:350px; max-height:460px; overflow:auto; display:grid; align-content:start; gap:9px; padding:8px 0 14px; }
  .simulator-messages>p { color:#8b95a8; font-size:13px; }
  .simulator-messages>div { border-left:2px solid #6657e8; background:#0d121a; padding:11px; }
  .simulator-messages strong { font-size:11px; color:#9c93f4; }
  .simulator-messages p { font-size:13px; line-height:1.55; margin:5px 0; }
  .simulator-messages small { display:block; color:#7a8498; letter-spacing:0; font-size:11px; }
  .simulator-card form { grid-template-columns:1fr auto; }
  .studio-alert { margin-bottom:12px; padding:12px 14px; border-radius:11px; font-size:13px; line-height:1.45; }
  .studio-alert.success { color:#86d795; border:1px solid #25462d; background:#112017; }
  .studio-alert.error { color:#ffb0b0; border:1px solid #492329; background:#2a1518; }
  .studio-empty { margin:28px; max-width:650px; border:1px solid #293142; border-radius:18px; padding:36px; background:#111620; }
  /* \u2500\u2500 AgentLabs /app/agents visual parity (light island) \u2500\u2500 */
  .alx-page { padding:20px 24px 48px; background:#f4f5f7; color:#0f172a; min-height:100%; }
  .alx-subnav { display:inline-flex; gap:4px; background:#e8eaef; border-radius:12px; padding:4px; margin-bottom:18px; }
  .alx-subnav button { border:0; background:transparent; color:#475569; font-weight:650; font-size:13px; padding:9px 14px; border-radius:10px; cursor:pointer; display:inline-flex; align-items:center; gap:6px; }
  .alx-subnav button.active { background:#fff; color:#0f172a; box-shadow:0 1px 3px rgba(15,23,42,.08); }
  .alx-ico { opacity:.8; }
  .alx-hero { background:linear-gradient(135deg,#eef2ff 0%,#f5f3ff 45%,#f8fafc 100%); border:1px solid #e2e8f0; border-radius:18px; padding:22px 22px 18px; margin-bottom:16px; }
  .alx-hero-top { display:flex; justify-content:space-between; gap:16px; flex-wrap:wrap; align-items:flex-start; margin-bottom:16px; }
  .alx-hero-title { display:flex; gap:14px; align-items:center; }
  .alx-hero-icon { width:48px; height:48px; border-radius:14px; background:#4f46e5; color:#fff; display:grid; place-items:center; font-size:20px; box-shadow:0 8px 20px rgba(79,70,229,.28); }
  .alx-hero-title h1 { margin:0; font-size:26px; font-weight:800; letter-spacing:-.03em; color:#0f172a; }
  .alx-hero-title p { margin:4px 0 0; color:#64748b; font-size:14px; }
  .alx-hero-actions { display:flex; gap:8px; flex-wrap:wrap; }
  .alx-btn { border:0; border-radius:10px; padding:10px 16px; font-weight:700; font-size:13px; cursor:pointer; min-height:40px; }
  .alx-btn.primary { background:#4f46e5; color:#fff; }
  .alx-btn.primary:hover { background:#4338ca; }
  .alx-btn.ghost { background:#fff; color:#312e81; border:1px solid #c7d2fe; }
  .alx-btn.block { width:100%; }
  .alx-btn:disabled { opacity:.5; cursor:not-allowed; }
  .alx-stats { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; }
  .alx-stat { background:#fff; border:1px solid #e2e8f0; border-radius:14px; padding:14px 16px; }
  .alx-stat b { display:block; font-size:24px; font-weight:800; color:#0f172a; }
  .alx-stat span { color:#64748b; font-size:12px; font-weight:600; }
  .alx-stat.accent-green b { color:#059669; }
  .alx-stat.accent-purple b { color:#7c3aed; }
  .alx-banner { margin:0 0 12px; padding:10px 14px; border-radius:12px; font-size:13px; font-weight:650; }
  .alx-banner-warn { background:#fffbeb; border:1px solid #fcd34d; color:#92400e; }
  .alx-banner-error { background:#fef2f2; border:1px solid #fecaca; color:#991b1b; }
  .alx-filters { display:flex; flex-wrap:wrap; gap:8px; align-items:center; margin:0 0 16px; }
  .alx-chip { border:1px solid #e2e8f0; background:#fff; color:#475569; border-radius:999px; padding:8px 12px; font-size:12px; font-weight:650; cursor:pointer; }
  .alx-chip.active { background:#0f172a; border-color:#0f172a; color:#fff; }
  .alx-search { margin-left:auto; min-width:220px; flex:0 1 260px; border:1px solid #e2e8f0; border-radius:10px; background:#fff; color:#0f172a; padding:10px 12px; font-size:13px; }
  .alx-card-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(260px,1fr)); gap:14px; }
  .alx-agent-card { border:1px solid #e8e4dc; border-radius:16px; padding:16px; display:grid; gap:10px; cursor:pointer; transition:transform .12s ease, box-shadow .12s ease; text-align:left; }
  .alx-agent-card:hover { transform:translateY(-2px); box-shadow:0 10px 28px rgba(15,23,42,.08); }
  .alx-agent-card.tone-cream { background:#fbf7f0; }
  .alx-agent-card.tone-mint { background:#eefaf4; border-color:#d1fae5; }
  .alx-agent-card.tone-peach { background:#fff7ed; border-color:#ffedd5; }
  .alx-agent-card.is-demo-muted { opacity:.62; filter:grayscale(.35); }
  .alx-agent-card.is-demo-muted:hover { opacity:.85; filter:grayscale(.1); }
  .alx-pill.demo { background:#e5e7eb; color:#4b5563; }
  .alx-demo-toggle { display:inline-flex; align-items:center; gap:6px; margin-inline-start:auto; font-size:12px; color:#64748b; cursor:pointer; user-select:none; white-space:nowrap; }
  .alx-demo-toggle input { margin:0; }
  .alx-card-head { display:flex; gap:12px; align-items:flex-start; }
  .alx-card-icon { width:40px; height:40px; border-radius:12px; background:#e0e7ff; color:#4338ca; display:grid; place-items:center; font-size:16px; flex-shrink:0; }
  .alx-card-icon.kind-incoming { background:#d1fae5; color:#047857; }
  .alx-card-icon.kind-outgoing { background:#ffedd5; color:#c2410c; }
  .alx-card-icon.kind-omni,.alx-card-icon.kind-webchat { background:#e0e7ff; color:#4338ca; }
  .alx-card-titles h3 { margin:0 0 6px; font-size:15px; font-weight:750; color:#0f172a; max-width:180px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .alx-pill { display:inline-block; font-size:11px; font-weight:700; border-radius:999px; padding:3px 9px; }
  .alx-pill.incoming { background:#d1fae5; color:#047857; }
  .alx-pill.outgoing { background:#ffedd5; color:#c2410c; }
  .alx-pill.custom,.alx-pill.webchat,.alx-pill.omni { background:#e0e7ff; color:#4338ca; }
  .alx-stat.accent-orange b { color:#c2410c; }
  .alx-mode-banner { display:grid; gap:4px; }
  .alx-mode-banner strong { font-size:13px; }
  .alx-mode-banner span { font-size:12px; font-weight:500; opacity:.95; }
  .alx-mode-banner.mode-inbound { border-color:#6ee7b7; background:#ecfdf5; color:#065f46; }
  .alx-mode-banner.mode-outbound { border-color:#fdba74; background:#fff7ed; color:#9a3412; }
  .alx-mode-banner.mode-omni,.alx-mode-banner.mode-webchat { border-color:#a5b4fc; background:#eef2ff; color:#3730a3; }
  .alx-field-hint { display:block; margin-top:6px; color:#64748b; font-size:11px; line-height:1.4; font-weight:500; }
  .alx-voice-knobs { margin:0 0 14px; padding:12px 14px; border:1px solid #c7d2fe; border-radius:12px; background:#eef2ff; }
  .alx-voice-knobs-title { margin:0 0 6px; font-size:13px; font-weight:800; color:#312e81; }
  .alx-voice-knobs-live { margin-top:10px; padding:10px 12px; border-radius:10px; background:#fff; border:1px solid #e0e7ff; font-size:12px; color:#1e1b4b; }
  .alx-voice-knobs-live ul { margin:6px 0 0; padding-left:18px; line-height:1.5; }
  .alx-voice-knobs-live code { font-size:11px; background:#eef2ff; padding:1px 5px; border-radius:4px; }
  .alx-voice-knobs-stale { display:block; margin-top:8px; color:#b45309; font-weight:700; }
  .alx-card-voice { color:#64748b; font-size:12px; line-height:1.4; }
  .alx-card-tags span { display:inline-block; font-size:11px; color:#64748b; background:rgba(255,255,255,.65); border-radius:999px; padding:2px 8px; margin-right:4px; }
  .alx-card-prompt { margin:0; color:#475569; font-size:12px; line-height:1.5; min-height:3.4em; }
  .alx-card-foot { display:flex; gap:8px; color:#94a3b8; font-size:11px; }
  .alx-card-foot .ok { color:#059669; font-weight:700; }
  .alx-empty { text-align:center; padding:48px 20px; background:#fff; border:1px dashed #cbd5e1; border-radius:16px; }
  .alx-empty h2 { margin:0 0 8px; color:#0f172a; }
  .alx-empty p { color:#64748b; margin:0 0 16px; }
  .alx-back { background:none; border:0; color:#4f46e5; font-weight:650; cursor:pointer; margin-bottom:10px; padding:0; }
  .alx-edit-hero { display:flex; justify-content:space-between; gap:12px; flex-wrap:wrap; margin-bottom:14px; }
  .alx-edit-hero h1 { margin:0; font-size:24px; color:#0f172a; }
  .alx-edit-hero p { margin:4px 0 0; color:#64748b; font-size:13px; }
  .alx-edit-layout { display:grid; grid-template-columns:minmax(0,1fr) 300px; gap:16px; align-items:start; }
  .alx-edit-form { display:grid; gap:12px; }
  .alx-form-card { background:#fff; border:1px solid #e2e8f0; border-radius:14px; padding:16px; display:grid; gap:12px; }
  .alx-form-card h2 { margin:0; font-size:15px; color:#0f172a; }
  .alx-playbook { display:grid; gap:12px; }
  .alx-playbook-toolbar,.alx-playbook-add { display:flex; flex-wrap:wrap; gap:8px; }
  .alx-playbook-view-toggle { display:inline-flex; border:1px solid #e2e8f0; border-radius:10px; overflow:hidden; width:fit-content; }
  .alx-playbook-view-toggle button { background:#f8fafc; border:0; color:#64748b; padding:6px 14px; font-size:12px; font-weight:600; cursor:pointer; }
  .alx-playbook-view-toggle button.active { background:#eef2ff; color:#3730a3; }
  .alx-playbook-steps { margin:0; padding:0; list-style:none; display:grid; gap:10px; }
  .alx-playbook-step { border:1px solid #e2e8f0; border-radius:12px; background:#f8fafc; padding:12px; display:grid; gap:8px; }
  .alx-playbook-step-head { display:flex; justify-content:space-between; align-items:center; gap:8px; }
  .alx-playbook-step-head strong { font-size:13px; color:#0f172a; }
  .alx-playbook-step-actions { display:flex; gap:4px; }
  .alx-playbook-step-actions button { border:1px solid #e2e8f0; background:#fff; border-radius:8px; width:28px; height:28px; cursor:pointer; color:#334155; }
  .alx-playbook-step textarea,.alx-playbook-step input,.alx-playbook-step select { width:100%; box-sizing:border-box; border:1px solid #e2e8f0; border-radius:10px; padding:8px 10px; font-size:13px; background:#fff; color:#0f172a; }
  .alx-playbook-branch-opt { display:grid; grid-template-columns:1fr 1fr; gap:8px; }
  .alx-playbook-branch-opt .alx-playbook-next-step { grid-column:1 / -1; display:grid; gap:4px; font-size:12px; color:#64748b; }
  .alx-playbook-flow-layout { display:grid; grid-template-columns:minmax(0,1fr) minmax(220px,280px); gap:12px; align-items:start; }
  @media (max-width:900px) { .alx-playbook-flow-layout { grid-template-columns:1fr; } }
  .alx-playbook-flow { overflow:auto; border:1px solid #e2e8f0; border-radius:12px; background:#f1f5f9; max-height:560px; }
  .alx-playbook-flow-stage { position:relative; margin:0 auto; }
  .alx-playbook-flow-edges { position:absolute; inset:0; pointer-events:none; z-index:0; }
  .alx-playbook-flow-edge { stroke:#94a3b8; stroke-width:2; }
  .alx-playbook-flow-edge.is-dashed { stroke-dasharray:6 4; stroke:#cbd5e1; }
  .alx-playbook-flow-edge-label { fill:#64748b; font-size:10px; font-family:system-ui,sans-serif; }
  .alx-playbook-flow-node { position:absolute; z-index:1; display:grid; gap:2px; text-align:left; border:1px solid #e2e8f0; border-radius:12px; background:#fff; padding:10px 12px; box-shadow:0 1px 2px rgba(15,23,42,.04); cursor:pointer; color:#0f172a; }
  .alx-playbook-flow-node:hover { border-color:#c7d2fe; }
  .alx-playbook-flow-node.is-selected { border-color:#6366f1; box-shadow:0 0 0 2px rgba(99,102,241,.2); background:#eef2ff; }
  .alx-playbook-flow-node-kind { font-size:11px; font-weight:700; color:#4338ca; }
  .alx-playbook-flow-node-id { font-size:10px; color:#94a3b8; font-family:ui-monospace,monospace; }
  .alx-playbook-flow-node-preview { font-size:11px; color:#475569; line-height:1.3; overflow:hidden; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; }
  .alx-playbook-flow-panel { border:1px solid #e2e8f0; border-radius:12px; background:#f8fafc; padding:12px; display:grid; gap:8px; min-height:120px; }
  .alx-playbook-flow-panel-fields { border:0; background:transparent; padding:0; }
  .alx-widget-builder { display:grid; grid-template-columns:minmax(180px,240px) minmax(0,1fr); gap:16px; align-items:start; }
  .alx-widget-preview { background:#e2e8f0; border-radius:14px; padding:16px; min-height:220px; display:grid; place-items:end; }
  .alx-widget-preview-card { width:100%; background:#fff; border-radius:14px; overflow:hidden; box-shadow:0 10px 30px rgba(15,23,42,.12); }
  .alx-widget-preview-card header { color:#fff; padding:12px 14px; display:grid; gap:2px; }
  .alx-widget-preview-card header b { font-size:13px; }
  .alx-widget-preview-card header small { opacity:.9; font-size:11px; }
  .alx-widget-preview-body { padding:12px 14px; min-height:72px; font-size:12px; color:#334155; line-height:1.4; }
  .alx-widget-preview-card footer { padding:10px 14px 14px; display:flex; justify-content:flex-end; }
  .alx-widget-launcher { color:#fff; border-radius:999px; padding:8px 14px; font-size:12px; font-weight:700; }
  .alx-widget-fields { display:grid; gap:10px; }
  .alx-embed-snippet { display:grid; gap:8px; }
  .webchat-widget { display:grid; grid-template-rows:auto 1fr auto; min-height:320px; background:#fff; border:1px solid #e2e8f0; border-radius:16px; overflow:hidden; font-family:system-ui,sans-serif; }
  .webchat-widget.is-collapsed { min-height:0; border:0; background:transparent; display:block; }
  .webchat-widget header { color:#fff; padding:12px 14px; display:flex; justify-content:space-between; align-items:flex-start; gap:8px; background:var(--centeros-primary,#4f46e5); }
  .webchat-widget header b { display:block; font-size:14px; }
  .webchat-widget header small { display:block; opacity:.9; font-size:11px; margin-top:2px; }
  .webchat-min { border:0; background:rgba(255,255,255,.2); color:#fff; border-radius:8px; width:28px; height:28px; cursor:pointer; }
  .webchat-log { padding:12px; overflow:auto; display:grid; gap:8px; background:#f8fafc; min-height:160px; }
  .webchat-log .user,.webchat-log .assistant { max-width:85%; padding:8px 10px; border-radius:12px; font-size:13px; line-height:1.4; }
  .webchat-log .user { justify-self:end; background:#e0e7ff; color:#1e1b4b; }
  .webchat-log .assistant { justify-self:start; background:#fff; border:1px solid #e2e8f0; color:#0f172a; }
  .webchat-widget form { display:grid; grid-template-columns:1fr auto; gap:8px; padding:10px; border-top:1px solid #e2e8f0; }
  .webchat-widget form input { border:1px solid #e2e8f0; border-radius:10px; padding:10px; font-size:13px; }
  .webchat-widget form button { border:0; border-radius:10px; color:#fff; font-weight:700; padding:10px 12px; cursor:pointer; background:var(--centeros-primary,#4f46e5); }
  .webchat-launcher { border:0; border-radius:999px; color:#fff; font-weight:700; padding:12px 18px; cursor:pointer; box-shadow:0 8px 24px rgba(15,23,42,.2); }
  .webchat-error { color:#b91c1c; font-size:12px; padding:0 12px 8px; }
  @media (max-width:720px){ .alx-widget-builder { grid-template-columns:1fr; } }
  .alx-field { display:grid; gap:6px; color:#64748b; font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:.04em; }
  .alx-field input,.alx-field select,.alx-field textarea { border:1px solid #e2e8f0; border-radius:10px; background:#f8fafc; color:#0f172a; padding:10px 12px; font-size:13px; font-weight:500; text-transform:none; letter-spacing:0; min-height:40px; width:100%; box-sizing:border-box; }
  .alx-field textarea { min-height:72px; resize:vertical; line-height:1.45; }
  .alx-mono { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:12px!important; min-height:140px!important; }
  .alx-field small { color:#94a3b8; font-weight:500; text-transform:none; letter-spacing:0; }
  .alx-field-row { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
  .alx-checks,.alx-tools { display:grid; gap:8px; }
  .alx-checks label,.alx-tools label { display:flex; gap:8px; align-items:center; color:#334155; font-size:13px; font-weight:500; text-transform:none; letter-spacing:0; }
  .alx-side { position:sticky; top:12px; }
  .alx-studio-tabs { display:flex; gap:8px; margin:12px 0; border-bottom:1px solid #283143; }
  .alx-studio-tabs button { border:0; background:none; color:#8490a4; font-size:13px; font-weight:700;
    padding:10px 14px; border-bottom:2px solid transparent; cursor:pointer; }
  .alx-studio-tabs button.active { color:#e8eaf0; border-bottom-color:#6657e8; }
  /* The test room is the full page width: a transcript, a scenario script and a
     softphone each need room that the 300px settings sidebar never had. One
     tool is shown at a time, so the pane gets the whole width. */
  .alx-test-room { display:block; }
  .alx-test-tabs { display:flex; gap:6px; flex-wrap:wrap; margin-bottom:12px; }
  .alx-test-tabs button { border:1px solid #283143; background:#0d121a; color:#8490a4;
    border-radius:8px; padding:8px 12px; font-size:12px; font-weight:700; cursor:pointer; }
  .alx-test-tabs button.active { border-color:#6657e8; color:#e8eaf0; background:#161d2c; }
  .alx-test-pane { max-width:820px; }
  .alx-test-pane .alx-form-card { margin-bottom:12px; }
  .alx-test-room .alx-sim { max-height:none; }
  .alx-scenario textarea { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:12px;
    line-height:1.6; border-radius:8px; border:1px solid #283143; background:#0d121a; color:#e8eaf0;
    padding:10px; margin-bottom:8px; }
  .alx-scenario-result ul { margin:6px 0 0; padding-left:18px; font-size:13px; line-height:1.7; }
  .alx-scenario-result details { margin-top:8px; font-size:12px; }
  .alx-muted { color:#94a3b8; font-size:12px; margin:0; }
  .alx-sim { min-height:180px; max-height:280px; overflow:auto; background:#f8fafc; border-radius:10px; padding:10px; display:grid; gap:10px; }
  .alx-sim-message { max-width:min(88%,620px); border-radius:12px; padding:9px 11px; display:grid; gap:3px; }
  .alx-sim-message strong { font-size:11px; text-transform:uppercase; letter-spacing:.04em; }
  .alx-sim-message p { margin:0; font-size:13px; line-height:1.45; white-space:pre-wrap; }
  .alx-sim-message.user { justify-self:end; background:#e0e7ff; color:#312e81; }
  .alx-sim-message.assistant { justify-self:start; background:#fff; color:#0f172a; border:1px solid #e2e8f0; }
  .alx-sim-evidence { color:#475569; font-size:11px; }
  .alx-sim-form { display:grid; grid-template-columns:1fr auto; gap:8px; }
  .alx-sim-form input { border:1px solid #e2e8f0; border-radius:10px; padding:10px; font-size:13px; }
  .alx-sim-form button { border:0; border-radius:10px; background:#4f46e5; color:#fff; font-weight:700; padding:10px 12px; cursor:pointer; }
  .alx-modal-backdrop { position:fixed; inset:0; background:rgba(15,23,42,.45); display:grid; place-items:center; z-index:80; padding:20px; }
  .alx-modal { width:min(720px,100%); max-height:90vh; overflow:auto; background:#fff; border-radius:16px; box-shadow:0 24px 60px rgba(15,23,42,.25); }
  .alx-modal.alx-modal-wide { width:min(920px,100%); }
  .alx-provider-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; }
  .alx-provider-card { text-align:left; border:1px solid #e2e8f0; background:#f8fafc; border-radius:12px; padding:12px 14px; cursor:pointer; display:grid; gap:4px; }
  .alx-provider-card strong { color:#0f172a; font-size:13px; }
  .alx-provider-card span { color:#64748b; font-size:11px; line-height:1.4; }
  .alx-provider-card.selected { border-color:#4f46e5; background:#eef2ff; box-shadow:0 0 0 1px #4f46e5; }
  .alx-provider-card:disabled,.alx-provider-card.is-disabled { opacity:.55; cursor:not-allowed; }
  .alx-provider-card .alx-badge-soon { display:inline-block; font-size:10px; font-weight:700; color:#7c3aed; background:#ede9fe; border-radius:999px; padding:2px 8px; width:fit-content; }
  .alx-tool-grid { display:grid; gap:8px; }
  .alx-tool-row { display:flex; gap:10px; align-items:flex-start; border:1px solid #e2e8f0; border-radius:10px; padding:10px 12px; background:#f8fafc; }
  .alx-tool-row input { margin-top:3px; }
  .alx-tool-row b { display:block; color:#0f172a; font-size:13px; }
  .alx-tool-row span { color:#64748b; font-size:12px; line-height:1.35; }
  .alx-services-card h2 { margin-bottom:6px; }
  .alx-service-grid { display:grid; gap:8px; margin:8px 0 14px; }
  .alx-service-row { display:flex; gap:10px; align-items:flex-start; border:1px solid #e2e8f0; border-radius:12px; padding:11px 12px; background:#f8fafc; cursor:pointer; }
  .alx-service-row.on { border-color:#4f46e5; background:#eef2ff; box-shadow:inset 3px 0 #4f46e5; }
  .alx-service-row input { margin-top:3px; flex:0 0 auto; }
  .alx-service-row b { display:block; color:#0f172a; font-size:13px; }
  .alx-service-row span { display:block; color:#64748b; font-size:12px; line-height:1.4; margin-top:3px; }
  .alx-service-row code { font-size:11px; background:#e2e8f0; border-radius:4px; padding:1px 5px; color:#334155; }
  .alx-svc-badge { font-style:normal; font-size:10px; font-weight:700; color:#6366f1; background:#e0e7ff; border-radius:999px; padding:2px 7px; margin-left:6px; }
  .alx-selected-services { margin-top:8px; padding:10px 12px; border:1px dashed #cbd5e1; border-radius:12px; background:#fff; }
  .alx-selected-services small { color:#6366f1; font-size:9px; font-weight:800; letter-spacing:.1em; }
  .alx-selected-services ul { margin:8px 0 0; padding-left:18px; color:#334155; font-size:12px; }
  .alx-empty-services { display:grid; gap:10px; justify-items:start; }
  .alx-test-chips { display:flex; flex-wrap:wrap; gap:6px; margin:0 0 10px; }
  .alx-chip-btn { border:1px solid #c7d2fe; background:#eef2ff; color:#3730a3; border-radius:999px; padding:6px 10px; font-size:11px; font-weight:700; cursor:pointer; }
  .alx-chip-btn:disabled { opacity:.45; cursor:not-allowed; }
  .alx-provider-map .alx-provider-table { display:grid; gap:8px; margin:12px 0; }
  .alx-stack-summary { border:1px solid #c7d2fe; background:linear-gradient(160deg,#eef2ff 0%,#f8fafc 70%); border-radius:14px; padding:12px 14px; margin:10px 0 14px; }
  .alx-stack-summary>small { display:block; color:#4f46e5; font-size:9px; font-weight:800; letter-spacing:.12em; margin-bottom:8px; }
  .alx-stack-summary ul { list-style:none; margin:0; padding:0; display:grid; gap:7px; }
  .alx-stack-summary li { display:grid; grid-template-columns:72px minmax(0,1.2fr) minmax(0,.9fr); gap:8px; align-items:baseline; font-size:12px; }
  .alx-stack-summary li span { color:#64748b; font-weight:700; text-transform:uppercase; font-size:10px; letter-spacing:.04em; }
  .alx-stack-summary li b { color:#0f172a; font-size:12px; word-break:break-word; }
  .alx-stack-summary li em { font-style:normal; color:#64748b; font-size:11px; }
  .alx-provider-table-v2 .alx-provider-head { display:grid; grid-template-columns:120px minmax(0,1.3fr) minmax(160px,.9fr); gap:10px; padding:0 4px 4px; color:#94a3b8; font-size:10px; font-weight:800; letter-spacing:.08em; text-transform:uppercase; }
  .alx-provider-row { display:grid; grid-template-columns:120px minmax(0,1.3fr) minmax(160px,.9fr); gap:10px; align-items:start; border:1px solid #e2e8f0; border-radius:12px; padding:10px 12px; background:#f8fafc; }
  .alx-provider-row.alx-provider-row-pick { border-color:#c7d2fe; background:#f5f7ff; }
  .alx-provider-row strong { font-size:12px; color:#0f172a; }
  .alx-provider-row em { font-style:normal; font-size:11px; color:#64748b; line-height:1.4; display:block; margin-top:4px; }
  .alx-provider-now { display:flex; flex-wrap:wrap; gap:6px; align-items:center; }
  .alx-provider-chip { display:inline-flex; align-items:center; border-radius:999px; padding:4px 10px; font-size:11px; font-weight:800; white-space:nowrap; height:fit-content; }
  .alx-provider-chip.live { background:#dcfce7; color:#166534; border:1px solid #86efac; }
  .alx-provider-chip.pick { background:#e0e7ff; color:#3730a3; border:1px solid #a5b4fc; }
  .alx-provider-chip.muted { background:#f1f5f9; color:#64748b; border:1px solid #e2e8f0; }
  .alx-provider-chip.warn { background:#fff7ed; color:#9a3412; border:1px solid #fed7aa; }
  .alx-provider-row.is-secondary { opacity:.78; background:#f8fafc; border-color:#e2e8f0; }
  .alx-provider-row.is-secondary select:disabled { cursor:not-allowed; background:#f1f5f9; }
  .alx-field.is-pipeline-secondary { opacity:.78; }
  .alx-field.is-pipeline-secondary select:disabled { cursor:not-allowed; background:#f1f5f9; }
  .alx-runtime-cards { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; margin:10px 0 12px; }
  .alx-runtime-card { display:flex; gap:10px; align-items:flex-start; text-align:left; border:1px solid #e2e8f0; background:#f8fafc; border-radius:12px; padding:12px 14px; cursor:pointer; }
  .alx-runtime-card b { display:block; color:#0f172a; font-size:13px; }
  .alx-runtime-card em { display:block; font-style:normal; color:#64748b; font-size:11px; line-height:1.4; margin-top:2px; }
  .alx-runtime-card.selected { border-color:#4f46e5; background:#eef2ff; box-shadow:0 0 0 1px #4f46e5; }
  .alx-runtime-card input { margin-top:3px; }
  .alx-pilot-banner { border:1px solid #fed7aa; background:#fff7ed; color:#9a3412; border-radius:12px; padding:10px 12px; font-size:12px; line-height:1.45; margin:8px 0 12px; }
  .alx-pilot-banner code { font-size:11px; }
  .alx-provider-lock { display:inline-flex; align-items:center; border-radius:999px; padding:5px 10px; font-size:10px; font-weight:800; background:#f1f5f9; color:#64748b; border:1px solid #e2e8f0; height:fit-content; white-space:nowrap; }
  .alx-provider-lock.soft { background:#fff7ed; color:#9a3412; border-color:#fed7aa; }
  .alx-provider-pick { display:grid; gap:6px; min-width:0; }
  .alx-provider-pick small { color:#64748b; font-size:11px; line-height:1.35; }
  .alx-provider-pick .alx-chip-btn { justify-self:start; }
  .alx-number-provider-list { list-style:none; margin:0; padding:0; display:grid; gap:6px; }
  .alx-number-provider-list li { display:grid; grid-template-columns:88px minmax(0,1fr) auto; gap:8px; align-items:center; font-size:12px; padding:6px 8px; border-radius:8px; background:#fff; border:1px solid #e2e8f0; }
  .alx-number-provider-list b { color:#4f46e5; text-transform:uppercase; font-size:11px; }
  .alx-number-provider-list em { font-style:normal; color:#64748b; font-size:11px; }
  .alx-trunk-status { margin-top:10px; padding:10px 12px; border:1px dashed #cbd5e1; border-radius:12px; background:#fff; }
  .alx-trunk-status small { color:#6366f1; font-size:9px; font-weight:800; letter-spacing:.1em; }
  .alx-trunk-status ul { margin:8px 0; padding-left:18px; color:#334155; font-size:12px; }
  @media (max-width:900px) {
    .alx-provider-row,.alx-provider-table-v2 .alx-provider-head,.alx-stack-summary li,.alx-number-provider-list li { grid-template-columns:1fr; }
    .alx-provider-table-v2 .alx-provider-head { display:none; }
  }
  .alx-knowledge-mode { display:grid; gap:8px; margin:8px 0 12px; }
  .alx-knowledge-radios { display:grid; gap:8px; }
  .alx-knowledge-radios label { display:flex; gap:10px; align-items:flex-start; border:1px solid #e2e8f0; border-radius:12px; padding:10px 12px; background:#f8fafc; cursor:pointer; }
  .alx-knowledge-radios label:has(input:checked) { border-color:#4f46e5; background:#eef2ff; box-shadow:inset 3px 0 #4f46e5; }
  .alx-knowledge-radios input { margin-top:3px; }
  .alx-knowledge-radios b { display:block; color:#0f172a; font-size:13px; }
  .alx-knowledge-radios em { display:block; font-style:normal; color:#64748b; font-size:12px; margin-top:2px; line-height:1.35; }
  .alx-knowledge-brain-block { display:grid; gap:12px; }
  .alx-brain-empty { display:grid; gap:10px; padding:12px 14px; border:1px dashed #c7d2fe; border-radius:12px; background:#eef2ff; color:#334155; font-size:13px; line-height:1.45; }
  .alx-brain-empty p { margin:0; }
  .alx-brain-empty .alx-btn { justify-self:start; }
  .alx-char-counter { display:flex; justify-content:flex-end; font-size:11px; color:#64748b; margin-top:4px; }
  .alx-char-counter .warn { color:#b45309; font-weight:600; }
  .alx-char-counter .over { color:#b91c1c; font-weight:700; }
  .alx-test-retrieve { display:grid; gap:8px; padding:12px; border:1px solid #e2e8f0; border-radius:12px; background:#f8fafc; }
  .alx-test-retrieve-row { display:grid; grid-template-columns:minmax(0,1fr) auto; gap:8px; align-items:center; }
  .alx-test-retrieve-row input { border:1px solid #e2e8f0; border-radius:10px; padding:8px 10px; font-size:13px; background:#fff; }
  .alx-retrieve-hits { list-style:none; margin:0; padding:0; display:grid; gap:6px; }
  .alx-retrieve-hits li { display:flex; justify-content:space-between; gap:10px; padding:8px 10px; border-radius:8px; background:#fff; border:1px solid #e2e8f0; font-size:12px; }
  .alx-retrieve-hits b { color:#0f172a; font-weight:600; }
  .alx-retrieve-hits em { font-style:normal; color:#64748b; text-transform:uppercase; font-size:10px; letter-spacing:.04em; }
  .alx-knowledge-none-note { padding:10px 12px; border-radius:12px; background:#fff7ed; border:1px solid #fed7aa; }
  .alx-agent-count { color:#4f46e5; font-weight:700; }
  .alx-var-chips { display:flex; flex-wrap:wrap; gap:6px; }
  .alx-var-chips code { background:#f1f5f9; border:1px solid #e2e8f0; border-radius:8px; padding:4px 8px; font-size:11px; color:#334155; }
  .alx-range-row { display:grid; gap:6px; }
  .alx-range-row input[type=range] { width:100%; }
  .alx-tpl-search { width:100%; border:1px solid #e2e8f0; border-radius:10px; padding:10px 12px; font-size:13px; background:#f8fafc; box-sizing:border-box; }
  .alx-modal-foot { display:flex; justify-content:flex-end; gap:10px; padding:14px 20px; border-top:1px solid #e2e8f0; background:#fafbfc; position:sticky; bottom:0; }
  @media (max-width:820px) {
    .alx-provider-grid,.alx-runtime-cards { grid-template-columns:1fr; }
  }
  .alx-modal-head { display:flex; justify-content:space-between; gap:12px; padding:18px 20px; border-bottom:1px solid #e2e8f0; }
  .alx-modal-head h2 { margin:0; font-size:18px; color:#0f172a; }
  .alx-modal-head p { margin:4px 0 0; color:#64748b; font-size:13px; }
  .alx-modal-close { border:0; background:#f1f5f9; width:32px; height:32px; border-radius:8px; cursor:pointer; }
  .alx-modal-body { padding:18px 20px 22px; display:grid; gap:14px; }
  .alx-modal-section { margin:0; font-size:13px; color:#0f172a; }
  .alx-type-grid { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
  .alx-type-card { text-align:left; border:1px solid #e2e8f0; background:#f8fafc; border-radius:12px; padding:14px; cursor:pointer; display:grid; gap:6px; }
  .alx-type-card:hover { border-color:#4f46e5; background:#eef2ff; }
  .alx-type-card strong { color:#0f172a; font-size:14px; }
  .alx-type-card span { color:#64748b; font-size:12px; line-height:1.4; }
  .alx-modal-templates { display:grid; gap:8px; }
  .alx-modal-tpl { text-align:left; border:1px solid #e2e8f0; background:#fff; border-radius:10px; padding:12px; cursor:pointer; display:grid; gap:4px; }
  .alx-modal-tpl:hover { border-color:#a5b4fc; }
  .alx-modal-tpl b { color:#0f172a; font-size:13px; }
  .alx-modal-tpl span { color:#64748b; font-size:12px; }
  .alx-wizard-modal { width:min(820px,100%); }
  .alx-iv-progress { height:6px; background:#e2e8f0; border-radius:999px; overflow:hidden; margin:0 0 12px; }
  .alx-iv-progress span { display:block; height:100%; background:#4f46e5; }
  .alx-iv-log { display:grid; gap:10px; min-height:200px; max-height:340px; overflow:auto; padding:4px 2px 12px; }
  .alx-iv-msg { max-width:88%; padding:10px 12px; border-radius:12px; }
  .alx-iv-msg small { display:block; font-size:10px; font-weight:700; letter-spacing:.04em; text-transform:uppercase; margin:0 0 4px; opacity:.7; }
  .alx-iv-msg p { margin:0; font-size:13px; line-height:1.45; }
  .alx-iv-msg.assistant { background:#eef2ff; color:#1e1b4b; }
  .alx-iv-msg.user { background:#0f766e; color:#fff; justify-self:end; }
  .alx-iv-form { display:grid; grid-template-columns:1fr auto; gap:8px; margin-top:12px; }
  .alx-iv-form input { border:1px solid #e2e8f0; border-radius:10px; padding:10px 12px; font-size:13px; }
  .alx-asst { display:grid; gap:18px; padding:4px 0 28px; }
  .alx-asst-hero {
    display:flex; justify-content:space-between; gap:16px; align-items:flex-end; flex-wrap:wrap;
    border:1px solid #e2e8f0; border-radius:28px; padding:22px 24px;
    background:
      radial-gradient(circle at top left, rgba(79,70,229,.16), transparent 32%),
      radial-gradient(circle at 82% 18%, rgba(14,165,233,.12), transparent 24%),
      linear-gradient(135deg, #fff, #f8fafc);
    box-shadow:0 28px 70px rgba(15,23,42,.06);
  }
  .alx-asst-hero-main { display:flex; gap:16px; align-items:flex-start; min-width:0; }
  .alx-asst-mark {
    width:64px; height:64px; flex:none; border-radius:22px; display:grid; place-items:center;
    background:linear-gradient(145deg, rgba(79,70,229,.18), rgba(79,70,229,.06));
    color:#4f46e5; font-size:22px; border:1px solid rgba(79,70,229,.2);
  }
  .alx-asst-kicker { margin:0; font-size:11px; font-weight:700; letter-spacing:.28em; text-transform:uppercase; color:#64748b; }
  .alx-asst-hero h1 { margin:8px 0 0; font-size:34px; letter-spacing:-.06em; color:#0f172a; }
  .alx-asst-lead { margin:10px 0 0; max-width:40rem; color:#64748b; font-size:14px; line-height:1.7; }
  .alx-asst-card {
    overflow:hidden; border:1px solid #e2e8f0; border-radius:26px;
    background:
      radial-gradient(circle at top left, rgba(79,70,229,.1), transparent 34%),
      linear-gradient(180deg, #fff, #f8fafc);
    box-shadow:0 24px 70px rgba(15,23,42,.08);
    display:flex; flex-direction:column; min-height:min(72vh, 760px);
  }
  .alx-asst-card-head {
    display:flex; justify-content:space-between; gap:12px; flex-wrap:wrap;
    padding:16px 18px; border-bottom:1px solid #e2e8f0;
  }
  .alx-asst-identity { display:flex; gap:10px; align-items:center; }
  .alx-asst-spark {
    width:40px; height:40px; border-radius:16px; display:grid; place-items:center;
    background:rgba(79,70,229,.12); color:#4f46e5; border:1px solid rgba(79,70,229,.2);
  }
  .alx-asst-name { margin:0; font-size:14px; font-weight:700; color:#0f172a; }
  .alx-asst-workspace { margin:2px 0 0; font-size:11px; letter-spacing:.16em; text-transform:uppercase; color:#64748b; }
  .alx-asst-progress-meta { display:flex; gap:8px; align-items:center; color:#64748b; font-size:12px; flex-wrap:wrap; }
  .alx-asst-badge {
    display:inline-flex; border-radius:999px; padding:4px 10px; font-size:11px; font-weight:700;
    background:rgba(79,70,229,.1); color:#4f46e5;
  }
  .alx-asst-log { flex:1 1 auto; min-height:16rem; max-height:min(48vh, 28rem); overflow:auto; padding:16px 18px; display:grid; gap:10px; align-content:start; }
  .alx-asst-row { display:flex; }
  .alx-asst-row.user { justify-content:flex-end; }
  .alx-asst-row.assistant { justify-content:flex-start; }
  .alx-asst-bubble {
    max-width:85%; border-radius:18px; padding:12px 14px; font-size:14px; line-height:1.6;
  }
  .alx-asst-bubble.assistant { background:rgba(15,23,42,.06); color:#0f172a; }
  .alx-asst-bubble.user { background:rgba(79,70,229,.12); color:#0f172a; }
  .alx-asst-bubble.muted { color:#64748b; }
  .alx-asst-composer { border-top:1px solid #e2e8f0; padding:16px 18px 18px; display:grid; gap:12px; }
  .alx-asst-next, .alx-asst-ready {
    border:1px solid #e2e8f0; border-radius:18px; padding:12px 14px; background:rgba(255,255,255,.72);
  }
  .alx-asst-next.warn { border-color:rgba(245,158,11,.28); background:rgba(245,158,11,.08); color:#92400e; }
  .alx-asst-next-label { margin:0 0 4px; font-size:11px; font-weight:700; letter-spacing:.18em; text-transform:uppercase; color:#64748b; }
  .alx-asst-next p, .alx-asst-ready p { margin:0; font-size:14px; line-height:1.55; color:#0f172a; }
  .alx-asst-ready h3 { margin:4px 0 6px; font-size:18px; color:#0f172a; }
  .alx-asst-ready-meta { color:#64748b !important; font-size:13px !important; }
  .alx-asst-composer textarea {
    width:100%; min-height:5.5rem; resize:vertical; border:1px solid #e2e8f0; border-radius:18px;
    padding:12px 14px; font:inherit; font-size:14px; line-height:1.5; color:#0f172a; background:#fff;
  }
  .alx-asst-composer textarea:focus { outline:2px solid rgba(79,70,229,.28); border-color:#a5b4fc; }
  .alx-asst-actions { display:flex; flex-wrap:wrap; gap:8px; }
  @media (max-width:768px) {
    .alx-asst-hero { padding:18px; }
    .alx-asst-hero h1 { font-size:26px; }
    .alx-asst-card { min-height:auto; }
    .alx-asst-log { min-height:12rem; max-height:50vh; }
  }
  .agentos-shell[data-theme="dark"] .alx-asst-hero,
  .agentos-shell[data-theme="dark"] .alx-asst-card {
    background:
      radial-gradient(circle at top left, rgba(45,212,191,.12), transparent 32%),
      linear-gradient(180deg, #101820, #0c1218);
    border-color:#283143;
  }
  .agentos-shell[data-theme="dark"] .alx-asst-hero h1,
  .agentos-shell[data-theme="dark"] .alx-asst-name,
  .agentos-shell[data-theme="dark"] .alx-asst-bubble,
  .agentos-shell[data-theme="dark"] .alx-asst-next p,
  .agentos-shell[data-theme="dark"] .alx-asst-ready p,
  .agentos-shell[data-theme="dark"] .alx-asst-ready h3 { color:#e8eef7; }
  .agentos-shell[data-theme="dark"] .alx-asst-lead,
  .agentos-shell[data-theme="dark"] .alx-asst-kicker,
  .agentos-shell[data-theme="dark"] .alx-asst-workspace,
  .agentos-shell[data-theme="dark"] .alx-asst-progress-meta,
  .agentos-shell[data-theme="dark"] .alx-asst-next-label { color:#93a0b5; }
  .agentos-shell[data-theme="dark"] .alx-asst-bubble.assistant { background:#1a2433; }
  .agentos-shell[data-theme="dark"] .alx-asst-bubble.user { background:#134e4a; }
  .agentos-shell[data-theme="dark"] .alx-asst-composer,
  .agentos-shell[data-theme="dark"] .alx-asst-card-head { border-color:#283143; }
  .agentos-shell[data-theme="dark"] .alx-asst-composer textarea,
  .agentos-shell[data-theme="dark"] .alx-asst-next,
  .agentos-shell[data-theme="dark"] .alx-asst-ready {
    background:#0d121a; border-color:#283143; color:#e8eef7;
  }
  .alx-wizard-steps { display:flex; flex-wrap:wrap; gap:6px; padding:12px 16px; border-bottom:1px solid #e2e8f0; background:#f8fafc; }
  .alx-wizard-steps button { border:1px solid #e2e8f0; background:#fff; color:#64748b; border-radius:999px; padding:6px 10px; font-size:11px; font-weight:650; cursor:pointer; display:inline-flex; align-items:center; gap:6px; }
  .alx-wizard-steps button.active { background:#4f46e5; border-color:#4f46e5; color:#fff; }
  .alx-wizard-steps button.done { background:#eef2ff; border-color:#c7d2fe; color:#3730a3; }
  .alx-wizard-num { width:18px; height:18px; border-radius:999px; background:rgba(15,23,42,.08); display:grid; place-items:center; font-size:10px; font-weight:800; }
  .alx-wizard-steps button.active .alx-wizard-num { background:rgba(255,255,255,.25); }
  .alx-wizard-body { min-height:320px; }
  .alx-wizard-footer { display:flex; justify-content:space-between; gap:10px; padding:14px 20px; border-top:1px solid #e2e8f0; background:#fff; }
  .alx-type-card.selected,.alx-modal-tpl.selected { border-color:#4f46e5!important; background:#eef2ff!important; box-shadow:0 0 0 1px #4f46e5; }
  .alx-review { display:grid; gap:10px; margin:0; }
  .alx-review div { display:grid; grid-template-columns:120px 1fr; gap:8px; padding:10px; background:#f8fafc; border-radius:10px; border:1px solid #e2e8f0; }
  .alx-review dt { margin:0; color:#64748b; font-size:11px; font-weight:700; text-transform:uppercase; }
  .alx-review dd { margin:0; color:#0f172a; font-size:13px; line-height:1.4; }
  @media (max-width:960px) {
    .alx-edit-layout,.alx-type-grid,.alx-field-row { grid-template-columns:1fr; }
    .alx-stats { grid-template-columns:1fr; }
    .alx-search { margin-left:0; width:100%; flex:1 1 100%; }
  }
  @media (max-width:640px) {
    .alx-page { padding:14px 12px 80px; }
  }
  .studio-empty h2 { font-size:28px; margin:10px 0; }
  .studio-empty p { color:#8791a4; font-size:14px; line-height:1.55; }
  .studio-empty form { display:grid; grid-template-columns:1fr auto; gap:9px; margin-top:20px; }
  .directory-page .directory-list { margin-top:4px; max-height:520px; }.directory-meta { color:#aab3c3; font-size:12px; margin:0 0 8px; }.directory-meta b { color:#e8eaf0; }.directory-note { color:#b7c0cf; font-size:11px; line-height:1.5; margin:0 0 12px; padding:10px; background:#0c1218; border-left:2px solid #4ecbdb; }.directory-action-form { display:grid; gap:10px; margin-top:14px; padding-top:12px; border-top:1px solid #252c39; }.directory-section { color:#8b80f6; font-size:9px; font-weight:800; letter-spacing:.12em; }.directory-create-form,.directory-edit-form { display:grid; gap:10px; margin-top:4px; }.directory-edit-form { padding-bottom:4px; }.directory-form-actions { display:flex; gap:8px; }.directory-form-actions button { flex:1; }.directory-secondary-btn { background:#263044!important; color:#d7dceb!important; border:1px solid #354257!important; font-size:13px!important; font-weight:650!important; padding:10px 14px!important; cursor:pointer; border-radius:11px; min-height:42px; }
.directory-secondary-btn:hover { background:#2e3a52!important; }.directory-detail-grid { display:grid; grid-template-columns:1fr 1fr; gap:10px; margin:0 0 8px; }.directory-detail-grid>div { background:#0c1218; border:1px solid #243041; border-radius:10px; padding:10px 12px; }.directory-detail-grid dt { color:#738094; font-size:9px; text-transform:uppercase; letter-spacing:.08em; margin:0 0 4px; }.directory-detail-grid dd { margin:0; color:#e8eaf0; font-size:12px; line-height:1.45; word-break:break-word; }.directory-detail-span { grid-column:1/-1; }.directory-loading { color:#69cbd7; font-size:11px; margin:0 0 10px; }.directory-detail-card header b { color:#69cbd7!important; font-size:12px!important; }.directory-field-hint { display:block; margin-top:4px; color:#738094; font-size:10px; line-height:1.4; text-transform:none; letter-spacing:0; font-weight:400; }
  .campaigns-page .campaigns-note { color:#97a1b4; font-size:13px; margin:0 0 16px; line-height:1.5; max-width:720px; }
  .campaign-wizard-steps {
    display:flex; flex-wrap:wrap; gap:8px; margin:0 0 12px;
  }
  .campaign-wizard-step {
    display:inline-flex; align-items:center; gap:8px; border:1px solid #273142;
    background:#0d121a; color:#8490a4; border-radius:999px; padding:8px 12px;
    font-size:12px; font-weight:700; cursor:pointer; min-height:36px;
  }
  .campaign-wizard-step em {
    font-style:normal; width:20px; height:20px; border-radius:50%;
    display:grid; place-items:center; background:#1c2333; color:#a8b4cc; font-size:11px;
  }
  .campaign-wizard-step.active { border-color:#0d9488; color:#ecfdf5; background:#0f1c1a; }
  .campaign-wizard-step.active em { background:#0d9488; color:#fff; }
  .campaign-wizard-step.done { border-color:#14532d; color:#86efac; }
  .campaign-wizard-step.done em { background:#166534; color:#fff; }
  .campaign-wizard-hint {
    margin:0 0 12px; padding:10px 12px; border-radius:10px; font-size:12px; line-height:1.45;
    background:#0c1218; border:1px solid #273142; color:#97a1b4;
  }
  .campaign-wizard-hint b { color:#e8eaf0; }
  .campaign-advanced-toggle {
    width:100%; text-align:left; border:1px dashed #354257; background:#0c1218;
    color:#a8b4cc; border-radius:10px; padding:10px 12px; font-size:12px; font-weight:700;
    cursor:pointer; margin:4px 0 8px;
  }
  .campaign-advanced-block {
    display:grid; gap:10px; padding:12px; margin-bottom:8px;
    border:1px solid #273142; border-radius:12px; background:#0b1018;
  }
  .campaign-run-steps {
    display:flex; flex-wrap:wrap; gap:8px; margin:0 0 12px;
  }
  .campaign-run-steps span {
    font-size:11px; font-weight:700; letter-spacing:.04em; text-transform:uppercase;
    padding:6px 10px; border-radius:999px; border:1px solid #273142; color:#738094; background:#0d121a;
  }
  .campaign-run-steps span.done { border-color:#14532d; color:#86efac; background:#0c1a12; }
  .campaign-run-steps span.active { border-color:#0d9488; color:#5eead4; background:#0f1c1a; }
  .agentos-shell[data-theme="light"] .campaign-wizard-step {
    background:#fff; border-color:#d6d3d1; color:#57534e;
  }
  .agentos-shell[data-theme="light"] .campaign-wizard-step em { background:#f5f5f4; color:#57534e; }
  .agentos-shell[data-theme="light"] .campaign-wizard-hint {
    background:#fafaf9; border-color:#e7e5e4; color:#57534e;
  }
  .agentos-shell[data-theme="light"] .campaign-wizard-hint b { color:#0f172a; }
  .agentos-shell[data-theme="light"] .campaign-advanced-toggle {
    background:#fff; border-color:#d6d3d1; color:#57534e;
  }
  .agentos-shell[data-theme="light"] .campaign-advanced-block {
    background:#fafaf9; border-color:#e7e5e4;
  }
  .agentos-shell[data-theme="light"] .campaign-run-steps span {
    background:#fff; border-color:#d6d3d1; color:#78716c;
  }
  .studio-inline-empty {
    display:grid; gap:8px; align-content:start; justify-items:start;
    padding:16px 14px; margin:4px 0 8px;
    border:1px dashed #2d3748; border-radius:12px; background:#0c1218;
  }
  .studio-inline-empty.compact { padding:12px 10px; margin:0; }
  .studio-inline-empty strong { color:#e8eaf0; font-size:13px; font-weight:700; }
  .studio-inline-empty p { margin:0; color:#8490a4; font-size:12px; line-height:1.5; max-width:36rem; }
  .studio-inline-empty .agentos-btn,
  .studio-inline-empty .directory-secondary-btn { margin-top:4px; }
  .studio-inline-empty-actions { display:flex; flex-wrap:wrap; gap:8px; margin-top:4px; }
  .campaigns-page .call-list.directory-list { gap:6px; }
  .campaigns-page .call-list.directory-list>button { padding:10px 11px; }
  .directory-page .call-list.directory-list { gap:6px; }
  .directory-page .call-list.directory-list>button { padding:10px 11px; }
  .numbers-studio .numbers-list { gap:6px; }
  .numbers-studio .numbers-row { padding:10px 12px; }
  .campaign-contacts-panel { margin-top:18px; padding-top:14px; border-top:1px solid #252c39; display:grid; gap:10px; }
  .campaign-contact-actions { display:grid; grid-template-columns:1fr auto; gap:8px; align-items:end; }
  .campaign-contact-actions label { min-width:0; }
  .campaign-contact-list { max-height:280px; }
  .campaign-contact-row { display:flex; justify-content:space-between; align-items:center; gap:8px; padding:12px; border:1px solid #273142; border-radius:11px; background:#0d121a; }
  .campaign-contact-row span { display:grid; gap:3px; }
  .campaign-contact-row strong { font-size:13px; color:#e8eaf0; }
  .campaign-contact-row small { color:#8490a4; font-size:12px; }
  .campaign-day-chips { display:flex; flex-wrap:wrap; gap:6px; }
  .campaign-day-chips .directory-secondary-btn.active { border-color:#6657e8!important; background:#2a2f55!important; color:#fff!important; }
  .leads-page .leads-note { color:#8490a4; font-size:11px; margin:0 0 14px; line-height:1.45; }
  .leads-toolbar-actions { display:flex; flex-wrap:wrap; gap:8px; align-items:center; }
  .leads-view-toggle { display:inline-flex; border:1px solid #273142; border-radius:10px; overflow:hidden; }
  .leads-view-toggle button { background:#0d121a; border:0; color:#aab3c3; padding:6px 12px; font-size:11px; }
  .leads-view-toggle button.active { background:#2a2f55; color:#fff; }
  .leads-filter { display:flex; gap:6px; align-items:center; color:#8490a4; font-size:11px; }
  .leads-filter select { background:#0d121a; border:1px solid #273142; color:#e8eaf0; border-radius:8px; padding:4px 8px; }
  .leads-bulk-bar { display:flex; flex-wrap:wrap; gap:10px; align-items:center; margin:0 0 12px; padding:10px 12px; border:1px solid #3d4f8a; border-radius:12px; background:#12182a; color:#c5ceff; font-size:12px; }
  .leads-bulk-bar select { background:#0d121a; border:1px solid #273142; color:#e8eaf0; border-radius:8px; padding:4px 8px; }
  .leads-bulk-bar button.ghost { background:transparent; border:1px solid #273142; color:#aab3c3; }
  .leads-board { display:grid; grid-template-columns:repeat(auto-fill,minmax(180px,1fr)); gap:10px; margin-bottom:14px; overflow-x:auto; }
  .leads-column { background:#0c1218; border:1px solid #243041; border-radius:12px; min-height:160px; display:flex; flex-direction:column; }
  .leads-column header { display:flex; justify-content:space-between; align-items:center; padding:8px 10px; border-bottom:1px solid #243041; }
  .leads-column header strong { font-size:11px; color:#e8eaf0; }
  .leads-column header em { font-style:normal; font-size:10px; color:#738094; background:#151c28; border-radius:999px; padding:2px 8px; }
  .leads-column-body { display:grid; gap:6px; padding:8px; max-height:480px; overflow:auto; }
  .leads-card { display:grid; gap:5px; text-align:left; background:#0d121a; border:1px solid #273142; border-radius:10px; padding:8px 9px; color:#e8eaf0; cursor:pointer; }
  .leads-card.active { border-color:#6657e8; box-shadow:inset 3px 0 #6657e8; }
  .leads-card-top { display:flex; gap:8px; align-items:flex-start; }
  .leads-card-top strong { font-size:12px; line-height:1.3; }
  .leads-card small { color:#8490a4; font-size:10px; }
  .leads-card select { width:100%; background:#101825; border:1px solid #273142; color:#e8eaf0; border-radius:8px; padding:4px 6px; font-size:11px; }
  .leads-detail-dock { margin-top:8px; }
  .leads-list { display:grid; gap:7px; max-height:520px; overflow:auto; } .leads-list button { display:flex; justify-content:space-between; align-items:center; text-align:left; background:#0d121a; border:1px solid #273142; } .leads-list button.active { border-color:#6657e8; box-shadow:inset 3px 0 #6657e8; } .leads-list button span { display:grid; gap:3px; } .leads-list button strong { font-size:11px; color:#e8eaf0; } .leads-list button small { color:#738094; letter-spacing:0; } .leads-list button em { font-style:normal; font-size:9px; text-transform:uppercase; } .score-hot { color:#ff9d6a!important; } .score-warm { color:#f0c674!important; } .score-cold { color:#8aa0b8!important; } .lead-card-detail { display:grid; gap:10px; } .lead-metrics { display:grid; grid-template-columns:1fr 1fr; gap:8px; } .lead-metrics span { display:grid; gap:3px; background:#0c1218; border:1px solid #243041; border-radius:10px; padding:9px 10px; color:#758095; font-size:8px; text-transform:uppercase; } .lead-metrics b { color:#e8eaf0; font-size:12px; text-transform:none; letter-spacing:0; } .lead-metrics select { background:#101825; border:1px solid #273142; color:#e8eaf0; border-radius:8px; padding:4px 6px; font-size:12px; text-transform:none; } .lead-line { margin:0; color:#aab3c3; font-size:11px; } .lead-line b { color:#e8eaf0; } .lead-next-action { padding:12px; background:#101825; border-left:2px solid #f0c674; border-radius:0 10px 10px 0; } .lead-next-action>small { color:#f0c674; font-size:9px; font-weight:800; letter-spacing:.12em; } .lead-next-action p { margin:6px 0 0; color:#b9c1cf; font-size:11px; line-height:1.5; } .lead-tags { color:#738094; font-size:10px; } .lead-actions { display:flex; gap:8px; } .lead-call-id { font-size:9px; color:#69cbd7; overflow-wrap:anywhere; } .voice-lead-panel { margin:12px 0; padding:12px; border:1px solid #3d4f8a; border-radius:12px; background:#12182a; display:grid; gap:10px; } .voice-lead-panel>small { color:#c5ceff; font-size:9px; font-weight:800; letter-spacing:.12em; }
  .numbers-help { color:#8b97ab; font-size:13px; line-height:1.5; margin:0 0 14px; }
  .numbers-byo-form { display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:16px; }
  .numbers-byo-form label:last-of-type, .numbers-byo-form button { grid-column:1/-1; }
  .numbers-list { display:grid; gap:8px; }
  .numbers-list.muted { opacity:.75; margin-top:8px; }
  .numbers-row { display:flex; justify-content:space-between; gap:12px; align-items:flex-start; border:1px solid #273142; background:#0d121a; border-radius:12px; padding:12px 14px; }
  .numbers-row strong { display:block; font-size:14px; }
  .numbers-row small { display:block; color:#8490a4; margin-top:3px; font-size:12px; }
  .numbers-row-actions { display:flex; flex-direction:column; align-items:flex-end; gap:8px; }
  .numbers-empty { color:#8490a4; font-size:13px; }
  .numbers-legend { margin:0; padding-left:18px; color:#c3cad6; line-height:1.55; font-size:13px; }
  .numbers-legend li { margin-bottom:10px; }
  .numbers-legend b { color:#e8eef8; }
  .numbers-header-actions { display:flex; gap:8px; flex-wrap:wrap; }
  .numbers-tabs {
    display:inline-flex; flex-wrap:wrap; gap:0; margin:0 0 14px;
    border:1px solid #273142; border-radius:12px; overflow:hidden; background:#0d121a;
  }
  .numbers-tabs button {
    border:0; background:transparent; color:#8490a4; padding:10px 16px;
    font-size:13px; font-weight:700; cursor:pointer; min-height:42px;
  }
  .numbers-tabs button.active { background:#0d9488; color:#fff; }
  .numbers-tab-panel { margin-top:4px; }
  .numbers-unbound-banner {
    display:flex; justify-content:space-between; align-items:center; gap:14px; flex-wrap:wrap;
    margin:0 0 14px; padding:14px 16px; border-radius:14px;
    border:1px solid #991b1b; background:linear-gradient(90deg,#2a1212,#1a0c0c);
  }
  .numbers-unbound-banner strong { display:block; color:#fecaca; font-size:14px; margin-bottom:4px; }
  .numbers-unbound-banner p { margin:0; color:#fca5a5; font-size:12px; line-height:1.45; max-width:40rem; }
  .numbers-row-warn { border-color:#a16207 !important; box-shadow:inset 3px 0 #f59e0b; }
  .status-warn { color:#fbbf24 !important; font-style:normal; font-size:11px; font-weight:700; }
  .agentos-shell[data-theme="light"] .numbers-tabs {
    background:#fff; border-color:#d6d3d1;
  }
  .agentos-shell[data-theme="light"] .numbers-tabs button { color:#57534e; }
  .agentos-shell[data-theme="light"] .numbers-unbound-banner {
    background:#fef2f2; border-color:#fecaca;
  }
  .agentos-shell[data-theme="light"] .numbers-unbound-banner strong { color:#991b1b; }
  .agentos-shell[data-theme="light"] .numbers-unbound-banner p { color:#b91c1c; }
  .numbers-provider-badges { display:flex; flex-wrap:wrap; gap:6px; margin:8px 0 12px; }
  .provider-chip { display:inline-block; border-radius:100px; padding:2px 8px; font-size:10px; font-weight:800; text-transform:uppercase; border:1px solid #3d4f8a; background:#1a2240; color:#c5ceff; }
  .provider-chip.provider-verimor { border-color:#2f6b45; background:#13261b; color:#86d795; }
  .provider-chip.provider-zadarma { border-color:#3d4f8a; background:#1a2240; color:#9ec5ff; }
  .provider-chip.provider-byo_sip,.provider-chip.provider-manual { border-color:#5a4a2a; background:#2a2212; color:#f0c674; }
  .numbers-tier { display:inline-block; margin-left:6px; border-radius:100px; padding:1px 8px; font-size:10px; font-weight:800; vertical-align:middle; letter-spacing:.02em; }
  .numbers-tier-production { border:1px solid #2f6b45; background:#13261b; color:#86d795; }
  .numbers-tier-demo { border:1px solid #5a4a2a; background:#2a2212; color:#f0c674; }
  .numbers-tier-byo { border:1px solid #3d4f8a; background:#1a2240; color:#9ec5ff; }
  .numbers-tier-internal { border:1px solid #3d3d4a; background:#1a1a22; color:#a0a0b0; }
  .numbers-tier-hint { color:#8b97ab !important; font-size:11px !important; margin-top:6px !important; }
  .numbers-tier-hint-warn { color:#f0c674 !important; }
  .live-ops-page { padding:28px 34px 40px; }
  .live-ops-toolbar { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
  .live-ops-scope-bar { display:flex; flex-wrap:wrap; gap:10px; align-items:center; margin:0 0 12px; }
  .live-ops-ws-chips { display:flex; flex-wrap:wrap; gap:6px; }
  .live-ops-ws-chips button { border:1px solid #30394a; background:#0d121a; color:#c3cad6; border-radius:100px; padding:4px 10px; font-size:11px; cursor:pointer; }
  .live-ops-ws-chips button.active { border-color:#5b6cff; background:#1a2240; color:#c5ceff; }
  .live-ws-chip { display:inline-block; margin-right:6px; border-radius:100px; padding:1px 7px; font-size:10px; font-weight:700; border:1px solid #3d4f8a; background:#1a2240; color:#9ec5ff; }
  .live-ops-note { color:#8490a4; font-size:13px; margin:0 0 14px; }
  .live-ops-note b,.live-ops-note code { color:#c5ceff; }
  .live-ops-kpi-grid { display:grid; grid-template-columns:repeat(6,minmax(0,1fr)); gap:10px; margin-bottom:14px; }
  .live-ops-kpi-primary { margin-bottom:12px; }
  .live-ops-stale-alert { border:1px solid #8a4040; background:#1a1010; color:#ffb4b4; border-radius:10px; padding:10px 12px; }
  .live-ops-kpi-latency { grid-template-columns:repeat(6,minmax(0,1fr)); margin:10px 0 8px; }
  .live-ops-quality-card { grid-column: span 1; }
  .live-ops-channel-split { display:grid; grid-template-columns:1fr 1fr; gap:10px; margin:10px 0 8px; }
  .live-ops-channel-card { border:1px solid #283143; border-radius:12px; background:#0c1218; padding:10px 12px; }
  .live-ops-channel-card.is-empty { opacity:.85; border-style:dashed; }
  .live-ops-channel-card-head { display:flex; justify-content:space-between; align-items:baseline; gap:8px; margin-bottom:8px; }
  .live-ops-channel-card-head b { color:#e8eaf0; font-size:12px; }
  .live-ops-channel-card-head small { color:#8490a4; font-size:10px; }
  .live-ops-channel-kpis { display:grid; grid-template-columns:1fr 1fr; gap:6px 10px; font-size:11px; color:#8490a4; }
  .live-ops-channel-kpis strong { color:#e8eaf0; font-size:13px; margin-left:4px; }
  .live-ops-empty-quality { margin:8px 0 0; color:#8490a4; font-size:12px; line-height:1.45; }
  .live-ops-trend7d { margin-top:12px; padding-top:10px; border-top:1px solid #283143; }
  .live-ops-trend7d-head { display:flex; justify-content:space-between; align-items:baseline; margin-bottom:8px; }
  .live-ops-trend7d-head small { color:#8b80f6; font-size:9px; font-weight:800; letter-spacing:.1em; }
  .live-ops-trend7d-head span { color:#8490a4; font-size:11px; }
  .live-ops-trend7d-bars { display:grid; grid-template-columns:repeat(7,minmax(0,1fr)); gap:6px; align-items:end; height:96px; }
  .live-ops-trend7d-col { display:flex; flex-direction:column; justify-content:flex-end; align-items:center; height:100%; gap:4px; }
  .live-ops-trend7d-col i { display:block; width:100%; max-width:28px; border-radius:6px 6px 2px 2px; background:linear-gradient(180deg,#5b6cff 0%,#2f6b45 100%); min-height:4px; }
  .live-ops-trend7d-col i.empty { background:#1a2240; opacity:.6; }
  .live-ops-trend7d-col span { color:#5c687c; font-size:9px; }
  .live-ops-grid { display:grid; grid-template-columns:1.2fr 1fr 1fr; gap:14px; }
  .live-call-list { display:grid; gap:8px; max-height:480px; overflow:auto; }
  .live-call-row { display:flex; flex-direction:column; gap:8px; background:#0d121a; border:1px solid #273142; border-radius:10px; padding:10px; }
  .live-call-main { width:100%; display:flex; justify-content:space-between; gap:10px; text-align:left; background:transparent; border:0; padding:4px 6px; cursor:pointer; }
  .live-call-row strong { display:block; color:#e8eaf0; font-size:12px; }
  .live-call-row small { display:block; color:#8490a4; margin-top:3px; font-size:11px; }
  .live-call-row em { color:#69cbd7; font-style:normal; font-size:10px; white-space:nowrap; display:grid; gap:4px; justify-items:end; }
  .live-call-open-hint { color:#9ec5ff; font-weight:700; }
  .live-call-actions { display:flex; align-items:center; gap:8px; flex-wrap:wrap; width:100%; padding:0 4px 2px; }
  .live-hangup-btn { border:1px solid #c44; background:#e11d48; color:#fff; border-radius:8px; padding:10px 14px; font-size:12px; font-weight:800; cursor:pointer; white-space:nowrap; min-height:40px; flex:1 1 auto; }
  .live-hangup-btn:disabled { opacity:.55; cursor:not-allowed; }
  .live-hangup-btn:not(:disabled):hover { background:#be123c; }
  .live-handoff-btn { border:1px solid #3d4f8a; background:#1a2240; color:#c5ceff; border-radius:8px; padding:10px 12px; font-size:12px; font-weight:700; cursor:pointer; white-space:nowrap; min-height:40px; flex:1 1 auto; }
  .live-handoff-btn:disabled { opacity:.55; cursor:not-allowed; }
  .live-handoff-btn:not(:disabled):hover { background:#243056; }
  .live-call-row.status-active { border-color:#f0c674; }
  .live-call-row.status-waiting_for_human,.live-call-row.handoff-pending { border-color:#ff9d9d; }
  .live-ops-handoff-bar { display:flex; flex-wrap:wrap; align-items:flex-end; gap:12px; margin:0 0 14px; padding:10px 12px; border:1px solid #3a2a2a; border-radius:12px; background:#141018; }
  .live-ops-dest-field { display:grid; gap:4px; color:#8490a4; font-size:10px; text-transform:uppercase; min-width:180px; }
  .live-ops-dest-field input { border:1px solid #30394a; border-radius:8px; background:#090d14; color:#e8eaf0; padding:8px 10px; font-size:12px; font-family:ui-monospace,monospace; }
  .live-ops-handoff-help { color:#8490a4; font-size:11px; max-width:360px; line-height:1.4; }
  .live-ops-handoff-help code { color:#c5ceff; }
  .live-handoff-chip { display:inline-block; margin-top:5px; border-radius:100px; padding:2px 8px; font-size:10px; font-weight:700; border:1px solid #8a4040; background:#2a1414; color:#ffb4b4; }
  .voice-handoff-banner { display:flex; flex-wrap:wrap; gap:10px; align-items:center; justify-content:space-between; margin:0 0 12px; padding:10px 12px; border:1px solid #8a4040; border-radius:10px; background:#1a1010; color:#ffb4b4; font-size:12px; font-weight:700; }
  .voice-handoff-banner small { font-weight:500; color:#c9a0a0; }
  .voice-active-actions { display:flex; gap:8px; margin:0 0 12px; }
  .voice-hangup-banner-btn { border:1px solid #fff; background:#e11d48; color:#fff; border-radius:8px; padding:8px 14px; font-size:12px; font-weight:800; cursor:pointer; white-space:nowrap; min-height:36px; }
  .voice-hangup-banner-btn:disabled { opacity:.55; cursor:not-allowed; }
  .voice-hangup-banner-btn:not(:disabled):hover { background:#be123c; }
  .live-trust-row { display:block; width:100%; border:1px solid #283143; border-radius:10px; background:#0d121a; padding:10px 12px; margin-bottom:8px; text-align:left; color:inherit; }
  .live-trust-row.is-clickable { cursor:pointer; }
  .live-trust-row.is-clickable:hover { border-color:#4a5d8a; }
  .live-trust-row strong { color:#ff9d9d; font-size:11px; text-transform:uppercase; }
  .live-trust-row p { margin:4px 0; color:#c3cad6; font-size:12px; }
  .live-trust-row small { color:#8490a4; font-size:10px; }
  .studio-alert.success { border-color:#2f6b45; background:#13261b; color:#86d795; }
  @media (max-width:1100px) {
    .live-ops-grid { grid-template-columns:1fr; }
    .live-ops-kpi-grid { grid-template-columns:repeat(3,minmax(0,1fr)); }
    .live-ops-kpi-latency { grid-template-columns:repeat(3,minmax(0,1fr)); }
    .live-ops-channel-split { grid-template-columns:1fr; }
  }

  .numbers-byo-form textarea { border:1px solid #30394a; border-radius:8px; background:#090d14; color:#e8eaf0; padding:9px 10px; font-size:12px; font-family:ui-monospace,monospace; width:100%; }

  .voice-profile-grid { display:grid; grid-template-columns:1fr 1fr; gap:9px; }.voice-toggle-row { display:flex; gap:18px; padding:4px 0; }.voice-toggle-row label,.voice-consent { display:flex!important; grid-auto-flow:column; justify-content:start; align-items:center; gap:7px!important; }.voice-toggle-row input,.voice-consent input { width:auto; }
  .voice-browser-demo { margin:0 0 14px; display:grid; gap:12px; border-color:#3d4f8a; background:linear-gradient(145deg,#12182a 0%,#0d121a 60%); }
  .voice-demo-copy { margin:0; color:#8490a4; font-size:12px; line-height:1.5; max-width:720px; }
  .voice-demo-agent-pick { display:grid; gap:5px; color:#8490a4; font-size:10px; text-transform:uppercase; max-width:420px; }
  .voice-demo-agent-pick select { width:100%; border:1px solid #30394a; border-radius:10px; background:#090d14; color:#e8eaf0; padding:10px 12px; font-size:13px; }
  .browser-demo-softphone { display:grid; gap:12px; }
  .browser-demo-softphone.compact { gap:10px; }
  .bds-header { display:flex; justify-content:space-between; align-items:flex-start; gap:10px; flex-wrap:wrap; }
  .bds-header small { color:#69cbd7; font-size:9px; font-weight:800; letter-spacing:.14em; display:block; }
  .bds-header h3 { margin:6px 0 0; font-size:16px; color:#e8eaf0; }
  .bds-phase { font-style:normal; border-radius:100px; padding:5px 10px; font-size:9px; font-weight:800; text-transform:uppercase; letter-spacing:.06em; border:1px solid #3d4f8a; color:#c5ceff; background:#1a2240; }
  .bds-phase.phase-listening { border-color:#e05a5a; color:#ffb4b4; background:#2a1616; }
  .bds-phase.phase-thinking,.bds-phase.phase-speaking { border-color:#4ecbdb; color:#4ecbdb; background:#102028; }
  .bds-phase.phase-active { border-color:#2f6b45; color:#86d795; background:#13261b; }
  .bds-copy,.bds-warn,.bds-tip { margin:0; color:#8490a4; font-size:12px; line-height:1.45; }
  .bds-warn { color:#f0c674; }
  .bds-tip { color:#8b97ab; background:#12182a; border:1px solid #2a3550; border-radius:10px; padding:8px 10px; }
  .bds-tip code { font-size:11px; color:#69cbd7; }
  .bds-mode-toggle { display:inline-flex; gap:0; border:1px solid #3d4f8a; border-radius:11px; overflow:hidden; width:fit-content; }
  .bds-mode-btn { border:0; background:#12182a; color:#8490a4; padding:8px 12px; font-size:11px; font-weight:800; cursor:pointer; }
  .bds-mode-btn + .bds-mode-btn { border-left:1px solid #3d4f8a; }
  .bds-mode-btn.active { background:#1a2240; color:#c5ceff; }
  .bds-mode-btn:disabled { opacity:.55; cursor:not-allowed; }
  .bds-controls { display:grid; gap:10px; }
  .bds-consent { display:flex!important; align-items:center; gap:8px; color:#aab3c3; font-size:12px; text-transform:none; }
  .bds-consent input { width:auto; }
  .bds-actions { display:flex; flex-wrap:wrap; gap:8px; align-items:center; }
  .bds-actions-live { width:100%; justify-content:space-between; }
  .bds-actions-live .bds-btn.hangup { margin-left:auto; font-weight:800; min-height:40px; padding:0 16px; }
  .bds-btn { border:0; border-radius:11px; padding:11px 14px; font-size:12px; font-weight:800; cursor:pointer; }
  .bds-btn:disabled { opacity:.45; cursor:not-allowed; }
  .bds-btn.primary { background:#6657e8; color:#fff; }
  .bds-btn.ghost { background:#1a2240; color:#c5ceff; border:1px solid #3d4f8a; }
  .bds-btn.ptt { background:#1f6f78; color:#e8fbff; min-width:140px; user-select:none; touch-action:none; }
  .bds-btn.ptt.hot { background:#c43c3c; color:#fff; box-shadow:0 0 0 3px rgba(196,60,60,.25); }
  .bds-live-pill { border-radius:100px; padding:10px 14px; font-size:12px; font-weight:800; border:1px solid #2f6b45; background:#13261b; color:#86d795; min-width:180px; text-align:center; }
  .bds-live-pill.open { border-color:#2f6b45; color:#86d795; background:#13261b; box-shadow:0 0 0 3px rgba(47,107,69,.18); }
  .bds-live-pill.hot { border-color:#e05a5a; color:#ffb4b4; background:#2a1616; box-shadow:0 0 0 3px rgba(196,60,60,.22); animation:bds-pulse 1.2s ease-in-out infinite; }
  .bds-live-pill.speaking { border-color:#4ecbdb; color:#4ecbdb; background:#102028; }
  .bds-live-pill.busy { border-color:#3d4f8a; color:#c5ceff; background:#1a2240; }
  @keyframes bds-pulse { 0%,100% { box-shadow:0 0 0 3px rgba(196,60,60,.15); } 50% { box-shadow:0 0 0 6px rgba(196,60,60,.28); } }
  .bds-btn.hangup { background:#2a1616; color:#ffb4b4; border:1px solid #7a3a3a; }
  .bds-phase.phase-error { border-color:#7a3a3a; color:#ffb4b4; background:#2a1616; }
  .bds-hint { color:#69cbd7; font-size:12px; }
  .bds-error { color:#ff9d9d; font-size:12px; background:#2a1616; border:1px solid #7a3a3a; border-radius:10px; padding:8px 10px; }
  .bds-turns { display:grid; gap:8px; max-height:220px; overflow:auto; }
  .bds-turns>small { color:#8b80f6; font-size:9px; font-weight:800; letter-spacing:.12em; }
  .bds-turn { background:#0c1218; border:1px solid #283143; border-radius:10px; padding:8px 10px; }
  .bds-turn p { margin:0 0 4px; color:#b9c1cf; font-size:11px; line-height:1.4; }
  .bds-turn strong { color:#e8eaf0; }
  .bds-meter { display:grid; gap:6px; padding:10px 12px; border-radius:12px; border:1px solid #283143; background:#0c1218; }
  .bds-meter.live { border-color:#3d4f8a; }
  .bds-meter.quality-good { border-color:#2f6b45; }
  .bds-meter.quality-weak,.bds-meter.quality-silent { border-color:#7a5a2a; }
  .bds-meter.quality-clipping,.bds-meter.quality-loud { border-color:#7a3a3a; }
  .bds-meter-head { display:flex; align-items:center; gap:8px; flex-wrap:wrap; color:#8490a4; font-size:10px; text-transform:uppercase; letter-spacing:.08em; }
  .bds-meter-head strong { color:#e8eaf0; font-size:12px; text-transform:none; letter-spacing:0; }
  .bds-meter-head em { margin-left:auto; font-style:normal; color:#69cbd7; font-weight:800; font-size:12px; }
  .bds-meter-track { position:relative; height:12px; border-radius:100px; background:#090d14; border:1px solid #243041; overflow:hidden; }
  .bds-meter-fill { height:100%; border-radius:100px; background:linear-gradient(90deg,#2f6b45 0%,#86d795 45%,#f0c674 75%,#e05a5a 100%); transition:width .05s linear; }
  .bds-meter-peak { position:absolute; top:0; bottom:0; width:2px; background:#fff; opacity:.85; transform:translateX(-1px); }
  .bds-meter-scale { display:flex; justify-content:space-between; color:#5c687c; font-size:9px; }
  .bds-meter-err,.bds-meter-warn { color:#f0c674; font-size:11px; }
  .bds-meter-idle { color:#5c687c; font-size:11px; }
  .alx-demo-card { border-color:#3d4f8a!important; background:linear-gradient(160deg,#12182a 0%,#0f141c 70%)!important; }
  .alx-publish-path {
    display:flex; flex-wrap:wrap; gap:8px; margin:0 0 14px; padding:0 2px;
  }
  .alx-publish-path span {
    display:inline-flex; align-items:center; gap:8px; border:1px solid #d6d3d1;
    background:#fff; color:#57534e; border-radius:999px; padding:7px 12px;
    font-size:12px; font-weight:700;
  }
  .alx-publish-path span em {
    font-style:normal; width:20px; height:20px; border-radius:50%;
    display:grid; place-items:center; background:#f5f5f4; font-size:11px;
  }
  .alx-publish-path span.active { border-color:#0d9488; color:#0f766e; background:#f0fdfa; }
  .alx-publish-path span.active em { background:#0d9488; color:#fff; }
  .alx-publish-path span.done { border-color:#14532d; color:#166534; background:#ecfdf5; }
  .alx-publish-path span.done em { background:#166534; color:#fff; }
  .alx-list-path { margin:12px 0 0; }
  /* FAZ3 sticky publish strip */
  .alx-studio-sticky {
    position:sticky; top:0; z-index:40; margin:0 0 14px;
    background:rgba(250,248,245,.92); backdrop-filter:blur(10px);
    border:1px solid #e7e5e4; border-radius:14px;
    box-shadow:0 8px 24px rgba(28,25,23,.06);
  }
  .alx-studio-sticky-inner {
    display:flex; flex-wrap:wrap; align-items:center; gap:10px 12px;
    padding:10px 12px;
  }
  .alx-publish-path-sticky { margin:0; flex:1 1 220px; }
  .alx-studio-sticky-actions {
    display:flex; flex-wrap:wrap; gap:8px; margin-left:auto;
  }
  .alx-studio-sticky-actions .alx-btn { min-height:36px; padding:8px 12px; font-size:12px; }
  .alx-live-chip {
    display:inline-flex; align-items:center; gap:6px;
    border-radius:999px; padding:6px 12px; font-size:12px; font-weight:800;
    border:1px solid transparent; white-space:nowrap;
  }
  .alx-live-chip.on {
    background:#ecfdf5; color:#166534; border-color:#86efac;
  }
  .alx-live-chip.on::before { content:""; width:8px; height:8px; border-radius:50%; background:#16a34a; box-shadow:0 0 0 3px rgba(22,163,74,.2); }
  .alx-live-chip.stale {
    background:#fff7ed; color:#c2410c; border-color:#fdba74;
  }
  .alx-live-chip.stale::before { content:""; width:8px; height:8px; border-radius:50%; background:#ea580c; }
  .alx-live-chip.off {
    background:#f5f5f4; color:#78716c; border-color:#d6d3d1;
  }
  .alx-live-chip.off::before { content:""; width:8px; height:8px; border-radius:50%; background:#a8a29e; }
  .alx-test-anchor { scroll-margin-top:88px; display:grid; gap:14px; }
  .alx-card-foot .alx-live-chip { font-size:11px; padding:4px 10px; }
  @media (max-width:900px) {
    .alx-hero-actions-desktop { display:none; }
    .alx-studio-sticky-inner { flex-direction:column; align-items:stretch; }
    .alx-studio-sticky-actions { margin-left:0; }
    .alx-studio-sticky-actions .alx-btn { flex:1 1 auto; }
  }
  .agentos-shell[data-theme="dark"] .alx-studio-sticky {
    background:rgba(12,18,24,.92); border-color:#283143;
    box-shadow:0 8px 24px rgba(0,0,0,.35);
  }
  .agentos-shell[data-theme="dark"] .alx-publish-path span {
    background:#0d121a; border-color:#273142; color:#a8b4cc;
  }
  .agentos-shell[data-theme="dark"] .alx-publish-path span em { background:#1a2240; color:#c5ceff; }
  .agentos-shell[data-theme="dark"] .alx-publish-path span.active {
    border-color:#0d9488; color:#5eead4; background:#042f2e;
  }
  .agentos-shell[data-theme="dark"] .alx-publish-path span.done {
    border-color:#166534; color:#86efac; background:#052e16;
  }
  .alx-advanced-toggle {
    width:100%; text-align:left; border:1px dashed #c4b5a0; background:#faf8f5;
    color:#57534e; border-radius:12px; padding:12px 14px; font-size:13px; font-weight:700;
    cursor:pointer; margin:0 0 14px;
  }
  .alx-card-cta {
    margin-top:10px; font-size:12px; font-weight:700; color:#0f766e;
  }
  .alx-pill.draft { background:#fff7ed; color:#c2410c; border:1px solid #fdba74; }
  .voice-quick-filters {
    display:flex; flex-wrap:wrap; gap:8px; margin:0 0 10px;
  }
  .voice-quick-filters button {
    border:1px solid #273142; background:#0d121a; color:#8490a4; border-radius:999px;
    padding:7px 12px; font-size:12px; font-weight:700; cursor:pointer; min-height:34px;
  }
  .voice-quick-filters button.active { background:#0d9488; border-color:#0d9488; color:#fff; }
  .voice-advanced-filters-toggle,
  .voice-test-tools-toggle {
    width:100%; text-align:left; border:1px dashed #354257; background:#0c1218;
    color:#a8b4cc; border-radius:10px; padding:10px 12px; font-size:12px; font-weight:700;
    cursor:pointer; margin:0 0 12px;
  }
  .voice-card-tabs {
    display:flex; flex-wrap:wrap; gap:0; margin:12px 0 14px;
    border:1px solid #273142; border-radius:12px; overflow:hidden; background:#0d121a;
  }
  .voice-card-tabs button {
    border:0; background:transparent; color:#8490a4; padding:10px 14px;
    font-size:12px; font-weight:700; cursor:pointer; min-height:40px;
  }
  .voice-card-tabs button.active { background:#0d9488; color:#fff; }
  .agentos-shell[data-theme="light"] .voice-quick-filters button {
    background:#fff; border-color:#d6d3d1; color:#57534e;
  }
  .agentos-shell[data-theme="light"] .voice-card-tabs {
    background:#fff; border-color:#d6d3d1;
  }
  .agentos-shell[data-theme="light"] .voice-card-tabs button { color:#57534e; }
  .agentos-shell[data-theme="light"] .voice-advanced-filters-toggle,
  .agentos-shell[data-theme="light"] .voice-test-tools-toggle {
    background:#fff; border-color:#d6d3d1; color:#57534e;
  }
  .voice-studio { padding:28px 34px 40px; }.voice-toolbar { display:flex; align-items:end; justify-content:space-between; margin-bottom:18px; gap:12px; flex-wrap:wrap; }.voice-toolbar span { color:#4ecbdb; font-size:9px; font-weight:800; letter-spacing:.14em; }.voice-toolbar h2 { margin:6px 0 0; font-size:28px; }.voice-toolbar-actions { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }.voice-toolbar-actions>b { color:#8490a4; border:1px solid #2d3748; background:#111720; border-radius:100px; padding:8px 12px; font-size:9px; }.voice-density-toggle { display:inline-flex; border:1px solid #2d3748; border-radius:100px; overflow:hidden; background:#111720; }.voice-density-toggle button { border:0; background:transparent; color:#8490a4; padding:7px 12px; font-size:10px; font-weight:700; cursor:pointer; }.voice-density-toggle button.active { background:#6657e8; color:#fff; }.voice-layout { display:grid; grid-template-columns:minmax(280px,.75fr) minmax(0,1.4fr); gap:14px; align-items:start; }.voice-call-create form { grid-template-columns:1fr 1fr; }.voice-call-create form label:first-child,.voice-call-create form .voice-consent,.voice-call-create form button { grid-column:1/-1; }.call-list-filters { margin-top:14px; display:grid; gap:8px; padding:12px; border:1px solid #283143; border-radius:12px; background:#0c1218; }.call-list-filters>small { color:#8b80f6; font-size:9px; font-weight:800; letter-spacing:.12em; }.call-list-filter-grid { display:grid; grid-template-columns:1fr 1fr; gap:8px; }.call-list-filter-grid label { display:grid; gap:4px; color:#8490a4; font-size:9px; text-transform:uppercase; }.call-list-filter-grid select { width:100%; border:1px solid #30394a; border-radius:8px; background:#090d14; color:#e8eaf0; padding:7px 8px; font-size:11px; }.call-list { display:grid; gap:7px; margin-top:12px; max-height:360px; overflow:auto; }.call-list.density-compact { gap:4px; max-height:420px; }.call-list.density-compact button { padding:8px 10px; }.call-list.density-compact button small:last-child { display:none; }.call-list button { display:flex; justify-content:space-between; align-items:center; text-align:left; background:#0d121a; border:1px solid #273142; }.call-list button.active { border-color:#6657e8; box-shadow:inset 3px 0 #6657e8; }.call-list button span { display:grid; gap:3px; }.call-list button strong { text-transform:uppercase; font-size:9px; }.call-list button small { color:#737f92; letter-spacing:0; }.call-list button em { color:#63cbd8; font-style:normal; font-size:8px; text-transform:uppercase; }.call-list button em.status-completed { color:#86d795; }.call-list button em.status-failed { color:#ff9d9d; }.call-list button em.status-active,.call-list button em.status-ringing { color:#f0c674; }.call-list-more { margin-top:10px; width:100%; border:1px solid #3d4f8a; background:#1a2240; color:#c5ceff; border-radius:10px; padding:9px; font-size:11px; font-weight:700; cursor:pointer; }.voice-analysis-chips { display:flex; flex-wrap:wrap; gap:6px; }.voice-analysis-chips .chip { border-radius:100px; padding:3px 9px; font-size:10px; font-weight:700; background:#1a2240; color:#c5ceff; border:1px solid #3d4f8a; }.voice-analysis-chips .chip.outcome-converted,.voice-analysis-chips .chip.outcome-qualified { border-color:#2f6b45; background:#13261b; color:#86d795; }.voice-analysis-chips .chip.outcome-abandoned,.voice-analysis-chips .chip.sentiment-negative { border-color:#7a3a3a; background:#2a1616; color:#ff9d9d; }.voice-analysis-chips .chip.sentiment-positive { border-color:#2f6b45; background:#13261b; color:#86d795; }.voice-analysis-meta { color:#738094; font-size:10px; }.voice-lead-panel { margin:12px 0; padding:12px; border:1px solid #283143; border-radius:12px; background:#0c1218; display:grid; gap:10px; }.voice-lead-panel-header { display:flex; justify-content:space-between; align-items:center; gap:8px; flex-wrap:wrap; }.voice-lead-panel-header>small { color:#8b80f6; font-size:9px; font-weight:800; letter-spacing:.1em; }.voice-recording-ladder { display:flex; flex-wrap:wrap; gap:6px; list-style:none; margin:0; padding:0; }.voice-recording-ladder li { border-radius:100px; padding:3px 8px; font-size:9px; text-transform:uppercase; border:1px solid #2d3748; color:#738094; }.voice-recording-ladder li.done { border-color:#3d4f8a; color:#aab3c3; }.voice-recording-ladder li.current { border-color:#4ecbdb; color:#4ecbdb; background:#102028; font-weight:800; }.voice-recording-actions,.voice-recording-empty { display:flex; flex-wrap:wrap; gap:8px; align-items:center; }
  .performance-page { padding:28px 34px 40px; }
  .performance-toolbar-actions { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
  .performance-agent-filter { display:grid; gap:4px; color:#8490a4; font-size:9px; text-transform:uppercase; }
  .performance-agent-filter select { border:1px solid #30394a; border-radius:8px; background:#090d14; color:#e8eaf0; padding:7px 10px; font-size:11px; min-width:140px; }
  .performance-note { color:#8490a4; font-size:13px; margin:0 0 16px; }
  .performance-note b { color:#c5ceff; }
  .integrations-page { padding:28px 34px 40px; }
  .integrations-note { color:#8490a4; font-size:13px; margin:0 0 14px; }
  .integrations-tabs { display:flex; flex-wrap:wrap; gap:8px; margin-bottom:14px; }
  .integrations-tabs button { border:1px solid #2d3748; background:#111720; color:#8490a4; border-radius:100px; padding:7px 12px; font-size:11px; font-weight:700; cursor:pointer; }
  .integrations-tabs button.active { background:#6657e8; border-color:#6657e8; color:#fff; }
  .integrations-form { display:grid; gap:10px; }
  .integrations-form label { display:grid; gap:4px; color:#8490a4; font-size:10px; text-transform:uppercase; }
  .integrations-form input,.integrations-form select { border:1px solid #30394a; border-radius:8px; background:#090d14; color:#e8eaf0; padding:9px 10px; font-size:12px; }
  .integrations-scopes { border:1px solid #283143; border-radius:10px; padding:10px; display:grid; gap:6px; }
  .integrations-scopes legend { color:#8b80f6; font-size:9px; font-weight:800; }
  .integrations-row { display:flex; justify-content:space-between; gap:10px; align-items:center; border:1px solid #283143; border-radius:10px; background:#0d121a; padding:10px 12px; margin-bottom:8px; }
  .integrations-row strong { display:block; color:#e8eaf0; font-size:12px; }
  .integrations-row small { display:block; color:#8490a4; font-size:11px; margin-top:3px; overflow-wrap:anywhere; }
  .integrations-secret-once code { display:block; margin:8px 0; padding:10px; background:#0a0f16; border-radius:8px; color:#86d795; overflow-wrap:anywhere; }
  .integrations-docs code { color:#69cbd7; }
  .integrations-docs ul { color:#c3cad6; line-height:1.55; }
  .studio-alert.success { border:1px solid #2f6b45; background:#13261b; color:#86d795; padding:12px; border-radius:10px; margin-bottom:12px; }

  .performance-kpi-grid { display:grid; grid-template-columns:repeat(6,minmax(0,1fr)); gap:10px; margin-bottom:16px; }
  .performance-kpi { background:#0d121a; border:1px solid #283143; border-radius:12px; padding:12px; display:grid; gap:6px; }
  .performance-kpi small { color:#758095; font-size:9px; text-transform:uppercase; letter-spacing:.08em; }
  .performance-kpi b { color:#e8eaf0; font-size:20px; }
  .performance-kpi.tone-ok b { color:#86d795; }
  .performance-kpi.tone-bad b { color:#ff9d9d; }
  .performance-kpi.tone-warn b { color:#f0c674; }
  .performance-charts { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
  .bar-chart { display:grid; gap:8px; }
  .bar-chart-row { display:grid; grid-template-columns:88px 1fr auto; gap:8px; align-items:center; }
  .bar-chart-label { color:#aab3c3; font-size:11px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .bar-chart-track { height:10px; background:#121821; border:1px solid #243041; border-radius:100px; overflow:hidden; }
  .bar-chart-track i { display:block; height:100%; background:linear-gradient(90deg,#6657e8,#4ecbdb); border-radius:100px; min-width:0; }
  .bar-chart-track i.tone-converted,.bar-chart-track i.tone-qualified,.bar-chart-track i.sent-positive { background:linear-gradient(90deg,#2f6b45,#86d795); }
  .bar-chart-track i.tone-abandoned,.bar-chart-track i.sent-negative { background:linear-gradient(90deg,#7a3a3a,#ff9d9d); }
  .bar-chart-track i.sent-neutral,.bar-chart-track i.tone-unknown { background:linear-gradient(90deg,#3d4a5c,#8490a4); }
  .bar-chart-value { color:#e8eaf0; font-size:11px; font-weight:700; min-width:72px; text-align:right; }
  .bar-chart-value small { color:#8490a4; font-weight:500; margin-left:4px; }

  /* Billing cost charts \u2014 column plot + empty (not 30 zero rows) */
  .cost-charts .cost-card { min-height:280px; display:flex; flex-direction:column; }
  .cost-empty { flex:1; display:grid; place-content:center; justify-items:center; gap:8px; text-align:center; padding:28px 16px; border:1px dashed #2a3548; border-radius:14px; background:linear-gradient(180deg,#0c1119 0%,#0a0e15 100%); }
  .cost-empty-icon { width:44px; height:44px; border-radius:12px; display:grid; place-items:center; background:#141b28; border:1px solid #2c3a52; color:#6b7c99; font-size:18px; }
  .cost-empty strong { color:#e8eaf0; font-size:14px; font-weight:700; }
  .cost-empty p { margin:0; max-width:34ch; color:#8490a4; font-size:12px; line-height:1.5; }
  .cost-col-chart { display:grid; gap:10px; flex:1; }
  .cost-col-plot { display:flex; align-items:flex-end; gap:4px; min-height:168px; height:168px; padding:8px 4px 0; border-bottom:1px solid #243041; }
  .cost-col { flex:1 1 0; min-width:0; display:grid; grid-template-rows:1fr auto auto; justify-items:center; gap:4px; height:100%; }
  .cost-col-bar-wrap { width:100%; height:100%; display:flex; align-items:flex-end; justify-content:center; }
  .cost-col-bar { width:min(100%,18px); border-radius:6px 6px 2px 2px; background:linear-gradient(180deg,#7b6cf0 0%,#4ecbdb 100%); box-shadow:0 0 0 1px rgba(102,87,232,.25); transition:height .2s ease, opacity .15s ease; }
  .cost-col.is-idle .cost-col-bar { width:min(100%,10px); background:#1c2433; box-shadow:none; opacity:.55; }
  .cost-col.is-active:hover .cost-col-bar { filter:brightness(1.12); }
  .cost-col-label { color:#738094; font-size:9px; font-variant-numeric:tabular-nums; line-height:1; }
  .cost-col-label.is-spacer { opacity:0; }
  .cost-col-value { color:#c5cce0; font-size:9px; font-weight:700; font-variant-numeric:tabular-nums; max-width:100%; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .cost-col-chart.is-dense .cost-col-bar { width:min(100%,8px); border-radius:4px 4px 1px 1px; }
  .cost-col-chart.is-dense .cost-col-plot { gap:2px; }
  .cost-col-legend { display:flex; justify-content:space-between; gap:10px; flex-wrap:wrap; color:#6f7b90; font-size:10px; }
  .cost-col-legend b { color:#c5cce0; font-weight:700; }
  .cost-service-list { display:grid; gap:12px; }
  .cost-service-row { display:grid; gap:5px; }
  .cost-service-head { display:flex; justify-content:space-between; gap:10px; align-items:baseline; }
  .cost-service-head strong { color:#e8eaf0; font-size:12px; font-weight:650; }
  .cost-service-head span { color:#86d795; font-size:12px; font-weight:700; font-variant-numeric:tabular-nums; }
  .cost-service-track { height:8px; background:#121821; border:1px solid #243041; border-radius:100px; overflow:hidden; }
  .cost-service-track i { display:block; height:100%; border-radius:100px; background:linear-gradient(90deg,#6657e8,#4ecbdb); }
  .cost-service-meta { color:#6f7b90; font-size:10px; letter-spacing:0; text-transform:none; }
  .agentos-shell[data-theme="light"] .cost-empty { background:linear-gradient(180deg,#f7f8fb,#eef1f6); border-color:#d0d7e4; }
  .agentos-shell[data-theme="light"] .cost-empty strong { color:#152033; }
  .agentos-shell[data-theme="light"] .cost-empty p { color:#5b667a; }
  .agentos-shell[data-theme="light"] .cost-col-plot { border-bottom-color:#d0d7e4; }
  .agentos-shell[data-theme="light"] .cost-col.is-idle .cost-col-bar { background:#d9e0ec; }
  .agentos-shell[data-theme="light"] .cost-service-track { background:#eef1f6; border-color:#d0d7e4; }
  .agentos-shell[data-theme="light"] .cost-service-head strong { color:#152033; }
  .voice-ops-cost { margin:12px 0; padding:12px 14px; border:1px solid #3d2f1a; border-radius:12px; background:linear-gradient(135deg,#1a150c,#121820); display:grid; gap:8px; }
  .voice-ops-cost>small { color:#f0c674; font-size:9px; font-weight:800; letter-spacing:.12em; }
  .voice-ops-cost-head { display:flex; flex-wrap:wrap; gap:8px 14px; align-items:baseline; }
  .voice-ops-cost-head strong { color:#f5e6b8; font-size:18px; }
  .voice-ops-cost-head span { color:#aab3c3; font-size:11px; }
  .voice-ops-cost-stack { display:flex; flex-wrap:wrap; gap:8px; }
  .voice-ops-cost-stack span { background:#0a0f16; border:1px solid #2a3548; border-radius:8px; padding:6px 9px; color:#8490a4; font-size:10px; }
  .voice-ops-cost-stack b { color:#e8eaf0; font-weight:700; margin-left:4px; }
  .voice-ops-cost-meters { list-style:none; margin:0; padding:0; display:grid; gap:6px; }
  .voice-ops-cost-meters li { display:grid; grid-template-columns:1fr auto auto; gap:10px; align-items:center; padding:6px 8px; border-radius:8px; background:#0a0f16; border:1px solid #243041; color:#aab3c3; font-size:11px; }
  .voice-ops-cost-meters em { font-style:normal; color:#69cbd7; font-variant-numeric:tabular-nums; }
  .voice-ops-cost-meters b { color:#86d795; font-variant-numeric:tabular-nums; }
  .voice-ops-cost-note { margin:0; color:#738094; font-size:10px; line-height:1.4; }

.voice-metrics { display:grid; grid-template-columns:repeat(3,1fr); gap:8px; }.voice-metrics span { display:grid; gap:4px; background:#0d121a; border:1px solid #283143; border-radius:10px; padding:10px; color:#758095; font-size:8px; text-transform:uppercase; }.voice-metrics b { color:#e8eaf0; font-size:12px; }.voice-call-id { display:block; margin-top:4px; font-size:9px; color:#69cbd7; overflow-wrap:anywhere; }.voice-context-panel { margin:12px 0; padding:12px; border:1px solid #283143; border-radius:12px; background:#0c1218; display:grid; gap:10px; }.voice-context-panel>small { color:#8b80f6; font-size:9px; font-weight:800; letter-spacing:.12em; }.voice-context-grid { display:grid; grid-template-columns:1fr 1fr; gap:8px; }.voice-context-grid span { display:grid; gap:3px; color:#758095; font-size:8px; text-transform:uppercase; background:#0a0f16; border:1px solid #243041; border-radius:10px; padding:9px 10px; }.voice-context-grid b { color:#e8eaf0; font-size:12px; text-transform:none; letter-spacing:0; font-weight:700; }.voice-link-chip { justify-self:start; border:1px solid #3d4f8a; background:#1a2240; color:#c5ceff; border-radius:100px; padding:4px 10px; font-size:11px; font-weight:700; cursor:pointer; }.voice-link-chip:hover { border-color:#6657e8; }.voice-purpose-note { display:grid; gap:6px; }.voice-purpose-note>small { color:#4ecbdb; font-size:9px; font-weight:800; letter-spacing:.1em; }.voice-purpose-note pre { margin:0; white-space:pre-wrap; word-break:break-word; background:#0a0f16; border:1px solid #243041; border-radius:10px; padding:10px 12px; color:#b9c1cf; font-size:11px; line-height:1.5; max-height:160px; overflow:auto; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }.voice-intel-stack { display:grid; gap:10px; margin:12px 0; }.voice-recording-panel { margin:12px 0; padding:12px; border:1px solid #283143; border-radius:12px; background:#0c1218; display:grid; gap:8px; }.voice-recording-panel>small { color:#4ecbdb; font-size:9px; font-weight:800; letter-spacing:.12em; }.voice-recording-meta { margin:0; color:#aab3c3; font-size:11px; }.voice-recording-meta b { color:#e8eaf0; }.voice-recording-key { display:block; font-size:9px; color:#69cbd7; overflow-wrap:anywhere; background:#0a0f16; border:1px solid #243041; border-radius:8px; padding:8px; }.voice-recording-player { display:grid; gap:8px; }.voice-recording-player audio { width:100%; }.voice-recording-player a { color:#8cd4dd; font-size:11px; font-weight:700; }.voice-follow-ups { margin:4px 0 12px; display:grid; gap:8px; }.voice-follow-ups>small { color:#4ecbdb; font-size:9px; font-weight:800; letter-spacing:.12em; }.voice-follow-up { border:1px solid #283143; border-radius:10px; background:#0d121a; padding:10px 12px; display:grid; gap:4px; }.voice-follow-up strong { font-size:11px; color:#e8eaf0; }.voice-follow-up em { font-style:normal; color:#69cbd7; font-size:9px; text-transform:uppercase; margin-left:6px; }.voice-follow-up p { margin:0; color:#b7c0cf; font-size:11px; }.voice-analysis { margin:0; padding:12px; background:#101825; border-left:2px solid #8b80f6; display:grid; gap:6px; border-radius:0 10px 10px 0; }.voice-analysis p { margin:0; color:#b9c1cf; font-size:11px; line-height:1.5; }.voice-transcript-panel { margin:4px 0 12px; display:grid; gap:6px; }.voice-transcript-panel>small { color:#4ecbdb; font-size:9px; font-weight:800; letter-spacing:.12em; }.voice-transcript { min-height:220px; max-height:420px; overflow:auto; display:grid; align-content:start; gap:9px; padding:10px 0; }.voice-transcript>div { max-width:86%; padding:10px 12px; border-radius:12px; background:#1b2230; }.voice-transcript>div.user { justify-self:end; background:#433b9c; }.voice-turn-meta { display:flex; justify-content:space-between; gap:10px; align-items:baseline; }.voice-turn-meta strong { color:#8cd4dd; font-size:8px; text-transform:uppercase; }.voice-turn-meta time { color:#9aa3b5; font-size:9px; }.voice-transcript p { font-size:11px; line-height:1.55; margin:5px 0 0; }.voice-transcript>small { color:#69cbd7; letter-spacing:0; }.voice-runtime-card>form { grid-template-columns:1fr auto auto; align-items:center; }.voice-actions { display:flex; gap:8px; }.voice-actions button { flex:1; background:#263044; }.voice-actions button:last-child { background:#3b4770; }.voice-summary { margin:0; padding:12px; background:#0c1218; border-left:2px solid #4ecbdb; border-radius:0 10px 10px 0; }.voice-summary>small { color:#4ecbdb; font-size:9px; font-weight:800; letter-spacing:.12em; }.voice-summary p { color:#b9c1cf; font-size:11px; line-height:1.55; margin:6px 0 0; }.voice-tool-timeline { margin:4px 0 12px; display:grid; gap:8px; }.voice-tool-timeline>small { color:#8b80f6; font-size:9px; font-weight:800; letter-spacing:.12em; }.voice-tool-empty { color:#738094; font-size:11px; margin:0; }.voice-tool-item { border:1px solid #283143; border-radius:10px; background:#0d121a; padding:10px 12px; display:grid; gap:4px; }.voice-tool-item>div { display:flex; justify-content:space-between; gap:8px; }.voice-tool-item strong { font-size:10px; color:#d7dbef; }.voice-tool-item em { font-style:normal; font-size:9px; text-transform:uppercase; color:#69cbd7; }.voice-tool-item.status-failed em,.voice-tool-item.status-denied em { color:#ff9d9d; }.voice-tool-item p { margin:0; color:#b7c0cf; font-size:11px; line-height:1.45; }.voice-tool-item small { color:#738094; letter-spacing:0; }.voice-runtime-card>header b.status-completed { color:#86d795; }.voice-runtime-card>header b.status-failed { color:#ff9d9d; }.voice-runtime-card>header b.status-active,.voice-runtime-card>header b.status-ringing { color:#f0c674; }
  .webchat-widget { width:min(380px,100%); min-height:520px; display:grid; grid-template-rows:auto 1fr auto auto; background:#0d1119; border:1px solid #293143; border-radius:18px; overflow:hidden; color:#f2f4f8; font-family:Inter,system-ui,sans-serif; }.webchat-widget>header { padding:16px 18px; display:grid; gap:3px; background:linear-gradient(135deg,#6254dc,#347d8a); }.webchat-widget>header small { font-size:9px; opacity:.75; }.webchat-log { padding:14px; display:grid; align-content:start; gap:9px; overflow:auto; }.webchat-log div { max-width:84%; padding:9px 11px; border-radius:12px; font-size:11px; line-height:1.5; }.webchat-log p { margin:0; }.webchat-log .user { justify-self:end; background:#6657e8; }.webchat-log .assistant { background:#1b2230; }.webchat-widget form { display:grid; grid-template-columns:1fr auto; gap:8px; padding:12px; border-top:1px solid #252c39; }.webchat-widget input { min-width:0; border:1px solid #30394a; border-radius:10px; background:#090d14; color:#fff; padding:10px; }.webchat-widget button { border:0; border-radius:10px; background:#6657e8; color:#fff; font-weight:800; }.webchat-error { color:#ff9d9d; padding:8px 12px; font-size:10px; }
  @media (max-width:1200px) {
    .agentos-quick-grid { grid-template-columns:repeat(2,minmax(0,1fr)); }
  }
  @media (max-width:1000px) {
    .brain-workbench,.studio-grid,.voice-layout,.directory-layout,.performance-charts { grid-template-columns:1fr; }
    .performance-kpi-grid { grid-template-columns:repeat(3,minmax(0,1fr)); }
    .brain-stats { grid-template-columns:repeat(2,1fr); }
    .agentos-panels { grid-template-columns:1fr; }
  }
  @media (max-width:900px) {
    .agentos-shell { grid-template-columns:72px 1fr; }
    .agentos-brand div,.agentos-workspace div { display:none; }
    .agentos-nav-section-label { display:none; }
    .agentos-nav-section + .agentos-nav-section { margin-top:4px; padding-top:4px; }
    .agentos-sidebar nav button { justify-content:center; padding:9px; font-size:0; gap:0; }
    .agentos-sidebar nav button span { font-size:16px; width:auto; }
    .agentos-hero-card { display:none; }
  }
  @media (max-width:720px) {
    .agentos-shell { grid-template-columns:1fr; }
    .agentos-sidebar { display:none; }
    .agentos-mobile-nav { display:grid; }
    .agentos-main { padding-bottom:64px; }
    .agentos-topbar { padding:12px 16px; }
    .agentos-status { display:none; }
    .agentos-hero,.agentos-quick,.agentos-panels { margin-left:14px; margin-right:14px; }
    .agentos-hero { padding:20px; flex-direction:column; align-items:stretch; }
    .agentos-hero h2 { font-size:24px; }
    .agentos-quick-grid { grid-template-columns:1fr; }
    .studio-page,.voice-studio,.brain-page,.performance-page { padding:18px 14px 80px; }
    .performance-kpi-grid { grid-template-columns:repeat(2,minmax(0,1fr)); }
    .studio-toolbar h2 { font-size:22px; }
    .voice-metrics,.lead-metrics,.directory-detail-grid,.voice-context-grid { grid-template-columns:1fr; }
    .campaign-contact-actions { grid-template-columns:1fr; }
  }

  /* \u2014\u2014 Light mode (data-theme=light) \u2014\u2014 */
  .agentos-shell[data-theme="light"] {
    color-scheme: light;
    --agentos-surface:#ffffff;
    --agentos-border:#d6d3d1;
    --agentos-muted:#57534e;
    --agentos-text:#0f172a;
    background:#f4f1ea;
    color:var(--agentos-text);
  }
  .agentos-shell[data-theme="light"].is-embedded { border-color:#d6d3d1; }
  .agentos-shell[data-theme="light"] .agentos-sidebar {
    background:linear-gradient(180deg,#fff 0%,#f5f5f4 100%);
    border-right:1px solid #d6d3d1;
  }
  .agentos-shell[data-theme="light"] .agentos-brand small,
  .agentos-shell[data-theme="light"] .agentos-workspace small,
  .agentos-shell[data-theme="light"] .agentos-nav-section-label { color:#78716c; }
  .agentos-shell[data-theme="light"] .agentos-nav-section + .agentos-nav-section { border-top-color:#e7e5e4; }
  .agentos-shell[data-theme="light"] .agentos-sidebar nav button { color:#57534e; }
  .agentos-shell[data-theme="light"] .agentos-sidebar nav button span { color:#a8a29e; }
  .agentos-shell[data-theme="light"] .agentos-sidebar nav button:hover { background:#f5f5f4; color:#0f172a; }
  .agentos-shell[data-theme="light"] .agentos-sidebar nav button.active {
    color:#0f172a;
    background:linear-gradient(90deg,color-mix(in srgb,var(--agentos-primary) 18%,#fff),#f0fdfa);
    box-shadow:inset 2px 0 var(--agentos-primary);
  }
  .agentos-shell[data-theme="light"] .agentos-sidebar nav button.active span { color:#0f766e; }
  .agentos-shell[data-theme="light"] .agentos-workspace { border-top-color:#e7e5e4; }
  .agentos-shell[data-theme="light"] .agentos-avatar { background:#ccfbf1; color:#0f766e; }
  .agentos-shell[data-theme="light"] .agentos-main {
    background:radial-gradient(circle at 82% 0%,rgba(13,148,136,.08),transparent 32%),#f4f1ea;
  }
  .agentos-shell[data-theme="light"] .agentos-topbar {
    background:rgba(255,255,255,.92); border-bottom-color:#e7e5e4;
  }
  .agentos-shell[data-theme="light"] .agentos-topbar small { color:#78716c; }
  .agentos-shell[data-theme="light"] .agentos-topbar h1 { color:#0f172a; }
  .agentos-shell[data-theme="light"] .agentos-theme-toggle {
    border-color:#d6d3d1; background:#fff;
  }
  .agentos-shell[data-theme="light"] .agentos-theme-toggle button { color:#57534e; }
  .agentos-shell[data-theme="light"] .agentos-status-v2 {
    border-color:#99f6e4; color:#0f766e; background:#ecfdf5;
  }
  .agentos-shell[data-theme="light"] .agentos-ops-banner {
    border-bottom-color:#d97706;
  }
  .agentos-shell[data-theme="light"] .agentos-hero-v2 {
    background:#fff; border-color:#0d9488; color:#0f172a;
    box-shadow:0 12px 40px rgba(15,23,42,.08);
  }
  .agentos-shell[data-theme="light"] .agentos-hero-v2 h2,
  .agentos-shell[data-theme="light"] .agentos-hero-v2 p { color:#0f172a; }
  .agentos-shell[data-theme="light"] .agentos-hero-v2 p { color:#334155; }
  .agentos-shell[data-theme="light"] .agentos-hero-card-v2 {
    background:#0f172a; color:#f8fafc; border-color:#0d9488;
  }
  .agentos-shell[data-theme="light"] .agentos-section-head h3 { color:#0f172a; }
  .agentos-shell[data-theme="light"] .agentos-quick-card-v2 {
    background:linear-gradient(180deg,#fff 0%,#f0fdfa 100%);
    border-color:#99f6e4; color:#0f172a;
  }
  .agentos-shell[data-theme="light"] .agentos-quick-card-v2 p { color:#57534e; }
  .agentos-shell[data-theme="light"] .agentos-quick-card-v2 b { background:#ccfbf1; color:#0f766e; }
  .agentos-shell[data-theme="light"] .agentos-quick-card-v2 span { color:#0f766e; }
  .agentos-shell[data-theme="light"] .agentos-panel {
    background:#fff; border-color:#d6d3d1;
  }
  .agentos-shell[data-theme="light"] .agentos-panel-head { border-bottom-color:#e7e5e4; }
  .agentos-shell[data-theme="light"] .agentos-panel-head h3 { color:#0f172a; }
  .agentos-shell[data-theme="light"] .agentos-module-list button { color:#0f172a; border-bottom-color:#e7e5e4; }
  .agentos-shell[data-theme="light"] .agentos-module-list button:hover { background:#f5f5f4; }
  .agentos-shell[data-theme="light"] .agentos-module-list b { background:#ccfbf1; color:#0f766e; }
  .agentos-shell[data-theme="light"] .agentos-module-list small { color:#78716c; }
  .agentos-shell[data-theme="light"] .agentos-account-list li {
    background:#fafaf9; border-color:#e7e5e4;
  }
  .agentos-shell[data-theme="light"] .agentos-account-list span { color:#78716c; }
  .agentos-shell[data-theme="light"] .agentos-account-list strong { color:#0f172a; }
  .agentos-shell[data-theme="light"] .agentos-security-note { color:#57534e; }
  .agentos-shell[data-theme="light"] .agentos-mobile-nav {
    background:rgba(255,255,255,.96); border-top-color:#e7e5e4;
  }
  .agentos-shell[data-theme="light"] .agentos-mobile-nav button { color:#78716c; }
  .agentos-shell[data-theme="light"] .agentos-mobile-nav button.active { color:#0f172a; background:#f0fdfa; }

  /* Studio / shared surfaces in light mode */
  .agentos-shell[data-theme="light"] .studio-page,
  .agentos-shell[data-theme="light"] .voice-studio,
  .agentos-shell[data-theme="light"] .brain-page,
  .agentos-shell[data-theme="light"] .performance-page,
  .agentos-shell[data-theme="light"] .directory-page { color:#0f172a; }
  .agentos-shell[data-theme="light"] .studio-toolbar h2,
  .agentos-shell[data-theme="light"] .voice-toolbar h2,
  .agentos-shell[data-theme="light"] .brain-toolbar h2 { color:#0f172a; }
  .agentos-shell[data-theme="light"] .studio-toolbar span,
  .agentos-shell[data-theme="light"] .voice-toolbar span,
  .agentos-shell[data-theme="light"] .brain-toolbar span { color:#0f766e; }
  .agentos-shell[data-theme="light"] .studio-card,
  .agentos-shell[data-theme="light"] .brain-card,
  .agentos-shell[data-theme="light"] .brain-stats article {
    background:#fff !important; border-color:#d6d3d1 !important; color:#0f172a;
  }
  .agentos-shell[data-theme="light"] .studio-card header b,
  .agentos-shell[data-theme="light"] .brain-card header b { color:#57534e !important; }
  .agentos-shell[data-theme="light"] .studio-card small,
  .agentos-shell[data-theme="light"] .brain-card small { color:#0f766e !important; }
  .agentos-shell[data-theme="light"] .studio-card input,
  .agentos-shell[data-theme="light"] .studio-card textarea,
  .agentos-shell[data-theme="light"] .studio-card select,
  .agentos-shell[data-theme="light"] .brain-card input,
  .agentos-shell[data-theme="light"] .brain-card textarea,
  .agentos-shell[data-theme="light"] .brain-toolbar select,
  .agentos-shell[data-theme="light"] .voice-studio input,
  .agentos-shell[data-theme="light"] .voice-studio select,
  .agentos-shell[data-theme="light"] .voice-studio textarea,
  .agentos-shell[data-theme="light"] .directory-page input,
  .agentos-shell[data-theme="light"] .directory-page select,
  .agentos-shell[data-theme="light"] .directory-page textarea {
    background:#fff !important; color:#0f172a !important; border-color:#d6d3d1 !important;
  }
  .agentos-shell[data-theme="light"] .studio-alert {
    background:#f0fdfa; border-color:#99f6e4; color:#0f766e;
  }
  .agentos-shell[data-theme="light"] .studio-alert.error,
  .agentos-shell[data-theme="light"] .brain-alert.error {
    background:#fef2f2 !important; border-color:#fecaca !important; color:#b91c1c !important;
  }
  .agentos-shell[data-theme="light"] .studio-alert.success,
  .agentos-shell[data-theme="light"] .brain-alert.success {
    background:#ecfdf5 !important; border-color:#a7f3d0 !important; color:#047857 !important;
  }
  .agentos-shell[data-theme="light"] .call-list button,
  .agentos-shell[data-theme="light"] .leads-list button,
  .agentos-shell[data-theme="light"] .leads-card,
  .agentos-shell[data-theme="light"] .numbers-row,
  .agentos-shell[data-theme="light"] .campaign-contact-row {
    background:#fff !important; border-color:#d6d3d1 !important; color:#0f172a !important;
  }
  .agentos-shell[data-theme="light"] .call-list button strong,
  .agentos-shell[data-theme="light"] .leads-list button strong,
  .agentos-shell[data-theme="light"] .leads-card strong,
  .agentos-shell[data-theme="light"] .numbers-row strong { color:#0f172a !important; }
  .agentos-shell[data-theme="light"] .call-list button small,
  .agentos-shell[data-theme="light"] .leads-list button small,
  .agentos-shell[data-theme="light"] .numbers-row small,
  .agentos-shell[data-theme="light"] .voice-tool-empty,
  .agentos-shell[data-theme="light"] .numbers-empty,
  .agentos-shell[data-theme="light"] .numbers-help,
  .agentos-shell[data-theme="light"] .campaigns-note,
  .agentos-shell[data-theme="light"] .leads-note,
  .agentos-shell[data-theme="light"] .directory-note { color:#57534e !important; }
  .agentos-shell[data-theme="light"] .call-list button.active,
  .agentos-shell[data-theme="light"] .leads-list button.active,
  .agentos-shell[data-theme="light"] .leads-card.active {
    border-color:#0d9488 !important;
    background:#f0fdfa !important;
    box-shadow:inset 3px 0 #0d9488 !important;
  }
  .agentos-shell[data-theme="light"] .studio-inline-empty {
    background:#fafaf9; border-color:#d6d3d1;
  }
  .agentos-shell[data-theme="light"] .studio-inline-empty strong { color:#0f172a; }
  .agentos-shell[data-theme="light"] .studio-inline-empty p { color:#57534e; }
  .agentos-shell[data-theme="light"] .directory-secondary-btn {
    background:#f5f5f4 !important; color:#0f172a !important; border-color:#d6d3d1 !important;
  }
  .agentos-shell[data-theme="light"] .leads-column {
    background:#fff; border-color:#d6d3d1;
  }
  .agentos-shell[data-theme="light"] .leads-column header { border-bottom-color:#e7e5e4; }
  .agentos-shell[data-theme="light"] .leads-column header strong { color:#0f172a; }
  .agentos-shell[data-theme="light"] .leads-view-toggle { border-color:#d6d3d1; }
  .agentos-shell[data-theme="light"] .leads-view-toggle button { background:#fff; color:#57534e; }
  .agentos-shell[data-theme="light"] .leads-view-toggle button.active { background:#0d9488; color:#fff; }
  .agentos-shell[data-theme="light"] .voice-density-toggle { border-color:#d6d3d1; background:#fff; }
  .agentos-shell[data-theme="light"] .voice-density-toggle button { color:#57534e; }
  .agentos-shell[data-theme="light"] .voice-toolbar-actions>b {
    color:#57534e; border-color:#d6d3d1; background:#fff;
  }
  .agentos-shell[data-theme="light"] .voice-summary,
  .agentos-shell[data-theme="light"] .voice-analysis,
  .agentos-shell[data-theme="light"] .voice-context-panel,
  .agentos-shell[data-theme="light"] .voice-lead-panel,
  .agentos-shell[data-theme="light"] .voice-recording-panel,
  .agentos-shell[data-theme="light"] .voice-transcript-panel {
    background:#fff !important; border-color:#d6d3d1 !important; color:#0f172a !important;
  }
  .agentos-shell[data-theme="light"] .voice-metrics span,
  .agentos-shell[data-theme="light"] .lead-metrics span,
  .agentos-shell[data-theme="light"] .directory-detail-grid>div,
  .agentos-shell[data-theme="light"] .voice-context-grid span {
    background:#fafaf9 !important; border-color:#e7e5e4 !important; color:#57534e !important;
  }
  .agentos-shell[data-theme="light"] .voice-metrics b,
  .agentos-shell[data-theme="light"] .lead-metrics b,
  .agentos-shell[data-theme="light"] .directory-detail-grid dd,
  .agentos-shell[data-theme="light"] .voice-context-grid b { color:#0f172a !important; }
  .agentos-shell[data-theme="light"] .directory-section { color:#0f766e !important; }
  .agentos-shell[data-theme="light"] .agentos-btn.ghost {
    color:#0f172a; border-color:#a8a29e; background:#fff;
  }
  .agentos-shell[data-theme="light"] .agentos-btn.ghost:hover { background:#f5f5f4; }

  /* Arabic / RTL shell: flip sidebar column and common horizontal chrome. */
  .agentos-shell[dir='rtl'] {
    direction: rtl;
    font-family: "Noto Sans Arabic", "IBM Plex Sans Arabic", ui-sans-serif, system-ui, sans-serif;
  }
  .agentos-shell[dir='rtl'] .agentos-sidebar nav button,
  .agentos-shell[dir='rtl'] .call-list button {
    text-align: right;
  }
  .agentos-shell[dir='rtl'] .call-list button.active {
    box-shadow: inset -3px 0 #6657e8;
  }
  .agentos-shell[dir='rtl'] .voice-analysis,
  .agentos-shell[dir='rtl'] .voice-summary {
    border-left: 0;
    border-right: 2px solid #8b80f6;
    border-radius: 10px 0 0 10px;
  }
  .agentos-shell[dir='rtl'] .voice-summary {
    border-right-color: #4ecbdb;
  }

  .conversation-lab { display:grid; gap:12px; margin:0 0 16px; padding:14px; border:1px solid #3d4f8a; border-radius:14px; background:linear-gradient(145deg,#12182a 0%,#0d121a 70%); }
  .conversation-lab-top { display:flex; justify-content:space-between; gap:12px; flex-wrap:wrap; }
  .conversation-lab-top h2 { margin:0; font-size:16px; letter-spacing:.04em; }
  .conversation-lab-top p { margin:6px 0 0; color:#8490a4; font-size:12px; }
  .conversation-lab-actions { display:flex; gap:8px; flex-wrap:wrap; align-items:center; }
  .conversation-lab-actions button, .lab-file { border:1px solid #4a5d8a; background:#1a2240; color:#e8eaf0; border-radius:8px; padding:8px 10px; font-size:11px; font-weight:700; }
  .lab-chip { border:1px solid #2f6b45; color:#86d795; border-radius:99px; padding:4px 8px; font-size:10px; }
  .lab-file input { display:none; }
  .conversation-lab-grid { display:grid; grid-template-columns:220px 1fr; gap:12px; }
  .conversation-lab-runs { display:grid; align-content:start; gap:6px; max-height:520px; overflow:auto; }
  .conversation-lab-runs button { text-align:left; border:1px solid #283143; background:#0d121a; color:#c3cad6; border-radius:8px; padding:8px; }
  .conversation-lab-runs button.active { border-color:#6657e8; }
  .conversation-lab-runs small { display:block; color:#7a8498; }
  .conversation-lab-main { display:grid; grid-template-columns:1fr 240px; gap:10px; min-height:360px; }
  .conversation-lab-thread { display:grid; gap:10px; max-height:520px; overflow:auto; }
  .lab-msg { border-left:2px solid #6657e8; background:#0d121a; padding:10px; }
  .lab-msg.agent { border-left-color:#4ecbdb; }
  .lab-msg strong { font-size:10px; letter-spacing:.08em; color:#9c93f4; }
  .lab-msg p { margin:6px 0; font-size:13px; line-height:1.5; }
  .conversation-lab-side { border:1px solid #283143; border-radius:10px; padding:10px; background:#0d121a; }
  .conversation-lab-side dt { color:#7a8498; font-size:10px; text-transform:uppercase; margin-top:8px; }
  .conversation-lab-side dd { margin:2px 0 0; font-size:12px; }
  .lab-observer { margin-top:12px; padding:8px; border-radius:8px; }
  .lab-pass { background:#13261b; color:#86d795; }
  .lab-warn { background:#2a2410; color:#f0c674; }
  .lab-fail { background:#2a1616; color:#ffb4b4; }
  .conversation-lab-metrics { display:flex; gap:12px; flex-wrap:wrap; color:#8490a4; font-size:11px; }
  @media (max-width:1100px) {
    .conversation-lab-grid, .conversation-lab-main { grid-template-columns:1fr; }
  }
`;
export {
  AgentOSShell,
  BillingLifecyclePage,
  BrainLiveOpsPage,
  CampaignsPage,
  ConversationLabPanel,
  DirectoryPage,
  IntegrationsPage,
  IntelligenceStudioPage,
  LeadsPage,
  LiveOpsPage,
  NumbersPage,
  OperationsStudioPage,
  PerformancePage,
  PlatformAdminPage,
  ProviderStudioPage,
  VoiceStudioPage,
  WebchatWidget,
  agentOSStyles,
  createAgentApi,
  createBillingApi,
  createBrainApi,
  createBrainLiveOpsApi,
  createCampaignsApi,
  createContactsApi,
  createIntegrationsApi,
  createIntelligenceApi,
  createLeadsApi,
  createLiveOpsApi,
  createOperationsApi,
  createPerformanceApi,
  createPhoneNumbersApi,
  createPlatformAdminApi,
  createProviderApi,
  createVoiceApi,
  createWebchatApi,
  readColorMode,
  writeColorMode
};
